
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea2dd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea2dd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dRKaB", function(module, exports) {
(function(root) {
    // Detect free variables `exports`.
    var freeExports = exports;
    // Detect free variable `module`.
    var freeModule = module && module.exports == freeExports && module;
    // Detect free variable `global`, from Node.js or Browserified code,
    // and use it as `root`.
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) root = freeGlobal;
    /*--------------------------------------------------------------------------*/ // All astral symbols.
    var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    // All ASCII symbols (not just printable ASCII) except those listed in the
    // first column of the overrides table.
    // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
    var regexAsciiWhitelist = /[\x01-\x7F]/g;
    // All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
    // code points listed in the first column of the overrides table on
    // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
    var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
    var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
    var encodeMap = {
        "\xad": "shy",
        "\u200C": "zwnj",
        "\u200D": "zwj",
        "\u200E": "lrm",
        "\u2063": "ic",
        "\u2062": "it",
        "\u2061": "af",
        "\u200F": "rlm",
        "\u200B": "ZeroWidthSpace",
        "\u2060": "NoBreak",
        "\u0311": "DownBreve",
        "\u20DB": "tdot",
        "\u20DC": "DotDot",
        "	": "Tab",
        "\n": "NewLine",
        "\u2008": "puncsp",
        "\u205F": "MediumSpace",
        "\u2009": "thinsp",
        "\u200A": "hairsp",
        "\u2004": "emsp13",
        "\u2002": "ensp",
        "\u2005": "emsp14",
        "\u2003": "emsp",
        "\u2007": "numsp",
        "\xa0": "nbsp",
        "\u205F\u200A": "ThickSpace",
        "\u203E": "oline",
        "_": "lowbar",
        "\u2010": "dash",
        "\u2013": "ndash",
        "\u2014": "mdash",
        "\u2015": "horbar",
        ",": "comma",
        ";": "semi",
        "\u204F": "bsemi",
        ":": "colon",
        "\u2A74": "Colone",
        "!": "excl",
        "\xa1": "iexcl",
        "?": "quest",
        "\xbf": "iquest",
        ".": "period",
        "\u2025": "nldr",
        "\u2026": "mldr",
        "\xb7": "middot",
        "'": "apos",
        "\u2018": "lsquo",
        "\u2019": "rsquo",
        "\u201A": "sbquo",
        "\u2039": "lsaquo",
        "\u203A": "rsaquo",
        '"': "quot",
        "\u201C": "ldquo",
        "\u201D": "rdquo",
        "\u201E": "bdquo",
        "\xab": "laquo",
        "\xbb": "raquo",
        "(": "lpar",
        ")": "rpar",
        "[": "lsqb",
        "]": "rsqb",
        "{": "lcub",
        "}": "rcub",
        "\u2308": "lceil",
        "\u2309": "rceil",
        "\u230A": "lfloor",
        "\u230B": "rfloor",
        "\u2985": "lopar",
        "\u2986": "ropar",
        "\u298B": "lbrke",
        "\u298C": "rbrke",
        "\u298D": "lbrkslu",
        "\u298E": "rbrksld",
        "\u298F": "lbrksld",
        "\u2990": "rbrkslu",
        "\u2991": "langd",
        "\u2992": "rangd",
        "\u2993": "lparlt",
        "\u2994": "rpargt",
        "\u2995": "gtlPar",
        "\u2996": "ltrPar",
        "\u27E6": "lobrk",
        "\u27E7": "robrk",
        "\u27E8": "lang",
        "\u27E9": "rang",
        "\u27EA": "Lang",
        "\u27EB": "Rang",
        "\u27EC": "loang",
        "\u27ED": "roang",
        "\u2772": "lbbrk",
        "\u2773": "rbbrk",
        "\u2016": "Vert",
        "\xa7": "sect",
        "\xb6": "para",
        "@": "commat",
        "*": "ast",
        "/": "sol",
        "undefined": null,
        "&": "amp",
        "#": "num",
        "%": "percnt",
        "\u2030": "permil",
        "\u2031": "pertenk",
        "\u2020": "dagger",
        "\u2021": "Dagger",
        "\u2022": "bull",
        "\u2043": "hybull",
        "\u2032": "prime",
        "\u2033": "Prime",
        "\u2034": "tprime",
        "\u2057": "qprime",
        "\u2035": "bprime",
        "\u2041": "caret",
        "`": "grave",
        "\xb4": "acute",
        "\u02DC": "tilde",
        "^": "Hat",
        "\xaf": "macr",
        "\u02D8": "breve",
        "\u02D9": "dot",
        "\xa8": "die",
        "\u02DA": "ring",
        "\u02DD": "dblac",
        "\xb8": "cedil",
        "\u02DB": "ogon",
        "\u02C6": "circ",
        "\u02C7": "caron",
        "\xb0": "deg",
        "\xa9": "copy",
        "\xae": "reg",
        "\u2117": "copysr",
        "\u2118": "wp",
        "\u211E": "rx",
        "\u2127": "mho",
        "\u2129": "iiota",
        "\u2190": "larr",
        "\u219A": "nlarr",
        "\u2192": "rarr",
        "\u219B": "nrarr",
        "\u2191": "uarr",
        "\u2193": "darr",
        "\u2194": "harr",
        "\u21AE": "nharr",
        "\u2195": "varr",
        "\u2196": "nwarr",
        "\u2197": "nearr",
        "\u2198": "searr",
        "\u2199": "swarr",
        "\u219D": "rarrw",
        "\u219D\u0338": "nrarrw",
        "\u219E": "Larr",
        "\u219F": "Uarr",
        "\u21A0": "Rarr",
        "\u21A1": "Darr",
        "\u21A2": "larrtl",
        "\u21A3": "rarrtl",
        "\u21A4": "mapstoleft",
        "\u21A5": "mapstoup",
        "\u21A6": "map",
        "\u21A7": "mapstodown",
        "\u21A9": "larrhk",
        "\u21AA": "rarrhk",
        "\u21AB": "larrlp",
        "\u21AC": "rarrlp",
        "\u21AD": "harrw",
        "\u21B0": "lsh",
        "\u21B1": "rsh",
        "\u21B2": "ldsh",
        "\u21B3": "rdsh",
        "\u21B5": "crarr",
        "\u21B6": "cularr",
        "\u21B7": "curarr",
        "\u21BA": "olarr",
        "\u21BB": "orarr",
        "\u21BC": "lharu",
        "\u21BD": "lhard",
        "\u21BE": "uharr",
        "\u21BF": "uharl",
        "\u21C0": "rharu",
        "\u21C1": "rhard",
        "\u21C2": "dharr",
        "\u21C3": "dharl",
        "\u21C4": "rlarr",
        "\u21C5": "udarr",
        "\u21C6": "lrarr",
        "\u21C7": "llarr",
        "\u21C8": "uuarr",
        "\u21C9": "rrarr",
        "\u21CA": "ddarr",
        "\u21CB": "lrhar",
        "\u21CC": "rlhar",
        "\u21D0": "lArr",
        "\u21CD": "nlArr",
        "\u21D1": "uArr",
        "\u21D2": "rArr",
        "\u21CF": "nrArr",
        "\u21D3": "dArr",
        "\u21D4": "iff",
        "\u21CE": "nhArr",
        "\u21D5": "vArr",
        "\u21D6": "nwArr",
        "\u21D7": "neArr",
        "\u21D8": "seArr",
        "\u21D9": "swArr",
        "\u21DA": "lAarr",
        "\u21DB": "rAarr",
        "\u21DD": "zigrarr",
        "\u21E4": "larrb",
        "\u21E5": "rarrb",
        "\u21F5": "duarr",
        "\u21FD": "loarr",
        "\u21FE": "roarr",
        "\u21FF": "hoarr",
        "\u2200": "forall",
        "\u2201": "comp",
        "\u2202": "part",
        "\u2202\u0338": "npart",
        "\u2203": "exist",
        "\u2204": "nexist",
        "\u2205": "empty",
        "\u2207": "Del",
        "\u2208": "in",
        "\u2209": "notin",
        "\u220B": "ni",
        "\u220C": "notni",
        "\u03F6": "bepsi",
        "\u220F": "prod",
        "\u2210": "coprod",
        "\u2211": "sum",
        "+": "plus",
        "\xb1": "pm",
        "\xf7": "div",
        "\xd7": "times",
        "<": "lt",
        "\u226E": "nlt",
        "<\u20D2": "nvlt",
        "=": "equals",
        "\u2260": "ne",
        "=\u20E5": "bne",
        "\u2A75": "Equal",
        ">": "gt",
        "\u226F": "ngt",
        ">\u20D2": "nvgt",
        "\xac": "not",
        "|": "vert",
        "\xa6": "brvbar",
        "\u2212": "minus",
        "\u2213": "mp",
        "\u2214": "plusdo",
        "\u2044": "frasl",
        "\u2216": "setmn",
        "\u2217": "lowast",
        "\u2218": "compfn",
        "\u221A": "Sqrt",
        "\u221D": "prop",
        "\u221E": "infin",
        "\u221F": "angrt",
        "\u2220": "ang",
        "\u2220\u20D2": "nang",
        "\u2221": "angmsd",
        "\u2222": "angsph",
        "\u2223": "mid",
        "\u2224": "nmid",
        "\u2225": "par",
        "\u2226": "npar",
        "\u2227": "and",
        "\u2228": "or",
        "\u2229": "cap",
        "\u2229\uFE00": "caps",
        "\u222A": "cup",
        "\u222A\uFE00": "cups",
        "\u222B": "int",
        "\u222C": "Int",
        "\u222D": "tint",
        "\u2A0C": "qint",
        "\u222E": "oint",
        "\u222F": "Conint",
        "\u2230": "Cconint",
        "\u2231": "cwint",
        "\u2232": "cwconint",
        "\u2233": "awconint",
        "\u2234": "there4",
        "\u2235": "becaus",
        "\u2236": "ratio",
        "\u2237": "Colon",
        "\u2238": "minusd",
        "\u223A": "mDDot",
        "\u223B": "homtht",
        "\u223C": "sim",
        "\u2241": "nsim",
        "\u223C\u20D2": "nvsim",
        "\u223D": "bsim",
        "\u223D\u0331": "race",
        "\u223E": "ac",
        "\u223E\u0333": "acE",
        "\u223F": "acd",
        "\u2240": "wr",
        "\u2242": "esim",
        "\u2242\u0338": "nesim",
        "\u2243": "sime",
        "\u2244": "nsime",
        "\u2245": "cong",
        "\u2247": "ncong",
        "\u2246": "simne",
        "\u2248": "ap",
        "\u2249": "nap",
        "\u224A": "ape",
        "\u224B": "apid",
        "\u224B\u0338": "napid",
        "\u224C": "bcong",
        "\u224D": "CupCap",
        "\u226D": "NotCupCap",
        "\u224D\u20D2": "nvap",
        "\u224E": "bump",
        "\u224E\u0338": "nbump",
        "\u224F": "bumpe",
        "\u224F\u0338": "nbumpe",
        "\u2250": "doteq",
        "\u2250\u0338": "nedot",
        "\u2251": "eDot",
        "\u2252": "efDot",
        "\u2253": "erDot",
        "\u2254": "colone",
        "\u2255": "ecolon",
        "\u2256": "ecir",
        "\u2257": "cire",
        "\u2259": "wedgeq",
        "\u225A": "veeeq",
        "\u225C": "trie",
        "\u225F": "equest",
        "\u2261": "equiv",
        "\u2262": "nequiv",
        "\u2261\u20E5": "bnequiv",
        "\u2264": "le",
        "\u2270": "nle",
        "\u2264\u20D2": "nvle",
        "\u2265": "ge",
        "\u2271": "nge",
        "\u2265\u20D2": "nvge",
        "\u2266": "lE",
        "\u2266\u0338": "nlE",
        "\u2267": "gE",
        "\u2267\u0338": "ngE",
        "\u2268\uFE00": "lvnE",
        "\u2268": "lnE",
        "\u2269": "gnE",
        "\u2269\uFE00": "gvnE",
        "\u226A": "ll",
        "\u226A\u0338": "nLtv",
        "\u226A\u20D2": "nLt",
        "\u226B": "gg",
        "\u226B\u0338": "nGtv",
        "\u226B\u20D2": "nGt",
        "\u226C": "twixt",
        "\u2272": "lsim",
        "\u2274": "nlsim",
        "\u2273": "gsim",
        "\u2275": "ngsim",
        "\u2276": "lg",
        "\u2278": "ntlg",
        "\u2277": "gl",
        "\u2279": "ntgl",
        "\u227A": "pr",
        "\u2280": "npr",
        "\u227B": "sc",
        "\u2281": "nsc",
        "\u227C": "prcue",
        "\u22E0": "nprcue",
        "\u227D": "sccue",
        "\u22E1": "nsccue",
        "\u227E": "prsim",
        "\u227F": "scsim",
        "\u227F\u0338": "NotSucceedsTilde",
        "\u2282": "sub",
        "\u2284": "nsub",
        "\u2282\u20D2": "vnsub",
        "\u2283": "sup",
        "\u2285": "nsup",
        "\u2283\u20D2": "vnsup",
        "\u2286": "sube",
        "\u2288": "nsube",
        "\u2287": "supe",
        "\u2289": "nsupe",
        "\u228A\uFE00": "vsubne",
        "\u228A": "subne",
        "\u228B\uFE00": "vsupne",
        "\u228B": "supne",
        "\u228D": "cupdot",
        "\u228E": "uplus",
        "\u228F": "sqsub",
        "\u228F\u0338": "NotSquareSubset",
        "\u2290": "sqsup",
        "\u2290\u0338": "NotSquareSuperset",
        "\u2291": "sqsube",
        "\u22E2": "nsqsube",
        "\u2292": "sqsupe",
        "\u22E3": "nsqsupe",
        "\u2293": "sqcap",
        "\u2293\uFE00": "sqcaps",
        "\u2294": "sqcup",
        "\u2294\uFE00": "sqcups",
        "\u2295": "oplus",
        "\u2296": "ominus",
        "\u2297": "otimes",
        "\u2298": "osol",
        "\u2299": "odot",
        "\u229A": "ocir",
        "\u229B": "oast",
        "\u229D": "odash",
        "\u229E": "plusb",
        "\u229F": "minusb",
        "\u22A0": "timesb",
        "\u22A1": "sdotb",
        "\u22A2": "vdash",
        "\u22AC": "nvdash",
        "\u22A3": "dashv",
        "\u22A4": "top",
        "\u22A5": "bot",
        "\u22A7": "models",
        "\u22A8": "vDash",
        "\u22AD": "nvDash",
        "\u22A9": "Vdash",
        "\u22AE": "nVdash",
        "\u22AA": "Vvdash",
        "\u22AB": "VDash",
        "\u22AF": "nVDash",
        "\u22B0": "prurel",
        "\u22B2": "vltri",
        "\u22EA": "nltri",
        "\u22B3": "vrtri",
        "\u22EB": "nrtri",
        "\u22B4": "ltrie",
        "\u22EC": "nltrie",
        "\u22B4\u20D2": "nvltrie",
        "\u22B5": "rtrie",
        "\u22ED": "nrtrie",
        "\u22B5\u20D2": "nvrtrie",
        "\u22B6": "origof",
        "\u22B7": "imof",
        "\u22B8": "mumap",
        "\u22B9": "hercon",
        "\u22BA": "intcal",
        "\u22BB": "veebar",
        "\u22BD": "barvee",
        "\u22BE": "angrtvb",
        "\u22BF": "lrtri",
        "\u22C0": "Wedge",
        "\u22C1": "Vee",
        "\u22C2": "xcap",
        "\u22C3": "xcup",
        "\u22C4": "diam",
        "\u22C5": "sdot",
        "\u22C6": "Star",
        "\u22C7": "divonx",
        "\u22C8": "bowtie",
        "\u22C9": "ltimes",
        "\u22CA": "rtimes",
        "\u22CB": "lthree",
        "\u22CC": "rthree",
        "\u22CD": "bsime",
        "\u22CE": "cuvee",
        "\u22CF": "cuwed",
        "\u22D0": "Sub",
        "\u22D1": "Sup",
        "\u22D2": "Cap",
        "\u22D3": "Cup",
        "\u22D4": "fork",
        "\u22D5": "epar",
        "\u22D6": "ltdot",
        "\u22D7": "gtdot",
        "\u22D8": "Ll",
        "\u22D8\u0338": "nLl",
        "\u22D9": "Gg",
        "\u22D9\u0338": "nGg",
        "\u22DA\uFE00": "lesg",
        "\u22DA": "leg",
        "\u22DB": "gel",
        "\u22DB\uFE00": "gesl",
        "\u22DE": "cuepr",
        "\u22DF": "cuesc",
        "\u22E6": "lnsim",
        "\u22E7": "gnsim",
        "\u22E8": "prnsim",
        "\u22E9": "scnsim",
        "\u22EE": "vellip",
        "\u22EF": "ctdot",
        "\u22F0": "utdot",
        "\u22F1": "dtdot",
        "\u22F2": "disin",
        "\u22F3": "isinsv",
        "\u22F4": "isins",
        "\u22F5": "isindot",
        "\u22F5\u0338": "notindot",
        "\u22F6": "notinvc",
        "\u22F7": "notinvb",
        "\u22F9": "isinE",
        "\u22F9\u0338": "notinE",
        "\u22FA": "nisd",
        "\u22FB": "xnis",
        "\u22FC": "nis",
        "\u22FD": "notnivc",
        "\u22FE": "notnivb",
        "\u2305": "barwed",
        "\u2306": "Barwed",
        "\u230C": "drcrop",
        "\u230D": "dlcrop",
        "\u230E": "urcrop",
        "\u230F": "ulcrop",
        "\u2310": "bnot",
        "\u2312": "profline",
        "\u2313": "profsurf",
        "\u2315": "telrec",
        "\u2316": "target",
        "\u231C": "ulcorn",
        "\u231D": "urcorn",
        "\u231E": "dlcorn",
        "\u231F": "drcorn",
        "\u2322": "frown",
        "\u2323": "smile",
        "\u232D": "cylcty",
        "\u232E": "profalar",
        "\u2336": "topbot",
        "\u233D": "ovbar",
        "\u233F": "solbar",
        "\u237C": "angzarr",
        "\u23B0": "lmoust",
        "\u23B1": "rmoust",
        "\u23B4": "tbrk",
        "\u23B5": "bbrk",
        "\u23B6": "bbrktbrk",
        "\u23DC": "OverParenthesis",
        "\u23DD": "UnderParenthesis",
        "\u23DE": "OverBrace",
        "\u23DF": "UnderBrace",
        "\u23E2": "trpezium",
        "\u23E7": "elinters",
        "\u2423": "blank",
        "\u2500": "boxh",
        "\u2502": "boxv",
        "\u250C": "boxdr",
        "\u2510": "boxdl",
        "\u2514": "boxur",
        "\u2518": "boxul",
        "\u251C": "boxvr",
        "\u2524": "boxvl",
        "\u252C": "boxhd",
        "\u2534": "boxhu",
        "\u253C": "boxvh",
        "\u2550": "boxH",
        "\u2551": "boxV",
        "\u2552": "boxdR",
        "\u2553": "boxDr",
        "\u2554": "boxDR",
        "\u2555": "boxdL",
        "\u2556": "boxDl",
        "\u2557": "boxDL",
        "\u2558": "boxuR",
        "\u2559": "boxUr",
        "\u255A": "boxUR",
        "\u255B": "boxuL",
        "\u255C": "boxUl",
        "\u255D": "boxUL",
        "\u255E": "boxvR",
        "\u255F": "boxVr",
        "\u2560": "boxVR",
        "\u2561": "boxvL",
        "\u2562": "boxVl",
        "\u2563": "boxVL",
        "\u2564": "boxHd",
        "\u2565": "boxhD",
        "\u2566": "boxHD",
        "\u2567": "boxHu",
        "\u2568": "boxhU",
        "\u2569": "boxHU",
        "\u256A": "boxvH",
        "\u256B": "boxVh",
        "\u256C": "boxVH",
        "\u2580": "uhblk",
        "\u2584": "lhblk",
        "\u2588": "block",
        "\u2591": "blk14",
        "\u2592": "blk12",
        "\u2593": "blk34",
        "\u25A1": "squ",
        "\u25AA": "squf",
        "\u25AB": "EmptyVerySmallSquare",
        "\u25AD": "rect",
        "\u25AE": "marker",
        "\u25B1": "fltns",
        "\u25B3": "xutri",
        "\u25B4": "utrif",
        "\u25B5": "utri",
        "\u25B8": "rtrif",
        "\u25B9": "rtri",
        "\u25BD": "xdtri",
        "\u25BE": "dtrif",
        "\u25BF": "dtri",
        "\u25C2": "ltrif",
        "\u25C3": "ltri",
        "\u25CA": "loz",
        "\u25CB": "cir",
        "\u25EC": "tridot",
        "\u25EF": "xcirc",
        "\u25F8": "ultri",
        "\u25F9": "urtri",
        "\u25FA": "lltri",
        "\u25FB": "EmptySmallSquare",
        "\u25FC": "FilledSmallSquare",
        "\u2605": "starf",
        "\u2606": "star",
        "\u260E": "phone",
        "\u2640": "female",
        "\u2642": "male",
        "\u2660": "spades",
        "\u2663": "clubs",
        "\u2665": "hearts",
        "\u2666": "diams",
        "\u266A": "sung",
        "\u2713": "check",
        "\u2717": "cross",
        "\u2720": "malt",
        "\u2736": "sext",
        "\u2758": "VerticalSeparator",
        "\u27C8": "bsolhsub",
        "\u27C9": "suphsol",
        "\u27F5": "xlarr",
        "\u27F6": "xrarr",
        "\u27F7": "xharr",
        "\u27F8": "xlArr",
        "\u27F9": "xrArr",
        "\u27FA": "xhArr",
        "\u27FC": "xmap",
        "\u27FF": "dzigrarr",
        "\u2902": "nvlArr",
        "\u2903": "nvrArr",
        "\u2904": "nvHarr",
        "\u2905": "Map",
        "\u290C": "lbarr",
        "\u290D": "rbarr",
        "\u290E": "lBarr",
        "\u290F": "rBarr",
        "\u2910": "RBarr",
        "\u2911": "DDotrahd",
        "\u2912": "UpArrowBar",
        "\u2913": "DownArrowBar",
        "\u2916": "Rarrtl",
        "\u2919": "latail",
        "\u291A": "ratail",
        "\u291B": "lAtail",
        "\u291C": "rAtail",
        "\u291D": "larrfs",
        "\u291E": "rarrfs",
        "\u291F": "larrbfs",
        "\u2920": "rarrbfs",
        "\u2923": "nwarhk",
        "\u2924": "nearhk",
        "\u2925": "searhk",
        "\u2926": "swarhk",
        "\u2927": "nwnear",
        "\u2928": "toea",
        "\u2929": "tosa",
        "\u292A": "swnwar",
        "\u2933": "rarrc",
        "\u2933\u0338": "nrarrc",
        "\u2935": "cudarrr",
        "\u2936": "ldca",
        "\u2937": "rdca",
        "\u2938": "cudarrl",
        "\u2939": "larrpl",
        "\u293C": "curarrm",
        "\u293D": "cularrp",
        "\u2945": "rarrpl",
        "\u2948": "harrcir",
        "\u2949": "Uarrocir",
        "\u294A": "lurdshar",
        "\u294B": "ldrushar",
        "\u294E": "LeftRightVector",
        "\u294F": "RightUpDownVector",
        "\u2950": "DownLeftRightVector",
        "\u2951": "LeftUpDownVector",
        "\u2952": "LeftVectorBar",
        "\u2953": "RightVectorBar",
        "\u2954": "RightUpVectorBar",
        "\u2955": "RightDownVectorBar",
        "\u2956": "DownLeftVectorBar",
        "\u2957": "DownRightVectorBar",
        "\u2958": "LeftUpVectorBar",
        "\u2959": "LeftDownVectorBar",
        "\u295A": "LeftTeeVector",
        "\u295B": "RightTeeVector",
        "\u295C": "RightUpTeeVector",
        "\u295D": "RightDownTeeVector",
        "\u295E": "DownLeftTeeVector",
        "\u295F": "DownRightTeeVector",
        "\u2960": "LeftUpTeeVector",
        "\u2961": "LeftDownTeeVector",
        "\u2962": "lHar",
        "\u2963": "uHar",
        "\u2964": "rHar",
        "\u2965": "dHar",
        "\u2966": "luruhar",
        "\u2967": "ldrdhar",
        "\u2968": "ruluhar",
        "\u2969": "rdldhar",
        "\u296A": "lharul",
        "\u296B": "llhard",
        "\u296C": "rharul",
        "\u296D": "lrhard",
        "\u296E": "udhar",
        "\u296F": "duhar",
        "\u2970": "RoundImplies",
        "\u2971": "erarr",
        "\u2972": "simrarr",
        "\u2973": "larrsim",
        "\u2974": "rarrsim",
        "\u2975": "rarrap",
        "\u2976": "ltlarr",
        "\u2978": "gtrarr",
        "\u2979": "subrarr",
        "\u297B": "suplarr",
        "\u297C": "lfisht",
        "\u297D": "rfisht",
        "\u297E": "ufisht",
        "\u297F": "dfisht",
        "\u299A": "vzigzag",
        "\u299C": "vangrt",
        "\u299D": "angrtvbd",
        "\u29A4": "ange",
        "\u29A5": "range",
        "\u29A6": "dwangle",
        "\u29A7": "uwangle",
        "\u29A8": "angmsdaa",
        "\u29A9": "angmsdab",
        "\u29AA": "angmsdac",
        "\u29AB": "angmsdad",
        "\u29AC": "angmsdae",
        "\u29AD": "angmsdaf",
        "\u29AE": "angmsdag",
        "\u29AF": "angmsdah",
        "\u29B0": "bemptyv",
        "\u29B1": "demptyv",
        "\u29B2": "cemptyv",
        "\u29B3": "raemptyv",
        "\u29B4": "laemptyv",
        "\u29B5": "ohbar",
        "\u29B6": "omid",
        "\u29B7": "opar",
        "\u29B9": "operp",
        "\u29BB": "olcross",
        "\u29BC": "odsold",
        "\u29BE": "olcir",
        "\u29BF": "ofcir",
        "\u29C0": "olt",
        "\u29C1": "ogt",
        "\u29C2": "cirscir",
        "\u29C3": "cirE",
        "\u29C4": "solb",
        "\u29C5": "bsolb",
        "\u29C9": "boxbox",
        "\u29CD": "trisb",
        "\u29CE": "rtriltri",
        "\u29CF": "LeftTriangleBar",
        "\u29CF\u0338": "NotLeftTriangleBar",
        "\u29D0": "RightTriangleBar",
        "\u29D0\u0338": "NotRightTriangleBar",
        "\u29DC": "iinfin",
        "\u29DD": "infintie",
        "\u29DE": "nvinfin",
        "\u29E3": "eparsl",
        "\u29E4": "smeparsl",
        "\u29E5": "eqvparsl",
        "\u29EB": "lozf",
        "\u29F4": "RuleDelayed",
        "\u29F6": "dsol",
        "\u2A00": "xodot",
        "\u2A01": "xoplus",
        "\u2A02": "xotime",
        "\u2A04": "xuplus",
        "\u2A06": "xsqcup",
        "\u2A0D": "fpartint",
        "\u2A10": "cirfnint",
        "\u2A11": "awint",
        "\u2A12": "rppolint",
        "\u2A13": "scpolint",
        "\u2A14": "npolint",
        "\u2A15": "pointint",
        "\u2A16": "quatint",
        "\u2A17": "intlarhk",
        "\u2A22": "pluscir",
        "\u2A23": "plusacir",
        "\u2A24": "simplus",
        "\u2A25": "plusdu",
        "\u2A26": "plussim",
        "\u2A27": "plustwo",
        "\u2A29": "mcomma",
        "\u2A2A": "minusdu",
        "\u2A2D": "loplus",
        "\u2A2E": "roplus",
        "\u2A2F": "Cross",
        "\u2A30": "timesd",
        "\u2A31": "timesbar",
        "\u2A33": "smashp",
        "\u2A34": "lotimes",
        "\u2A35": "rotimes",
        "\u2A36": "otimesas",
        "\u2A37": "Otimes",
        "\u2A38": "odiv",
        "\u2A39": "triplus",
        "\u2A3A": "triminus",
        "\u2A3B": "tritime",
        "\u2A3C": "iprod",
        "\u2A3F": "amalg",
        "\u2A40": "capdot",
        "\u2A42": "ncup",
        "\u2A43": "ncap",
        "\u2A44": "capand",
        "\u2A45": "cupor",
        "\u2A46": "cupcap",
        "\u2A47": "capcup",
        "\u2A48": "cupbrcap",
        "\u2A49": "capbrcup",
        "\u2A4A": "cupcup",
        "\u2A4B": "capcap",
        "\u2A4C": "ccups",
        "\u2A4D": "ccaps",
        "\u2A50": "ccupssm",
        "\u2A53": "And",
        "\u2A54": "Or",
        "\u2A55": "andand",
        "\u2A56": "oror",
        "\u2A57": "orslope",
        "\u2A58": "andslope",
        "\u2A5A": "andv",
        "\u2A5B": "orv",
        "\u2A5C": "andd",
        "\u2A5D": "ord",
        "\u2A5F": "wedbar",
        "\u2A66": "sdote",
        "\u2A6A": "simdot",
        "\u2A6D": "congdot",
        "\u2A6D\u0338": "ncongdot",
        "\u2A6E": "easter",
        "\u2A6F": "apacir",
        "\u2A70": "apE",
        "\u2A70\u0338": "napE",
        "\u2A71": "eplus",
        "\u2A72": "pluse",
        "\u2A73": "Esim",
        "\u2A77": "eDDot",
        "\u2A78": "equivDD",
        "\u2A79": "ltcir",
        "\u2A7A": "gtcir",
        "\u2A7B": "ltquest",
        "\u2A7C": "gtquest",
        "\u2A7D": "les",
        "\u2A7D\u0338": "nles",
        "\u2A7E": "ges",
        "\u2A7E\u0338": "nges",
        "\u2A7F": "lesdot",
        "\u2A80": "gesdot",
        "\u2A81": "lesdoto",
        "\u2A82": "gesdoto",
        "\u2A83": "lesdotor",
        "\u2A84": "gesdotol",
        "\u2A85": "lap",
        "\u2A86": "gap",
        "\u2A87": "lne",
        "\u2A88": "gne",
        "\u2A89": "lnap",
        "\u2A8A": "gnap",
        "\u2A8B": "lEg",
        "\u2A8C": "gEl",
        "\u2A8D": "lsime",
        "\u2A8E": "gsime",
        "\u2A8F": "lsimg",
        "\u2A90": "gsiml",
        "\u2A91": "lgE",
        "\u2A92": "glE",
        "\u2A93": "lesges",
        "\u2A94": "gesles",
        "\u2A95": "els",
        "\u2A96": "egs",
        "\u2A97": "elsdot",
        "\u2A98": "egsdot",
        "\u2A99": "el",
        "\u2A9A": "eg",
        "\u2A9D": "siml",
        "\u2A9E": "simg",
        "\u2A9F": "simlE",
        "\u2AA0": "simgE",
        "\u2AA1": "LessLess",
        "\u2AA1\u0338": "NotNestedLessLess",
        "\u2AA2": "GreaterGreater",
        "\u2AA2\u0338": "NotNestedGreaterGreater",
        "\u2AA4": "glj",
        "\u2AA5": "gla",
        "\u2AA6": "ltcc",
        "\u2AA7": "gtcc",
        "\u2AA8": "lescc",
        "\u2AA9": "gescc",
        "\u2AAA": "smt",
        "\u2AAB": "lat",
        "\u2AAC": "smte",
        "\u2AAC\uFE00": "smtes",
        "\u2AAD": "late",
        "\u2AAD\uFE00": "lates",
        "\u2AAE": "bumpE",
        "\u2AAF": "pre",
        "\u2AAF\u0338": "npre",
        "\u2AB0": "sce",
        "\u2AB0\u0338": "nsce",
        "\u2AB3": "prE",
        "\u2AB4": "scE",
        "\u2AB5": "prnE",
        "\u2AB6": "scnE",
        "\u2AB7": "prap",
        "\u2AB8": "scap",
        "\u2AB9": "prnap",
        "\u2ABA": "scnap",
        "\u2ABB": "Pr",
        "\u2ABC": "Sc",
        "\u2ABD": "subdot",
        "\u2ABE": "supdot",
        "\u2ABF": "subplus",
        "\u2AC0": "supplus",
        "\u2AC1": "submult",
        "\u2AC2": "supmult",
        "\u2AC3": "subedot",
        "\u2AC4": "supedot",
        "\u2AC5": "subE",
        "\u2AC5\u0338": "nsubE",
        "\u2AC6": "supE",
        "\u2AC6\u0338": "nsupE",
        "\u2AC7": "subsim",
        "\u2AC8": "supsim",
        "\u2ACB\uFE00": "vsubnE",
        "\u2ACB": "subnE",
        "\u2ACC\uFE00": "vsupnE",
        "\u2ACC": "supnE",
        "\u2ACF": "csub",
        "\u2AD0": "csup",
        "\u2AD1": "csube",
        "\u2AD2": "csupe",
        "\u2AD3": "subsup",
        "\u2AD4": "supsub",
        "\u2AD5": "subsub",
        "\u2AD6": "supsup",
        "\u2AD7": "suphsub",
        "\u2AD8": "supdsub",
        "\u2AD9": "forkv",
        "\u2ADA": "topfork",
        "\u2ADB": "mlcp",
        "\u2AE4": "Dashv",
        "\u2AE6": "Vdashl",
        "\u2AE7": "Barv",
        "\u2AE8": "vBar",
        "\u2AE9": "vBarv",
        "\u2AEB": "Vbar",
        "\u2AEC": "Not",
        "\u2AED": "bNot",
        "\u2AEE": "rnmid",
        "\u2AEF": "cirmid",
        "\u2AF0": "midcir",
        "\u2AF1": "topcir",
        "\u2AF2": "nhpar",
        "\u2AF3": "parsim",
        "\u2AFD": "parsl",
        "\u2AFD\u20E5": "nparsl",
        "\u266D": "flat",
        "\u266E": "natur",
        "\u266F": "sharp",
        "\xa4": "curren",
        "\xa2": "cent",
        "$": "dollar",
        "\xa3": "pound",
        "\xa5": "yen",
        "\u20AC": "euro",
        "\xb9": "sup1",
        "\xbd": "half",
        "\u2153": "frac13",
        "\xbc": "frac14",
        "\u2155": "frac15",
        "\u2159": "frac16",
        "\u215B": "frac18",
        "\xb2": "sup2",
        "\u2154": "frac23",
        "\u2156": "frac25",
        "\xb3": "sup3",
        "\xbe": "frac34",
        "\u2157": "frac35",
        "\u215C": "frac38",
        "\u2158": "frac45",
        "\u215A": "frac56",
        "\u215D": "frac58",
        "\u215E": "frac78",
        "\uD835\uDCB6": "ascr",
        "\uD835\uDD52": "aopf",
        "\uD835\uDD1E": "afr",
        "\uD835\uDD38": "Aopf",
        "\uD835\uDD04": "Afr",
        "\uD835\uDC9C": "Ascr",
        "\xaa": "ordf",
        "\xe1": "aacute",
        "\xc1": "Aacute",
        "\xe0": "agrave",
        "\xc0": "Agrave",
        "\u0103": "abreve",
        "\u0102": "Abreve",
        "\xe2": "acirc",
        "\xc2": "Acirc",
        "\xe5": "aring",
        "\xc5": "angst",
        "\xe4": "auml",
        "\xc4": "Auml",
        "\xe3": "atilde",
        "\xc3": "Atilde",
        "\u0105": "aogon",
        "\u0104": "Aogon",
        "\u0101": "amacr",
        "\u0100": "Amacr",
        "\xe6": "aelig",
        "\xc6": "AElig",
        "\uD835\uDCB7": "bscr",
        "\uD835\uDD53": "bopf",
        "\uD835\uDD1F": "bfr",
        "\uD835\uDD39": "Bopf",
        "\u212C": "Bscr",
        "\uD835\uDD05": "Bfr",
        "\uD835\uDD20": "cfr",
        "\uD835\uDCB8": "cscr",
        "\uD835\uDD54": "copf",
        "\u212D": "Cfr",
        "\uD835\uDC9E": "Cscr",
        "\u2102": "Copf",
        "\u0107": "cacute",
        "\u0106": "Cacute",
        "\u0109": "ccirc",
        "\u0108": "Ccirc",
        "\u010D": "ccaron",
        "\u010C": "Ccaron",
        "\u010B": "cdot",
        "\u010A": "Cdot",
        "\xe7": "ccedil",
        "\xc7": "Ccedil",
        "\u2105": "incare",
        "\uD835\uDD21": "dfr",
        "\u2146": "dd",
        "\uD835\uDD55": "dopf",
        "\uD835\uDCB9": "dscr",
        "\uD835\uDC9F": "Dscr",
        "\uD835\uDD07": "Dfr",
        "\u2145": "DD",
        "\uD835\uDD3B": "Dopf",
        "\u010F": "dcaron",
        "\u010E": "Dcaron",
        "\u0111": "dstrok",
        "\u0110": "Dstrok",
        "\xf0": "eth",
        "\xd0": "ETH",
        "\u2147": "ee",
        "\u212F": "escr",
        "\uD835\uDD22": "efr",
        "\uD835\uDD56": "eopf",
        "\u2130": "Escr",
        "\uD835\uDD08": "Efr",
        "\uD835\uDD3C": "Eopf",
        "\xe9": "eacute",
        "\xc9": "Eacute",
        "\xe8": "egrave",
        "\xc8": "Egrave",
        "\xea": "ecirc",
        "\xca": "Ecirc",
        "\u011B": "ecaron",
        "\u011A": "Ecaron",
        "\xeb": "euml",
        "\xcb": "Euml",
        "\u0117": "edot",
        "\u0116": "Edot",
        "\u0119": "eogon",
        "\u0118": "Eogon",
        "\u0113": "emacr",
        "\u0112": "Emacr",
        "\uD835\uDD23": "ffr",
        "\uD835\uDD57": "fopf",
        "\uD835\uDCBB": "fscr",
        "\uD835\uDD09": "Ffr",
        "\uD835\uDD3D": "Fopf",
        "\u2131": "Fscr",
        "\uFB00": "fflig",
        "\uFB03": "ffilig",
        "\uFB04": "ffllig",
        "\uFB01": "filig",
        "fj": "fjlig",
        "\uFB02": "fllig",
        "\u0192": "fnof",
        "\u210A": "gscr",
        "\uD835\uDD58": "gopf",
        "\uD835\uDD24": "gfr",
        "\uD835\uDCA2": "Gscr",
        "\uD835\uDD3E": "Gopf",
        "\uD835\uDD0A": "Gfr",
        "\u01F5": "gacute",
        "\u011F": "gbreve",
        "\u011E": "Gbreve",
        "\u011D": "gcirc",
        "\u011C": "Gcirc",
        "\u0121": "gdot",
        "\u0120": "Gdot",
        "\u0122": "Gcedil",
        "\uD835\uDD25": "hfr",
        "\u210E": "planckh",
        "\uD835\uDCBD": "hscr",
        "\uD835\uDD59": "hopf",
        "\u210B": "Hscr",
        "\u210C": "Hfr",
        "\u210D": "Hopf",
        "\u0125": "hcirc",
        "\u0124": "Hcirc",
        "\u210F": "hbar",
        "\u0127": "hstrok",
        "\u0126": "Hstrok",
        "\uD835\uDD5A": "iopf",
        "\uD835\uDD26": "ifr",
        "\uD835\uDCBE": "iscr",
        "\u2148": "ii",
        "\uD835\uDD40": "Iopf",
        "\u2110": "Iscr",
        "\u2111": "Im",
        "\xed": "iacute",
        "\xcd": "Iacute",
        "\xec": "igrave",
        "\xcc": "Igrave",
        "\xee": "icirc",
        "\xce": "Icirc",
        "\xef": "iuml",
        "\xcf": "Iuml",
        "\u0129": "itilde",
        "\u0128": "Itilde",
        "\u0130": "Idot",
        "\u012F": "iogon",
        "\u012E": "Iogon",
        "\u012B": "imacr",
        "\u012A": "Imacr",
        "\u0133": "ijlig",
        "\u0132": "IJlig",
        "\u0131": "imath",
        "\uD835\uDCBF": "jscr",
        "\uD835\uDD5B": "jopf",
        "\uD835\uDD27": "jfr",
        "\uD835\uDCA5": "Jscr",
        "\uD835\uDD0D": "Jfr",
        "\uD835\uDD41": "Jopf",
        "\u0135": "jcirc",
        "\u0134": "Jcirc",
        "\u0237": "jmath",
        "\uD835\uDD5C": "kopf",
        "\uD835\uDCC0": "kscr",
        "\uD835\uDD28": "kfr",
        "\uD835\uDCA6": "Kscr",
        "\uD835\uDD42": "Kopf",
        "\uD835\uDD0E": "Kfr",
        "\u0137": "kcedil",
        "\u0136": "Kcedil",
        "\uD835\uDD29": "lfr",
        "\uD835\uDCC1": "lscr",
        "\u2113": "ell",
        "\uD835\uDD5D": "lopf",
        "\u2112": "Lscr",
        "\uD835\uDD0F": "Lfr",
        "\uD835\uDD43": "Lopf",
        "\u013A": "lacute",
        "\u0139": "Lacute",
        "\u013E": "lcaron",
        "\u013D": "Lcaron",
        "\u013C": "lcedil",
        "\u013B": "Lcedil",
        "\u0142": "lstrok",
        "\u0141": "Lstrok",
        "\u0140": "lmidot",
        "\u013F": "Lmidot",
        "\uD835\uDD2A": "mfr",
        "\uD835\uDD5E": "mopf",
        "\uD835\uDCC2": "mscr",
        "\uD835\uDD10": "Mfr",
        "\uD835\uDD44": "Mopf",
        "\u2133": "Mscr",
        "\uD835\uDD2B": "nfr",
        "\uD835\uDD5F": "nopf",
        "\uD835\uDCC3": "nscr",
        "\u2115": "Nopf",
        "\uD835\uDCA9": "Nscr",
        "\uD835\uDD11": "Nfr",
        "\u0144": "nacute",
        "\u0143": "Nacute",
        "\u0148": "ncaron",
        "\u0147": "Ncaron",
        "\xf1": "ntilde",
        "\xd1": "Ntilde",
        "\u0146": "ncedil",
        "\u0145": "Ncedil",
        "\u2116": "numero",
        "\u014B": "eng",
        "\u014A": "ENG",
        "\uD835\uDD60": "oopf",
        "\uD835\uDD2C": "ofr",
        "\u2134": "oscr",
        "\uD835\uDCAA": "Oscr",
        "\uD835\uDD12": "Ofr",
        "\uD835\uDD46": "Oopf",
        "\xba": "ordm",
        "\xf3": "oacute",
        "\xd3": "Oacute",
        "\xf2": "ograve",
        "\xd2": "Ograve",
        "\xf4": "ocirc",
        "\xd4": "Ocirc",
        "\xf6": "ouml",
        "\xd6": "Ouml",
        "\u0151": "odblac",
        "\u0150": "Odblac",
        "\xf5": "otilde",
        "\xd5": "Otilde",
        "\xf8": "oslash",
        "\xd8": "Oslash",
        "\u014D": "omacr",
        "\u014C": "Omacr",
        "\u0153": "oelig",
        "\u0152": "OElig",
        "\uD835\uDD2D": "pfr",
        "\uD835\uDCC5": "pscr",
        "\uD835\uDD61": "popf",
        "\u2119": "Popf",
        "\uD835\uDD13": "Pfr",
        "\uD835\uDCAB": "Pscr",
        "\uD835\uDD62": "qopf",
        "\uD835\uDD2E": "qfr",
        "\uD835\uDCC6": "qscr",
        "\uD835\uDCAC": "Qscr",
        "\uD835\uDD14": "Qfr",
        "\u211A": "Qopf",
        "\u0138": "kgreen",
        "\uD835\uDD2F": "rfr",
        "\uD835\uDD63": "ropf",
        "\uD835\uDCC7": "rscr",
        "\u211B": "Rscr",
        "\u211C": "Re",
        "\u211D": "Ropf",
        "\u0155": "racute",
        "\u0154": "Racute",
        "\u0159": "rcaron",
        "\u0158": "Rcaron",
        "\u0157": "rcedil",
        "\u0156": "Rcedil",
        "\uD835\uDD64": "sopf",
        "\uD835\uDCC8": "sscr",
        "\uD835\uDD30": "sfr",
        "\uD835\uDD4A": "Sopf",
        "\uD835\uDD16": "Sfr",
        "\uD835\uDCAE": "Sscr",
        "\u24C8": "oS",
        "\u015B": "sacute",
        "\u015A": "Sacute",
        "\u015D": "scirc",
        "\u015C": "Scirc",
        "\u0161": "scaron",
        "\u0160": "Scaron",
        "\u015F": "scedil",
        "\u015E": "Scedil",
        "\xdf": "szlig",
        "\uD835\uDD31": "tfr",
        "\uD835\uDCC9": "tscr",
        "\uD835\uDD65": "topf",
        "\uD835\uDCAF": "Tscr",
        "\uD835\uDD17": "Tfr",
        "\uD835\uDD4B": "Topf",
        "\u0165": "tcaron",
        "\u0164": "Tcaron",
        "\u0163": "tcedil",
        "\u0162": "Tcedil",
        "\u2122": "trade",
        "\u0167": "tstrok",
        "\u0166": "Tstrok",
        "\uD835\uDCCA": "uscr",
        "\uD835\uDD66": "uopf",
        "\uD835\uDD32": "ufr",
        "\uD835\uDD4C": "Uopf",
        "\uD835\uDD18": "Ufr",
        "\uD835\uDCB0": "Uscr",
        "\xfa": "uacute",
        "\xda": "Uacute",
        "\xf9": "ugrave",
        "\xd9": "Ugrave",
        "\u016D": "ubreve",
        "\u016C": "Ubreve",
        "\xfb": "ucirc",
        "\xdb": "Ucirc",
        "\u016F": "uring",
        "\u016E": "Uring",
        "\xfc": "uuml",
        "\xdc": "Uuml",
        "\u0171": "udblac",
        "\u0170": "Udblac",
        "\u0169": "utilde",
        "\u0168": "Utilde",
        "\u0173": "uogon",
        "\u0172": "Uogon",
        "\u016B": "umacr",
        "\u016A": "Umacr",
        "\uD835\uDD33": "vfr",
        "\uD835\uDD67": "vopf",
        "\uD835\uDCCB": "vscr",
        "\uD835\uDD19": "Vfr",
        "\uD835\uDD4D": "Vopf",
        "\uD835\uDCB1": "Vscr",
        "\uD835\uDD68": "wopf",
        "\uD835\uDCCC": "wscr",
        "\uD835\uDD34": "wfr",
        "\uD835\uDCB2": "Wscr",
        "\uD835\uDD4E": "Wopf",
        "\uD835\uDD1A": "Wfr",
        "\u0175": "wcirc",
        "\u0174": "Wcirc",
        "\uD835\uDD35": "xfr",
        "\uD835\uDCCD": "xscr",
        "\uD835\uDD69": "xopf",
        "\uD835\uDD4F": "Xopf",
        "\uD835\uDD1B": "Xfr",
        "\uD835\uDCB3": "Xscr",
        "\uD835\uDD36": "yfr",
        "\uD835\uDCCE": "yscr",
        "\uD835\uDD6A": "yopf",
        "\uD835\uDCB4": "Yscr",
        "\uD835\uDD1C": "Yfr",
        "\uD835\uDD50": "Yopf",
        "\xfd": "yacute",
        "\xdd": "Yacute",
        "\u0177": "ycirc",
        "\u0176": "Ycirc",
        "\xff": "yuml",
        "\u0178": "Yuml",
        "\uD835\uDCCF": "zscr",
        "\uD835\uDD37": "zfr",
        "\uD835\uDD6B": "zopf",
        "\u2128": "Zfr",
        "\u2124": "Zopf",
        "\uD835\uDCB5": "Zscr",
        "\u017A": "zacute",
        "\u0179": "Zacute",
        "\u017E": "zcaron",
        "\u017D": "Zcaron",
        "\u017C": "zdot",
        "\u017B": "Zdot",
        "\u01B5": "imped",
        "\xfe": "thorn",
        "\xde": "THORN",
        "\u0149": "napos",
        "\u03B1": "alpha",
        "\u0391": "Alpha",
        "\u03B2": "beta",
        "\u0392": "Beta",
        "\u03B3": "gamma",
        "\u0393": "Gamma",
        "\u03B4": "delta",
        "\u0394": "Delta",
        "\u03B5": "epsi",
        "\u03F5": "epsiv",
        "\u0395": "Epsilon",
        "\u03DD": "gammad",
        "\u03DC": "Gammad",
        "\u03B6": "zeta",
        "\u0396": "Zeta",
        "\u03B7": "eta",
        "\u0397": "Eta",
        "\u03B8": "theta",
        "\u03D1": "thetav",
        "\u0398": "Theta",
        "\u03B9": "iota",
        "\u0399": "Iota",
        "\u03BA": "kappa",
        "\u03F0": "kappav",
        "\u039A": "Kappa",
        "\u03BB": "lambda",
        "\u039B": "Lambda",
        "\u03BC": "mu",
        "\xb5": "micro",
        "\u039C": "Mu",
        "\u03BD": "nu",
        "\u039D": "Nu",
        "\u03BE": "xi",
        "\u039E": "Xi",
        "\u03BF": "omicron",
        "\u039F": "Omicron",
        "\u03C0": "pi",
        "\u03D6": "piv",
        "\u03A0": "Pi",
        "\u03C1": "rho",
        "\u03F1": "rhov",
        "\u03A1": "Rho",
        "\u03C3": "sigma",
        "\u03A3": "Sigma",
        "\u03C2": "sigmaf",
        "\u03C4": "tau",
        "\u03A4": "Tau",
        "\u03C5": "upsi",
        "\u03A5": "Upsilon",
        "\u03D2": "Upsi",
        "\u03C6": "phi",
        "\u03D5": "phiv",
        "\u03A6": "Phi",
        "\u03C7": "chi",
        "\u03A7": "Chi",
        "\u03C8": "psi",
        "\u03A8": "Psi",
        "\u03C9": "omega",
        "\u03A9": "ohm",
        "\u0430": "acy",
        "\u0410": "Acy",
        "\u0431": "bcy",
        "\u0411": "Bcy",
        "\u0432": "vcy",
        "\u0412": "Vcy",
        "\u0433": "gcy",
        "\u0413": "Gcy",
        "\u0453": "gjcy",
        "\u0403": "GJcy",
        "\u0434": "dcy",
        "\u0414": "Dcy",
        "\u0452": "djcy",
        "\u0402": "DJcy",
        "\u0435": "iecy",
        "\u0415": "IEcy",
        "\u0451": "iocy",
        "\u0401": "IOcy",
        "\u0454": "jukcy",
        "\u0404": "Jukcy",
        "\u0436": "zhcy",
        "\u0416": "ZHcy",
        "\u0437": "zcy",
        "\u0417": "Zcy",
        "\u0455": "dscy",
        "\u0405": "DScy",
        "\u0438": "icy",
        "\u0418": "Icy",
        "\u0456": "iukcy",
        "\u0406": "Iukcy",
        "\u0457": "yicy",
        "\u0407": "YIcy",
        "\u0439": "jcy",
        "\u0419": "Jcy",
        "\u0458": "jsercy",
        "\u0408": "Jsercy",
        "\u043A": "kcy",
        "\u041A": "Kcy",
        "\u045C": "kjcy",
        "\u040C": "KJcy",
        "\u043B": "lcy",
        "\u041B": "Lcy",
        "\u0459": "ljcy",
        "\u0409": "LJcy",
        "\u043C": "mcy",
        "\u041C": "Mcy",
        "\u043D": "ncy",
        "\u041D": "Ncy",
        "\u045A": "njcy",
        "\u040A": "NJcy",
        "\u043E": "ocy",
        "\u041E": "Ocy",
        "\u043F": "pcy",
        "\u041F": "Pcy",
        "\u0440": "rcy",
        "\u0420": "Rcy",
        "\u0441": "scy",
        "\u0421": "Scy",
        "\u0442": "tcy",
        "\u0422": "Tcy",
        "\u045B": "tshcy",
        "\u040B": "TSHcy",
        "\u0443": "ucy",
        "\u0423": "Ucy",
        "\u045E": "ubrcy",
        "\u040E": "Ubrcy",
        "\u0444": "fcy",
        "\u0424": "Fcy",
        "\u0445": "khcy",
        "\u0425": "KHcy",
        "\u0446": "tscy",
        "\u0426": "TScy",
        "\u0447": "chcy",
        "\u0427": "CHcy",
        "\u045F": "dzcy",
        "\u040F": "DZcy",
        "\u0448": "shcy",
        "\u0428": "SHcy",
        "\u0449": "shchcy",
        "\u0429": "SHCHcy",
        "\u044A": "hardcy",
        "\u042A": "HARDcy",
        "\u044B": "ycy",
        "\u042B": "Ycy",
        "\u044C": "softcy",
        "\u042C": "SOFTcy",
        "\u044D": "ecy",
        "\u042D": "Ecy",
        "\u044E": "yucy",
        "\u042E": "YUcy",
        "\u044F": "yacy",
        "\u042F": "YAcy",
        "\u2135": "aleph",
        "\u2136": "beth",
        "\u2137": "gimel",
        "\u2138": "daleth"
    };
    var regexEscape = /["&'<>`]/g;
    var escapeMap = {
        '"': "&quot;",
        "&": "&amp;",
        "'": "&#x27;",
        "<": "&lt;",
        // See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
        // following is not strictly necessary unless it’s part of a tag or an
        // unquoted attribute value. We’re only escaping it to support those
        // situations, and for XML support.
        ">": "&gt;",
        // In Internet Explorer ≤ 8, the backtick character can be used
        // to break out of (un)quoted attribute values or HTML comments.
        // See http://html5sec.org/#102, http://html5sec.org/#108, and
        // http://html5sec.org/#133.
        "`": "&#x60;"
    };
    var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
    var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
    var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
    var decodeMap = {
        "aacute": "\xe1",
        "Aacute": "\xc1",
        "abreve": "\u0103",
        "Abreve": "\u0102",
        "ac": "\u223E",
        "acd": "\u223F",
        "acE": "\u223E\u0333",
        "acirc": "\xe2",
        "Acirc": "\xc2",
        "acute": "\xb4",
        "acy": "\u0430",
        "Acy": "\u0410",
        "aelig": "\xe6",
        "AElig": "\xc6",
        "af": "\u2061",
        "afr": "\uD835\uDD1E",
        "Afr": "\uD835\uDD04",
        "agrave": "\xe0",
        "Agrave": "\xc0",
        "alefsym": "\u2135",
        "aleph": "\u2135",
        "alpha": "\u03B1",
        "Alpha": "\u0391",
        "amacr": "\u0101",
        "Amacr": "\u0100",
        "amalg": "\u2A3F",
        "amp": "&",
        "AMP": "&",
        "and": "\u2227",
        "And": "\u2A53",
        "andand": "\u2A55",
        "andd": "\u2A5C",
        "andslope": "\u2A58",
        "andv": "\u2A5A",
        "ang": "\u2220",
        "ange": "\u29A4",
        "angle": "\u2220",
        "angmsd": "\u2221",
        "angmsdaa": "\u29A8",
        "angmsdab": "\u29A9",
        "angmsdac": "\u29AA",
        "angmsdad": "\u29AB",
        "angmsdae": "\u29AC",
        "angmsdaf": "\u29AD",
        "angmsdag": "\u29AE",
        "angmsdah": "\u29AF",
        "angrt": "\u221F",
        "angrtvb": "\u22BE",
        "angrtvbd": "\u299D",
        "angsph": "\u2222",
        "angst": "\xc5",
        "angzarr": "\u237C",
        "aogon": "\u0105",
        "Aogon": "\u0104",
        "aopf": "\uD835\uDD52",
        "Aopf": "\uD835\uDD38",
        "ap": "\u2248",
        "apacir": "\u2A6F",
        "ape": "\u224A",
        "apE": "\u2A70",
        "apid": "\u224B",
        "apos": "'",
        "ApplyFunction": "\u2061",
        "approx": "\u2248",
        "approxeq": "\u224A",
        "aring": "\xe5",
        "Aring": "\xc5",
        "ascr": "\uD835\uDCB6",
        "Ascr": "\uD835\uDC9C",
        "Assign": "\u2254",
        "ast": "*",
        "asymp": "\u2248",
        "asympeq": "\u224D",
        "atilde": "\xe3",
        "Atilde": "\xc3",
        "auml": "\xe4",
        "Auml": "\xc4",
        "awconint": "\u2233",
        "awint": "\u2A11",
        "backcong": "\u224C",
        "backepsilon": "\u03F6",
        "backprime": "\u2035",
        "backsim": "\u223D",
        "backsimeq": "\u22CD",
        "Backslash": "\u2216",
        "Barv": "\u2AE7",
        "barvee": "\u22BD",
        "barwed": "\u2305",
        "Barwed": "\u2306",
        "barwedge": "\u2305",
        "bbrk": "\u23B5",
        "bbrktbrk": "\u23B6",
        "bcong": "\u224C",
        "bcy": "\u0431",
        "Bcy": "\u0411",
        "bdquo": "\u201E",
        "becaus": "\u2235",
        "because": "\u2235",
        "Because": "\u2235",
        "bemptyv": "\u29B0",
        "bepsi": "\u03F6",
        "bernou": "\u212C",
        "Bernoullis": "\u212C",
        "beta": "\u03B2",
        "Beta": "\u0392",
        "beth": "\u2136",
        "between": "\u226C",
        "bfr": "\uD835\uDD1F",
        "Bfr": "\uD835\uDD05",
        "bigcap": "\u22C2",
        "bigcirc": "\u25EF",
        "bigcup": "\u22C3",
        "bigodot": "\u2A00",
        "bigoplus": "\u2A01",
        "bigotimes": "\u2A02",
        "bigsqcup": "\u2A06",
        "bigstar": "\u2605",
        "bigtriangledown": "\u25BD",
        "bigtriangleup": "\u25B3",
        "biguplus": "\u2A04",
        "bigvee": "\u22C1",
        "bigwedge": "\u22C0",
        "bkarow": "\u290D",
        "blacklozenge": "\u29EB",
        "blacksquare": "\u25AA",
        "blacktriangle": "\u25B4",
        "blacktriangledown": "\u25BE",
        "blacktriangleleft": "\u25C2",
        "blacktriangleright": "\u25B8",
        "blank": "\u2423",
        "blk12": "\u2592",
        "blk14": "\u2591",
        "blk34": "\u2593",
        "block": "\u2588",
        "bne": "=\u20E5",
        "bnequiv": "\u2261\u20E5",
        "bnot": "\u2310",
        "bNot": "\u2AED",
        "bopf": "\uD835\uDD53",
        "Bopf": "\uD835\uDD39",
        "bot": "\u22A5",
        "bottom": "\u22A5",
        "bowtie": "\u22C8",
        "boxbox": "\u29C9",
        "boxdl": "\u2510",
        "boxdL": "\u2555",
        "boxDl": "\u2556",
        "boxDL": "\u2557",
        "boxdr": "\u250C",
        "boxdR": "\u2552",
        "boxDr": "\u2553",
        "boxDR": "\u2554",
        "boxh": "\u2500",
        "boxH": "\u2550",
        "boxhd": "\u252C",
        "boxhD": "\u2565",
        "boxHd": "\u2564",
        "boxHD": "\u2566",
        "boxhu": "\u2534",
        "boxhU": "\u2568",
        "boxHu": "\u2567",
        "boxHU": "\u2569",
        "boxminus": "\u229F",
        "boxplus": "\u229E",
        "boxtimes": "\u22A0",
        "boxul": "\u2518",
        "boxuL": "\u255B",
        "boxUl": "\u255C",
        "boxUL": "\u255D",
        "boxur": "\u2514",
        "boxuR": "\u2558",
        "boxUr": "\u2559",
        "boxUR": "\u255A",
        "boxv": "\u2502",
        "boxV": "\u2551",
        "boxvh": "\u253C",
        "boxvH": "\u256A",
        "boxVh": "\u256B",
        "boxVH": "\u256C",
        "boxvl": "\u2524",
        "boxvL": "\u2561",
        "boxVl": "\u2562",
        "boxVL": "\u2563",
        "boxvr": "\u251C",
        "boxvR": "\u255E",
        "boxVr": "\u255F",
        "boxVR": "\u2560",
        "bprime": "\u2035",
        "breve": "\u02D8",
        "Breve": "\u02D8",
        "brvbar": "\xa6",
        "bscr": "\uD835\uDCB7",
        "Bscr": "\u212C",
        "bsemi": "\u204F",
        "bsim": "\u223D",
        "bsime": "\u22CD",
        "bsol": "\\",
        "bsolb": "\u29C5",
        "bsolhsub": "\u27C8",
        "bull": "\u2022",
        "bullet": "\u2022",
        "bump": "\u224E",
        "bumpe": "\u224F",
        "bumpE": "\u2AAE",
        "bumpeq": "\u224F",
        "Bumpeq": "\u224E",
        "cacute": "\u0107",
        "Cacute": "\u0106",
        "cap": "\u2229",
        "Cap": "\u22D2",
        "capand": "\u2A44",
        "capbrcup": "\u2A49",
        "capcap": "\u2A4B",
        "capcup": "\u2A47",
        "capdot": "\u2A40",
        "CapitalDifferentialD": "\u2145",
        "caps": "\u2229\uFE00",
        "caret": "\u2041",
        "caron": "\u02C7",
        "Cayleys": "\u212D",
        "ccaps": "\u2A4D",
        "ccaron": "\u010D",
        "Ccaron": "\u010C",
        "ccedil": "\xe7",
        "Ccedil": "\xc7",
        "ccirc": "\u0109",
        "Ccirc": "\u0108",
        "Cconint": "\u2230",
        "ccups": "\u2A4C",
        "ccupssm": "\u2A50",
        "cdot": "\u010B",
        "Cdot": "\u010A",
        "cedil": "\xb8",
        "Cedilla": "\xb8",
        "cemptyv": "\u29B2",
        "cent": "\xa2",
        "centerdot": "\xb7",
        "CenterDot": "\xb7",
        "cfr": "\uD835\uDD20",
        "Cfr": "\u212D",
        "chcy": "\u0447",
        "CHcy": "\u0427",
        "check": "\u2713",
        "checkmark": "\u2713",
        "chi": "\u03C7",
        "Chi": "\u03A7",
        "cir": "\u25CB",
        "circ": "\u02C6",
        "circeq": "\u2257",
        "circlearrowleft": "\u21BA",
        "circlearrowright": "\u21BB",
        "circledast": "\u229B",
        "circledcirc": "\u229A",
        "circleddash": "\u229D",
        "CircleDot": "\u2299",
        "circledR": "\xae",
        "circledS": "\u24C8",
        "CircleMinus": "\u2296",
        "CirclePlus": "\u2295",
        "CircleTimes": "\u2297",
        "cire": "\u2257",
        "cirE": "\u29C3",
        "cirfnint": "\u2A10",
        "cirmid": "\u2AEF",
        "cirscir": "\u29C2",
        "ClockwiseContourIntegral": "\u2232",
        "CloseCurlyDoubleQuote": "\u201D",
        "CloseCurlyQuote": "\u2019",
        "clubs": "\u2663",
        "clubsuit": "\u2663",
        "colon": ":",
        "Colon": "\u2237",
        "colone": "\u2254",
        "Colone": "\u2A74",
        "coloneq": "\u2254",
        "comma": ",",
        "commat": "@",
        "comp": "\u2201",
        "compfn": "\u2218",
        "complement": "\u2201",
        "complexes": "\u2102",
        "cong": "\u2245",
        "congdot": "\u2A6D",
        "Congruent": "\u2261",
        "conint": "\u222E",
        "Conint": "\u222F",
        "ContourIntegral": "\u222E",
        "copf": "\uD835\uDD54",
        "Copf": "\u2102",
        "coprod": "\u2210",
        "Coproduct": "\u2210",
        "copy": "\xa9",
        "COPY": "\xa9",
        "copysr": "\u2117",
        "CounterClockwiseContourIntegral": "\u2233",
        "crarr": "\u21B5",
        "cross": "\u2717",
        "Cross": "\u2A2F",
        "cscr": "\uD835\uDCB8",
        "Cscr": "\uD835\uDC9E",
        "csub": "\u2ACF",
        "csube": "\u2AD1",
        "csup": "\u2AD0",
        "csupe": "\u2AD2",
        "ctdot": "\u22EF",
        "cudarrl": "\u2938",
        "cudarrr": "\u2935",
        "cuepr": "\u22DE",
        "cuesc": "\u22DF",
        "cularr": "\u21B6",
        "cularrp": "\u293D",
        "cup": "\u222A",
        "Cup": "\u22D3",
        "cupbrcap": "\u2A48",
        "cupcap": "\u2A46",
        "CupCap": "\u224D",
        "cupcup": "\u2A4A",
        "cupdot": "\u228D",
        "cupor": "\u2A45",
        "cups": "\u222A\uFE00",
        "curarr": "\u21B7",
        "curarrm": "\u293C",
        "curlyeqprec": "\u22DE",
        "curlyeqsucc": "\u22DF",
        "curlyvee": "\u22CE",
        "curlywedge": "\u22CF",
        "curren": "\xa4",
        "curvearrowleft": "\u21B6",
        "curvearrowright": "\u21B7",
        "cuvee": "\u22CE",
        "cuwed": "\u22CF",
        "cwconint": "\u2232",
        "cwint": "\u2231",
        "cylcty": "\u232D",
        "dagger": "\u2020",
        "Dagger": "\u2021",
        "daleth": "\u2138",
        "darr": "\u2193",
        "dArr": "\u21D3",
        "Darr": "\u21A1",
        "dash": "\u2010",
        "dashv": "\u22A3",
        "Dashv": "\u2AE4",
        "dbkarow": "\u290F",
        "dblac": "\u02DD",
        "dcaron": "\u010F",
        "Dcaron": "\u010E",
        "dcy": "\u0434",
        "Dcy": "\u0414",
        "dd": "\u2146",
        "DD": "\u2145",
        "ddagger": "\u2021",
        "ddarr": "\u21CA",
        "DDotrahd": "\u2911",
        "ddotseq": "\u2A77",
        "deg": "\xb0",
        "Del": "\u2207",
        "delta": "\u03B4",
        "Delta": "\u0394",
        "demptyv": "\u29B1",
        "dfisht": "\u297F",
        "dfr": "\uD835\uDD21",
        "Dfr": "\uD835\uDD07",
        "dHar": "\u2965",
        "dharl": "\u21C3",
        "dharr": "\u21C2",
        "DiacriticalAcute": "\xb4",
        "DiacriticalDot": "\u02D9",
        "DiacriticalDoubleAcute": "\u02DD",
        "DiacriticalGrave": "`",
        "DiacriticalTilde": "\u02DC",
        "diam": "\u22C4",
        "diamond": "\u22C4",
        "Diamond": "\u22C4",
        "diamondsuit": "\u2666",
        "diams": "\u2666",
        "die": "\xa8",
        "DifferentialD": "\u2146",
        "digamma": "\u03DD",
        "disin": "\u22F2",
        "div": "\xf7",
        "divide": "\xf7",
        "divideontimes": "\u22C7",
        "divonx": "\u22C7",
        "djcy": "\u0452",
        "DJcy": "\u0402",
        "dlcorn": "\u231E",
        "dlcrop": "\u230D",
        "dollar": "$",
        "dopf": "\uD835\uDD55",
        "Dopf": "\uD835\uDD3B",
        "dot": "\u02D9",
        "Dot": "\xa8",
        "DotDot": "\u20DC",
        "doteq": "\u2250",
        "doteqdot": "\u2251",
        "DotEqual": "\u2250",
        "dotminus": "\u2238",
        "dotplus": "\u2214",
        "dotsquare": "\u22A1",
        "doublebarwedge": "\u2306",
        "DoubleContourIntegral": "\u222F",
        "DoubleDot": "\xa8",
        "DoubleDownArrow": "\u21D3",
        "DoubleLeftArrow": "\u21D0",
        "DoubleLeftRightArrow": "\u21D4",
        "DoubleLeftTee": "\u2AE4",
        "DoubleLongLeftArrow": "\u27F8",
        "DoubleLongLeftRightArrow": "\u27FA",
        "DoubleLongRightArrow": "\u27F9",
        "DoubleRightArrow": "\u21D2",
        "DoubleRightTee": "\u22A8",
        "DoubleUpArrow": "\u21D1",
        "DoubleUpDownArrow": "\u21D5",
        "DoubleVerticalBar": "\u2225",
        "downarrow": "\u2193",
        "Downarrow": "\u21D3",
        "DownArrow": "\u2193",
        "DownArrowBar": "\u2913",
        "DownArrowUpArrow": "\u21F5",
        "DownBreve": "\u0311",
        "downdownarrows": "\u21CA",
        "downharpoonleft": "\u21C3",
        "downharpoonright": "\u21C2",
        "DownLeftRightVector": "\u2950",
        "DownLeftTeeVector": "\u295E",
        "DownLeftVector": "\u21BD",
        "DownLeftVectorBar": "\u2956",
        "DownRightTeeVector": "\u295F",
        "DownRightVector": "\u21C1",
        "DownRightVectorBar": "\u2957",
        "DownTee": "\u22A4",
        "DownTeeArrow": "\u21A7",
        "drbkarow": "\u2910",
        "drcorn": "\u231F",
        "drcrop": "\u230C",
        "dscr": "\uD835\uDCB9",
        "Dscr": "\uD835\uDC9F",
        "dscy": "\u0455",
        "DScy": "\u0405",
        "dsol": "\u29F6",
        "dstrok": "\u0111",
        "Dstrok": "\u0110",
        "dtdot": "\u22F1",
        "dtri": "\u25BF",
        "dtrif": "\u25BE",
        "duarr": "\u21F5",
        "duhar": "\u296F",
        "dwangle": "\u29A6",
        "dzcy": "\u045F",
        "DZcy": "\u040F",
        "dzigrarr": "\u27FF",
        "eacute": "\xe9",
        "Eacute": "\xc9",
        "easter": "\u2A6E",
        "ecaron": "\u011B",
        "Ecaron": "\u011A",
        "ecir": "\u2256",
        "ecirc": "\xea",
        "Ecirc": "\xca",
        "ecolon": "\u2255",
        "ecy": "\u044D",
        "Ecy": "\u042D",
        "eDDot": "\u2A77",
        "edot": "\u0117",
        "eDot": "\u2251",
        "Edot": "\u0116",
        "ee": "\u2147",
        "efDot": "\u2252",
        "efr": "\uD835\uDD22",
        "Efr": "\uD835\uDD08",
        "eg": "\u2A9A",
        "egrave": "\xe8",
        "Egrave": "\xc8",
        "egs": "\u2A96",
        "egsdot": "\u2A98",
        "el": "\u2A99",
        "Element": "\u2208",
        "elinters": "\u23E7",
        "ell": "\u2113",
        "els": "\u2A95",
        "elsdot": "\u2A97",
        "emacr": "\u0113",
        "Emacr": "\u0112",
        "empty": "\u2205",
        "emptyset": "\u2205",
        "EmptySmallSquare": "\u25FB",
        "emptyv": "\u2205",
        "EmptyVerySmallSquare": "\u25AB",
        "emsp": "\u2003",
        "emsp13": "\u2004",
        "emsp14": "\u2005",
        "eng": "\u014B",
        "ENG": "\u014A",
        "ensp": "\u2002",
        "eogon": "\u0119",
        "Eogon": "\u0118",
        "eopf": "\uD835\uDD56",
        "Eopf": "\uD835\uDD3C",
        "epar": "\u22D5",
        "eparsl": "\u29E3",
        "eplus": "\u2A71",
        "epsi": "\u03B5",
        "epsilon": "\u03B5",
        "Epsilon": "\u0395",
        "epsiv": "\u03F5",
        "eqcirc": "\u2256",
        "eqcolon": "\u2255",
        "eqsim": "\u2242",
        "eqslantgtr": "\u2A96",
        "eqslantless": "\u2A95",
        "Equal": "\u2A75",
        "equals": "=",
        "EqualTilde": "\u2242",
        "equest": "\u225F",
        "Equilibrium": "\u21CC",
        "equiv": "\u2261",
        "equivDD": "\u2A78",
        "eqvparsl": "\u29E5",
        "erarr": "\u2971",
        "erDot": "\u2253",
        "escr": "\u212F",
        "Escr": "\u2130",
        "esdot": "\u2250",
        "esim": "\u2242",
        "Esim": "\u2A73",
        "eta": "\u03B7",
        "Eta": "\u0397",
        "eth": "\xf0",
        "ETH": "\xd0",
        "euml": "\xeb",
        "Euml": "\xcb",
        "euro": "\u20AC",
        "excl": "!",
        "exist": "\u2203",
        "Exists": "\u2203",
        "expectation": "\u2130",
        "exponentiale": "\u2147",
        "ExponentialE": "\u2147",
        "fallingdotseq": "\u2252",
        "fcy": "\u0444",
        "Fcy": "\u0424",
        "female": "\u2640",
        "ffilig": "\uFB03",
        "fflig": "\uFB00",
        "ffllig": "\uFB04",
        "ffr": "\uD835\uDD23",
        "Ffr": "\uD835\uDD09",
        "filig": "\uFB01",
        "FilledSmallSquare": "\u25FC",
        "FilledVerySmallSquare": "\u25AA",
        "fjlig": "fj",
        "flat": "\u266D",
        "fllig": "\uFB02",
        "fltns": "\u25B1",
        "fnof": "\u0192",
        "fopf": "\uD835\uDD57",
        "Fopf": "\uD835\uDD3D",
        "forall": "\u2200",
        "ForAll": "\u2200",
        "fork": "\u22D4",
        "forkv": "\u2AD9",
        "Fouriertrf": "\u2131",
        "fpartint": "\u2A0D",
        "frac12": "\xbd",
        "frac13": "\u2153",
        "frac14": "\xbc",
        "frac15": "\u2155",
        "frac16": "\u2159",
        "frac18": "\u215B",
        "frac23": "\u2154",
        "frac25": "\u2156",
        "frac34": "\xbe",
        "frac35": "\u2157",
        "frac38": "\u215C",
        "frac45": "\u2158",
        "frac56": "\u215A",
        "frac58": "\u215D",
        "frac78": "\u215E",
        "frasl": "\u2044",
        "frown": "\u2322",
        "fscr": "\uD835\uDCBB",
        "Fscr": "\u2131",
        "gacute": "\u01F5",
        "gamma": "\u03B3",
        "Gamma": "\u0393",
        "gammad": "\u03DD",
        "Gammad": "\u03DC",
        "gap": "\u2A86",
        "gbreve": "\u011F",
        "Gbreve": "\u011E",
        "Gcedil": "\u0122",
        "gcirc": "\u011D",
        "Gcirc": "\u011C",
        "gcy": "\u0433",
        "Gcy": "\u0413",
        "gdot": "\u0121",
        "Gdot": "\u0120",
        "ge": "\u2265",
        "gE": "\u2267",
        "gel": "\u22DB",
        "gEl": "\u2A8C",
        "geq": "\u2265",
        "geqq": "\u2267",
        "geqslant": "\u2A7E",
        "ges": "\u2A7E",
        "gescc": "\u2AA9",
        "gesdot": "\u2A80",
        "gesdoto": "\u2A82",
        "gesdotol": "\u2A84",
        "gesl": "\u22DB\uFE00",
        "gesles": "\u2A94",
        "gfr": "\uD835\uDD24",
        "Gfr": "\uD835\uDD0A",
        "gg": "\u226B",
        "Gg": "\u22D9",
        "ggg": "\u22D9",
        "gimel": "\u2137",
        "gjcy": "\u0453",
        "GJcy": "\u0403",
        "gl": "\u2277",
        "gla": "\u2AA5",
        "glE": "\u2A92",
        "glj": "\u2AA4",
        "gnap": "\u2A8A",
        "gnapprox": "\u2A8A",
        "gne": "\u2A88",
        "gnE": "\u2269",
        "gneq": "\u2A88",
        "gneqq": "\u2269",
        "gnsim": "\u22E7",
        "gopf": "\uD835\uDD58",
        "Gopf": "\uD835\uDD3E",
        "grave": "`",
        "GreaterEqual": "\u2265",
        "GreaterEqualLess": "\u22DB",
        "GreaterFullEqual": "\u2267",
        "GreaterGreater": "\u2AA2",
        "GreaterLess": "\u2277",
        "GreaterSlantEqual": "\u2A7E",
        "GreaterTilde": "\u2273",
        "gscr": "\u210A",
        "Gscr": "\uD835\uDCA2",
        "gsim": "\u2273",
        "gsime": "\u2A8E",
        "gsiml": "\u2A90",
        "gt": ">",
        "Gt": "\u226B",
        "GT": ">",
        "gtcc": "\u2AA7",
        "gtcir": "\u2A7A",
        "gtdot": "\u22D7",
        "gtlPar": "\u2995",
        "gtquest": "\u2A7C",
        "gtrapprox": "\u2A86",
        "gtrarr": "\u2978",
        "gtrdot": "\u22D7",
        "gtreqless": "\u22DB",
        "gtreqqless": "\u2A8C",
        "gtrless": "\u2277",
        "gtrsim": "\u2273",
        "gvertneqq": "\u2269\uFE00",
        "gvnE": "\u2269\uFE00",
        "Hacek": "\u02C7",
        "hairsp": "\u200A",
        "half": "\xbd",
        "hamilt": "\u210B",
        "hardcy": "\u044A",
        "HARDcy": "\u042A",
        "harr": "\u2194",
        "hArr": "\u21D4",
        "harrcir": "\u2948",
        "harrw": "\u21AD",
        "Hat": "^",
        "hbar": "\u210F",
        "hcirc": "\u0125",
        "Hcirc": "\u0124",
        "hearts": "\u2665",
        "heartsuit": "\u2665",
        "hellip": "\u2026",
        "hercon": "\u22B9",
        "hfr": "\uD835\uDD25",
        "Hfr": "\u210C",
        "HilbertSpace": "\u210B",
        "hksearow": "\u2925",
        "hkswarow": "\u2926",
        "hoarr": "\u21FF",
        "homtht": "\u223B",
        "hookleftarrow": "\u21A9",
        "hookrightarrow": "\u21AA",
        "hopf": "\uD835\uDD59",
        "Hopf": "\u210D",
        "horbar": "\u2015",
        "HorizontalLine": "\u2500",
        "hscr": "\uD835\uDCBD",
        "Hscr": "\u210B",
        "hslash": "\u210F",
        "hstrok": "\u0127",
        "Hstrok": "\u0126",
        "HumpDownHump": "\u224E",
        "HumpEqual": "\u224F",
        "hybull": "\u2043",
        "hyphen": "\u2010",
        "iacute": "\xed",
        "Iacute": "\xcd",
        "ic": "\u2063",
        "icirc": "\xee",
        "Icirc": "\xce",
        "icy": "\u0438",
        "Icy": "\u0418",
        "Idot": "\u0130",
        "iecy": "\u0435",
        "IEcy": "\u0415",
        "iexcl": "\xa1",
        "iff": "\u21D4",
        "ifr": "\uD835\uDD26",
        "Ifr": "\u2111",
        "igrave": "\xec",
        "Igrave": "\xcc",
        "ii": "\u2148",
        "iiiint": "\u2A0C",
        "iiint": "\u222D",
        "iinfin": "\u29DC",
        "iiota": "\u2129",
        "ijlig": "\u0133",
        "IJlig": "\u0132",
        "Im": "\u2111",
        "imacr": "\u012B",
        "Imacr": "\u012A",
        "image": "\u2111",
        "ImaginaryI": "\u2148",
        "imagline": "\u2110",
        "imagpart": "\u2111",
        "imath": "\u0131",
        "imof": "\u22B7",
        "imped": "\u01B5",
        "Implies": "\u21D2",
        "in": "\u2208",
        "incare": "\u2105",
        "infin": "\u221E",
        "infintie": "\u29DD",
        "inodot": "\u0131",
        "int": "\u222B",
        "Int": "\u222C",
        "intcal": "\u22BA",
        "integers": "\u2124",
        "Integral": "\u222B",
        "intercal": "\u22BA",
        "Intersection": "\u22C2",
        "intlarhk": "\u2A17",
        "intprod": "\u2A3C",
        "InvisibleComma": "\u2063",
        "InvisibleTimes": "\u2062",
        "iocy": "\u0451",
        "IOcy": "\u0401",
        "iogon": "\u012F",
        "Iogon": "\u012E",
        "iopf": "\uD835\uDD5A",
        "Iopf": "\uD835\uDD40",
        "iota": "\u03B9",
        "Iota": "\u0399",
        "iprod": "\u2A3C",
        "iquest": "\xbf",
        "iscr": "\uD835\uDCBE",
        "Iscr": "\u2110",
        "isin": "\u2208",
        "isindot": "\u22F5",
        "isinE": "\u22F9",
        "isins": "\u22F4",
        "isinsv": "\u22F3",
        "isinv": "\u2208",
        "it": "\u2062",
        "itilde": "\u0129",
        "Itilde": "\u0128",
        "iukcy": "\u0456",
        "Iukcy": "\u0406",
        "iuml": "\xef",
        "Iuml": "\xcf",
        "jcirc": "\u0135",
        "Jcirc": "\u0134",
        "jcy": "\u0439",
        "Jcy": "\u0419",
        "jfr": "\uD835\uDD27",
        "Jfr": "\uD835\uDD0D",
        "jmath": "\u0237",
        "jopf": "\uD835\uDD5B",
        "Jopf": "\uD835\uDD41",
        "jscr": "\uD835\uDCBF",
        "Jscr": "\uD835\uDCA5",
        "jsercy": "\u0458",
        "Jsercy": "\u0408",
        "jukcy": "\u0454",
        "Jukcy": "\u0404",
        "kappa": "\u03BA",
        "Kappa": "\u039A",
        "kappav": "\u03F0",
        "kcedil": "\u0137",
        "Kcedil": "\u0136",
        "kcy": "\u043A",
        "Kcy": "\u041A",
        "kfr": "\uD835\uDD28",
        "Kfr": "\uD835\uDD0E",
        "kgreen": "\u0138",
        "khcy": "\u0445",
        "KHcy": "\u0425",
        "kjcy": "\u045C",
        "KJcy": "\u040C",
        "kopf": "\uD835\uDD5C",
        "Kopf": "\uD835\uDD42",
        "kscr": "\uD835\uDCC0",
        "Kscr": "\uD835\uDCA6",
        "lAarr": "\u21DA",
        "lacute": "\u013A",
        "Lacute": "\u0139",
        "laemptyv": "\u29B4",
        "lagran": "\u2112",
        "lambda": "\u03BB",
        "Lambda": "\u039B",
        "lang": "\u27E8",
        "Lang": "\u27EA",
        "langd": "\u2991",
        "langle": "\u27E8",
        "lap": "\u2A85",
        "Laplacetrf": "\u2112",
        "laquo": "\xab",
        "larr": "\u2190",
        "lArr": "\u21D0",
        "Larr": "\u219E",
        "larrb": "\u21E4",
        "larrbfs": "\u291F",
        "larrfs": "\u291D",
        "larrhk": "\u21A9",
        "larrlp": "\u21AB",
        "larrpl": "\u2939",
        "larrsim": "\u2973",
        "larrtl": "\u21A2",
        "lat": "\u2AAB",
        "latail": "\u2919",
        "lAtail": "\u291B",
        "late": "\u2AAD",
        "lates": "\u2AAD\uFE00",
        "lbarr": "\u290C",
        "lBarr": "\u290E",
        "lbbrk": "\u2772",
        "lbrace": "{",
        "lbrack": "[",
        "lbrke": "\u298B",
        "lbrksld": "\u298F",
        "lbrkslu": "\u298D",
        "lcaron": "\u013E",
        "Lcaron": "\u013D",
        "lcedil": "\u013C",
        "Lcedil": "\u013B",
        "lceil": "\u2308",
        "lcub": "{",
        "lcy": "\u043B",
        "Lcy": "\u041B",
        "ldca": "\u2936",
        "ldquo": "\u201C",
        "ldquor": "\u201E",
        "ldrdhar": "\u2967",
        "ldrushar": "\u294B",
        "ldsh": "\u21B2",
        "le": "\u2264",
        "lE": "\u2266",
        "LeftAngleBracket": "\u27E8",
        "leftarrow": "\u2190",
        "Leftarrow": "\u21D0",
        "LeftArrow": "\u2190",
        "LeftArrowBar": "\u21E4",
        "LeftArrowRightArrow": "\u21C6",
        "leftarrowtail": "\u21A2",
        "LeftCeiling": "\u2308",
        "LeftDoubleBracket": "\u27E6",
        "LeftDownTeeVector": "\u2961",
        "LeftDownVector": "\u21C3",
        "LeftDownVectorBar": "\u2959",
        "LeftFloor": "\u230A",
        "leftharpoondown": "\u21BD",
        "leftharpoonup": "\u21BC",
        "leftleftarrows": "\u21C7",
        "leftrightarrow": "\u2194",
        "Leftrightarrow": "\u21D4",
        "LeftRightArrow": "\u2194",
        "leftrightarrows": "\u21C6",
        "leftrightharpoons": "\u21CB",
        "leftrightsquigarrow": "\u21AD",
        "LeftRightVector": "\u294E",
        "LeftTee": "\u22A3",
        "LeftTeeArrow": "\u21A4",
        "LeftTeeVector": "\u295A",
        "leftthreetimes": "\u22CB",
        "LeftTriangle": "\u22B2",
        "LeftTriangleBar": "\u29CF",
        "LeftTriangleEqual": "\u22B4",
        "LeftUpDownVector": "\u2951",
        "LeftUpTeeVector": "\u2960",
        "LeftUpVector": "\u21BF",
        "LeftUpVectorBar": "\u2958",
        "LeftVector": "\u21BC",
        "LeftVectorBar": "\u2952",
        "leg": "\u22DA",
        "lEg": "\u2A8B",
        "leq": "\u2264",
        "leqq": "\u2266",
        "leqslant": "\u2A7D",
        "les": "\u2A7D",
        "lescc": "\u2AA8",
        "lesdot": "\u2A7F",
        "lesdoto": "\u2A81",
        "lesdotor": "\u2A83",
        "lesg": "\u22DA\uFE00",
        "lesges": "\u2A93",
        "lessapprox": "\u2A85",
        "lessdot": "\u22D6",
        "lesseqgtr": "\u22DA",
        "lesseqqgtr": "\u2A8B",
        "LessEqualGreater": "\u22DA",
        "LessFullEqual": "\u2266",
        "LessGreater": "\u2276",
        "lessgtr": "\u2276",
        "LessLess": "\u2AA1",
        "lesssim": "\u2272",
        "LessSlantEqual": "\u2A7D",
        "LessTilde": "\u2272",
        "lfisht": "\u297C",
        "lfloor": "\u230A",
        "lfr": "\uD835\uDD29",
        "Lfr": "\uD835\uDD0F",
        "lg": "\u2276",
        "lgE": "\u2A91",
        "lHar": "\u2962",
        "lhard": "\u21BD",
        "lharu": "\u21BC",
        "lharul": "\u296A",
        "lhblk": "\u2584",
        "ljcy": "\u0459",
        "LJcy": "\u0409",
        "ll": "\u226A",
        "Ll": "\u22D8",
        "llarr": "\u21C7",
        "llcorner": "\u231E",
        "Lleftarrow": "\u21DA",
        "llhard": "\u296B",
        "lltri": "\u25FA",
        "lmidot": "\u0140",
        "Lmidot": "\u013F",
        "lmoust": "\u23B0",
        "lmoustache": "\u23B0",
        "lnap": "\u2A89",
        "lnapprox": "\u2A89",
        "lne": "\u2A87",
        "lnE": "\u2268",
        "lneq": "\u2A87",
        "lneqq": "\u2268",
        "lnsim": "\u22E6",
        "loang": "\u27EC",
        "loarr": "\u21FD",
        "lobrk": "\u27E6",
        "longleftarrow": "\u27F5",
        "Longleftarrow": "\u27F8",
        "LongLeftArrow": "\u27F5",
        "longleftrightarrow": "\u27F7",
        "Longleftrightarrow": "\u27FA",
        "LongLeftRightArrow": "\u27F7",
        "longmapsto": "\u27FC",
        "longrightarrow": "\u27F6",
        "Longrightarrow": "\u27F9",
        "LongRightArrow": "\u27F6",
        "looparrowleft": "\u21AB",
        "looparrowright": "\u21AC",
        "lopar": "\u2985",
        "lopf": "\uD835\uDD5D",
        "Lopf": "\uD835\uDD43",
        "loplus": "\u2A2D",
        "lotimes": "\u2A34",
        "lowast": "\u2217",
        "lowbar": "_",
        "LowerLeftArrow": "\u2199",
        "LowerRightArrow": "\u2198",
        "loz": "\u25CA",
        "lozenge": "\u25CA",
        "lozf": "\u29EB",
        "lpar": "(",
        "lparlt": "\u2993",
        "lrarr": "\u21C6",
        "lrcorner": "\u231F",
        "lrhar": "\u21CB",
        "lrhard": "\u296D",
        "lrm": "\u200E",
        "lrtri": "\u22BF",
        "lsaquo": "\u2039",
        "lscr": "\uD835\uDCC1",
        "Lscr": "\u2112",
        "lsh": "\u21B0",
        "Lsh": "\u21B0",
        "lsim": "\u2272",
        "lsime": "\u2A8D",
        "lsimg": "\u2A8F",
        "lsqb": "[",
        "lsquo": "\u2018",
        "lsquor": "\u201A",
        "lstrok": "\u0142",
        "Lstrok": "\u0141",
        "lt": "<",
        "Lt": "\u226A",
        "LT": "<",
        "ltcc": "\u2AA6",
        "ltcir": "\u2A79",
        "ltdot": "\u22D6",
        "lthree": "\u22CB",
        "ltimes": "\u22C9",
        "ltlarr": "\u2976",
        "ltquest": "\u2A7B",
        "ltri": "\u25C3",
        "ltrie": "\u22B4",
        "ltrif": "\u25C2",
        "ltrPar": "\u2996",
        "lurdshar": "\u294A",
        "luruhar": "\u2966",
        "lvertneqq": "\u2268\uFE00",
        "lvnE": "\u2268\uFE00",
        "macr": "\xaf",
        "male": "\u2642",
        "malt": "\u2720",
        "maltese": "\u2720",
        "map": "\u21A6",
        "Map": "\u2905",
        "mapsto": "\u21A6",
        "mapstodown": "\u21A7",
        "mapstoleft": "\u21A4",
        "mapstoup": "\u21A5",
        "marker": "\u25AE",
        "mcomma": "\u2A29",
        "mcy": "\u043C",
        "Mcy": "\u041C",
        "mdash": "\u2014",
        "mDDot": "\u223A",
        "measuredangle": "\u2221",
        "MediumSpace": "\u205F",
        "Mellintrf": "\u2133",
        "mfr": "\uD835\uDD2A",
        "Mfr": "\uD835\uDD10",
        "mho": "\u2127",
        "micro": "\xb5",
        "mid": "\u2223",
        "midast": "*",
        "midcir": "\u2AF0",
        "middot": "\xb7",
        "minus": "\u2212",
        "minusb": "\u229F",
        "minusd": "\u2238",
        "minusdu": "\u2A2A",
        "MinusPlus": "\u2213",
        "mlcp": "\u2ADB",
        "mldr": "\u2026",
        "mnplus": "\u2213",
        "models": "\u22A7",
        "mopf": "\uD835\uDD5E",
        "Mopf": "\uD835\uDD44",
        "mp": "\u2213",
        "mscr": "\uD835\uDCC2",
        "Mscr": "\u2133",
        "mstpos": "\u223E",
        "mu": "\u03BC",
        "Mu": "\u039C",
        "multimap": "\u22B8",
        "mumap": "\u22B8",
        "nabla": "\u2207",
        "nacute": "\u0144",
        "Nacute": "\u0143",
        "nang": "\u2220\u20D2",
        "nap": "\u2249",
        "napE": "\u2A70\u0338",
        "napid": "\u224B\u0338",
        "napos": "\u0149",
        "napprox": "\u2249",
        "natur": "\u266E",
        "natural": "\u266E",
        "naturals": "\u2115",
        "nbsp": "\xa0",
        "nbump": "\u224E\u0338",
        "nbumpe": "\u224F\u0338",
        "ncap": "\u2A43",
        "ncaron": "\u0148",
        "Ncaron": "\u0147",
        "ncedil": "\u0146",
        "Ncedil": "\u0145",
        "ncong": "\u2247",
        "ncongdot": "\u2A6D\u0338",
        "ncup": "\u2A42",
        "ncy": "\u043D",
        "Ncy": "\u041D",
        "ndash": "\u2013",
        "ne": "\u2260",
        "nearhk": "\u2924",
        "nearr": "\u2197",
        "neArr": "\u21D7",
        "nearrow": "\u2197",
        "nedot": "\u2250\u0338",
        "NegativeMediumSpace": "\u200B",
        "NegativeThickSpace": "\u200B",
        "NegativeThinSpace": "\u200B",
        "NegativeVeryThinSpace": "\u200B",
        "nequiv": "\u2262",
        "nesear": "\u2928",
        "nesim": "\u2242\u0338",
        "NestedGreaterGreater": "\u226B",
        "NestedLessLess": "\u226A",
        "NewLine": "\n",
        "nexist": "\u2204",
        "nexists": "\u2204",
        "nfr": "\uD835\uDD2B",
        "Nfr": "\uD835\uDD11",
        "nge": "\u2271",
        "ngE": "\u2267\u0338",
        "ngeq": "\u2271",
        "ngeqq": "\u2267\u0338",
        "ngeqslant": "\u2A7E\u0338",
        "nges": "\u2A7E\u0338",
        "nGg": "\u22D9\u0338",
        "ngsim": "\u2275",
        "ngt": "\u226F",
        "nGt": "\u226B\u20D2",
        "ngtr": "\u226F",
        "nGtv": "\u226B\u0338",
        "nharr": "\u21AE",
        "nhArr": "\u21CE",
        "nhpar": "\u2AF2",
        "ni": "\u220B",
        "nis": "\u22FC",
        "nisd": "\u22FA",
        "niv": "\u220B",
        "njcy": "\u045A",
        "NJcy": "\u040A",
        "nlarr": "\u219A",
        "nlArr": "\u21CD",
        "nldr": "\u2025",
        "nle": "\u2270",
        "nlE": "\u2266\u0338",
        "nleftarrow": "\u219A",
        "nLeftarrow": "\u21CD",
        "nleftrightarrow": "\u21AE",
        "nLeftrightarrow": "\u21CE",
        "nleq": "\u2270",
        "nleqq": "\u2266\u0338",
        "nleqslant": "\u2A7D\u0338",
        "nles": "\u2A7D\u0338",
        "nless": "\u226E",
        "nLl": "\u22D8\u0338",
        "nlsim": "\u2274",
        "nlt": "\u226E",
        "nLt": "\u226A\u20D2",
        "nltri": "\u22EA",
        "nltrie": "\u22EC",
        "nLtv": "\u226A\u0338",
        "nmid": "\u2224",
        "NoBreak": "\u2060",
        "NonBreakingSpace": "\xa0",
        "nopf": "\uD835\uDD5F",
        "Nopf": "\u2115",
        "not": "\xac",
        "Not": "\u2AEC",
        "NotCongruent": "\u2262",
        "NotCupCap": "\u226D",
        "NotDoubleVerticalBar": "\u2226",
        "NotElement": "\u2209",
        "NotEqual": "\u2260",
        "NotEqualTilde": "\u2242\u0338",
        "NotExists": "\u2204",
        "NotGreater": "\u226F",
        "NotGreaterEqual": "\u2271",
        "NotGreaterFullEqual": "\u2267\u0338",
        "NotGreaterGreater": "\u226B\u0338",
        "NotGreaterLess": "\u2279",
        "NotGreaterSlantEqual": "\u2A7E\u0338",
        "NotGreaterTilde": "\u2275",
        "NotHumpDownHump": "\u224E\u0338",
        "NotHumpEqual": "\u224F\u0338",
        "notin": "\u2209",
        "notindot": "\u22F5\u0338",
        "notinE": "\u22F9\u0338",
        "notinva": "\u2209",
        "notinvb": "\u22F7",
        "notinvc": "\u22F6",
        "NotLeftTriangle": "\u22EA",
        "NotLeftTriangleBar": "\u29CF\u0338",
        "NotLeftTriangleEqual": "\u22EC",
        "NotLess": "\u226E",
        "NotLessEqual": "\u2270",
        "NotLessGreater": "\u2278",
        "NotLessLess": "\u226A\u0338",
        "NotLessSlantEqual": "\u2A7D\u0338",
        "NotLessTilde": "\u2274",
        "NotNestedGreaterGreater": "\u2AA2\u0338",
        "NotNestedLessLess": "\u2AA1\u0338",
        "notni": "\u220C",
        "notniva": "\u220C",
        "notnivb": "\u22FE",
        "notnivc": "\u22FD",
        "NotPrecedes": "\u2280",
        "NotPrecedesEqual": "\u2AAF\u0338",
        "NotPrecedesSlantEqual": "\u22E0",
        "NotReverseElement": "\u220C",
        "NotRightTriangle": "\u22EB",
        "NotRightTriangleBar": "\u29D0\u0338",
        "NotRightTriangleEqual": "\u22ED",
        "NotSquareSubset": "\u228F\u0338",
        "NotSquareSubsetEqual": "\u22E2",
        "NotSquareSuperset": "\u2290\u0338",
        "NotSquareSupersetEqual": "\u22E3",
        "NotSubset": "\u2282\u20D2",
        "NotSubsetEqual": "\u2288",
        "NotSucceeds": "\u2281",
        "NotSucceedsEqual": "\u2AB0\u0338",
        "NotSucceedsSlantEqual": "\u22E1",
        "NotSucceedsTilde": "\u227F\u0338",
        "NotSuperset": "\u2283\u20D2",
        "NotSupersetEqual": "\u2289",
        "NotTilde": "\u2241",
        "NotTildeEqual": "\u2244",
        "NotTildeFullEqual": "\u2247",
        "NotTildeTilde": "\u2249",
        "NotVerticalBar": "\u2224",
        "npar": "\u2226",
        "nparallel": "\u2226",
        "nparsl": "\u2AFD\u20E5",
        "npart": "\u2202\u0338",
        "npolint": "\u2A14",
        "npr": "\u2280",
        "nprcue": "\u22E0",
        "npre": "\u2AAF\u0338",
        "nprec": "\u2280",
        "npreceq": "\u2AAF\u0338",
        "nrarr": "\u219B",
        "nrArr": "\u21CF",
        "nrarrc": "\u2933\u0338",
        "nrarrw": "\u219D\u0338",
        "nrightarrow": "\u219B",
        "nRightarrow": "\u21CF",
        "nrtri": "\u22EB",
        "nrtrie": "\u22ED",
        "nsc": "\u2281",
        "nsccue": "\u22E1",
        "nsce": "\u2AB0\u0338",
        "nscr": "\uD835\uDCC3",
        "Nscr": "\uD835\uDCA9",
        "nshortmid": "\u2224",
        "nshortparallel": "\u2226",
        "nsim": "\u2241",
        "nsime": "\u2244",
        "nsimeq": "\u2244",
        "nsmid": "\u2224",
        "nspar": "\u2226",
        "nsqsube": "\u22E2",
        "nsqsupe": "\u22E3",
        "nsub": "\u2284",
        "nsube": "\u2288",
        "nsubE": "\u2AC5\u0338",
        "nsubset": "\u2282\u20D2",
        "nsubseteq": "\u2288",
        "nsubseteqq": "\u2AC5\u0338",
        "nsucc": "\u2281",
        "nsucceq": "\u2AB0\u0338",
        "nsup": "\u2285",
        "nsupe": "\u2289",
        "nsupE": "\u2AC6\u0338",
        "nsupset": "\u2283\u20D2",
        "nsupseteq": "\u2289",
        "nsupseteqq": "\u2AC6\u0338",
        "ntgl": "\u2279",
        "ntilde": "\xf1",
        "Ntilde": "\xd1",
        "ntlg": "\u2278",
        "ntriangleleft": "\u22EA",
        "ntrianglelefteq": "\u22EC",
        "ntriangleright": "\u22EB",
        "ntrianglerighteq": "\u22ED",
        "nu": "\u03BD",
        "Nu": "\u039D",
        "num": "#",
        "numero": "\u2116",
        "numsp": "\u2007",
        "nvap": "\u224D\u20D2",
        "nvdash": "\u22AC",
        "nvDash": "\u22AD",
        "nVdash": "\u22AE",
        "nVDash": "\u22AF",
        "nvge": "\u2265\u20D2",
        "nvgt": ">\u20D2",
        "nvHarr": "\u2904",
        "nvinfin": "\u29DE",
        "nvlArr": "\u2902",
        "nvle": "\u2264\u20D2",
        "nvlt": "<\u20D2",
        "nvltrie": "\u22B4\u20D2",
        "nvrArr": "\u2903",
        "nvrtrie": "\u22B5\u20D2",
        "nvsim": "\u223C\u20D2",
        "nwarhk": "\u2923",
        "nwarr": "\u2196",
        "nwArr": "\u21D6",
        "nwarrow": "\u2196",
        "nwnear": "\u2927",
        "oacute": "\xf3",
        "Oacute": "\xd3",
        "oast": "\u229B",
        "ocir": "\u229A",
        "ocirc": "\xf4",
        "Ocirc": "\xd4",
        "ocy": "\u043E",
        "Ocy": "\u041E",
        "odash": "\u229D",
        "odblac": "\u0151",
        "Odblac": "\u0150",
        "odiv": "\u2A38",
        "odot": "\u2299",
        "odsold": "\u29BC",
        "oelig": "\u0153",
        "OElig": "\u0152",
        "ofcir": "\u29BF",
        "ofr": "\uD835\uDD2C",
        "Ofr": "\uD835\uDD12",
        "ogon": "\u02DB",
        "ograve": "\xf2",
        "Ograve": "\xd2",
        "ogt": "\u29C1",
        "ohbar": "\u29B5",
        "ohm": "\u03A9",
        "oint": "\u222E",
        "olarr": "\u21BA",
        "olcir": "\u29BE",
        "olcross": "\u29BB",
        "oline": "\u203E",
        "olt": "\u29C0",
        "omacr": "\u014D",
        "Omacr": "\u014C",
        "omega": "\u03C9",
        "Omega": "\u03A9",
        "omicron": "\u03BF",
        "Omicron": "\u039F",
        "omid": "\u29B6",
        "ominus": "\u2296",
        "oopf": "\uD835\uDD60",
        "Oopf": "\uD835\uDD46",
        "opar": "\u29B7",
        "OpenCurlyDoubleQuote": "\u201C",
        "OpenCurlyQuote": "\u2018",
        "operp": "\u29B9",
        "oplus": "\u2295",
        "or": "\u2228",
        "Or": "\u2A54",
        "orarr": "\u21BB",
        "ord": "\u2A5D",
        "order": "\u2134",
        "orderof": "\u2134",
        "ordf": "\xaa",
        "ordm": "\xba",
        "origof": "\u22B6",
        "oror": "\u2A56",
        "orslope": "\u2A57",
        "orv": "\u2A5B",
        "oS": "\u24C8",
        "oscr": "\u2134",
        "Oscr": "\uD835\uDCAA",
        "oslash": "\xf8",
        "Oslash": "\xd8",
        "osol": "\u2298",
        "otilde": "\xf5",
        "Otilde": "\xd5",
        "otimes": "\u2297",
        "Otimes": "\u2A37",
        "otimesas": "\u2A36",
        "ouml": "\xf6",
        "Ouml": "\xd6",
        "ovbar": "\u233D",
        "OverBar": "\u203E",
        "OverBrace": "\u23DE",
        "OverBracket": "\u23B4",
        "OverParenthesis": "\u23DC",
        "par": "\u2225",
        "para": "\xb6",
        "parallel": "\u2225",
        "parsim": "\u2AF3",
        "parsl": "\u2AFD",
        "part": "\u2202",
        "PartialD": "\u2202",
        "pcy": "\u043F",
        "Pcy": "\u041F",
        "percnt": "%",
        "period": ".",
        "permil": "\u2030",
        "perp": "\u22A5",
        "pertenk": "\u2031",
        "pfr": "\uD835\uDD2D",
        "Pfr": "\uD835\uDD13",
        "phi": "\u03C6",
        "Phi": "\u03A6",
        "phiv": "\u03D5",
        "phmmat": "\u2133",
        "phone": "\u260E",
        "pi": "\u03C0",
        "Pi": "\u03A0",
        "pitchfork": "\u22D4",
        "piv": "\u03D6",
        "planck": "\u210F",
        "planckh": "\u210E",
        "plankv": "\u210F",
        "plus": "+",
        "plusacir": "\u2A23",
        "plusb": "\u229E",
        "pluscir": "\u2A22",
        "plusdo": "\u2214",
        "plusdu": "\u2A25",
        "pluse": "\u2A72",
        "PlusMinus": "\xb1",
        "plusmn": "\xb1",
        "plussim": "\u2A26",
        "plustwo": "\u2A27",
        "pm": "\xb1",
        "Poincareplane": "\u210C",
        "pointint": "\u2A15",
        "popf": "\uD835\uDD61",
        "Popf": "\u2119",
        "pound": "\xa3",
        "pr": "\u227A",
        "Pr": "\u2ABB",
        "prap": "\u2AB7",
        "prcue": "\u227C",
        "pre": "\u2AAF",
        "prE": "\u2AB3",
        "prec": "\u227A",
        "precapprox": "\u2AB7",
        "preccurlyeq": "\u227C",
        "Precedes": "\u227A",
        "PrecedesEqual": "\u2AAF",
        "PrecedesSlantEqual": "\u227C",
        "PrecedesTilde": "\u227E",
        "preceq": "\u2AAF",
        "precnapprox": "\u2AB9",
        "precneqq": "\u2AB5",
        "precnsim": "\u22E8",
        "precsim": "\u227E",
        "prime": "\u2032",
        "Prime": "\u2033",
        "primes": "\u2119",
        "prnap": "\u2AB9",
        "prnE": "\u2AB5",
        "prnsim": "\u22E8",
        "prod": "\u220F",
        "Product": "\u220F",
        "profalar": "\u232E",
        "profline": "\u2312",
        "profsurf": "\u2313",
        "prop": "\u221D",
        "Proportion": "\u2237",
        "Proportional": "\u221D",
        "propto": "\u221D",
        "prsim": "\u227E",
        "prurel": "\u22B0",
        "pscr": "\uD835\uDCC5",
        "Pscr": "\uD835\uDCAB",
        "psi": "\u03C8",
        "Psi": "\u03A8",
        "puncsp": "\u2008",
        "qfr": "\uD835\uDD2E",
        "Qfr": "\uD835\uDD14",
        "qint": "\u2A0C",
        "qopf": "\uD835\uDD62",
        "Qopf": "\u211A",
        "qprime": "\u2057",
        "qscr": "\uD835\uDCC6",
        "Qscr": "\uD835\uDCAC",
        "quaternions": "\u210D",
        "quatint": "\u2A16",
        "quest": "?",
        "questeq": "\u225F",
        "quot": '"',
        "QUOT": '"',
        "rAarr": "\u21DB",
        "race": "\u223D\u0331",
        "racute": "\u0155",
        "Racute": "\u0154",
        "radic": "\u221A",
        "raemptyv": "\u29B3",
        "rang": "\u27E9",
        "Rang": "\u27EB",
        "rangd": "\u2992",
        "range": "\u29A5",
        "rangle": "\u27E9",
        "raquo": "\xbb",
        "rarr": "\u2192",
        "rArr": "\u21D2",
        "Rarr": "\u21A0",
        "rarrap": "\u2975",
        "rarrb": "\u21E5",
        "rarrbfs": "\u2920",
        "rarrc": "\u2933",
        "rarrfs": "\u291E",
        "rarrhk": "\u21AA",
        "rarrlp": "\u21AC",
        "rarrpl": "\u2945",
        "rarrsim": "\u2974",
        "rarrtl": "\u21A3",
        "Rarrtl": "\u2916",
        "rarrw": "\u219D",
        "ratail": "\u291A",
        "rAtail": "\u291C",
        "ratio": "\u2236",
        "rationals": "\u211A",
        "rbarr": "\u290D",
        "rBarr": "\u290F",
        "RBarr": "\u2910",
        "rbbrk": "\u2773",
        "rbrace": "}",
        "rbrack": "]",
        "rbrke": "\u298C",
        "rbrksld": "\u298E",
        "rbrkslu": "\u2990",
        "rcaron": "\u0159",
        "Rcaron": "\u0158",
        "rcedil": "\u0157",
        "Rcedil": "\u0156",
        "rceil": "\u2309",
        "rcub": "}",
        "rcy": "\u0440",
        "Rcy": "\u0420",
        "rdca": "\u2937",
        "rdldhar": "\u2969",
        "rdquo": "\u201D",
        "rdquor": "\u201D",
        "rdsh": "\u21B3",
        "Re": "\u211C",
        "real": "\u211C",
        "realine": "\u211B",
        "realpart": "\u211C",
        "reals": "\u211D",
        "rect": "\u25AD",
        "reg": "\xae",
        "REG": "\xae",
        "ReverseElement": "\u220B",
        "ReverseEquilibrium": "\u21CB",
        "ReverseUpEquilibrium": "\u296F",
        "rfisht": "\u297D",
        "rfloor": "\u230B",
        "rfr": "\uD835\uDD2F",
        "Rfr": "\u211C",
        "rHar": "\u2964",
        "rhard": "\u21C1",
        "rharu": "\u21C0",
        "rharul": "\u296C",
        "rho": "\u03C1",
        "Rho": "\u03A1",
        "rhov": "\u03F1",
        "RightAngleBracket": "\u27E9",
        "rightarrow": "\u2192",
        "Rightarrow": "\u21D2",
        "RightArrow": "\u2192",
        "RightArrowBar": "\u21E5",
        "RightArrowLeftArrow": "\u21C4",
        "rightarrowtail": "\u21A3",
        "RightCeiling": "\u2309",
        "RightDoubleBracket": "\u27E7",
        "RightDownTeeVector": "\u295D",
        "RightDownVector": "\u21C2",
        "RightDownVectorBar": "\u2955",
        "RightFloor": "\u230B",
        "rightharpoondown": "\u21C1",
        "rightharpoonup": "\u21C0",
        "rightleftarrows": "\u21C4",
        "rightleftharpoons": "\u21CC",
        "rightrightarrows": "\u21C9",
        "rightsquigarrow": "\u219D",
        "RightTee": "\u22A2",
        "RightTeeArrow": "\u21A6",
        "RightTeeVector": "\u295B",
        "rightthreetimes": "\u22CC",
        "RightTriangle": "\u22B3",
        "RightTriangleBar": "\u29D0",
        "RightTriangleEqual": "\u22B5",
        "RightUpDownVector": "\u294F",
        "RightUpTeeVector": "\u295C",
        "RightUpVector": "\u21BE",
        "RightUpVectorBar": "\u2954",
        "RightVector": "\u21C0",
        "RightVectorBar": "\u2953",
        "ring": "\u02DA",
        "risingdotseq": "\u2253",
        "rlarr": "\u21C4",
        "rlhar": "\u21CC",
        "rlm": "\u200F",
        "rmoust": "\u23B1",
        "rmoustache": "\u23B1",
        "rnmid": "\u2AEE",
        "roang": "\u27ED",
        "roarr": "\u21FE",
        "robrk": "\u27E7",
        "ropar": "\u2986",
        "ropf": "\uD835\uDD63",
        "Ropf": "\u211D",
        "roplus": "\u2A2E",
        "rotimes": "\u2A35",
        "RoundImplies": "\u2970",
        "rpar": ")",
        "rpargt": "\u2994",
        "rppolint": "\u2A12",
        "rrarr": "\u21C9",
        "Rrightarrow": "\u21DB",
        "rsaquo": "\u203A",
        "rscr": "\uD835\uDCC7",
        "Rscr": "\u211B",
        "rsh": "\u21B1",
        "Rsh": "\u21B1",
        "rsqb": "]",
        "rsquo": "\u2019",
        "rsquor": "\u2019",
        "rthree": "\u22CC",
        "rtimes": "\u22CA",
        "rtri": "\u25B9",
        "rtrie": "\u22B5",
        "rtrif": "\u25B8",
        "rtriltri": "\u29CE",
        "RuleDelayed": "\u29F4",
        "ruluhar": "\u2968",
        "rx": "\u211E",
        "sacute": "\u015B",
        "Sacute": "\u015A",
        "sbquo": "\u201A",
        "sc": "\u227B",
        "Sc": "\u2ABC",
        "scap": "\u2AB8",
        "scaron": "\u0161",
        "Scaron": "\u0160",
        "sccue": "\u227D",
        "sce": "\u2AB0",
        "scE": "\u2AB4",
        "scedil": "\u015F",
        "Scedil": "\u015E",
        "scirc": "\u015D",
        "Scirc": "\u015C",
        "scnap": "\u2ABA",
        "scnE": "\u2AB6",
        "scnsim": "\u22E9",
        "scpolint": "\u2A13",
        "scsim": "\u227F",
        "scy": "\u0441",
        "Scy": "\u0421",
        "sdot": "\u22C5",
        "sdotb": "\u22A1",
        "sdote": "\u2A66",
        "searhk": "\u2925",
        "searr": "\u2198",
        "seArr": "\u21D8",
        "searrow": "\u2198",
        "sect": "\xa7",
        "semi": ";",
        "seswar": "\u2929",
        "setminus": "\u2216",
        "setmn": "\u2216",
        "sext": "\u2736",
        "sfr": "\uD835\uDD30",
        "Sfr": "\uD835\uDD16",
        "sfrown": "\u2322",
        "sharp": "\u266F",
        "shchcy": "\u0449",
        "SHCHcy": "\u0429",
        "shcy": "\u0448",
        "SHcy": "\u0428",
        "ShortDownArrow": "\u2193",
        "ShortLeftArrow": "\u2190",
        "shortmid": "\u2223",
        "shortparallel": "\u2225",
        "ShortRightArrow": "\u2192",
        "ShortUpArrow": "\u2191",
        "shy": "\xad",
        "sigma": "\u03C3",
        "Sigma": "\u03A3",
        "sigmaf": "\u03C2",
        "sigmav": "\u03C2",
        "sim": "\u223C",
        "simdot": "\u2A6A",
        "sime": "\u2243",
        "simeq": "\u2243",
        "simg": "\u2A9E",
        "simgE": "\u2AA0",
        "siml": "\u2A9D",
        "simlE": "\u2A9F",
        "simne": "\u2246",
        "simplus": "\u2A24",
        "simrarr": "\u2972",
        "slarr": "\u2190",
        "SmallCircle": "\u2218",
        "smallsetminus": "\u2216",
        "smashp": "\u2A33",
        "smeparsl": "\u29E4",
        "smid": "\u2223",
        "smile": "\u2323",
        "smt": "\u2AAA",
        "smte": "\u2AAC",
        "smtes": "\u2AAC\uFE00",
        "softcy": "\u044C",
        "SOFTcy": "\u042C",
        "sol": "/",
        "solb": "\u29C4",
        "solbar": "\u233F",
        "sopf": "\uD835\uDD64",
        "Sopf": "\uD835\uDD4A",
        "spades": "\u2660",
        "spadesuit": "\u2660",
        "spar": "\u2225",
        "sqcap": "\u2293",
        "sqcaps": "\u2293\uFE00",
        "sqcup": "\u2294",
        "sqcups": "\u2294\uFE00",
        "Sqrt": "\u221A",
        "sqsub": "\u228F",
        "sqsube": "\u2291",
        "sqsubset": "\u228F",
        "sqsubseteq": "\u2291",
        "sqsup": "\u2290",
        "sqsupe": "\u2292",
        "sqsupset": "\u2290",
        "sqsupseteq": "\u2292",
        "squ": "\u25A1",
        "square": "\u25A1",
        "Square": "\u25A1",
        "SquareIntersection": "\u2293",
        "SquareSubset": "\u228F",
        "SquareSubsetEqual": "\u2291",
        "SquareSuperset": "\u2290",
        "SquareSupersetEqual": "\u2292",
        "SquareUnion": "\u2294",
        "squarf": "\u25AA",
        "squf": "\u25AA",
        "srarr": "\u2192",
        "sscr": "\uD835\uDCC8",
        "Sscr": "\uD835\uDCAE",
        "ssetmn": "\u2216",
        "ssmile": "\u2323",
        "sstarf": "\u22C6",
        "star": "\u2606",
        "Star": "\u22C6",
        "starf": "\u2605",
        "straightepsilon": "\u03F5",
        "straightphi": "\u03D5",
        "strns": "\xaf",
        "sub": "\u2282",
        "Sub": "\u22D0",
        "subdot": "\u2ABD",
        "sube": "\u2286",
        "subE": "\u2AC5",
        "subedot": "\u2AC3",
        "submult": "\u2AC1",
        "subne": "\u228A",
        "subnE": "\u2ACB",
        "subplus": "\u2ABF",
        "subrarr": "\u2979",
        "subset": "\u2282",
        "Subset": "\u22D0",
        "subseteq": "\u2286",
        "subseteqq": "\u2AC5",
        "SubsetEqual": "\u2286",
        "subsetneq": "\u228A",
        "subsetneqq": "\u2ACB",
        "subsim": "\u2AC7",
        "subsub": "\u2AD5",
        "subsup": "\u2AD3",
        "succ": "\u227B",
        "succapprox": "\u2AB8",
        "succcurlyeq": "\u227D",
        "Succeeds": "\u227B",
        "SucceedsEqual": "\u2AB0",
        "SucceedsSlantEqual": "\u227D",
        "SucceedsTilde": "\u227F",
        "succeq": "\u2AB0",
        "succnapprox": "\u2ABA",
        "succneqq": "\u2AB6",
        "succnsim": "\u22E9",
        "succsim": "\u227F",
        "SuchThat": "\u220B",
        "sum": "\u2211",
        "Sum": "\u2211",
        "sung": "\u266A",
        "sup": "\u2283",
        "Sup": "\u22D1",
        "sup1": "\xb9",
        "sup2": "\xb2",
        "sup3": "\xb3",
        "supdot": "\u2ABE",
        "supdsub": "\u2AD8",
        "supe": "\u2287",
        "supE": "\u2AC6",
        "supedot": "\u2AC4",
        "Superset": "\u2283",
        "SupersetEqual": "\u2287",
        "suphsol": "\u27C9",
        "suphsub": "\u2AD7",
        "suplarr": "\u297B",
        "supmult": "\u2AC2",
        "supne": "\u228B",
        "supnE": "\u2ACC",
        "supplus": "\u2AC0",
        "supset": "\u2283",
        "Supset": "\u22D1",
        "supseteq": "\u2287",
        "supseteqq": "\u2AC6",
        "supsetneq": "\u228B",
        "supsetneqq": "\u2ACC",
        "supsim": "\u2AC8",
        "supsub": "\u2AD4",
        "supsup": "\u2AD6",
        "swarhk": "\u2926",
        "swarr": "\u2199",
        "swArr": "\u21D9",
        "swarrow": "\u2199",
        "swnwar": "\u292A",
        "szlig": "\xdf",
        "Tab": "	",
        "target": "\u2316",
        "tau": "\u03C4",
        "Tau": "\u03A4",
        "tbrk": "\u23B4",
        "tcaron": "\u0165",
        "Tcaron": "\u0164",
        "tcedil": "\u0163",
        "Tcedil": "\u0162",
        "tcy": "\u0442",
        "Tcy": "\u0422",
        "tdot": "\u20DB",
        "telrec": "\u2315",
        "tfr": "\uD835\uDD31",
        "Tfr": "\uD835\uDD17",
        "there4": "\u2234",
        "therefore": "\u2234",
        "Therefore": "\u2234",
        "theta": "\u03B8",
        "Theta": "\u0398",
        "thetasym": "\u03D1",
        "thetav": "\u03D1",
        "thickapprox": "\u2248",
        "thicksim": "\u223C",
        "ThickSpace": "\u205F\u200A",
        "thinsp": "\u2009",
        "ThinSpace": "\u2009",
        "thkap": "\u2248",
        "thksim": "\u223C",
        "thorn": "\xfe",
        "THORN": "\xde",
        "tilde": "\u02DC",
        "Tilde": "\u223C",
        "TildeEqual": "\u2243",
        "TildeFullEqual": "\u2245",
        "TildeTilde": "\u2248",
        "times": "\xd7",
        "timesb": "\u22A0",
        "timesbar": "\u2A31",
        "timesd": "\u2A30",
        "tint": "\u222D",
        "toea": "\u2928",
        "top": "\u22A4",
        "topbot": "\u2336",
        "topcir": "\u2AF1",
        "topf": "\uD835\uDD65",
        "Topf": "\uD835\uDD4B",
        "topfork": "\u2ADA",
        "tosa": "\u2929",
        "tprime": "\u2034",
        "trade": "\u2122",
        "TRADE": "\u2122",
        "triangle": "\u25B5",
        "triangledown": "\u25BF",
        "triangleleft": "\u25C3",
        "trianglelefteq": "\u22B4",
        "triangleq": "\u225C",
        "triangleright": "\u25B9",
        "trianglerighteq": "\u22B5",
        "tridot": "\u25EC",
        "trie": "\u225C",
        "triminus": "\u2A3A",
        "TripleDot": "\u20DB",
        "triplus": "\u2A39",
        "trisb": "\u29CD",
        "tritime": "\u2A3B",
        "trpezium": "\u23E2",
        "tscr": "\uD835\uDCC9",
        "Tscr": "\uD835\uDCAF",
        "tscy": "\u0446",
        "TScy": "\u0426",
        "tshcy": "\u045B",
        "TSHcy": "\u040B",
        "tstrok": "\u0167",
        "Tstrok": "\u0166",
        "twixt": "\u226C",
        "twoheadleftarrow": "\u219E",
        "twoheadrightarrow": "\u21A0",
        "uacute": "\xfa",
        "Uacute": "\xda",
        "uarr": "\u2191",
        "uArr": "\u21D1",
        "Uarr": "\u219F",
        "Uarrocir": "\u2949",
        "ubrcy": "\u045E",
        "Ubrcy": "\u040E",
        "ubreve": "\u016D",
        "Ubreve": "\u016C",
        "ucirc": "\xfb",
        "Ucirc": "\xdb",
        "ucy": "\u0443",
        "Ucy": "\u0423",
        "udarr": "\u21C5",
        "udblac": "\u0171",
        "Udblac": "\u0170",
        "udhar": "\u296E",
        "ufisht": "\u297E",
        "ufr": "\uD835\uDD32",
        "Ufr": "\uD835\uDD18",
        "ugrave": "\xf9",
        "Ugrave": "\xd9",
        "uHar": "\u2963",
        "uharl": "\u21BF",
        "uharr": "\u21BE",
        "uhblk": "\u2580",
        "ulcorn": "\u231C",
        "ulcorner": "\u231C",
        "ulcrop": "\u230F",
        "ultri": "\u25F8",
        "umacr": "\u016B",
        "Umacr": "\u016A",
        "uml": "\xa8",
        "UnderBar": "_",
        "UnderBrace": "\u23DF",
        "UnderBracket": "\u23B5",
        "UnderParenthesis": "\u23DD",
        "Union": "\u22C3",
        "UnionPlus": "\u228E",
        "uogon": "\u0173",
        "Uogon": "\u0172",
        "uopf": "\uD835\uDD66",
        "Uopf": "\uD835\uDD4C",
        "uparrow": "\u2191",
        "Uparrow": "\u21D1",
        "UpArrow": "\u2191",
        "UpArrowBar": "\u2912",
        "UpArrowDownArrow": "\u21C5",
        "updownarrow": "\u2195",
        "Updownarrow": "\u21D5",
        "UpDownArrow": "\u2195",
        "UpEquilibrium": "\u296E",
        "upharpoonleft": "\u21BF",
        "upharpoonright": "\u21BE",
        "uplus": "\u228E",
        "UpperLeftArrow": "\u2196",
        "UpperRightArrow": "\u2197",
        "upsi": "\u03C5",
        "Upsi": "\u03D2",
        "upsih": "\u03D2",
        "upsilon": "\u03C5",
        "Upsilon": "\u03A5",
        "UpTee": "\u22A5",
        "UpTeeArrow": "\u21A5",
        "upuparrows": "\u21C8",
        "urcorn": "\u231D",
        "urcorner": "\u231D",
        "urcrop": "\u230E",
        "uring": "\u016F",
        "Uring": "\u016E",
        "urtri": "\u25F9",
        "uscr": "\uD835\uDCCA",
        "Uscr": "\uD835\uDCB0",
        "utdot": "\u22F0",
        "utilde": "\u0169",
        "Utilde": "\u0168",
        "utri": "\u25B5",
        "utrif": "\u25B4",
        "uuarr": "\u21C8",
        "uuml": "\xfc",
        "Uuml": "\xdc",
        "uwangle": "\u29A7",
        "vangrt": "\u299C",
        "varepsilon": "\u03F5",
        "varkappa": "\u03F0",
        "varnothing": "\u2205",
        "varphi": "\u03D5",
        "varpi": "\u03D6",
        "varpropto": "\u221D",
        "varr": "\u2195",
        "vArr": "\u21D5",
        "varrho": "\u03F1",
        "varsigma": "\u03C2",
        "varsubsetneq": "\u228A\uFE00",
        "varsubsetneqq": "\u2ACB\uFE00",
        "varsupsetneq": "\u228B\uFE00",
        "varsupsetneqq": "\u2ACC\uFE00",
        "vartheta": "\u03D1",
        "vartriangleleft": "\u22B2",
        "vartriangleright": "\u22B3",
        "vBar": "\u2AE8",
        "Vbar": "\u2AEB",
        "vBarv": "\u2AE9",
        "vcy": "\u0432",
        "Vcy": "\u0412",
        "vdash": "\u22A2",
        "vDash": "\u22A8",
        "Vdash": "\u22A9",
        "VDash": "\u22AB",
        "Vdashl": "\u2AE6",
        "vee": "\u2228",
        "Vee": "\u22C1",
        "veebar": "\u22BB",
        "veeeq": "\u225A",
        "vellip": "\u22EE",
        "verbar": "|",
        "Verbar": "\u2016",
        "vert": "|",
        "Vert": "\u2016",
        "VerticalBar": "\u2223",
        "VerticalLine": "|",
        "VerticalSeparator": "\u2758",
        "VerticalTilde": "\u2240",
        "VeryThinSpace": "\u200A",
        "vfr": "\uD835\uDD33",
        "Vfr": "\uD835\uDD19",
        "vltri": "\u22B2",
        "vnsub": "\u2282\u20D2",
        "vnsup": "\u2283\u20D2",
        "vopf": "\uD835\uDD67",
        "Vopf": "\uD835\uDD4D",
        "vprop": "\u221D",
        "vrtri": "\u22B3",
        "vscr": "\uD835\uDCCB",
        "Vscr": "\uD835\uDCB1",
        "vsubne": "\u228A\uFE00",
        "vsubnE": "\u2ACB\uFE00",
        "vsupne": "\u228B\uFE00",
        "vsupnE": "\u2ACC\uFE00",
        "Vvdash": "\u22AA",
        "vzigzag": "\u299A",
        "wcirc": "\u0175",
        "Wcirc": "\u0174",
        "wedbar": "\u2A5F",
        "wedge": "\u2227",
        "Wedge": "\u22C0",
        "wedgeq": "\u2259",
        "weierp": "\u2118",
        "wfr": "\uD835\uDD34",
        "Wfr": "\uD835\uDD1A",
        "wopf": "\uD835\uDD68",
        "Wopf": "\uD835\uDD4E",
        "wp": "\u2118",
        "wr": "\u2240",
        "wreath": "\u2240",
        "wscr": "\uD835\uDCCC",
        "Wscr": "\uD835\uDCB2",
        "xcap": "\u22C2",
        "xcirc": "\u25EF",
        "xcup": "\u22C3",
        "xdtri": "\u25BD",
        "xfr": "\uD835\uDD35",
        "Xfr": "\uD835\uDD1B",
        "xharr": "\u27F7",
        "xhArr": "\u27FA",
        "xi": "\u03BE",
        "Xi": "\u039E",
        "xlarr": "\u27F5",
        "xlArr": "\u27F8",
        "xmap": "\u27FC",
        "xnis": "\u22FB",
        "xodot": "\u2A00",
        "xopf": "\uD835\uDD69",
        "Xopf": "\uD835\uDD4F",
        "xoplus": "\u2A01",
        "xotime": "\u2A02",
        "xrarr": "\u27F6",
        "xrArr": "\u27F9",
        "xscr": "\uD835\uDCCD",
        "Xscr": "\uD835\uDCB3",
        "xsqcup": "\u2A06",
        "xuplus": "\u2A04",
        "xutri": "\u25B3",
        "xvee": "\u22C1",
        "xwedge": "\u22C0",
        "yacute": "\xfd",
        "Yacute": "\xdd",
        "yacy": "\u044F",
        "YAcy": "\u042F",
        "ycirc": "\u0177",
        "Ycirc": "\u0176",
        "ycy": "\u044B",
        "Ycy": "\u042B",
        "yen": "\xa5",
        "yfr": "\uD835\uDD36",
        "Yfr": "\uD835\uDD1C",
        "yicy": "\u0457",
        "YIcy": "\u0407",
        "yopf": "\uD835\uDD6A",
        "Yopf": "\uD835\uDD50",
        "yscr": "\uD835\uDCCE",
        "Yscr": "\uD835\uDCB4",
        "yucy": "\u044E",
        "YUcy": "\u042E",
        "yuml": "\xff",
        "Yuml": "\u0178",
        "zacute": "\u017A",
        "Zacute": "\u0179",
        "zcaron": "\u017E",
        "Zcaron": "\u017D",
        "zcy": "\u0437",
        "Zcy": "\u0417",
        "zdot": "\u017C",
        "Zdot": "\u017B",
        "zeetrf": "\u2128",
        "ZeroWidthSpace": "\u200B",
        "zeta": "\u03B6",
        "Zeta": "\u0396",
        "zfr": "\uD835\uDD37",
        "Zfr": "\u2128",
        "zhcy": "\u0436",
        "ZHcy": "\u0416",
        "zigrarr": "\u21DD",
        "zopf": "\uD835\uDD6B",
        "Zopf": "\u2124",
        "zscr": "\uD835\uDCCF",
        "Zscr": "\uD835\uDCB5",
        "zwj": "\u200D",
        "zwnj": "\u200C"
    };
    var decodeMapLegacy = {
        "aacute": "\xe1",
        "Aacute": "\xc1",
        "acirc": "\xe2",
        "Acirc": "\xc2",
        "acute": "\xb4",
        "aelig": "\xe6",
        "AElig": "\xc6",
        "agrave": "\xe0",
        "Agrave": "\xc0",
        "amp": "&",
        "AMP": "&",
        "aring": "\xe5",
        "Aring": "\xc5",
        "atilde": "\xe3",
        "Atilde": "\xc3",
        "auml": "\xe4",
        "Auml": "\xc4",
        "brvbar": "\xa6",
        "ccedil": "\xe7",
        "Ccedil": "\xc7",
        "cedil": "\xb8",
        "cent": "\xa2",
        "copy": "\xa9",
        "COPY": "\xa9",
        "curren": "\xa4",
        "deg": "\xb0",
        "divide": "\xf7",
        "eacute": "\xe9",
        "Eacute": "\xc9",
        "ecirc": "\xea",
        "Ecirc": "\xca",
        "egrave": "\xe8",
        "Egrave": "\xc8",
        "eth": "\xf0",
        "ETH": "\xd0",
        "euml": "\xeb",
        "Euml": "\xcb",
        "frac12": "\xbd",
        "frac14": "\xbc",
        "frac34": "\xbe",
        "gt": ">",
        "GT": ">",
        "iacute": "\xed",
        "Iacute": "\xcd",
        "icirc": "\xee",
        "Icirc": "\xce",
        "iexcl": "\xa1",
        "igrave": "\xec",
        "Igrave": "\xcc",
        "iquest": "\xbf",
        "iuml": "\xef",
        "Iuml": "\xcf",
        "laquo": "\xab",
        "lt": "<",
        "LT": "<",
        "macr": "\xaf",
        "micro": "\xb5",
        "middot": "\xb7",
        "nbsp": "\xa0",
        "not": "\xac",
        "ntilde": "\xf1",
        "Ntilde": "\xd1",
        "oacute": "\xf3",
        "Oacute": "\xd3",
        "ocirc": "\xf4",
        "Ocirc": "\xd4",
        "ograve": "\xf2",
        "Ograve": "\xd2",
        "ordf": "\xaa",
        "ordm": "\xba",
        "oslash": "\xf8",
        "Oslash": "\xd8",
        "otilde": "\xf5",
        "Otilde": "\xd5",
        "ouml": "\xf6",
        "Ouml": "\xd6",
        "para": "\xb6",
        "plusmn": "\xb1",
        "pound": "\xa3",
        "quot": '"',
        "QUOT": '"',
        "raquo": "\xbb",
        "reg": "\xae",
        "REG": "\xae",
        "sect": "\xa7",
        "shy": "\xad",
        "sup1": "\xb9",
        "sup2": "\xb2",
        "sup3": "\xb3",
        "szlig": "\xdf",
        "thorn": "\xfe",
        "THORN": "\xde",
        "times": "\xd7",
        "uacute": "\xfa",
        "Uacute": "\xda",
        "ucirc": "\xfb",
        "Ucirc": "\xdb",
        "ugrave": "\xf9",
        "Ugrave": "\xd9",
        "uml": "\xa8",
        "uuml": "\xfc",
        "Uuml": "\xdc",
        "yacute": "\xfd",
        "Yacute": "\xdd",
        "yen": "\xa5",
        "yuml": "\xff"
    };
    var decodeMapNumeric = {
        "0": "\uFFFD",
        "128": "\u20AC",
        "130": "\u201A",
        "131": "\u0192",
        "132": "\u201E",
        "133": "\u2026",
        "134": "\u2020",
        "135": "\u2021",
        "136": "\u02C6",
        "137": "\u2030",
        "138": "\u0160",
        "139": "\u2039",
        "140": "\u0152",
        "142": "\u017D",
        "145": "\u2018",
        "146": "\u2019",
        "147": "\u201C",
        "148": "\u201D",
        "149": "\u2022",
        "150": "\u2013",
        "151": "\u2014",
        "152": "\u02DC",
        "153": "\u2122",
        "154": "\u0161",
        "155": "\u203A",
        "156": "\u0153",
        "158": "\u017E",
        "159": "\u0178"
    };
    var invalidReferenceCodePoints = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        11,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        64976,
        64977,
        64978,
        64979,
        64980,
        64981,
        64982,
        64983,
        64984,
        64985,
        64986,
        64987,
        64988,
        64989,
        64990,
        64991,
        64992,
        64993,
        64994,
        64995,
        64996,
        64997,
        64998,
        64999,
        65000,
        65001,
        65002,
        65003,
        65004,
        65005,
        65006,
        65007,
        65534,
        65535,
        131070,
        131071,
        196606,
        196607,
        262142,
        262143,
        327678,
        327679,
        393214,
        393215,
        458750,
        458751,
        524286,
        524287,
        589822,
        589823,
        655358,
        655359,
        720894,
        720895,
        786430,
        786431,
        851966,
        851967,
        917502,
        917503,
        983038,
        983039,
        1048574,
        1048575,
        1114110,
        1114111
    ];
    /*--------------------------------------------------------------------------*/ var stringFromCharCode = String.fromCharCode;
    var object = {};
    var hasOwnProperty = object.hasOwnProperty;
    var has = function(object, propertyName) {
        return hasOwnProperty.call(object, propertyName);
    };
    var contains = function(array, value) {
        var index = -1;
        var length = array.length;
        while(++index < length){
            if (array[index] == value) return true;
        }
        return false;
    };
    var merge = function(options, defaults) {
        if (!options) return defaults;
        var result = {};
        var key;
        for(key in defaults)// A `hasOwnProperty` check is not needed here, since only recognized
        // option names are used anyway. Any others are ignored.
        result[key] = has(options, key) ? options[key] : defaults[key];
        return result;
    };
    // Modified version of `ucs2encode`; see https://mths.be/punycode.
    var codePointToSymbol = function(codePoint, strict) {
        var output = "";
        if (codePoint >= 0xD800 && codePoint <= 0xDFFF || codePoint > 0x10FFFF) {
            // See issue #4:
            // “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
            // greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
            // REPLACEMENT CHARACTER.”
            if (strict) parseError("character reference outside the permissible Unicode range");
            return "\uFFFD";
        }
        if (has(decodeMapNumeric, codePoint)) {
            if (strict) parseError("disallowed character reference");
            return decodeMapNumeric[codePoint];
        }
        if (strict && contains(invalidReferenceCodePoints, codePoint)) parseError("disallowed character reference");
        if (codePoint > 0xFFFF) {
            codePoint -= 0x10000;
            output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        output += stringFromCharCode(codePoint);
        return output;
    };
    var hexEscape = function(codePoint) {
        return "&#x" + codePoint.toString(16).toUpperCase() + ";";
    };
    var decEscape = function(codePoint) {
        return "&#" + codePoint + ";";
    };
    var parseError = function(message) {
        throw Error("Parse error: " + message);
    };
    /*--------------------------------------------------------------------------*/ var encode = function(string, options) {
        options = merge(options, encode.options);
        var strict = options.strict;
        if (strict && regexInvalidRawCodePoint.test(string)) parseError("forbidden code point");
        var encodeEverything = options.encodeEverything;
        var useNamedReferences = options.useNamedReferences;
        var allowUnsafeSymbols = options.allowUnsafeSymbols;
        var escapeCodePoint = options.decimal ? decEscape : hexEscape;
        var escapeBmpSymbol = function(symbol) {
            return escapeCodePoint(symbol.charCodeAt(0));
        };
        if (encodeEverything) {
            // Encode ASCII symbols.
            string = string.replace(regexAsciiWhitelist, function(symbol) {
                // Use named references if requested & possible.
                if (useNamedReferences && has(encodeMap, symbol)) return "&" + encodeMap[symbol] + ";";
                return escapeBmpSymbol(symbol);
            });
            // Shorten a few escapes that represent two symbols, of which at least one
            // is within the ASCII range.
            if (useNamedReferences) string = string.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;").replace(/&#x66;&#x6A;/g, "&fjlig;");
            // Encode non-ASCII symbols.
            if (useNamedReferences) // Encode non-ASCII symbols that can be replaced with a named reference.
            string = string.replace(regexEncodeNonAscii, function(string) {
                // Note: there is no need to check `has(encodeMap, string)` here.
                return "&" + encodeMap[string] + ";";
            });
        // Note: any remaining non-ASCII symbols are handled outside of the `if`.
        } else if (useNamedReferences) {
            // Apply named character references.
            // Encode `<>"'&` using named character references.
            if (!allowUnsafeSymbols) string = string.replace(regexEscape, function(string) {
                return "&" + encodeMap[string] + ";"; // no need to check `has()` here
            });
            // Shorten escapes that represent two symbols, of which at least one is
            // `<>"'&`.
            string = string.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;");
            // Encode non-ASCII symbols that can be replaced with a named reference.
            string = string.replace(regexEncodeNonAscii, function(string) {
                // Note: there is no need to check `has(encodeMap, string)` here.
                return "&" + encodeMap[string] + ";";
            });
        } else if (!allowUnsafeSymbols) // Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
        // using named character references.
        string = string.replace(regexEscape, escapeBmpSymbol);
        return string// Encode astral symbols.
        .replace(regexAstralSymbols, function($0) {
            // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            var high = $0.charCodeAt(0);
            var low = $0.charCodeAt(1);
            var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
            return escapeCodePoint(codePoint);
        })// Encode any remaining BMP symbols that are not printable ASCII symbols
        // using a hexadecimal escape.
        .replace(regexBmpWhitelist, escapeBmpSymbol);
    };
    // Expose default options (so they can be overridden globally).
    encode.options = {
        "allowUnsafeSymbols": false,
        "encodeEverything": false,
        "strict": false,
        "useNamedReferences": false,
        "decimal": false
    };
    var decode = function(html, options) {
        options = merge(options, decode.options);
        var strict = options.strict;
        if (strict && regexInvalidEntity.test(html)) parseError("malformed character reference");
        return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
            var codePoint;
            var semicolon;
            var decDigits;
            var hexDigits;
            var reference;
            var next;
            if ($1) {
                reference = $1;
                // Note: there is no need to check `has(decodeMap, reference)`.
                return decodeMap[reference];
            }
            if ($2) {
                // Decode named character references without trailing `;`, e.g. `&amp`.
                // This is only a parse error if it gets converted to `&`, or if it is
                // followed by `=` in an attribute context.
                reference = $2;
                next = $3;
                if (next && options.isAttributeValue) {
                    if (strict && next == "=") parseError("`&` did not start a character reference");
                    return $0;
                } else {
                    if (strict) parseError("named character reference was not terminated by a semicolon");
                    // Note: there is no need to check `has(decodeMapLegacy, reference)`.
                    return decodeMapLegacy[reference] + (next || "");
                }
            }
            if ($4) {
                // Decode decimal escapes, e.g. `&#119558;`.
                decDigits = $4;
                semicolon = $5;
                if (strict && !semicolon) parseError("character reference was not terminated by a semicolon");
                codePoint = parseInt(decDigits, 10);
                return codePointToSymbol(codePoint, strict);
            }
            if ($6) {
                // Decode hexadecimal escapes, e.g. `&#x1D306;`.
                hexDigits = $6;
                semicolon = $7;
                if (strict && !semicolon) parseError("character reference was not terminated by a semicolon");
                codePoint = parseInt(hexDigits, 16);
                return codePointToSymbol(codePoint, strict);
            }
            // If we’re still here, `if ($7)` is implied; it’s an ambiguous
            // ampersand for sure. https://mths.be/notes/ambiguous-ampersands
            if (strict) parseError("named character reference was not terminated by a semicolon");
            return $0;
        });
    };
    // Expose default options (so they can be overridden globally).
    decode.options = {
        "isAttributeValue": false,
        "strict": false
    };
    var escape = function(string) {
        return string.replace(regexEscape, function($0) {
            // Note: there is no need to check `has(escapeMap, $0)` here.
            return escapeMap[$0];
        });
    };
    /*--------------------------------------------------------------------------*/ var he = {
        "version": "1.2.0",
        "encode": encode,
        "decode": decode,
        "escape": escape,
        "unescape": decode
    };
    // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define(function() {
        return he;
    });
    else if (freeExports && !freeExports.nodeType) {
        if (freeModule) freeModule.exports = he;
        else for(var key in he)has(he, key) && (freeExports[key] = he[key]);
    } else root.he = he;
})(this);

});

function $8e4453fb4fc895c8$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $8e4453fb4fc895c8$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n2 = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n2 >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n2++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $8e4453fb4fc895c8$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $8e4453fb4fc895c8$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$8e4453fb4fc895c8$var$_isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $8e4453fb4fc895c8$var$_construct(t, arguments, $8e4453fb4fc895c8$var$_getPrototypeOf(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $8e4453fb4fc895c8$var$_setPrototypeOf(Wrapper, t);
    }, $8e4453fb4fc895c8$var$_wrapNativeSuper(t);
}
function $8e4453fb4fc895c8$var$_construct(t, e, r) {
    if ($8e4453fb4fc895c8$var$_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $8e4453fb4fc895c8$var$_setPrototypeOf(p, r.prototype), p;
}
function $8e4453fb4fc895c8$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
function $8e4453fb4fc895c8$var$_callSuper(t, o, e) {
    return o = $8e4453fb4fc895c8$var$_getPrototypeOf(o), $8e4453fb4fc895c8$var$_possibleConstructorReturn(t, $8e4453fb4fc895c8$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $8e4453fb4fc895c8$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $8e4453fb4fc895c8$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $8e4453fb4fc895c8$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $8e4453fb4fc895c8$var$_assertThisInitialized(t);
}
function $8e4453fb4fc895c8$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $8e4453fb4fc895c8$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8e4453fb4fc895c8$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $8e4453fb4fc895c8$var$_getPrototypeOf(t) {
    return $8e4453fb4fc895c8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $8e4453fb4fc895c8$var$_getPrototypeOf(t);
}
function $8e4453fb4fc895c8$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $8e4453fb4fc895c8$var$_setPrototypeOf(t, e);
}
function $8e4453fb4fc895c8$var$_setPrototypeOf(t, e) {
    return $8e4453fb4fc895c8$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $8e4453fb4fc895c8$var$_setPrototypeOf(t, e);
}
function $8e4453fb4fc895c8$var$_slicedToArray(r, e) {
    return $8e4453fb4fc895c8$var$_arrayWithHoles(r) || $8e4453fb4fc895c8$var$_iterableToArrayLimit(r, e) || $8e4453fb4fc895c8$var$_unsupportedIterableToArray(r, e) || $8e4453fb4fc895c8$var$_nonIterableRest();
}
function $8e4453fb4fc895c8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8e4453fb4fc895c8$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $8e4453fb4fc895c8$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $8e4453fb4fc895c8$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $8e4453fb4fc895c8$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $8e4453fb4fc895c8$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($8e4453fb4fc895c8$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $8e4453fb4fc895c8$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $8e4453fb4fc895c8$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $8e4453fb4fc895c8$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $8e4453fb4fc895c8$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $8e4453fb4fc895c8$var$_toConsumableArray(r) {
    return $8e4453fb4fc895c8$var$_arrayWithoutHoles(r) || $8e4453fb4fc895c8$var$_iterableToArray(r) || $8e4453fb4fc895c8$var$_unsupportedIterableToArray(r) || $8e4453fb4fc895c8$var$_nonIterableSpread();
}
function $8e4453fb4fc895c8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8e4453fb4fc895c8$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8e4453fb4fc895c8$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8e4453fb4fc895c8$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $8e4453fb4fc895c8$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $8e4453fb4fc895c8$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $8e4453fb4fc895c8$var$_arrayLikeToArray(r);
}
function $8e4453fb4fc895c8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $8e4453fb4fc895c8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e4453fb4fc895c8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e4453fb4fc895c8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8e4453fb4fc895c8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e4453fb4fc895c8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8e4453fb4fc895c8$var$_defineProperty(e, r, t) {
    return (r = $8e4453fb4fc895c8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8e4453fb4fc895c8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8e4453fb4fc895c8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8e4453fb4fc895c8$var$_typeof(o);
}
function $8e4453fb4fc895c8$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $8e4453fb4fc895c8$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $8e4453fb4fc895c8$var$_toPropertyKey(o.key), o);
    }
}
function $8e4453fb4fc895c8$var$_createClass(e, r, t) {
    return r && $8e4453fb4fc895c8$var$_defineProperties(e.prototype, r), t && $8e4453fb4fc895c8$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $8e4453fb4fc895c8$var$_toPropertyKey(t) {
    var i = $8e4453fb4fc895c8$var$_toPrimitive(t, "string");
    return "symbol" == $8e4453fb4fc895c8$var$_typeof(i) ? i : i + "";
}
function $8e4453fb4fc895c8$var$_toPrimitive(t, r) {
    if ("object" != $8e4453fb4fc895c8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8e4453fb4fc895c8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $8e4453fb4fc895c8$var$Pn = /*#__PURE__*/ function() {
    function Pn() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Pn);
    }
    return $8e4453fb4fc895c8$var$_createClass(Pn, null, [
        {
            key: "render",
            value: function render(e, t) {
                var i = document.createElement("div");
                i.id = "error-view", i.innerText = t, e.replaceChildren(i);
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$fi = /*#__PURE__*/ function() {
    function fi() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, fi);
    }
    return $8e4453fb4fc895c8$var$_createClass(fi, null, [
        {
            key: "onLoad",
            value: function onLoad(e) {
                e.innerHTML = '<div id="loading-validate-key-property"></div>';
            }
        },
        {
            key: "createElements",
            value: function createElements() {
                var e = document.createElement("div");
                return e.id = "validate-property-key-view", e;
            }
        },
        {
            key: "render",
            value: function render(e, t, i) {
                var s = fi.createElements(), r = {
                    onSuccess: t,
                    onFail: $8e4453fb4fc895c8$var$Pn.render.bind(this, e, "Your 'key' has failed authentication"),
                    onLoad: fi.onLoad.bind(this, s)
                };
                i.key && i.verifyKey(i.key, r), e.replaceChildren(s);
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$R = /*#__PURE__*/ function() {
    function R() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, R);
    }
    return $8e4453fb4fc895c8$var$_createClass(R, null, [
        {
            key: "unsetStyle",
            value: function unsetStyle(e, t) {
                var i = Object.keys(t).reduce(function(s, r) {
                    return s[r] = "", s;
                }, {});
                Object.assign(e.style, i);
            }
        },
        {
            key: "unsetActivityCSSMouseStates",
            value: function unsetActivityCSSMouseStates(e, t) {
                t.click && R.unsetStyle(e, t.click), t.hover && R.unsetStyle(e, t.hover);
            }
        },
        {
            key: "unsetAllCSSMouseStates",
            value: function unsetAllCSSMouseStates(e, t) {
                R.unsetActivityCSSMouseStates(e, t), t["default"] && R.unsetStyle(e, t["default"]);
            }
        },
        {
            key: "processStateful",
            value: function processStateful(e, t, i) {
                var s = e["default"] || {}, r = Object.assign(JSON.parse(JSON.stringify($8e4453fb4fc895c8$var$_objectSpread($8e4453fb4fc895c8$var$_objectSpread({}, s), t))), e == null ? void 0 : e.hover), o = Object.assign(JSON.parse(JSON.stringify($8e4453fb4fc895c8$var$_objectSpread($8e4453fb4fc895c8$var$_objectSpread({}, r), i))), e == null ? void 0 : e.click);
                return {
                    "default": s,
                    hover: r,
                    click: o
                };
            }
        },
        {
            key: "mergeStatefulStyles",
            value: function mergeStatefulStyles(e) {
                var t = {
                    "default": {},
                    hover: {},
                    click: {}
                };
                return e.forEach(function(i) {
                    t["default"] = Object.assign(t["default"], i["default"]), t.hover = Object.assign(t.hover, i.hover), t.click = Object.assign(t.click, i.click);
                }), t;
            }
        },
        {
            key: "overwriteDefaultWithAlreadyApplied",
            value: function overwriteDefaultWithAlreadyApplied(e, t) {
                Object.keys(e["default"] || []).forEach(function(i) {
                    var r;
                    var s = i;
                    t.style[s] && (r = e["default"]) != null && r[s] && (e["default"][i] = t.style[s]);
                });
            }
        },
        {
            key: "applyToStyleIfNotDefined",
            value: function applyToStyleIfNotDefined(e, t) {
                for(var i in t){
                    var s = t[i];
                    e[i] === "" && s && (e[i] = s);
                }
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Ke = /*#__PURE__*/ function() {
    function Ke() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ke);
    }
    return $8e4453fb4fc895c8$var$_createClass(Ke, null, [
        {
            key: "attemptAppendStyleSheetToHead",
            value: function attemptAppendStyleSheetToHead(e) {
                if (e.fontFamily && e.fontFamily !== Ke.DEFAULT_FONT_FAMILY) return;
                var t = document.getElementsByTagName("head")[0];
                if (!Array.from(t.getElementsByTagName("link")).some(function(s) {
                    return s.getAttribute("href") === Ke.FONT_URL;
                })) {
                    var s = document.createElement("link");
                    s.rel = "stylesheet", s.href = Ke.FONT_URL, t.appendChild(s);
                }
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$Ke.FONT_URL = "https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap", $8e4453fb4fc895c8$var$Ke.DEFAULT_FONT_FAMILY = "'Inter', sans-serif, Avenir, Helvetica, Arial";
var $8e4453fb4fc895c8$var$pi = $8e4453fb4fc895c8$var$Ke;
var $8e4453fb4fc895c8$var$mt = /*#__PURE__*/ function() {
    function mt() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, mt);
    }
    return $8e4453fb4fc895c8$var$_createClass(mt, null, [
        {
            key: "apply",
            value: function apply(e, t) {
                if (t) try {
                    mt.applyStyleSheet(e, t);
                } catch (_unused) {
                    mt.addStyleElement(e, t);
                }
            }
        },
        {
            key: "applyStyleSheet",
            value: function applyStyleSheet(e, t) {
                var i = new CSSStyleSheet();
                i.replaceSync(e), t.adoptedStyleSheets.push(i);
            }
        },
        {
            key: "addStyleElement",
            value: function addStyleElement(e, t) {
                var i = document.createElement("style");
                i.innerHTML = e, t.appendChild(i);
            }
        },
        {
            key: "applyDefaultStyleToComponent",
            value: function applyDefaultStyleToComponent(e, t) {
                t && $8e4453fb4fc895c8$var$R.applyToStyleIfNotDefined(e, t), $8e4453fb4fc895c8$var$R.applyToStyleIfNotDefined(e, mt.DEFAULT_COMPONENT_STYLE);
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$mt.DEFAULT_COMPONENT_STYLE = {
    height: "350px",
    width: "320px",
    borderTop: "1px solid #cacaca",
    borderRight: "1px solid #cacaca",
    borderLeft: "1px solid #cacaca",
    borderBottom: "1px solid #cacaca",
    fontFamily: $8e4453fb4fc895c8$var$pi.DEFAULT_FONT_FAMILY,
    fontSize: "0.9rem",
    backgroundColor: "white",
    position: "relative",
    // this is used to prevent inputAreaStyle background color from going beyond the container's rounded border
    // it will cause issues if there are elements that are meant to be outside of the chat component and in
    // that instance they should overwrite this
    // this is also causing the chat to squeeze when there is no space
    overflow: "hidden"
};
var $8e4453fb4fc895c8$var$Pt = $8e4453fb4fc895c8$var$mt;
var $8e4453fb4fc895c8$var$st;
var $8e4453fb4fc895c8$var$Ct = ($8e4453fb4fc895c8$var$st = /*#__PURE__*/ $8e4453fb4fc895c8$var$_createClass(function st() {
    $8e4453fb4fc895c8$var$_classCallCheck(this, st);
}), $8e4453fb4fc895c8$var$st.IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), $8e4453fb4fc895c8$var$st.IS_CHROMIUM = window.chrome, $8e4453fb4fc895c8$var$st);
var $8e4453fb4fc895c8$var$D = /* @__PURE__ */ function(n) {
    return n.ESCAPE = "Escape", n.ENTER = "Enter", n.TAB = "Tab", n.ARROW_UP = "ArrowUp", n.ARROW_DOWN = "ArrowDown", n.ARROW_RIGHT = "ArrowRight", n.ARROW_LEFT = "ArrowLeft", n.BACKSPACE = "Backspace", n.DELETE = "Delete", n.META = "Meta", n.CONTROL = "Control", n;
}($8e4453fb4fc895c8$var$D || {});
var $8e4453fb4fc895c8$var$Je = /*#__PURE__*/ function() {
    function Je() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Je);
    }
    return $8e4453fb4fc895c8$var$_createClass(Je, null, [
        {
            key: "add",
            value: // prettier-ignore
            function add(e, t, i, s) {
                i !== void 0 && e.addEventListener("keydown", Je.onKeyDown.bind(this, i)), e.oninput = Je.onInput.bind(this, i, s), e.addEventListener("paste", function(r) {
                    var o;
                    r.preventDefault(), (o = r.clipboardData) != null && o.files.length && t.addFilesToAnyType(Array.from(r.clipboardData.files));
                });
            }
        },
        {
            key: "onKeyDown",
            value: function onKeyDown(e, t) {
                var s = t.target.textContent;
                s && s.length >= e && !Je.PERMITTED_KEYS.has(t.key) && !Je.isKeyCombinationPermitted(t) && t.preventDefault();
            }
        },
        {
            key: "isKeyCombinationPermitted",
            value: function isKeyCombinationPermitted(e) {
                return e.key === "a" ? e.ctrlKey || e.metaKey : !1;
            }
        },
        {
            key: "onInput",
            value: function onInput(e, t, i) {
                var s = i.target, r = s.textContent || "";
                e !== void 0 && r.length > e && (s.textContent = r.substring(0, e), $8e4453fb4fc895c8$var$Qt.focusEndOfInput(s)), t == null || t();
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$Je.PERMITTED_KEYS = /* @__PURE__ */ new Set([
    $8e4453fb4fc895c8$var$D.BACKSPACE,
    $8e4453fb4fc895c8$var$D.DELETE,
    $8e4453fb4fc895c8$var$D.ARROW_RIGHT,
    $8e4453fb4fc895c8$var$D.ARROW_LEFT,
    $8e4453fb4fc895c8$var$D.ARROW_DOWN,
    $8e4453fb4fc895c8$var$D.ARROW_UP,
    $8e4453fb4fc895c8$var$D.META,
    $8e4453fb4fc895c8$var$D.CONTROL,
    $8e4453fb4fc895c8$var$D.ENTER
]);
var $8e4453fb4fc895c8$var$ds = $8e4453fb4fc895c8$var$Je;
var $8e4453fb4fc895c8$var$On = /*#__PURE__*/ function() {
    function On() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, On);
    }
    return $8e4453fb4fc895c8$var$_createClass(On, null, [
        {
            key: "sanitizePastedTextContent",
            value: function sanitizePastedTextContent(e) {
                var i, s;
                e.preventDefault();
                var t = (i = e.clipboardData) == null ? void 0 : i.getData("text/plain");
                t && ((s = document.execCommand) == null || s.call(document, "insertText", !1, t));
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Ze = /*#__PURE__*/ function() {
    function Ze(e, t, i) {
        var _this = this;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ze);
        var r, o;
        var s = Ze.processConfig(t, e.textInput);
        this.elementRef = Ze.createContainerElement((r = s == null ? void 0 : s.styles) == null ? void 0 : r.container), this._config = s, this.inputElementRef = this.createInputElement(), this.elementRef.appendChild(this.inputElementRef), e.setPlaceholderText = this.setPlaceholderText.bind(this), e.setPlaceholderText(((o = this._config.placeholder) == null ? void 0 : o.text) || "Ask me anything!"), setTimeout(function() {
            $8e4453fb4fc895c8$var$ds.add(_this.inputElementRef, i, _this._config.characterLimit, e._validationHandler);
        });
    }
    return $8e4453fb4fc895c8$var$_createClass(Ze, [
        {
            key: "clear",
            value: // this also similarly prevents scroll up
            function clear() {
                var t;
                var e = window.scrollY;
                this.inputElementRef.classList.contains("text-input-disabled") || (Object.assign(this.inputElementRef.style, (t = this._config.placeholder) == null ? void 0 : t.style), this.inputElementRef.textContent = "", $8e4453fb4fc895c8$var$Qt.focusEndOfInput(this.inputElementRef)), $8e4453fb4fc895c8$var$Ct.IS_CHROMIUM && window.scrollTo({
                    top: e
                });
            }
        },
        {
            key: "createInputElement",
            value: function createInputElement() {
                var t, i, s, r;
                var e = document.createElement("div");
                return e.id = Ze.TEXT_INPUT_ID, e.classList.add("text-input-styling"), $8e4453fb4fc895c8$var$Ct.IS_CHROMIUM && Ze.preventAutomaticScrollUpOnNewLine(e), typeof this._config.disabled == "boolean" && this._config.disabled === !0 ? (e.contentEditable = "false", e.classList.add("text-input-disabled")) : (e.contentEditable = "true", this.addEventListeners(e)), Object.assign(e.style, (t = this._config.styles) == null ? void 0 : t.text), Object.assign(e.style, (i = this._config.placeholder) == null ? void 0 : i.style), (r = (s = this._config.placeholder) == null ? void 0 : s.style) != null && r.color || e.setAttribute("textcolor", ""), e;
            }
        },
        {
            key: "removePlaceholderStyle",
            value: function removePlaceholderStyle() {
                var e, t, i, s;
                !this.inputElementRef.classList.contains("text-input-disabled") && (e = this._config.placeholder) != null && e.style && ($8e4453fb4fc895c8$var$R.unsetStyle(this.inputElementRef, (t = this._config.placeholder) == null ? void 0 : t.style), Object.assign(this.inputElementRef.style, (s = (i = this._config) == null ? void 0 : i.styles) == null ? void 0 : s.text));
            }
        },
        {
            key: "addEventListeners",
            value: function addEventListeners(e) {
                var _this2 = this;
                var t, i;
                (t = this._config.styles) != null && t.focus && (e.onfocus = function() {
                    var s;
                    return Object.assign(_this2.elementRef.style, (s = _this2._config.styles) == null ? void 0 : s.focus);
                }, e.onblur = this.onBlur.bind(this, this._config.styles.focus, (i = this._config.styles) == null ? void 0 : i.container)), e.addEventListener("keydown", this.onKeydown.bind(this)), e.addEventListener("input", this.onInput.bind(this)), e.addEventListener("paste", $8e4453fb4fc895c8$var$On.sanitizePastedTextContent);
            }
        },
        {
            key: "onBlur",
            value: function onBlur(e, t) {
                $8e4453fb4fc895c8$var$R.unsetStyle(this.elementRef, e), t && Object.assign(this.elementRef.style, t);
            }
        },
        {
            key: "onKeydown",
            value: function onKeydown(e) {
                var t;
                e.key === $8e4453fb4fc895c8$var$D.ENTER && !e.ctrlKey && !e.shiftKey && (e.preventDefault(), (t = this.submit) == null || t.call(this));
            }
        },
        {
            key: "onInput",
            value: function onInput() {
                var e;
                this.isTextInputEmpty() ? Object.assign(this.inputElementRef.style, (e = this._config.placeholder) == null ? void 0 : e.style) : this.removePlaceholderStyle();
            }
        },
        {
            key: "setPlaceholderText",
            value: function setPlaceholderText(e) {
                this.inputElementRef.setAttribute("deep-chat-placeholder-text", e);
            }
        },
        {
            key: "isTextInputEmpty",
            value: function isTextInputEmpty() {
                return this.inputElementRef.textContent === "";
            }
        }
    ], [
        {
            key: "processConfig",
            value: function processConfig(e, t) {
                var _t2, _t$disabled, _t$placeholder, _i$text;
                var i;
                return (_t2 = t) !== null && _t2 !== void 0 ? _t2 : t = {}, (_t$disabled = t.disabled) !== null && _t$disabled !== void 0 ? _t$disabled : t.disabled = e.isTextInputDisabled, (_t$placeholder = t.placeholder) !== null && _t$placeholder !== void 0 ? _t$placeholder : t.placeholder = {}, (_i$text = (i = t.placeholder).text) !== null && _i$text !== void 0 ? _i$text : i.text = e.textInputPlaceholderText, t;
            }
        },
        {
            key: "createContainerElement",
            value: function createContainerElement(e) {
                var t = document.createElement("div");
                return t.id = "text-input-container", Object.assign(t.style, e), t;
            }
        },
        {
            key: "preventAutomaticScrollUpOnNewLine",
            value: function preventAutomaticScrollUpOnNewLine(e) {
                var t;
                e.addEventListener("keydown", function() {
                    t = window.scrollY;
                }), e.addEventListener("input", function() {
                    t !== window.scrollY && window.scrollTo({
                        top: t
                    });
                });
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$Ze.TEXT_INPUT_ID = "text-input";
var $8e4453fb4fc895c8$var$mi = $8e4453fb4fc895c8$var$Ze;
var $8e4453fb4fc895c8$var$Qt = /*#__PURE__*/ function() {
    function Qt() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Qt);
    }
    return $8e4453fb4fc895c8$var$_createClass(Qt, null, [
        {
            key: "focusEndOfInput",
            value: function focusEndOfInput(e) {
                var t = document.createRange();
                t.selectNodeContents(e), t.collapse(!1);
                var i = window.getSelection();
                i == null || i.removeAllRanges(), i == null || i.addRange(t);
            }
        },
        {
            key: "focusFromParentElement",
            value: function focusFromParentElement(e) {
                var t = e.querySelector("#".concat($8e4453fb4fc895c8$var$mi.TEXT_INPUT_ID));
                t && ($8e4453fb4fc895c8$var$Ct.IS_SAFARI && t.focus(), Qt.focusEndOfInput(t));
            }
        }
    ]);
}();
function $8e4453fb4fc895c8$var$Hs(n) {
    return n.charAt(0).toUpperCase() + n.slice(1);
}
function $8e4453fb4fc895c8$var$Nn(n) {
    return n && JSON.stringify(n);
}
function $8e4453fb4fc895c8$var$ks(n, e, t, i) {
    var s = "\n".concat($8e4453fb4fc895c8$var$Hs(e), " message: ").concat(JSON.stringify(n), " \n"), r = t ? "".concat($8e4453fb4fc895c8$var$Hs(e), " message after interceptor: ").concat($8e4453fb4fc895c8$var$Nn(i), " \n") : "";
    return s + r;
}
function $8e4453fb4fc895c8$var$Dn(n, e, t, i) {
    return "".concat($8e4453fb4fc895c8$var$ks(n, e, t, i), "Make sure the ").concat(e, " message is using the Response format: https://deepchat.dev/docs/connect/#Response \nYou can also augment it using the responseInterceptor property: https://deepchat.dev/docs/interceptors#responseInterceptor");
}
function $8e4453fb4fc895c8$var$Bn(n, e, t) {
    var i = "response";
    return "".concat($8e4453fb4fc895c8$var$ks(n, i, e, t), "Make sure the ").concat(i, ' message is using the {text: string} format, e.g: {text: "Model Response"}');
}
function $8e4453fb4fc895c8$var$Fn(n, e) {
    var t = "request";
    return "".concat($8e4453fb4fc895c8$var$ks(n, t, e), "Make sure the ").concat(t, ' message is using the {body: {text: string}} format, e.g: {body: {text: "Model Response"}}');
}
var $8e4453fb4fc895c8$var$qs = "Make sure the events are using {text: string} or {html: string} format.\nYou can also augment them using the responseInterceptor property: https://deepchat.dev/docs/interceptors#responseInterceptor", $8e4453fb4fc895c8$var$M = {
    INVALID_KEY: "Invalid API Key",
    CONNECTION_FAILED: "Failed to connect",
    INVALID_RESPONSE: $8e4453fb4fc895c8$var$Dn,
    INVALID_MODEL_REQUEST: $8e4453fb4fc895c8$var$Fn,
    INVALID_MODEL_RESPONSE: $8e4453fb4fc895c8$var$Bn,
    INVALID_STREAM_EVENT: $8e4453fb4fc895c8$var$qs,
    INVALID_STREAM_EVENT_MIX: "Cannot mix {text: string} and {html: string} responses.",
    NO_VALID_STREAM_EVENTS_SENT: "No valid stream events were sent.\n".concat($8e4453fb4fc895c8$var$qs)
}, $8e4453fb4fc895c8$var$Ni = /*#__PURE__*/ function() {
    function Ni() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ni);
    }
    return $8e4453fb4fc895c8$var$_createClass(Ni, null, [
        {
            key: "addElements",
            value: function addElements(e) {
                for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)t[_key - 1] = arguments[_key];
                t.forEach(function(i) {
                    return e.appendChild(i);
                });
            }
        },
        {
            key: "isScrollbarAtBottomOfElement",
            value: function isScrollbarAtBottomOfElement(e) {
                var t = e.scrollHeight, i = e.clientHeight, s = e.scrollTop, r = t - i;
                return s >= r - Ni.CODE_SNIPPET_GENERATION_JUMP;
            }
        },
        {
            key: "cloneElement",
            value: function cloneElement(e) {
                var t = e.cloneNode(!0);
                return e.parentNode.replaceChild(t, e), t;
            }
        },
        {
            key: "scrollToBottom",
            value: function scrollToBottom(e) {
                e.scrollTop = e.scrollHeight;
            }
        },
        {
            key: "scrollToTop",
            value: function scrollToTop(e) {
                e.scrollTop = 0;
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$Ni.CODE_SNIPPET_GENERATION_JUMP = 0.5;
var $8e4453fb4fc895c8$var$X = $8e4453fb4fc895c8$var$Ni;
var $8e4453fb4fc895c8$var$Di = /*#__PURE__*/ function() {
    function Di() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Di);
    }
    return $8e4453fb4fc895c8$var$_createClass(Di, null, [
        {
            key: "speak",
            value: function speak(e, t) {
                if (window.SpeechSynthesisUtterance) {
                    var i = new SpeechSynthesisUtterance(e);
                    Object.assign(i, t), speechSynthesis.speak(i);
                }
            }
        },
        {
            key: "processConfig",
            value: function processConfig(e, t) {
                var i = {};
                setTimeout(function() {
                    if ($8e4453fb4fc895c8$var$_typeof(e) == "object" && (e.lang && (i.lang = e.lang), e.pitch && (i.pitch = e.pitch), e.rate && (i.rate = e.rate), e.volume && (i.volume = e.volume), e.voiceName)) {
                        var s = window.speechSynthesis.getVoices().find(function(r) {
                            var o;
                            return r.name.toLocaleLowerCase() === ((o = e.voiceName) == null ? void 0 : o.toLocaleLowerCase());
                        });
                        s && (i.voice = s);
                    }
                    t(i);
                }, Di.LOAD_VOICES_MS);
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$Di.LOAD_VOICES_MS = 200;
var $8e4453fb4fc895c8$var$xt = $8e4453fb4fc895c8$var$Di;
var $8e4453fb4fc895c8$var$gt = /*#__PURE__*/ function() {
    function gt() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, gt);
    }
    return $8e4453fb4fc895c8$var$_createClass(gt, null, [
        {
            key: "colorToHex",
            value: function colorToHex(e) {
                var t = document.createElement("div");
                return t.style.color = e, document.body.appendChild(t), "#".concat(window.getComputedStyle(t).color.match(/\d+/g).map(function(r) {
                    return parseInt(r).toString(16).padStart(2, "0");
                }).join(""));
            }
        },
        {
            key: "setDots",
            value: function setDots(e, t) {
                var i, s, r, o;
                if ((o = (r = (s = (i = t == null ? void 0 : t.loading) == null ? void 0 : i.message) == null ? void 0 : s.styles) == null ? void 0 : r.bubble) != null && o.color) {
                    var a = gt.colorToHex(t.loading.message.styles.bubble.color);
                    e.style.setProperty("--loading-message-color", a), e.style.setProperty("--loading-message-color-fade", "".concat(a, "33"));
                } else e.style.setProperty("--loading-message-color", "#848484"), e.style.setProperty("--loading-message-color-fade", "#55555533");
            }
        },
        {
            key: "setRing",
            value: function setRing(e, t) {
                var _ref = t || {}, i = _ref.color, s = _ref.width, r = _ref.height, o = _ref.margin, a = _ref.border;
                if (i) {
                    var l = gt.colorToHex(i);
                    e.style.setProperty("--loading-history-color", l);
                } else e.style.setProperty("--loading-history-color", "#dbdbdb");
                e.style.setProperty("--loading-history-height", r || "57px"), e.style.setProperty("--loading-history-width", s || "57px"), e.style.setProperty("--loading-history-margin", o || "7px"), e.style.setProperty("--loading-history-border", a || "6px solid");
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$gt.BUBBLE_CLASS = "deep-chat-loading-message-bubble", $8e4453fb4fc895c8$var$gt.DOTS_CONTAINER_CLASS = "deep-chat-loading-message-dots-container";
var $8e4453fb4fc895c8$var$Oe = $8e4453fb4fc895c8$var$gt;
var $8e4453fb4fc895c8$var$ce = /*#__PURE__*/ function() {
    function ce() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, ce);
    }
    return $8e4453fb4fc895c8$var$_createClass(ce, null, [
        {
            key: "setElementProps",
            value: // prettier-ignore
            function setElementProps(e, t, i, s) {
                var r;
                i !== "loading" && (e.applyCustomStyles(t, s, !0, (r = e.messageStyles) == null ? void 0 : r[i]), t.bubbleElement.classList.add(ce.FILE_BUBBLE_CLASS));
            }
        },
        {
            key: "addMessage",
            value: function addMessage(e, t, i, s, r) {
                ce.setElementProps(e, t, i, s), r || (e.elementRef.appendChild(t.outerContainer), e.elementRef.scrollTop = e.elementRef.scrollHeight);
            }
        },
        {
            key: "wrapInLink",
            value: function wrapInLink(e, t, i) {
                var s = document.createElement("a");
                return s.href = t, s.download = i || ce.DEFAULT_FILE_NAME, s.target = "_blank", s.appendChild(e), s;
            }
        },
        {
            key: "isNonLinkableDataUrl",
            value: function isNonLinkableDataUrl(e, t) {
                return !t.startsWith("data") || e === "image" ? !1 : e === "any" && t.startsWith("data:text/javascript") || !t.startsWith("data:image") && !t.startsWith("data:application");
            }
        },
        {
            key: "processContent",
            value: function processContent(e, t, i, s) {
                return !i || ce.isNonLinkableDataUrl(e, i) ? t : ce.wrapInLink(t, i, s);
            }
        },
        {
            key: "waitToLoadThenScroll",
            value: function waitToLoadThenScroll(e) {
                setTimeout(function() {
                    e.scrollTop = e.scrollHeight;
                }, 60);
            }
        },
        {
            key: "scrollDownOnImageLoad",
            value: function scrollDownOnImageLoad(e, t) {
                if (e.startsWith("data")) ce.waitToLoadThenScroll(t);
                else try {
                    fetch(e, {
                        mode: "no-cors"
                    })["catch"](function() {})["finally"](function() {
                        ce.waitToLoadThenScroll(t);
                    });
                } catch (_unused2) {
                    t.scrollTop = t.scrollHeight;
                }
            }
        },
        {
            key: "reAddFileRefToObject",
            value: function reAddFileRefToObject(e, t) {
                var i;
                (i = e.files) == null || i.forEach(function(s, r) {
                    var o;
                    s.ref && (o = t.message.files) != null && o[r] && (t.message.files[r].ref = s.ref);
                });
            }
        },
        {
            key: "removeFileRef",
            value: function removeFileRef(e) {
                var t = $8e4453fb4fc895c8$var$_objectSpread({}, e);
                return delete t.ref, t;
            }
        },
        {
            key: "isAudioFile",
            value: function isAudioFile(e) {
                var t = /\.(mp3|ogg|wav|aac|webm|4a)$/i, i = e.type, s = e.src;
                return i === "audio" || (s == null ? void 0 : s.startsWith("data:audio")) || s && t.test(s);
            }
        },
        {
            key: "isImageFile",
            value: function isImageFile(e) {
                var t = e.type, i = e.src;
                return t === "image" || (i == null ? void 0 : i.startsWith("data:image")) || i && ce.isImageFileExtension(i);
            }
        },
        {
            key: "isImageFileExtension",
            value: function isImageFileExtension(e) {
                return /\.(jpg|jpeg|png|gif|bmp)$/i.test(e);
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$ce.DEFAULT_FILE_NAME = "file", $8e4453fb4fc895c8$var$ce.FILE_BUBBLE_CLASS = "file-message";
var $8e4453fb4fc895c8$var$j = $8e4453fb4fc895c8$var$ce;
var $8e4453fb4fc895c8$var$Y = /*#__PURE__*/ function() {
    function Y() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Y);
    }
    return $8e4453fb4fc895c8$var$_createClass(Y, null, [
        {
            key: "checkForContainerStyles",
            value: function checkForContainerStyles(e, t) {
                var i = e.containerStyle;
                i && (Object.assign(t.style, i), console.error("The containerStyle property is deprecated since version 1.3.14."), console.error("Please change to using the style property instead: https://deepchat.dev/docs/styles#style"));
            }
        },
        {
            key: "handleResponseProperty",
            value: function handleResponseProperty(e) {
                return console.error("The {result: ....} response object type is deprecated since version 1.3.0."), console.error("Please change to using the new response object: https://deepchat.dev/docs/connect#Response"), e.result;
            }
        },
        {
            key: "processHistory",
            value: function processHistory(e) {
                var t = e.initialMessages;
                if (t) return console.error("The initialMessages property is deprecated since version 2.0.0."), console.error("Please change to using the history property instead: https://deepchat.dev/docs/messages/#history"), t;
            }
        },
        {
            key: "processHistoryFile",
            value: function processHistoryFile(e) {
                var t = e.file;
                t && (console.error("The file property in MessageContent is deprecated since version 1.3.17."), console.error("Please change to using the files array property: https://deepchat.dev/docs/messages/#MessageContent"), e.files = [
                    t
                ]);
            }
        },
        {
            key: "processValidateInput",
            value: function processValidateInput(e) {
                var t = e.validateMessageBeforeSending;
                if (t) return console.error("The validateMessageBeforeSending property is deprecated since version 1.3.24."), console.error("Please change to using validateInput: https://deepchat.dev/docs/interceptors#validateInput"), t;
            }
        },
        {
            key: "processSubmitUserMessage",
            value: function processSubmitUserMessage(e) {
                return console.error("The submitUserMessage(text: string) argument string type is deprecated since version 1.4.4."), console.error("Please change to using the new argument type: https://deepchat.dev/docs/methods#submitUserMessage"), {
                    text: e
                };
            }
        },
        {
            key: "flagHTMLUpdateClass",
            value: function flagHTMLUpdateClass(e) {
                var t;
                (t = e.children[0]) != null && t.classList.contains("deep-chat-update-message") && (console.error('The "deep-chat-update-message" html class is deprecated since version 1.4.4.'), console.error("Please change to using {..., overwrite: true} object: https://deepchat.dev/docs/connect#Response"));
            }
        },
        {
            key: "processConnect",
            value: function processConnect(e) {
                var t = e;
                t.request && (t.connect ? Object.assign(t.connect, t.request) : t.connect = t.request, console.error("The request property is deprecated since version 2.0.0."), console.error("Please see the connect object: https://deepchat.dev/docs/connect#connect-1"));
            }
        },
        {
            key: "checkForStream",
            value: function checkForStream(e) {
                var t = e.stream;
                if (t) return console.error("The stream property has been moved to the connect object in version 2.0.0."), console.error("Please see the connect object: https://deepchat.dev/docs/connect#connect-1"), t;
            }
        },
        {
            key: "fireOnNewMessage",
            value: function fireOnNewMessage(e, t) {
                var s;
                var i = e;
                i.onNewMessage && (console.error("The onNewMessage event has been deprecated since version 2.0.0."), console.error("Please see the onMessage event: https://deepchat.dev/docs/events#onMessage"), (s = i.onNewMessage) == null || s.call(i, t)), e.dispatchEvent(new CustomEvent("new-message", {
                    detail: t
                }));
            }
        },
        {
            key: "processFileConfigConnect",
            value: function processFileConfigConnect(e) {
                var t = e;
                t.request && (console.error("The request property in file configuration is deprecated since version 2.0.0."), console.error("Please use the connect property instead: https://deepchat.dev/docs/files"), t.connect || (t.connect = t.request));
            }
        },
        {
            key: "processMessageStyles",
            value: function processMessageStyles(e) {
                if (!e) return;
                var t = structuredClone(e), i = t.loading;
                return i && (i.outerContainer || i.innerContainer || i.bubble || i.media) && (console.error("The loading message styles are defined using LoadingMessageStyles interface since version 2.1.0."), console.error("Check it out here: https://deepchat.dev/docs/messages/styles#LoadingMessageStyles"), t.loading = {
                    message: {
                        styles: i
                    }
                }), t;
            }
        },
        {
            key: "processDemo",
            value: function processDemo(e) {
                return typeof e == "boolean" || e.displayLoadingBubble && (console.error("The demo displayLoadingBubble property is deprecated since version 2.1.0."), console.error("Please use displayLoading instead: https://deepchat.dev/docs/demo#demo"), e.displayLoading = {
                    message: !0
                }), e;
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$et = /*#__PURE__*/ function() {
    function et() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, et);
    }
    return $8e4453fb4fc895c8$var$_createClass(et, null, [
        {
            key: "mouseUp",
            value: function mouseUp(e, t) {
                $8e4453fb4fc895c8$var$R.unsetAllCSSMouseStates(e, t), Object.assign(e.style, t["default"]), Object.assign(e.style, t.hover);
            }
        },
        {
            key: "mouseDown",
            value: function mouseDown(e, t) {
                Object.assign(e.style, t.click);
            }
        },
        {
            key: "mouseLeave",
            value: function mouseLeave(e, t) {
                $8e4453fb4fc895c8$var$R.unsetAllCSSMouseStates(e, t), Object.assign(e.style, t["default"]);
            }
        },
        {
            key: "mouseEnter",
            value: function mouseEnter(e, t) {
                Object.assign(e.style, t.hover);
            }
        },
        {
            key: "add",
            value: function add(e, t) {
                e.addEventListener("mouseenter", et.mouseEnter.bind(this, e, t)), e.addEventListener("mouseleave", et.mouseLeave.bind(this, e, t)), e.addEventListener("mousedown", et.mouseDown.bind(this, e, t)), e.addEventListener("mouseup", et.mouseUp.bind(this, e, t));
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Un = "deep-chat-temporary-message", $8e4453fb4fc895c8$var$jn = "deep-chat-suggestion-button", $8e4453fb4fc895c8$var$hs = {
    "deep-chat-button": {
        styles: {
            "default": {
                backgroundColor: "white",
                padding: "5px",
                paddingLeft: "7px",
                paddingRight: "7px",
                border: "1px solid #c2c2c2",
                borderRadius: "6px",
                cursor: "pointer"
            },
            hover: {
                backgroundColor: "#fafafa"
            },
            click: {
                backgroundColor: "#f1f1f1"
            }
        }
    }
}, $8e4453fb4fc895c8$var$zs = Object.keys($8e4453fb4fc895c8$var$hs);
var $8e4453fb4fc895c8$var$Ne = /*#__PURE__*/ function() {
    function Ne() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ne);
    }
    return $8e4453fb4fc895c8$var$_createClass(Ne, null, [
        {
            key: "applySuggestionEvent",
            value: function applySuggestionEvent(e, t) {
                setTimeout(function() {
                    t.addEventListener("click", function() {
                        var i, s;
                        (s = e.submitUserMessage) == null || s.call(e, {
                            text: ((i = t.textContent) == null ? void 0 : i.trim()) || ""
                        });
                    });
                });
            }
        },
        {
            key: "isElementTemporary",
            value: function isElementTemporary(e) {
                var t;
                return e ? (t = e.bubbleElement.children[0]) == null ? void 0 : t.classList.contains($8e4453fb4fc895c8$var$Un) : !1;
            }
        },
        {
            key: "doesElementContainDeepChatClass",
            value: function doesElementContainDeepChatClass(e) {
                return $8e4453fb4fc895c8$var$zs.find(function(t) {
                    return e.classList.contains(t);
                });
            }
        },
        {
            key: "applyEvents",
            value: function applyEvents(e, t) {
                var i = $8e4453fb4fc895c8$var$hs[t].events;
                Object.keys(i || []).forEach(function(s) {
                    e.addEventListener(s, i == null ? void 0 : i[s]);
                });
            }
        },
        {
            key: "getProcessedStyles",
            value: function getProcessedStyles(e, t, i) {
                var s = Array.from(t.classList).reduce(function(a, l) {
                    var d;
                    var c = (d = e[l]) == null ? void 0 : d.styles;
                    return c && e[l].styles && a.push(c), a;
                }, []), r = $8e4453fb4fc895c8$var$hs[i].styles;
                if (r) {
                    var a = JSON.parse(JSON.stringify(r));
                    a["default"] && $8e4453fb4fc895c8$var$R.overwriteDefaultWithAlreadyApplied(a, t), s.unshift(a);
                }
                var o = $8e4453fb4fc895c8$var$R.mergeStatefulStyles(s);
                return $8e4453fb4fc895c8$var$R.processStateful(o, {}, {});
            }
        },
        {
            key: "applyDeepChatUtilities",
            value: function applyDeepChatUtilities(e, t, i) {
                $8e4453fb4fc895c8$var$zs.forEach(function(r) {
                    var o = i.getElementsByClassName(r);
                    Array.from(o || []).forEach(function(a) {
                        var l = Ne.getProcessedStyles(t, a, r);
                        $8e4453fb4fc895c8$var$ne.applyStylesToElement(a, l), Ne.applyEvents(a, r);
                    });
                });
                var s = i.getElementsByClassName($8e4453fb4fc895c8$var$jn);
                Array.from(s).forEach(function(r) {
                    return Ne.applySuggestionEvent(e, r);
                });
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$ne = /*#__PURE__*/ function() {
    function ne() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, ne);
    }
    return $8e4453fb4fc895c8$var$_createClass(ne, null, [
        {
            key: "applyStylesToElement",
            value: function applyStylesToElement(e, t) {
                var i = $8e4453fb4fc895c8$var$R.processStateful(t, {}, {});
                $8e4453fb4fc895c8$var$et.add(e, i), Object.assign(e.style, i["default"]);
            }
        },
        {
            key: "applyEventsToElement",
            value: function applyEventsToElement(e, t) {
                Object.keys(t).forEach(function(i) {
                    var s = t[i];
                    s && e.addEventListener(i, s);
                });
            }
        },
        {
            key: "applyClassUtilitiesToElement",
            value: function applyClassUtilitiesToElement(e, t) {
                var i = t.events, s = t.styles;
                i && ne.applyEventsToElement(e, i), s && !$8e4453fb4fc895c8$var$Ne.doesElementContainDeepChatClass(e) && ne.applyStylesToElement(e, s);
            }
        },
        {
            key: "applyCustomClassUtilities",
            value: function applyCustomClassUtilities(e, t) {
                Object.keys(e).forEach(function(i) {
                    var s = t.getElementsByClassName(i);
                    Array.from(s).forEach(function(r) {
                        e[i] && ne.applyClassUtilitiesToElement(r, e[i]);
                    });
                });
            }
        },
        {
            key: "apply",
            value: function apply(e, t) {
                $8e4453fb4fc895c8$var$Ne.applyDeepChatUtilities(e, e.htmlClassUtilities, t), ne.applyCustomClassUtilities(e.htmlClassUtilities, t);
            }
        },
        {
            key: "traverseNodes",
            value: function traverseNodes(e, t) {
                e.nodeType === Node.ELEMENT_NODE && t.push(e.outerHTML), e.childNodes.forEach(function(i) {
                    ne.traverseNodes(i, t);
                });
            }
        },
        {
            key: "splitHTML",
            value: function splitHTML(e) {
                var i = new DOMParser().parseFromString(e, "text/html"), s = [];
                return i.body.childNodes.forEach(function(r) {
                    ne.traverseNodes(r, s);
                }), s;
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$ke = /*#__PURE__*/ function() {
    function ke() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, ke);
    }
    return $8e4453fb4fc895c8$var$_createClass(ke, null, [
        {
            key: "addElement",
            value: function addElement(e, t) {
                e.elementRef.appendChild(t), e.elementRef.scrollTop = e.elementRef.scrollHeight;
            }
        },
        {
            key: "createElements",
            value: function createElements(e, t, i, s) {
                var r = e.createMessageElementsOnOrientation("", i, s);
                return r.bubbleElement.classList.add(ke.HTML_BUBBLE_CLASS), r.bubbleElement.innerHTML = t, r;
            }
        },
        {
            key: "overwriteElements",
            value: function overwriteElements(e, t, i) {
                i.bubbleElement.innerHTML = t, $8e4453fb4fc895c8$var$ne.apply(e, i.outerContainer), $8e4453fb4fc895c8$var$Y.flagHTMLUpdateClass(i.bubbleElement);
            }
        },
        {
            key: "overwrite",
            value: function overwrite(e, t, i, s) {
                var r = e.messageToElements, o = $8e4453fb4fc895c8$var$b.overwriteMessage(r, s, t, i, "html", ke.HTML_BUBBLE_CLASS);
                return o && ke.overwriteElements(e, t, o), o;
            }
        },
        {
            key: "create",
            value: function create(e, t, i) {
                var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                var o;
                var r = ke.createElements(e, t, i, s);
                return $8e4453fb4fc895c8$var$b.fillEmptyMessageElement(r.bubbleElement, t), $8e4453fb4fc895c8$var$ne.apply(e, r.outerContainer), $8e4453fb4fc895c8$var$Y.flagHTMLUpdateClass(r.bubbleElement), e.applyCustomStyles(r, i, !1, (o = e.messageStyles) == null ? void 0 : o.html), r;
            }
        },
        {
            key: "add",
            value: function add(e, t, i, s, r) {
                var o = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
                if (r != null && r.status) {
                    var l = this.overwrite(e, t, i, s);
                    if (l) return l;
                    r.status = !1;
                }
                var a = ke.create(e, t, i, o);
                return o || ke.addElement(e, a.outerContainer), a;
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$ke.HTML_BUBBLE_CLASS = "html-message";
var $8e4453fb4fc895c8$var$xe = $8e4453fb4fc895c8$var$ke;
var $8e4453fb4fc895c8$var$li;
function $8e4453fb4fc895c8$var$En(n) {
    return $8e4453fb4fc895c8$var$li = $8e4453fb4fc895c8$var$li || document.createElement("textarea"), $8e4453fb4fc895c8$var$li.innerHTML = "&" + n + ";", $8e4453fb4fc895c8$var$li.value;
}
var $8e4453fb4fc895c8$var$Hn = Object.prototype.hasOwnProperty;
function $8e4453fb4fc895c8$var$qn(n, e) {
    return n ? $8e4453fb4fc895c8$var$Hn.call(n, e) : !1;
}
function $8e4453fb4fc895c8$var$Sn(n) {
    var e = [].slice.call(arguments, 1);
    return e.forEach(function(t) {
        if (t) {
            if ($8e4453fb4fc895c8$var$_typeof(t) != "object") throw new TypeError(t + "must be object");
            Object.keys(t).forEach(function(i) {
                n[i] = t[i];
            });
        }
    }), n;
}
var $8e4453fb4fc895c8$var$zn = /\\([\\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
function $8e4453fb4fc895c8$var$zt(n) {
    return n.indexOf("\\") < 0 ? n : n.replace($8e4453fb4fc895c8$var$zn, "$1");
}
function $8e4453fb4fc895c8$var$xn(n) {
    return !(n >= 55296 && n <= 57343 || n >= 64976 && n <= 65007 || (n & 65535) === 65535 || (n & 65535) === 65534 || n >= 0 && n <= 8 || n === 11 || n >= 14 && n <= 31 || n >= 127 && n <= 159 || n > 1114111);
}
function $8e4453fb4fc895c8$var$us(n) {
    if (n > 65535) {
        n -= 65536;
        var e = 55296 + (n >> 10), t = 56320 + (n & 1023);
        return String.fromCharCode(e, t);
    }
    return String.fromCharCode(n);
}
var $8e4453fb4fc895c8$var$Gn = /&([a-z#][a-z0-9]{1,31});/gi, $8e4453fb4fc895c8$var$Vn = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;
function $8e4453fb4fc895c8$var$$n(n, e) {
    var t = 0, i = $8e4453fb4fc895c8$var$En(e);
    return e !== i ? i : e.charCodeAt(0) === 35 && $8e4453fb4fc895c8$var$Vn.test(e) && (t = e[1].toLowerCase() === "x" ? parseInt(e.slice(2), 16) : parseInt(e.slice(1), 10), $8e4453fb4fc895c8$var$xn(t)) ? $8e4453fb4fc895c8$var$us(t) : n;
}
function $8e4453fb4fc895c8$var$nt(n) {
    return n.indexOf("&") < 0 ? n : n.replace($8e4453fb4fc895c8$var$Gn, $8e4453fb4fc895c8$var$$n);
}
var $8e4453fb4fc895c8$var$Wn = /[&<>"]/, $8e4453fb4fc895c8$var$Kn = /[&<>"]/g, $8e4453fb4fc895c8$var$Jn = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
};
function $8e4453fb4fc895c8$var$Zn(n) {
    return $8e4453fb4fc895c8$var$Jn[n];
}
function $8e4453fb4fc895c8$var$Z(n) {
    return $8e4453fb4fc895c8$var$Wn.test(n) ? n.replace($8e4453fb4fc895c8$var$Kn, $8e4453fb4fc895c8$var$Zn) : n;
}
var $8e4453fb4fc895c8$var$g = {};
$8e4453fb4fc895c8$var$g.blockquote_open = function() {
    return "<blockquote>\n";
};
$8e4453fb4fc895c8$var$g.blockquote_close = function(n, e) {
    return "</blockquote>" + $8e4453fb4fc895c8$var$ot(n, e);
};
$8e4453fb4fc895c8$var$g.code = function(n, e) {
    return n[e].block ? "<pre><code>" + $8e4453fb4fc895c8$var$Z(n[e].content) + "</code></pre>" + $8e4453fb4fc895c8$var$ot(n, e) : "<code>" + $8e4453fb4fc895c8$var$Z(n[e].content) + "</code>";
};
$8e4453fb4fc895c8$var$g.fence = function(n, e, t, i, s) {
    var r = n[e], o = "", a = t.langPrefix, l = "", c, d, h;
    if (r.params) {
        if (c = r.params.split(/\s+/g), d = c.join(" "), $8e4453fb4fc895c8$var$qn(s.rules.fence_custom, c[0])) return s.rules.fence_custom[c[0]](n, e, t, i, s);
        l = $8e4453fb4fc895c8$var$Z($8e4453fb4fc895c8$var$nt($8e4453fb4fc895c8$var$zt(d))), o = ' class="' + a + l + '"';
    }
    return t.highlight ? h = t.highlight.apply(t.highlight, [
        r.content
    ].concat(c)) || $8e4453fb4fc895c8$var$Z(r.content) : h = $8e4453fb4fc895c8$var$Z(r.content), "<pre><code" + o + ">" + h + "</code></pre>" + $8e4453fb4fc895c8$var$ot(n, e);
};
$8e4453fb4fc895c8$var$g.fence_custom = {};
$8e4453fb4fc895c8$var$g.heading_open = function(n, e) {
    return "<h" + n[e].hLevel + ">";
};
$8e4453fb4fc895c8$var$g.heading_close = function(n, e) {
    return "</h" + n[e].hLevel + ">\n";
};
$8e4453fb4fc895c8$var$g.hr = function(n, e, t) {
    return (t.xhtmlOut ? "<hr />" : "<hr>") + $8e4453fb4fc895c8$var$ot(n, e);
};
$8e4453fb4fc895c8$var$g.bullet_list_open = function() {
    return "<ul>\n";
};
$8e4453fb4fc895c8$var$g.bullet_list_close = function(n, e) {
    return "</ul>" + $8e4453fb4fc895c8$var$ot(n, e);
};
$8e4453fb4fc895c8$var$g.list_item_open = function() {
    return "<li>";
};
$8e4453fb4fc895c8$var$g.list_item_close = function() {
    return "</li>\n";
};
$8e4453fb4fc895c8$var$g.ordered_list_open = function(n, e) {
    var t = n[e], i = t.order > 1 ? ' start="' + t.order + '"' : "";
    return "<ol" + i + ">\n";
};
$8e4453fb4fc895c8$var$g.ordered_list_close = function(n, e) {
    return "</ol>" + $8e4453fb4fc895c8$var$ot(n, e);
};
$8e4453fb4fc895c8$var$g.paragraph_open = function(n, e) {
    return n[e].tight ? "" : "<p>";
};
$8e4453fb4fc895c8$var$g.paragraph_close = function(n, e) {
    var t = !(n[e].tight && e && n[e - 1].type === "inline" && !n[e - 1].content);
    return (n[e].tight ? "" : "</p>") + (t ? $8e4453fb4fc895c8$var$ot(n, e) : "");
};
$8e4453fb4fc895c8$var$g.link_open = function(n, e, t) {
    var i = n[e].title ? ' title="' + $8e4453fb4fc895c8$var$Z($8e4453fb4fc895c8$var$nt(n[e].title)) + '"' : "", s = t.linkTarget ? ' target="' + t.linkTarget + '"' : "";
    return '<a href="' + $8e4453fb4fc895c8$var$Z(n[e].href) + '"' + i + s + ">";
};
$8e4453fb4fc895c8$var$g.link_close = function() {
    return "</a>";
};
$8e4453fb4fc895c8$var$g.image = function(n, e, t) {
    var i = ' src="' + $8e4453fb4fc895c8$var$Z(n[e].src) + '"', s = n[e].title ? ' title="' + $8e4453fb4fc895c8$var$Z($8e4453fb4fc895c8$var$nt(n[e].title)) + '"' : "", r = ' alt="' + (n[e].alt ? $8e4453fb4fc895c8$var$Z($8e4453fb4fc895c8$var$nt($8e4453fb4fc895c8$var$zt(n[e].alt))) : "") + '"', o = t.xhtmlOut ? " /" : "";
    return "<img" + i + r + s + o + ">";
};
$8e4453fb4fc895c8$var$g.table_open = function() {
    return "<table>\n";
};
$8e4453fb4fc895c8$var$g.table_close = function() {
    return "</table>\n";
};
$8e4453fb4fc895c8$var$g.thead_open = function() {
    return "<thead>\n";
};
$8e4453fb4fc895c8$var$g.thead_close = function() {
    return "</thead>\n";
};
$8e4453fb4fc895c8$var$g.tbody_open = function() {
    return "<tbody>\n";
};
$8e4453fb4fc895c8$var$g.tbody_close = function() {
    return "</tbody>\n";
};
$8e4453fb4fc895c8$var$g.tr_open = function() {
    return "<tr>";
};
$8e4453fb4fc895c8$var$g.tr_close = function() {
    return "</tr>\n";
};
$8e4453fb4fc895c8$var$g.th_open = function(n, e) {
    var t = n[e];
    return "<th" + (t.align ? ' style="text-align:' + t.align + '"' : "") + ">";
};
$8e4453fb4fc895c8$var$g.th_close = function() {
    return "</th>";
};
$8e4453fb4fc895c8$var$g.td_open = function(n, e) {
    var t = n[e];
    return "<td" + (t.align ? ' style="text-align:' + t.align + '"' : "") + ">";
};
$8e4453fb4fc895c8$var$g.td_close = function() {
    return "</td>";
};
$8e4453fb4fc895c8$var$g.strong_open = function() {
    return "<strong>";
};
$8e4453fb4fc895c8$var$g.strong_close = function() {
    return "</strong>";
};
$8e4453fb4fc895c8$var$g.em_open = function() {
    return "<em>";
};
$8e4453fb4fc895c8$var$g.em_close = function() {
    return "</em>";
};
$8e4453fb4fc895c8$var$g.del_open = function() {
    return "<del>";
};
$8e4453fb4fc895c8$var$g.del_close = function() {
    return "</del>";
};
$8e4453fb4fc895c8$var$g.ins_open = function() {
    return "<ins>";
};
$8e4453fb4fc895c8$var$g.ins_close = function() {
    return "</ins>";
};
$8e4453fb4fc895c8$var$g.mark_open = function() {
    return "<mark>";
};
$8e4453fb4fc895c8$var$g.mark_close = function() {
    return "</mark>";
};
$8e4453fb4fc895c8$var$g.sub = function(n, e) {
    return "<sub>" + $8e4453fb4fc895c8$var$Z(n[e].content) + "</sub>";
};
$8e4453fb4fc895c8$var$g.sup = function(n, e) {
    return "<sup>" + $8e4453fb4fc895c8$var$Z(n[e].content) + "</sup>";
};
$8e4453fb4fc895c8$var$g.hardbreak = function(n, e, t) {
    return t.xhtmlOut ? "<br />\n" : "<br>\n";
};
$8e4453fb4fc895c8$var$g.softbreak = function(n, e, t) {
    return t.breaks ? t.xhtmlOut ? "<br />\n" : "<br>\n" : "\n";
};
$8e4453fb4fc895c8$var$g.text = function(n, e) {
    return $8e4453fb4fc895c8$var$Z(n[e].content);
};
$8e4453fb4fc895c8$var$g.htmlblock = function(n, e) {
    return n[e].content;
};
$8e4453fb4fc895c8$var$g.htmltag = function(n, e) {
    return n[e].content;
};
$8e4453fb4fc895c8$var$g.abbr_open = function(n, e) {
    return '<abbr title="' + $8e4453fb4fc895c8$var$Z($8e4453fb4fc895c8$var$nt(n[e].title)) + '">';
};
$8e4453fb4fc895c8$var$g.abbr_close = function() {
    return "</abbr>";
};
$8e4453fb4fc895c8$var$g.footnote_ref = function(n, e) {
    var t = Number(n[e].id + 1).toString(), i = "fnref" + t;
    return n[e].subId > 0 && (i += ":" + n[e].subId), '<sup class="footnote-ref"><a href="#fn' + t + '" id="' + i + '">[' + t + "]</a></sup>";
};
$8e4453fb4fc895c8$var$g.footnote_block_open = function(n, e, t) {
    var i = t.xhtmlOut ? '<hr class="footnotes-sep" />\n' : '<hr class="footnotes-sep">\n';
    return i + '<section class="footnotes">\n<ol class="footnotes-list">\n';
};
$8e4453fb4fc895c8$var$g.footnote_block_close = function() {
    return "</ol>\n</section>\n";
};
$8e4453fb4fc895c8$var$g.footnote_open = function(n, e) {
    var t = Number(n[e].id + 1).toString();
    return '<li id="fn' + t + '"  class="footnote-item">';
};
$8e4453fb4fc895c8$var$g.footnote_close = function() {
    return "</li>\n";
};
$8e4453fb4fc895c8$var$g.footnote_anchor = function(n, e) {
    var t = Number(n[e].id + 1).toString(), i = "fnref" + t;
    return n[e].subId > 0 && (i += ":" + n[e].subId), ' <a href="#' + i + '" class="footnote-backref">\u21A9</a>';
};
$8e4453fb4fc895c8$var$g.dl_open = function() {
    return "<dl>\n";
};
$8e4453fb4fc895c8$var$g.dt_open = function() {
    return "<dt>";
};
$8e4453fb4fc895c8$var$g.dd_open = function() {
    return "<dd>";
};
$8e4453fb4fc895c8$var$g.dl_close = function() {
    return "</dl>\n";
};
$8e4453fb4fc895c8$var$g.dt_close = function() {
    return "</dt>\n";
};
$8e4453fb4fc895c8$var$g.dd_close = function() {
    return "</dd>\n";
};
function $8e4453fb4fc895c8$var$_n(n, e) {
    return ++e >= n.length - 2 ? e : n[e].type === "paragraph_open" && n[e].tight && n[e + 1].type === "inline" && n[e + 1].content.length === 0 && n[e + 2].type === "paragraph_close" && n[e + 2].tight ? $8e4453fb4fc895c8$var$_n(n, e + 2) : e;
}
var $8e4453fb4fc895c8$var$ot = $8e4453fb4fc895c8$var$g.getBreak = function(e, t) {
    return t = $8e4453fb4fc895c8$var$_n(e, t), t < e.length && e[t].type === "list_item_close" ? "" : "\n";
};
function $8e4453fb4fc895c8$var$Ms() {
    this.rules = $8e4453fb4fc895c8$var$Sn({}, $8e4453fb4fc895c8$var$g), this.getBreak = $8e4453fb4fc895c8$var$g.getBreak;
}
$8e4453fb4fc895c8$var$Ms.prototype.renderInline = function(n, e, t) {
    for(var i = this.rules, s = n.length, r = 0, o = ""; s--;)o += i[n[r].type](n, r++, e, t, this);
    return o;
};
$8e4453fb4fc895c8$var$Ms.prototype.render = function(n, e, t) {
    for(var i = this.rules, s = n.length, r = -1, o = ""; ++r < s;)n[r].type === "inline" ? o += this.renderInline(n[r].children, e, t) : o += i[n[r].type](n, r, e, t, this);
    return o;
};
function $8e4453fb4fc895c8$var$oe() {
    this.__rules__ = [], this.__cache__ = null;
}
$8e4453fb4fc895c8$var$oe.prototype.__find__ = function(n) {
    for(var e = this.__rules__.length, t = -1; e--;)if (this.__rules__[++t].name === n) return t;
    return -1;
};
$8e4453fb4fc895c8$var$oe.prototype.__compile__ = function() {
    var n = this, e = [
        ""
    ];
    n.__rules__.forEach(function(t) {
        t.enabled && t.alt.forEach(function(i) {
            e.indexOf(i) < 0 && e.push(i);
        });
    }), n.__cache__ = {}, e.forEach(function(t) {
        n.__cache__[t] = [], n.__rules__.forEach(function(i) {
            i.enabled && (t && i.alt.indexOf(t) < 0 || n.__cache__[t].push(i.fn));
        });
    });
};
$8e4453fb4fc895c8$var$oe.prototype.at = function(n, e, t) {
    var i = this.__find__(n), s = t || {};
    if (i === -1) throw new Error("Parser rule not found: " + n);
    this.__rules__[i].fn = e, this.__rules__[i].alt = s.alt || [], this.__cache__ = null;
};
$8e4453fb4fc895c8$var$oe.prototype.before = function(n, e, t, i) {
    var s = this.__find__(n), r = i || {};
    if (s === -1) throw new Error("Parser rule not found: " + n);
    this.__rules__.splice(s, 0, {
        name: e,
        enabled: !0,
        fn: t,
        alt: r.alt || []
    }), this.__cache__ = null;
};
$8e4453fb4fc895c8$var$oe.prototype.after = function(n, e, t, i) {
    var s = this.__find__(n), r = i || {};
    if (s === -1) throw new Error("Parser rule not found: " + n);
    this.__rules__.splice(s + 1, 0, {
        name: e,
        enabled: !0,
        fn: t,
        alt: r.alt || []
    }), this.__cache__ = null;
};
$8e4453fb4fc895c8$var$oe.prototype.push = function(n, e, t) {
    var i = t || {};
    this.__rules__.push({
        name: n,
        enabled: !0,
        fn: e,
        alt: i.alt || []
    }), this.__cache__ = null;
};
$8e4453fb4fc895c8$var$oe.prototype.enable = function(n, e) {
    n = Array.isArray(n) ? n : [
        n
    ], e && this.__rules__.forEach(function(t) {
        t.enabled = !1;
    }), n.forEach(function(t) {
        var i = this.__find__(t);
        if (i < 0) throw new Error("Rules manager: invalid rule name " + t);
        this.__rules__[i].enabled = !0;
    }, this), this.__cache__ = null;
};
$8e4453fb4fc895c8$var$oe.prototype.disable = function(n) {
    n = Array.isArray(n) ? n : [
        n
    ], n.forEach(function(e) {
        var t = this.__find__(e);
        if (t < 0) throw new Error("Rules manager: invalid rule name " + e);
        this.__rules__[t].enabled = !1;
    }, this), this.__cache__ = null;
};
$8e4453fb4fc895c8$var$oe.prototype.getRules = function(n) {
    return this.__cache__ === null && this.__compile__(), this.__cache__[n] || [];
};
function $8e4453fb4fc895c8$var$Xn(n) {
    n.inlineMode ? n.tokens.push({
        type: "inline",
        content: n.src.replace(/\n/g, " ").trim(),
        level: 0,
        lines: [
            0,
            1
        ],
        children: []
    }) : n.block.parse(n.src, n.options, n.env, n.tokens);
}
function $8e4453fb4fc895c8$var$at(n, e, t, i, s) {
    this.src = n, this.env = i, this.options = t, this.parser = e, this.tokens = s, this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = [], this.isInLabel = !1, this.linkLevel = 0, this.linkContent = "", this.labelUnmatchedScopes = 0;
}
$8e4453fb4fc895c8$var$at.prototype.pushPending = function() {
    this.tokens.push({
        type: "text",
        content: this.pending,
        level: this.pendingLevel
    }), this.pending = "";
};
$8e4453fb4fc895c8$var$at.prototype.push = function(n) {
    this.pending && this.pushPending(), this.tokens.push(n), this.pendingLevel = this.level;
};
$8e4453fb4fc895c8$var$at.prototype.cacheSet = function(n, e) {
    for(var t = this.cache.length; t <= n; t++)this.cache.push(0);
    this.cache[n] = e;
};
$8e4453fb4fc895c8$var$at.prototype.cacheGet = function(n) {
    return n < this.cache.length ? this.cache[n] : 0;
};
function $8e4453fb4fc895c8$var$Gt(n, e) {
    var t, i, s, r = -1, o = n.posMax, a = n.pos, l = n.isInLabel;
    if (n.isInLabel) return -1;
    if (n.labelUnmatchedScopes) return n.labelUnmatchedScopes--, -1;
    for(n.pos = e + 1, n.isInLabel = !0, t = 1; n.pos < o;){
        if (s = n.src.charCodeAt(n.pos), s === 91) t++;
        else if (s === 93 && (t--, t === 0)) {
            i = !0;
            break;
        }
        n.parser.skipToken(n);
    }
    return i ? (r = n.pos, n.labelUnmatchedScopes = 0) : n.labelUnmatchedScopes = t - 1, n.pos = a, n.isInLabel = l, r;
}
function $8e4453fb4fc895c8$var$Yn(n, e, t, i) {
    var s, r, o, a, l, c;
    if (n.charCodeAt(0) !== 42 || n.charCodeAt(1) !== 91 || n.indexOf("]:") === -1 || (s = new $8e4453fb4fc895c8$var$at(n, e, t, i, []), r = $8e4453fb4fc895c8$var$Gt(s, 1), r < 0 || n.charCodeAt(r + 1) !== 58)) return -1;
    for(a = s.posMax, o = r + 2; o < a && s.src.charCodeAt(o) !== 10; o++);
    return l = n.slice(2, r), c = n.slice(r + 2, o).trim(), c.length === 0 ? -1 : (i.abbreviations || (i.abbreviations = {}), $8e4453fb4fc895c8$var$_typeof(i.abbreviations[":" + l]) > "u" && (i.abbreviations[":" + l] = c), o);
}
function $8e4453fb4fc895c8$var$Qn(n) {
    var e = n.tokens, t, i, s, r;
    if (!n.inlineMode) {
        for(t = 1, i = e.length - 1; t < i; t++)if (e[t - 1].type === "paragraph_open" && e[t].type === "inline" && e[t + 1].type === "paragraph_close") {
            for(s = e[t].content; s.length && (r = $8e4453fb4fc895c8$var$Yn(s, n.inline, n.options, n.env), !(r < 0));)s = s.slice(r).trim();
            e[t].content = s, s.length || (e[t - 1].tight = !0, e[t + 1].tight = !0);
        }
    }
}
function $8e4453fb4fc895c8$var$fs(n) {
    var e = $8e4453fb4fc895c8$var$nt(n);
    try {
        e = decodeURI(e);
    } catch (_unused3) {}
    return encodeURI(e);
}
function $8e4453fb4fc895c8$var$wn(n, e) {
    var t, i, s, r = e, o = n.posMax;
    if (n.src.charCodeAt(e) === 60) {
        for(e++; e < o;){
            if (t = n.src.charCodeAt(e), t === 10) return !1;
            if (t === 62) return s = $8e4453fb4fc895c8$var$fs($8e4453fb4fc895c8$var$zt(n.src.slice(r + 1, e))), n.parser.validateLink(s) ? (n.pos = e + 1, n.linkContent = s, !0) : !1;
            if (t === 92 && e + 1 < o) {
                e += 2;
                continue;
            }
            e++;
        }
        return !1;
    }
    for(i = 0; e < o && (t = n.src.charCodeAt(e), !(t === 32 || t < 32 || t === 127));){
        if (t === 92 && e + 1 < o) {
            e += 2;
            continue;
        }
        if (t === 40 && (i++, i > 1) || t === 41 && (i--, i < 0)) break;
        e++;
    }
    return r === e || (s = $8e4453fb4fc895c8$var$zt(n.src.slice(r, e)), !n.parser.validateLink(s)) ? !1 : (n.linkContent = s, n.pos = e, !0);
}
function $8e4453fb4fc895c8$var$An(n, e) {
    var t, i = e, s = n.posMax, r = n.src.charCodeAt(e);
    if (r !== 34 && r !== 39 && r !== 40) return !1;
    for(e++, r === 40 && (r = 41); e < s;){
        if (t = n.src.charCodeAt(e), t === r) return n.pos = e + 1, n.linkContent = $8e4453fb4fc895c8$var$zt(n.src.slice(i + 1, e)), !0;
        if (t === 92 && e + 1 < s) {
            e += 2;
            continue;
        }
        e++;
    }
    return !1;
}
function $8e4453fb4fc895c8$var$Cn(n) {
    return n.trim().replace(/\s+/g, " ").toUpperCase();
}
function $8e4453fb4fc895c8$var$er(n, e, t, i) {
    var s, r, o, a, l, c, d, h, f;
    if (n.charCodeAt(0) !== 91 || n.indexOf("]:") === -1 || (s = new $8e4453fb4fc895c8$var$at(n, e, t, i, []), r = $8e4453fb4fc895c8$var$Gt(s, 0), r < 0 || n.charCodeAt(r + 1) !== 58)) return -1;
    for(a = s.posMax, o = r + 2; o < a && (l = s.src.charCodeAt(o), !(l !== 32 && l !== 10)); o++);
    if (!$8e4453fb4fc895c8$var$wn(s, o)) return -1;
    for(d = s.linkContent, o = s.pos, c = o, o = o + 1; o < a && (l = s.src.charCodeAt(o), !(l !== 32 && l !== 10)); o++);
    for(o < a && c !== o && $8e4453fb4fc895c8$var$An(s, o) ? (h = s.linkContent, o = s.pos) : (h = "", o = c); o < a && s.src.charCodeAt(o) === 32;)o++;
    return o < a && s.src.charCodeAt(o) !== 10 ? -1 : (f = $8e4453fb4fc895c8$var$Cn(n.slice(1, r)), $8e4453fb4fc895c8$var$_typeof(i.references[f]) > "u" && (i.references[f] = {
        title: h,
        href: d
    }), o);
}
function $8e4453fb4fc895c8$var$tr(n) {
    var e = n.tokens, t, i, s, r;
    if (n.env.references = n.env.references || {}, !n.inlineMode) {
        for(t = 1, i = e.length - 1; t < i; t++)if (e[t].type === "inline" && e[t - 1].type === "paragraph_open" && e[t + 1].type === "paragraph_close") {
            for(s = e[t].content; s.length && (r = $8e4453fb4fc895c8$var$er(s, n.inline, n.options, n.env), !(r < 0));)s = s.slice(r).trim();
            e[t].content = s, s.length || (e[t - 1].tight = !0, e[t + 1].tight = !0);
        }
    }
}
function $8e4453fb4fc895c8$var$ir(n) {
    var e = n.tokens, t, i, s;
    for(i = 0, s = e.length; i < s; i++)t = e[i], t.type === "inline" && n.inline.parse(t.content, n.options, n.env, t.children);
}
function $8e4453fb4fc895c8$var$sr(n) {
    var e, t, i, s, r, o, a, l, c, d = 0, h = !1, f = {};
    if (n.env.footnotes && (n.tokens = n.tokens.filter(function(u) {
        return u.type === "footnote_reference_open" ? (h = !0, l = [], c = u.label, !1) : u.type === "footnote_reference_close" ? (h = !1, f[":" + c] = l, !1) : (h && l.push(u), !h);
    }), !!n.env.footnotes.list)) {
        for(o = n.env.footnotes.list, n.tokens.push({
            type: "footnote_block_open",
            level: d++
        }), e = 0, t = o.length; e < t; e++){
            for(n.tokens.push({
                type: "footnote_open",
                id: e,
                level: d++
            }), o[e].tokens ? (a = [], a.push({
                type: "paragraph_open",
                tight: !1,
                level: d++
            }), a.push({
                type: "inline",
                content: "",
                level: d,
                children: o[e].tokens
            }), a.push({
                type: "paragraph_close",
                tight: !1,
                level: --d
            })) : o[e].label && (a = f[":" + o[e].label]), n.tokens = n.tokens.concat(a), n.tokens[n.tokens.length - 1].type === "paragraph_close" ? r = n.tokens.pop() : r = null, s = o[e].count > 0 ? o[e].count : 1, i = 0; i < s; i++)n.tokens.push({
                type: "footnote_anchor",
                id: e,
                subId: i,
                level: d
            });
            r && n.tokens.push(r), n.tokens.push({
                type: "footnote_close",
                level: --d
            });
        }
        n.tokens.push({
            type: "footnote_block_close",
            level: --d
        });
    }
}
var $8e4453fb4fc895c8$var$Gs = " \n()[]'\".,!?-";
function $8e4453fb4fc895c8$var$ts(n) {
    return n.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1");
}
function $8e4453fb4fc895c8$var$nr(n) {
    var e, t, i, s, r, o, a, l, c, d, h, f, u = n.tokens;
    if (n.env.abbreviations) {
        for(n.env.abbrRegExp || (f = "(^|[" + $8e4453fb4fc895c8$var$Gs.split("").map($8e4453fb4fc895c8$var$ts).join("") + "])(" + Object.keys(n.env.abbreviations).map(function(m) {
            return m.substr(1);
        }).sort(function(m, p) {
            return p.length - m.length;
        }).map($8e4453fb4fc895c8$var$ts).join("|") + ")($|[" + $8e4453fb4fc895c8$var$Gs.split("").map($8e4453fb4fc895c8$var$ts).join("") + "])", n.env.abbrRegExp = new RegExp(f, "g")), d = n.env.abbrRegExp, t = 0, i = u.length; t < i; t++)if (u[t].type === "inline") {
            for(s = u[t].children, e = s.length - 1; e >= 0; e--)if (r = s[e], r.type === "text") {
                for(l = 0, o = r.content, d.lastIndex = 0, c = r.level, a = []; h = d.exec(o);)d.lastIndex > l && a.push({
                    type: "text",
                    content: o.slice(l, h.index + h[1].length),
                    level: c
                }), a.push({
                    type: "abbr_open",
                    title: n.env.abbreviations[":" + h[2]],
                    level: c++
                }), a.push({
                    type: "text",
                    content: h[2],
                    level: c
                }), a.push({
                    type: "abbr_close",
                    level: --c
                }), l = d.lastIndex - h[3].length;
                a.length && (l < o.length && a.push({
                    type: "text",
                    content: o.slice(l),
                    level: c
                }), u[t].children = s = [].concat(s.slice(0, e), a, s.slice(e + 1)));
            }
        }
    }
}
var $8e4453fb4fc895c8$var$rr = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, $8e4453fb4fc895c8$var$or = /\((c|tm|r|p)\)/ig, $8e4453fb4fc895c8$var$ar = {
    c: "\xa9",
    r: "\xae",
    p: "\xa7",
    tm: "\u2122"
};
function $8e4453fb4fc895c8$var$lr(n) {
    return n.indexOf("(") < 0 ? n : n.replace($8e4453fb4fc895c8$var$or, function(e, t) {
        return $8e4453fb4fc895c8$var$ar[t.toLowerCase()];
    });
}
function $8e4453fb4fc895c8$var$cr(n) {
    var e, t, i, s, r;
    if (n.options.typographer) {
        for(r = n.tokens.length - 1; r >= 0; r--)if (n.tokens[r].type === "inline") for(s = n.tokens[r].children, e = s.length - 1; e >= 0; e--)t = s[e], t.type === "text" && (i = t.content, i = $8e4453fb4fc895c8$var$lr(i), $8e4453fb4fc895c8$var$rr.test(i) && (i = i.replace(/\+-/g, "\xb1").replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---([^-]|$)/mg, "$1\u2014$2").replace(/(^|\s)--(\s|$)/mg, "$1\u2013$2").replace(/(^|[^-\s])--([^-\s]|$)/mg, "$1\u2013$2")), t.content = i);
    }
}
var $8e4453fb4fc895c8$var$dr = /['"]/, $8e4453fb4fc895c8$var$Vs = /['"]/g, $8e4453fb4fc895c8$var$hr = /[-\s()\[\]]/, $8e4453fb4fc895c8$var$$s = "\u2019";
function $8e4453fb4fc895c8$var$Ws(n, e) {
    return e < 0 || e >= n.length ? !1 : !$8e4453fb4fc895c8$var$hr.test(n[e]);
}
function $8e4453fb4fc895c8$var$ut(n, e, t) {
    return n.substr(0, e) + t + n.substr(e + 1);
}
function $8e4453fb4fc895c8$var$ur(n) {
    var e, t, i, s, r, o, a, l, c, d, h, f, u, m, p, v, y;
    if (n.options.typographer) {
        for(y = [], p = n.tokens.length - 1; p >= 0; p--)if (n.tokens[p].type === "inline") {
            for(v = n.tokens[p].children, y.length = 0, e = 0; e < v.length; e++)if (t = v[e], !(t.type !== "text" || $8e4453fb4fc895c8$var$dr.test(t.text))) {
                for(a = v[e].level, u = y.length - 1; u >= 0 && !(y[u].level <= a); u--);
                y.length = u + 1, i = t.content, r = 0, o = i.length;
                e: for(; r < o && ($8e4453fb4fc895c8$var$Vs.lastIndex = r, s = $8e4453fb4fc895c8$var$Vs.exec(i), !!s);){
                    if (l = !$8e4453fb4fc895c8$var$Ws(i, s.index - 1), r = s.index + 1, m = s[0] === "'", c = !$8e4453fb4fc895c8$var$Ws(i, r), !c && !l) {
                        m && (t.content = $8e4453fb4fc895c8$var$ut(t.content, s.index, $8e4453fb4fc895c8$var$$s));
                        continue;
                    }
                    if (h = !c, f = !l, f) {
                        for(u = y.length - 1; u >= 0 && (d = y[u], !(y[u].level < a)); u--)if (d.single === m && y[u].level === a) {
                            d = y[u], m ? (v[d.token].content = $8e4453fb4fc895c8$var$ut(v[d.token].content, d.pos, n.options.quotes[2]), t.content = $8e4453fb4fc895c8$var$ut(t.content, s.index, n.options.quotes[3])) : (v[d.token].content = $8e4453fb4fc895c8$var$ut(v[d.token].content, d.pos, n.options.quotes[0]), t.content = $8e4453fb4fc895c8$var$ut(t.content, s.index, n.options.quotes[1])), y.length = u;
                            continue e;
                        }
                    }
                    h ? y.push({
                        token: e,
                        pos: s.index,
                        single: m,
                        level: a
                    }) : f && m && (t.content = $8e4453fb4fc895c8$var$ut(t.content, s.index, $8e4453fb4fc895c8$var$$s));
                }
            }
        }
    }
}
var $8e4453fb4fc895c8$var$is = [
    [
        "block",
        $8e4453fb4fc895c8$var$Xn
    ],
    [
        "abbr",
        $8e4453fb4fc895c8$var$Qn
    ],
    [
        "references",
        $8e4453fb4fc895c8$var$tr
    ],
    [
        "inline",
        $8e4453fb4fc895c8$var$ir
    ],
    [
        "footnote_tail",
        $8e4453fb4fc895c8$var$sr
    ],
    [
        "abbr2",
        $8e4453fb4fc895c8$var$nr
    ],
    [
        "replacements",
        $8e4453fb4fc895c8$var$cr
    ],
    [
        "smartquotes",
        $8e4453fb4fc895c8$var$ur
    ]
];
function $8e4453fb4fc895c8$var$Tn() {
    this.options = {}, this.ruler = new $8e4453fb4fc895c8$var$oe();
    for(var n = 0; n < $8e4453fb4fc895c8$var$is.length; n++)this.ruler.push($8e4453fb4fc895c8$var$is[n][0], $8e4453fb4fc895c8$var$is[n][1]);
}
$8e4453fb4fc895c8$var$Tn.prototype.process = function(n) {
    var e, t, i;
    for(i = this.ruler.getRules(""), e = 0, t = i.length; e < t; e++)i[e](n);
};
function $8e4453fb4fc895c8$var$lt(n, e, t, i, s) {
    var r, o, a, l, c, d, h;
    for(this.src = n, this.parser = e, this.options = t, this.env = i, this.tokens = s, this.bMarks = [], this.eMarks = [], this.tShift = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.parentType = "root", this.ddIndent = -1, this.level = 0, this.result = "", o = this.src, d = 0, h = !1, a = l = d = 0, c = o.length; l < c; l++){
        if (r = o.charCodeAt(l), !h) {
            if (r === 32) {
                d++;
                continue;
            } else h = !0;
        }
        (r === 10 || l === c - 1) && (r !== 10 && l++, this.bMarks.push(a), this.eMarks.push(l), this.tShift.push(d), h = !1, d = 0, a = l + 1);
    }
    this.bMarks.push(o.length), this.eMarks.push(o.length), this.tShift.push(0), this.lineMax = this.bMarks.length - 1;
}
$8e4453fb4fc895c8$var$lt.prototype.isEmpty = function(e) {
    return this.bMarks[e] + this.tShift[e] >= this.eMarks[e];
};
$8e4453fb4fc895c8$var$lt.prototype.skipEmptyLines = function(e) {
    for(var t = this.lineMax; e < t && !(this.bMarks[e] + this.tShift[e] < this.eMarks[e]); e++);
    return e;
};
$8e4453fb4fc895c8$var$lt.prototype.skipSpaces = function(e) {
    for(var t = this.src.length; e < t && this.src.charCodeAt(e) === 32; e++);
    return e;
};
$8e4453fb4fc895c8$var$lt.prototype.skipChars = function(e, t) {
    for(var i = this.src.length; e < i && this.src.charCodeAt(e) === t; e++);
    return e;
};
$8e4453fb4fc895c8$var$lt.prototype.skipCharsBack = function(e, t, i) {
    if (e <= i) return e;
    for(; e > i;)if (t !== this.src.charCodeAt(--e)) return e + 1;
    return e;
};
$8e4453fb4fc895c8$var$lt.prototype.getLines = function(e, t, i, s) {
    var r, o, a, l, c, d = e;
    if (e >= t) return "";
    if (d + 1 === t) return o = this.bMarks[d] + Math.min(this.tShift[d], i), a = s ? this.eMarks[d] + 1 : this.eMarks[d], this.src.slice(o, a);
    for(l = new Array(t - e), r = 0; d < t; d++, r++)c = this.tShift[d], c > i && (c = i), c < 0 && (c = 0), o = this.bMarks[d] + c, d + 1 < t || s ? a = this.eMarks[d] + 1 : a = this.eMarks[d], l[r] = this.src.slice(o, a);
    return l.join("");
};
function $8e4453fb4fc895c8$var$fr(n, e, t) {
    var i, s;
    if (n.tShift[e] - n.blkIndent < 4) return !1;
    for(s = i = e + 1; i < t;){
        if (n.isEmpty(i)) {
            i++;
            continue;
        }
        if (n.tShift[i] - n.blkIndent >= 4) {
            i++, s = i;
            continue;
        }
        break;
    }
    return n.line = i, n.tokens.push({
        type: "code",
        content: n.getLines(e, s, 4 + n.blkIndent, !0),
        block: !0,
        lines: [
            e,
            n.line
        ],
        level: n.level
    }), !0;
}
function $8e4453fb4fc895c8$var$pr(n, e, t, i) {
    var s, r, o, a, l, c = !1, d = n.bMarks[e] + n.tShift[e], h = n.eMarks[e];
    if (d + 3 > h || (s = n.src.charCodeAt(d), s !== 126 && s !== 96) || (l = d, d = n.skipChars(d, s), r = d - l, r < 3) || (o = n.src.slice(d, h).trim(), o.indexOf("`") >= 0)) return !1;
    if (i) return !0;
    for(a = e; a++, !(a >= t || (d = l = n.bMarks[a] + n.tShift[a], h = n.eMarks[a], d < h && n.tShift[a] < n.blkIndent));)if (n.src.charCodeAt(d) === s && !(n.tShift[a] - n.blkIndent >= 4) && (d = n.skipChars(d, s), !(d - l < r) && (d = n.skipSpaces(d), !(d < h)))) {
        c = !0;
        break;
    }
    return r = n.tShift[e], n.line = a + (c ? 1 : 0), n.tokens.push({
        type: "fence",
        params: o,
        content: n.getLines(e + 1, a, r, !0),
        lines: [
            e,
            n.line
        ],
        level: n.level
    }), !0;
}
function $8e4453fb4fc895c8$var$mr(n, e, t, i) {
    var s, r, o, a, l, c, d, h, f, u, m, p = n.bMarks[e] + n.tShift[e], v = n.eMarks[e];
    if (p > v || n.src.charCodeAt(p++) !== 62 || n.level >= n.options.maxNesting) return !1;
    if (i) return !0;
    for(n.src.charCodeAt(p) === 32 && p++, l = n.blkIndent, n.blkIndent = 0, a = [
        n.bMarks[e]
    ], n.bMarks[e] = p, p = p < v ? n.skipSpaces(p) : p, r = p >= v, o = [
        n.tShift[e]
    ], n.tShift[e] = p - n.bMarks[e], h = n.parser.ruler.getRules("blockquote"), s = e + 1; s < t && (p = n.bMarks[s] + n.tShift[s], v = n.eMarks[s], !(p >= v)); s++){
        if (n.src.charCodeAt(p++) === 62) {
            n.src.charCodeAt(p) === 32 && p++, a.push(n.bMarks[s]), n.bMarks[s] = p, p = p < v ? n.skipSpaces(p) : p, r = p >= v, o.push(n.tShift[s]), n.tShift[s] = p - n.bMarks[s];
            continue;
        }
        if (r) break;
        for(m = !1, f = 0, u = h.length; f < u; f++)if (h[f](n, s, t, !0)) {
            m = !0;
            break;
        }
        if (m) break;
        a.push(n.bMarks[s]), o.push(n.tShift[s]), n.tShift[s] = -1337;
    }
    for(c = n.parentType, n.parentType = "blockquote", n.tokens.push({
        type: "blockquote_open",
        lines: d = [
            e,
            0
        ],
        level: n.level++
    }), n.parser.tokenize(n, e, s), n.tokens.push({
        type: "blockquote_close",
        level: --n.level
    }), n.parentType = c, d[1] = n.line, f = 0; f < o.length; f++)n.bMarks[f + e] = a[f], n.tShift[f + e] = o[f];
    return n.blkIndent = l, !0;
}
function $8e4453fb4fc895c8$var$gr(n, e, t, i) {
    var s, r, o, a = n.bMarks[e], l = n.eMarks[e];
    if (a += n.tShift[e], a > l || (s = n.src.charCodeAt(a++), s !== 42 && s !== 45 && s !== 95)) return !1;
    for(r = 1; a < l;){
        if (o = n.src.charCodeAt(a++), o !== s && o !== 32) return !1;
        o === s && r++;
    }
    return r < 3 ? !1 : (i || (n.line = e + 1, n.tokens.push({
        type: "hr",
        lines: [
            e,
            n.line
        ],
        level: n.level
    })), !0);
}
function $8e4453fb4fc895c8$var$Ks(n, e) {
    var t, i, s;
    return i = n.bMarks[e] + n.tShift[e], s = n.eMarks[e], i >= s || (t = n.src.charCodeAt(i++), t !== 42 && t !== 45 && t !== 43) || i < s && n.src.charCodeAt(i) !== 32 ? -1 : i;
}
function $8e4453fb4fc895c8$var$Js(n, e) {
    var t, i = n.bMarks[e] + n.tShift[e], s = n.eMarks[e];
    if (i + 1 >= s || (t = n.src.charCodeAt(i++), t < 48 || t > 57)) return -1;
    for(;;){
        if (i >= s) return -1;
        if (t = n.src.charCodeAt(i++), !(t >= 48 && t <= 57)) {
            if (t === 41 || t === 46) break;
            return -1;
        }
    }
    return i < s && n.src.charCodeAt(i) !== 32 ? -1 : i;
}
function $8e4453fb4fc895c8$var$br(n, e) {
    var t, i, s = n.level + 2;
    for(t = e + 2, i = n.tokens.length - 2; t < i; t++)n.tokens[t].level === s && n.tokens[t].type === "paragraph_open" && (n.tokens[t + 2].tight = !0, n.tokens[t].tight = !0, t += 2);
}
function $8e4453fb4fc895c8$var$vr(n, e, t, i) {
    var s, r, o, a, l, c, d, h, f, u, m, p, v, y, P, V, Ue, L, Q = !0, ee, F, Ge, Rt;
    if ((h = $8e4453fb4fc895c8$var$Js(n, e)) >= 0) v = !0;
    else if ((h = $8e4453fb4fc895c8$var$Ks(n, e)) >= 0) v = !1;
    else return !1;
    if (n.level >= n.options.maxNesting) return !1;
    if (p = n.src.charCodeAt(h - 1), i) return !0;
    for(P = n.tokens.length, v ? (d = n.bMarks[e] + n.tShift[e], m = Number(n.src.substr(d, h - d - 1)), n.tokens.push({
        type: "ordered_list_open",
        order: m,
        lines: Ue = [
            e,
            0
        ],
        level: n.level++
    })) : n.tokens.push({
        type: "bullet_list_open",
        lines: Ue = [
            e,
            0
        ],
        level: n.level++
    }), s = e, V = !1, ee = n.parser.ruler.getRules("list"); s < t && (y = n.skipSpaces(h), f = n.eMarks[s], y >= f ? u = 1 : u = y - h, u > 4 && (u = 1), u < 1 && (u = 1), r = h - n.bMarks[s] + u, n.tokens.push({
        type: "list_item_open",
        lines: L = [
            e,
            0
        ],
        level: n.level++
    }), a = n.blkIndent, l = n.tight, o = n.tShift[e], c = n.parentType, n.tShift[e] = y - n.bMarks[e], n.blkIndent = r, n.tight = !0, n.parentType = "list", n.parser.tokenize(n, e, t, !0), (!n.tight || V) && (Q = !1), V = n.line - e > 1 && n.isEmpty(n.line - 1), n.blkIndent = a, n.tShift[e] = o, n.tight = l, n.parentType = c, n.tokens.push({
        type: "list_item_close",
        level: --n.level
    }), s = e = n.line, L[1] = s, y = n.bMarks[e], !(s >= t || n.isEmpty(s) || n.tShift[s] < n.blkIndent));){
        for(Rt = !1, F = 0, Ge = ee.length; F < Ge; F++)if (ee[F](n, s, t, !0)) {
            Rt = !0;
            break;
        }
        if (Rt) break;
        if (v) {
            if (h = $8e4453fb4fc895c8$var$Js(n, s), h < 0) break;
        } else if (h = $8e4453fb4fc895c8$var$Ks(n, s), h < 0) break;
        if (p !== n.src.charCodeAt(h - 1)) break;
    }
    return n.tokens.push({
        type: v ? "ordered_list_close" : "bullet_list_close",
        level: --n.level
    }), Ue[1] = s, n.line = s, Q && $8e4453fb4fc895c8$var$br(n, P), !0;
}
function $8e4453fb4fc895c8$var$yr(n, e, t, i) {
    var s, r, o, a, l, c = n.bMarks[e] + n.tShift[e], d = n.eMarks[e];
    if (c + 4 > d || n.src.charCodeAt(c) !== 91 || n.src.charCodeAt(c + 1) !== 94 || n.level >= n.options.maxNesting) return !1;
    for(a = c + 2; a < d; a++){
        if (n.src.charCodeAt(a) === 32) return !1;
        if (n.src.charCodeAt(a) === 93) break;
    }
    return a === c + 2 || a + 1 >= d || n.src.charCodeAt(++a) !== 58 ? !1 : (i || (a++, n.env.footnotes || (n.env.footnotes = {}), n.env.footnotes.refs || (n.env.footnotes.refs = {}), l = n.src.slice(c + 2, a - 2), n.env.footnotes.refs[":" + l] = -1, n.tokens.push({
        type: "footnote_reference_open",
        label: l,
        level: n.level++
    }), s = n.bMarks[e], r = n.tShift[e], o = n.parentType, n.tShift[e] = n.skipSpaces(a) - a, n.bMarks[e] = a, n.blkIndent += 4, n.parentType = "footnote", n.tShift[e] < n.blkIndent && (n.tShift[e] += n.blkIndent, n.bMarks[e] -= n.blkIndent), n.parser.tokenize(n, e, t, !0), n.parentType = o, n.blkIndent -= 4, n.tShift[e] = r, n.bMarks[e] = s, n.tokens.push({
        type: "footnote_reference_close",
        level: --n.level
    })), !0);
}
function $8e4453fb4fc895c8$var$Er(n, e, t, i) {
    var s, r, o, a = n.bMarks[e] + n.tShift[e], l = n.eMarks[e];
    if (a >= l || (s = n.src.charCodeAt(a), s !== 35 || a >= l)) return !1;
    for(r = 1, s = n.src.charCodeAt(++a); s === 35 && a < l && r <= 6;)r++, s = n.src.charCodeAt(++a);
    return r > 6 || a < l && s !== 32 ? !1 : (i || (l = n.skipCharsBack(l, 32, a), o = n.skipCharsBack(l, 35, a), o > a && n.src.charCodeAt(o - 1) === 32 && (l = o), n.line = e + 1, n.tokens.push({
        type: "heading_open",
        hLevel: r,
        lines: [
            e,
            n.line
        ],
        level: n.level
    }), a < l && n.tokens.push({
        type: "inline",
        content: n.src.slice(a, l).trim(),
        level: n.level + 1,
        lines: [
            e,
            n.line
        ],
        children: []
    }), n.tokens.push({
        type: "heading_close",
        hLevel: r,
        level: n.level
    })), !0);
}
function $8e4453fb4fc895c8$var$Sr(n, e, t) {
    var i, s, r, o = e + 1;
    return o >= t || n.tShift[o] < n.blkIndent || n.tShift[o] - n.blkIndent > 3 || (s = n.bMarks[o] + n.tShift[o], r = n.eMarks[o], s >= r) || (i = n.src.charCodeAt(s), i !== 45 && i !== 61) || (s = n.skipChars(s, i), s = n.skipSpaces(s), s < r) ? !1 : (s = n.bMarks[e] + n.tShift[e], n.line = o + 1, n.tokens.push({
        type: "heading_open",
        hLevel: i === 61 ? 1 : 2,
        lines: [
            e,
            n.line
        ],
        level: n.level
    }), n.tokens.push({
        type: "inline",
        content: n.src.slice(s, n.eMarks[e]).trim(),
        level: n.level + 1,
        lines: [
            e,
            n.line - 1
        ],
        children: []
    }), n.tokens.push({
        type: "heading_close",
        hLevel: i === 61 ? 1 : 2,
        level: n.level
    }), !0);
}
var $8e4453fb4fc895c8$var$kn = {};
[
    "article",
    "aside",
    "button",
    "blockquote",
    "body",
    "canvas",
    "caption",
    "col",
    "colgroup",
    "dd",
    "div",
    "dl",
    "dt",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "iframe",
    "li",
    "map",
    "object",
    "ol",
    "output",
    "p",
    "pre",
    "progress",
    "script",
    "section",
    "style",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "tr",
    "thead",
    "ul",
    "video"
].forEach(function(n) {
    $8e4453fb4fc895c8$var$kn[n] = !0;
});
var $8e4453fb4fc895c8$var$xr = /^<([a-zA-Z]{1,15})[\s\/>]/, $8e4453fb4fc895c8$var$_r = /^<\/([a-zA-Z]{1,15})[\s>]/;
function $8e4453fb4fc895c8$var$wr(n) {
    var e = n | 32;
    return e >= 97 && e <= 122;
}
function $8e4453fb4fc895c8$var$Ar(n, e, t, i) {
    var s, r, o, a = n.bMarks[e], l = n.eMarks[e], c = n.tShift[e];
    if (a += c, !n.options.html || c > 3 || a + 2 >= l || n.src.charCodeAt(a) !== 60) return !1;
    if (s = n.src.charCodeAt(a + 1), s === 33 || s === 63) {
        if (i) return !0;
    } else if (s === 47 || $8e4453fb4fc895c8$var$wr(s)) {
        if (s === 47) {
            if (r = n.src.slice(a, l).match($8e4453fb4fc895c8$var$_r), !r) return !1;
        } else if (r = n.src.slice(a, l).match($8e4453fb4fc895c8$var$xr), !r) return !1;
        if ($8e4453fb4fc895c8$var$kn[r[1].toLowerCase()] !== !0) return !1;
        if (i) return !0;
    } else return !1;
    for(o = e + 1; o < n.lineMax && !n.isEmpty(o);)o++;
    return n.line = o, n.tokens.push({
        type: "htmlblock",
        level: n.level,
        lines: [
            e,
            n.line
        ],
        content: n.getLines(e, o, 0, !0)
    }), !0;
}
function $8e4453fb4fc895c8$var$ss(n, e) {
    var t = n.bMarks[e] + n.blkIndent, i = n.eMarks[e];
    return n.src.substr(t, i - t);
}
function $8e4453fb4fc895c8$var$Cr(n, e, t, i) {
    var s, r, o, a, l, c, d, h, f, u, m;
    if (e + 2 > t || (l = e + 1, n.tShift[l] < n.blkIndent) || (o = n.bMarks[l] + n.tShift[l], o >= n.eMarks[l]) || (s = n.src.charCodeAt(o), s !== 124 && s !== 45 && s !== 58) || (r = $8e4453fb4fc895c8$var$ss(n, e + 1), !/^[-:| ]+$/.test(r)) || (c = r.split("|"), c <= 2)) return !1;
    for(h = [], a = 0; a < c.length; a++){
        if (f = c[a].trim(), !f) {
            if (a === 0 || a === c.length - 1) continue;
            return !1;
        }
        if (!/^:?-+:?$/.test(f)) return !1;
        f.charCodeAt(f.length - 1) === 58 ? h.push(f.charCodeAt(0) === 58 ? "center" : "right") : f.charCodeAt(0) === 58 ? h.push("left") : h.push("");
    }
    if (r = $8e4453fb4fc895c8$var$ss(n, e).trim(), r.indexOf("|") === -1 || (c = r.replace(/^\||\|$/g, "").split("|"), h.length !== c.length)) return !1;
    if (i) return !0;
    for(n.tokens.push({
        type: "table_open",
        lines: u = [
            e,
            0
        ],
        level: n.level++
    }), n.tokens.push({
        type: "thead_open",
        lines: [
            e,
            e + 1
        ],
        level: n.level++
    }), n.tokens.push({
        type: "tr_open",
        lines: [
            e,
            e + 1
        ],
        level: n.level++
    }), a = 0; a < c.length; a++)n.tokens.push({
        type: "th_open",
        align: h[a],
        lines: [
            e,
            e + 1
        ],
        level: n.level++
    }), n.tokens.push({
        type: "inline",
        content: c[a].trim(),
        lines: [
            e,
            e + 1
        ],
        level: n.level,
        children: []
    }), n.tokens.push({
        type: "th_close",
        level: --n.level
    });
    for(n.tokens.push({
        type: "tr_close",
        level: --n.level
    }), n.tokens.push({
        type: "thead_close",
        level: --n.level
    }), n.tokens.push({
        type: "tbody_open",
        lines: m = [
            e + 2,
            0
        ],
        level: n.level++
    }), l = e + 2; l < t && !(n.tShift[l] < n.blkIndent || (r = $8e4453fb4fc895c8$var$ss(n, l).trim(), r.indexOf("|") === -1)); l++){
        for(c = r.replace(/^\||\|$/g, "").split("|"), n.tokens.push({
            type: "tr_open",
            level: n.level++
        }), a = 0; a < c.length; a++)n.tokens.push({
            type: "td_open",
            align: h[a],
            level: n.level++
        }), d = c[a].substring(c[a].charCodeAt(0) === 124 ? 1 : 0, c[a].charCodeAt(c[a].length - 1) === 124 ? c[a].length - 1 : c[a].length).trim(), n.tokens.push({
            type: "inline",
            content: d,
            level: n.level,
            children: []
        }), n.tokens.push({
            type: "td_close",
            level: --n.level
        });
        n.tokens.push({
            type: "tr_close",
            level: --n.level
        });
    }
    return n.tokens.push({
        type: "tbody_close",
        level: --n.level
    }), n.tokens.push({
        type: "table_close",
        level: --n.level
    }), u[1] = m[1] = l, n.line = l, !0;
}
function $8e4453fb4fc895c8$var$ci(n, e) {
    var t, i, s = n.bMarks[e] + n.tShift[e], r = n.eMarks[e];
    return s >= r || (i = n.src.charCodeAt(s++), i !== 126 && i !== 58) || (t = n.skipSpaces(s), s === t) || t >= r ? -1 : t;
}
function $8e4453fb4fc895c8$var$Tr(n, e) {
    var t, i, s = n.level + 2;
    for(t = e + 2, i = n.tokens.length - 2; t < i; t++)n.tokens[t].level === s && n.tokens[t].type === "paragraph_open" && (n.tokens[t + 2].tight = !0, n.tokens[t].tight = !0, t += 2);
}
function $8e4453fb4fc895c8$var$kr(n, e, t, i) {
    var s, r, o, a, l, c, d, h, f, u, m, p, v, y;
    if (i) return n.ddIndent < 0 ? !1 : $8e4453fb4fc895c8$var$ci(n, e) >= 0;
    if (d = e + 1, n.isEmpty(d) && ++d > t || n.tShift[d] < n.blkIndent || (s = $8e4453fb4fc895c8$var$ci(n, d), s < 0) || n.level >= n.options.maxNesting) return !1;
    c = n.tokens.length, n.tokens.push({
        type: "dl_open",
        lines: l = [
            e,
            0
        ],
        level: n.level++
    }), o = e, r = d;
    e: for(;;){
        for(y = !0, v = !1, n.tokens.push({
            type: "dt_open",
            lines: [
                o,
                o
            ],
            level: n.level++
        }), n.tokens.push({
            type: "inline",
            content: n.getLines(o, o + 1, n.blkIndent, !1).trim(),
            level: n.level + 1,
            lines: [
                o,
                o
            ],
            children: []
        }), n.tokens.push({
            type: "dt_close",
            level: --n.level
        });;){
            if (n.tokens.push({
                type: "dd_open",
                lines: a = [
                    d,
                    0
                ],
                level: n.level++
            }), p = n.tight, f = n.ddIndent, h = n.blkIndent, m = n.tShift[r], u = n.parentType, n.blkIndent = n.ddIndent = n.tShift[r] + 2, n.tShift[r] = s - n.bMarks[r], n.tight = !0, n.parentType = "deflist", n.parser.tokenize(n, r, t, !0), (!n.tight || v) && (y = !1), v = n.line - r > 1 && n.isEmpty(n.line - 1), n.tShift[r] = m, n.tight = p, n.parentType = u, n.blkIndent = h, n.ddIndent = f, n.tokens.push({
                type: "dd_close",
                level: --n.level
            }), a[1] = d = n.line, d >= t || n.tShift[d] < n.blkIndent) break e;
            if (s = $8e4453fb4fc895c8$var$ci(n, d), s < 0) break;
            r = d;
        }
        if (d >= t || (o = d, n.isEmpty(o)) || n.tShift[o] < n.blkIndent || (r = o + 1, r >= t) || (n.isEmpty(r) && r++, r >= t) || n.tShift[r] < n.blkIndent || (s = $8e4453fb4fc895c8$var$ci(n, r), s < 0)) break;
    }
    return n.tokens.push({
        type: "dl_close",
        level: --n.level
    }), l[1] = d, n.line = d, y && $8e4453fb4fc895c8$var$Tr(n, c), !0;
}
function $8e4453fb4fc895c8$var$Mr(n, e) {
    var t, i, s, r, o, a = e + 1, l;
    if (t = n.lineMax, a < t && !n.isEmpty(a)) {
        for(l = n.parser.ruler.getRules("paragraph"); a < t && !n.isEmpty(a); a++)if (!(n.tShift[a] - n.blkIndent > 3)) {
            for(s = !1, r = 0, o = l.length; r < o; r++)if (l[r](n, a, t, !0)) {
                s = !0;
                break;
            }
            if (s) break;
        }
    }
    return i = n.getLines(e, a, n.blkIndent, !1).trim(), n.line = a, i.length && (n.tokens.push({
        type: "paragraph_open",
        tight: !1,
        lines: [
            e,
            n.line
        ],
        level: n.level
    }), n.tokens.push({
        type: "inline",
        content: i,
        level: n.level + 1,
        lines: [
            e,
            n.line
        ],
        children: []
    }), n.tokens.push({
        type: "paragraph_close",
        tight: !1,
        level: n.level
    })), !0;
}
var $8e4453fb4fc895c8$var$di = [
    [
        "code",
        $8e4453fb4fc895c8$var$fr
    ],
    [
        "fences",
        $8e4453fb4fc895c8$var$pr,
        [
            "paragraph",
            "blockquote",
            "list"
        ]
    ],
    [
        "blockquote",
        $8e4453fb4fc895c8$var$mr,
        [
            "paragraph",
            "blockquote",
            "list"
        ]
    ],
    [
        "hr",
        $8e4453fb4fc895c8$var$gr,
        [
            "paragraph",
            "blockquote",
            "list"
        ]
    ],
    [
        "list",
        $8e4453fb4fc895c8$var$vr,
        [
            "paragraph",
            "blockquote"
        ]
    ],
    [
        "footnote",
        $8e4453fb4fc895c8$var$yr,
        [
            "paragraph"
        ]
    ],
    [
        "heading",
        $8e4453fb4fc895c8$var$Er,
        [
            "paragraph",
            "blockquote"
        ]
    ],
    [
        "lheading",
        $8e4453fb4fc895c8$var$Sr
    ],
    [
        "htmlblock",
        $8e4453fb4fc895c8$var$Ar,
        [
            "paragraph",
            "blockquote"
        ]
    ],
    [
        "table",
        $8e4453fb4fc895c8$var$Cr,
        [
            "paragraph"
        ]
    ],
    [
        "deflist",
        $8e4453fb4fc895c8$var$kr,
        [
            "paragraph"
        ]
    ],
    [
        "paragraph",
        $8e4453fb4fc895c8$var$Mr
    ]
];
function $8e4453fb4fc895c8$var$Rs() {
    this.ruler = new $8e4453fb4fc895c8$var$oe();
    for(var n = 0; n < $8e4453fb4fc895c8$var$di.length; n++)this.ruler.push($8e4453fb4fc895c8$var$di[n][0], $8e4453fb4fc895c8$var$di[n][1], {
        alt: ($8e4453fb4fc895c8$var$di[n][2] || []).slice()
    });
}
$8e4453fb4fc895c8$var$Rs.prototype.tokenize = function(n, e, t) {
    for(var i = this.ruler.getRules(""), s = i.length, r = e, o = !1, a, l; r < t && (n.line = r = n.skipEmptyLines(r), !(r >= t || n.tShift[r] < n.blkIndent));){
        for(l = 0; l < s && (a = i[l](n, r, t, !1), !a); l++);
        if (n.tight = !o, n.isEmpty(n.line - 1) && (o = !0), r = n.line, r < t && n.isEmpty(r)) {
            if (o = !0, r++, r < t && n.parentType === "list" && n.isEmpty(r)) break;
            n.line = r;
        }
    }
};
var $8e4453fb4fc895c8$var$Rr = /[\n\t]/g, $8e4453fb4fc895c8$var$Ir = /\r[\n\u0085]|[\u2424\u2028\u0085]/g, $8e4453fb4fc895c8$var$Lr = /\u00a0/g;
$8e4453fb4fc895c8$var$Rs.prototype.parse = function(n, e, t, i) {
    var s, r = 0, o = 0;
    if (!n) return [];
    n = n.replace($8e4453fb4fc895c8$var$Lr, " "), n = n.replace($8e4453fb4fc895c8$var$Ir, "\n"), n.indexOf("	") >= 0 && (n = n.replace($8e4453fb4fc895c8$var$Rr, function(a, l) {
        var c;
        return n.charCodeAt(l) === 10 ? (r = l + 1, o = 0, a) : (c = "    ".slice((l - r - o) % 4), o = l - r + 1, c);
    })), s = new $8e4453fb4fc895c8$var$lt(n, this, e, t, i), this.tokenize(s, s.line, s.lineMax);
};
function $8e4453fb4fc895c8$var$Pr(n) {
    switch(n){
        case 10:
        case 92:
        case 96:
        case 42:
        case 95:
        case 94:
        case 91:
        case 93:
        case 33:
        case 38:
        case 60:
        case 62:
        case 123:
        case 125:
        case 36:
        case 37:
        case 64:
        case 126:
        case 43:
        case 61:
        case 58:
            return !0;
        default:
            return !1;
    }
}
function $8e4453fb4fc895c8$var$Or(n, e) {
    for(var t = n.pos; t < n.posMax && !$8e4453fb4fc895c8$var$Pr(n.src.charCodeAt(t));)t++;
    return t === n.pos ? !1 : (e || (n.pending += n.src.slice(n.pos, t)), n.pos = t, !0);
}
function $8e4453fb4fc895c8$var$Nr(n, e) {
    var t, i, s = n.pos;
    if (n.src.charCodeAt(s) !== 10) return !1;
    if (t = n.pending.length - 1, i = n.posMax, !e) {
        if (t >= 0 && n.pending.charCodeAt(t) === 32) {
            if (t >= 1 && n.pending.charCodeAt(t - 1) === 32) {
                for(var r = t - 2; r >= 0; r--)if (n.pending.charCodeAt(r) !== 32) {
                    n.pending = n.pending.substring(0, r + 1);
                    break;
                }
                n.push({
                    type: "hardbreak",
                    level: n.level
                });
            } else n.pending = n.pending.slice(0, -1), n.push({
                type: "softbreak",
                level: n.level
            });
        } else n.push({
            type: "softbreak",
            level: n.level
        });
    }
    for(s++; s < i && n.src.charCodeAt(s) === 32;)s++;
    return n.pos = s, !0;
}
var $8e4453fb4fc895c8$var$Is = [];
for(var $8e4453fb4fc895c8$var$Zs = 0; $8e4453fb4fc895c8$var$Zs < 256; $8e4453fb4fc895c8$var$Zs++)$8e4453fb4fc895c8$var$Is.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(n) {
    $8e4453fb4fc895c8$var$Is[n.charCodeAt(0)] = 1;
});
function $8e4453fb4fc895c8$var$Dr(n, e) {
    var t, i = n.pos, s = n.posMax;
    if (n.src.charCodeAt(i) !== 92) return !1;
    if (i++, i < s) {
        if (t = n.src.charCodeAt(i), t < 256 && $8e4453fb4fc895c8$var$Is[t] !== 0) return e || (n.pending += n.src[i]), n.pos += 2, !0;
        if (t === 10) {
            for(e || n.push({
                type: "hardbreak",
                level: n.level
            }), i++; i < s && n.src.charCodeAt(i) === 32;)i++;
            return n.pos = i, !0;
        }
    }
    return e || (n.pending += "\\"), n.pos++, !0;
}
function $8e4453fb4fc895c8$var$Br(n, e) {
    var t, i, s, r, o, a = n.pos, l = n.src.charCodeAt(a);
    if (l !== 96) return !1;
    for(t = a, a++, i = n.posMax; a < i && n.src.charCodeAt(a) === 96;)a++;
    for(s = n.src.slice(t, a), r = o = a; (r = n.src.indexOf("`", o)) !== -1;){
        for(o = r + 1; o < i && n.src.charCodeAt(o) === 96;)o++;
        if (o - r === s.length) return e || n.push({
            type: "code",
            content: n.src.slice(a, r).replace(/[ \n]+/g, " ").trim(),
            block: !1,
            level: n.level
        }), n.pos = o, !0;
    }
    return e || (n.pending += s), n.pos += s.length, !0;
}
function $8e4453fb4fc895c8$var$Fr(n, e) {
    var t, i, s, r = n.posMax, o = n.pos, a, l;
    if (n.src.charCodeAt(o) !== 126 || e || o + 4 >= r || n.src.charCodeAt(o + 1) !== 126 || n.level >= n.options.maxNesting || (a = o > 0 ? n.src.charCodeAt(o - 1) : -1, l = n.src.charCodeAt(o + 2), a === 126) || l === 126 || l === 32 || l === 10) return !1;
    for(i = o + 2; i < r && n.src.charCodeAt(i) === 126;)i++;
    if (i > o + 3) return n.pos += i - o, e || (n.pending += n.src.slice(o, i)), !0;
    for(n.pos = o + 2, s = 1; n.pos + 1 < r;){
        if (n.src.charCodeAt(n.pos) === 126 && n.src.charCodeAt(n.pos + 1) === 126 && (a = n.src.charCodeAt(n.pos - 1), l = n.pos + 2 < r ? n.src.charCodeAt(n.pos + 2) : -1, l !== 126 && a !== 126 && (a !== 32 && a !== 10 ? s-- : l !== 32 && l !== 10 && s++, s <= 0))) {
            t = !0;
            break;
        }
        n.parser.skipToken(n);
    }
    return t ? (n.posMax = n.pos, n.pos = o + 2, e || (n.push({
        type: "del_open",
        level: n.level++
    }), n.parser.tokenize(n), n.push({
        type: "del_close",
        level: --n.level
    })), n.pos = n.posMax + 2, n.posMax = r, !0) : (n.pos = o, !1);
}
function $8e4453fb4fc895c8$var$Ur(n, e) {
    var t, i, s, r = n.posMax, o = n.pos, a, l;
    if (n.src.charCodeAt(o) !== 43 || e || o + 4 >= r || n.src.charCodeAt(o + 1) !== 43 || n.level >= n.options.maxNesting || (a = o > 0 ? n.src.charCodeAt(o - 1) : -1, l = n.src.charCodeAt(o + 2), a === 43) || l === 43 || l === 32 || l === 10) return !1;
    for(i = o + 2; i < r && n.src.charCodeAt(i) === 43;)i++;
    if (i !== o + 2) return n.pos += i - o, e || (n.pending += n.src.slice(o, i)), !0;
    for(n.pos = o + 2, s = 1; n.pos + 1 < r;){
        if (n.src.charCodeAt(n.pos) === 43 && n.src.charCodeAt(n.pos + 1) === 43 && (a = n.src.charCodeAt(n.pos - 1), l = n.pos + 2 < r ? n.src.charCodeAt(n.pos + 2) : -1, l !== 43 && a !== 43 && (a !== 32 && a !== 10 ? s-- : l !== 32 && l !== 10 && s++, s <= 0))) {
            t = !0;
            break;
        }
        n.parser.skipToken(n);
    }
    return t ? (n.posMax = n.pos, n.pos = o + 2, e || (n.push({
        type: "ins_open",
        level: n.level++
    }), n.parser.tokenize(n), n.push({
        type: "ins_close",
        level: --n.level
    })), n.pos = n.posMax + 2, n.posMax = r, !0) : (n.pos = o, !1);
}
function $8e4453fb4fc895c8$var$jr(n, e) {
    var t, i, s, r = n.posMax, o = n.pos, a, l;
    if (n.src.charCodeAt(o) !== 61 || e || o + 4 >= r || n.src.charCodeAt(o + 1) !== 61 || n.level >= n.options.maxNesting || (a = o > 0 ? n.src.charCodeAt(o - 1) : -1, l = n.src.charCodeAt(o + 2), a === 61) || l === 61 || l === 32 || l === 10) return !1;
    for(i = o + 2; i < r && n.src.charCodeAt(i) === 61;)i++;
    if (i !== o + 2) return n.pos += i - o, e || (n.pending += n.src.slice(o, i)), !0;
    for(n.pos = o + 2, s = 1; n.pos + 1 < r;){
        if (n.src.charCodeAt(n.pos) === 61 && n.src.charCodeAt(n.pos + 1) === 61 && (a = n.src.charCodeAt(n.pos - 1), l = n.pos + 2 < r ? n.src.charCodeAt(n.pos + 2) : -1, l !== 61 && a !== 61 && (a !== 32 && a !== 10 ? s-- : l !== 32 && l !== 10 && s++, s <= 0))) {
            t = !0;
            break;
        }
        n.parser.skipToken(n);
    }
    return t ? (n.posMax = n.pos, n.pos = o + 2, e || (n.push({
        type: "mark_open",
        level: n.level++
    }), n.parser.tokenize(n), n.push({
        type: "mark_close",
        level: --n.level
    })), n.pos = n.posMax + 2, n.posMax = r, !0) : (n.pos = o, !1);
}
function $8e4453fb4fc895c8$var$Xs(n) {
    return n >= 48 && n <= 57 || n >= 65 && n <= 90 || n >= 97 && n <= 122;
}
function $8e4453fb4fc895c8$var$Ys(n, e) {
    var t = e, i, s, r, o = !0, a = !0, l = n.posMax, c = n.src.charCodeAt(e);
    for(i = e > 0 ? n.src.charCodeAt(e - 1) : -1; t < l && n.src.charCodeAt(t) === c;)t++;
    return t >= l && (o = !1), r = t - e, r >= 4 ? o = a = !1 : (s = t < l ? n.src.charCodeAt(t) : -1, (s === 32 || s === 10) && (o = !1), (i === 32 || i === 10) && (a = !1), c === 95 && ($8e4453fb4fc895c8$var$Xs(i) && (o = !1), $8e4453fb4fc895c8$var$Xs(s) && (a = !1))), {
        can_open: o,
        can_close: a,
        delims: r
    };
}
function $8e4453fb4fc895c8$var$Hr(n, e) {
    var t, i, s, r, o, a, l, c = n.posMax, d = n.pos, h = n.src.charCodeAt(d);
    if (h !== 95 && h !== 42 || e) return !1;
    if (l = $8e4453fb4fc895c8$var$Ys(n, d), t = l.delims, !l.can_open) return n.pos += t, e || (n.pending += n.src.slice(d, n.pos)), !0;
    if (n.level >= n.options.maxNesting) return !1;
    for(n.pos = d + t, a = [
        t
    ]; n.pos < c;){
        if (n.src.charCodeAt(n.pos) === h) {
            if (l = $8e4453fb4fc895c8$var$Ys(n, n.pos), i = l.delims, l.can_close) {
                for(r = a.pop(), o = i; r !== o;){
                    if (o < r) {
                        a.push(r - o);
                        break;
                    }
                    if (o -= r, a.length === 0) break;
                    n.pos += r, r = a.pop();
                }
                if (a.length === 0) {
                    t = r, s = !0;
                    break;
                }
                n.pos += i;
                continue;
            }
            l.can_open && a.push(i), n.pos += i;
            continue;
        }
        n.parser.skipToken(n);
    }
    return s ? (n.posMax = n.pos, n.pos = d + t, e || ((t === 2 || t === 3) && n.push({
        type: "strong_open",
        level: n.level++
    }), (t === 1 || t === 3) && n.push({
        type: "em_open",
        level: n.level++
    }), n.parser.tokenize(n), (t === 1 || t === 3) && n.push({
        type: "em_close",
        level: --n.level
    }), (t === 2 || t === 3) && n.push({
        type: "strong_close",
        level: --n.level
    })), n.pos = n.posMax + t, n.posMax = c, !0) : (n.pos = d, !1);
}
var $8e4453fb4fc895c8$var$qr = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
function $8e4453fb4fc895c8$var$zr(n, e) {
    var t, i, s = n.posMax, r = n.pos;
    if (n.src.charCodeAt(r) !== 126 || e || r + 2 >= s || n.level >= n.options.maxNesting) return !1;
    for(n.pos = r + 1; n.pos < s;){
        if (n.src.charCodeAt(n.pos) === 126) {
            t = !0;
            break;
        }
        n.parser.skipToken(n);
    }
    return !t || r + 1 === n.pos || (i = n.src.slice(r + 1, n.pos), i.match(/(^|[^\\])(\\\\)*\s/)) ? (n.pos = r, !1) : (n.posMax = n.pos, n.pos = r + 1, e || n.push({
        type: "sub",
        level: n.level,
        content: i.replace($8e4453fb4fc895c8$var$qr, "$1")
    }), n.pos = n.posMax + 1, n.posMax = s, !0);
}
var $8e4453fb4fc895c8$var$Gr = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
function $8e4453fb4fc895c8$var$Vr(n, e) {
    var t, i, s = n.posMax, r = n.pos;
    if (n.src.charCodeAt(r) !== 94 || e || r + 2 >= s || n.level >= n.options.maxNesting) return !1;
    for(n.pos = r + 1; n.pos < s;){
        if (n.src.charCodeAt(n.pos) === 94) {
            t = !0;
            break;
        }
        n.parser.skipToken(n);
    }
    return !t || r + 1 === n.pos || (i = n.src.slice(r + 1, n.pos), i.match(/(^|[^\\])(\\\\)*\s/)) ? (n.pos = r, !1) : (n.posMax = n.pos, n.pos = r + 1, e || n.push({
        type: "sup",
        level: n.level,
        content: i.replace($8e4453fb4fc895c8$var$Gr, "$1")
    }), n.pos = n.posMax + 1, n.posMax = s, !0);
}
function $8e4453fb4fc895c8$var$$r(n, e) {
    var t, i, s, r, o, a, l, c, d = !1, h = n.pos, f = n.posMax, u = n.pos, m = n.src.charCodeAt(u);
    if (m === 33 && (d = !0, m = n.src.charCodeAt(++u)), m !== 91 || n.level >= n.options.maxNesting || (t = u + 1, i = $8e4453fb4fc895c8$var$Gt(n, u), i < 0)) return !1;
    if (a = i + 1, a < f && n.src.charCodeAt(a) === 40) {
        for(a++; a < f && (c = n.src.charCodeAt(a), !(c !== 32 && c !== 10)); a++);
        if (a >= f) return !1;
        for(u = a, $8e4453fb4fc895c8$var$wn(n, a) ? (r = n.linkContent, a = n.pos) : r = "", u = a; a < f && (c = n.src.charCodeAt(a), !(c !== 32 && c !== 10)); a++);
        if (a < f && u !== a && $8e4453fb4fc895c8$var$An(n, a)) for(o = n.linkContent, a = n.pos; a < f && (c = n.src.charCodeAt(a), !(c !== 32 && c !== 10)); a++);
        else o = "";
        if (a >= f || n.src.charCodeAt(a) !== 41) return n.pos = h, !1;
        a++;
    } else {
        if (n.linkLevel > 0) return !1;
        for(; a < f && (c = n.src.charCodeAt(a), !(c !== 32 && c !== 10)); a++);
        if (a < f && n.src.charCodeAt(a) === 91 && (u = a + 1, a = $8e4453fb4fc895c8$var$Gt(n, a), a >= 0 ? s = n.src.slice(u, a++) : a = u - 1), s || ($8e4453fb4fc895c8$var$_typeof(s) > "u" && (a = i + 1), s = n.src.slice(t, i)), l = n.env.references[$8e4453fb4fc895c8$var$Cn(s)], !l) return n.pos = h, !1;
        r = l.href, o = l.title;
    }
    return e || (n.pos = t, n.posMax = i, d ? n.push({
        type: "image",
        src: r,
        title: o,
        alt: n.src.substr(t, i - t),
        level: n.level
    }) : (n.push({
        type: "link_open",
        href: r,
        title: o,
        level: n.level++
    }), n.linkLevel++, n.parser.tokenize(n), n.linkLevel--, n.push({
        type: "link_close",
        level: --n.level
    }))), n.pos = a, n.posMax = f, !0;
}
function $8e4453fb4fc895c8$var$Wr(n, e) {
    var t, i, s, r, o = n.posMax, a = n.pos;
    return a + 2 >= o || n.src.charCodeAt(a) !== 94 || n.src.charCodeAt(a + 1) !== 91 || n.level >= n.options.maxNesting || (t = a + 2, i = $8e4453fb4fc895c8$var$Gt(n, a + 1), i < 0) ? !1 : (e || (n.env.footnotes || (n.env.footnotes = {}), n.env.footnotes.list || (n.env.footnotes.list = []), s = n.env.footnotes.list.length, n.pos = t, n.posMax = i, n.push({
        type: "footnote_ref",
        id: s,
        level: n.level
    }), n.linkLevel++, r = n.tokens.length, n.parser.tokenize(n), n.env.footnotes.list[s] = {
        tokens: n.tokens.splice(r)
    }, n.linkLevel--), n.pos = i + 1, n.posMax = o, !0);
}
function $8e4453fb4fc895c8$var$Kr(n, e) {
    var t, i, s, r, o = n.posMax, a = n.pos;
    if (a + 3 > o || !n.env.footnotes || !n.env.footnotes.refs || n.src.charCodeAt(a) !== 91 || n.src.charCodeAt(a + 1) !== 94 || n.level >= n.options.maxNesting) return !1;
    for(i = a + 2; i < o; i++){
        if (n.src.charCodeAt(i) === 32 || n.src.charCodeAt(i) === 10) return !1;
        if (n.src.charCodeAt(i) === 93) break;
    }
    return i === a + 2 || i >= o || (i++, t = n.src.slice(a + 2, i - 1), $8e4453fb4fc895c8$var$_typeof(n.env.footnotes.refs[":" + t]) > "u") ? !1 : (e || (n.env.footnotes.list || (n.env.footnotes.list = []), n.env.footnotes.refs[":" + t] < 0 ? (s = n.env.footnotes.list.length, n.env.footnotes.list[s] = {
        label: t,
        count: 0
    }, n.env.footnotes.refs[":" + t] = s) : s = n.env.footnotes.refs[":" + t], r = n.env.footnotes.list[s].count, n.env.footnotes.list[s].count++, n.push({
        type: "footnote_ref",
        id: s,
        subId: r,
        level: n.level
    })), n.pos = i, n.posMax = o, !0);
}
var $8e4453fb4fc895c8$var$Jr = [
    "coap",
    "doi",
    "javascript",
    "aaa",
    "aaas",
    "about",
    "acap",
    "cap",
    "cid",
    "crid",
    "data",
    "dav",
    "dict",
    "dns",
    "file",
    "ftp",
    "geo",
    "go",
    "gopher",
    "h323",
    "http",
    "https",
    "iax",
    "icap",
    "im",
    "imap",
    "info",
    "ipp",
    "iris",
    "iris.beep",
    "iris.xpc",
    "iris.xpcs",
    "iris.lwz",
    "ldap",
    "mailto",
    "mid",
    "msrp",
    "msrps",
    "mtqp",
    "mupdate",
    "news",
    "nfs",
    "ni",
    "nih",
    "nntp",
    "opaquelocktoken",
    "pop",
    "pres",
    "rtsp",
    "service",
    "session",
    "shttp",
    "sieve",
    "sip",
    "sips",
    "sms",
    "snmp",
    "soap.beep",
    "soap.beeps",
    "tag",
    "tel",
    "telnet",
    "tftp",
    "thismessage",
    "tn3270",
    "tip",
    "tv",
    "urn",
    "vemmi",
    "ws",
    "wss",
    "xcon",
    "xcon-userid",
    "xmlrpc.beep",
    "xmlrpc.beeps",
    "xmpp",
    "z39.50r",
    "z39.50s",
    "adiumxtra",
    "afp",
    "afs",
    "aim",
    "apt",
    "attachment",
    "aw",
    "beshare",
    "bitcoin",
    "bolo",
    "callto",
    "chrome",
    "chrome-extension",
    "com-eventbrite-attendee",
    "content",
    "cvs",
    "dlna-playsingle",
    "dlna-playcontainer",
    "dtn",
    "dvb",
    "ed2k",
    "facetime",
    "feed",
    "finger",
    "fish",
    "gg",
    "git",
    "gizmoproject",
    "gtalk",
    "hcp",
    "icon",
    "ipn",
    "irc",
    "irc6",
    "ircs",
    "itms",
    "jar",
    "jms",
    "keyparc",
    "lastfm",
    "ldaps",
    "magnet",
    "maps",
    "market",
    "message",
    "mms",
    "ms-help",
    "msnim",
    "mumble",
    "mvn",
    "notes",
    "oid",
    "palm",
    "paparazzi",
    "platform",
    "proxy",
    "psyc",
    "query",
    "res",
    "resource",
    "rmi",
    "rsync",
    "rtmp",
    "secondlife",
    "sftp",
    "sgn",
    "skype",
    "smb",
    "soldat",
    "spotify",
    "ssh",
    "steam",
    "svn",
    "teamspeak",
    "things",
    "udp",
    "unreal",
    "ut2004",
    "ventrilo",
    "view-source",
    "webcal",
    "wtai",
    "wyciwyg",
    "xfire",
    "xri",
    "ymsgr"
], $8e4453fb4fc895c8$var$Zr = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/, $8e4453fb4fc895c8$var$Xr = /^<([a-zA-Z.\-]{1,25}):([^<>\x00-\x20]*)>/;
function $8e4453fb4fc895c8$var$Yr(n, e) {
    var t, i, s, r, o, a = n.pos;
    return n.src.charCodeAt(a) !== 60 || (t = n.src.slice(a), t.indexOf(">") < 0) ? !1 : (i = t.match($8e4453fb4fc895c8$var$Xr), i ? $8e4453fb4fc895c8$var$Jr.indexOf(i[1].toLowerCase()) < 0 || (r = i[0].slice(1, -1), o = $8e4453fb4fc895c8$var$fs(r), !n.parser.validateLink(r)) ? !1 : (e || (n.push({
        type: "link_open",
        href: o,
        level: n.level
    }), n.push({
        type: "text",
        content: r,
        level: n.level + 1
    }), n.push({
        type: "link_close",
        level: n.level
    })), n.pos += i[0].length, !0) : (s = t.match($8e4453fb4fc895c8$var$Zr), s ? (r = s[0].slice(1, -1), o = $8e4453fb4fc895c8$var$fs("mailto:" + r), n.parser.validateLink(o) ? (e || (n.push({
        type: "link_open",
        href: o,
        level: n.level
    }), n.push({
        type: "text",
        content: r,
        level: n.level + 1
    }), n.push({
        type: "link_close",
        level: n.level
    })), n.pos += s[0].length, !0) : !1) : !1));
}
function $8e4453fb4fc895c8$var$Ui(n, e) {
    return n = n.source, e = e || "", function t(i, s) {
        return i ? (s = s.source || s, n = n.replace(i, s), t) : new RegExp(n, e);
    };
}
var $8e4453fb4fc895c8$var$Qr = /[a-zA-Z_:][a-zA-Z0-9:._-]*/, $8e4453fb4fc895c8$var$eo = /[^"'=<>`\x00-\x20]+/, $8e4453fb4fc895c8$var$to = /'[^']*'/, $8e4453fb4fc895c8$var$io = /"[^"]*"/, $8e4453fb4fc895c8$var$so = $8e4453fb4fc895c8$var$Ui(/(?:unquoted|single_quoted|double_quoted)/)("unquoted", $8e4453fb4fc895c8$var$eo)("single_quoted", $8e4453fb4fc895c8$var$to)("double_quoted", $8e4453fb4fc895c8$var$io)(), $8e4453fb4fc895c8$var$no = $8e4453fb4fc895c8$var$Ui(/(?:\s+attr_name(?:\s*=\s*attr_value)?)/)("attr_name", $8e4453fb4fc895c8$var$Qr)("attr_value", $8e4453fb4fc895c8$var$so)(), $8e4453fb4fc895c8$var$ro = $8e4453fb4fc895c8$var$Ui(/<[A-Za-z][A-Za-z0-9]*attribute*\s*\/?>/)("attribute", $8e4453fb4fc895c8$var$no)(), $8e4453fb4fc895c8$var$oo = /<\/[A-Za-z][A-Za-z0-9]*\s*>/, $8e4453fb4fc895c8$var$ao = /<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->/, $8e4453fb4fc895c8$var$lo = /<[?].*?[?]>/, $8e4453fb4fc895c8$var$co = /<![A-Z]+\s+[^>]*>/, $8e4453fb4fc895c8$var$ho = /<!\[CDATA\[[\s\S]*?\]\]>/, $8e4453fb4fc895c8$var$uo = $8e4453fb4fc895c8$var$Ui(/^(?:open_tag|close_tag|comment|processing|declaration|cdata)/)("open_tag", $8e4453fb4fc895c8$var$ro)("close_tag", $8e4453fb4fc895c8$var$oo)("comment", $8e4453fb4fc895c8$var$ao)("processing", $8e4453fb4fc895c8$var$lo)("declaration", $8e4453fb4fc895c8$var$co)("cdata", $8e4453fb4fc895c8$var$ho)();
function $8e4453fb4fc895c8$var$fo(n) {
    var e = n | 32;
    return e >= 97 && e <= 122;
}
function $8e4453fb4fc895c8$var$po(n, e) {
    var t, i, s, r = n.pos;
    return !n.options.html || (s = n.posMax, n.src.charCodeAt(r) !== 60 || r + 2 >= s) || (t = n.src.charCodeAt(r + 1), t !== 33 && t !== 63 && t !== 47 && !$8e4453fb4fc895c8$var$fo(t)) || (i = n.src.slice(r).match($8e4453fb4fc895c8$var$uo), !i) ? !1 : (e || n.push({
        type: "htmltag",
        content: n.src.slice(r, r + i[0].length),
        level: n.level
    }), n.pos += i[0].length, !0);
}
var $8e4453fb4fc895c8$var$mo = /^&#((?:x[a-f0-9]{1,8}|[0-9]{1,8}));/i, $8e4453fb4fc895c8$var$go = /^&([a-z][a-z0-9]{1,31});/i;
function $8e4453fb4fc895c8$var$bo(n, e) {
    var t, i, s, r = n.pos, o = n.posMax;
    if (n.src.charCodeAt(r) !== 38) return !1;
    if (r + 1 < o) {
        if (t = n.src.charCodeAt(r + 1), t === 35) {
            if (s = n.src.slice(r).match($8e4453fb4fc895c8$var$mo), s) return e || (i = s[1][0].toLowerCase() === "x" ? parseInt(s[1].slice(1), 16) : parseInt(s[1], 10), n.pending += $8e4453fb4fc895c8$var$xn(i) ? $8e4453fb4fc895c8$var$us(i) : $8e4453fb4fc895c8$var$us(65533)), n.pos += s[0].length, !0;
        } else if (s = n.src.slice(r).match($8e4453fb4fc895c8$var$go), s) {
            var a = $8e4453fb4fc895c8$var$En(s[1]);
            if (s[1] !== a) return e || (n.pending += a), n.pos += s[0].length, !0;
        }
    }
    return e || (n.pending += "&"), n.pos++, !0;
}
var $8e4453fb4fc895c8$var$ns = [
    [
        "text",
        $8e4453fb4fc895c8$var$Or
    ],
    [
        "newline",
        $8e4453fb4fc895c8$var$Nr
    ],
    [
        "escape",
        $8e4453fb4fc895c8$var$Dr
    ],
    [
        "backticks",
        $8e4453fb4fc895c8$var$Br
    ],
    [
        "del",
        $8e4453fb4fc895c8$var$Fr
    ],
    [
        "ins",
        $8e4453fb4fc895c8$var$Ur
    ],
    [
        "mark",
        $8e4453fb4fc895c8$var$jr
    ],
    [
        "emphasis",
        $8e4453fb4fc895c8$var$Hr
    ],
    [
        "sub",
        $8e4453fb4fc895c8$var$zr
    ],
    [
        "sup",
        $8e4453fb4fc895c8$var$Vr
    ],
    [
        "links",
        $8e4453fb4fc895c8$var$$r
    ],
    [
        "footnote_inline",
        $8e4453fb4fc895c8$var$Wr
    ],
    [
        "footnote_ref",
        $8e4453fb4fc895c8$var$Kr
    ],
    [
        "autolink",
        $8e4453fb4fc895c8$var$Yr
    ],
    [
        "htmltag",
        $8e4453fb4fc895c8$var$po
    ],
    [
        "entity",
        $8e4453fb4fc895c8$var$bo
    ]
];
function $8e4453fb4fc895c8$var$ji() {
    this.ruler = new $8e4453fb4fc895c8$var$oe();
    for(var n = 0; n < $8e4453fb4fc895c8$var$ns.length; n++)this.ruler.push($8e4453fb4fc895c8$var$ns[n][0], $8e4453fb4fc895c8$var$ns[n][1]);
    this.validateLink = $8e4453fb4fc895c8$var$vo;
}
$8e4453fb4fc895c8$var$ji.prototype.skipToken = function(n) {
    var e = this.ruler.getRules(""), t = e.length, i = n.pos, s, r;
    if ((r = n.cacheGet(i)) > 0) {
        n.pos = r;
        return;
    }
    for(s = 0; s < t; s++)if (e[s](n, !0)) {
        n.cacheSet(i, n.pos);
        return;
    }
    n.pos++, n.cacheSet(i, n.pos);
};
$8e4453fb4fc895c8$var$ji.prototype.tokenize = function(n) {
    for(var e = this.ruler.getRules(""), t = e.length, i = n.posMax, s, r; n.pos < i;){
        for(r = 0; r < t && (s = e[r](n, !1), !s); r++);
        if (s) {
            if (n.pos >= i) break;
            continue;
        }
        n.pending += n.src[n.pos++];
    }
    n.pending && n.pushPending();
};
$8e4453fb4fc895c8$var$ji.prototype.parse = function(n, e, t, i) {
    var s = new $8e4453fb4fc895c8$var$at(n, this, e, t, i);
    this.tokenize(s);
};
function $8e4453fb4fc895c8$var$vo(n) {
    var e = [
        "vbscript",
        "javascript",
        "file",
        "data"
    ], t = n.trim().toLowerCase();
    return t = $8e4453fb4fc895c8$var$nt(t), !(t.indexOf(":") !== -1 && e.indexOf(t.split(":")[0]) !== -1);
}
var $8e4453fb4fc895c8$var$yo = {
    options: {
        html: !1,
        // Enable HTML tags in source
        xhtmlOut: !1,
        // Use '/' to close single tags (<br />)
        breaks: !1,
        // Convert '\n' in paragraphs into <br>
        langPrefix: "language-",
        // CSS language prefix for fenced blocks
        linkTarget: "",
        // set target to open link in
        // Enable some language-neutral replacements + quotes beautification
        typographer: !1,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
        quotes: "\u201C\u201D\u2018\u2019",
        // Highlighter function. Should return escaped HTML,
        // or '' if input not changed
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                "block",
                "inline",
                "references",
                "replacements",
                "smartquotes",
                "references",
                "abbr2",
                "footnote_tail"
            ]
        },
        block: {
            rules: [
                "blockquote",
                "code",
                "fences",
                "footnote",
                "heading",
                "hr",
                "htmlblock",
                "lheading",
                "list",
                "paragraph",
                "table"
            ]
        },
        inline: {
            rules: [
                "autolink",
                "backticks",
                "del",
                "emphasis",
                "entity",
                "escape",
                "footnote_ref",
                "htmltag",
                "links",
                "newline",
                "text"
            ]
        }
    }
}, $8e4453fb4fc895c8$var$Eo = {
    options: {
        html: !1,
        // Enable HTML tags in source
        xhtmlOut: !1,
        // Use '/' to close single tags (<br />)
        breaks: !1,
        // Convert '\n' in paragraphs into <br>
        langPrefix: "language-",
        // CSS language prefix for fenced blocks
        linkTarget: "",
        // set target to open link in
        // Enable some language-neutral replacements + quotes beautification
        typographer: !1,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
        quotes: "\u201C\u201D\u2018\u2019",
        // Highlighter function. Should return escaped HTML,
        // or '' if input not changed
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20
    },
    components: {
        // Don't restrict core/block/inline rules
        core: {},
        block: {},
        inline: {}
    }
}, $8e4453fb4fc895c8$var$So = {
    options: {
        html: !0,
        // Enable HTML tags in source
        xhtmlOut: !0,
        // Use '/' to close single tags (<br />)
        breaks: !1,
        // Convert '\n' in paragraphs into <br>
        langPrefix: "language-",
        // CSS language prefix for fenced blocks
        linkTarget: "",
        // set target to open link in
        // Enable some language-neutral replacements + quotes beautification
        typographer: !1,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
        quotes: "\u201C\u201D\u2018\u2019",
        // Highlighter function. Should return escaped HTML,
        // or '' if input not changed
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                "block",
                "inline",
                "references",
                "abbr2"
            ]
        },
        block: {
            rules: [
                "blockquote",
                "code",
                "fences",
                "heading",
                "hr",
                "htmlblock",
                "lheading",
                "list",
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "autolink",
                "backticks",
                "emphasis",
                "entity",
                "escape",
                "htmltag",
                "links",
                "newline",
                "text"
            ]
        }
    }
}, $8e4453fb4fc895c8$var$xo = {
    "default": $8e4453fb4fc895c8$var$yo,
    full: $8e4453fb4fc895c8$var$Eo,
    commonmark: $8e4453fb4fc895c8$var$So
};
function $8e4453fb4fc895c8$var$Mn(n, e, t) {
    this.src = e, this.env = t, this.options = n.options, this.tokens = [], this.inlineMode = !1, this.inline = n.inline, this.block = n.block, this.renderer = n.renderer, this.typographer = n.typographer;
}
function $8e4453fb4fc895c8$var$_e(n, e) {
    typeof n != "string" && (e = n, n = "default"), e && e.linkify != null && console.warn("linkify option is removed. Use linkify plugin instead:\n\nimport Remarkable from 'remarkable';\nimport linkify from 'remarkable/linkify';\nnew Remarkable().use(linkify)\n"), this.inline = new $8e4453fb4fc895c8$var$ji(), this.block = new $8e4453fb4fc895c8$var$Rs(), this.core = new $8e4453fb4fc895c8$var$Tn(), this.renderer = new $8e4453fb4fc895c8$var$Ms(), this.ruler = new $8e4453fb4fc895c8$var$oe(), this.options = {}, this.configure($8e4453fb4fc895c8$var$xo[n]), this.set(e || {});
}
$8e4453fb4fc895c8$var$_e.prototype.set = function(n) {
    $8e4453fb4fc895c8$var$Sn(this.options, n);
};
$8e4453fb4fc895c8$var$_e.prototype.configure = function(n) {
    var e = this;
    if (!n) throw new Error("Wrong `remarkable` preset, check name/content");
    n.options && e.set(n.options), n.components && Object.keys(n.components).forEach(function(t) {
        n.components[t].rules && e[t].ruler.enable(n.components[t].rules, !0);
    });
};
$8e4453fb4fc895c8$var$_e.prototype.use = function(n, e) {
    return n(this, e), this;
};
$8e4453fb4fc895c8$var$_e.prototype.parse = function(n, e) {
    var t = new $8e4453fb4fc895c8$var$Mn(this, n, e);
    return this.core.process(t), t.tokens;
};
$8e4453fb4fc895c8$var$_e.prototype.render = function(n, e) {
    return e = e || {}, this.renderer.render(this.parse(n, e), this.options, e);
};
$8e4453fb4fc895c8$var$_e.prototype.parseInline = function(n, e) {
    var t = new $8e4453fb4fc895c8$var$Mn(this, n, e);
    return t.inlineMode = !0, this.core.process(t), t.tokens;
};
$8e4453fb4fc895c8$var$_e.prototype.renderInline = function(n, e) {
    return e = e || {}, this.renderer.render(this.parseInline(n, e), this.options, e);
};
var $8e4453fb4fc895c8$var$bt = /*#__PURE__*/ function() {
    function bt() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, bt);
    }
    return $8e4453fb4fc895c8$var$_createClass(bt, null, [
        {
            key: "instantiate",
            value: function instantiate(e) {
                if (e) return new $8e4453fb4fc895c8$var$_e($8e4453fb4fc895c8$var$_objectSpread($8e4453fb4fc895c8$var$_objectSpread({}, bt.DEFAULT_PROPERTIES), e));
                if (window.hljs) {
                    var t = window.hljs;
                    return new $8e4453fb4fc895c8$var$_e({
                        highlight: function highlight(i, s) {
                            if (s && t.getLanguage(s)) try {
                                return t.highlight(s, i).value;
                            } catch (_unused4) {
                                console.error("failed to setup the highlight dependency");
                            }
                            try {
                                return t.highlightAuto(i).value;
                            } catch (_unused5) {
                                console.error("failed to automatically highlight messages");
                            }
                            return "";
                        },
                        html: !1,
                        // Enable HTML tags in source
                        xhtmlOut: !1,
                        // Use '/' to close single tags (<br />)
                        breaks: !0,
                        // Convert '\n' in paragraphs into <br>
                        langPrefix: "language-",
                        // CSS language prefix for fenced blocks
                        linkTarget: "_blank",
                        // set target to open in a new tab
                        typographer: !0
                    });
                } else return new $8e4453fb4fc895c8$var$_e(bt.DEFAULT_PROPERTIES);
            }
        },
        {
            key: "createNew",
            value: function createNew(e) {
                var t = bt.instantiate(e);
                return t.inline.validateLink = function() {
                    return !0;
                }, t;
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$bt.DEFAULT_PROPERTIES = {
    breaks: !0,
    linkTarget: "_blank"
};
var $8e4453fb4fc895c8$var$Vt = $8e4453fb4fc895c8$var$bt;
var $8e4453fb4fc895c8$var$z = /*#__PURE__*/ function() {
    function z() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, z);
    }
    return $8e4453fb4fc895c8$var$_createClass(z, null, [
        {
            key: "applyCustomStylesToElements",
            value: function applyCustomStylesToElements(e, t, i) {
                if (i && (Object.assign(e.outerContainer.style, i.outerContainer), Object.assign(e.innerContainer.style, i.innerContainer), Object.assign(e.bubbleElement.style, i.bubble), t)) {
                    var s = e.bubbleElement.children[0], r = s.tagName.toLocaleLowerCase() !== "a" ? s : s.children[0];
                    Object.assign(r.style, i.media);
                }
            }
        },
        {
            key: "applySideStyles",
            value: function applySideStyles(e, t, i, s) {
                s && (z.applyCustomStylesToElements(e, i, s.shared), t === $8e4453fb4fc895c8$var$b.USER_ROLE ? z.applyCustomStylesToElements(e, i, s.user) : (z.applyCustomStylesToElements(e, i, s.ai), z.applyCustomStylesToElements(e, i, s[t])));
            }
        },
        {
            key: "isElementsStyles",
            value: function isElementsStyles(e) {
                return !!(e.outerContainer || e.innerContainer || e.bubble || e.media);
            }
        },
        {
            key: "applyCustomStyles",
            value: function applyCustomStyles(e, t, i, s, r) {
                var o;
                r && e["default"] !== r ? z.isElementsStyles(r) ? (z.applyCustomStylesToElements(t, s, (o = e["default"]) == null ? void 0 : o.shared), z.applyCustomStylesToElements(t, s, r)) : (z.applySideStyles(t, i, s, e["default"]), z.applySideStyles(t, i, s, r)) : z.applySideStyles(t, i, s, e["default"]);
            }
        },
        {
            key: "extractParticularSharedStyles",
            value: function extractParticularSharedStyles(e, t) {
                if (!(t != null && t.shared)) return;
                var i = t.shared, s = {
                    outerContainer: {},
                    innerContainer: {},
                    bubble: {},
                    media: {}
                };
                return e.forEach(function(r) {
                    var o, a, l, c;
                    s.outerContainer[r] = ((o = i.outerContainer) == null ? void 0 : o[r]) || "", s.innerContainer[r] = ((a = i.innerContainer) == null ? void 0 : a[r]) || "", s.bubble[r] = ((l = i.bubble) == null ? void 0 : l[r]) || "", s.media[r] = ((c = i.media) == null ? void 0 : c[r]) || "";
                }), s;
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$gi = /*#__PURE__*/ function() {
    function gi() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, gi);
    }
    return $8e4453fb4fc895c8$var$_createClass(gi, null, [
        {
            key: "onMessage",
            value: function onMessage(e, t, i) {
                var r;
                var s = JSON.parse(JSON.stringify({
                    message: t,
                    isHistory: i,
                    isInitial: i
                }));
                $8e4453fb4fc895c8$var$j.reAddFileRefToObject(t, s), (r = e.onMessage) == null || r.call(e, s), e.dispatchEvent(new CustomEvent("message", {
                    detail: s
                })), $8e4453fb4fc895c8$var$Y.fireOnNewMessage(e, s);
            }
        },
        {
            key: "onClearMessages",
            value: function onClearMessages(e) {
                var t;
                (t = e.onClearMessages) == null || t.call(e), e.dispatchEvent(new CustomEvent("clear-messages"));
            }
        },
        {
            key: "onRender",
            value: function onRender(e) {
                var t;
                (t = e.onComponentRender) == null || t.call(e, e), e.dispatchEvent(new CustomEvent("render", {
                    detail: e
                }));
            }
        },
        {
            key: "onError",
            value: function onError(e, t) {
                var i;
                (i = e.onError) == null || i.call(e, t), e.dispatchEvent(new CustomEvent("error", {
                    detail: t
                }));
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$N = /*#__PURE__*/ function() {
    function N() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, N);
    }
    return $8e4453fb4fc895c8$var$_createClass(N, null, [
        {
            key: "generateLoadingRingElement",
            value: function generateLoadingRingElement() {
                var e = document.createElement("div");
                return e.classList.add("loading-history"), e.appendChild(document.createElement("div")), e.appendChild(document.createElement("div")), e.appendChild(document.createElement("div")), e.appendChild(document.createElement("div")), e;
            }
        },
        {
            key: "apply",
            value: function apply(e, t, i) {
                $8e4453fb4fc895c8$var$Oe.setRing(t.bubbleElement, i == null ? void 0 : i.bubble), i != null && i.bubble && (i = JSON.parse(JSON.stringify(i)), delete i.bubble), e.applyCustomStyles(t, "history", !1, i);
            }
        },
        {
            key: "addLoadHistoryMessage",
            value: function addLoadHistoryMessage(e, t) {
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
                var o, a, l, c, d, h, f, u;
                e.bubbleElement.classList.add(N.CLASS);
                var s = i ? N.FULL_VIEW_CLASS : N.SMALL_CLASS;
                e.outerContainer.classList.add(s);
                var r = i ? (c = (l = (a = (o = t.messageStyles) == null ? void 0 : o.loading) == null ? void 0 : a.history) == null ? void 0 : l.full) == null ? void 0 : c.styles : (u = (f = (h = (d = t.messageStyles) == null ? void 0 : d.loading) == null ? void 0 : h.history) == null ? void 0 : f.small) == null ? void 0 : u.styles;
                N.apply(t, e, r), t.elementRef.prepend(e.outerContainer);
            }
        },
        {
            key: "createDefaultElements",
            value: function createDefaultElements(e) {
                var t = e.createMessageElements("", $8e4453fb4fc895c8$var$b.AI_ROLE), i = t.bubbleElement, s = N.generateLoadingRingElement();
                return i.appendChild(s), t;
            }
        },
        {
            key: "addMessage",
            value: function addMessage(e) {
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                var r, o, a, l;
                var i = (l = (a = (o = (r = e.messageStyles) == null ? void 0 : r.loading) == null ? void 0 : o.history) == null ? void 0 : a.full) == null ? void 0 : l.html, s = i ? $8e4453fb4fc895c8$var$xe.createElements(e, i, $8e4453fb4fc895c8$var$b.AI_ROLE, !0) : N.createDefaultElements(e);
                return N.addLoadHistoryMessage(s, e, t), s;
            }
        },
        {
            key: "tryChangeViewToSmall",
            value: function tryChangeViewToSmall(e, t) {
                var i, s, r, o, a, l, c, d;
                if (t != null && t.outerContainer.classList.contains(N.FULL_VIEW_CLASS)) {
                    t.outerContainer.classList.replace(N.FULL_VIEW_CLASS, N.SMALL_CLASS);
                    var h = (o = (r = (s = (i = e.messageStyles) == null ? void 0 : i.loading) == null ? void 0 : s.history) == null ? void 0 : r.small) == null ? void 0 : o.styles;
                    h && N.apply(e, t, h);
                    var f = (d = (c = (l = (a = e.messageStyles) == null ? void 0 : a.loading) == null ? void 0 : l.history) == null ? void 0 : c.small) == null ? void 0 : d.html;
                    return f && (t.bubbleElement.innerHTML = f), !0;
                }
                return !1;
            }
        },
        {
            key: "changeFullViewToSmall",
            value: function changeFullViewToSmall(e) {
                var t = e.messageElementRefs[e.messageElementRefs.length - 1];
                N.tryChangeViewToSmall(e, t) || N.tryChangeViewToSmall(e, e.messageElementRefs[0]);
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$N.CLASS = "loading-history-message", $8e4453fb4fc895c8$var$N.FULL_VIEW_CLASS = "loading-history-message-full-view", $8e4453fb4fc895c8$var$N.SMALL_CLASS = "loading-history-message-small";
var $8e4453fb4fc895c8$var$De = $8e4453fb4fc895c8$var$N;
var $8e4453fb4fc895c8$var$me = /*#__PURE__*/ function() {
    // public lastElem: HTMLElement | null = null;
    function me(e) {
        var _this3 = this;
        $8e4453fb4fc895c8$var$_classCallCheck(this, me);
        this.messageElementRefs = [], this.htmlClassUtilities = {}, this.messageToElements = [], this.elementRef = me.createContainerElement(), this.messageStyles = $8e4453fb4fc895c8$var$Y.processMessageStyles(e.messageStyles), this._remarkable = $8e4453fb4fc895c8$var$Vt.createNew(e.remarkable), this._avatars = e.avatars, this._names = e.names, this._onMessage = $8e4453fb4fc895c8$var$gi.onMessage.bind(this, e), e.htmlClassUtilities && (this.htmlClassUtilities = e.htmlClassUtilities), setTimeout(function() {
            _this3.submitUserMessage = e.submitUserMessage;
        });
    }
    return $8e4453fb4fc895c8$var$_createClass(me, [
        {
            key: "addNewTextMessage",
            value: function addNewTextMessage(e, t, i) {
                var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                if (i != null && i.status) {
                    var o = this.overwriteText(t, e, this.messageElementRefs);
                    if (o) return o;
                    i.status = !1;
                }
                var r = s ? this.createAndPrependNewMessageElement(e, t, s) : this.createAndAppendNewMessageElement(e, t);
                return r.bubbleElement.classList.add(me.TEXT_BUBBLE_CLASS), this.applyCustomStyles(r, t, !1), $8e4453fb4fc895c8$var$b.fillEmptyMessageElement(r.bubbleElement, e), r;
            }
        },
        {
            key: "overwriteText",
            value: function overwriteText(e, t, i) {
                var s = $8e4453fb4fc895c8$var$b.overwriteMessage(this.messageToElements, i, t, e, "text", me.TEXT_BUBBLE_CLASS);
                return s && this.renderText(s.bubbleElement, t), s;
            }
        },
        {
            key: "createAndAppendNewMessageElement",
            value: function createAndAppendNewMessageElement(e, t) {
                var _this4 = this;
                var i = this.createNewMessageElement(e, t);
                return this.elementRef.appendChild(i.outerContainer), setTimeout(function() {
                    return $8e4453fb4fc895c8$var$X.scrollToBottom(_this4.elementRef);
                }), i;
            }
        },
        {
            key: "createAndPrependNewMessageElement",
            value: function createAndPrependNewMessageElement(e, t, i) {
                var r;
                var s = this.createNewMessageElement(e, t, i);
                if (i && (r = this.elementRef.firstChild) != null && r.classList.contains(me.INTRO_CLASS)) {
                    this.elementRef.firstChild.insertAdjacentElement("afterend", s.outerContainer);
                    var o = this.messageElementRefs[0];
                    this.messageElementRefs[0] = this.messageElementRefs[1], this.messageElementRefs[1] = o;
                } else this.elementRef.insertBefore(s.outerContainer, this.elementRef.firstChild);
                return s;
            }
        },
        {
            key: "createMessageElementsOnOrientation",
            value: function createMessageElementsOnOrientation(e, t, i) {
                return i ? this.createAndPrependNewMessageElement(e, t, !0) : this.createNewMessageElement(e, t);
            }
        },
        {
            key: "createNewMessageElement",
            value: function createNewMessageElement(e, t) {
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                var r;
                (r = this._introPanel) == null || r.hide();
                var s = this.messageElementRefs[this.messageElementRefs.length - 1];
                return $8e4453fb4fc895c8$var$De.changeFullViewToSmall(this), me.isTemporaryElement(s) && (this.revealRoleElementsIfTempRemoved(s, t), s.outerContainer.remove(), this.messageElementRefs.pop()), this.createMessageElements(e, t, i);
            }
        },
        {
            key: "revealRoleElementsIfTempRemoved",
            value: function revealRoleElementsIfTempRemoved(e, t) {
                if ((this._avatars || this._names) && $8e4453fb4fc895c8$var$Ne.isElementTemporary(e)) {
                    var i = this.messageElementRefs[this.messageElementRefs.length - 2];
                    i && this.messageToElements.length > 0 && !e.bubbleElement.classList.contains($8e4453fb4fc895c8$var$b.getRoleClass(t)) && $8e4453fb4fc895c8$var$b.revealRoleElements(i.innerContainer, this._avatars, this._names);
                }
            }
        },
        {
            key: "createElements",
            value: function createElements(e, t) {
                var i = me.createBaseElements(t), s = i.outerContainer, r = i.innerContainer, o = i.bubbleElement;
                return s.appendChild(r), this.addInnerContainerElements(o, e, t), i;
            }
        },
        {
            key: "createMessageElements",
            value: function createMessageElements(e, t) {
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                var s = this.createElements(e, t);
                return $8e4453fb4fc895c8$var$b.updateRefArr(this.messageElementRefs, s, i), $8e4453fb4fc895c8$var$b.classifyMessages(t, this.messageElementRefs), s;
            }
        },
        {
            key: "addInnerContainerElements",
            value: // prettier-ignore
            function addInnerContainerElements(e, t, i) {
                var s;
                return ((s = this.messageToElements[this.messageToElements.length - 1]) == null ? void 0 : s[0].role) === i && !this.isLastMessageError() && $8e4453fb4fc895c8$var$b.hideRoleElements(this.messageElementRefs, !!this._avatars, !!this._names), e.classList.add("message-bubble", $8e4453fb4fc895c8$var$b.getRoleClass(i), i === $8e4453fb4fc895c8$var$b.USER_ROLE ? "user-message-text" : "ai-message-text"), this.renderText(e, t), $8e4453fb4fc895c8$var$b.addRoleElements(e, i, this._avatars, this._names), {
                    bubbleElement: e
                };
            }
        },
        {
            key: "applyCustomStyles",
            value: function applyCustomStyles(e, t, i, s) {
                e && this.messageStyles && $8e4453fb4fc895c8$var$z.applyCustomStyles(this.messageStyles, e, t, i, s);
            }
        },
        {
            key: "removeMessage",
            value: function removeMessage(e) {
                e.outerContainer.remove();
                var t = this.messageElementRefs.findIndex(function(i) {
                    return i === e;
                });
                this.messageElementRefs.splice(t, 1);
            }
        },
        {
            key: "removeLastMessage",
            value: function removeLastMessage() {
                this.messageElementRefs[this.messageElementRefs.length - 1].outerContainer.remove(), this.messageElementRefs.pop();
            }
        },
        {
            key: "isLastMessageError",
            value: function isLastMessageError() {
                var e;
                return (e = $8e4453fb4fc895c8$var$b.getLastMessageBubbleElement(this.elementRef)) == null ? void 0 : e.classList.contains("error-message-text");
            }
        },
        {
            key: "sendClientUpdate",
            value: function sendClientUpdate(e) {
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                var i;
                (i = this._onMessage) == null || i.call(this, e, t);
            }
        },
        {
            key: "renderText",
            value: function renderText(e, t) {
                e.innerHTML = this._remarkable.render(t), e.innerText.trim().length === 0 && (e.innerText = t);
            }
        },
        {
            key: "refreshTextMessages",
            value: function refreshTextMessages(e) {
                var _this5 = this;
                this._remarkable = $8e4453fb4fc895c8$var$Vt.createNew(e), this.messageToElements.forEach(function(t) {
                    t[1].text && t[0].text && _this5.renderText(t[1].text.bubbleElement, t[0].text);
                });
            }
        }
    ], [
        {
            key: "createContainerElement",
            value: function createContainerElement() {
                var e = document.createElement("div");
                return e.id = "messages", e;
            }
        },
        {
            key: "isTemporaryElement",
            value: function isTemporaryElement(e) {
                return me.isLoadingMessage(e) || $8e4453fb4fc895c8$var$Ne.isElementTemporary(e);
            }
        },
        {
            key: "createBaseElements",
            value: function createBaseElements(e) {
                var t = document.createElement("div"), i = document.createElement("div");
                i.classList.add("inner-message-container"), t.appendChild(i), t.classList.add("outer-message-container"), t.classList.add($8e4453fb4fc895c8$var$b.buildRoleContainerClass(e));
                var s = document.createElement("div");
                return s.classList.add("message-bubble"), i.appendChild(s), {
                    outerContainer: t,
                    innerContainer: i,
                    bubbleElement: s
                };
            }
        },
        {
            key: "createMessageContent",
            value: function createMessageContent(e) {
                var t = e.text, i = e.files, s = e.html, r = e._sessionId, o = e.role, a = {
                    role: o || $8e4453fb4fc895c8$var$b.AI_ROLE
                };
                return t && (a.text = t), i && (a.files = i), s && (a.html = s), !t && !i && !s && (a.text = ""), r && (a._sessionId = r), a;
            }
        },
        {
            key: "isLoadingMessage",
            value: function isLoadingMessage(e) {
                return e == null ? void 0 : e.bubbleElement.classList.contains($8e4453fb4fc895c8$var$Oe.BUBBLE_CLASS);
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$me.TEXT_BUBBLE_CLASS = "text-message", $8e4453fb4fc895c8$var$me.INTRO_CLASS = "deep-chat-intro";
var $8e4453fb4fc895c8$var$Be = $8e4453fb4fc895c8$var$me;
var $8e4453fb4fc895c8$var$_o = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='iso-8859-1'?%3e%3csvg%20fill='%23000000'%20version='1.1'%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20viewBox='0%200%2032%2032'%20xml:space='preserve'%3e%3cpath%20d='M23,30.36H9c-2.404,0-4.36-1.956-4.36-4.36V15c0-2.404,1.956-4.36,4.36-4.36h3.659%20c0.167-1.566,1.415-2.813,2.981-2.981V5.333c-1.131-0.174-2-1.154-2-2.333c0-1.301,1.059-2.36,2.36-2.36%20c1.302,0,2.36,1.059,2.36,2.36c0,1.179-0.869,2.159-2,2.333V7.66c1.566,0.167,2.814,1.415,2.981,2.981H23%20c2.404,0,4.36,1.956,4.36,4.36v11C27.36,28.404,25.404,30.36,23,30.36z%20M9,11.36c-2.007,0-3.64,1.633-3.64,3.64v11%20c0,2.007,1.633,3.64,3.64,3.64h14c2.007,0,3.64-1.633,3.64-3.64V15c0-2.007-1.633-3.64-3.64-3.64H9z%20M13.384,10.64h5.231%20C18.439,9.354,17.334,8.36,16,8.36C14.667,8.36,13.561,9.354,13.384,10.64z%20M16,1.36c-0.904,0-1.64,0.736-1.64,1.64%20S15.096,4.64,16,4.64c0.904,0,1.64-0.736,1.64-1.64S16.904,1.36,16,1.36z%20M20,27.36h-8c-1.301,0-2.36-1.059-2.36-2.36%20s1.059-2.36,2.36-2.36h8c1.302,0,2.36,1.059,2.36,2.36S21.302,27.36,20,27.36z%20M12,23.36c-0.904,0-1.64,0.735-1.64,1.64%20s0.736,1.64,1.64,1.64h8c0.904,0,1.64-0.735,1.64-1.64s-0.735-1.64-1.64-1.64H12z%20M31,23.86h-2c-0.199,0-0.36-0.161-0.36-0.36V15%20c0-0.199,0.161-0.36,0.36-0.36h2c0.199,0,0.36,0.161,0.36,0.36v8.5C31.36,23.699,31.199,23.86,31,23.86z%20M29.36,23.14h1.279v-7.78%20H29.36V23.14z%20M3,23.86H1c-0.199,0-0.36-0.161-0.36-0.36V15c0-0.199,0.161-0.36,0.36-0.36h2c0.199,0,0.36,0.161,0.36,0.36v8.5%20C3.36,23.699,3.199,23.86,3,23.86z%20M1.36,23.14h1.28v-7.78H1.36V23.14z%20M20,20.36c-1.302,0-2.36-1.059-2.36-2.36%20s1.059-2.36,2.36-2.36s2.36,1.059,2.36,2.36C22.36,19.302,21.302,20.36,20,20.36z%20M20,16.36c-0.904,0-1.64,0.736-1.64,1.64%20s0.735,1.64,1.64,1.64s1.64-0.735,1.64-1.64S20.904,16.36,20,16.36z%20M12,20.36c-1.301,0-2.36-1.059-2.36-2.36s1.059-2.36,2.36-2.36%20s2.36,1.059,2.36,2.36C14.36,19.302,13.301,20.36,12,20.36z%20M12,16.36c-0.904,0-1.64,0.736-1.64,1.64s0.736,1.64,1.64,1.64%20s1.64-0.735,1.64-1.64S12.904,16.36,12,16.36z'/%3e%3crect%20style='fill:none;'%20width='32'%20height='32'/%3e%3c/svg%3e", $8e4453fb4fc895c8$var$wo = "data:image/png;base64,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", $8e4453fb4fc895c8$var$te = /*#__PURE__*/ function() {
    function te() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, te);
    }
    return $8e4453fb4fc895c8$var$_createClass(te, null, [
        {
            key: "hide",
            value: function hide(e) {
                var t;
                (t = e.getElementsByClassName(te.CONTAINER_CLASS)[0].style).visibility || (t.visibility = "hidden");
            }
        },
        {
            key: "reveal",
            value: function reveal(e) {
                e.getElementsByClassName(te.CONTAINER_CLASS)[0].style.visibility = "";
            }
        },
        {
            key: "applyCustomStylesToElements",
            value: function applyCustomStylesToElements(e, t, i) {
                Object.assign(e.style, i.container), Object.assign(t.style, i.avatar);
            }
        },
        {
            key: "applyCustomStyles",
            value: function applyCustomStyles(e, t, i, s) {
                var r, o, a, l;
                if ((r = i["default"]) != null && r.styles && te.applyCustomStylesToElements(e, t, i["default"].styles), s === $8e4453fb4fc895c8$var$b.USER_ROLE) (o = i.user) != null && o.styles && te.applyCustomStylesToElements(e, t, i.user.styles);
                else {
                    (a = i.ai) != null && a.styles && te.applyCustomStylesToElements(e, t, i.ai.styles);
                    var c = (l = i[s]) == null ? void 0 : l.styles;
                    c && te.applyCustomStylesToElements(e, t, c);
                }
            }
        },
        {
            key: "createAvatar",
            value: function createAvatar(e, t) {
                var r, o, a, l, c;
                var i = document.createElement("img");
                e === $8e4453fb4fc895c8$var$b.USER_ROLE ? i.src = ((r = t == null ? void 0 : t.user) == null ? void 0 : r.src) || ((o = t == null ? void 0 : t["default"]) == null ? void 0 : o.src) || $8e4453fb4fc895c8$var$wo : i.src = ((a = t == null ? void 0 : t[e]) == null ? void 0 : a.src) || ((l = t == null ? void 0 : t.ai) == null ? void 0 : l.src) || ((c = t == null ? void 0 : t["default"]) == null ? void 0 : c.src) || $8e4453fb4fc895c8$var$_o, i.classList.add("avatar"), i.alt = "".concat(e, " avatar");
                var s = document.createElement("div");
                return s.classList.add(te.CONTAINER_CLASS), s.appendChild(i), t && te.applyCustomStyles(s, i, t, e), s;
            }
        },
        {
            key: "getPosition",
            value: function getPosition(e, t) {
                var _i2, _i3, _i4;
                var s, r, o, a, l, c;
                var i = (r = (s = t == null ? void 0 : t[e]) == null ? void 0 : s.styles) == null ? void 0 : r.position;
                return e !== $8e4453fb4fc895c8$var$b.USER_ROLE && ((_i2 = i) !== null && _i2 !== void 0 ? _i2 : i = (a = (o = t == null ? void 0 : t.ai) == null ? void 0 : o.styles) == null ? void 0 : a.position), (_i3 = i) !== null && _i3 !== void 0 ? _i3 : i = (c = (l = t == null ? void 0 : t["default"]) == null ? void 0 : l.styles) == null ? void 0 : c.position, (_i4 = i) !== null && _i4 !== void 0 ? _i4 : i = e === $8e4453fb4fc895c8$var$b.USER_ROLE ? "right" : "left", i;
            }
        },
        {
            key: "add",
            value: function add(e, t, i) {
                var s = typeof i == "boolean" ? void 0 : i, r = te.createAvatar(t, s), o = te.getPosition(t, s);
                r.classList.add(o === "left" ? "left-item-position" : "right-item-position"), e.insertAdjacentElement(o === "left" ? "beforebegin" : "afterend", r);
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$te.CONTAINER_CLASS = "avatar-container";
var $8e4453fb4fc895c8$var$Ot = $8e4453fb4fc895c8$var$te;
var $8e4453fb4fc895c8$var$Se = /*#__PURE__*/ function() {
    function Se() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Se);
    }
    return $8e4453fb4fc895c8$var$_createClass(Se, null, [
        {
            key: "hide",
            value: function hide(e) {
                var t;
                (t = e.getElementsByClassName(Se.NAME_CLASS)[0].style).visibility || (t.visibility = "hidden");
            }
        },
        {
            key: "reveal",
            value: function reveal(e) {
                e.getElementsByClassName(Se.NAME_CLASS)[0].style.visibility = "";
            }
        },
        {
            key: "getPosition",
            value: function getPosition(e, t) {
                var _i5, _i6, _i7;
                var s, r, o;
                var i = (s = t == null ? void 0 : t[e]) == null ? void 0 : s.position;
                return e !== $8e4453fb4fc895c8$var$b.USER_ROLE && ((_i5 = i) !== null && _i5 !== void 0 ? _i5 : i = (r = t == null ? void 0 : t.ai) == null ? void 0 : r.position), (_i6 = i) !== null && _i6 !== void 0 ? _i6 : i = (o = t == null ? void 0 : t["default"]) == null ? void 0 : o.position, (_i7 = i) !== null && _i7 !== void 0 ? _i7 : i = e === $8e4453fb4fc895c8$var$b.USER_ROLE ? "right" : "left", i;
            }
        },
        {
            key: "applyStyle",
            value: function applyStyle(e, t, i) {
                var s, r, o, a;
                Object.assign(e.style, (s = i["default"]) == null ? void 0 : s.style), t === $8e4453fb4fc895c8$var$b.USER_ROLE ? Object.assign(e.style, (r = i.user) == null ? void 0 : r.style) : (Object.assign(e.style, (o = i.ai) == null ? void 0 : o.style), Object.assign(e.style, (a = i[t]) == null ? void 0 : a.style));
            }
        },
        {
            key: "getNameText",
            value: function getNameText(e, t) {
                var i, s, r, o, a, l;
                return e === $8e4453fb4fc895c8$var$b.USER_ROLE ? ((i = t.user) == null ? void 0 : i.text) || ((s = t["default"]) == null ? void 0 : s.text) || "User" : e === $8e4453fb4fc895c8$var$b.AI_ROLE ? ((r = t.ai) == null ? void 0 : r.text) || ((o = t["default"]) == null ? void 0 : o.text) || "AI" : ((a = t[e]) == null ? void 0 : a.text) || ((l = t["default"]) == null ? void 0 : l.text) || e;
            }
        },
        {
            key: "createName",
            value: function createName(e, t) {
                var i = document.createElement("div");
                return i.classList.add(Se.NAME_CLASS), i.textContent = Se.getNameText(e, t), Se.applyStyle(i, e, t), i;
            }
        },
        {
            key: "add",
            value: function add(e, t, i) {
                var s = typeof i == "boolean" ? {} : i, r = Se.createName(t, s), o = Se.getPosition(t, s);
                r.classList.add(o === "left" ? "left-item-position" : "right-item-position"), e.insertAdjacentElement(o === "left" ? "beforebegin" : "afterend", r);
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$Se.NAME_CLASS = "name";
var $8e4453fb4fc895c8$var$Nt = $8e4453fb4fc895c8$var$Se;
var $8e4453fb4fc895c8$var$w = /*#__PURE__*/ function() {
    function w() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, w);
    }
    return $8e4453fb4fc895c8$var$_createClass(w, null, [
        {
            key: "getLastElementsByClass",
            value: function getLastElementsByClass(e, t, i) {
                var _loop = function _loop() {
                    var r = e[s];
                    if (r.bubbleElement.classList.contains(t[0]) && !t.slice(1).find(function(a) {
                        return !r.bubbleElement.classList.contains(a);
                    })) {
                        if (i) {
                            if (!i.find(function(l) {
                                return r.bubbleElement.classList.contains(l);
                            })) return {
                                v: r
                            };
                        } else return {
                            v: r
                        };
                    }
                }, _ret;
                for(var s = e.length - 1; s >= 0; s -= 1){
                    _ret = _loop();
                    if (_ret) return _ret.v;
                }
            }
        },
        {
            key: "getLastMessage",
            value: function getLastMessage(e, t, i) {
                for(var s = e.length - 1; s >= 0; s -= 1)if (e[s][0].role === t) {
                    if (i) {
                        if (e[s][0][i]) return e[s][0];
                    } else return e[s][0];
                }
            }
        },
        {
            key: "getLastTextToElement",
            value: function getLastTextToElement(e, t) {
                for(var i = e.length - 1; i >= 0; i -= 1)if (e[i][0] === t) return e[i];
            }
        },
        {
            key: "overwriteMessage",
            value: function overwriteMessage(e, t, i, s, r, o) {
                var a = w.getLastElementsByClass(t, [
                    w.getRoleClass(s),
                    o
                ], [
                    $8e4453fb4fc895c8$var$Oe.BUBBLE_CLASS
                ]), l = w.getLastMessage(e, s, r);
                return l && (l[r] = i), a;
            }
        },
        {
            key: "getRoleClass",
            value: function getRoleClass(e) {
                return "".concat(e, "-message");
            }
        },
        {
            key: "fillEmptyMessageElement",
            value: function fillEmptyMessageElement(e, t) {
                t.trim().length === 0 && (e.classList.add(w.EMPTY_MESSAGE_CLASS), e.innerHTML = '<div style="color:#00000000">.</div>');
            }
        },
        {
            key: "unfillEmptyMessageElement",
            value: function unfillEmptyMessageElement(e, t) {
                e.classList.contains(w.EMPTY_MESSAGE_CLASS) && t.trim().length > 0 && e.replaceChildren();
            }
        },
        {
            key: "getLastMessageBubbleElement",
            value: function getLastMessageBubbleElement(e) {
                var t, i, s;
                return Array.from(((s = (i = (t = w.getLastMessageElement(e)) == null ? void 0 : t.children) == null ? void 0 : i[0]) == null ? void 0 : s.children) || []).find(function(r) {
                    return r.classList.contains("message-bubble");
                });
            }
        },
        {
            key: "getLastMessageElement",
            value: function getLastMessageElement(e) {
                return e.children[e.children.length - 1];
            }
        },
        {
            key: "addRoleElements",
            value: function addRoleElements(e, t, i, s) {
                i && $8e4453fb4fc895c8$var$Ot.add(e, t, i), s && $8e4453fb4fc895c8$var$Nt.add(e, t, s);
            }
        },
        {
            key: "hideRoleElements",
            value: function hideRoleElements(e, t, i) {
                var s = e[e.length - 1].innerContainer;
                t && $8e4453fb4fc895c8$var$Ot.hide(s), i && $8e4453fb4fc895c8$var$Nt.hide(s);
            }
        },
        {
            key: "revealRoleElements",
            value: function revealRoleElements(e, t, i) {
                t && $8e4453fb4fc895c8$var$Ot.reveal(e), i && $8e4453fb4fc895c8$var$Nt.reveal(e);
            }
        },
        {
            key: "updateRefArr",
            value: function updateRefArr(e, t, i) {
                i ? e.unshift(t) : e.push(t);
            }
        },
        {
            key: "buildRoleContainerClass",
            value: function buildRoleContainerClass(e) {
                return "deep-chat-".concat(e, "-container");
            }
        },
        {
            key: "addNewPositionClasses",
            value: function addNewPositionClasses(e, t) {
                var _e$outerContainer$cla;
                e.outerContainer.classList.remove(w.POSITION_TOP_MESSAGE_CLASS, w.POSITION_MIDDLE_MESSAGE_CLASS, w.POSITION_BOTTOM_MESSAGE_CLASS), (_e$outerContainer$cla = e.outerContainer.classList).add.apply(_e$outerContainer$cla, $8e4453fb4fc895c8$var$_toConsumableArray(t));
            }
        },
        {
            key: "getNumberOfElements",
            value: function getNumberOfElements(e) {
                var t = 0;
                return e.text !== void 0 && (t += 1), e.html !== void 0 && (t += 1), e.files && (t += e.files.length), t;
            }
        },
        {
            key: "filterdMessageElements",
            value: function filterdMessageElements(e, t) {
                return e.filter(function(i) {
                    return i.bubbleElement.classList.contains(t);
                });
            }
        },
        {
            key: "findMessageElements",
            value: function findMessageElements(e, t) {
                return e.find(function(i) {
                    return i.bubbleElement.classList.contains(t);
                });
            }
        },
        {
            key: "generateMessageBodyElements",
            value: function generateMessageBodyElements(e, t) {
                var i = {};
                return e.text && (i.text = w.findMessageElements(t, $8e4453fb4fc895c8$var$Be.TEXT_BUBBLE_CLASS)), e.html && (i.html = w.findMessageElements(t, $8e4453fb4fc895c8$var$xe.HTML_BUBBLE_CLASS)), e.files && (i.files = w.filterdMessageElements(t, $8e4453fb4fc895c8$var$j.FILE_BUBBLE_CLASS)), i;
            }
        },
        {
            key: "generateMessageBody",
            value: function generateMessageBody(e, t) {
                var i = w.getNumberOfElements(e), s = t.slice(t.length - i);
                return w.generateMessageBodyElements(e, s);
            }
        },
        {
            key: "classifyMessages",
            value: function classifyMessages(e, t) {
                var i = w.buildRoleContainerClass(e);
                t.forEach(function(s, r) {
                    var o = s.outerContainer.classList.contains(i), a = t[r - 1], l = t[r + 1], c = a == null ? void 0 : a.outerContainer.classList.contains(i), d = l == null ? void 0 : l.outerContainer.classList.contains(i);
                    o && (!c && d ? w.addNewPositionClasses(s, [
                        w.POSITION_TOP_MESSAGE_CLASS
                    ]) : c && d ? w.addNewPositionClasses(s, [
                        w.POSITION_MIDDLE_MESSAGE_CLASS
                    ]) : c && !d ? w.addNewPositionClasses(s, [
                        w.POSITION_BOTTOM_MESSAGE_CLASS
                    ]) : !c && !d && w.addNewPositionClasses(s, [
                        w.POSITION_TOP_MESSAGE_CLASS,
                        w.POSITION_BOTTOM_MESSAGE_CLASS
                    ]));
                });
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$w.AI_ROLE = "ai", $8e4453fb4fc895c8$var$w.USER_ROLE = "user", $8e4453fb4fc895c8$var$w.EMPTY_MESSAGE_CLASS = "empty-message", $8e4453fb4fc895c8$var$w.POSITION_TOP_MESSAGE_CLASS = "deep-chat-top-message", $8e4453fb4fc895c8$var$w.POSITION_MIDDLE_MESSAGE_CLASS = "deep-chat-middle-message", $8e4453fb4fc895c8$var$w.POSITION_BOTTOM_MESSAGE_CLASS = "deep-chat-bottom-message";
var $8e4453fb4fc895c8$var$b = $8e4453fb4fc895c8$var$w;
var $8e4453fb4fc895c8$var$vt = /*#__PURE__*/ function() {
    function vt(e) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, vt);
        this._fileAdded = !1, this._streamType = "", this._hasStreamEnded = !1, this._messages = e;
    }
    return $8e4453fb4fc895c8$var$_createClass(vt, [
        {
            key: "upsertStreamedMessage",
            value: function upsertStreamedMessage(e) {
                var r;
                if (this._hasStreamEnded) return;
                if ((e == null ? void 0 : e.text) === void 0 && (e == null ? void 0 : e.html) === void 0) return console.error($8e4453fb4fc895c8$var$M.INVALID_STREAM_EVENT);
                var t = (e == null ? void 0 : e.text) || (e == null ? void 0 : e.html) || "", i = $8e4453fb4fc895c8$var$X.isScrollbarAtBottomOfElement(this._messages.elementRef), s = (e == null ? void 0 : e.text) !== void 0 ? "text" : "html";
                if (!this._elements && !this._message) this.setInitialState(s, t, e == null ? void 0 : e.role);
                else {
                    if (this._streamType !== s) return console.error($8e4453fb4fc895c8$var$M.INVALID_STREAM_EVENT_MIX);
                    this.updateBasedOnType(t, s, (r = this._elements) == null ? void 0 : r.bubbleElement, e == null ? void 0 : e.overwrite);
                }
                i && $8e4453fb4fc895c8$var$X.scrollToBottom(this._messages.elementRef);
            }
        },
        {
            key: "setInitialState",
            value: function setInitialState(e, t, i) {
                var _i8;
                this._streamType = e, (_i8 = i) !== null && _i8 !== void 0 ? _i8 : i = $8e4453fb4fc895c8$var$b.AI_ROLE, this._elements = e === "text" ? this._messages.addNewTextMessage(t, i) : $8e4453fb4fc895c8$var$xe.add(this._messages, t, i, this._messages.messageElementRefs), this._elements.bubbleElement.classList.add(vt.MESSAGE_CLASS), this._activeMessageRole = i, this._message = $8e4453fb4fc895c8$var$_defineProperty({
                    role: this._activeMessageRole
                }, e, t), this._messages.messageToElements.push([
                    this._message,
                    $8e4453fb4fc895c8$var$_defineProperty({}, e, this._elements)
                ]);
            }
        },
        {
            key: "updateBasedOnType",
            value: function updateBasedOnType(e, t, i) {
                var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                $8e4453fb4fc895c8$var$b.unfillEmptyMessageElement(i, e), (t === "text" ? this.updateText : this.updateHTML).bind(this)(e, i, s);
            }
        },
        {
            key: "updateText",
            value: function updateText(e, t, i) {
                this._message && (this._message.text = i ? e : this._message.text + e, this._messages.renderText(t, this._message.text));
            }
        },
        {
            key: "updateHTML",
            value: function updateHTML(e, t, i) {
                if (this._message) {
                    if (i) this._message.html = e, t.innerHTML = e;
                    else {
                        var s = document.createElement("span");
                        s.innerHTML = e, t.appendChild(s), this._message.html = (t == null ? void 0 : t.innerHTML) || "";
                    }
                }
            }
        },
        {
            key: "finaliseStreamedMessage",
            value: function finaliseStreamedMessage() {
                var e;
                if (!(this._endStreamAfterOperation || !this._message) && !(this._fileAdded && !this._elements)) {
                    if (!this._elements) throw Error($8e4453fb4fc895c8$var$M.NO_VALID_STREAM_EVENTS_SENT);
                    (e = this._elements.bubbleElement) != null && e.classList.contains(vt.MESSAGE_CLASS) && (this._streamType === "text" ? this._messages.textToSpeech && $8e4453fb4fc895c8$var$xt.speak(this._message.text || "", this._messages.textToSpeech) : this._streamType === "html" && this._elements && $8e4453fb4fc895c8$var$ne.apply(this._messages, this._elements.outerContainer), this._elements.bubbleElement.classList.remove(vt.MESSAGE_CLASS), this._message && this._messages.sendClientUpdate($8e4453fb4fc895c8$var$Be.createMessageContent(this._message), !1), this._hasStreamEnded = !0);
                }
            }
        },
        {
            key: "markFileAdded",
            value: function markFileAdded() {
                this._fileAdded = !0;
            }
        },
        {
            key: "newMessage",
            value: function newMessage() {
                this.finaliseStreamedMessage(), this._elements = void 0, delete this._message, this._fileAdded = !1, this._hasStreamEnded = !1, this._activeMessageRole = void 0;
            }
        },
        {
            key: "endStreamAfterFileDownloaded",
            value: function() {
                var _endStreamAfterFileDownloaded = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee(e, t) {
                    var r, _yield$t, i, s;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                this._endStreamAfterOperation = !0;
                                _context.next = 3;
                                return t();
                            case 3:
                                _yield$t = _context.sent;
                                i = _yield$t.text;
                                s = _yield$t.files;
                                i && this.updateBasedOnType(i, "text", (r = this._elements) == null ? void 0 : r.bubbleElement, !0), this._endStreamAfterOperation = !1, this.finaliseStreamedMessage(), s && e.addNewMessage({
                                    files: s
                                });
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function endStreamAfterFileDownloaded(_x, _x2) {
                    return _endStreamAfterFileDownloaded.apply(this, arguments);
                }
                return endStreamAfterFileDownloaded;
            }()
        }
    ]);
}();
$8e4453fb4fc895c8$var$vt.MESSAGE_CLASS = "streamed-message";
var $8e4453fb4fc895c8$var$we = $8e4453fb4fc895c8$var$vt;
var $8e4453fb4fc895c8$var$Xe = /*#__PURE__*/ function() {
    function Xe() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Xe);
    }
    return $8e4453fb4fc895c8$var$_createClass(Xe, null, [
        {
            key: "tempRemoveContentHeader",
            value: // prettier-ignore
            function() {
                var _tempRemoveContentHeader = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee2(e, t, i) {
                    var s, r;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (e != null && e.headers) {
                                    _context2.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                s = e.headers[Xe.CONTENT_TYPE];
                                delete e.headers[Xe.CONTENT_TYPE];
                                _context2.prev = 4;
                                _context2.next = 7;
                                return t(i);
                            case 7:
                                r = _context2.sent;
                                _context2.next = 13;
                                break;
                            case 10:
                                _context2.prev = 10;
                                _context2.t0 = _context2["catch"](4);
                                throw e.headers[Xe.CONTENT_TYPE] = s, _context2.t0;
                            case 13:
                                return _context2.abrupt("return", (e.headers[Xe.CONTENT_TYPE] = s, r));
                            case 14:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, null, [
                        [
                            4,
                            10
                        ]
                    ]);
                }));
                function tempRemoveContentHeader(_x7, _x8, _x9) {
                    return _tempRemoveContentHeader.apply(this, arguments);
                }
                return tempRemoveContentHeader;
            }()
        },
        {
            key: "displayError",
            value: function displayError(e, t) {
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Service error, please try again.";
                if (console.error(t), $8e4453fb4fc895c8$var$_typeof(t) == "object") return t instanceof Error ? e.addNewErrorMessage("service", t.message) : Array.isArray(t) || typeof t.error == "string" ? e.addNewErrorMessage("service", t) : Object.keys(t).length === 0 ? e.addNewErrorMessage("service", i) : e.addNewErrorMessage("service", JSON.stringify(t));
                e.addNewErrorMessage("service", t);
            }
        },
        {
            key: "fetch",
            value: function(_fetch) {
                function fetch1(_x3, _x4, _x5, _x6) {
                    return _fetch.apply(this, arguments);
                }
                fetch1.toString = function() {
                    return _fetch.toString();
                };
                return fetch1;
            }(function(e, t, i, s) {
                var o, a;
                var r = {
                    method: ((o = e.connectSettings) == null ? void 0 : o.method) || "POST",
                    headers: t
                };
                return r.method !== "GET" && (r.body = i ? JSON.stringify(s) : s), e.connectSettings.credentials && (r.credentials = e.connectSettings.credentials), fetch(((a = e.connectSettings) == null ? void 0 : a.url) || e.url || "", r);
            })
        },
        {
            key: "processResponseByType",
            value: function processResponseByType(e) {
                var t = e.headers.get("content-type");
                return t != null && t.includes("application/json") ? e.json() : t != null && t.includes("text/plain") || !t ? e : e.blob();
            }
        },
        {
            key: "processRequestInterceptor",
            value: function() {
                var _processRequestInterceptor = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee3(e, t) {
                    var o, i, s, r;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                _context3.next = 2;
                                return (o = e.requestInterceptor) == null ? void 0 : o.call(e, t);
                            case 2:
                                _context3.t0 = _context3.sent;
                                if (_context3.t0) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.t0 = t;
                            case 5:
                                i = _context3.t0;
                                s = i;
                                r = i;
                                return _context3.abrupt("return", {
                                    body: s.body,
                                    headers: s.headers,
                                    error: r.error
                                });
                            case 9:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function processRequestInterceptor(_x10, _x11) {
                    return _processRequestInterceptor.apply(this, arguments);
                }
                return processRequestInterceptor;
            }()
        },
        {
            key: "validateResponseFormat",
            value: function validateResponseFormat(e) {
                return e && $8e4453fb4fc895c8$var$_typeof(e) == "object" && (typeof e.error == "string" || typeof e.text == "string" || typeof e.html == "string" || Array.isArray(e.files));
            }
        },
        {
            key: "onInterceptorError",
            value: function onInterceptorError(e, t, i) {
                e.addNewErrorMessage("service", t), i == null || i();
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$Xe.CONTENT_TYPE = "Content-Type";
var $8e4453fb4fc895c8$var$E = $8e4453fb4fc895c8$var$Xe;
function $8e4453fb4fc895c8$var$Ao(_x12, _x13) {
    return $8e4453fb4fc895c8$var$_Ao.apply(this, arguments);
}
function $8e4453fb4fc895c8$var$_Ao() {
    $8e4453fb4fc895c8$var$_Ao = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee125(n, e) {
        var t, i;
        return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee125$(_context125) {
            while(true)switch(_context125.prev = _context125.next){
                case 0:
                    t = n.getReader();
                case 1:
                    _context125.next = 3;
                    return t.read();
                case 3:
                    if ((i = _context125.sent).done) {
                        _context125.next = 7;
                        break;
                    }
                    e(i.value);
                case 5:
                    _context125.next = 1;
                    break;
                case 7:
                case "end":
                    return _context125.stop();
            }
        }, _callee125);
    }));
    return $8e4453fb4fc895c8$var$_Ao.apply(this, arguments);
}
function $8e4453fb4fc895c8$var$Co(n) {
    var e, t, i, s = !1;
    return function(o) {
        e === void 0 ? (e = o, t = 0, i = -1) : e = $8e4453fb4fc895c8$var$ko(e, o);
        var a = e.length;
        var l = 0;
        for(; t < a;){
            s && (e[t] === 10 && (l = ++t), s = !1);
            var c = -1;
            for(; t < a && c === -1; ++t)switch(e[t]){
                case 58:
                    i === -1 && (i = t - l);
                    break;
                case 13:
                    s = !0;
                case 10:
                    c = t;
                    break;
            }
            if (c === -1) break;
            n(e.subarray(l, c), i), l = t, i = -1;
        }
        l === a ? e = void 0 : l !== 0 && (e = e.subarray(l), t -= l);
    };
}
function $8e4453fb4fc895c8$var$To(n, e, t) {
    var i = $8e4453fb4fc895c8$var$Qs();
    var s = new TextDecoder();
    return function(o, a) {
        if (o.length === 0) t == null || t(i), i = $8e4453fb4fc895c8$var$Qs();
        else if (a > 0) {
            var l = s.decode(o.subarray(0, a)), c = a + (o[a + 1] === 32 ? 2 : 1), d = s.decode(o.subarray(c));
            switch(l){
                case "data":
                    i.data = i.data ? i.data + "\n" + d : d;
                    break;
                case "event":
                    i.event = d;
                    break;
                case "id":
                    n(i.id = d);
                    break;
                case "retry":
                    var h = parseInt(d, 10);
                    isNaN(h) || e(i.retry = h);
                    break;
            }
        }
    };
}
function $8e4453fb4fc895c8$var$ko(n, e) {
    var t = new Uint8Array(n.length + e.length);
    return t.set(n), t.set(e, n.length), t;
}
function $8e4453fb4fc895c8$var$Qs() {
    return {
        data: "",
        event: "",
        id: "",
        retry: void 0
    };
}
var $8e4453fb4fc895c8$var$Mo = function Mo(n, e) {
    var t = {};
    for(var i in n)Object.prototype.hasOwnProperty.call(n, i) && e.indexOf(i) < 0 && (t[i] = n[i]);
    if (n != null && typeof Object.getOwnPropertySymbols == "function") for(var s = 0, i = Object.getOwnPropertySymbols(n); s < i.length; s++)e.indexOf(i[s]) < 0 && Object.prototype.propertyIsEnumerable.call(n, i[s]) && (t[i[s]] = n[i[s]]);
    return t;
};
var $8e4453fb4fc895c8$var$ps = "text/event-stream", $8e4453fb4fc895c8$var$Ro = 1e3, $8e4453fb4fc895c8$var$en = "last-event-id";
function $8e4453fb4fc895c8$var$Io(n, e) {
    var t = e.signal, i = e.headers, s = e.onopen, r = e.onmessage, o = e.onclose, a = e.onerror, l = e.openWhenHidden, c = e.fetch, d = $8e4453fb4fc895c8$var$Mo(e, [
        "signal",
        "headers",
        "onopen",
        "onmessage",
        "onclose",
        "onerror",
        "openWhenHidden",
        "fetch"
    ]);
    return new Promise(function(h, f) {
        var u = Object.assign({}, i);
        u.accept || (u.accept = $8e4453fb4fc895c8$var$ps);
        var m;
        function p() {
            m.abort(), document.hidden || L();
        }
        l || document.addEventListener("visibilitychange", p);
        var v = $8e4453fb4fc895c8$var$Ro, y = 0;
        function P() {
            document.removeEventListener("visibilitychange", p), window.clearTimeout(y), m.abort();
        }
        t == null || t.addEventListener("abort", function() {
            P(), h();
        });
        var V = c !== null && c !== void 0 ? c : window.fetch, Ue = s !== null && s !== void 0 ? s : $8e4453fb4fc895c8$var$Lo;
        function L() {
            return _L.apply(this, arguments);
        }
        function _L() {
            _L = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee4() {
                var Q, ee, F;
                return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while(true)switch(_context4.prev = _context4.next){
                        case 0:
                            m = new AbortController();
                            _context4.prev = 1;
                            _context4.next = 4;
                            return V(n, Object.assign(Object.assign({}, d), {
                                headers: u,
                                signal: m.signal
                            }));
                        case 4:
                            ee = _context4.sent;
                            _context4.next = 7;
                            return Ue(ee);
                        case 7:
                            _context4.next = 9;
                            return $8e4453fb4fc895c8$var$Ao(ee.body, $8e4453fb4fc895c8$var$Co($8e4453fb4fc895c8$var$To(function(F) {
                                F ? u[$8e4453fb4fc895c8$var$en] = F : delete u[$8e4453fb4fc895c8$var$en];
                            }, function(F) {
                                v = F;
                            }, r)));
                        case 9:
                            o == null || o();
                            P();
                            h();
                            _context4.next = 17;
                            break;
                        case 14:
                            _context4.prev = 14;
                            _context4.t0 = _context4["catch"](1);
                            if (!m.signal.aborted) try {
                                F = (Q = a == null ? void 0 : a(_context4.t0)) !== null && Q !== void 0 ? Q : v;
                                window.clearTimeout(y), y = window.setTimeout(L, F);
                            } catch (F) {
                                P(), f(F);
                            }
                        case 17:
                        case "end":
                            return _context4.stop();
                    }
                }, _callee4, null, [
                    [
                        1,
                        14
                    ]
                ]);
            }));
            return _L.apply(this, arguments);
        }
        L();
    });
}
function $8e4453fb4fc895c8$var$Lo(n) {
    var e = n.headers.get("content-type");
    if (!(e != null && e.startsWith($8e4453fb4fc895c8$var$ps))) throw new Error("Expected content-type to be ".concat($8e4453fb4fc895c8$var$ps, ", Actual: ").concat(e));
}
var $8e4453fb4fc895c8$var$T = /*#__PURE__*/ function() {
    function T() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, T);
    }
    return $8e4453fb4fc895c8$var$_createClass(T, null, [
        {
            key: "request",
            value: function() {
                var _request = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee7(e, t, i) {
                    var s, r, p, v, y, P, V, Ue, o, _yield$E$processReque, a, l, c, _e$streamHandlers, d, h, f, u, m, _args7 = arguments;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                s = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : !0;
                                r = _args7.length > 4 && _args7[4] !== undefined ? _args7[4] : !1;
                                o = {
                                    body: t,
                                    headers: (p = e.connectSettings) == null ? void 0 : p.headers
                                };
                                _context7.next = 5;
                                return $8e4453fb4fc895c8$var$E.processRequestInterceptor(e.deepChat, o);
                            case 5:
                                _yield$E$processReque = _context7.sent;
                                a = _yield$E$processReque.body;
                                l = _yield$E$processReque.headers;
                                c = _yield$E$processReque.error;
                                _e$streamHandlers = e.streamHandlers;
                                d = _e$streamHandlers.onOpen;
                                h = _e$streamHandlers.onClose;
                                f = _e$streamHandlers.abortStream;
                                if (!c) {
                                    _context7.next = 15;
                                    break;
                                }
                                return _context7.abrupt("return", $8e4453fb4fc895c8$var$E.onInterceptorError(i, c, h));
                            case 15:
                                if (!((v = e.connectSettings) != null && v.handler)) {
                                    _context7.next = 17;
                                    break;
                                }
                                return _context7.abrupt("return", $8e4453fb4fc895c8$var$Le.stream(e, a, i));
                            case 17:
                                if (!(((y = e.connectSettings) == null ? void 0 : y.url) === $8e4453fb4fc895c8$var$Ae.URL)) {
                                    _context7.next = 19;
                                    break;
                                }
                                return _context7.abrupt("return", $8e4453fb4fc895c8$var$Ae.requestStream(i, e.streamHandlers));
                            case 19:
                                u = new $8e4453fb4fc895c8$var$we(i), m = $8e4453fb4fc895c8$var$E.fetch.bind(this, e, l, s);
                                return _context7.abrupt("return", ($8e4453fb4fc895c8$var$Io(((P = e.connectSettings) == null ? void 0 : P.url) || e.url || "", {
                                    method: ((V = e.connectSettings) == null ? void 0 : V.method) || "POST",
                                    headers: l,
                                    credentials: (Ue = e.connectSettings) == null ? void 0 : Ue.credentials,
                                    body: s ? JSON.stringify(a) : a,
                                    openWhenHidden: !0,
                                    // keep stream open when browser tab not open
                                    onopen: function onopen(L) {
                                        return $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee5() {
                                            return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee5$(_context5) {
                                                while(true)switch(_context5.prev = _context5.next){
                                                    case 0:
                                                        if (!L.ok) {
                                                            _context5.next = 2;
                                                            break;
                                                        }
                                                        return _context5.abrupt("return", d());
                                                    case 2:
                                                        _context5.next = 4;
                                                        return $8e4453fb4fc895c8$var$E.processResponseByType(L);
                                                    case 4:
                                                        throw _context5.sent;
                                                    case 5:
                                                    case "end":
                                                        return _context5.stop();
                                                }
                                            }, _callee5);
                                        }))();
                                    },
                                    onmessage: function onmessage(L) {
                                        return $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee6() {
                                            var Q, ee, F, Ge, Rt;
                                            return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee6$(_context6) {
                                                while(true)switch(_context6.prev = _context6.next){
                                                    case 0:
                                                        if (!(JSON.stringify(L.data) !== JSON.stringify("[DONE]"))) {
                                                            _context6.next = 9;
                                                            break;
                                                        }
                                                        try {
                                                            Ge = JSON.parse(L.data);
                                                        } catch (_unused6) {
                                                            Ge = {};
                                                        }
                                                        _context6.next = 4;
                                                        return (ee = (Q = e.deepChat).responseInterceptor) == null ? void 0 : ee.call(Q, Ge);
                                                    case 4:
                                                        _context6.t0 = _context6.sent;
                                                        if (_context6.t0) {
                                                            _context6.next = 7;
                                                            break;
                                                        }
                                                        _context6.t0 = Ge;
                                                    case 7:
                                                        Rt = _context6.t0;
                                                        (F = e.extractResultData) == null || F.call(e, Rt, m, a).then(function(Ve) {
                                                            e.asyncCallInProgress && Ve && Ve.text !== "" ? (T.simulate(i, e.streamHandlers, Ve), h(), e.asyncCallInProgress = !1) : T.upsertWFiles(i, u.upsertStreamedMessage.bind(u), u, Ve);
                                                        })["catch"](function(Ve) {
                                                            return $8e4453fb4fc895c8$var$E.displayError(i, Ve);
                                                        });
                                                    case 9:
                                                    case "end":
                                                        return _context6.stop();
                                                }
                                            }, _callee6);
                                        }))();
                                    },
                                    onerror: function onerror(L) {
                                        throw h(), L;
                                    },
                                    onclose: function onclose() {
                                        if (!e.asyncCallInProgress) try {
                                            u.finaliseStreamedMessage(), h();
                                        } catch (L) {
                                            if (!r) throw L;
                                        }
                                    },
                                    signal: f.signal
                                })["catch"](function(L) {
                                    var Q;
                                    i.isLastMessageError() || (Q = e.extractResultData) == null || Q.call(e, L).then(function() {
                                        $8e4453fb4fc895c8$var$E.displayError(i, L);
                                    })["catch"](function(ee) {
                                        $8e4453fb4fc895c8$var$E.displayError(i, ee);
                                    });
                                }), u));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function request(_x14, _x15, _x16) {
                    return _request.apply(this, arguments);
                }
                return request;
            }()
        },
        {
            key: "simulate",
            value: function simulate(e, t, i) {
                var s = t;
                if (i.files && e.addNewMessage($8e4453fb4fc895c8$var$_objectSpread({
                    sendUpdate: !1,
                    ignoreText: !0
                }, i), !1), i.text) {
                    t.onOpen();
                    var r = i.text.split("");
                    T.populateMessages(r, new $8e4453fb4fc895c8$var$we(e), s, "text");
                }
                if (i.html) {
                    t.onOpen();
                    var _r2 = $8e4453fb4fc895c8$var$ne.splitHTML(i.html);
                    _r2.length === 0 && (_r2 = i.html.split("")), T.populateMessages(_r2, new $8e4453fb4fc895c8$var$we(e), s, "html");
                }
            }
        },
        {
            key: "populateMessages",
            value: function populateMessages(e, t, i, s) {
                var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
                var o = e[r];
                if (o) {
                    t.upsertStreamedMessage($8e4453fb4fc895c8$var$_defineProperty({}, s, o));
                    var a = setTimeout(function() {
                        T.populateMessages(e, t, i, s, r + 1);
                    }, i.simulationInterim || 6);
                    i.abortStream.abort = function() {
                        T.abort(a, t, i.onClose);
                    };
                } else t.finaliseStreamedMessage(), i.onClose();
            }
        },
        {
            key: "isSimulation",
            value: function isSimulation(e) {
                return $8e4453fb4fc895c8$var$_typeof(e) == "object" && !!e.simulation;
            }
        },
        {
            key: "isSimulatable",
            value: function isSimulatable(e, t) {
                return T.isSimulation(e) && t && (t.text || t.html);
            }
        },
        {
            key: "abort",
            value: function abort(e, t, i) {
                clearTimeout(e), t.finaliseStreamedMessage(), i();
            }
        },
        {
            key: "upsertWFiles",
            value: function upsertWFiles(e, t, i, s) {
                if (s != null && s.text || s != null && s.html) {
                    var _i9;
                    var r = t(s);
                    (_i9 = i) !== null && _i9 !== void 0 ? _i9 : i = r || void 0;
                }
                s != null && s.files && (e.addNewMessage({
                    files: s.files
                }), i == null || i.markFileAdded());
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Ye = /*#__PURE__*/ function() {
    function Ye() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ye);
    }
    return $8e4453fb4fc895c8$var$_createClass(Ye, null, [
        {
            key: "generateResponse",
            value: function generateResponse(e) {
                var t = e[e.length - 1][0];
                if (t.files && t.files.length > 0) {
                    if (t.files.length > 1) return "These are interesting files!";
                    var i = t.files[0];
                    return i.src && i.src.startsWith("data:image/gif") ? "That is a nice gif!" : i.type === "image" ? "That is a nice image!" : i.type === "audio" ? "I like the sound of that!" : "That is an interesting file!";
                }
                if (t.text) {
                    if (t.text.charAt(t.text.length - 1) === "?") return "I'm sorry but I can't answer that question...";
                    if (t.text.includes("updog")) return "What's updog?";
                }
                return "Hi there! This is a demo response!";
            }
        },
        {
            key: "getCustomResponse",
            value: function getCustomResponse(e, t) {
                return typeof e == "function" ? e(t) : e;
            }
        },
        {
            key: "getResponse",
            value: function getResponse(_ref3) {
                var e = _ref3.customDemoResponse, t = _ref3.messageToElements;
                return e ? Ye.getCustomResponse(e, t[t.length - 1][0]) : {
                    text: Ye.generateResponse(t)
                };
            }
        },
        {
            key: "request",
            value: function request(e, t) {
                var i = Ye.getResponse(t);
                setTimeout(/*#__PURE__*/ $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee8() {
                    var r, o, s;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                _context8.next = 2;
                                return (o = (r = e.deepChat).responseInterceptor) == null ? void 0 : o.call(r, i);
                            case 2:
                                _context8.t0 = _context8.sent;
                                if (_context8.t0) {
                                    _context8.next = 5;
                                    break;
                                }
                                _context8.t0 = i;
                            case 5:
                                s = _context8.t0;
                                s.error ? (t.addNewErrorMessage("service", s.error), e.completionsHandlers.onFinish()) : $8e4453fb4fc895c8$var$T.isSimulatable(e.stream, s) ? $8e4453fb4fc895c8$var$T.simulate(t, e.streamHandlers, s) : (t.addNewMessage(s), e.completionsHandlers.onFinish());
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8);
                })), 400);
            }
        },
        {
            key: "requestStream",
            value: function requestStream(e, t) {
                setTimeout(function() {
                    var i = Ye.getResponse(e);
                    $8e4453fb4fc895c8$var$T.simulate(e, t, i);
                }, 400);
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$Ye.URL = "deep-chat-demo";
var $8e4453fb4fc895c8$var$Ae = $8e4453fb4fc895c8$var$Ye;
var $8e4453fb4fc895c8$var$U = /*#__PURE__*/ function() {
    function U() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, U);
    }
    return $8e4453fb4fc895c8$var$_createClass(U, null, [
        {
            key: "setup",
            value: function setup(e) {
                e.connectSettings.url !== $8e4453fb4fc895c8$var$Ae.URL && (e.permittedErrorPrefixes = [
                    "Connection error",
                    "Error in server message"
                ], e.websocket = "pending");
            }
        },
        {
            key: "isElementPresentInDOM",
            value: function isElementPresentInDOM(e) {
                return e.getRootNode({
                    composed: !0
                }) instanceof Document;
            }
        },
        {
            key: "createConnection",
            value: function createConnection(e, t) {
                if (!U.isElementPresentInDOM(e.deepChat)) return;
                var i = e.connectSettings.websocket;
                if (i) {
                    if (e.connectSettings.handler) return $8e4453fb4fc895c8$var$Le.websocket(e, t);
                    try {
                        var s = typeof i != "boolean" ? i : void 0, r = new WebSocket(e.connectSettings.url || "", s);
                        e.websocket = r, e.websocket.onopen = function() {
                            var o, a;
                            t.removeError(), e.websocket && $8e4453fb4fc895c8$var$_typeof(e.websocket) == "object" && U.assignListeners(e, r, t), (a = (o = e.deepChat)._validationHandler) == null || a.call(o);
                        }, e.websocket.onerror = function(o) {
                            console.error(o), U.retryConnection(e, t);
                        };
                    } catch (s) {
                        console.error(s), U.retryConnection(e, t);
                    }
                }
            }
        },
        {
            key: "retryConnection",
            value: function retryConnection(e, t) {
                var i, s;
                (s = (i = e.deepChat)._validationHandler) == null || s.call(i), U.isElementPresentInDOM(e.deepChat) && (e.websocket = "pending", t.isLastMessageError() || t.addNewErrorMessage("service", "Connection error"), setTimeout(function() {
                    U.createConnection(e, t);
                }, 5e3));
            }
        },
        {
            key: "assignListeners",
            value: function assignListeners(e, t, i) {
                var _this6 = this;
                var s = {};
                t.onmessage = /*#__PURE__*/ function() {
                    var _ref5 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee9(r) {
                        var o, a, l, c, d, h, f;
                        return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee9$(_context9) {
                            while(true)switch(_context9.prev = _context9.next){
                                case 0:
                                    if (!e.extractResultData) {
                                        _context9.next = 20;
                                        break;
                                    }
                                    _context9.prev = 1;
                                    l = JSON.parse(r.data);
                                    _context9.next = 5;
                                    return (a = (o = e.deepChat).responseInterceptor) == null ? void 0 : a.call(o, l);
                                case 5:
                                    _context9.t0 = _context9.sent;
                                    if (_context9.t0) {
                                        _context9.next = 8;
                                        break;
                                    }
                                    _context9.t0 = l;
                                case 8:
                                    c = _context9.t0;
                                    _context9.next = 11;
                                    return e.extractResultData(c);
                                case 11:
                                    d = _context9.sent;
                                    if (!(!d || $8e4453fb4fc895c8$var$_typeof(d) != "object")) {
                                        _context9.next = 14;
                                        break;
                                    }
                                    throw Error($8e4453fb4fc895c8$var$M.INVALID_RESPONSE(l, "server", !!e.deepChat.responseInterceptor, c));
                                case 14:
                                    if ($8e4453fb4fc895c8$var$T.isSimulation(e.stream)) {
                                        h = U.stream.bind(_this6, e, i, s), f = s[l.role || $8e4453fb4fc895c8$var$b.AI_ROLE];
                                        $8e4453fb4fc895c8$var$T.upsertWFiles(i, h, f, d);
                                    } else i.addNewMessage(d);
                                    _context9.next = 20;
                                    break;
                                case 17:
                                    _context9.prev = 17;
                                    _context9.t1 = _context9["catch"](1);
                                    $8e4453fb4fc895c8$var$E.displayError(i, _context9.t1, "Error in server message");
                                case 20:
                                case "end":
                                    return _context9.stop();
                            }
                        }, _callee9, null, [
                            [
                                1,
                                17
                            ]
                        ]);
                    }));
                    return function(_x17) {
                        return _ref5.apply(this, arguments);
                    };
                }(), t.onclose = function() {
                    console.error("Connection closed"), i.isLastMessageError() || i.addNewErrorMessage("service", "Connection error"), e.stream && e.streamHandlers.abortStream.abort(), U.createConnection(e, i);
                };
            }
        },
        {
            key: "sendWebsocket",
            value: function() {
                var _sendWebsocket = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee10(e, t, i) {
                    var s, d, h, r, o, _yield$E$processReque2, a, l, c, _args10 = arguments;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                s = _args10.length > 3 && _args10[3] !== undefined ? _args10[3] : !0;
                                r = e.websocket;
                                if (!(!r || r === "pending")) {
                                    _context10.next = 4;
                                    break;
                                }
                                return _context10.abrupt("return");
                            case 4:
                                o = {
                                    body: t,
                                    headers: (d = e.connectSettings) == null ? void 0 : d.headers
                                };
                                _context10.next = 7;
                                return $8e4453fb4fc895c8$var$E.processRequestInterceptor(e.deepChat, o);
                            case 7:
                                _yield$E$processReque2 = _context10.sent;
                                a = _yield$E$processReque2.body;
                                l = _yield$E$processReque2.error;
                                if (!l) {
                                    _context10.next = 12;
                                    break;
                                }
                                return _context10.abrupt("return", i.addNewErrorMessage("service", l));
                            case 12:
                                if (U.isWebSocket(r)) {
                                    _context10.next = 14;
                                    break;
                                }
                                return _context10.abrupt("return", r.newUserMessage.listener(a));
                            case 14:
                                c = s ? JSON.stringify(a) : a;
                                if (!(((h = e.connectSettings) == null ? void 0 : h.url) === $8e4453fb4fc895c8$var$Ae.URL)) {
                                    _context10.next = 17;
                                    break;
                                }
                                return _context10.abrupt("return", $8e4453fb4fc895c8$var$Ae.request(e, i));
                            case 17:
                                r.readyState === void 0 || r.readyState !== r.OPEN ? (console.error("Connection is not open"), i.isLastMessageError() || i.addNewErrorMessage("service", "Connection error")) : (r.send(JSON.stringify(c)), e.completionsHandlers.onFinish());
                            case 18:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10);
                }));
                function sendWebsocket(_x18, _x19, _x20) {
                    return _sendWebsocket.apply(this, arguments);
                }
                return sendWebsocket;
            }()
        },
        {
            key: "canSendMessage",
            value: function canSendMessage(e) {
                return e ? e === "pending" ? !1 : U.isWebSocket(e) ? e.readyState !== void 0 && e.readyState === e.OPEN : e.isOpen : !0;
            }
        },
        {
            key: "isWebSocket",
            value: function isWebSocket(e) {
                return e.send !== void 0;
            }
        },
        {
            key: "stream",
            value: function stream(e, t, i, s) {
                if (!s) return;
                var r = e.stream.simulation;
                if (typeof r == "string") {
                    var _i$o;
                    var o = s.role || $8e4453fb4fc895c8$var$b.AI_ROLE, a = i[o];
                    s.text === r || s.html === r ? (a == null || a.finaliseStreamedMessage(), delete i[o]) : ((_i$o = i[o]) !== null && _i$o !== void 0 ? _i$o : i[o] = new $8e4453fb4fc895c8$var$we(t), i[o].upsertStreamedMessage(s));
                } else $8e4453fb4fc895c8$var$T.simulate(t, e.streamHandlers, s);
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Le = /*#__PURE__*/ function() {
    function Le() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Le);
    }
    return $8e4453fb4fc895c8$var$_createClass(Le, null, [
        {
            key: "request",
            value: function() {
                var _request2 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee12(e, t, i) {
                    var a, l, s, r, o;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                s = !0;
                                r = /*#__PURE__*/ function() {
                                    var _ref6 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee11(c) {
                                        var h, f, d;
                                        return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee11$(_context11) {
                                            while(true)switch(_context11.prev = _context11.next){
                                                case 0:
                                                    if (s) {
                                                        _context11.next = 2;
                                                        break;
                                                    }
                                                    return _context11.abrupt("return");
                                                case 2:
                                                    s = !1;
                                                    _context11.next = 5;
                                                    return (f = (h = e.deepChat).responseInterceptor) == null ? void 0 : f.call(h, c);
                                                case 5:
                                                    _context11.t0 = _context11.sent;
                                                    if (_context11.t0) {
                                                        _context11.next = 8;
                                                        break;
                                                    }
                                                    _context11.t0 = c;
                                                case 8:
                                                    d = _context11.t0;
                                                    $8e4453fb4fc895c8$var$E.validateResponseFormat(d) ? typeof d.error == "string" ? (console.error(d.error), i.addNewErrorMessage("service", d.error), e.completionsHandlers.onFinish()) : $8e4453fb4fc895c8$var$T.isSimulatable(e.stream, d) ? $8e4453fb4fc895c8$var$T.simulate(i, e.streamHandlers, d) : (i.addNewMessage(d), e.completionsHandlers.onFinish()) : (console.error($8e4453fb4fc895c8$var$M.INVALID_RESPONSE(c, "server", !!e.deepChat.responseInterceptor, d)), i.addNewErrorMessage("service", "Error in server message"), e.completionsHandlers.onFinish());
                                                case 10:
                                                case "end":
                                                    return _context11.stop();
                                            }
                                        }, _callee11);
                                    }));
                                    return function r(_x24) {
                                        return _ref6.apply(this, arguments);
                                    };
                                }(), o = Le.generateOptionalSignals();
                                (l = (a = e.connectSettings).handler) == null || l.call(a, t, $8e4453fb4fc895c8$var$_objectSpread($8e4453fb4fc895c8$var$_objectSpread({}, o), {}, {
                                    onResponse: r
                                }));
                            case 3:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12);
                }));
                function request(_x21, _x22, _x23) {
                    return _request2.apply(this, arguments);
                }
                return request;
            }()
        },
        {
            key: "attemptToFinaliseStream",
            value: function attemptToFinaliseStream(e, t) {
                try {
                    var i = t.messageElementRefs[t.messageElementRefs.length - 1];
                    $8e4453fb4fc895c8$var$Be.isLoadingMessage(i) ? t.removeLastMessage() : e.finaliseStreamedMessage();
                } catch (i) {
                    console.error(i), t.addNewErrorMessage("service", i);
                }
            }
        },
        {
            key: "stream",
            value: function stream(e, t, i) {
                var h, f;
                var s = !0, r = !1;
                var o = new $8e4453fb4fc895c8$var$we(i), a = function a() {
                    r || !s || (e.streamHandlers.onOpen(), r = !0);
                }, l = function l() {
                    s && (Le.attemptToFinaliseStream(o, i), e.streamHandlers.onClose(), s = !1);
                }, c = /*#__PURE__*/ function() {
                    var _ref7 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee13(u) {
                        var p, v, m;
                        return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee13$(_context13) {
                            while(true)switch(_context13.prev = _context13.next){
                                case 0:
                                    if (s) {
                                        _context13.next = 2;
                                        break;
                                    }
                                    return _context13.abrupt("return");
                                case 2:
                                    _context13.next = 4;
                                    return (v = (p = e.deepChat).responseInterceptor) == null ? void 0 : v.call(p, u);
                                case 4:
                                    _context13.t0 = _context13.sent;
                                    if (_context13.t0) {
                                        _context13.next = 7;
                                        break;
                                    }
                                    _context13.t0 = u;
                                case 7:
                                    m = _context13.t0;
                                    $8e4453fb4fc895c8$var$E.validateResponseFormat(m) ? m.error ? (console.error(m.error), o.finaliseStreamedMessage(), i.addNewErrorMessage("service", m.error), e.streamHandlers.onClose(), s = !1) : $8e4453fb4fc895c8$var$T.upsertWFiles(i, o.upsertStreamedMessage.bind(o), o, m) : console.error($8e4453fb4fc895c8$var$M.INVALID_RESPONSE(u, "server", !!e.deepChat.responseInterceptor, m));
                                case 9:
                                case "end":
                                    return _context13.stop();
                            }
                        }, _callee13);
                    }));
                    return function c(_x25) {
                        return _ref7.apply(this, arguments);
                    };
                }();
                e.streamHandlers.abortStream.abort = function() {
                    Le.attemptToFinaliseStream(o, i), e.streamHandlers.onClose(), s = !1;
                };
                var d = Le.generateOptionalSignals();
                (f = (h = e.connectSettings).handler) == null || f.call(h, t, $8e4453fb4fc895c8$var$_objectSpread($8e4453fb4fc895c8$var$_objectSpread({}, d), {}, {
                    onOpen: a,
                    onResponse: c,
                    onClose: l,
                    stopClicked: e.streamHandlers.stopClicked
                }));
            }
        },
        {
            key: "websocket",
            value: function websocket(e, t) {
                var _this7 = this;
                var l, c;
                var i = {
                    isOpen: !1,
                    newUserMessage: {
                        listener: function listener() {}
                    },
                    roleToStream: {}
                };
                e.websocket = i;
                var s = function s() {
                    t.removeError(), i.isOpen = !0;
                }, r = function r() {
                    i.isOpen = !1;
                }, o = /*#__PURE__*/ function() {
                    var _ref8 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee14(d) {
                        var f, u, h, m, p;
                        return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee14$(_context14) {
                            while(true)switch(_context14.prev = _context14.next){
                                case 0:
                                    if (i.isOpen) {
                                        _context14.next = 2;
                                        break;
                                    }
                                    return _context14.abrupt("return");
                                case 2:
                                    _context14.next = 4;
                                    return (u = (f = e.deepChat).responseInterceptor) == null ? void 0 : u.call(f, d);
                                case 4:
                                    _context14.t0 = _context14.sent;
                                    if (_context14.t0) {
                                        _context14.next = 7;
                                        break;
                                    }
                                    _context14.t0 = d;
                                case 7:
                                    h = _context14.t0;
                                    if (!$8e4453fb4fc895c8$var$E.validateResponseFormat(h)) console.error($8e4453fb4fc895c8$var$M.INVALID_RESPONSE(d, "server", !!e.deepChat.responseInterceptor, h)), t.addNewErrorMessage("service", "Error in server message");
                                    else if (typeof h.error == "string") console.error(h.error), t.isLastMessageError() || t.addNewErrorMessage("service", h.error);
                                    else if ($8e4453fb4fc895c8$var$T.isSimulation(e.stream)) {
                                        m = $8e4453fb4fc895c8$var$U.stream.bind(_this7, e, t, i.roleToStream), p = i.roleToStream[d.role || $8e4453fb4fc895c8$var$b.AI_ROLE];
                                        $8e4453fb4fc895c8$var$T.upsertWFiles(t, m, p, d);
                                    } else t.addNewMessage(h);
                                case 9:
                                case "end":
                                    return _context14.stop();
                            }
                        }, _callee14);
                    }));
                    return function o(_x26) {
                        return _ref8.apply(this, arguments);
                    };
                }(), a = Le.generateOptionalSignals();
                (c = (l = e.connectSettings).handler) == null || c.call(l, void 0, $8e4453fb4fc895c8$var$_objectSpread($8e4453fb4fc895c8$var$_objectSpread({}, a), {}, {
                    onOpen: s,
                    onResponse: o,
                    onClose: r,
                    newUserMessage: i.newUserMessage
                }));
            }
        },
        {
            key: "generateOptionalSignals",
            value: function generateOptionalSignals() {
                return {
                    onClose: function onClose() {},
                    onOpen: function onOpen() {},
                    stopClicked: {
                        listener: function listener() {}
                    },
                    newUserMessage: {
                        listener: function listener() {}
                    }
                };
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$C = /*#__PURE__*/ function() {
    function C() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, C);
    }
    return $8e4453fb4fc895c8$var$_createClass(C, null, [
        {
            key: "request",
            value: function() {
                var _request3 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee16(e, t, i) {
                    var s, f, u, m, r, _yield$E$processReque3, o, a, l, c, d, h, _args16 = arguments;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee16$(_context16) {
                        while(true)switch(_context16.prev = _context16.next){
                            case 0:
                                s = _args16.length > 3 && _args16[3] !== undefined ? _args16[3] : !0;
                                r = {
                                    body: t,
                                    headers: (f = e.connectSettings) == null ? void 0 : f.headers
                                };
                                _context16.next = 4;
                                return $8e4453fb4fc895c8$var$E.processRequestInterceptor(e.deepChat, r);
                            case 4:
                                _yield$E$processReque3 = _context16.sent;
                                o = _yield$E$processReque3.body;
                                a = _yield$E$processReque3.headers;
                                l = _yield$E$processReque3.error;
                                c = e.completionsHandlers.onFinish;
                                if (!l) {
                                    _context16.next = 11;
                                    break;
                                }
                                return _context16.abrupt("return", $8e4453fb4fc895c8$var$E.onInterceptorError(i, l, c));
                            case 11:
                                if (!((u = e.connectSettings) != null && u.handler)) {
                                    _context16.next = 13;
                                    break;
                                }
                                return _context16.abrupt("return", $8e4453fb4fc895c8$var$Le.request(e, o, i));
                            case 13:
                                if (!(((m = e.connectSettings) == null ? void 0 : m.url) === $8e4453fb4fc895c8$var$Ae.URL)) {
                                    _context16.next = 15;
                                    break;
                                }
                                return _context16.abrupt("return", $8e4453fb4fc895c8$var$Ae.request(e, i));
                            case 15:
                                d = !0;
                                h = $8e4453fb4fc895c8$var$E.fetch.bind(this, e, a, s);
                                h(o).then(function(p) {
                                    return d = !!p.ok, p;
                                }).then(function(p) {
                                    return $8e4453fb4fc895c8$var$E.processResponseByType(p);
                                }).then(/*#__PURE__*/ function() {
                                    var _ref9 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee15(p) {
                                        var P, V, v, y;
                                        return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee15$(_context15) {
                                            while(true)switch(_context15.prev = _context15.next){
                                                case 0:
                                                    if (e.extractResultData) {
                                                        _context15.next = 2;
                                                        break;
                                                    }
                                                    return _context15.abrupt("return");
                                                case 2:
                                                    _context15.next = 4;
                                                    return (V = (P = e.deepChat).responseInterceptor) == null ? void 0 : V.call(P, p);
                                                case 4:
                                                    _context15.t0 = _context15.sent;
                                                    if (_context15.t0) {
                                                        _context15.next = 7;
                                                        break;
                                                    }
                                                    _context15.t0 = p;
                                                case 7:
                                                    v = _context15.t0;
                                                    _context15.next = 10;
                                                    return e.extractResultData(v, h, o);
                                                case 10:
                                                    y = _context15.sent;
                                                    if (d) {
                                                        _context15.next = 13;
                                                        break;
                                                    }
                                                    throw p;
                                                case 13:
                                                    if (!(!y || $8e4453fb4fc895c8$var$_typeof(y) != "object")) {
                                                        _context15.next = 15;
                                                        break;
                                                    }
                                                    throw Error($8e4453fb4fc895c8$var$M.INVALID_RESPONSE(p, "response", !!e.deepChat.responseInterceptor, v));
                                                case 15:
                                                    y.makingAnotherRequest || ($8e4453fb4fc895c8$var$T.isSimulatable(e.stream, y) ? $8e4453fb4fc895c8$var$T.simulate(i, e.streamHandlers, y) : (i.addNewMessage(y), c()));
                                                case 16:
                                                case "end":
                                                    return _context15.stop();
                                            }
                                        }, _callee15);
                                    }));
                                    return function(_x30) {
                                        return _ref9.apply(this, arguments);
                                    };
                                }())["catch"](function(p) {
                                    $8e4453fb4fc895c8$var$E.displayError(i, p), c();
                                });
                            case 18:
                            case "end":
                                return _context16.stop();
                        }
                    }, _callee16, this);
                }));
                function request(_x27, _x28, _x29) {
                    return _request3.apply(this, arguments);
                }
                return request;
            }()
        },
        {
            key: "executePollRequest",
            value: function executePollRequest(e, t, i, s) {
                var r = e.completionsHandlers.onFinish;
                fetch(t, i).then(function(o) {
                    return o.json();
                }).then(/*#__PURE__*/ function() {
                    var _ref10 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee17(o) {
                        var l, c, a;
                        return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee17$(_context17) {
                            while(true)switch(_context17.prev = _context17.next){
                                case 0:
                                    if (e.extractPollResultData) {
                                        _context17.next = 2;
                                        break;
                                    }
                                    return _context17.abrupt("return");
                                case 2:
                                    _context17.t0 = e;
                                    _context17.next = 5;
                                    return (c = (l = e.deepChat).responseInterceptor) == null ? void 0 : c.call(l, o);
                                case 5:
                                    _context17.t1 = _context17.sent;
                                    if (_context17.t1) {
                                        _context17.next = 8;
                                        break;
                                    }
                                    _context17.t1 = o;
                                case 8:
                                    _context17.t2 = _context17.t1;
                                    _context17.next = 11;
                                    return _context17.t0.extractPollResultData.call(_context17.t0, _context17.t2);
                                case 11:
                                    a = _context17.sent;
                                    a.timeoutMS ? setTimeout(function() {
                                        C.executePollRequest(e, t, i, s);
                                    }, a.timeoutMS) : $8e4453fb4fc895c8$var$T.isSimulatable(e.stream, a) ? $8e4453fb4fc895c8$var$T.simulate(s, e.streamHandlers, a) : (s.addNewMessage(a), r());
                                case 13:
                                case "end":
                                    return _context17.stop();
                            }
                        }, _callee17);
                    }));
                    return function(_x31) {
                        return _ref10.apply(this, arguments);
                    };
                }())["catch"](function(o) {
                    $8e4453fb4fc895c8$var$E.displayError(s, o), r();
                });
            }
        },
        {
            key: "poll",
            value: function() {
                var _poll = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee18(e, t, i) {
                    var s, u, m, p, r, _yield$E$processReque4, o, a, l, c, d, h, f, _args18 = arguments;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee18$(_context18) {
                        while(true)switch(_context18.prev = _context18.next){
                            case 0:
                                s = _args18.length > 3 && _args18[3] !== undefined ? _args18[3] : !0;
                                r = {
                                    body: t,
                                    headers: (u = e.connectSettings) == null ? void 0 : u.headers
                                };
                                _context18.next = 4;
                                return $8e4453fb4fc895c8$var$E.processRequestInterceptor(e.deepChat, r);
                            case 4:
                                _yield$E$processReque4 = _context18.sent;
                                o = _yield$E$processReque4.body;
                                a = _yield$E$processReque4.headers;
                                l = _yield$E$processReque4.error;
                                if (!l) {
                                    _context18.next = 10;
                                    break;
                                }
                                return _context18.abrupt("return", $8e4453fb4fc895c8$var$E.onInterceptorError(i, l));
                            case 10:
                                c = ((m = e.connectSettings) == null ? void 0 : m.url) || e.url || "", d = ((p = e.connectSettings) == null ? void 0 : p.method) || "POST", h = s ? JSON.stringify(o) : o, f = {
                                    method: d,
                                    body: h,
                                    headers: a
                                };
                                e.connectSettings.credentials && (f.credentials = e.connectSettings.credentials), C.executePollRequest(e, c, f, i);
                            case 12:
                            case "end":
                                return _context18.stop();
                        }
                    }, _callee18);
                }));
                function poll(_x32, _x33, _x34) {
                    return _poll.apply(this, arguments);
                }
                return poll;
            }() // prettier-ignore
        },
        {
            key: "verifyKey",
            value: function verifyKey(e, t, i, s, r, o, a, l, c) {
                if (e === "") return o($8e4453fb4fc895c8$var$M.INVALID_KEY);
                a(), fetch(t, {
                    method: s,
                    headers: i,
                    body: c || null
                }).then(function(d) {
                    return $8e4453fb4fc895c8$var$E.processResponseByType(d);
                }).then(function(d) {
                    l(d, e, r, o);
                })["catch"](function(d) {
                    o($8e4453fb4fc895c8$var$M.CONNECTION_FAILED), console.error(d);
                });
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$yt = /*#__PURE__*/ function() {
    function yt(e, t, i) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, yt);
        this._isLoading = !1, this._isPaginationComplete = !1, this._index = 0, this._messages = t, i.fetchHistory && this.fetchHistory(i.fetchHistory), e.loadHistory && this.setupLoadHistoryOnScroll(e.loadHistory), this.setupInitialHistory(e);
    }
    return $8e4453fb4fc895c8$var$_createClass(yt, [
        {
            key: "fetchHistory",
            value: function() {
                var _fetchHistory = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee19(e) {
                    var _this8 = this;
                    var t, i;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee19$(_context19) {
                        while(true)switch(_context19.prev = _context19.next){
                            case 0:
                                t = $8e4453fb4fc895c8$var$De.addMessage(this._messages);
                                _context19.next = 3;
                                return e();
                            case 3:
                                i = _context19.sent;
                                this._messages.removeMessage(t), i.forEach(function(s) {
                                    return _this8._messages.addAnyMessage(s, !0);
                                }), setTimeout(function() {
                                    return $8e4453fb4fc895c8$var$X.scrollToBottom(_this8._messages.elementRef);
                                }, 0);
                            case 5:
                            case "end":
                                return _context19.stop();
                        }
                    }, _callee19, this);
                }));
                function fetchHistory(_x35) {
                    return _fetchHistory.apply(this, arguments);
                }
                return fetchHistory;
            }()
        },
        {
            key: "processLoadedHistory",
            value: function processLoadedHistory(e) {
                var _this9 = this;
                var a;
                var _this$_messages = this._messages, t = _this$_messages.messageElementRefs, i = _this$_messages.messageToElements, s = _this$_messages.elementRef, r = (a = t.find(function(l) {
                    return !l.outerContainer.classList.contains($8e4453fb4fc895c8$var$Be.INTRO_CLASS);
                })) == null ? void 0 : a.outerContainer, o = s.scrollTop;
                e == null || e.reverse().map(function(l) {
                    var c = _this9._messages.addAnyMessage($8e4453fb4fc895c8$var$_objectSpread($8e4453fb4fc895c8$var$_objectSpread({}, l), {}, {
                        sendUpdate: !0
                    }), !0, !0);
                    if (c) {
                        var d = $8e4453fb4fc895c8$var$b.generateMessageBody(c, t);
                        i.unshift([
                            c,
                            d
                        ]);
                    }
                    return c;
                }).filter(function(l) {
                    return !!l;
                }).reverse().forEach(function(l) {
                    return _this9._messages.sendClientUpdate(l, !0);
                }), r && (s.scrollTop = o + r.offsetTop - 40);
            }
        },
        {
            key: "populateMessages",
            value: function populateMessages(e, t) {
                this._messages.removeMessage(e), this._isPaginationComplete = t.findIndex(function(s) {
                    return !s;
                }) < 0;
                var i = t.filter(function(s) {
                    return !!s;
                });
                this.processLoadedHistory(i);
            }
        },
        {
            key: "setupLoadHistoryOnScroll",
            value: function() {
                var _setupLoadHistoryOnScroll = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee21(e) {
                    var _this10 = this;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee21$(_context21) {
                        while(true)switch(_context21.prev = _context21.next){
                            case 0:
                                this._messages.elementRef.onscroll = /*#__PURE__*/ $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee20() {
                                    var t, i;
                                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee20$(_context20) {
                                        while(true)switch(_context20.prev = _context20.next){
                                            case 0:
                                                if (!(!_this10._isLoading && !_this10._isPaginationComplete && _this10._messages.elementRef.scrollTop === 0)) {
                                                    _context20.next = 13;
                                                    break;
                                                }
                                                _this10._isLoading = !0;
                                                t = $8e4453fb4fc895c8$var$De.addMessage(_this10._messages, !1);
                                                _context20.prev = 3;
                                                _context20.next = 6;
                                                return e(_this10._index++);
                                            case 6:
                                                i = _context20.sent;
                                                _this10.populateMessages(t, i), _this10._isLoading = !1;
                                                _context20.next = 13;
                                                break;
                                            case 10:
                                                _context20.prev = 10;
                                                _context20.t0 = _context20["catch"](3);
                                                _this10._messages.removeMessage(t), _this10._isPaginationComplete = !0, _this10._messages.addNewErrorMessage("service", yt.FAILED_ERROR_MESSAGE, !0), console.error(_context20.t0);
                                            case 13:
                                            case "end":
                                                return _context20.stop();
                                        }
                                    }, _callee20, null, [
                                        [
                                            3,
                                            10
                                        ]
                                    ]);
                                }));
                            case 1:
                            case "end":
                                return _context21.stop();
                        }
                    }, _callee21, this);
                }));
                function setupLoadHistoryOnScroll(_x36) {
                    return _setupLoadHistoryOnScroll.apply(this, arguments);
                }
                return setupLoadHistoryOnScroll;
            }()
        },
        {
            key: "populateInitialHistory",
            value: function populateInitialHistory(e) {
                var _this11 = this;
                e.forEach(function(t) {
                    $8e4453fb4fc895c8$var$Y.processHistoryFile(t), _this11._messages.addNewMessage(t, !0);
                });
            }
        },
        {
            key: "loadInitialHistory",
            value: function() {
                var _loadInitialHistory = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee22(e) {
                    var _this12 = this;
                    var t, i, s;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee22$(_context22) {
                        while(true)switch(_context22.prev = _context22.next){
                            case 0:
                                this._isLoading = !0;
                                t = $8e4453fb4fc895c8$var$De.addMessage(this._messages);
                                _context22.prev = 2;
                                _context22.next = 5;
                                return e(this._index++);
                            case 5:
                                i = _context22.sent;
                                s = this._messages.elementRef.scrollTop;
                                this.populateMessages(t, i), s === 0 && setTimeout(function() {
                                    return $8e4453fb4fc895c8$var$X.scrollToBottom(_this12._messages.elementRef);
                                }, 0);
                                _context22.next = 13;
                                break;
                            case 10:
                                _context22.prev = 10;
                                _context22.t0 = _context22["catch"](2);
                                this._messages.removeMessage(t), this._isPaginationComplete = !0, this._messages.addNewErrorMessage("service", yt.FAILED_ERROR_MESSAGE, !0), console.error(_context22.t0);
                            case 13:
                                this._isLoading = !1;
                            case 14:
                            case "end":
                                return _context22.stop();
                        }
                    }, _callee22, this, [
                        [
                            2,
                            10
                        ]
                    ]);
                }));
                function loadInitialHistory(_x37) {
                    return _loadInitialHistory.apply(this, arguments);
                }
                return loadInitialHistory;
            }()
        },
        {
            key: "setupInitialHistory",
            value: function() {
                var _setupInitialHistory = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee23(e) {
                    var t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee23$(_context23) {
                        while(true)switch(_context23.prev = _context23.next){
                            case 0:
                                e.loadHistory && this.loadInitialHistory(e.loadHistory);
                                t = e.history || $8e4453fb4fc895c8$var$Y.processHistory(e);
                                t && (this.populateInitialHistory(t), this._index += 1);
                            case 3:
                            case "end":
                                return _context23.stop();
                        }
                    }, _callee23, this);
                }));
                function setupInitialHistory(_x38) {
                    return _setupInitialHistory.apply(this, arguments);
                }
                return setupInitialHistory;
            }()
        }
    ], [
        {
            key: "addErrorPrefix",
            value: function addErrorPrefix(e) {
                var _e$permittedErrorPref;
                (_e$permittedErrorPref = e.permittedErrorPrefixes) !== null && _e$permittedErrorPref !== void 0 ? _e$permittedErrorPref : e.permittedErrorPrefixes = [], e.permittedErrorPrefixes.push(yt.FAILED_ERROR_MESSAGE);
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$yt.FAILED_ERROR_MESSAGE = "Failed to load history";
var $8e4453fb4fc895c8$var$$t = $8e4453fb4fc895c8$var$yt;
var $8e4453fb4fc895c8$var$Tt = /*#__PURE__*/ function() {
    function Tt() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Tt);
    }
    return $8e4453fb4fc895c8$var$_createClass(Tt, null, [
        {
            key: "getCharacterLimitMessages",
            value: function getCharacterLimitMessages(e, t) {
                var r;
                if (t === -1) return e;
                var i = 0, s = e.length - 1;
                for(s; s >= 0; s -= 1){
                    var o = (r = e[s]) == null ? void 0 : r.text;
                    if (o !== void 0 && (i += o.length, i > t)) {
                        e[s].text = o.substring(0, o.length - (i - t));
                        break;
                    }
                }
                return e.slice(Math.max(s, 0));
            }
        },
        {
            key: "getMaxMessages",
            value: function getMaxMessages(e, t) {
                return e.slice(Math.max(e.length - t, 0));
            }
        },
        {
            key: "processMessages",
            value: function processMessages(e, t, i) {
                return t !== void 0 ? t > 0 && (e = Tt.getMaxMessages(e, t)) : e = [
                    e[e.length - 1]
                ], e = JSON.parse(JSON.stringify(e)), i === void 0 ? e : Tt.getCharacterLimitMessages(e, i);
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$O = /*#__PURE__*/ function() {
    function O() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, O);
    }
    return $8e4453fb4fc895c8$var$_createClass(O, null, [
        {
            key: "parseConfig",
            value: // prettier-ignore
            function parseConfig(e, t, i, s) {
                var o;
                var r = {
                    files: t
                };
                if ($8e4453fb4fc895c8$var$_typeof(s) == "object") {
                    $8e4453fb4fc895c8$var$Y.processFileConfigConnect(s);
                    var a = s.files, l = s.connect, c = s.button;
                    a && (a.infoModal && (r.files.infoModal = a.infoModal, (o = a.infoModal) != null && o.textMarkDown && (r.infoModalTextMarkUp = i.render(a.infoModal.textMarkDown))), a.acceptedFormats && (r.files.acceptedFormats = a.acceptedFormats), a.maxNumberOfFiles && (r.files.maxNumberOfFiles = a.maxNumberOfFiles)), r.button = c, l && (l.headers || l.method || l.url || l.credentials || e.headers || e.method || e.url || e.credentials) && (r.connect = {
                        url: (l == null ? void 0 : l.url) || e.url,
                        method: (l == null ? void 0 : l.method) || e.method,
                        headers: (l == null ? void 0 : l.headers) || e.headers,
                        credentials: (l == null ? void 0 : l.credentials) || e.credentials
                    });
                }
                return r;
            }
        },
        {
            key: "processMixedFiles",
            value: function processMixedFiles(e, t, i) {
                if (i) {
                    var s = {
                        acceptedFormats: ""
                    };
                    e.fileTypes.mixedFiles = O.parseConfig(e.connectSettings, s, t, i);
                }
            }
        },
        {
            key: "processMicrophone",
            value: function processMicrophone(e, t, i, s) {
                var _l$files, _f$maxNumberOfFiles;
                var a, l, c, d, h, f;
                var o = $8e4453fb4fc895c8$var$_objectSpread({
                    acceptedFormats: "audio/*"
                }, ((a = e.fileTypes.audio) == null ? void 0 : a.files) || {});
                i && (navigator.mediaDevices.getUserMedia !== void 0 ? (e.recordAudio = O.parseConfig(e.connectSettings, o, t, i), $8e4453fb4fc895c8$var$_typeof(i) == "object" && i.files && ((_l$files = (l = e.recordAudio).files) !== null && _l$files !== void 0 ? _l$files : l.files = {}, e.recordAudio.files.format = (c = i.files) == null ? void 0 : c.format, e.recordAudio.files.maxDurationSeconds = (d = i.files) == null ? void 0 : d.maxDurationSeconds, (h = e.fileTypes.audio) != null && h.files && ((_f$maxNumberOfFiles = (f = e.fileTypes.audio.files).maxNumberOfFiles) !== null && _f$maxNumberOfFiles !== void 0 ? _f$maxNumberOfFiles : f.maxNumberOfFiles = i.files.maxNumberOfFiles))) : s || (e.fileTypes.audio = O.parseConfig(e.connectSettings, o, t, i)));
            }
        },
        {
            key: "processAudioConfig",
            value: function processAudioConfig(e, t, i, s) {
                if (!i && !s) return;
                var o = $8e4453fb4fc895c8$var$_objectSpread({
                    acceptedFormats: "audio/*"
                }, (s == null ? void 0 : s.files) || {});
                e.fileTypes.audio = O.parseConfig(e.connectSettings, o, t, i);
            }
        },
        {
            key: "processGifConfig",
            value: function processGifConfig(e, t, i, s) {
                if (!i && !s) return;
                var o = $8e4453fb4fc895c8$var$_objectSpread({
                    acceptedFormats: "image/gif"
                }, (s == null ? void 0 : s.files) || {});
                e.fileTypes.gifs = O.parseConfig(e.connectSettings, o, t, i);
            }
        },
        {
            key: "processCamera",
            value: function processCamera(e, t, i, s) {
                var _l$files2;
                var a, l, c, d;
                var o = $8e4453fb4fc895c8$var$_objectSpread({
                    acceptedFormats: "image/*"
                }, ((a = e.fileTypes.images) == null ? void 0 : a.files) || {});
                i && (navigator.mediaDevices.getUserMedia !== void 0 ? (e.camera = O.parseConfig(e.connectSettings, o, t, i), $8e4453fb4fc895c8$var$_typeof(i) == "object" && (e.camera.modalContainerStyle = i.modalContainerStyle, i.files && ((_l$files2 = (l = e.camera).files) !== null && _l$files2 !== void 0 ? _l$files2 : l.files = {}, e.camera.files.format = (c = i.files) == null ? void 0 : c.format, e.camera.files.dimensions = (d = i.files) == null ? void 0 : d.dimensions))) : s || (e.fileTypes.images = O.parseConfig(e.connectSettings, o, t, i)));
            }
        },
        {
            key: "processImagesConfig",
            value: function processImagesConfig(e, t, i, s) {
                if (!i && !s) return;
                var o = $8e4453fb4fc895c8$var$_objectSpread({
                    acceptedFormats: "image/*"
                }, (s == null ? void 0 : s.files) || {});
                e.fileTypes.images = O.parseConfig(e.connectSettings, o, t, i);
            }
        },
        {
            key: "populateDefaultFileIO",
            value: function populateDefaultFileIO(e, t) {
                var _e$files, _i$acceptedFormats, _s$maxNumberOfFiles;
                var i, s;
                e && ((_e$files = e.files) !== null && _e$files !== void 0 ? _e$files : e.files = {}, (_i$acceptedFormats = (i = e.files).acceptedFormats) !== null && _i$acceptedFormats !== void 0 ? _i$acceptedFormats : i.acceptedFormats = t, (_s$maxNumberOfFiles = (s = e.files).maxNumberOfFiles) !== null && _s$maxNumberOfFiles !== void 0 ? _s$maxNumberOfFiles : s.maxNumberOfFiles = 1);
            }
        },
        {
            key: "set",
            value: function set(e, t, i) {
                O.populateDefaultFileIO(i == null ? void 0 : i.audio, ".4a,.mp3,.webm,.mp4,.mpga,.wav,.mpeg,.m4a"), O.populateDefaultFileIO(i == null ? void 0 : i.images, ".png,.jpg");
                var s = $8e4453fb4fc895c8$var$Vt.createNew(e.remarkable);
                O.processImagesConfig(t, s, e.images, i == null ? void 0 : i.images), O.processCamera(t, s, e.camera, e.images), O.processGifConfig(t, s, e.gifs, i == null ? void 0 : i.gifs), O.processAudioConfig(t, s, e.audio, i == null ? void 0 : i.audio), O.processMicrophone(t, s, e.microphone, e.audio), O.processMixedFiles(t, s, e.mixedFiles);
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$rt = /*#__PURE__*/ function() {
    function rt(e, t, i) {
        var _a$url;
        $8e4453fb4fc895c8$var$_classCallCheck(this, rt);
        var s, r, o, a, l;
        this.rawBody = {}, this.validateKeyProperty = !1, this.canSendMessage = rt.canSendMessage, this.connectSettings = {}, this.fileTypes = {}, this.completionsHandlers = {}, this.streamHandlers = {}, this.deepChat = e, this.demo = i, Object.assign(this.rawBody, (s = e.connect) == null ? void 0 : s.additionalBodyProps), this.totalMessagesMaxCharLength = (r = e == null ? void 0 : e.requestBodyLimits) == null ? void 0 : r.totalMessagesMaxCharLength, this.maxMessages = (o = e == null ? void 0 : e.requestBodyLimits) == null ? void 0 : o.maxMessages, $8e4453fb4fc895c8$var$O.set(e, this, t), e.connect && (this.connectSettings = e.connect), this.demo && ((_a$url = (a = this.connectSettings).url) !== null && _a$url !== void 0 ? _a$url : a.url = $8e4453fb4fc895c8$var$Ae.URL), this.connectSettings.websocket && $8e4453fb4fc895c8$var$U.setup(this), this.stream = ((l = this.deepChat.connect) == null ? void 0 : l.stream) || $8e4453fb4fc895c8$var$Y.checkForStream(this.deepChat), e.loadHistory && $8e4453fb4fc895c8$var$$t.addErrorPrefix(this);
    }
    return $8e4453fb4fc895c8$var$_createClass(rt, [
        {
            key: "verifyKey",
            value: function verifyKey(e, t) {}
        },
        {
            key: "getServiceIOByType",
            value: function getServiceIOByType(e) {
                if (e.type.startsWith("audio") && this.fileTypes.audio) return this.fileTypes.audio;
                if (e.type.startsWith("image")) {
                    if (this.fileTypes.gifs && e.type.endsWith("/gif")) return this.fileTypes.gifs;
                    if (this.fileTypes.images) return this.fileTypes.images;
                    if (this.camera) return this.camera;
                }
                return this.fileTypes.mixedFiles;
            }
        },
        {
            key: "request",
            value: function() {
                var _request4 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee24(e, t) {
                    var i, _args24 = arguments;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee24$(_context24) {
                        while(true)switch(_context24.prev = _context24.next){
                            case 0:
                                i = _args24.length > 2 && _args24[2] !== undefined ? _args24[2] : !0;
                                return _context24.abrupt("return", this.stream && !$8e4453fb4fc895c8$var$T.isSimulation(this.stream) ? $8e4453fb4fc895c8$var$T.request(this, e, t, i) : $8e4453fb4fc895c8$var$C.request(this, e, t, i));
                            case 2:
                            case "end":
                                return _context24.stop();
                        }
                    }, _callee24, this);
                }));
                function request(_x39, _x40) {
                    return _request4.apply(this, arguments);
                }
                return request;
            }()
        },
        {
            key: "callAPIWithText",
            value: function() {
                var _callAPIWithText = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee25(e, t) {
                    var _o$headers, _a$ContentType;
                    var r, o, a, l, i, s;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee25$(_context25) {
                        while(true)switch(_context25.prev = _context25.next){
                            case 0:
                                i = $8e4453fb4fc895c8$var$_objectSpread({
                                    messages: t
                                }, this.rawBody);
                                s = !1;
                                (r = this.connectSettings.headers) != null && r["Content-Type"] || ((_o$headers = (o = this.connectSettings).headers) !== null && _o$headers !== void 0 ? _o$headers : o.headers = {}, (_a$ContentType = (a = this.connectSettings.headers)["Content-Type"]) !== null && _a$ContentType !== void 0 ? _a$ContentType : a["Content-Type"] = "application/json", s = !0);
                                _context25.next = 5;
                                return this.request(i, e);
                            case 5:
                                s && ((l = this.connectSettings.headers) == null || delete l["Content-Type"]);
                            case 6:
                            case "end":
                                return _context25.stop();
                        }
                    }, _callee25, this);
                }));
                function callAPIWithText(_x41, _x42) {
                    return _callAPIWithText.apply(this, arguments);
                }
                return callAPIWithText;
            }()
        },
        {
            key: "callApiWithFiles",
            value: function() {
                var _callApiWithFiles = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee26(e, t, i) {
                    var s, r, o;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee26$(_context26) {
                        while(true)switch(_context26.prev = _context26.next){
                            case 0:
                                s = rt.createCustomFormDataBody(this.rawBody, t, i), r = this.connectSettings, o = this.getServiceIOByType(i[0]);
                                this.connectSettings = (o == null ? void 0 : o.connect) || this.connectSettings;
                                _context26.next = 4;
                                return this.request(s, e, !1);
                            case 4:
                                this.connectSettings = r;
                            case 5:
                            case "end":
                                return _context26.stop();
                        }
                    }, _callee26, this);
                }));
                function callApiWithFiles(_x43, _x44, _x45) {
                    return _callApiWithFiles.apply(this, arguments);
                }
                return callApiWithFiles;
            }()
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee27(e, t, i) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee27$(_context27) {
                        while(true)switch(_context27.prev = _context27.next){
                            case 0:
                                i ? this.callApiWithFiles(e, t, i) : this.callAPIWithText(e, t);
                            case 1:
                            case "end":
                                return _context27.stop();
                        }
                    }, _callee27, this);
                }));
                function callServiceAPI(_x46, _x47, _x48) {
                    return _callServiceAPI.apply(this, arguments);
                }
                return callServiceAPI;
            }() // prettier-ignore
        },
        {
            key: "callAPI",
            value: function() {
                var _callAPI = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee28(e, t) {
                    var i, s;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee28$(_context28) {
                        while(true)switch(_context28.prev = _context28.next){
                            case 0:
                                if (this.connectSettings) {
                                    _context28.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                i = $8e4453fb4fc895c8$var$Tt.processMessages(t.messageToElements.map(function(_ref12) {
                                    var _ref13 = $8e4453fb4fc895c8$var$_slicedToArray(_ref12, 1), s = _ref13[0];
                                    return s;
                                }), this.maxMessages, this.totalMessagesMaxCharLength);
                                if (this.connectSettings.websocket) {
                                    s = $8e4453fb4fc895c8$var$_objectSpread({
                                        messages: i
                                    }, this.rawBody);
                                    $8e4453fb4fc895c8$var$U.sendWebsocket(this, s, t, !1);
                                } else this.callServiceAPI(t, i, e.files);
                            case 4:
                            case "end":
                                return _context28.stop();
                        }
                    }, _callee28, this);
                }));
                function callAPI(_x49, _x50) {
                    return _callAPI.apply(this, arguments);
                }
                return callAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee29(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee29$(_context29) {
                        while(true)switch(_context29.prev = _context29.next){
                            case 0:
                                if (!e.error) {
                                    _context29.next = 2;
                                    break;
                                }
                                throw e.error;
                            case 2:
                                if (!e.result) {
                                    _context29.next = 4;
                                    break;
                                }
                                return _context29.abrupt("return", $8e4453fb4fc895c8$var$Y.handleResponseProperty(e));
                            case 4:
                                if (!$8e4453fb4fc895c8$var$E.validateResponseFormat(e)) {
                                    _context29.next = 6;
                                    break;
                                }
                                return _context29.abrupt("return", e);
                            case 6:
                            case "end":
                                return _context29.stop();
                        }
                    }, _callee29);
                }));
                function extractResultData(_x51) {
                    return _extractResultData.apply(this, arguments);
                }
                return extractResultData;
            }()
        },
        {
            key: "isDirectConnection",
            value: function isDirectConnection() {
                return !1;
            }
        },
        {
            key: "isWebModel",
            value: function isWebModel() {
                return !1;
            }
        }
    ], [
        {
            key: "canSendMessage",
            value: function canSendMessage(e, t, i) {
                return i ? !0 : !!(e && e.trim() !== "") || !!(t && t.length > 0);
            }
        },
        {
            key: "createCustomFormDataBody",
            value: function createCustomFormDataBody(e, t, i) {
                var s = new FormData();
                i.forEach(function(a) {
                    return s.append("files", a);
                }), Object.keys(e).forEach(function(a) {
                    return s.append(a, String(e[a]));
                });
                var r = 0;
                t.slice(0, t.length - 1).forEach(function(a) {
                    s.append("message".concat(r += 1), JSON.stringify(a));
                });
                var o = t[t.length - 1];
                return o.text && (delete o.files, s.append("message".concat(r += 1), JSON.stringify(o))), s;
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$G = /*#__PURE__*/ function(_rt) {
    // prettier-ignore
    function G(e, t, i, s, r) {
        var _this13;
        $8e4453fb4fc895c8$var$_classCallCheck(this, G);
        var o;
        _this13 = $8e4453fb4fc895c8$var$_callSuper(this, G, [
            e,
            r
        ]), _this13.insertKeyPlaceholderText = "API Key", _this13.keyHelpUrl = "", Object.assign(_this13.rawBody, (o = e.connect) == null ? void 0 : o.additionalBodyProps), _this13.keyVerificationDetails = t, _this13.buildHeadersFunc = i, s && _this13.setApiKeyProperties(s), _this13.connectSettings = _this13.buildConnectSettings(_this13.key || "", e.connect);
        return _this13;
    }
    $8e4453fb4fc895c8$var$_inherits(G, _rt);
    return $8e4453fb4fc895c8$var$_createClass(G, [
        {
            key: "setApiKeyProperties",
            value: function setApiKeyProperties(e) {
                this.key = e.key, e.validateKeyProperty && (this.validateKeyProperty = e.validateKeyProperty);
            }
        },
        {
            key: "buildConnectSettings",
            value: function buildConnectSettings(e, t) {
                var _i$headers;
                var i = t !== null && t !== void 0 ? t : {};
                return (_i$headers = i.headers) !== null && _i$headers !== void 0 ? _i$headers : i.headers = {}, Object.assign(i.headers, this.buildHeadersFunc(e)), i;
            }
        },
        {
            key: "keyAuthenticated",
            value: function keyAuthenticated(e, t) {
                this.connectSettings = this.buildConnectSettings(t, this.connectSettings), this.key = t, e();
            }
        },
        {
            key: "verifyKey",
            value: function verifyKey(e, t) {
                var _this$keyVerification = this.keyVerificationDetails, i = _this$keyVerification.url, s = _this$keyVerification.method, r = _this$keyVerification.handleVerificationResult, o = _this$keyVerification.createHeaders, a = _this$keyVerification.body, l = (o == null ? void 0 : o(e)) || this.buildHeadersFunc(e);
                $8e4453fb4fc895c8$var$C.verifyKey(e, i, l, s, this.keyAuthenticated.bind(this, t.onSuccess), t.onFail, t.onLoad, r, a);
            }
        },
        {
            key: "isDirectConnection",
            value: function isDirectConnection() {
                return !0;
            }
        }
    ]);
}($8e4453fb4fc895c8$var$rt);
var $8e4453fb4fc895c8$var$bi = /*#__PURE__*/ function() {
    function bi() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, bi);
    }
    return $8e4453fb4fc895c8$var$_createClass(bi, null, [
        {
            key: "waitForPropertiesToBeUpdatedBeforeRender",
            value: function waitForPropertiesToBeUpdatedBeforeRender(e) {
                e._propUpdated_ = !1, setTimeout(function() {
                    e._propUpdated_ ? bi.waitForPropertiesToBeUpdatedBeforeRender(e) : (e._waitingToRender_ = !1, e.onRender());
                });
            }
        },
        {
            key: "attemptRender",
            value: function attemptRender(e) {
                e._propUpdated_ = !0, e._waitingToRender_ || (e._waitingToRender_ = !0, bi.waitForPropertiesToBeUpdatedBeforeRender(e));
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Me = /*#__PURE__*/ function(_HTMLElement) {
    // If this is not working, try using propertyName directly
    function Me() {
        var _this14;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Me);
        _this14 = $8e4453fb4fc895c8$var$_callSuper(this, Me), _this14._waitingToRender_ = !1, _this14._propUpdated_ = !1, Object.keys(Me._attributeToProperty_).forEach(function(e) {
            var t = Me._attributeToProperty_[e];
            _this14.constructPropertyAccessors(t), _this14.hasOwnProperty(e) || _this14.constructPropertyAccessors(t, e);
        });
        return _this14;
    }
    $8e4453fb4fc895c8$var$_inherits(Me, _HTMLElement);
    return $8e4453fb4fc895c8$var$_createClass(Me, [
        {
            key: "constructPropertyAccessors",
            value: // need to be called here as accessors need to be set for the class instance
            function constructPropertyAccessors(e, t) {
                var i;
                Object.defineProperty(this, t || e, {
                    get: function get() {
                        return i;
                    },
                    set: function set(o) {
                        i = o, t ? this[e] = o : $8e4453fb4fc895c8$var$bi.attemptRender(this);
                    }
                });
            }
        },
        {
            key: "attributeChangedCallback",
            value: function attributeChangedCallback(e, t, i) {
                if (t === i) return;
                var s = Me._attributes_[e](i), r = Me._attributeToProperty_[e];
                this[r] = s;
            }
        },
        {
            key: "onRender",
            value: function onRender() {}
        }
    ], [
        {
            key: "observedAttributes",
            get: function get() {
                return Object.keys(Me._attributes_) || [];
            }
        }
    ]);
}(/*#__PURE__*/ $8e4453fb4fc895c8$var$_wrapNativeSuper(HTMLElement));
$8e4453fb4fc895c8$var$Me._attributes_ = {}, $8e4453fb4fc895c8$var$Me._attributeToProperty_ = {};
var $8e4453fb4fc895c8$var$ms = $8e4453fb4fc895c8$var$Me;
var $8e4453fb4fc895c8$var$Po = '<?xml version="1.0" standalone="no"?>\n<svg version="1.1"\n	xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"\n	xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="0.9em" height="0.9em"\n	viewBox="0 0 1200 1200" enable-background="new 0 0 1200 1200">\n		<path d="\n			M669.727,273.516c-22.891-2.476-46.15-3.895-69.727-4.248c-103.025,0.457-209.823,25.517-310.913,73.536\n			c-75.058,37.122-148.173,89.529-211.67,154.174C46.232,529.978,6.431,577.76,0,628.74c0.76,44.162,48.153,98.67,77.417,131.764\n			c59.543,62.106,130.754,113.013,211.67,154.174c2.75,1.335,5.51,2.654,8.276,3.955l-75.072,131.102l102.005,60.286l551.416-960.033\n			l-98.186-60.008L669.727,273.516z M902.563,338.995l-74.927,129.857c34.47,44.782,54.932,100.006,54.932,159.888\n			c0,149.257-126.522,270.264-282.642,270.264c-6.749,0-13.29-0.728-19.922-1.172l-49.585,85.84c22.868,2.449,45.99,4.233,69.58,4.541\n			c103.123-0.463,209.861-25.812,310.84-73.535c75.058-37.122,148.246-89.529,211.743-154.174\n			c31.186-32.999,70.985-80.782,77.417-131.764c-0.76-44.161-48.153-98.669-77.417-131.763\n			c-59.543-62.106-130.827-113.013-211.743-154.175C908.108,341.478,905.312,340.287,902.563,338.995L902.563,338.995z\n			M599.927,358.478c6.846,0,13.638,0.274,20.361,0.732l-58.081,100.561c-81.514,16.526-142.676,85.88-142.676,168.897\n			c0,20.854,3.841,40.819,10.913,59.325c0.008,0.021-0.008,0.053,0,0.074l-58.228,100.854\n			c-34.551-44.823-54.932-100.229-54.932-160.182C317.285,479.484,443.808,358.477,599.927,358.478L599.927,358.478z M768.896,570.513\n			L638.013,797.271c81.076-16.837,141.797-85.875,141.797-168.603C779.81,608.194,775.724,588.729,768.896,570.513L768.896,570.513z"\n			/>\n</svg>\n', $8e4453fb4fc895c8$var$Oo = '<?xml version="1.0" standalone="no"?>\n<svg version="1.1"\n	xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"\n	xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="0.9em" height="0.9em"\n	viewBox="0 0 1200 1200" enable-background="new 0 0 1200 1200">\n		<path id="path6686" inkscape:connector-curvature="0" d="M779.843,599.925c0,95.331-80.664,172.612-180.169,172.612\n			c-99.504,0-180.168-77.281-180.168-172.612c0-95.332,80.664-172.612,180.168-172.612\n			C699.179,427.312,779.843,504.594,779.843,599.925z M600,240.521c-103.025,0.457-209.814,25.538-310.904,73.557\n			c-75.058,37.122-148.206,89.496-211.702,154.141C46.208,501.218,6.431,549,0,599.981c0.76,44.161,48.13,98.669,77.394,131.763\n			c59.543,62.106,130.786,113.018,211.702,154.179c94.271,45.751,198.616,72.092,310.904,73.557\n			c103.123-0.464,209.888-25.834,310.866-73.557c75.058-37.122,148.243-89.534,211.74-154.179\n			c31.185-32.999,70.962-80.782,77.394-131.763c-0.76-44.161-48.13-98.671-77.394-131.764\n			c-59.543-62.106-130.824-112.979-211.74-154.141C816.644,268.36,712.042,242.2,600,240.521z M599.924,329.769\n			c156.119,0,282.675,120.994,282.675,270.251c0,149.256-126.556,270.25-282.675,270.25S317.249,749.275,317.249,600.02\n			C317.249,450.763,443.805,329.769,599.924,329.769L599.924,329.769z"/>\n</svg>\n';
var $8e4453fb4fc895c8$var$re = /*#__PURE__*/ function() {
    function re() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, re);
    }
    return $8e4453fb4fc895c8$var$_createClass(re, null, [
        {
            key: "createSVGElement",
            value: function createSVGElement(e) {
                return new DOMParser().parseFromString(e, "image/svg+xml").documentElement;
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$je = /*#__PURE__*/ function() {
    function je() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, je);
    }
    return $8e4453fb4fc895c8$var$_createClass(je, null, [
        {
            key: "changeVisibility",
            value: // prettier-ignore
            function changeVisibility(e, t, i, s) {
                s.target.id === je.VISIBLE_ICON_ID ? (t.style.display = "none", i.style.display = "block", e.type = "password") : (t.style.display = "block", i.style.display = "none", e.type = "text");
            }
        },
        {
            key: "createIconElement",
            value: function createIconElement(e, t) {
                var i = $8e4453fb4fc895c8$var$re.createSVGElement(e);
                return i.id = t, i.classList.add("visibility-icon"), i;
            }
        },
        {
            key: "create",
            value: function create(e) {
                var t = document.createElement("div");
                t.id = "visibility-icon-container";
                var i = je.createIconElement($8e4453fb4fc895c8$var$Oo, je.VISIBLE_ICON_ID);
                i.style.display = "none", t.appendChild(i);
                var s = je.createIconElement($8e4453fb4fc895c8$var$Po, "not-visible-icon");
                return t.appendChild(s), t.onclick = je.changeVisibility.bind(this, e, i, s), t;
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$je.VISIBLE_ICON_ID = "visible-icon";
var $8e4453fb4fc895c8$var$gs = $8e4453fb4fc895c8$var$je;
var $8e4453fb4fc895c8$var$H = /*#__PURE__*/ function() {
    function H() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, H);
    }
    return $8e4453fb4fc895c8$var$_createClass(H, null, [
        {
            key: "createCautionText",
            value: function createCautionText() {
                var e = document.createElement("a");
                return e.classList.add("insert-key-input-help-text"), e.innerText = "Please exercise CAUTION when inserting your API key outside of deepchat.dev or localhost!!", e;
            }
        },
        {
            key: "createHelpLink",
            value: function createHelpLink(e) {
                var t = document.createElement("a");
                return t.classList.add("insert-key-input-help-text"), t.href = e, t.innerText = "Find more info here", t.target = "_blank", t;
            }
        },
        {
            key: "createFailText",
            value: function createFailText() {
                var e = document.createElement("div");
                return e.id = "insert-key-input-invalid-text", e.style.display = "none", e;
            }
        },
        {
            key: "createHelpTextContainer",
            value: function createHelpTextContainer(e) {
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                var i = document.createElement("div");
                i.id = "insert-key-help-text-container";
                var s = document.createElement("div");
                s.id = "insert-key-help-text-contents";
                var r = H.createFailText();
                if (s.appendChild(r), e) {
                    var o = H.createHelpLink(e);
                    s.appendChild(o);
                }
                if (t === !0) {
                    var _o2 = H.createCautionText();
                    s.appendChild(_o2);
                }
                return i.appendChild(s), {
                    helpTextContainerElement: i,
                    failTextElement: r
                };
            }
        },
        {
            key: "onFail",
            value: function onFail(e, t, i, s) {
                e.classList.replace("insert-key-input-valid", "insert-key-input-invalid"), i.innerText = s, i.style.display = "block", t.innerText = "Start", e.classList.remove("loading");
            }
        },
        {
            key: "onLoad",
            value: function onLoad(e, t) {
                e.classList.add("loading"), t.innerHTML = '<div id="loading-key"></div>';
            }
        },
        {
            key: "verifyKey",
            value: function verifyKey(e, t, i) {
                var s = e.value.trim();
                i.verifyKey(s, t);
            }
        },
        {
            key: "addVerificationEvents",
            value: function addVerificationEvents(e, t, i, s, r) {
                var o = {
                    onSuccess: s,
                    onFail: H.onFail.bind(this, e, t, i),
                    onLoad: H.onLoad.bind(this, e, t)
                }, a = H.verifyKey.bind(this, e, o, r);
                t.onclick = a, e.onkeydown = function(l) {
                    !e.classList.contains("loading") && l.key === $8e4453fb4fc895c8$var$D.ENTER && a();
                };
            }
        },
        {
            key: "createStartButton",
            value: function createStartButton() {
                var e = document.createElement("div");
                return e.id = "start-button", e.innerText = "Start", e;
            }
        },
        {
            key: "onInputFocus",
            value: function onInputFocus(e) {
                e.target.classList.replace("insert-key-input-invalid", "insert-key-input-valid");
            }
        },
        {
            key: "createInput",
            value: function createInput(e) {
                var t = document.createElement("div");
                t.id = "insert-key-input-container";
                var i = document.createElement("input");
                return i.id = "insert-key-input", i.placeholder = e || "API Key", i.type = "password", i.classList.add("insert-key-input-valid"), i.onfocus = H.onInputFocus, t.appendChild(i), t;
            }
        },
        {
            key: "createContents",
            value: function createContents(e, t) {
                var d;
                var i = document.createElement("div");
                i.id = "insert-key-contents";
                var s = H.createInput(t.insertKeyPlaceholderText), r = s.children[0], o = $8e4453fb4fc895c8$var$gs.create(r);
                s.appendChild(o), i.appendChild(s);
                var a = H.createStartButton(), _H$createHelpTextCont = H.createHelpTextContainer(t.keyHelpUrl, (d = t.deepChat._insertKeyViewStyles) == null ? void 0 : d.displayCautionText), l = _H$createHelpTextCont.helpTextContainerElement, c = _H$createHelpTextCont.failTextElement;
                return i.appendChild(a), i.appendChild(l), H.addVerificationEvents(r, a, c, e, t), i;
            }
        },
        {
            key: "createElements",
            value: function createElements(e, t) {
                var i = document.createElement("div");
                i.id = "insert-key-view";
                var s = H.createContents(e, t);
                return i.appendChild(s), i;
            }
        },
        {
            key: "render",
            value: function render(e, t, i) {
                var s = H.createElements(t, i);
                e.replaceChildren(s);
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$ie = /*#__PURE__*/ function() {
    function ie() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, ie);
    }
    return $8e4453fb4fc895c8$var$_createClass(ie, null, [
        {
            key: "enableButtons",
            value: function enableButtons(e, t) {
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                window.webLLM ? (e && (e.disabled = !1), t && (t.disabled = !1)) : i < $8e4453fb4fc895c8$var$Wt.MODULE_SEARCH_LIMIT_S * 4 && setTimeout(function() {
                    return ie.enableButtons(e, t, i + 1);
                }, 250);
            }
        },
        {
            key: "setUpInitial",
            value: function setUpInitial(e, t, i, s) {
                var r = (t == null ? void 0 : t.downloadClass) || ie.DOWNLOAD_BUTTON_CLASS, o = (t == null ? void 0 : t.uploadClass) || ie.UPLOAD_BUTTON_CLASS, a = (t == null ? void 0 : t.fileInputClass) || ie.FILE_INPUT_CLASS;
                return setTimeout(function() {
                    var l = i == null ? void 0 : i.getElementsByClassName(r)[0], c = i == null ? void 0 : i.getElementsByClassName(a)[0], d = i == null ? void 0 : i.getElementsByClassName(o)[0];
                    l && (l.onclick = function() {
                        return e();
                    }), c && (c.onchange = function() {
                        c.files && c.files.length > 0 && e(c.files);
                    }), d && (d.onclick = function() {
                        return c.click();
                    }), (l || d) && ie.enableButtons(l, d);
                }), (t == null ? void 0 : t.initialHtml) || '<div>\n        Download or upload a web model that will run entirely on your browser: <br/> \n        <button disabled class="'.concat(r, ' deep-chat-button deep-chat-web-model-button">Download</button>\n        ').concat(s ? "" : '<input type="file" class="'.concat(a, '" hidden multiple />\n          <button disabled class="').concat(o, ' deep-chat-button deep-chat-web-model-button">Upload</button>'), "\n      </div>");
            }
        },
        {
            key: "exportFile",
            value: function exportFile(e) {
                var t = document.createElement("a"), i = 4;
                var _loop2 = function _loop2(s) {
                    setTimeout(function() {
                        var r = s * i;
                        for(var o = r; o < Math.min(r + i, e.length); o += 1){
                            var a = URL.createObjectURL(e[o]);
                            t.href = a, t.download = e[o].name, document.body.appendChild(t), t.click(), URL.revokeObjectURL(a);
                        }
                    }, 500 * s);
                };
                for(var s = 0; s < e.length / i; s += 1)_loop2(s);
            }
        },
        {
            key: "setUpAfterLoad",
            value: function setUpAfterLoad(e, t, i, s) {
                var r = (t == null ? void 0 : t.exportFilesClass) || ie.EXPORT_BUTTON_CLASS;
                return setTimeout(function() {
                    var o = i == null ? void 0 : i.getElementsByClassName(r)[0];
                    o && (o.onclick = function() {
                        return ie.exportFile(e);
                    });
                }), (t == null ? void 0 : t.afterLoadHtml) || "<div>\n        Model loaded successfully and has been cached for future requests.\n        ".concat(s ? "" : '<br/> <button style="margin-top: 5px" class="'.concat(r, ' deep-chat-button">Export</button>'), "\n      </div>");
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$ie.DOWNLOAD_BUTTON_CLASS = "deep-chat-download-button", $8e4453fb4fc895c8$var$ie.UPLOAD_BUTTON_CLASS = "deep-chat-upload-button", $8e4453fb4fc895c8$var$ie.FILE_INPUT_CLASS = "deep-chat-file-input", $8e4453fb4fc895c8$var$ie.EXPORT_BUTTON_CLASS = "deep-chat-export-button";
var $8e4453fb4fc895c8$var$vi = $8e4453fb4fc895c8$var$ie;
var $8e4453fb4fc895c8$var$tn = {
    model_list: [
        // Llama-2
        {
            model_url: "https://huggingface.co/mlc-ai/Llama-2-7b-chat-hf-q4f32_1-MLC/resolve/main/",
            local_id: "Llama-2-7b-chat-hf-q4f32_1",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Llama-2-7b-chat-hf/Llama-2-7b-chat-hf-q4f32_1-ctx4k_cs1k-webgpu.wasm",
            vram_required_MB: 9109.03,
            low_resource_required: !1
        },
        {
            model_url: "https://huggingface.co/mlc-ai/Llama-2-7b-chat-hf-q4f16_1-MLC/resolve/main/",
            local_id: "Llama-2-7b-chat-hf-q4f16_1",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Llama-2-7b-chat-hf/Llama-2-7b-chat-hf-q4f16_1-ctx4k_cs1k-webgpu.wasm",
            vram_required_MB: 6749.02,
            low_resource_required: !1,
            required_features: [
                "shader-f16"
            ]
        },
        {
            model_url: "https://huggingface.co/mlc-ai/Llama-2-7b-chat-hf-q4f16_1-MLC/resolve/main/",
            local_id: "Llama-2-7b-chat-hf-q4f16_1-1k",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Llama-2-7b-chat-hf/Llama-2-7b-chat-hf-q4f16_1-ctx1k-webgpu.wasm",
            vram_required_MB: 4618.52,
            low_resource_required: !1,
            required_features: [
                "shader-f16"
            ]
        },
        {
            model_url: "https://huggingface.co/mlc-ai/Llama-2-13b-chat-hf-q4f16_1-MLC/resolve/main/",
            local_id: "Llama-2-13b-chat-hf-q4f16_1",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Llama-2-13b-chat-hf/Llama-2-13b-chat-hf-q4f16_1-ctx4k_cs1k-webgpu.wasm",
            vram_required_MB: 11814.09,
            low_resource_required: !1,
            required_features: [
                "shader-f16"
            ]
        },
        {
            model_url: "https://huggingface.co/mlc-ai/Llama-2-70b-chat-hf-q4f16_1-MLC/resolve/main/",
            local_id: "Llama-2-70b-chat-hf-q4f16_1",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Llama-2-70b-chat-hf/Llama-2-70b-chat-hf-q4f16_1-ctx4k_cs1k-webgpu.wasm",
            vram_required_MB: 43729.05,
            low_resource_required: !1,
            required_features: [
                "shader-f16"
            ]
        },
        // RedPajama
        {
            model_url: "https://huggingface.co/mlc-ai/RedPajama-INCITE-Chat-3B-v1-q4f16_1-MLC/resolve/main/",
            local_id: "RedPajama-INCITE-Chat-3B-v1-q4f16_1",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/RedPajama-INCITE-Chat-3B-v1/RedPajama-INCITE-Chat-3B-v1-q4f16_1-ctx2k-webgpu.wasm",
            vram_required_MB: 2972.09,
            low_resource_required: !1,
            required_features: [
                "shader-f16"
            ]
        },
        {
            model_url: "https://huggingface.co/mlc-ai/RedPajama-INCITE-Chat-3B-v1-q4f32_1-MLC/resolve/main/",
            local_id: "RedPajama-INCITE-Chat-3B-v1-q4f32_1",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/RedPajama-INCITE-Chat-3B-v1/RedPajama-INCITE-Chat-3B-v1-q4f32_1-ctx2k-webgpu.wasm",
            vram_required_MB: 3928.09,
            low_resource_required: !1
        },
        {
            model_url: "https://huggingface.co/mlc-ai/RedPajama-INCITE-Chat-3B-v1-q4f16_1-MLC/resolve/main/",
            local_id: "RedPajama-INCITE-Chat-3B-v1-q4f16_1-1k",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/RedPajama-INCITE-Chat-3B-v1/RedPajama-INCITE-Chat-3B-v1-q4f16_1-ctx1k-webgpu.wasm",
            vram_required_MB: 2041.09,
            low_resource_required: !0,
            required_features: [
                "shader-f16"
            ]
        },
        {
            model_url: "https://huggingface.co/mlc-ai/RedPajama-INCITE-Chat-3B-v1-q4f32_1-MLC/resolve/main/",
            local_id: "RedPajama-INCITE-Chat-3B-v1-q4f32_1-1k",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/RedPajama-INCITE-Chat-3B-v1/RedPajama-INCITE-Chat-3B-v1-q4f32_1-ctx1k-webgpu.wasm",
            vram_required_MB: 2558.09,
            low_resource_required: !0
        },
        // Mistral variants
        {
            model_url: "https://huggingface.co/mlc-ai/WizardMath-7B-V1.1-q4f16_1-MLC/resolve/main/",
            local_id: "WizardMath-7B-V1.1-q4f16_1",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Mistral-7B-Instruct-v0.2/Mistral-7B-Instruct-v0.2-q4f16_1-sw4k_cs1k-webgpu.wasm",
            vram_required_MB: 6079.02,
            low_resource_required: !1,
            required_features: [
                "shader-f16"
            ]
        },
        {
            model_url: "https://huggingface.co/mlc-ai/Mistral-7B-Instruct-v0.2-q4f16_1-MLC/resolve/main/",
            local_id: "Mistral-7B-Instruct-v0.2-q4f16_1",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Mistral-7B-Instruct-v0.2/Mistral-7B-Instruct-v0.2-q4f16_1-sw4k_cs1k-webgpu.wasm",
            vram_required_MB: 6079.02,
            low_resource_required: !1,
            required_features: [
                "shader-f16"
            ]
        },
        {
            model_url: "https://huggingface.co/mlc-ai/OpenHermes-2.5-Mistral-7B-q4f16_1-MLC/resolve/main/",
            local_id: "OpenHermes-2.5-Mistral-7B-q4f16_1",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Mistral-7B-Instruct-v0.2/Mistral-7B-Instruct-v0.2-q4f16_1-sw4k_cs1k-webgpu.wasm",
            vram_required_MB: 6079.02,
            low_resource_required: !1,
            required_features: [
                "shader-f16"
            ]
        },
        {
            model_url: "https://huggingface.co/mlc-ai/NeuralHermes-2.5-Mistral-7B-q4f16_1-MLC/resolve/main/",
            local_id: "NeuralHermes-2.5-Mistral-7B-q4f16_1",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Mistral-7B-Instruct-v0.2/Mistral-7B-Instruct-v0.2-q4f16_1-sw4k_cs1k-webgpu.wasm",
            vram_required_MB: 6079.02,
            low_resource_required: !1,
            required_features: [
                "shader-f16"
            ]
        },
        // TinyLlama
        {
            model_url: "https://huggingface.co/mlc-ai/TinyLlama-1.1B-Chat-v0.4-q0f16-MLC/resolve/main/",
            local_id: "TinyLlama-1.1B-Chat-v0.4-q0f16",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/TinyLlama-1.1B-Chat-v0.4/TinyLlama-1.1B-Chat-v0.4-q0f16-ctx2k-webgpu.wasm",
            vram_required_MB: 5063.52,
            low_resource_required: !1,
            required_features: [
                "shader-f16"
            ]
        },
        {
            model_url: "https://huggingface.co/mlc-ai/TinyLlama-1.1B-Chat-v0.4-q0f32-MLC/resolve/main/",
            local_id: "TinyLlama-1.1B-Chat-v0.4-q0f32",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/TinyLlama-1.1B-Chat-v0.4/TinyLlama-1.1B-Chat-v0.4-q0f32-ctx2k-webgpu.wasm",
            vram_required_MB: 5394.53,
            low_resource_required: !1
        },
        {
            model_url: "https://huggingface.co/mlc-ai/TinyLlama-1.1B-Chat-v0.4-q4f16_1-MLC/resolve/main/",
            local_id: "TinyLlama-1.1B-Chat-v0.4-q4f16_1-1k",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/TinyLlama-1.1B-Chat-v0.4/TinyLlama-1.1B-Chat-v0.4-q4f16_1-ctx1k-webgpu.wasm",
            vram_required_MB: 899.11,
            low_resource_required: !0,
            required_features: [
                "shader-f16"
            ]
        },
        {
            model_url: "https://huggingface.co/mlc-ai/TinyLlama-1.1B-Chat-v0.4-q4f32_1-MLC/resolve/main/",
            local_id: "TinyLlama-1.1B-Chat-v0.4-q4f32_1-1k",
            model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/TinyLlama-1.1B-Chat-v0.4/TinyLlama-1.1B-Chat-v0.4-q4f32_1-ctx1k-webgpu.wasm",
            vram_required_MB: 992.11,
            low_resource_required: !0
        }
    ],
    use_web_worker: !0
}, $8e4453fb4fc895c8$var$A = /*#__PURE__*/ function(_rt2) {
    function A(e) {
        var _this15;
        $8e4453fb4fc895c8$var$_classCallCheck(this, A);
        var t, i;
        _this15 = $8e4453fb4fc895c8$var$_callSuper(this, A, [
            e
        ]), _this15._isModelLoaded = !1, _this15._isModelLoading = !1, _this15._loadOnFirstMessage = !1, _this15._webModel = {}, _this15.permittedErrorPrefixes = [
            A.MULTIPLE_MODELS_ERROR,
            A.WEB_LLM_NOT_FOUND_ERROR,
            A.GENERIC_ERROR
        ], _this15._conversationHistory = [], $8e4453fb4fc895c8$var$_typeof(e.webModel) == "object" && (_this15._webModel = e.webModel), (t = _this15._webModel.load) != null && t.clearCache && A.clearAllCache(), _this15.findModelInWindow(e), _this15.canSendMessage = _this15.canSubmit.bind($8e4453fb4fc895c8$var$_assertThisInitialized(_this15)), _this15._chatEl = (i = e.shadowRoot) == null ? void 0 : i.children[0], e.history && A.setUpHistory(_this15._conversationHistory, e.history);
        return _this15;
    }
    // need ref of messages object as web model exhibits unique behaviour to manipulate chat
    $8e4453fb4fc895c8$var$_inherits(A, _rt2);
    return $8e4453fb4fc895c8$var$_createClass(A, [
        {
            key: "setUpMessages",
            value: function setUpMessages(e) {
                var _this16 = this;
                this._messages = e, this._removeIntro = function() {
                    e.removeIntroductoryMessage(), _this16._removeIntro = void 0;
                };
            }
        },
        {
            key: "findModelInWindow",
            value: function findModelInWindow(e) {
                var _this17 = this;
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var i;
                window.webLLM ? this.configureInit(this.shouldAddIntroMessage(e.introMessage)) : t > A.MODULE_SEARCH_LIMIT_S ? ((i = this._messages) == null || i.addNewErrorMessage("service", A.WEB_LLM_NOT_FOUND_ERROR), console.error("The deep-chat-web-llm module has not been attached to the window object. Please see the following guide:"), console.error("https://deepchat.dev/examples/externalModules")) : setTimeout(function() {
                    return _this17.findModelInWindow(e, t + 1);
                }, 1e3);
            }
        },
        {
            key: "shouldAddIntroMessage",
            value: function shouldAddIntroMessage(e) {
                var t;
                return !e && this._webModel && ((t = this._webModel.introMessage) == null ? void 0 : t.displayed) !== !1;
            }
        },
        {
            key: "scrollToTop",
            value: function scrollToTop(e) {
                var _this18 = this;
                var t;
                ((t = this._webModel.introMessage) == null ? void 0 : t.autoScroll) !== !1 && setTimeout(function() {
                    var i, s;
                    (i = _this18._messages) != null && i.elementRef && $8e4453fb4fc895c8$var$X.scrollToTop((s = _this18._messages) == null ? void 0 : s.elementRef);
                }, e);
            }
        },
        {
            key: "getIntroMessage",
            value: function getIntroMessage(e) {
                if (!this.shouldAddIntroMessage(e) || !this._chatEl) return;
                var t = $8e4453fb4fc895c8$var$vi.setUpInitial(this.init.bind(this), this._webModel.introMessage, this._chatEl, !!this._webModel.worker);
                return this.scrollToTop(1), {
                    role: $8e4453fb4fc895c8$var$b.AI_ROLE,
                    html: t,
                    sendUpdate: !1
                };
            }
        },
        {
            key: "configureInit",
            value: function() {
                var _configureInit = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee30(e) {
                    var t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee30$(_context30) {
                        while(true)switch(_context30.prev = _context30.next){
                            case 0:
                                t = this._webModel.load;
                                if (!t) {
                                    _context30.next = 8;
                                    break;
                                }
                                if (!t.onInit) {
                                    _context30.next = 5;
                                    break;
                                }
                                this.init();
                                return _context30.abrupt("return");
                            case 5:
                                if (!t.onMessage) {
                                    _context30.next = 8;
                                    break;
                                }
                                this._loadOnFirstMessage = !0;
                                return _context30.abrupt("return");
                            case 8:
                                e || this.init();
                            case 9:
                            case "end":
                                return _context30.stop();
                        }
                    }, _callee30, this);
                }));
                function configureInit(_x52) {
                    return _configureInit.apply(this, arguments);
                }
                return configureInit;
            }()
        },
        {
            key: "init",
            value: function() {
                var _init = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee31(e) {
                    var i, t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee31$(_context31) {
                        while(true)switch(_context31.prev = _context31.next){
                            case 0:
                                (i = this._messages) == null || i.removeError();
                                t = this.attemptToCreateChat();
                                _context31.t0 = t;
                                if (!_context31.t0) {
                                    _context31.next = 6;
                                    break;
                                }
                                _context31.next = 6;
                                return this.loadModel(t, e);
                            case 6:
                            case "end":
                                return _context31.stop();
                        }
                    }, _callee31, this);
                }));
                function init(_x53) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "attemptToCreateChat",
            value: function attemptToCreateChat() {
                var t;
                if (A.chat) {
                    (t = this._messages) == null || t.addNewErrorMessage("service", A.MULTIPLE_MODELS_ERROR), console.error(A.MULTIPLE_MODELS_ERROR);
                    return;
                }
                if (this._isModelLoaded || this._isModelLoading) return;
                var e = this._webModel.worker;
                return $8e4453fb4fc895c8$var$tn.use_web_worker && e ? new window.webLLM.ChatWorkerClient(e) : new window.webLLM.ChatModule();
            }
        },
        {
            key: "getConfig",
            value: function getConfig() {
                var i;
                var e = A.DEFAULT_MODEL;
                this._webModel.model && (e = this._webModel.model);
                var t = JSON.parse(JSON.stringify($8e4453fb4fc895c8$var$tn));
                if (this._webModel.urls) {
                    var s = t.model_list.find(function(r) {
                        return r.local_id = e;
                    });
                    s && (this._webModel.urls.model && (s.model_url = this._webModel.urls.model), this._webModel.urls.wasm && (s.model_lib_url = this._webModel.urls.wasm));
                }
                return (i = this._webModel.load) != null && i.skipCache && (t.use_cache = !1), {
                    model: e,
                    appConfig: t
                };
            }
        },
        {
            key: "loadModel",
            value: function() {
                var _loadModel = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee32(e, t) {
                    var _this19 = this;
                    var o, a, l, c, d, h, f, i, s, r, _this$getConfig, u, m, p, _u;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee32$(_context32) {
                        while(true)switch(_context32.prev = _context32.next){
                            case 0:
                                this.scrollToTop(), A.chat = e, this._isModelLoading = !0;
                                i = ((o = this._webModel.introMessage) == null ? void 0 : o.displayed) === !1;
                                s = function s(u) {
                                    var m;
                                    (m = _this19._messages) == null || m.addNewMessage({
                                        html: "<div>".concat(u.text, "</div>"),
                                        overwrite: !0,
                                        sendUpdate: !1
                                    }), i && (setTimeout(function() {
                                        var p;
                                        return $8e4453fb4fc895c8$var$X.scrollToBottom((p = _this19._messages) == null ? void 0 : p.elementRef);
                                    }), i = !1);
                                };
                                A.chat.setInitProgressCallback(s);
                                _context32.prev = 4;
                                _this$getConfig = this.getConfig(), u = _this$getConfig.model, m = _this$getConfig.appConfig, p = {};
                                this._webModel.instruction && (p.conv_config = {
                                    system: this._webModel.instruction
                                });
                                this._conversationHistory.length > 0 && (p.conversation_history = this._conversationHistory);
                                _context32.next = 10;
                                return A.chat.reload(u, p, m, t);
                            case 10:
                                r = _context32.sent;
                                _context32.next = 16;
                                break;
                            case 13:
                                _context32.prev = 13;
                                _context32.t0 = _context32["catch"](4);
                                return _context32.abrupt("return", this.unloadChat(_context32.t0));
                            case 16:
                                if ((l = (a = this.deepChat)._validationHandler) == null || l.call(a), (c = this._webModel.introMessage) != null && c.removeAfterLoad) this._webModel.introMessage.displayed === !1 ? (h = this._messages) == null || h.removeLastMessage() : (f = this._removeIntro) == null || f.call(this);
                                else {
                                    _u = $8e4453fb4fc895c8$var$vi.setUpAfterLoad(r, this._webModel.introMessage, this._chatEl, !!this._webModel.worker);
                                    (d = this._messages) == null || d.addNewMessage({
                                        html: _u,
                                        overwrite: !0,
                                        sendUpdate: !1
                                    });
                                }
                                this._isModelLoaded = !0, this._isModelLoading = !1;
                            case 18:
                            case "end":
                                return _context32.stop();
                        }
                    }, _callee32, this, [
                        [
                            4,
                            13
                        ]
                    ]);
                }));
                function loadModel(_x54, _x55) {
                    return _loadModel.apply(this, arguments);
                }
                return loadModel;
            }()
        },
        {
            key: "unloadChat",
            value: function() {
                var _unloadChat = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee33(e) {
                    var t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee33$(_context33) {
                        while(true)switch(_context33.prev = _context33.next){
                            case 0:
                                (t = this._messages) == null || t.addNewErrorMessage("service", A.GENERIC_ERROR);
                                console.error(e);
                                this._isModelLoaded = !1;
                                this._isModelLoading = !1;
                                _context33.t0 = A.chat;
                                if (!_context33.t0) {
                                    _context33.next = 9;
                                    break;
                                }
                                _context33.next = 8;
                                return A.chat.unload();
                            case 8:
                                A.chat = void 0;
                            case 9:
                            case "end":
                                return _context33.stop();
                        }
                    }, _callee33, this);
                }));
                function unloadChat(_x56) {
                    return _unloadChat.apply(this, arguments);
                }
                return unloadChat;
            }()
        },
        {
            key: "immediateResp",
            value: function() {
                var _immediateResp = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee34(e, t, i) {
                    var s, r;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee34$(_context34) {
                        while(true)switch(_context34.prev = _context34.next){
                            case 0:
                                _context34.next = 2;
                                return i.generate(t, void 0, 0);
                            case 2:
                                _context34.t0 = _context34.sent;
                                s = {
                                    text: _context34.t0
                                };
                                _context34.next = 6;
                                return A.processResponse(this.deepChat, e, s);
                            case 6:
                                r = _context34.sent;
                                r && e.addNewMessage(r), this.completionsHandlers.onFinish();
                            case 8:
                            case "end":
                                return _context34.stop();
                        }
                    }, _callee34, this);
                }));
                function immediateResp(_x57, _x58, _x59) {
                    return _immediateResp.apply(this, arguments);
                }
                return immediateResp;
            }()
        },
        {
            key: "streamResp",
            value: function() {
                var _streamResp = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee36(e, t, i) {
                    var _this20 = this;
                    var s;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee36$(_context36) {
                        while(true)switch(_context36.prev = _context36.next){
                            case 0:
                                this.streamHandlers.abortStream.abort = function() {
                                    i.interruptGenerate();
                                }, this.streamHandlers.onOpen();
                                s = new $8e4453fb4fc895c8$var$we(e);
                                _context36.next = 4;
                                return i.generate(t, /*#__PURE__*/ function() {
                                    var _ref14 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee35(r, o) {
                                        var a;
                                        return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee35$(_context35) {
                                            while(true)switch(_context35.prev = _context35.next){
                                                case 0:
                                                    _context35.next = 2;
                                                    return A.processResponse(_this20.deepChat, e, {
                                                        text: o
                                                    });
                                                case 2:
                                                    a = _context35.sent;
                                                    a && s.upsertStreamedMessage({
                                                        text: a.text,
                                                        overwrite: !0
                                                    });
                                                case 4:
                                                case "end":
                                                    return _context35.stop();
                                            }
                                        }, _callee35);
                                    }));
                                    return function(_x63, _x64) {
                                        return _ref14.apply(this, arguments);
                                    };
                                }());
                            case 4:
                                s.finaliseStreamedMessage();
                                this.streamHandlers.onClose();
                            case 6:
                            case "end":
                                return _context36.stop();
                        }
                    }, _callee36, this);
                }));
                function streamResp(_x60, _x61, _x62) {
                    return _streamResp.apply(this, arguments);
                }
                return streamResp;
            }()
        },
        {
            key: "generateRespByType",
            value: function() {
                var _generateRespByType = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee37(e, t, i, s) {
                    var r;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee37$(_context37) {
                        while(true)switch(_context37.prev = _context37.next){
                            case 0:
                                _context37.prev = 0;
                                if (!i) {
                                    _context37.next = 6;
                                    break;
                                }
                                _context37.next = 4;
                                return this.streamResp(e, t, s);
                            case 4:
                                _context37.next = 8;
                                break;
                            case 6:
                                _context37.next = 8;
                                return this.immediateResp(e, t, s);
                            case 8:
                                _context37.next = 13;
                                break;
                            case 10:
                                _context37.prev = 10;
                                _context37.t0 = _context37["catch"](0);
                                (r = this._messages) == null || r.addNewErrorMessage("service"), console.log(_context37.t0);
                            case 13:
                            case "end":
                                return _context37.stop();
                        }
                    }, _callee37, this, [
                        [
                            0,
                            10
                        ]
                    ]);
                }));
                function generateRespByType(_x65, _x66, _x67, _x68) {
                    return _generateRespByType.apply(this, arguments);
                }
                return generateRespByType;
            }()
        },
        {
            key: "generateResp",
            value: function() {
                var _generateResp = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee38(e, t, i) {
                    var s, _yield$E$processReque5, r, o, a, l, c;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee38$(_context38) {
                        while(true)switch(_context38.prev = _context38.next){
                            case 0:
                                s = t[t.length - 1].text;
                                _context38.next = 3;
                                return $8e4453fb4fc895c8$var$E.processRequestInterceptor(this.deepChat, {
                                    body: {
                                        text: s
                                    }
                                });
                            case 3:
                                _yield$E$processReque5 = _context38.sent;
                                r = _yield$E$processReque5.body;
                                o = _yield$E$processReque5.error;
                                a = !!this.stream;
                                try {
                                    if (o) $8e4453fb4fc895c8$var$E.displayError(e, new Error(o)), (a ? this.streamHandlers.onClose : this.completionsHandlers.onFinish)();
                                    else if (!r || !r.text) {
                                        l = $8e4453fb4fc895c8$var$M.INVALID_MODEL_REQUEST({
                                            body: r
                                        }, !1);
                                        console.error(l);
                                        c = a ? this.streamHandlers.onClose : this.completionsHandlers.onFinish;
                                        $8e4453fb4fc895c8$var$E.onInterceptorError(e, l, c);
                                    } else this.generateRespByType(e, r.text, !!this.stream, i);
                                } catch (l) {
                                    this.unloadChat(l);
                                }
                            case 8:
                            case "end":
                                return _context38.stop();
                        }
                    }, _callee38, this);
                }));
                function generateResp(_x69, _x70, _x71) {
                    return _generateResp.apply(this, arguments);
                }
                return generateResp;
            }()
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI2 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee39(e, t) {
                    var i, s;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee39$(_context39) {
                        while(true)switch(_context39.prev = _context39.next){
                            case 0:
                                if (this._isModelLoaded) {
                                    _context39.next = 7;
                                    break;
                                }
                                if (!this._loadOnFirstMessage) {
                                    _context39.next = 6;
                                    break;
                                }
                                _context39.next = 4;
                                return this.init();
                            case 4:
                                _context39.next = 7;
                                break;
                            case 6:
                                return _context39.abrupt("return");
                            case 7:
                                !A.chat || this._isModelLoading || ((i = this._webModel.introMessage) != null && i.removeAfterMessage && ((s = this._removeIntro) == null || s.call(this)), e.addLoadingMessage(), this.generateResp(e, t, A.chat));
                            case 8:
                            case "end":
                                return _context39.stop();
                        }
                    }, _callee39, this);
                }));
                function callServiceAPI(_x72, _x73) {
                    return _callServiceAPI2.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "canSubmit",
            value: function canSubmit(e) {
                return !(e != null && e.trim()) || this._isModelLoading ? !1 : this._loadOnFirstMessage ? !0 : !!this._isModelLoaded;
            }
        },
        {
            key: "isWebModel",
            value: function isWebModel() {
                return !0;
            }
        }
    ], [
        {
            key: "setUpHistory",
            value: function setUpHistory(e, t) {
                t.forEach(function(i, s) {
                    if (i.role === $8e4453fb4fc895c8$var$b.USER_ROLE && i.text) {
                        var r = t[s + 1];
                        r != null && r.text && r.role !== $8e4453fb4fc895c8$var$b.USER_ROLE && e.push([
                            i.text,
                            r.text
                        ]);
                    }
                });
            }
        },
        {
            key: "processResponse",
            value: function() {
                var _processResponse = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee40(e, t, i) {
                    var r, s, o;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee40$(_context40) {
                        while(true)switch(_context40.prev = _context40.next){
                            case 0:
                                _context40.next = 2;
                                return (r = e.responseInterceptor) == null ? void 0 : r.call(e, i);
                            case 2:
                                _context40.t0 = _context40.sent;
                                if (_context40.t0) {
                                    _context40.next = 5;
                                    break;
                                }
                                _context40.t0 = i;
                            case 5:
                                s = _context40.t0;
                                if (!s.error) {
                                    _context40.next = 11;
                                    break;
                                }
                                $8e4453fb4fc895c8$var$E.displayError(t, new Error(s.error));
                                return _context40.abrupt("return");
                            case 11:
                                if (!(!s || !s.text)) {
                                    _context40.next = 15;
                                    break;
                                }
                                o = $8e4453fb4fc895c8$var$M.INVALID_MODEL_RESPONSE(i, !!e.responseInterceptor, s);
                                $8e4453fb4fc895c8$var$E.displayError(t, new Error(o));
                                return _context40.abrupt("return");
                            case 15:
                                return _context40.abrupt("return", s);
                            case 16:
                            case "end":
                                return _context40.stop();
                        }
                    }, _callee40);
                }));
                function processResponse(_x74, _x75, _x76) {
                    return _processResponse.apply(this, arguments);
                }
                return processResponse;
            }()
        },
        {
            key: "clearAllCache",
            value: function clearAllCache() {
                A.clearCache("webllm/model"), A.clearCache("webllm/wasm");
            }
        },
        {
            key: "clearCache",
            value: function clearCache(e) {
                caches.open(e).then(function(t) {
                    t.keys().then(function(i) {
                        i.forEach(function(s) {
                            t["delete"](s);
                        });
                    });
                });
            }
        }
    ]);
}($8e4453fb4fc895c8$var$rt);
$8e4453fb4fc895c8$var$A.GENERIC_ERROR = "Error, please check the [troubleshooting](https://deepchat.dev/docs/webModel#troubleshooting) section of documentation for help.", $8e4453fb4fc895c8$var$A.MULTIPLE_MODELS_ERROR = "Cannot run multiple web models", $8e4453fb4fc895c8$var$A.WEB_LLM_NOT_FOUND_ERROR = "WebLLM module not found", $8e4453fb4fc895c8$var$A.DEFAULT_MODEL = "Llama-2-7b-chat-hf-q4f32_1", $8e4453fb4fc895c8$var$A.MODULE_SEARCH_LIMIT_S = 5;
var $8e4453fb4fc895c8$var$Wt = $8e4453fb4fc895c8$var$A;
var $8e4453fb4fc895c8$var$yi = /*#__PURE__*/ function() {
    function yi() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, yi);
    }
    return $8e4453fb4fc895c8$var$_createClass(yi, null, [
        {
            key: "buildHeaders",
            value: function buildHeaders(e) {
                return {
                    Authorization: "Bearer ".concat(e),
                    "Content-Type": "application/json"
                };
            }
        },
        {
            key: "handleVerificationResult",
            value: function handleVerificationResult(e, t, i, s) {
                var r = e;
                Array.isArray(r.error) && r.error[0] === "Error in `parameters`: field required" ? i(t) : s($8e4453fb4fc895c8$var$M.INVALID_KEY);
            }
        },
        {
            key: "buildKeyVerificationDetails",
            value: function buildKeyVerificationDetails() {
                return {
                    url: "https://api-inference.huggingface.co/models/gpt2",
                    method: "POST",
                    handleVerificationResult: yi.handleVerificationResult
                };
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$jt = /*#__PURE__*/ function(_G) {
    // prettier-ignore
    function jt(e, t, i, s, r, o) {
        var _this21;
        $8e4453fb4fc895c8$var$_classCallCheck(this, jt);
        _this21 = $8e4453fb4fc895c8$var$_callSuper(this, jt, [
            e,
            $8e4453fb4fc895c8$var$yi.buildKeyVerificationDetails(),
            $8e4453fb4fc895c8$var$yi.buildHeaders,
            r,
            o
        ]), _this21.insertKeyPlaceholderText = "Hugging Face Token", _this21.keyHelpUrl = "https://huggingface.co/settings/tokens", _this21.introPanelMarkUp = '\n    <div style="width: 100%; text-align: center; margin-left: -10px"><b>Hugging Face</b></div>\n    <p>First message may take an extented amount of time to complete as the model needs to be initialized.</p>', _this21.permittedErrorPrefixes = [
            "Authorization header"
        ], _this21.url = "".concat(jt.URL_PREFIX).concat(i), _this21.textInputPlaceholderText = t, $8e4453fb4fc895c8$var$_typeof(s) == "object" && (s.model && (_this21.url = "".concat(jt.URL_PREFIX).concat(s.model)), s.options && (_this21.rawBody.options = s.options), s.parameters && (_this21.rawBody.parameters = s.parameters));
        return _this21;
    }
    // prettier-ignore
    $8e4453fb4fc895c8$var$_inherits(jt, _G);
    return $8e4453fb4fc895c8$var$_createClass(jt, [
        {
            key: "preprocessBody",
            value: function preprocessBody(e, t, i) {
                var _s$options;
                var s = JSON.parse(JSON.stringify(e)), r = t[t.length - 1].text;
                if (r) return (_s$options = s.options) !== null && _s$options !== void 0 ? _s$options : s.options = {}, s.options.wait_for_model = !0, $8e4453fb4fc895c8$var$_objectSpread({
                    inputs: r
                }, s);
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI3 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee41(e, t, i) {
                    var s;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee41$(_context41) {
                        while(true)switch(_context41.prev = _context41.next){
                            case 0:
                                if (this.connectSettings) {
                                    _context41.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                s = this.preprocessBody(this.rawBody, t, i);
                                $8e4453fb4fc895c8$var$C.request(this, s, e);
                            case 4:
                            case "end":
                                return _context41.stop();
                        }
                    }, _callee41, this);
                }));
                function callServiceAPI(_x77, _x78, _x79) {
                    return _callServiceAPI3.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$G);
$8e4453fb4fc895c8$var$jt.URL_PREFIX = "https://api-inference.huggingface.co/models/";
var $8e4453fb4fc895c8$var$Fe = $8e4453fb4fc895c8$var$jt;
var $8e4453fb4fc895c8$var$ei = /*#__PURE__*/ function(_Fe) {
    // prettier-ignore
    function ei(e, t, i, s, r, o) {
        var _this22;
        $8e4453fb4fc895c8$var$_classCallCheck(this, ei);
        _this22 = $8e4453fb4fc895c8$var$_callSuper(this, ei, [
            e,
            t,
            i,
            s,
            r,
            o
        ]), _this22.isTextInputDisabled = !0, _this22.canSendMessage = ei.canSendFile;
        return _this22;
    }
    $8e4453fb4fc895c8$var$_inherits(ei, _Fe);
    return $8e4453fb4fc895c8$var$_createClass(ei, [
        {
            key: "preprocessBody",
            value: function preprocessBody(e, t, i) {
                return i[0];
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI4 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee42(e, t, i) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee42$(_context42) {
                        while(true)switch(_context42.prev = _context42.next){
                            case 0:
                                if (this.connectSettings) {
                                    _context42.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                if (i != null && i[0]) {
                                    _context42.next = 4;
                                    break;
                                }
                                throw new Error("No file was added");
                            case 4:
                                $8e4453fb4fc895c8$var$C.poll(this, i[0], e, !1);
                            case 5:
                            case "end":
                                return _context42.stop();
                        }
                    }, _callee42, this);
                }));
                function callServiceAPI(_x80, _x81, _x82) {
                    return _callServiceAPI4.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        }
    ], [
        {
            key: "canSendFile",
            value: function canSendFile(e, t) {
                return !!(t != null && t[0]);
            }
        }
    ]);
}($8e4453fb4fc895c8$var$Fe);
var $8e4453fb4fc895c8$var$No = /*#__PURE__*/ function(_ei) {
    // prettier-ignore
    function No(e) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, No);
        var s, r, o;
        var t = (r = (s = e.directConnection) == null ? void 0 : s.huggingFace) == null ? void 0 : r.audioClassification, i = (o = e.directConnection) == null ? void 0 : o.huggingFace;
        return $8e4453fb4fc895c8$var$_callSuper(this, No, [
            e,
            "Attach an audio file",
            "ehcalabres/wav2vec2-lg-xlsr-en-speech-emotion-recognition",
            t,
            i,
            {
                audio: {}
            }
        ]);
    }
    $8e4453fb4fc895c8$var$_inherits(No, _ei);
    return $8e4453fb4fc895c8$var$_createClass(No, [
        {
            key: "extractPollResultData",
            value: function() {
                var _extractPollResultData = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee43(e) {
                    var t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee43$(_context43) {
                        while(true)switch(_context43.prev = _context43.next){
                            case 0:
                                if (!e.estimated_time) {
                                    _context43.next = 2;
                                    break;
                                }
                                return _context43.abrupt("return", {
                                    timeoutMS: (e.estimated_time + 1) * 1e3
                                });
                            case 2:
                                if (!e.error) {
                                    _context43.next = 4;
                                    break;
                                }
                                throw e.error;
                            case 4:
                                return _context43.abrupt("return", {
                                    text: ((t = e[0]) == null ? void 0 : t.label) || ""
                                });
                            case 5:
                            case "end":
                                return _context43.stop();
                        }
                    }, _callee43);
                }));
                function extractPollResultData(_x83) {
                    return _extractPollResultData.apply(this, arguments);
                }
                return extractPollResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$ei);
var $8e4453fb4fc895c8$var$Do = /*#__PURE__*/ function(_ei2) {
    function Do(e) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Do);
        var s, r, o;
        var t = (r = (s = e.directConnection) == null ? void 0 : s.huggingFace) == null ? void 0 : r.imageClassification, i = (o = e.directConnection) == null ? void 0 : o.huggingFace;
        return $8e4453fb4fc895c8$var$_callSuper(this, Do, [
            e,
            "Attach an image file",
            "google/vit-base-patch16-224",
            t,
            i,
            {
                images: {}
            }
        ]);
    }
    $8e4453fb4fc895c8$var$_inherits(Do, _ei2);
    return $8e4453fb4fc895c8$var$_createClass(Do, [
        {
            key: "extractPollResultData",
            value: function() {
                var _extractPollResultData2 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee44(e) {
                    var t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee44$(_context44) {
                        while(true)switch(_context44.prev = _context44.next){
                            case 0:
                                if (!e.estimated_time) {
                                    _context44.next = 2;
                                    break;
                                }
                                return _context44.abrupt("return", {
                                    timeoutMS: (e.estimated_time + 1) * 1e3
                                });
                            case 2:
                                if (!e.error) {
                                    _context44.next = 4;
                                    break;
                                }
                                throw e.error;
                            case 4:
                                return _context44.abrupt("return", {
                                    text: ((t = e[0]) == null ? void 0 : t.label) || ""
                                });
                            case 5:
                            case "end":
                                return _context44.stop();
                        }
                    }, _callee44);
                }));
                function extractPollResultData(_x84) {
                    return _extractPollResultData2.apply(this, arguments);
                }
                return extractPollResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$ei);
var $8e4453fb4fc895c8$var$ti = "data:image/png;base64,";
var $8e4453fb4fc895c8$var$Ce = /*#__PURE__*/ function() {
    function Ce() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ce);
    }
    return $8e4453fb4fc895c8$var$_createClass(Ce, null, [
        {
            key: "buildHeaders",
            value: function buildHeaders(e) {
                return {
                    Authorization: "Bearer ".concat(e),
                    "Content-Type": "application/json"
                };
            }
        },
        {
            key: "handleVerificationResult",
            value: function handleVerificationResult(e, t, i, s) {
                e.message ? s($8e4453fb4fc895c8$var$M.INVALID_KEY) : i(t);
            }
        },
        {
            key: "buildKeyVerificationDetails",
            value: function buildKeyVerificationDetails() {
                return {
                    url: "https://api.stability.ai/v1/engines/list",
                    method: "GET",
                    handleVerificationResult: Ce.handleVerificationResult
                };
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Hi = /*#__PURE__*/ function(_G2) {
    // prettier-ignore
    function Hi(e, t, i, s, r) {
        var _this23;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Hi);
        _this23 = $8e4453fb4fc895c8$var$_callSuper(this, Hi, [
            e,
            t,
            i,
            s,
            r
        ]), _this23.insertKeyPlaceholderText = "Stability AI API Key", _this23.keyHelpUrl = "https://platform.stability.ai/docs/getting-started/authentication", _this23.permittedErrorPrefixes = [
            "Incorrect",
            "invalid_"
        ];
        return _this23;
    }
    $8e4453fb4fc895c8$var$_inherits(Hi, _G2);
    return $8e4453fb4fc895c8$var$_createClass(Hi);
}($8e4453fb4fc895c8$var$G);
var $8e4453fb4fc895c8$var$Ei = /*#__PURE__*/ function(_Hi) {
    function Ei(e) {
        var _this24;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ei);
        var o;
        var t = JSON.parse(JSON.stringify(e.directConnection)), i = t == null ? void 0 : t.stabilityAI, s = {
            images: {
                files: {
                    acceptedFormats: ".png",
                    maxNumberOfFiles: 1
                }
            }
        };
        _this24 = $8e4453fb4fc895c8$var$_callSuper(this, Ei, [
            e,
            $8e4453fb4fc895c8$var$Ce.buildKeyVerificationDetails(),
            $8e4453fb4fc895c8$var$Ce.buildHeaders,
            i,
            s
        ]), _this24.url = "https://api.stability.ai/v1/generation/esrgan-v1-x2plus/image-to-image/upscale", _this24.textInputPlaceholderText = "Describe image changes", _this24.introPanelMarkUp = '\n    <div style="width: 100%; text-align: center; margin-left: -10px"><b>Stability AI</b></div>\n    <div style="width: 100%; text-align: center; margin-left: -10px; margin-top: 5px"><b>Image to Image Upscale</b></div>\n    <p>Upload an image to generate a new one with higher resolution.</p>\n    <p>Click <a href="https://platform.stability.ai/">here</a> for more info.</p>';
        var r = (o = t == null ? void 0 : t.stabilityAI) == null ? void 0 : o.imageToImageUpscale;
        $8e4453fb4fc895c8$var$_typeof(r) == "object" && (r.engine_id && (_this24.url = "https://api.stability.ai/v1/generation/".concat(r.engine_id, "/image-to-image/upscale")), Ei.cleanConfig(r), Object.assign(_this24.rawBody, r)), _this24.canSendMessage = Ei.canSendFileMessage;
        return _this24;
    }
    $8e4453fb4fc895c8$var$_inherits(Ei, _Hi);
    return $8e4453fb4fc895c8$var$_createClass(Ei, [
        {
            key: "createFormDataBody",
            value: function createFormDataBody(e, t) {
                var i = new FormData();
                return i.append("image", t), Object.keys(e).forEach(function(s) {
                    i.append(s, String(e[s]));
                }), i;
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI5 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee45(e, t, i) {
                    var s;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee45$(_context45) {
                        while(true)switch(_context45.prev = _context45.next){
                            case 0:
                                if (this.connectSettings) {
                                    _context45.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                if (i) {
                                    _context45.next = 4;
                                    break;
                                }
                                throw new Error("Image was not found");
                            case 4:
                                s = this.createFormDataBody(this.rawBody, i[0]);
                                $8e4453fb4fc895c8$var$E.tempRemoveContentHeader(this.connectSettings, $8e4453fb4fc895c8$var$C.request.bind(this, this, s, e), !1);
                            case 6:
                            case "end":
                                return _context45.stop();
                        }
                    }, _callee45, this);
                }));
                function callServiceAPI(_x85, _x86, _x87) {
                    return _callServiceAPI5.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData2 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee46(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee46$(_context46) {
                        while(true)switch(_context46.prev = _context46.next){
                            case 0:
                                if (!e.message) {
                                    _context46.next = 2;
                                    break;
                                }
                                throw e.message;
                            case 2:
                                return _context46.abrupt("return", {
                                    files: e.artifacts.map(function(i) {
                                        return {
                                            src: "".concat($8e4453fb4fc895c8$var$ti).concat(i.base64),
                                            type: "image"
                                        };
                                    })
                                });
                            case 3:
                            case "end":
                                return _context46.stop();
                        }
                    }, _callee46);
                }));
                function extractResultData(_x88) {
                    return _extractResultData2.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ], [
        {
            key: "cleanConfig",
            value: function cleanConfig(e) {
                delete e.engine_id;
            }
        },
        {
            key: "canSendFileMessage",
            value: function canSendFileMessage(e, t) {
                return !!(t != null && t[0]);
            }
        }
    ]);
}($8e4453fb4fc895c8$var$Hi);
var $8e4453fb4fc895c8$var$Si = /*#__PURE__*/ function(_Hi2) {
    function Si(e) {
        var _this25;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Si);
        var o;
        var t = JSON.parse(JSON.stringify(e.directConnection)), i = t == null ? void 0 : t.stabilityAI, s = {
            images: {
                files: {
                    acceptedFormats: ".png",
                    maxNumberOfFiles: 2
                }
            }
        };
        _this25 = $8e4453fb4fc895c8$var$_callSuper(this, Si, [
            e,
            $8e4453fb4fc895c8$var$Ce.buildKeyVerificationDetails(),
            $8e4453fb4fc895c8$var$Ce.buildHeaders,
            i,
            s
        ]), _this25.url = "https://api.stability.ai/v1/generation/stable-diffusion-xl-1024-v1-0/image-to-image/masking", _this25._maskSource = "MASK_IMAGE_WHITE", _this25.textInputPlaceholderText = "Describe image changes", _this25.introPanelMarkUp = '\n    <div style="width: 100%; text-align: center; margin-left: -10px"><b>Stability AI</b></div>\n    <div style="width: 100%; text-align: center; margin-left: -10px; margin-top: 5px"><b>Image to Image Masking</b></div>\n    <p>Upload an image, its mask image to create a new one based on the changes you have described for the mask area.</p>\n    <p>Click <a href="https://platform.stability.ai/">here</a> for more info.</p>';
        var r = (o = t == null ? void 0 : t.stabilityAI) == null ? void 0 : o.imageToImageMasking;
        $8e4453fb4fc895c8$var$_typeof(r) == "object" && (r.engine_id && (_this25.url = "https://api.stability.ai/v1/generation/".concat(r.engine_id, "/image-to-image/masking")), r.weight !== void 0 && r.weight !== null && (_this25._imageWeight = r.weight), r.mask_source !== void 0 && r.mask_source !== null && (_this25._maskSource = r.mask_source), Si.cleanConfig(r), Object.assign(_this25.rawBody, r)), _this25.canSendMessage = Si.canSendFileTextMessage;
        return _this25;
    }
    $8e4453fb4fc895c8$var$_inherits(Si, _Hi2);
    return $8e4453fb4fc895c8$var$_createClass(Si, [
        {
            key: "createFormDataBody",
            value: function createFormDataBody(e, t, i, s) {
                var r = new FormData();
                return r.append("init_image", t), r.append("mask_source", String(this._maskSource)), r.append("mask_image", i), s && s !== "" && r.append("text_prompts[0][text]", s), this._imageWeight !== void 0 && this._imageWeight !== null && r.append("text_prompts[0][weight]", String(this._imageWeight)), Object.keys(e).forEach(function(o) {
                    r.append(o, String(e[o]));
                }), r.get("weight") === void 0 && r.append("weight", String(1)), r;
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI6 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee47(e, t, i) {
                    var o, a, s, r;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee47$(_context47) {
                        while(true)switch(_context47.prev = _context47.next){
                            case 0:
                                if (this.connectSettings) {
                                    _context47.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                if (!(!i || !i[0] || !i[1])) {
                                    _context47.next = 4;
                                    break;
                                }
                                throw new Error("Image was not found");
                            case 4:
                                s = (a = (o = t[t.length - 1]) == null ? void 0 : o.text) == null ? void 0 : a.trim(), r = this.createFormDataBody(this.rawBody, i[0], i[1], s);
                                $8e4453fb4fc895c8$var$E.tempRemoveContentHeader(this.connectSettings, $8e4453fb4fc895c8$var$C.request.bind(this, this, r, e), !1);
                            case 6:
                            case "end":
                                return _context47.stop();
                        }
                    }, _callee47, this);
                }));
                function callServiceAPI(_x89, _x90, _x91) {
                    return _callServiceAPI6.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData3 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee48(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee48$(_context48) {
                        while(true)switch(_context48.prev = _context48.next){
                            case 0:
                                if (!e.message) {
                                    _context48.next = 2;
                                    break;
                                }
                                throw e.message;
                            case 2:
                                return _context48.abrupt("return", {
                                    files: e.artifacts.map(function(i) {
                                        return {
                                            src: "".concat($8e4453fb4fc895c8$var$ti).concat(i.base64),
                                            type: "image"
                                        };
                                    })
                                });
                            case 3:
                            case "end":
                                return _context48.stop();
                        }
                    }, _callee48);
                }));
                function extractResultData(_x92) {
                    return _extractResultData3.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ], [
        {
            key: "cleanConfig",
            value: function cleanConfig(e) {
                delete e.engine_id, delete e.weight;
            }
        },
        {
            key: "canSendFileTextMessage",
            value: function canSendFileTextMessage(e, t) {
                return !!(t != null && t[0]) && !!(e && e.trim() !== "");
            }
        }
    ]);
}($8e4453fb4fc895c8$var$Hi);
var $8e4453fb4fc895c8$var$Bo = /*#__PURE__*/ function(_ei3) {
    function Bo(e) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Bo);
        var s, r, o;
        var t = (r = (s = e.directConnection) == null ? void 0 : s.huggingFace) == null ? void 0 : r.audioSpeechRecognition, i = (o = e.directConnection) == null ? void 0 : o.huggingFace;
        return $8e4453fb4fc895c8$var$_callSuper(this, Bo, [
            e,
            "Attach an audio file",
            "facebook/wav2vec2-large-960h-lv60-self",
            t,
            i,
            {
                audio: {}
            }
        ]);
    }
    $8e4453fb4fc895c8$var$_inherits(Bo, _ei3);
    return $8e4453fb4fc895c8$var$_createClass(Bo, [
        {
            key: "extractPollResultData",
            value: function() {
                var _extractPollResultData3 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee49(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee49$(_context49) {
                        while(true)switch(_context49.prev = _context49.next){
                            case 0:
                                if (!e.estimated_time) {
                                    _context49.next = 2;
                                    break;
                                }
                                return _context49.abrupt("return", {
                                    timeoutMS: (e.estimated_time + 1) * 1e3
                                });
                            case 2:
                                if (!e.error) {
                                    _context49.next = 4;
                                    break;
                                }
                                throw e.error;
                            case 4:
                                return _context49.abrupt("return", {
                                    text: e.text || ""
                                });
                            case 5:
                            case "end":
                                return _context49.stop();
                        }
                    }, _callee49);
                }));
                function extractPollResultData(_x93) {
                    return _extractPollResultData3.apply(this, arguments);
                }
                return extractPollResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$ei);
var $8e4453fb4fc895c8$var$Fo = /*#__PURE__*/ function(_Fe2) {
    function Fo(e) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Fo);
        var s, r, o;
        var t = (r = (s = e.directConnection) == null ? void 0 : s.huggingFace) == null ? void 0 : r.textGeneration, i = (o = e.directConnection) == null ? void 0 : o.huggingFace;
        return $8e4453fb4fc895c8$var$_callSuper(this, Fo, [
            e,
            "Once upon a time",
            "gpt2",
            t,
            i
        ]);
    }
    $8e4453fb4fc895c8$var$_inherits(Fo, _Fe2);
    return $8e4453fb4fc895c8$var$_createClass(Fo, [
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData4 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee50(e) {
                    var t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee50$(_context50) {
                        while(true)switch(_context50.prev = _context50.next){
                            case 0:
                                if (!e.error) {
                                    _context50.next = 2;
                                    break;
                                }
                                throw e.error;
                            case 2:
                                return _context50.abrupt("return", {
                                    text: ((t = e[0]) == null ? void 0 : t.generated_text) || ""
                                });
                            case 3:
                            case "end":
                                return _context50.stop();
                        }
                    }, _callee50);
                }));
                function extractResultData(_x94) {
                    return _extractResultData4.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$Fe);
var $8e4453fb4fc895c8$var$Uo = /*#__PURE__*/ function(_Fe3) {
    function Uo(e) {
        var _this26;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Uo);
        var s, r, o;
        var t = (r = (s = e.directConnection) == null ? void 0 : s.huggingFace) == null ? void 0 : r.questionAnswer, i = (o = e.directConnection) == null ? void 0 : o.huggingFace;
        _this26 = $8e4453fb4fc895c8$var$_callSuper(this, Uo, [
            e,
            "Ask a question",
            "bert-large-uncased-whole-word-masking-finetuned-squad",
            t,
            i
        ]), _this26.permittedErrorPrefixes = [
            "Authorization header",
            "Error in"
        ], _this26.context = t.context;
        return _this26;
    }
    $8e4453fb4fc895c8$var$_inherits(Uo, _Fe3);
    return $8e4453fb4fc895c8$var$_createClass(Uo, [
        {
            key: "preprocessBody",
            value: function preprocessBody(e, t) {
                var i = t[t.length - 1].text;
                if (i) return {
                    inputs: {
                        question: i,
                        context: this.context,
                        options: {
                            wait_for_model: !0
                        }
                    }
                };
            }
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData5 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee51(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee51$(_context51) {
                        while(true)switch(_context51.prev = _context51.next){
                            case 0:
                                if (!e.error) {
                                    _context51.next = 2;
                                    break;
                                }
                                throw e.error;
                            case 2:
                                return _context51.abrupt("return", {
                                    text: e.answer || ""
                                });
                            case 3:
                            case "end":
                                return _context51.stop();
                        }
                    }, _callee51);
                }));
                function extractResultData(_x95) {
                    return _extractResultData5.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$Fe);
var $8e4453fb4fc895c8$var$jo = /*#__PURE__*/ function(_Fe4) {
    function jo(e) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, jo);
        var s, r, o;
        var t = (r = (s = e.directConnection) == null ? void 0 : s.huggingFace) == null ? void 0 : r.summarization, i = (o = e.directConnection) == null ? void 0 : o.huggingFace;
        return $8e4453fb4fc895c8$var$_callSuper(this, jo, [
            e,
            "Insert text to summarize",
            "facebook/bart-large-cnn",
            t,
            i
        ]);
    }
    $8e4453fb4fc895c8$var$_inherits(jo, _Fe4);
    return $8e4453fb4fc895c8$var$_createClass(jo, [
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData6 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee52(e) {
                    var t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee52$(_context52) {
                        while(true)switch(_context52.prev = _context52.next){
                            case 0:
                                if (!e.error) {
                                    _context52.next = 2;
                                    break;
                                }
                                throw e.error;
                            case 2:
                                return _context52.abrupt("return", {
                                    text: ((t = e[0]) == null ? void 0 : t.summary_text) || ""
                                });
                            case 3:
                            case "end":
                                return _context52.stop();
                        }
                    }, _callee52);
                }));
                function extractResultData(_x96) {
                    return _extractResultData6.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$Fe);
var $8e4453fb4fc895c8$var$Ho = /*#__PURE__*/ function(_Fe5) {
    function Ho(e) {
        var _this27$maxMessages;
        var _this27;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ho);
        var s, r, o;
        var t = (r = (s = e.directConnection) == null ? void 0 : s.huggingFace) == null ? void 0 : r.conversation, i = (o = e.directConnection) == null ? void 0 : o.huggingFace;
        _this27 = $8e4453fb4fc895c8$var$_callSuper(this, Ho, [
            e,
            "Ask me anything!",
            "facebook/blenderbot-400M-distill",
            t,
            i
        ]), (_this27$maxMessages = _this27.maxMessages) !== null && _this27$maxMessages !== void 0 ? _this27$maxMessages : _this27.maxMessages = -1;
        return _this27;
    }
    // prettier-ignore
    $8e4453fb4fc895c8$var$_inherits(Ho, _Fe5);
    return $8e4453fb4fc895c8$var$_createClass(Ho, [
        {
            key: "processMessages",
            value: function processMessages(e) {
                var t = e.filter(function(a) {
                    return a.text;
                }), i = t[t.length - 1].text, s = t.slice(0, t.length - 1);
                if (!i) return;
                var r = s.filter(function(a) {
                    return a.role === "user";
                }).map(function(a) {
                    return a.text;
                }), o = s.filter(function(a) {
                    return a.role === "ai";
                }).map(function(a) {
                    return a.text;
                });
                return {
                    past_user_inputs: r,
                    generated_responses: o,
                    mostRecentMessageText: i
                };
            }
        },
        {
            key: "preprocessBody",
            value: function preprocessBody(e, t) {
                var _i$options;
                var i = JSON.parse(JSON.stringify(e)), s = this.processMessages(t);
                if (s) return (_i$options = i.options) !== null && _i$options !== void 0 ? _i$options : i.options = {}, i.options.wait_for_model = !0, $8e4453fb4fc895c8$var$_objectSpread({
                    inputs: {
                        past_user_inputs: s.past_user_inputs,
                        generated_responses: s.generated_responses,
                        text: s.mostRecentMessageText
                    }
                }, i);
            }
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData7 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee53(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee53$(_context53) {
                        while(true)switch(_context53.prev = _context53.next){
                            case 0:
                                if (!e.error) {
                                    _context53.next = 2;
                                    break;
                                }
                                throw e.error;
                            case 2:
                                return _context53.abrupt("return", {
                                    text: e.generated_text || ""
                                });
                            case 3:
                            case "end":
                                return _context53.stop();
                        }
                    }, _callee53);
                }));
                function extractResultData(_x97) {
                    return _extractResultData7.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$Fe);
var $8e4453fb4fc895c8$var$xi = /*#__PURE__*/ function(_Hi3) {
    function xi(e) {
        var _this28;
        $8e4453fb4fc895c8$var$_classCallCheck(this, xi);
        var o;
        var t = JSON.parse(JSON.stringify(e.directConnection)), i = t.stabilityAI, s = {
            images: {
                files: {
                    acceptedFormats: ".png",
                    maxNumberOfFiles: 1
                }
            }
        };
        _this28 = $8e4453fb4fc895c8$var$_callSuper(this, xi, [
            e,
            $8e4453fb4fc895c8$var$Ce.buildKeyVerificationDetails(),
            $8e4453fb4fc895c8$var$Ce.buildHeaders,
            i,
            s
        ]), _this28.url = "https://api.stability.ai/v1/generation/stable-diffusion-v1-6/image-to-image", _this28.textInputPlaceholderText = "Describe image changes", _this28.introPanelMarkUp = '\n    <div style="width: 100%; text-align: center; margin-left: -10px"><b>Stability AI: Image to Image</b></div>\n    <p>Upload an image to create a new one with the changes you have described.</p>\n    <p>Click <a href="https://platform.stability.ai/">here</a> for more info.</p>';
        var r = (o = t.stabilityAI) == null ? void 0 : o.imageToImage;
        $8e4453fb4fc895c8$var$_typeof(r) == "object" && (r.engine_id && (_this28.url = "https://api.stability.ai/v1/generation/".concat(r.engine_id, "/text-to-image")), r.weight !== void 0 && r.weight !== null && (_this28._imageWeight = r.weight), xi.cleanConfig(r), Object.assign(_this28.rawBody, r)), _this28.canSendMessage = xi.canSendFileTextMessage;
        return _this28;
    }
    $8e4453fb4fc895c8$var$_inherits(xi, _Hi3);
    return $8e4453fb4fc895c8$var$_createClass(xi, [
        {
            key: "createFormDataBody",
            value: function createFormDataBody(e, t, i) {
                var s = new FormData();
                return s.append("init_image", t), i && i !== "" && s.append("text_prompts[0][text]", i), this._imageWeight !== void 0 && this._imageWeight !== null && s.append("text_prompts[0][weight]", String(this._imageWeight)), Object.keys(e).forEach(function(r) {
                    s.append(r, String(e[r]));
                }), s.get("weight") === void 0 && s.append("weight", String(1)), s;
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI7 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee54(e, t, i) {
                    var o, a, s, r;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee54$(_context54) {
                        while(true)switch(_context54.prev = _context54.next){
                            case 0:
                                if (this.connectSettings) {
                                    _context54.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                if (i) {
                                    _context54.next = 4;
                                    break;
                                }
                                throw new Error("Image was not found");
                            case 4:
                                s = (a = (o = t[t.length - 1]) == null ? void 0 : o.text) == null ? void 0 : a.trim(), r = this.createFormDataBody(this.rawBody, i[0], s);
                                $8e4453fb4fc895c8$var$E.tempRemoveContentHeader(this.connectSettings, $8e4453fb4fc895c8$var$C.request.bind(this, this, r, e), !1);
                            case 6:
                            case "end":
                                return _context54.stop();
                        }
                    }, _callee54, this);
                }));
                function callServiceAPI(_x98, _x99, _x100) {
                    return _callServiceAPI7.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData8 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee55(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee55$(_context55) {
                        while(true)switch(_context55.prev = _context55.next){
                            case 0:
                                if (!e.message) {
                                    _context55.next = 2;
                                    break;
                                }
                                throw e.message;
                            case 2:
                                return _context55.abrupt("return", {
                                    files: e.artifacts.map(function(i) {
                                        return {
                                            src: "".concat($8e4453fb4fc895c8$var$ti).concat(i.base64),
                                            type: "image"
                                        };
                                    })
                                });
                            case 3:
                            case "end":
                                return _context55.stop();
                        }
                    }, _callee55);
                }));
                function extractResultData(_x101) {
                    return _extractResultData8.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ], [
        {
            key: "cleanConfig",
            value: function cleanConfig(e) {
                delete e.engine_id, delete e.weight;
            }
        },
        {
            key: "canSendFileTextMessage",
            value: function canSendFileTextMessage(e, t) {
                return !!(t != null && t[0]) && !!(e && e.trim() !== "");
            }
        }
    ]);
}($8e4453fb4fc895c8$var$Hi);
var $8e4453fb4fc895c8$var$qo = /*#__PURE__*/ function(_Fe6) {
    function qo(e) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, qo);
        var s, r, o;
        var t = (r = (s = e.directConnection) == null ? void 0 : s.huggingFace) == null ? void 0 : r.translation, i = (o = e.directConnection) == null ? void 0 : o.huggingFace;
        return $8e4453fb4fc895c8$var$_callSuper(this, qo, [
            e,
            "Insert text to translate",
            "Helsinki-NLP/opus-tatoeba-en-ja",
            t,
            i
        ]);
    }
    $8e4453fb4fc895c8$var$_inherits(qo, _Fe6);
    return $8e4453fb4fc895c8$var$_createClass(qo, [
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData9 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee56(e) {
                    var t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee56$(_context56) {
                        while(true)switch(_context56.prev = _context56.next){
                            case 0:
                                if (!e.error) {
                                    _context56.next = 2;
                                    break;
                                }
                                throw e.error;
                            case 2:
                                return _context56.abrupt("return", {
                                    text: ((t = e[0]) == null ? void 0 : t.translation_text) || ""
                                });
                            case 3:
                            case "end":
                                return _context56.stop();
                        }
                    }, _callee56);
                }));
                function extractResultData(_x102) {
                    return _extractResultData9.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$Fe);
var $8e4453fb4fc895c8$var$_i = /*#__PURE__*/ function(_Hi4) {
    function _i(e) {
        var _this29;
        $8e4453fb4fc895c8$var$_classCallCheck(this, _i);
        var r;
        var t = JSON.parse(JSON.stringify(e.directConnection)), i = t.stabilityAI;
        _this29 = $8e4453fb4fc895c8$var$_callSuper(this, _i, [
            e,
            $8e4453fb4fc895c8$var$Ce.buildKeyVerificationDetails(),
            $8e4453fb4fc895c8$var$Ce.buildHeaders,
            i
        ]), _this29.url = "https://api.stability.ai/v1/generation/stable-diffusion-v1-6/text-to-image", _this29.textInputPlaceholderText = "Describe an image", _this29.introPanelMarkUp = '\n    <div style="width: 100%; text-align: center; margin-left: -10px"><b>Stability AI: Text to Image</b></div>\n    <p>Insert text to generate an image.</p>\n    <p>Click <a href="https://platform.stability.ai/">here</a> for more info.</p>';
        var s = (r = t.stabilityAI) == null ? void 0 : r.textToImage;
        $8e4453fb4fc895c8$var$_typeof(s) == "object" && (s.engine_id && (_this29.url = "https://api.stability.ai/v1/generation/".concat(s.engine_id, "/text-to-image")), s.weight !== void 0 && s.weight !== null && (_this29._imageWeight = s.weight), _i.cleanConfig(s), Object.assign(_this29.rawBody, s)), _this29.canSendMessage = _i.canSendTextMessage;
        return _this29;
    }
    $8e4453fb4fc895c8$var$_inherits(_i, _Hi4);
    return $8e4453fb4fc895c8$var$_createClass(_i, [
        {
            key: "preprocessBody",
            value: function preprocessBody(e, t) {
                var i = JSON.parse(JSON.stringify(e)), s = {
                    text: t
                };
                return this._imageWeight && (s.weight = this._imageWeight), i.text_prompts = [
                    s
                ], i;
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI8 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee57(e, t) {
                    var i;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee57$(_context57) {
                        while(true)switch(_context57.prev = _context57.next){
                            case 0:
                                if (this.connectSettings) {
                                    _context57.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                i = this.preprocessBody(this.rawBody, t[t.length - 1].text);
                                $8e4453fb4fc895c8$var$C.request(this, i, e);
                            case 4:
                            case "end":
                                return _context57.stop();
                        }
                    }, _callee57, this);
                }));
                function callServiceAPI(_x103, _x104) {
                    return _callServiceAPI8.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData10 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee58(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee58$(_context58) {
                        while(true)switch(_context58.prev = _context58.next){
                            case 0:
                                if (!e.message) {
                                    _context58.next = 2;
                                    break;
                                }
                                throw e.message;
                            case 2:
                                return _context58.abrupt("return", {
                                    files: e.artifacts.map(function(i) {
                                        return {
                                            src: "".concat($8e4453fb4fc895c8$var$ti).concat(i.base64),
                                            type: "image"
                                        };
                                    })
                                });
                            case 3:
                            case "end":
                                return _context58.stop();
                        }
                    }, _callee58);
                }));
                function extractResultData(_x105) {
                    return _extractResultData10.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ], [
        {
            key: "cleanConfig",
            value: function cleanConfig(e) {
                delete e.engine_id, delete e.weight;
            }
        },
        {
            key: "canSendTextMessage",
            value: function canSendTextMessage(e) {
                return !!(e && e.trim() !== "");
            }
        }
    ]);
}($8e4453fb4fc895c8$var$Hi);
var $8e4453fb4fc895c8$var$zo = /*#__PURE__*/ function(_Fe7) {
    function zo(e) {
        var _this30;
        $8e4453fb4fc895c8$var$_classCallCheck(this, zo);
        var s, r, o;
        var t = (r = (s = e.directConnection) == null ? void 0 : s.huggingFace) == null ? void 0 : r.fillMask, i = (o = e.directConnection) == null ? void 0 : o.huggingFace;
        _this30 = $8e4453fb4fc895c8$var$_callSuper(this, zo, [
            e,
            "The goal of life is [MASK].",
            "bert-base-uncased",
            t,
            i
        ]), _this30.introPanelMarkUp = '\n    <div style="width: 100%; text-align: center; margin-left: -10px"><b>Hugging Face</b></div>\n    <p>Insert a sentence with the word [MASK] and the model will try to fill it for you. E.g. I want [MASK].</p>\n    <p>First message may take an extented amount of time to complete as the model needs to be initialized.</p>', _this30.permittedErrorPrefixes = [
            "Authorization header",
            "No mask_token"
        ];
        return _this30;
    }
    $8e4453fb4fc895c8$var$_inherits(zo, _Fe7);
    return $8e4453fb4fc895c8$var$_createClass(zo, [
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData11 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee59(e) {
                    var t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee59$(_context59) {
                        while(true)switch(_context59.prev = _context59.next){
                            case 0:
                                if (!e.error) {
                                    _context59.next = 2;
                                    break;
                                }
                                throw e.error;
                            case 2:
                                return _context59.abrupt("return", {
                                    text: ((t = e[0]) == null ? void 0 : t.sequence) || ""
                                });
                            case 3:
                            case "end":
                                return _context59.stop();
                        }
                    }, _callee59);
                }));
                function extractResultData(_x106) {
                    return _extractResultData11.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$Fe);
var $8e4453fb4fc895c8$var$Bi = /*#__PURE__*/ function() {
    function Bi() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Bi);
    }
    return $8e4453fb4fc895c8$var$_createClass(Bi, null, [
        {
            key: "buildHeaders",
            value: function buildHeaders(e) {
                return {
                    Authorization: "Bearer ".concat(e),
                    "Content-Type": "application/json"
                };
            }
        },
        {
            key: "handleVerificationResult",
            value: function handleVerificationResult(e, t, i, s) {
                var r = e;
                r.error ? r.error.code === "invalid_api_key" ? s($8e4453fb4fc895c8$var$M.INVALID_KEY) : s($8e4453fb4fc895c8$var$M.CONNECTION_FAILED) : i(t);
            }
        },
        {
            key: "buildKeyVerificationDetails",
            value: function buildKeyVerificationDetails() {
                return {
                    url: "https://api.openai.com/v1/models",
                    method: "GET",
                    handleVerificationResult: Bi.handleVerificationResult
                };
            }
        },
        {
            key: "directFetch",
            value: function() {
                var _directFetch = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee60(e, t, i) {
                    var s, r, _args60 = arguments;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee60$(_context60) {
                        while(true)switch(_context60.prev = _context60.next){
                            case 0:
                                s = _args60.length > 3 && _args60[3] !== undefined ? _args60[3] : !0;
                                e.connectSettings.method = i;
                                _context60.next = 4;
                                return $8e4453fb4fc895c8$var$E.fetch(e, e.connectSettings.headers, s, t).then(function(o) {
                                    return $8e4453fb4fc895c8$var$E.processResponseByType(o);
                                });
                            case 4:
                                r = _context60.sent;
                                if (!r.error) {
                                    _context60.next = 7;
                                    break;
                                }
                                throw r.error.message;
                            case 7:
                                return _context60.abrupt("return", r);
                            case 8:
                            case "end":
                                return _context60.stop();
                        }
                    }, _callee60);
                }));
                function directFetch(_x107, _x108, _x109) {
                    return _directFetch.apply(this, arguments);
                }
                return directFetch;
            }()
        }
    ]);
}();
$8e4453fb4fc895c8$var$Bi.FUNCTION_TOOL_RESP_ERROR = "Response object must either be {response: string}[] for each individual function or {text: string} for a direct response, see https://deepchat.dev/docs/directConnection/OpenAI#FunctionHandler.";
var $8e4453fb4fc895c8$var$I = $8e4453fb4fc895c8$var$Bi;
var $8e4453fb4fc895c8$var$se = /*#__PURE__*/ function() {
    function se() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, se);
    }
    return $8e4453fb4fc895c8$var$_createClass(se, null, [
        {
            key: "storeFiles",
            value: function() {
                var _storeFiles = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee62(e, t, i, s) {
                    var r, o, a, l;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee62$(_context62) {
                        while(true)switch(_context62.prev = _context62.next){
                            case 0:
                                r = e.connectSettings.headers;
                                if (r) {
                                    _context62.next = 3;
                                    break;
                                }
                                return _context62.abrupt("return");
                            case 3:
                                e.url = s;
                                o = r[$8e4453fb4fc895c8$var$E.CONTENT_TYPE];
                                delete r[$8e4453fb4fc895c8$var$E.CONTENT_TYPE];
                                a = i.map(/*#__PURE__*/ function() {
                                    var _ref15 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee61(l) {
                                        var c;
                                        return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee61$(_context61) {
                                            while(true)switch(_context61.prev = _context61.next){
                                                case 0:
                                                    c = new FormData();
                                                    return _context61.abrupt("return", (c.append("purpose", "assistants"), c.append("file", l), new Promise(function(d) {
                                                        d($8e4453fb4fc895c8$var$I.directFetch(e, c, "POST", !1));
                                                    })));
                                                case 2:
                                                case "end":
                                                    return _context61.stop();
                                            }
                                        }, _callee61);
                                    }));
                                    return function(_x114) {
                                        return _ref15.apply(this, arguments);
                                    };
                                }());
                                _context62.prev = 7;
                                _context62.next = 10;
                                return Promise.all(a);
                            case 10:
                                l = _context62.sent.map(function(c) {
                                    return {
                                        id: c.id,
                                        name: c.filename
                                    };
                                });
                                return _context62.abrupt("return", (r[$8e4453fb4fc895c8$var$E.CONTENT_TYPE] = o, l));
                            case 14:
                                _context62.prev = 14;
                                _context62.t0 = _context62["catch"](7);
                                throw r[$8e4453fb4fc895c8$var$E.CONTENT_TYPE] = o, $8e4453fb4fc895c8$var$E.displayError(t, _context62.t0), e.completionsHandlers.onFinish(), _context62.t0;
                            case 17:
                            case "end":
                                return _context62.stop();
                        }
                    }, _callee62, null, [
                        [
                            7,
                            14
                        ]
                    ]);
                }));
                function storeFiles(_x110, _x111, _x112, _x113) {
                    return _storeFiles.apply(this, arguments);
                }
                return storeFiles;
            }()
        },
        {
            key: "getType",
            value: function getType(e, t) {
                var i = e[t].path;
                return !i || i.endsWith("png") ? "image" : "any";
            }
        },
        {
            key: "getFiles",
            value: function() {
                var _getFiles = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee63(e, t, i, s) {
                    var r, a;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee63$(_context63) {
                        while(true)switch(_context63.prev = _context63.next){
                            case 0:
                                r = t.map(function(_ref16) {
                                    var l = _ref16.fileId;
                                    return e.url = "".concat(i).concat(l).concat(s), new Promise(function(c) {
                                        c($8e4453fb4fc895c8$var$I.directFetch(e, void 0, "GET", !1));
                                    });
                                });
                                _context63.next = 3;
                                return Promise.all(r);
                            case 3:
                                a = _context63.sent.map(function(l, c) {
                                    return new Promise(function(d) {
                                        var h = new FileReader();
                                        h.readAsDataURL(l), h.onload = function(f) {
                                            d({
                                                src: f.target.result,
                                                name: t[c].name,
                                                type: se.getType(t, c)
                                            });
                                        };
                                    });
                                });
                                _context63.next = 6;
                                return Promise.all(a);
                            case 6:
                                return _context63.abrupt("return", _context63.sent);
                            case 7:
                            case "end":
                                return _context63.stop();
                        }
                    }, _callee63);
                }));
                function getFiles(_x115, _x116, _x117, _x118) {
                    return _getFiles.apply(this, arguments);
                }
                return getFiles;
            }()
        },
        {
            key: "getFileName",
            value: function getFileName(e) {
                var t = e.split("/");
                return t[t.length - 1];
            }
        },
        {
            key: "getFilesAndNewText",
            value: function() {
                var _getFilesAndNewText = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee64(e, t, i, s, r) {
                    var c, d, o, a, l;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee64$(_context64) {
                        while(true)switch(_context64.prev = _context64.next){
                            case 0:
                                a = i.getFilesPrefix, l = i.getFilesPostfix;
                                _context64.t0 = t.length > 0;
                                if (!_context64.t0) {
                                    _context64.next = 7;
                                    break;
                                }
                                _context64.next = 5;
                                return se.getFiles(e, t, a, l);
                            case 5:
                                o = _context64.sent;
                                (c = r == null ? void 0 : r.text) != null && c.value && o.forEach(function(h, f) {
                                    var m;
                                    if (!h.src) return;
                                    var u = t[f].path;
                                    (m = r == null ? void 0 : r.text) != null && m.value && u && (r.text.value = r.text.value.replace(u, h.src));
                                });
                            case 7:
                                return _context64.abrupt("return", (d = r == null ? void 0 : r.text) != null && d.value ? {
                                    text: r.text.value,
                                    role: s
                                } : {
                                    files: o,
                                    role: s
                                });
                            case 8:
                            case "end":
                                return _context64.stop();
                        }
                    }, _callee64);
                }));
                function getFilesAndNewText(_x119, _x120, _x121, _x122, _x123) {
                    return _getFilesAndNewText.apply(this, arguments);
                }
                return getFilesAndNewText;
            }() // Noticed an issue where text contains a sandbox hyperlink to a csv, but no annotation provided
        },
        {
            key: "getFileDetails",
            value: function getFileDetails(e, t) {
                var s;
                var i = [];
                return (s = t == null ? void 0 : t.text) != null && s.value && e.content.forEach(function(r) {
                    var o, a;
                    (a = (o = r.text) == null ? void 0 : o.annotations) == null || a.forEach(function(l) {
                        var c;
                        l.text && l.text.startsWith("sandbox:") && (c = l.file_path) != null && c.file_id && i.push({
                            path: l.text,
                            fileId: l.file_path.file_id,
                            name: se.getFileName(l.text)
                        });
                    });
                }), t != null && t.image_file && i.push({
                    fileId: t.image_file.file_id
                }), i;
            }
        },
        {
            key: "getFilesAndText",
            value: function() {
                var _getFilesAndText = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee65(e, t, i, s) {
                    var r;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee65$(_context65) {
                        while(true)switch(_context65.prev = _context65.next){
                            case 0:
                                r = se.getFileDetails(t, s);
                                _context65.next = 3;
                                return se.getFilesAndNewText(e, r, i, t.role, s);
                            case 3:
                                return _context65.abrupt("return", _context65.sent);
                            case 4:
                            case "end":
                                return _context65.stop();
                        }
                    }, _callee65);
                }));
                function getFilesAndText(_x124, _x125, _x126, _x127) {
                    return _getFilesAndText.apply(this, arguments);
                }
                return getFilesAndText;
            }()
        },
        {
            key: "parseResult",
            value: function parseResult(e, t) {
                var i = [];
                if (t) i = e.data;
                else for(var s = 0; s < e.data.length; s += 1){
                    var r = e.data[s];
                    if (r.role === "assistant") i.push(r);
                    else break;
                }
                return i.reverse();
            }
        },
        {
            key: "parseMessages",
            value: function parseMessages(e, t, i) {
                var s = [];
                return t.forEach(/*#__PURE__*/ function() {
                    var _ref17 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee67(r) {
                        return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee67$(_context67) {
                            while(true)switch(_context67.prev = _context67.next){
                                case 0:
                                    r.content.filter(function(o) {
                                        return !!o.text || !!o.image_file;
                                    }).sort(function(o) {
                                        return o.text ? -1 : o.image_file ? 1 : 0;
                                    }).forEach(/*#__PURE__*/ function() {
                                        var _ref18 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee66(o) {
                                            return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee66$(_context66) {
                                                while(true)switch(_context66.prev = _context66.next){
                                                    case 0:
                                                        s.push(se.getFilesAndText(e, r, i, o));
                                                    case 1:
                                                    case "end":
                                                        return _context66.stop();
                                                }
                                            }, _callee66);
                                        }));
                                        return function(_x129) {
                                            return _ref18.apply(this, arguments);
                                        };
                                    }());
                                case 1:
                                case "end":
                                    return _context67.stop();
                            }
                        }, _callee67);
                    }));
                    return function(_x128) {
                        return _ref17.apply(this, arguments);
                    };
                }()), Promise.all(s);
            }
        },
        {
            key: "processStreamMessages",
            value: function() {
                var _processStreamMessages = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee68(e, t, i) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee68$(_context68) {
                        while(true)switch(_context68.prev = _context68.next){
                            case 0:
                                return _context68.abrupt("return", se.parseMessages(e, [
                                    {
                                        content: t,
                                        role: "assistant"
                                    }
                                ], i));
                            case 1:
                            case "end":
                                return _context68.stop();
                        }
                    }, _callee68);
                }));
                function processStreamMessages(_x130, _x131, _x132) {
                    return _processStreamMessages.apply(this, arguments);
                }
                return processStreamMessages;
            }() // prettier-ignore
        },
        {
            key: "processAPIMessages",
            value: function() {
                var _processAPIMessages = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee69(e, t, i, s) {
                    var r;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee69$(_context69) {
                        while(true)switch(_context69.prev = _context69.next){
                            case 0:
                                r = se.parseResult(t, i);
                                return _context69.abrupt("return", se.parseMessages(e, r, s));
                            case 2:
                            case "end":
                                return _context69.stop();
                        }
                    }, _callee69);
                }));
                function processAPIMessages(_x133, _x134, _x135, _x136) {
                    return _processAPIMessages.apply(this, arguments);
                }
                return processAPIMessages;
            }()
        }
    ]);
}();
$8e4453fb4fc895c8$var$se.FILES_WITH_TEXT_ERROR = "content with type `text` must have `text` values", $8e4453fb4fc895c8$var$se.FUNCTION_TOOL_RESP_ERROR = "Response must contain an array of strings for each individual function/tool_call, see https://deepchat.dev/docs/directConnection/OpenAI/#assistant-functions.";
var $8e4453fb4fc895c8$var$Te = $8e4453fb4fc895c8$var$se;
var $8e4453fb4fc895c8$var$He = /*#__PURE__*/ function(_G3) {
    // prettier-ignore
    function He(e, t, i, s, r, o) {
        var _this31;
        $8e4453fb4fc895c8$var$_classCallCheck(this, He);
        if (_this31 = $8e4453fb4fc895c8$var$_callSuper(this, He, [
            e,
            s,
            r,
            o
        ]), _this31.insertKeyPlaceholderText = "OpenAI API Key", _this31.keyHelpUrl = "https://platform.openai.com/account/api-keys", _this31.url = "", _this31.permittedErrorPrefixes = [
            "Incorrect",
            "Please send text",
            $8e4453fb4fc895c8$var$$t.FAILED_ERROR_MESSAGE
        ], _this31.shouldFetchHistory = !1, _this31.searchedForThreadId = !1, _this31.config = {}, _this31.newAssistantDetails = {
            model: "gpt-4"
        }, _this31.waitingForStreamResponse = !1, _this31.isSSEStream = !1, _this31.urlSegments = i, $8e4453fb4fc895c8$var$_typeof(t) == "object") {
            _this31.config = t;
            var _this31$config = _this31.config, a = _this31$config.new_assistant, l = _this31$config.thread_id, c = _this31$config.load_thread_history;
            Object.assign(_this31.newAssistantDetails, a), l && (_this31.sessionId = l), c && (_this31.shouldFetchHistory = !0);
        }
        _this31.maxMessages = 1, _this31.isSSEStream = !!(_this31.stream && ($8e4453fb4fc895c8$var$_typeof(_this31.stream) != "object" || !_this31.stream.simulation));
        return _this31;
    }
    $8e4453fb4fc895c8$var$_inherits(He, _G3);
    return $8e4453fb4fc895c8$var$_createClass(He, [
        {
            key: "fetchHistoryFunc",
            value: function() {
                var _fetchHistoryFunc = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee70() {
                    var _this32 = this;
                    var e;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee70$(_context70) {
                        while(true)switch(_context70.prev = _context70.next){
                            case 0:
                                setTimeout(function() {
                                    return _this32.deepChat.disableSubmitButton();
                                }, 2);
                                _context70.prev = 1;
                                _context70.next = 4;
                                return this.getThreadMessages(this.sessionId, !0);
                            case 4:
                                e = _context70.sent;
                                return _context70.abrupt("return", (this.deepChat.disableSubmitButton(!1), e));
                            case 8:
                                _context70.prev = 8;
                                _context70.t0 = _context70["catch"](1);
                                return _context70.abrupt("return", [
                                    {
                                        error: "Failed to fetch history"
                                    }
                                ]);
                            case 11:
                            case "end":
                                return _context70.stop();
                        }
                    }, _callee70, this, [
                        [
                            1,
                            8
                        ]
                    ]);
                }));
                function fetchHistoryFunc() {
                    return _fetchHistoryFunc.apply(this, arguments);
                }
                return fetchHistoryFunc;
            }()
        },
        {
            key: "processMessage",
            value: function processMessage(e, t) {
                var i = this.totalMessagesMaxCharLength || -1, s = $8e4453fb4fc895c8$var$Tt.getCharacterLimitMessages(e, i)[0];
                if (t && t.length > 0) {
                    var r = this.filesToolType;
                    if (typeof this.filesToolType == "function") {
                        var a = this.filesToolType(t.map(function(_ref19) {
                            var l = _ref19.name;
                            return l;
                        }));
                        a === "code_interpreter" || a === "file_search" || a === "images" ? r = a : (console.error('Tool type "'.concat(a, '" is not valid')), console.error('Expected "code_interpreter" or "file_search" or "images". Going to default to "images"'));
                    }
                    if (r === "file_search") return He.processAttachmentsMessage(s, t, "file_search");
                    if (r === "code_interpreter") return He.processAttachmentsMessage(s, t, "code_interpreter");
                    if (t.find(function(_ref20) {
                        var a = _ref20.name;
                        return !$8e4453fb4fc895c8$var$j.isImageFileExtension(a);
                    })) console.error("The uploaded files contained a non-image file"), console.error('Make sure only images can be uploaded or define a "code_interpreter" or "file_search" value in the "files_tool_type" property'), console.warn('Make sure your existing assistant supports these "tools" or specify them in the "new_assistant" property');
                    else {
                        var _a2 = He.processImageMessage(s, t);
                        if (_a2) return _a2;
                    }
                }
                return {
                    content: s.text || "",
                    role: "user"
                };
            }
        },
        {
            key: "createNewThreadMessages",
            value: function createNewThreadMessages(e, t, i) {
                var s = JSON.parse(JSON.stringify(e)), r = this.processMessage(t, i);
                return s.thread = {
                    messages: [
                        r
                    ]
                }, s;
            }
        },
        {
            key: "callService",
            value: function callService(e, t, i) {
                if (this.messages = e, this.sessionId) {
                    this.url = "".concat(this.urlSegments.threadsPrefix, "/").concat(this.sessionId, "/messages").concat(this.urlSegments.createMessagePostfix);
                    var s = this.processMessage(t, i);
                    $8e4453fb4fc895c8$var$C.request(this, s, e);
                } else {
                    this.url = "".concat(this.urlSegments.threadsPrefix, "/runs").concat(this.urlSegments.threadsPosfix);
                    var _s2 = this.createNewThreadMessages(this.rawBody, t, i);
                    this.isSSEStream ? this.createStreamRun(_s2) : $8e4453fb4fc895c8$var$C.request(this, _s2, e);
                }
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI9 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee71(e, t, i) {
                    var _r$assistant_id;
                    var r, s;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee71$(_context71) {
                        while(true)switch(_context71.prev = _context71.next){
                            case 0:
                                if (!(this.waitingForStreamResponse = !1, !this.connectSettings)) {
                                    _context71.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                if (!((_r$assistant_id = (r = this.rawBody).assistant_id) !== null && _r$assistant_id !== void 0)) {
                                    _context71.next = 6;
                                    break;
                                }
                                _r$assistant_id;
                                _context71.next = 12;
                                break;
                            case 6:
                                _context71.t0 = this.config.assistant_id;
                                if (_context71.t0) {
                                    _context71.next = 11;
                                    break;
                                }
                                _context71.next = 10;
                                return this.createNewAssistant();
                            case 10:
                                _context71.t0 = _context71.sent;
                            case 11:
                                r.assistant_id = _context71.t0;
                            case 12:
                                this.searchedForThreadId || this.searchPreviousMessagesForThreadId(e.messageToElements);
                                if (!i) {
                                    _context71.next = 19;
                                    break;
                                }
                                _context71.next = 16;
                                return $8e4453fb4fc895c8$var$Te.storeFiles(this, e, i, this.urlSegments.storeFiles);
                            case 16:
                                _context71.t1 = _context71.sent;
                                _context71.next = 20;
                                break;
                            case 19:
                                _context71.t1 = void 0;
                            case 20:
                                s = _context71.t1;
                                this.connectSettings.method = "POST", this.callService(e, t, s);
                            case 22:
                            case "end":
                                return _context71.stop();
                        }
                    }, _callee71, this);
                }));
                function callServiceAPI(_x137, _x138, _x139) {
                    return _callServiceAPI9.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "createNewAssistant",
            value: function() {
                var _createNewAssistant = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee72() {
                    var e;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee72$(_context72) {
                        while(true)switch(_context72.prev = _context72.next){
                            case 0:
                                _context72.prev = 0;
                                this.url = this.urlSegments.newAssistantUrl;
                                _context72.next = 4;
                                return $8e4453fb4fc895c8$var$I.directFetch(this, JSON.parse(JSON.stringify(this.newAssistantDetails)), "POST");
                            case 4:
                                e = _context72.sent;
                                return _context72.abrupt("return", (this.config.assistant_id = e.id, this.config.assistant_id));
                            case 8:
                                _context72.prev = 8;
                                _context72.t0 = _context72["catch"](0);
                                console.error(_context72.t0), console.error("Failed to create a new assistant");
                            case 11:
                            case "end":
                                return _context72.stop();
                        }
                    }, _callee72, this, [
                        [
                            0,
                            8
                        ]
                    ]);
                }));
                function createNewAssistant() {
                    return _createNewAssistant.apply(this, arguments);
                }
                return createNewAssistant;
            }()
        },
        {
            key: "searchPreviousMessagesForThreadId",
            value: function searchPreviousMessagesForThreadId(e) {
                var t = e.find(function(_ref21) {
                    var _ref22 = $8e4453fb4fc895c8$var$_slicedToArray(_ref21, 1), i = _ref22[0];
                    return i._sessionId;
                });
                t && (this.sessionId = t[0]._sessionId), this.searchedForThreadId = !0;
            }
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData12 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee73(e) {
                    var s, t, i;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee73$(_context73) {
                        while(true)switch(_context73.prev = _context73.next){
                            case 0:
                                if (!(this.waitingForStreamResponse || this.isSSEStream && this.sessionId)) {
                                    _context73.next = 4;
                                    break;
                                }
                                _context73.next = 3;
                                return this.handleStream(e);
                            case 3:
                                return _context73.abrupt("return", _context73.sent);
                            case 4:
                                if (!e.error) {
                                    _context73.next = 6;
                                    break;
                                }
                                throw e.error.message.startsWith($8e4453fb4fc895c8$var$Te.FILES_WITH_TEXT_ERROR) ? Error("Please send text with your file(s)") : e.error.message;
                            case 6:
                                _context73.next = 8;
                                return this.assignThreadAndRun(e);
                            case 8:
                                t = "".concat(this.urlSegments.threadsPrefix, "/").concat(this.sessionId, "/runs/").concat(this.run_id).concat(this.urlSegments.threadsPosfix), i = {
                                    method: "GET",
                                    headers: (s = this.connectSettings) == null ? void 0 : s.headers
                                };
                                return _context73.abrupt("return", ($8e4453fb4fc895c8$var$C.executePollRequest(this, t, i, this.messages), {
                                    makingAnotherRequest: !0
                                }));
                            case 10:
                            case "end":
                                return _context73.stop();
                        }
                    }, _callee73, this);
                }));
                function extractResultData(_x140) {
                    return _extractResultData12.apply(this, arguments);
                }
                return extractResultData;
            }()
        },
        {
            key: "assignThreadAndRun",
            value: function() {
                var _assignThreadAndRun = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee74(e) {
                    var t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee74$(_context74) {
                        while(true)switch(_context74.prev = _context74.next){
                            case 0:
                                if (!this.sessionId) {
                                    _context74.next = 8;
                                    break;
                                }
                                this.url = "".concat(this.urlSegments.threadsPrefix, "/").concat(this.sessionId, "/runs").concat(this.urlSegments.threadsPosfix);
                                _context74.next = 4;
                                return $8e4453fb4fc895c8$var$I.directFetch(this, JSON.parse(JSON.stringify(this.rawBody)), "POST");
                            case 4:
                                t = _context74.sent;
                                this.run_id = t.id;
                                _context74.next = 9;
                                break;
                            case 8:
                                this.sessionId = e.thread_id, this.run_id = e.id, this.messages && this.messages.messageToElements.length > 0 && (this.messages.messageToElements[this.messages.messageToElements.length - 1][0]._sessionId = this.sessionId);
                            case 9:
                            case "end":
                                return _context74.stop();
                        }
                    }, _callee74, this);
                }));
                function assignThreadAndRun(_x141) {
                    return _assignThreadAndRun.apply(this, arguments);
                }
                return assignThreadAndRun;
            }()
        },
        {
            key: "getThreadMessages",
            value: function() {
                var _getThreadMessages = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee75(e) {
                    var t, s, r, i, _args75 = arguments;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee75$(_context75) {
                        while(true)switch(_context75.prev = _context75.next){
                            case 0:
                                t = _args75.length > 1 && _args75[1] !== undefined ? _args75[1] : !1;
                                this.url = "".concat(this.urlSegments.threadsPrefix, "/").concat(e, "/messages?").concat(this.urlSegments.listMessagesPostfix);
                                _context75.next = 4;
                                return $8e4453fb4fc895c8$var$I.directFetch(this, {}, "GET");
                            case 4:
                                i = _context75.sent;
                                _context75.t0 = !t && this.deepChat.responseInterceptor;
                                if (!_context75.t0) {
                                    _context75.next = 10;
                                    break;
                                }
                                _context75.next = 9;
                                return (r = (s = this.deepChat).responseInterceptor) == null ? void 0 : r.call(s, i);
                            case 9:
                                i = _context75.sent;
                            case 10:
                                return _context75.abrupt("return", $8e4453fb4fc895c8$var$Te.processAPIMessages(this, i, t, this.urlSegments));
                            case 11:
                            case "end":
                                return _context75.stop();
                        }
                    }, _callee75, this);
                }));
                function getThreadMessages(_x142) {
                    return _getThreadMessages.apply(this, arguments);
                }
                return getThreadMessages;
            }()
        },
        {
            key: "extractPollResultData",
            value: function() {
                var _extractPollResultData4 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee76(e) {
                    var _this33 = this;
                    var r, t, i, o, _o$shift, a, l, s;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee76$(_context76) {
                        while(true)switch(_context76.prev = _context76.next){
                            case 0:
                                t = e.status, i = e.required_action;
                                if (!(t === "queued" || t === "in_progress")) {
                                    _context76.next = 3;
                                    break;
                                }
                                return _context76.abrupt("return", {
                                    timeoutMS: He.POLLING_TIMEOUT_MS
                                });
                            case 3:
                                if (!(t === "completed" && this.messages)) {
                                    _context76.next = 11;
                                    break;
                                }
                                _context76.next = 6;
                                return this.getThreadMessages(e.thread_id);
                            case 6:
                                o = _context76.sent;
                                _o$shift = o.shift();
                                a = _o$shift.text;
                                l = _o$shift.files;
                                return _context76.abrupt("return", (setTimeout(function() {
                                    o.forEach(function(c) {
                                        return _this33.deepChat.addMessage(c);
                                    });
                                }), {
                                    text: a,
                                    _sessionId: this.sessionId,
                                    files: l
                                }));
                            case 11:
                                s = (r = i == null ? void 0 : i.submit_tool_outputs) == null ? void 0 : r.tool_calls;
                                if (!(t === "requires_action" && s)) {
                                    _context76.next = 16;
                                    break;
                                }
                                _context76.next = 15;
                                return this.handleTools(s);
                            case 15:
                                return _context76.abrupt("return", _context76.sent);
                            case 16:
                                throw Error("Thread run status: ".concat(t));
                            case 17:
                            case "end":
                                return _context76.stop();
                        }
                    }, _callee76, this);
                }));
                function extractPollResultData(_x143) {
                    return _extractPollResultData4.apply(this, arguments);
                }
                return extractPollResultData;
            }() // prettier-ignore
        },
        {
            key: "handleTools",
            value: function() {
                var _handleTools = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee77(e) {
                    var t, i, s, r, o, a;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee77$(_context77) {
                        while(true)switch(_context77.prev = _context77.next){
                            case 0:
                                if (this.functionHandler) {
                                    _context77.next = 2;
                                    break;
                                }
                                throw Error("Please define the `function_handler` property inside the [openAI](https://deepchat.dev/docs/directConnection/openAI#Assistant) object.");
                            case 2:
                                t = e.map(function(l) {
                                    return {
                                        name: l["function"].name,
                                        arguments: l["function"].arguments
                                    };
                                });
                                _context77.next = 5;
                                return this.functionHandler(t);
                            case 5:
                                i = _context77.sent;
                                if (!(!Array.isArray(i) || e.length !== i.length)) {
                                    _context77.next = 8;
                                    break;
                                }
                                throw Error($8e4453fb4fc895c8$var$Te.FUNCTION_TOOL_RESP_ERROR);
                            case 8:
                                _context77.next = 10;
                                return Promise.all(i);
                            case 10:
                                s = _context77.sent;
                                if (!s.find(function(l) {
                                    return typeof l != "string";
                                })) {
                                    _context77.next = 13;
                                    break;
                                }
                                throw Error($8e4453fb4fc895c8$var$Te.FUNCTION_TOOL_RESP_ERROR);
                            case 13:
                                r = s.map(function(l, c) {
                                    return {
                                        tool_call_id: e[c].id,
                                        output: l
                                    };
                                }), o = "".concat(this.urlSegments.threadsPrefix, "/").concat(this.sessionId), a = "/runs/".concat(this.run_id, "/submit_tool_outputs").concat(this.urlSegments.threadsPosfix);
                                this.url = "".concat(o).concat(a);
                                if (!this.isSSEStream) {
                                    _context77.next = 20;
                                    break;
                                }
                                _context77.next = 18;
                                return this.createStreamRun({
                                    tool_outputs: r
                                });
                            case 18:
                                _context77.next = 22;
                                break;
                            case 20:
                                _context77.next = 22;
                                return $8e4453fb4fc895c8$var$I.directFetch(this, {
                                    tool_outputs: r
                                }, "POST");
                            case 22:
                                return _context77.abrupt("return", {
                                    timeoutMS: He.POLLING_TIMEOUT_MS
                                });
                            case 23:
                            case "end":
                                return _context77.stop();
                        }
                    }, _callee77, this);
                }));
                function handleTools(_x144) {
                    return _handleTools.apply(this, arguments);
                }
                return handleTools;
            }()
        },
        {
            key: "handleStream",
            value: function() {
                var _handleStream = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee78(e) {
                    var i, s, t, r;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee78$(_context78) {
                        while(true)switch(_context78.prev = _context78.next){
                            case 0:
                                t = (s = (i = e.required_action) == null ? void 0 : i.submit_tool_outputs) == null ? void 0 : s.tool_calls;
                                if (!(e.status === "requires_action" && t)) {
                                    _context78.next = 6;
                                    break;
                                }
                                this.run_id = e.id;
                                _context78.next = 5;
                                return this.handleTools(t);
                            case 5:
                                return _context78.abrupt("return", _context78.sent);
                            case 6:
                                if (!this.waitingForStreamResponse) {
                                    _context78.next = 8;
                                    break;
                                }
                                return _context78.abrupt("return", this.parseStreamResult(e));
                            case 8:
                                if (this.isSSEStream && this.sessionId) {
                                    this.url = "".concat(this.urlSegments.threadsPrefix, "/").concat(this.sessionId, "/runs").concat(this.urlSegments.threadsPosfix);
                                    r = JSON.parse(JSON.stringify(this.rawBody));
                                    this.createStreamRun(r);
                                }
                                return _context78.abrupt("return", {
                                    makingAnotherRequest: !0
                                });
                            case 10:
                            case "end":
                                return _context78.stop();
                        }
                    }, _callee78, this);
                }));
                function handleStream(_x145) {
                    return _handleStream.apply(this, arguments);
                }
                return handleStream;
            }() // prettier-ignore
        },
        {
            key: "parseStreamResult",
            value: function() {
                var _parseStreamResult = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee79(e) {
                    var t, i, s, r, o, a, l, c, _a3, _l;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee79$(_context79) {
                        while(true)switch(_context79.prev = _context79.next){
                            case 0:
                                if (!(e.content && e.content.length > 0 && this.messages)) {
                                    _context79.next = 5;
                                    break;
                                }
                                a = e.content.find(function(l) {
                                    return l.text;
                                });
                                if (!((t = a == null ? void 0 : a.text) != null && t.annotations && a.text.annotations.length > 0)) {
                                    _context79.next = 5;
                                    break;
                                }
                                l = e.content.find(function(d) {
                                    return !!d.text;
                                }) || e.content[0], c = $8e4453fb4fc895c8$var$Te.getFilesAndText.bind(this, this, {
                                    role: "assistant",
                                    content: e.content
                                }, this.urlSegments, l);
                                return _context79.abrupt("return", ((i = this.messageStream) == null || i.endStreamAfterFileDownloaded(this.messages, c), {
                                    text: ""
                                }));
                            case 5:
                                if (!((s = e.delta) != null && s.content)) {
                                    _context79.next = 14;
                                    break;
                                }
                                if (!(e.delta.content.length > 1)) {
                                    _context79.next = 13;
                                    break;
                                }
                                _a3 = e.delta.content.find(function(l) {
                                    return l.text;
                                });
                                if (!((r = _a3 == null ? void 0 : _a3.text) != null && r.annotations && _a3.text.annotations.length === 0)) {
                                    _context79.next = 13;
                                    break;
                                }
                                _context79.next = 11;
                                return $8e4453fb4fc895c8$var$Te.processStreamMessages(this, e.delta.content, this.urlSegments);
                            case 11:
                                _l = _context79.sent;
                                return _context79.abrupt("return", {
                                    text: _l[0].text,
                                    files: _l[1].files
                                });
                            case 13:
                                return _context79.abrupt("return", {
                                    text: (o = e.delta.content[0].text) == null ? void 0 : o.value
                                });
                            case 14:
                                return _context79.abrupt("return", (!this.sessionId && e.thread_id && (this.sessionId = e.thread_id), {
                                    makingAnotherRequest: !0
                                }));
                            case 15:
                            case "end":
                                return _context79.stop();
                        }
                    }, _callee79, this);
                }));
                function parseStreamResult(_x146) {
                    return _parseStreamResult.apply(this, arguments);
                }
                return parseStreamResult;
            }() // https://platform.openai.com/docs/api-reference/assistants-streaming
        },
        {
            key: "createStreamRun",
            value: function() {
                var _createStreamRun = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee80(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee80$(_context80) {
                        while(true)switch(_context80.prev = _context80.next){
                            case 0:
                                e.stream = !0;
                                this.waitingForStreamResponse = !0;
                                _context80.next = 4;
                                return $8e4453fb4fc895c8$var$T.request(this, e, this.messages, !0, !0);
                            case 4:
                                this.messageStream = _context80.sent;
                            case 5:
                            case "end":
                                return _context80.stop();
                        }
                    }, _callee80, this);
                }));
                function createStreamRun(_x147) {
                    return _createStreamRun.apply(this, arguments);
                }
                return createStreamRun;
            }()
        }
    ], [
        {
            key: "processImageMessage",
            value: function processImageMessage(e, t) {
                var i = t == null ? void 0 : t.filter(function(s) {
                    return $8e4453fb4fc895c8$var$j.isImageFileExtension(s.name);
                }).map(function(s) {
                    return {
                        type: "image_file",
                        image_file: {
                            file_id: s.id
                        }
                    };
                });
                if (i && i.length > 0) return e.text && e.text.length > 0 && i.push({
                    type: "text",
                    text: e.text
                }), {
                    content: i,
                    role: "user"
                };
            }
        },
        {
            key: "processAttachmentsMessage",
            value: function processAttachmentsMessage(e, t, i) {
                return {
                    attachments: t.map(function(r) {
                        return {
                            tools: [
                                {
                                    type: i
                                }
                            ],
                            file_id: r.id
                        };
                    }),
                    content: [
                        {
                            type: "text",
                            text: e.text
                        }
                    ],
                    role: "user"
                };
            }
        }
    ]);
}($8e4453fb4fc895c8$var$G);
$8e4453fb4fc895c8$var$He.POLLING_TIMEOUT_MS = 800;
var $8e4453fb4fc895c8$var$wi = $8e4453fb4fc895c8$var$He;
var $8e4453fb4fc895c8$var$Fi = /*#__PURE__*/ function(_wi) {
    function Fi(e) {
        var _o$headers2, _a$OpenAIBeta;
        var _this34;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Fi);
        var r, o, a, l, c;
        var t = JSON.parse(JSON.stringify(e.directConnection)), i = t.openAI, s = (r = t.openAI) == null ? void 0 : r.assistant;
        if (_this34 = $8e4453fb4fc895c8$var$_callSuper(this, Fi, [
            e,
            s,
            Fi.URL_SEGMENTS,
            $8e4453fb4fc895c8$var$I.buildKeyVerificationDetails(),
            $8e4453fb4fc895c8$var$I.buildHeaders,
            i
        ]), (_o$headers2 = (o = _this34.connectSettings).headers) !== null && _o$headers2 !== void 0 ? _o$headers2 : o.headers = {}, (_a$OpenAIBeta = (a = _this34.connectSettings.headers)["OpenAI-Beta"]) !== null && _a$OpenAIBeta !== void 0 ? _a$OpenAIBeta : a["OpenAI-Beta"] = "assistants=v2", _this34.shouldFetchHistory && _this34.sessionId && (_this34.fetchHistory = _this34.fetchHistoryFunc.bind($8e4453fb4fc895c8$var$_assertThisInitialized(_this34))), $8e4453fb4fc895c8$var$_typeof(s) == "object") {
            var _ref23 = (c = (l = e.directConnection) == null ? void 0 : l.openAI) == null ? void 0 : c.assistant, d = _ref23.function_handler, h = _ref23.files_tool_type;
            d && (_this34.functionHandler = d), h && (_this34.filesToolType = h);
        }
        return _this34;
    }
    $8e4453fb4fc895c8$var$_inherits(Fi, _wi);
    return $8e4453fb4fc895c8$var$_createClass(Fi);
}($8e4453fb4fc895c8$var$wi);
$8e4453fb4fc895c8$var$Fi.URL_SEGMENTS = {
    threadsPrefix: "https://api.openai.com/v1/threads",
    threadsPosfix: "",
    newAssistantUrl: "https://api.openai.com/v1/assistants",
    createMessagePostfix: "",
    listMessagesPostfix: "order=desc",
    storeFiles: "https://api.openai.com/v1/files",
    getFilesPrefix: "https://api.openai.com/v1/files/",
    getFilesPostfix: "/content"
};
var $8e4453fb4fc895c8$var$bs = $8e4453fb4fc895c8$var$Fi;
var $8e4453fb4fc895c8$var$Ai = /*#__PURE__*/ function() {
    function Ai() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ai);
    }
    return $8e4453fb4fc895c8$var$_createClass(Ai, null, [
        {
            key: "buildHeaders",
            value: function buildHeaders(e) {
                return {
                    Authorization: "Bearer ".concat(e),
                    "Content-Type": "application/json",
                    accept: "application/json"
                };
            }
        },
        {
            key: "handleVerificationResult",
            value: function handleVerificationResult(e, t, i, s) {
                var o;
                (o = e.message) != null && o.includes("invalid request: prompt must be at least 1 token long") ? i(t) : s($8e4453fb4fc895c8$var$M.INVALID_KEY);
            }
        },
        {
            key: "buildKeyVerificationDetails",
            value: function buildKeyVerificationDetails() {
                return {
                    url: "https://api.cohere.ai/v1/generate",
                    method: "POST",
                    handleVerificationResult: Ai.handleVerificationResult,
                    body: JSON.stringify({
                        prompt: ""
                    })
                };
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Ls = /*#__PURE__*/ function(_G4) {
    function Ls(e, t, i, s, r) {
        var _this35;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ls);
        _this35 = $8e4453fb4fc895c8$var$_callSuper(this, Ls, [
            e,
            $8e4453fb4fc895c8$var$Ai.buildKeyVerificationDetails(),
            $8e4453fb4fc895c8$var$Ai.buildHeaders,
            r
        ]), _this35.insertKeyPlaceholderText = "Cohere API Key", _this35.keyHelpUrl = "https://dashboard.cohere.ai/api-keys", _this35.permittedErrorPrefixes = [
            "invalid"
        ], _this35.url = t, _this35.textInputPlaceholderText = i, s && $8e4453fb4fc895c8$var$_typeof(s) == "object" && Object.assign(_this35.rawBody, s);
        return _this35;
    }
    $8e4453fb4fc895c8$var$_inherits(Ls, _G4);
    return $8e4453fb4fc895c8$var$_createClass(Ls);
}($8e4453fb4fc895c8$var$G);
var $8e4453fb4fc895c8$var$Go = /*#__PURE__*/ function(_Ls) {
    function Go(e) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Go);
        var s, r, o;
        var t = (r = (s = e.directConnection) == null ? void 0 : s.cohere) == null ? void 0 : r.textGeneration, i = (o = e.directConnection) == null ? void 0 : o.cohere;
        return $8e4453fb4fc895c8$var$_callSuper(this, Go, [
            e,
            "https://api.cohere.ai/v1/generate",
            "Once upon a time",
            t,
            i
        ]);
    }
    $8e4453fb4fc895c8$var$_inherits(Go, _Ls);
    return $8e4453fb4fc895c8$var$_createClass(Go, [
        {
            key: "preprocessBody",
            value: function preprocessBody(e, t) {
                var i = JSON.parse(JSON.stringify(e)), s = t[t.length - 1].text;
                if (s) return $8e4453fb4fc895c8$var$_objectSpread({
                    prompt: s
                }, i);
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI10 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee81(e, t) {
                    var i;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee81$(_context81) {
                        while(true)switch(_context81.prev = _context81.next){
                            case 0:
                                if (this.connectSettings) {
                                    _context81.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                i = this.preprocessBody(this.rawBody, t);
                                $8e4453fb4fc895c8$var$C.request(this, i, e);
                            case 4:
                            case "end":
                                return _context81.stop();
                        }
                    }, _callee81, this);
                }));
                function callServiceAPI(_x148, _x149) {
                    return _callServiceAPI10.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData13 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee82(e) {
                    var t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee82$(_context82) {
                        while(true)switch(_context82.prev = _context82.next){
                            case 0:
                                if (!e.message) {
                                    _context82.next = 2;
                                    break;
                                }
                                throw e.message;
                            case 2:
                                return _context82.abrupt("return", {
                                    text: ((t = e.generations) == null ? void 0 : t[0].text) || ""
                                });
                            case 3:
                            case "end":
                                return _context82.stop();
                        }
                    }, _callee82);
                }));
                function extractResultData(_x150) {
                    return _extractResultData13.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$Ls);
var $8e4453fb4fc895c8$var$Us = /*#__PURE__*/ function() {
    function Us() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Us);
    }
    return $8e4453fb4fc895c8$var$_createClass(Us, null, [
        {
            key: "buildHeaders",
            value: function buildHeaders(e) {
                return {
                    "api-key": e,
                    "Content-Type": "application/json"
                };
            }
        },
        {
            key: "buildKeyVerificationDetails",
            value: function buildKeyVerificationDetails(e) {
                return {
                    url: "".concat(e.endpoint, "/openai/models?api-version=").concat(e.version),
                    method: "GET",
                    handleVerificationResult: $8e4453fb4fc895c8$var$I.handleVerificationResult
                };
            }
        },
        {
            key: "validateURLDetails",
            value: function validateURLDetails(e) {
                var t = e.endpoint, i = e.version, s = e.deploymentId;
                return t && i && s;
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$Us.URL_DETAILS_ERROR_MESSAGE = "Please define the Azure URL Details. [More Information](https://deepchat.dev/docs/directConnection/Azure)";
var $8e4453fb4fc895c8$var$ue = $8e4453fb4fc895c8$var$Us;
var $8e4453fb4fc895c8$var$Et = /*#__PURE__*/ function(_wi2) {
    function Et(e) {
        var _v$headers;
        var _this36;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Et);
        var c, d, h, f, u, m, p, v;
        var t = JSON.parse(JSON.stringify(e.directConnection)), i = t.azure, s = (c = t.azure) == null ? void 0 : c.openAI, r = (s == null ? void 0 : s.urlDetails) || {}, o = "".concat((d = s == null ? void 0 : s.urlDetails) == null ? void 0 : d.endpoint, "/openai/"), a = "?api-version=".concat((h = s == null ? void 0 : s.urlDetails) == null ? void 0 : h.version), l = {
            threadsPrefix: "".concat(o).concat(Et.THREAD_RESOURCE),
            threadsPosfix: a,
            newAssistantUrl: "".concat(o).concat(Et.NEW_ASSISTANT_RESOURCE).concat(a),
            createMessagePostfix: a,
            listMessagesPostfix: "order=desc&api-version=".concat((f = s == null ? void 0 : s.urlDetails) == null ? void 0 : f.version),
            storeFiles: "".concat(o, "files").concat(a),
            getFilesPrefix: "".concat(o, "files/"),
            getFilesPostfix: "/content".concat(a)
        };
        if (_this36 = $8e4453fb4fc895c8$var$_callSuper(this, Et, [
            e,
            s == null ? void 0 : s.assistant,
            l,
            $8e4453fb4fc895c8$var$ue.buildKeyVerificationDetails(r),
            $8e4453fb4fc895c8$var$ue.buildHeaders,
            i
        ]), _this36.permittedErrorPrefixes = [
            $8e4453fb4fc895c8$var$ue.URL_DETAILS_ERROR_MESSAGE
        ], _this36.insertKeyPlaceholderText = "Azure OpenAI API Key", _this36.keyHelpUrl = "https://learn.microsoft.com/en-us/answers/questions/1193991/how-to-get-the-value-of-openai-api-key", _this36.isTextInputDisabled = !1, $8e4453fb4fc895c8$var$_typeof(s == null ? void 0 : s.assistant) == "object") {
            var _ref24 = (p = (m = (u = e.directConnection) == null ? void 0 : u.azure) == null ? void 0 : m.openAI) == null ? void 0 : p.assistant, y = _ref24.function_handler, P = _ref24.files_tool_type;
            y && (_this36.functionHandler = y), P && (_this36.filesToolType = P);
        }
        $8e4453fb4fc895c8$var$ue.validateURLDetails(r) ? (_v$headers = (v = _this36.connectSettings).headers) !== null && _v$headers !== void 0 ? _v$headers : v.headers = {} : (_this36.isTextInputDisabled = !0, _this36.canSendMessage = function() {
            return !1;
        }, setTimeout(function() {
            e.addMessage({
                error: $8e4453fb4fc895c8$var$ue.URL_DETAILS_ERROR_MESSAGE
            });
        }));
        return _this36;
    }
    $8e4453fb4fc895c8$var$_inherits(Et, _wi2);
    return $8e4453fb4fc895c8$var$_createClass(Et);
}($8e4453fb4fc895c8$var$wi);
$8e4453fb4fc895c8$var$Et.THREAD_RESOURCE = "threads", $8e4453fb4fc895c8$var$Et.NEW_ASSISTANT_RESOURCE = "assistants";
var $8e4453fb4fc895c8$var$vs = $8e4453fb4fc895c8$var$Et;
var $8e4453fb4fc895c8$var$Vo = /*#__PURE__*/ function(_Ls2) {
    function Vo(e) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Vo);
        var s, r, o;
        var t = (r = (s = e.directConnection) == null ? void 0 : s.cohere) == null ? void 0 : r.summarization, i = (o = e.directConnection) == null ? void 0 : o.cohere;
        return $8e4453fb4fc895c8$var$_callSuper(this, Vo, [
            e,
            "https://api.cohere.ai/v1/summarize",
            "Insert text to summarize",
            t,
            i
        ]);
    }
    $8e4453fb4fc895c8$var$_inherits(Vo, _Ls2);
    return $8e4453fb4fc895c8$var$_createClass(Vo, [
        {
            key: "preprocessBody",
            value: function preprocessBody(e, t) {
                var i = JSON.parse(JSON.stringify(e)), s = t[t.length - 1].text;
                if (s) return $8e4453fb4fc895c8$var$_objectSpread({
                    text: s
                }, i);
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI11 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee83(e, t) {
                    var i;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee83$(_context83) {
                        while(true)switch(_context83.prev = _context83.next){
                            case 0:
                                if (this.connectSettings) {
                                    _context83.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                i = this.preprocessBody(this.rawBody, t);
                                $8e4453fb4fc895c8$var$C.request(this, i, e);
                            case 4:
                            case "end":
                                return _context83.stop();
                        }
                    }, _callee83, this);
                }));
                function callServiceAPI(_x151, _x152) {
                    return _callServiceAPI11.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData14 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee84(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee84$(_context84) {
                        while(true)switch(_context84.prev = _context84.next){
                            case 0:
                                if (!e.message) {
                                    _context84.next = 2;
                                    break;
                                }
                                throw e.message;
                            case 2:
                                return _context84.abrupt("return", {
                                    text: e.summary || ""
                                });
                            case 3:
                            case "end":
                                return _context84.stop();
                        }
                    }, _callee84);
                }));
                function extractResultData(_x153) {
                    return _extractResultData14.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$Ls);
var $8e4453fb4fc895c8$var$St = /*#__PURE__*/ function(_G5) {
    function St(e) {
        var _o$model, _a$voice;
        var _this37;
        $8e4453fb4fc895c8$var$_classCallCheck(this, St);
        var r, o, a;
        var t = JSON.parse(JSON.stringify(e.directConnection)), i = t == null ? void 0 : t.openAI;
        _this37 = $8e4453fb4fc895c8$var$_callSuper(this, St, [
            e,
            $8e4453fb4fc895c8$var$I.buildKeyVerificationDetails(),
            $8e4453fb4fc895c8$var$I.buildHeaders,
            i
        ]), _this37.insertKeyPlaceholderText = "OpenAI API Key", _this37.keyHelpUrl = "https://platform.openai.com/account/api-keys", _this37.url = "https://api.openai.com/v1/audio/speech", _this37.permittedErrorPrefixes = [
            "Invalid"
        ], _this37.introPanelMarkUp = '\n    <div style="width: 100%; text-align: center; margin-left: -10px"><b>OpenAI : Text To Speech</b></div>\n    <p>Generate an audio file based on your text input.</p>\n    <p>Click <a href="https://platform.openai.com/docs/guides/text-to-speech">here</a> for more information.</p>';
        var s = (r = t == null ? void 0 : t.openAI) == null ? void 0 : r.textToSpeech;
        $8e4453fb4fc895c8$var$_typeof(s) == "object" && Object.assign(_this37.rawBody, s), (_o$model = (o = _this37.rawBody).model) !== null && _o$model !== void 0 ? _o$model : o.model = St.DEFAULT_MODEL, (_a$voice = (a = _this37.rawBody).voice) !== null && _a$voice !== void 0 ? _a$voice : a.voice = St.DEFAULT_VOIDE, _this37.textInputPlaceholderText = "Insert text to generate audio", _this37.rawBody.response_format = "mp3";
        return _this37;
    }
    $8e4453fb4fc895c8$var$_inherits(St, _G5);
    return $8e4453fb4fc895c8$var$_createClass(St, [
        {
            key: "preprocessBody",
            value: function preprocessBody(e, t) {
                var r, o;
                var i = JSON.parse(JSON.stringify(e)), s = (o = (r = t[t.length - 1]) == null ? void 0 : r.text) == null ? void 0 : o.trim();
                return s && s !== "" && (i.input = s), i;
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI12 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee85(e, t) {
                    var s, i;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee85$(_context85) {
                        while(true)switch(_context85.prev = _context85.next){
                            case 0:
                                if ((s = this.connectSettings) != null && s.headers) {
                                    _context85.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                this.url = this.connectSettings.url || this.url;
                                i = this.preprocessBody(this.rawBody, t);
                                $8e4453fb4fc895c8$var$C.request(this, i, e);
                            case 5:
                            case "end":
                                return _context85.stop();
                        }
                    }, _callee85, this);
                }));
                function callServiceAPI(_x154, _x155) {
                    return _callServiceAPI12.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData15 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee86(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee86$(_context86) {
                        while(true)switch(_context86.prev = _context86.next){
                            case 0:
                                if (!(e instanceof Blob)) {
                                    _context86.next = 2;
                                    break;
                                }
                                return _context86.abrupt("return", new Promise(function(t) {
                                    var i = new FileReader();
                                    i.readAsDataURL(e), i.onload = function(s) {
                                        t({
                                            files: [
                                                {
                                                    src: s.target.result,
                                                    type: "audio"
                                                }
                                            ]
                                        });
                                    };
                                }));
                            case 2:
                                if (!e.error) {
                                    _context86.next = 4;
                                    break;
                                }
                                throw e.error.message;
                            case 4:
                                return _context86.abrupt("return", {
                                    error: "error"
                                });
                            case 5:
                            case "end":
                                return _context86.stop();
                        }
                    }, _callee86);
                }));
                function extractResultData(_x156) {
                    return _extractResultData15.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$G);
$8e4453fb4fc895c8$var$St.DEFAULT_MODEL = "tts-1", $8e4453fb4fc895c8$var$St.DEFAULT_VOIDE = "alloy";
var $8e4453fb4fc895c8$var$ys = $8e4453fb4fc895c8$var$St;
var $8e4453fb4fc895c8$var$ge = /*#__PURE__*/ function(_G6) {
    function ge(e) {
        var _o$model2;
        var _this38;
        $8e4453fb4fc895c8$var$_classCallCheck(this, ge);
        var r, o;
        var t = JSON.parse(JSON.stringify(e.directConnection)), i = t == null ? void 0 : t.openAI;
        _this38 = $8e4453fb4fc895c8$var$_callSuper(this, ge, [
            e,
            $8e4453fb4fc895c8$var$I.buildKeyVerificationDetails(),
            $8e4453fb4fc895c8$var$I.buildHeaders,
            i,
            {
                audio: {}
            }
        ]), _this38.insertKeyPlaceholderText = "OpenAI API Key", _this38.keyHelpUrl = "https://platform.openai.com/account/api-keys", _this38.introPanelMarkUp = '\n    <div style="width: 100%; text-align: center; margin-left: -10px"><b>OpenAI : Speech To Text</b></div>\n    <p><b>Upload an audio file</b> to transcribe it into text. You can optionally provide text to guide the audio\n      processing.\n    <p>Click <a href="https://platform.openai.com/docs/guides/speech-to-text">here</a> for more info.</p>', _this38.url = "", _this38.permittedErrorPrefixes = [
            "Invalid"
        ], _this38.textInputPlaceholderText = "Upload an audio file", _this38._service_url = ge.AUDIO_TRANSCRIPTIONS_URL;
        var s = (r = t == null ? void 0 : t.openAI) == null ? void 0 : r.audio;
        $8e4453fb4fc895c8$var$_typeof(s) == "object" && (_this38.processConfig(s), ge.cleanConfig(s), Object.assign(_this38.rawBody, s)), (_o$model2 = (o = _this38.rawBody).model) !== null && _o$model2 !== void 0 ? _o$model2 : o.model = ge.DEFAULT_MODEL, _this38.rawBody.response_format = "json", _this38.canSendMessage = ge.canSendFileMessage;
        return _this38;
    }
    $8e4453fb4fc895c8$var$_inherits(ge, _G6);
    return $8e4453fb4fc895c8$var$_createClass(ge, [
        {
            key: "processConfig",
            value: function processConfig(e) {
                e != null && e.type && e.type === "translation" && (this._service_url = ge.AUDIO_TRANSLATIONS_URL, delete e.language);
            }
        },
        {
            key: "preprocessBody",
            value: function preprocessBody(e, t) {
                var r, o;
                var i = JSON.parse(JSON.stringify(e)), s = (o = (r = t[t.length - 1]) == null ? void 0 : r.text) == null ? void 0 : o.trim();
                return s && s !== "" && (i.prompt = s), i;
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI13 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee87(e, t, i) {
                    var o, s, r;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee87$(_context87) {
                        while(true)switch(_context87.prev = _context87.next){
                            case 0:
                                if ((o = this.connectSettings) != null && o.headers) {
                                    _context87.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                if (i != null && i[0]) {
                                    _context87.next = 4;
                                    break;
                                }
                                throw new Error("No file was added");
                            case 4:
                                this.url = this.connectSettings.url || this._service_url;
                                s = this.preprocessBody(this.rawBody, t), r = ge.createFormDataBody(s, i[0]);
                                $8e4453fb4fc895c8$var$E.tempRemoveContentHeader(this.connectSettings, $8e4453fb4fc895c8$var$C.request.bind(this, this, r, e), !1);
                            case 7:
                            case "end":
                                return _context87.stop();
                        }
                    }, _callee87, this);
                }));
                function callServiceAPI(_x157, _x158, _x159) {
                    return _callServiceAPI13.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData16 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee88(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee88$(_context88) {
                        while(true)switch(_context88.prev = _context88.next){
                            case 0:
                                if (!e.error) {
                                    _context88.next = 2;
                                    break;
                                }
                                throw e.error.message;
                            case 2:
                                return _context88.abrupt("return", {
                                    text: e.text
                                });
                            case 3:
                            case "end":
                                return _context88.stop();
                        }
                    }, _callee88);
                }));
                function extractResultData(_x160) {
                    return _extractResultData16.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ], [
        {
            key: "canSendFileMessage",
            value: function canSendFileMessage(e, t) {
                return !!(t != null && t[0]);
            }
        },
        {
            key: "cleanConfig",
            value: function cleanConfig(e) {
                delete e.type;
            }
        },
        {
            key: "createFormDataBody",
            value: function createFormDataBody(e, t) {
                var i = new FormData();
                return i.append("file", t), Object.keys(e).forEach(function(s) {
                    i.append(s, String(e[s]));
                }), i;
            }
        }
    ]);
}($8e4453fb4fc895c8$var$G);
$8e4453fb4fc895c8$var$ge.AUDIO_TRANSCRIPTIONS_URL = "https://api.openai.com/v1/audio/transcriptions", $8e4453fb4fc895c8$var$ge.AUDIO_TRANSLATIONS_URL = "https://api.openai.com/v1/audio/translations", $8e4453fb4fc895c8$var$ge.DEFAULT_MODEL = "whisper-1";
var $8e4453fb4fc895c8$var$Es = $8e4453fb4fc895c8$var$ge;
var $8e4453fb4fc895c8$var$fe = /*#__PURE__*/ function() {
    function fe() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, fe);
    }
    return $8e4453fb4fc895c8$var$_createClass(fe, null, [
        {
            key: "buildTextToSpeechHeaders",
            value: function buildTextToSpeechHeaders(e, t) {
                return {
                    "Ocp-Apim-Subscription-Key": t,
                    "Content-Type": "application/ssml+xml",
                    "X-Microsoft-OutputFormat": e
                };
            }
        },
        {
            key: "buildSpeechToTextHeaders",
            value: function buildSpeechToTextHeaders(e) {
                return {
                    "Ocp-Apim-Subscription-Key": e,
                    Accept: "application/json"
                };
            }
        },
        {
            key: "handleSpeechVerificationResult",
            value: function handleSpeechVerificationResult(e, t, i, s) {
                e.error ? s($8e4453fb4fc895c8$var$M.INVALID_KEY) : i(t);
            }
        },
        {
            key: "buildSpeechKeyVerificationDetails",
            value: function buildSpeechKeyVerificationDetails(e) {
                return {
                    url: "https://".concat(e, ".api.cognitive.microsoft.com/sts/v1.0/issuetoken"),
                    method: "POST",
                    createHeaders: function createHeaders(t) {
                        return {
                            "Ocp-Apim-Subscription-Key": "".concat(t)
                        };
                    },
                    handleVerificationResult: fe.handleSpeechVerificationResult
                };
            }
        },
        {
            key: "buildSummarizationHeader",
            value: function buildSummarizationHeader(e) {
                return {
                    "Ocp-Apim-Subscription-Key": e,
                    "Content-Type": "application/json"
                };
            }
        },
        {
            key: "handleLanguageVerificationResult",
            value: function handleLanguageVerificationResult(e, t, i, s) {
                var o;
                ((o = e.error) == null ? void 0 : o.code) === "401" ? s($8e4453fb4fc895c8$var$M.INVALID_KEY) : i(t);
            }
        },
        {
            key: "buildLanguageKeyVerificationDetails",
            value: function buildLanguageKeyVerificationDetails(e) {
                return {
                    url: "".concat(e, "/language/analyze-text/jobs?api-version=2022-10-01-preview"),
                    method: "POST",
                    createHeaders: function createHeaders(t) {
                        return {
                            "Ocp-Apim-Subscription-Key": "".concat(t)
                        };
                    },
                    handleVerificationResult: fe.handleLanguageVerificationResult
                };
            }
        },
        {
            key: "handleTranslationVerificationResult",
            value: function handleTranslationVerificationResult(e, t, i, s) {
                e.json().then(function(o) {
                    !Array.isArray(o) && o.error.code === 401e3 ? s($8e4453fb4fc895c8$var$M.INVALID_KEY) : i(t);
                });
            }
        },
        {
            key: "buildTranslationKeyVerificationDetails",
            value: function buildTranslationKeyVerificationDetails(e) {
                return {
                    url: "https://api.cognitive.microsofttranslator.com/translate?api-version=3.0&to=es",
                    method: "POST",
                    createHeaders: function createHeaders(t) {
                        return fe.buildTranslationHeaders(e, t);
                    },
                    handleVerificationResult: fe.handleTranslationVerificationResult
                };
            }
        },
        {
            key: "buildTranslationHeaders",
            value: function buildTranslationHeaders(e, t) {
                var i = {
                    "Ocp-Apim-Subscription-Key": t,
                    "Content-Type": "application/json"
                };
                return e && (i["Ocp-Apim-Subscription-Region"] = e), i;
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$$o = /*#__PURE__*/ function(_G7) {
    // prettier-ignore
    function $o(e, t, i, s, r) {
        var _this39;
        $8e4453fb4fc895c8$var$_classCallCheck(this, $o);
        _this39 = $8e4453fb4fc895c8$var$_callSuper(this, $o, [
            e,
            $8e4453fb4fc895c8$var$fe.buildLanguageKeyVerificationDetails(i),
            t,
            s,
            r
        ]), _this39.insertKeyPlaceholderText = "Azure Language Subscription Key", _this39.keyHelpUrl = // eslint-disable-next-line max-len
        "https://learn.microsoft.com/en-us/azure/api-management/api-management-subscriptions#create-and-manage-subscriptions-in-azure-portal", _this39.permittedErrorPrefixes = [
            "Access"
        ];
        return _this39;
    }
    $8e4453fb4fc895c8$var$_inherits($o, _G7);
    return $8e4453fb4fc895c8$var$_createClass($o);
}($8e4453fb4fc895c8$var$G);
var $8e4453fb4fc895c8$var$Ht = /*#__PURE__*/ function(_$o) {
    function Ht(e) {
        var _a$language;
        var _this40;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ht);
        var s, r, o, a;
        var t = (r = (s = e.directConnection) == null ? void 0 : s.azure) == null ? void 0 : r.summarization, i = (o = e.directConnection) == null ? void 0 : o.azure;
        _this40 = $8e4453fb4fc895c8$var$_callSuper(this, Ht, [
            e,
            $8e4453fb4fc895c8$var$fe.buildSummarizationHeader,
            t.endpoint,
            i
        ]), _this40.permittedErrorPrefixes = [
            Ht.ENDPOINT_ERROR_MESSAGE
        ], _this40.url = "", _this40.textInputPlaceholderText = "Insert text to summarize", _this40.isTextInputDisabled = !1, t.endpoint ? ((_a$language = (a = _this40.rawBody).language) !== null && _a$language !== void 0 ? _a$language : a.language = "en", Object.assign(_this40.rawBody, t), _this40.url = "".concat(t.endpoint, "/language/analyze-text/jobs?api-version=2022-10-01-preview")) : (_this40.isTextInputDisabled = !0, _this40.canSendMessage = function() {
            return !1;
        }, setTimeout(function() {
            e.addMessage({
                error: Ht.ENDPOINT_ERROR_MESSAGE
            });
        }));
        return _this40;
    }
    $8e4453fb4fc895c8$var$_inherits(Ht, _$o);
    return $8e4453fb4fc895c8$var$_createClass(Ht, [
        {
            key: "preprocessBody",
            value: function preprocessBody(e, t) {
                var i = t[t.length - 1].text;
                if (i) return {
                    analysisInput: {
                        documents: [
                            {
                                id: "1",
                                language: e.language,
                                text: i
                            }
                        ]
                    },
                    tasks: [
                        {
                            kind: "ExtractiveSummarization"
                        }
                    ]
                };
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI14 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee89(e, t) {
                    var i;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee89$(_context89) {
                        while(true)switch(_context89.prev = _context89.next){
                            case 0:
                                if (this.connectSettings) {
                                    _context89.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                i = this.preprocessBody(this.rawBody, t);
                                $8e4453fb4fc895c8$var$C.request(this, i, e), this.messages = e;
                            case 4:
                            case "end":
                                return _context89.stop();
                        }
                    }, _callee89, this);
                }));
                function callServiceAPI(_x161, _x162) {
                    return _callServiceAPI14.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData17 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee90(e) {
                    var t, _i10, s;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee90$(_context90) {
                        while(true)switch(_context90.prev = _context90.next){
                            case 0:
                                if (!e.error) {
                                    _context90.next = 2;
                                    break;
                                }
                                throw e.error.message;
                            case 2:
                                if (this.messages && this.completionsHandlers) {
                                    _i10 = e.headers.get("operation-location"), s = {
                                        method: "GET",
                                        headers: (t = this.connectSettings) == null ? void 0 : t.headers
                                    };
                                    $8e4453fb4fc895c8$var$C.executePollRequest(this, _i10, s, this.messages);
                                }
                                return _context90.abrupt("return", {
                                    makingAnotherRequest: !0
                                });
                            case 4:
                            case "end":
                                return _context90.stop();
                        }
                    }, _callee90, this);
                }));
                function extractResultData(_x163) {
                    return _extractResultData17.apply(this, arguments);
                }
                return extractResultData;
            }()
        },
        {
            key: "extractPollResultData",
            value: function() {
                var _extractPollResultData5 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee91(e) {
                    var t, _iterator, _step, _i11;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee91$(_context91) {
                        while(true)switch(_context91.prev = _context91.next){
                            case 0:
                                if (!e.error) {
                                    _context91.next = 2;
                                    break;
                                }
                                throw e.error;
                            case 2:
                                if (!(e.status === "running")) {
                                    _context91.next = 4;
                                    break;
                                }
                                return _context91.abrupt("return", {
                                    timeoutMS: 2e3
                                });
                            case 4:
                                if (!(e.errors.length > 0)) {
                                    _context91.next = 6;
                                    break;
                                }
                                throw e.errors[0];
                            case 6:
                                if (!(e.tasks.items[0].results.errors.length > 0)) {
                                    _context91.next = 8;
                                    break;
                                }
                                throw e.tasks.items[0].results.errors[0];
                            case 8:
                                t = "";
                                _iterator = $8e4453fb4fc895c8$var$_createForOfIteratorHelper(e.tasks.items[0].results.documents[0].sentences);
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        _i11 = _step.value;
                                        t += _i11.text;
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                                return _context91.abrupt("return", {
                                    text: t || ""
                                });
                            case 12:
                            case "end":
                                return _context91.stop();
                        }
                    }, _callee91);
                }));
                function extractPollResultData(_x164) {
                    return _extractPollResultData5.apply(this, arguments);
                }
                return extractPollResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$$o);
$8e4453fb4fc895c8$var$Ht.ENDPOINT_ERROR_MESSAGE = // eslint-disable-next-line max-len
"Please define the azure endpoint. [More Information](https://deepchat.dev/docs/directConnection/Azure#Summarization)";
var $8e4453fb4fc895c8$var$Ss = $8e4453fb4fc895c8$var$Ht;
var $8e4453fb4fc895c8$var$Dt = /*#__PURE__*/ function() {
    function Dt() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Dt);
    }
    return $8e4453fb4fc895c8$var$_createClass(Dt, null, [
        {
            key: "poll",
            value: function() {
                var _poll2 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee92(e, t) {
                    var i, a, l, d;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee92$(_context92) {
                        while(true)switch(_context92.prev = _context92.next){
                            case 0:
                                i = {
                                    authorization: e,
                                    "content-type": "application/json"
                                };
                                _context92.t0 = "https://api.assemblyai.com/v2/transcript/";
                                _context92.next = 4;
                                return fetch("https://api.assemblyai.com/v2/transcript", {
                                    method: "POST",
                                    body: JSON.stringify({
                                        audio_url: t
                                    }),
                                    headers: i
                                });
                            case 4:
                                _context92.next = 6;
                                return _context92.sent.json();
                            case 6:
                                _context92.t1 = _context92.sent.id;
                                a = _context92.t0.concat.call(_context92.t0, _context92.t1);
                            case 8:
                                if (l) {
                                    _context92.next = 24;
                                    break;
                                }
                                _context92.next = 11;
                                return fetch(a, {
                                    headers: i
                                });
                            case 11:
                                _context92.next = 13;
                                return _context92.sent.json();
                            case 13:
                                d = _context92.sent;
                                if (!(d.status === "completed")) {
                                    _context92.next = 18;
                                    break;
                                }
                                l = d;
                                _context92.next = 22;
                                break;
                            case 18:
                                if (!(d.status === "error")) {
                                    _context92.next = 20;
                                    break;
                                }
                                throw new Error("Transcription failed: ".concat(d.error));
                            case 20:
                                _context92.next = 22;
                                return new Promise(function(h) {
                                    return setTimeout(h, 3e3);
                                });
                            case 22:
                                _context92.next = 8;
                                break;
                            case 24:
                                return _context92.abrupt("return", l);
                            case 25:
                            case "end":
                                return _context92.stop();
                        }
                    }, _callee92);
                }));
                function poll(_x165, _x166) {
                    return _poll2.apply(this, arguments);
                }
                return poll;
            }()
        },
        {
            key: "buildHeaders",
            value: function buildHeaders(e) {
                return {
                    Authorization: e,
                    "Content-Type": "application/octet-stream"
                };
            }
        },
        {
            key: "handleVerificationResult",
            value: function handleVerificationResult(e, t, i, s) {
                var r = e;
                r.error ? r.error.code === "invalid_api_key" ? s($8e4453fb4fc895c8$var$M.INVALID_KEY) : s($8e4453fb4fc895c8$var$M.CONNECTION_FAILED) : i(t);
            }
        },
        {
            key: "buildKeyVerificationDetails",
            value: function buildKeyVerificationDetails() {
                return {
                    url: "https://api.assemblyai.com/v2/upload",
                    method: "POST",
                    handleVerificationResult: Dt.handleVerificationResult
                };
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Ps = /*#__PURE__*/ function(_G8) {
    function Ps(e) {
        var _this41;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ps);
        var i;
        var t = (i = e.directConnection) == null ? void 0 : i.assemblyAI;
        _this41 = $8e4453fb4fc895c8$var$_callSuper(this, Ps, [
            e,
            $8e4453fb4fc895c8$var$Dt.buildKeyVerificationDetails(),
            $8e4453fb4fc895c8$var$Dt.buildHeaders,
            t,
            {
                audio: {}
            }
        ]), _this41.insertKeyPlaceholderText = "AssemblyAI API Key", _this41.keyHelpUrl = "https://www.assemblyai.com/app/account", _this41.introPanelMarkUp = '\n    <div style="width: 100%; text-align: center; margin-left: -10px"><b>AssemblyAI Audio</b></div>\n    <p><b>Upload an audio file</b> to transcribe it into text.\n    <p>\n      Click <a href="https://www.assemblyai.com/docs/Guides/transcribing_an_audio_file#get-started">here</a> for more info.\n    </p>', _this41.url = "https://api.assemblyai.com/v2/upload", _this41.isTextInputDisabled = !0, _this41.textInputPlaceholderText = "Upload an audio file", _this41.permittedErrorPrefixes = [
            "Authentication",
            "Invalid"
        ], _this41.canSendMessage = Ps.canFileSendMessage;
        return _this41;
    }
    $8e4453fb4fc895c8$var$_inherits(Ps, _G8);
    return $8e4453fb4fc895c8$var$_createClass(Ps, [
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI15 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee93(e, t, i) {
                    var s;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee93$(_context93) {
                        while(true)switch(_context93.prev = _context93.next){
                            case 0:
                                if ((s = this.connectSettings) != null && s.headers) {
                                    _context93.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                if (i != null && i[0]) {
                                    _context93.next = 4;
                                    break;
                                }
                                throw new Error("No file was added");
                            case 4:
                                $8e4453fb4fc895c8$var$C.request(this, i[0], e, !1);
                            case 5:
                            case "end":
                                return _context93.stop();
                        }
                    }, _callee93, this);
                }));
                function callServiceAPI(_x167, _x168, _x169) {
                    return _callServiceAPI15.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData18 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee94(e) {
                    var s, r, t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee94$(_context94) {
                        while(true)switch(_context94.prev = _context94.next){
                            case 0:
                                if (!e.error) {
                                    _context94.next = 2;
                                    break;
                                }
                                throw e.error;
                            case 2:
                                t = (r = (s = this.connectSettings) == null ? void 0 : s.headers) == null ? void 0 : r.Authorization;
                                _context94.next = 5;
                                return $8e4453fb4fc895c8$var$Dt.poll(t, e.upload_url);
                            case 5:
                                _context94.t0 = _context94.sent.text;
                                return _context94.abrupt("return", {
                                    text: _context94.t0
                                });
                            case 7:
                            case "end":
                                return _context94.stop();
                        }
                    }, _callee94, this);
                }));
                function extractResultData(_x170) {
                    return _extractResultData18.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ], [
        {
            key: "canFileSendMessage",
            value: function canFileSendMessage(e, t) {
                return !!(t != null && t[0]);
            }
        }
    ]);
}($8e4453fb4fc895c8$var$G);
var $8e4453fb4fc895c8$var$Rn = /*#__PURE__*/ function(_G9) {
    // prettier-ignore
    function Rn(e, t, i, s, r) {
        var _this42;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Rn);
        _this42 = $8e4453fb4fc895c8$var$_callSuper(this, Rn, [
            e,
            $8e4453fb4fc895c8$var$fe.buildSpeechKeyVerificationDetails(i),
            t,
            s,
            r
        ]), _this42.insertKeyPlaceholderText = "Azure Speech Subscription Key", _this42.keyHelpUrl = // eslint-disable-next-line max-len
        "https://learn.microsoft.com/en-us/azure/api-management/api-management-subscriptions#create-and-manage-subscriptions-in-azure-portal";
        return _this42;
    }
    $8e4453fb4fc895c8$var$_inherits(Rn, _G9);
    return $8e4453fb4fc895c8$var$_createClass(Rn);
}($8e4453fb4fc895c8$var$G);
var $8e4453fb4fc895c8$var$Qe = /*#__PURE__*/ function(_Rn) {
    // prettier-ignore
    function Qe(e) {
        var _a$lang, _l$name, _c$gender;
        var _this43;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Qe);
        var s, r, o, a, l, c;
        var t = (r = (s = e.directConnection) == null ? void 0 : s.azure) == null ? void 0 : r.textToSpeech, i = (o = e.directConnection) == null ? void 0 : o.azure;
        _this43 = $8e4453fb4fc895c8$var$_callSuper(this, Qe, [
            e,
            $8e4453fb4fc895c8$var$fe.buildTextToSpeechHeaders.bind({}, (t == null ? void 0 : t.outputFormat) || "audio-16khz-128kbitrate-mono-mp3"),
            t.region,
            i
        ]), _this43.permittedErrorPrefixes = [
            Qe.REGION_ERROR_MESSAGE
        ], _this43.introPanelMarkUp = '\n    <div style="width: 100%; text-align: center; margin-left: -10px"><b>Azure Text To Speech</b></div>\n    <p>Insert text to synthesize it to audio.\n    <p>\n      Click <a href="'.concat(Qe.HELP_LINK, '">here</a> for more info.\n    </p>'), _this43.isTextInputDisabled = !1, _this43.url = "", t.region ? (Object.assign(_this43.rawBody, t), (_a$lang = (a = _this43.rawBody).lang) !== null && _a$lang !== void 0 ? _a$lang : a.lang = "en-US", (_l$name = (l = _this43.rawBody).name) !== null && _l$name !== void 0 ? _l$name : l.name = "en-US-JennyNeural", (_c$gender = (c = _this43.rawBody).gender) !== null && _c$gender !== void 0 ? _c$gender : c.gender = "Female", _this43.url = "https://".concat(t.region, ".tts.speech.microsoft.com/cognitiveservices/v1")) : (_this43.isTextInputDisabled = !0, _this43.canSendMessage = function() {
            return !1;
        }, setTimeout(function() {
            e.addMessage({
                error: Qe.REGION_ERROR_MESSAGE
            });
        }));
        return _this43;
    }
    $8e4453fb4fc895c8$var$_inherits(Qe, _Rn);
    return $8e4453fb4fc895c8$var$_createClass(Qe, [
        {
            key: "preprocessBody",
            value: function preprocessBody(e, t) {
                var i = t[t.length - 1].text;
                if (i) return "<speak version='1.0' xml:lang='".concat(e.lang, "'>\n      <voice xml:lang='").concat(e.lang, "' xml:gender='").concat(e.gender, "' name='").concat(e.name, "'>\n        ").concat(i, "\n      </voice>\n    </speak>");
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI16 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee95(e, t) {
                    var i;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee95$(_context95) {
                        while(true)switch(_context95.prev = _context95.next){
                            case 0:
                                if (this.connectSettings) {
                                    _context95.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                i = this.preprocessBody(this.rawBody, t);
                                $8e4453fb4fc895c8$var$C.request(this, i, e, !1);
                            case 4:
                            case "end":
                                return _context95.stop();
                        }
                    }, _callee95, this);
                }));
                function callServiceAPI(_x171, _x172) {
                    return _callServiceAPI16.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData19 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee96(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee96$(_context96) {
                        while(true)switch(_context96.prev = _context96.next){
                            case 0:
                                return _context96.abrupt("return", new Promise(function(t) {
                                    var i = new FileReader();
                                    i.readAsDataURL(e), i.onload = function(s) {
                                        t({
                                            files: [
                                                {
                                                    src: s.target.result,
                                                    type: "audio"
                                                }
                                            ]
                                        });
                                    };
                                }));
                            case 1:
                            case "end":
                                return _context96.stop();
                        }
                    }, _callee96);
                }));
                function extractResultData(_x173) {
                    return _extractResultData19.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$Rn);
$8e4453fb4fc895c8$var$Qe.HELP_LINK = // eslint-disable-next-line max-len
"https://learn.microsoft.com/en-GB/azure/cognitive-services/speech-service/get-started-text-to-speech?tabs=windows%2Cterminal&pivots=programming-language-rest", $8e4453fb4fc895c8$var$Qe.REGION_ERROR_MESSAGE = // eslint-disable-next-line max-len
"Please define a region config property. [More Information](https://deepchat.dev/docs/directConnection/Azure#TextToSpeech)";
var $8e4453fb4fc895c8$var$xs = $8e4453fb4fc895c8$var$Qe;
var $8e4453fb4fc895c8$var$qe = /*#__PURE__*/ function(_Rn2) {
    function qe(e) {
        var _this44;
        $8e4453fb4fc895c8$var$_classCallCheck(this, qe);
        var r, o, a;
        var t = (o = (r = e.directConnection) == null ? void 0 : r.azure) == null ? void 0 : o.speechToText, i = (a = e.directConnection) == null ? void 0 : a.azure, s = {
            audio: {
                files: {
                    acceptedFormats: ".wav,.ogg"
                }
            }
        };
        if (_this44 = $8e4453fb4fc895c8$var$_callSuper(this, qe, [
            e,
            $8e4453fb4fc895c8$var$fe.buildSpeechToTextHeaders,
            t.region,
            i,
            s
        ]), _this44.permittedErrorPrefixes = [
            qe.REGION_ERROR_MESSAGE
        ], _this44.introPanelMarkUp = '\n    <div style="width: 100%; text-align: center; margin-left: -10px"><b>Azure Speech To Text</b></div>\n    <p><b>Upload a .wav or .ogg audio file</b> to transcribe it into text.\n    <p>\n      Click <a href="'.concat(qe.HELP_LINK, '">here</a> for more info.\n    </p>'), _this44.url = "", _this44.isTextInputDisabled = !0, _this44.textInputPlaceholderText = "Upload an audio file", !t.region) _this44.isTextInputDisabled = !0, _this44.canSendMessage = function() {
            return !1;
        }, setTimeout(function() {
            e.addMessage({
                error: qe.REGION_ERROR_MESSAGE
            });
        });
        else {
            _this44.canSendMessage = qe.canFileSendMessage;
            var l = t.lang || "en-US";
            _this44.url = "https://".concat(t.region, ".stt.speech.microsoft.com/speech/recognition/conversation/cognitiveservices/v1?language=").concat(l, "&format=detailed"), _this44.recordAudio = void 0;
        }
        return _this44;
    }
    $8e4453fb4fc895c8$var$_inherits(qe, _Rn2);
    return $8e4453fb4fc895c8$var$_createClass(qe, [
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI17 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee97(e, t, i) {
                    var s, r;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee97$(_context97) {
                        while(true)switch(_context97.prev = _context97.next){
                            case 0:
                                if ((s = this.connectSettings) != null && s.headers) {
                                    _context97.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                if (i != null && i[0]) {
                                    _context97.next = 4;
                                    break;
                                }
                                throw new Error("No file was added");
                            case 4:
                                (r = this.connectSettings) != null && r.headers && (this.connectSettings.headers["Content-Type"] = i[0].name.toLocaleLowerCase().endsWith(".wav") ? "audio/wav; codecs=audio/pcm; samplerate=16000" : "audio/ogg; codecs=opus"), $8e4453fb4fc895c8$var$C.request(this, i[0], e, !1);
                            case 5:
                            case "end":
                                return _context97.stop();
                        }
                    }, _callee97, this);
                }));
                function callServiceAPI(_x174, _x175, _x176) {
                    return _callServiceAPI17.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData20 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee98(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee98$(_context98) {
                        while(true)switch(_context98.prev = _context98.next){
                            case 0:
                                if (!e.error) {
                                    _context98.next = 2;
                                    break;
                                }
                                throw e.error;
                            case 2:
                                return _context98.abrupt("return", {
                                    text: e.DisplayText || ""
                                });
                            case 3:
                            case "end":
                                return _context98.stop();
                        }
                    }, _callee98);
                }));
                function extractResultData(_x177) {
                    return _extractResultData20.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ], [
        {
            key: "canFileSendMessage",
            value: function canFileSendMessage(e, t) {
                return !!(t != null && t[0]);
            }
        }
    ]);
}($8e4453fb4fc895c8$var$Rn);
$8e4453fb4fc895c8$var$qe.HELP_LINK = // eslint-disable-next-line max-len
"https://learn.microsoft.com/en-GB/azure/cognitive-services/speech-service/get-started-text-to-speech?tabs=windows%2Cterminal&pivots=programming-language-rest", $8e4453fb4fc895c8$var$qe.REGION_ERROR_MESSAGE = // eslint-disable-next-line max-len
"Please define a region config property. [More Information](https://deepchat.dev/docs/directConnection/Azure#SpeechToText)";
var $8e4453fb4fc895c8$var$_s = $8e4453fb4fc895c8$var$qe;
var $8e4453fb4fc895c8$var$Wo = /*#__PURE__*/ function(_G10) {
    // prettier-ignore
    function Wo(e) {
        var _this45;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Wo);
        var s, r, o;
        var t = (r = (s = e.directConnection) == null ? void 0 : s.azure) == null ? void 0 : r.translation, i = (o = e.directConnection) == null ? void 0 : o.azure;
        _this45 = $8e4453fb4fc895c8$var$_callSuper(this, Wo, [
            e,
            $8e4453fb4fc895c8$var$fe.buildTranslationKeyVerificationDetails(t.region),
            $8e4453fb4fc895c8$var$fe.buildTranslationHeaders.bind({}, t == null ? void 0 : t.region),
            i
        ]), _this45.insertKeyPlaceholderText = "Azure Translate Subscription Key", _this45.keyHelpUrl = // eslint-disable-next-line max-len
        "https://learn.microsoft.com/en-us/azure/api-management/api-management-subscriptions#create-and-manage-subscriptions-in-azure-portal", _this45.url = "", _this45.url = "https://api.cognitive.microsofttranslator.com/translate?api-version=3.0&to=".concat(t.language || "es");
        return _this45;
    }
    $8e4453fb4fc895c8$var$_inherits(Wo, _G10);
    return $8e4453fb4fc895c8$var$_createClass(Wo, [
        {
            key: "preprocessBody",
            value: function preprocessBody(e) {
                var t = e[e.length - 1].text;
                if (t) return [
                    {
                        Text: t
                    }
                ];
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI18 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee99(e, t) {
                    var i;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee99$(_context99) {
                        while(true)switch(_context99.prev = _context99.next){
                            case 0:
                                if (this.connectSettings) {
                                    _context99.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                i = this.preprocessBody(t);
                                $8e4453fb4fc895c8$var$C.request(this, i, e);
                            case 4:
                            case "end":
                                return _context99.stop();
                        }
                    }, _callee99, this);
                }));
                function callServiceAPI(_x178, _x179) {
                    return _callServiceAPI18.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData21 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee100(e) {
                    var t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee100$(_context100) {
                        while(true)switch(_context100.prev = _context100.next){
                            case 0:
                                if (!Array.isArray(e)) {
                                    _context100.next = 2;
                                    break;
                                }
                                return _context100.abrupt("return", {
                                    text: ((t = e[0].translations) == null ? void 0 : t[0].text) || ""
                                });
                            case 2:
                                throw e.error;
                            case 3:
                            case "end":
                                return _context100.stop();
                        }
                    }, _callee100);
                }));
                function extractResultData(_x180) {
                    return _extractResultData21.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$G);
var $8e4453fb4fc895c8$var$_t = /*#__PURE__*/ function(_G11) {
    // prettier-ignore
    function _t(e, t, i, s, r) {
        var _this46$maxMessages, _m$model;
        var _this46;
        $8e4453fb4fc895c8$var$_classCallCheck(this, _t);
        var h, f, u, m;
        var o = JSON.parse(JSON.stringify(e.directConnection)), a = t || $8e4453fb4fc895c8$var$I.buildKeyVerificationDetails(), l = i || $8e4453fb4fc895c8$var$I.buildHeaders, c = s || o.openAI;
        _this46 = $8e4453fb4fc895c8$var$_callSuper(this, _t, [
            e,
            a,
            l,
            c
        ]), _this46.insertKeyPlaceholderText = "OpenAI API Key", _this46.keyHelpUrl = "https://platform.openai.com/account/api-keys", _this46.url = "https://api.openai.com/v1/chat/completions", _this46.permittedErrorPrefixes = [
            "Incorrect"
        ], _this46.asyncCallInProgress = !1, _this46._systemMessage = _t.generateSystemMessage("You are a helpful assistant.");
        var d = r || ((h = o.openAI) == null ? void 0 : h.chat);
        if ($8e4453fb4fc895c8$var$_typeof(d) == "object") {
            d.system_prompt && (_this46._systemMessage = _t.generateSystemMessage(d.system_prompt));
            var _ref25 = (u = (f = e.directConnection) == null ? void 0 : f.openAI) == null ? void 0 : u.chat, p = _ref25.function_handler;
            p && (_this46._functionHandler = p), _this46.cleanConfig(d), Object.assign(_this46.rawBody, d);
        }
        (_this46$maxMessages = _this46.maxMessages) !== null && _this46$maxMessages !== void 0 ? _this46$maxMessages : _this46.maxMessages = -1, (_m$model = (m = _this46.rawBody).model) !== null && _m$model !== void 0 ? _m$model : m.model = "gpt-4o";
        return _this46;
    }
    $8e4453fb4fc895c8$var$_inherits(_t, _G11);
    return $8e4453fb4fc895c8$var$_createClass(_t, [
        {
            key: "cleanConfig",
            value: function cleanConfig(e) {
                delete e.system_prompt, delete e.function_handler;
            }
        },
        {
            key: "preprocessBody",
            value: // prettier-ignore
            function preprocessBody(e, t) {
                var _i$max_tokens;
                var i = JSON.parse(JSON.stringify(e)), s = $8e4453fb4fc895c8$var$Tt.getCharacterLimitMessages(t, this.totalMessagesMaxCharLength ? this.totalMessagesMaxCharLength - this._systemMessage.content.length : -1).map(function(r) {
                    return {
                        content: _t.getContent(r),
                        role: r.role === $8e4453fb4fc895c8$var$b.USER_ROLE ? "user" : "assistant"
                    };
                });
                return t.find(function(r) {
                    return r.files && r.files.length > 0;
                }) && ((_i$max_tokens = i.max_tokens) !== null && _i$max_tokens !== void 0 ? _i$max_tokens : i.max_tokens = 300), i.messages = [
                    this._systemMessage
                ].concat($8e4453fb4fc895c8$var$_toConsumableArray(s)), i;
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI19 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee101(e, t) {
                    var i, s;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee101$(_context101) {
                        while(true)switch(_context101.prev = _context101.next){
                            case 0:
                                if (this.connectSettings) {
                                    _context101.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                i = this.preprocessBody(this.rawBody, t), s = this.stream;
                                s && ($8e4453fb4fc895c8$var$_typeof(s) != "object" || !s.simulation) || i.stream ? (i.stream = !0, $8e4453fb4fc895c8$var$T.request(this, i, e)) : $8e4453fb4fc895c8$var$C.request(this, i, e);
                            case 4:
                            case "end":
                                return _context101.stop();
                        }
                    }, _callee101, this);
                }));
                function callServiceAPI(_x181, _x182) {
                    return _callServiceAPI19.apply(this, arguments);
                }
                return callServiceAPI;
            }() // prettier-ignore
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData22 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee102(e, t, i) {
                    var s, r, o, a;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee102$(_context102) {
                        while(true)switch(_context102.prev = _context102.next){
                            case 0:
                                if (!e.error) {
                                    _context102.next = 2;
                                    break;
                                }
                                throw e.error.message;
                            case 2:
                                return _context102.abrupt("return", (r = (s = e.choices) == null ? void 0 : s[0]) != null && r.delta ? this.extractStreamResult(e.choices[0], t, i) : (a = (o = e.choices) == null ? void 0 : o[0]) != null && a.message ? e.choices[0].message.tool_calls ? this.handleTools(e.choices[0].message, t, i) : {
                                    text: e.choices[0].message.content
                                } : {
                                    text: ""
                                });
                            case 3:
                            case "end":
                                return _context102.stop();
                        }
                    }, _callee102, this);
                }));
                function extractResultData(_x183, _x184, _x185) {
                    return _extractResultData22.apply(this, arguments);
                }
                return extractResultData;
            }()
        },
        {
            key: "extractStreamResult",
            value: function() {
                var _extractStreamResult = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee103(e, t, i) {
                    var _this47 = this;
                    var s, r, o;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee103$(_context103) {
                        while(true)switch(_context103.prev = _context103.next){
                            case 0:
                                s = e.delta, r = e.finish_reason;
                                if (!(r === "tool_calls")) {
                                    _context103.next = 7;
                                    break;
                                }
                                this.asyncCallInProgress = !0;
                                o = {
                                    tool_calls: this._streamToolCalls
                                };
                                return _context103.abrupt("return", (this._streamToolCalls = void 0, this.handleTools(o, t, i)));
                            case 7:
                                s != null && s.tool_calls && (this._streamToolCalls ? s.tool_calls.forEach(function(o, a) {
                                    _this47._streamToolCalls && (_this47._streamToolCalls[a]["function"].arguments += o["function"].arguments);
                                }) : this._streamToolCalls = s.tool_calls);
                            case 8:
                                return _context103.abrupt("return", {
                                    text: (s == null ? void 0 : s.content) || ""
                                });
                            case 9:
                            case "end":
                                return _context103.stop();
                        }
                    }, _callee103, this);
                }));
                function extractStreamResult(_x186, _x187, _x188) {
                    return _extractStreamResult.apply(this, arguments);
                }
                return extractStreamResult;
            }() // prettier-ignore
        },
        {
            key: "handleTools",
            value: function() {
                var _handleTools2 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee104(e, t, i) {
                    var l, c, d, h, f, s, r, o, u, a, _u2;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee104$(_context104) {
                        while(true)switch(_context104.prev = _context104.next){
                            case 0:
                                if (!(!e.tool_calls || !t || !i || !this._functionHandler)) {
                                    _context104.next = 2;
                                    break;
                                }
                                throw Error("Please define the `function_handler` property inside the [openAI](https://deepchat.dev/docs/directConnection/openAI#Chat) object.");
                            case 2:
                                s = JSON.parse(JSON.stringify(i));
                                r = e.tool_calls.map(function(u) {
                                    return {
                                        name: u["function"].name,
                                        arguments: u["function"].arguments
                                    };
                                });
                                _context104.next = 6;
                                return (l = this._functionHandler) == null ? void 0 : l.call(this, r);
                            case 6:
                                o = _context104.sent;
                                if (Array.isArray(o)) {
                                    _context104.next = 17;
                                    break;
                                }
                                if (!o.text) {
                                    _context104.next = 16;
                                    break;
                                }
                                u = {
                                    text: o.text
                                };
                                _context104.next = 12;
                                return (d = (c = this.deepChat).responseInterceptor) == null ? void 0 : d.call(c, u);
                            case 12:
                                _context104.t0 = _context104.sent;
                                if (_context104.t0) {
                                    _context104.next = 15;
                                    break;
                                }
                                _context104.t0 = u;
                            case 15:
                                return _context104.abrupt("return", _context104.t0);
                            case 16:
                                throw Error($8e4453fb4fc895c8$var$I.FUNCTION_TOOL_RESP_ERROR);
                            case 17:
                                _context104.next = 19;
                                return Promise.all(o);
                            case 19:
                                a = _context104.sent;
                                if (!(s.messages.push({
                                    tool_calls: e.tool_calls,
                                    role: "assistant",
                                    content: null
                                }), !a.find(function(_ref26) {
                                    var u = _ref26.response;
                                    return typeof u != "string";
                                }) && r.length === a.length)) {
                                    _context104.next = 40;
                                    break;
                                }
                                a.forEach(function(u, m) {
                                    var v;
                                    var p = (v = e.tool_calls) == null ? void 0 : v[m];
                                    s == null || s.messages.push({
                                        role: "tool",
                                        tool_call_id: p == null ? void 0 : p.id,
                                        name: p == null ? void 0 : p["function"].name,
                                        content: u.response
                                    });
                                }), delete s.tools, delete s.tool_choice, delete s.stream;
                                _context104.prev = 22;
                                _context104.next = 25;
                                return t == null ? void 0 : t(s).then(function(m) {
                                    return $8e4453fb4fc895c8$var$E.processResponseByType(m);
                                });
                            case 25:
                                _u2 = _context104.sent;
                                _context104.next = 28;
                                return (f = (h = this.deepChat).responseInterceptor) == null ? void 0 : f.call(h, _u2);
                            case 28:
                                _context104.t1 = _context104.sent;
                                if (_context104.t1) {
                                    _context104.next = 31;
                                    break;
                                }
                                _context104.t1 = _u2;
                            case 31:
                                _u2 = _context104.t1;
                                if (!_u2.error) {
                                    _context104.next = 34;
                                    break;
                                }
                                throw _u2.error.message;
                            case 34:
                                return _context104.abrupt("return", {
                                    text: _u2.choices[0].message.content || ""
                                });
                            case 37:
                                _context104.prev = 37;
                                _context104.t2 = _context104["catch"](22);
                                throw this.asyncCallInProgress = !1, _context104.t2;
                            case 40:
                                throw Error($8e4453fb4fc895c8$var$I.FUNCTION_TOOL_RESP_ERROR);
                            case 41:
                            case "end":
                                return _context104.stop();
                        }
                    }, _callee104, this, [
                        [
                            22,
                            37
                        ]
                    ]);
                }));
                function handleTools(_x189, _x190, _x191) {
                    return _handleTools2.apply(this, arguments);
                }
                return handleTools;
            }()
        }
    ], [
        {
            key: "generateSystemMessage",
            value: function generateSystemMessage(e) {
                return {
                    role: "system",
                    content: e
                };
            }
        },
        {
            key: "getContent",
            value: function getContent(e) {
                if (e.files && e.files.length > 0) {
                    var t = e.files.map(function(i) {
                        return {
                            type: "image_url",
                            image_url: {
                                url: i.src
                            }
                        };
                    });
                    return e.text && e.text.trim().length > 0 && t.unshift({
                        type: "text",
                        text: e.text
                    }), t;
                }
                return e.text;
            }
        }
    ]);
}($8e4453fb4fc895c8$var$G);
var $8e4453fb4fc895c8$var$Os = /*#__PURE__*/ function(_t3) {
    function Os(e) {
        var _this48;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Os);
        var o, a, l, c, d, h, f;
        var t = JSON.parse(JSON.stringify(e.directConnection)), i = t.azure, s = ((a = (o = t.azure) == null ? void 0 : o.openAI) == null ? void 0 : a.urlDetails) || {}, r = (c = (l = t.azure) == null ? void 0 : l.openAI) == null ? void 0 : c.chat;
        if (_this48 = $8e4453fb4fc895c8$var$_callSuper(this, Os, [
            e,
            $8e4453fb4fc895c8$var$ue.buildKeyVerificationDetails(s),
            $8e4453fb4fc895c8$var$ue.buildHeaders,
            i,
            r
        ]), _this48.permittedErrorPrefixes = [
            $8e4453fb4fc895c8$var$ue.URL_DETAILS_ERROR_MESSAGE
        ], _this48.isTextInputDisabled = !1, $8e4453fb4fc895c8$var$_typeof(r) == "object") {
            var _ref27 = (f = (h = (d = e.directConnection) == null ? void 0 : d.azure) == null ? void 0 : h.openAI) == null ? void 0 : f.chat, u = _ref27.function_handler;
            u && (_this48._functionHandler = u);
        }
        $8e4453fb4fc895c8$var$ue.validateURLDetails(s) ? _this48.url = Os.buildURL(s) : (_this48.isTextInputDisabled = !0, _this48.canSendMessage = function() {
            return !1;
        }, setTimeout(function() {
            e.addMessage({
                error: $8e4453fb4fc895c8$var$ue.URL_DETAILS_ERROR_MESSAGE
            });
        }));
        return _this48;
    }
    $8e4453fb4fc895c8$var$_inherits(Os, _t3);
    return $8e4453fb4fc895c8$var$_createClass(Os, null, [
        {
            key: "buildURL",
            value: function buildURL(e) {
                var t = e.endpoint, i = e.deploymentId, s = e.version;
                return "".concat(t, "/openai/deployments/").concat(i, "/completions?api-version=").concat(s);
            }
        }
    ]);
}($8e4453fb4fc895c8$var$_t);
var $8e4453fb4fc895c8$var$be = /*#__PURE__*/ function(_G12) {
    function be(e) {
        var _this49;
        $8e4453fb4fc895c8$var$_classCallCheck(this, be);
        var o;
        var t = e.directConnection, i = t == null ? void 0 : t.openAI, s = {
            images: {
                files: {
                    acceptedFormats: ".png",
                    maxNumberOfFiles: 2
                }
            }
        };
        _this49 = $8e4453fb4fc895c8$var$_callSuper(this, be, [
            e,
            $8e4453fb4fc895c8$var$I.buildKeyVerificationDetails(),
            $8e4453fb4fc895c8$var$I.buildHeaders,
            i,
            s
        ]), _this49.insertKeyPlaceholderText = "OpenAI API Key", _this49.keyHelpUrl = "https://platform.openai.com/account/api-keys", _this49.introPanelMarkUp = '\n    <div style="width: 100%; text-align: center; margin-left: -10px"><b>OpenAI DALL\xb7E</b></div>\n    <p><b>Insert text</b> to generate an image.</p>\n    <p><b>Upload 1</b> PNG image to generate its variation and optionally insert text to specify the change.</p>\n    <p><b>Upload 2</b> PNG images where the second is a copy of the first with a transparent area where the edit should\n      take place and text to specify the edit.</p>\n    <p>Click <a href="https://platform.openai.com/docs/guides/images/introduction">here</a> for more info.</p>', _this49.url = "", _this49.permittedErrorPrefixes = [
            "Incorrect",
            "Invalid input image"
        ];
        var r = (o = t == null ? void 0 : t.openAI) == null ? void 0 : o.images;
        if (_this49.camera) {
            var a = $8e4453fb4fc895c8$var$_typeof(r) == "object" && r.size ? Number.parseInt(r.size) : 1024;
            _this49.camera.files = {
                dimensions: {
                    width: a,
                    height: a
                }
            };
        }
        $8e4453fb4fc895c8$var$_typeof(r) == "object" && Object.assign(_this49.rawBody, r), _this49.canSendMessage = be.canFileSendMessage;
        return _this49;
    }
    $8e4453fb4fc895c8$var$_inherits(be, _G12);
    return $8e4453fb4fc895c8$var$_createClass(be, [
        {
            key: "preprocessBody",
            value: function preprocessBody(e, t) {
                var i = JSON.parse(JSON.stringify(e));
                return t && t !== "" && (i.prompt = t), i;
            }
        },
        {
            key: "callApiWithImage",
            value: function callApiWithImage(e, t, i) {
                var o, a;
                var s;
                var r = (a = (o = t[t.length - 1]) == null ? void 0 : o.text) == null ? void 0 : a.trim();
                if (i[1] || r && r !== "") {
                    this.url = be.IMAGE_EDIT_URL;
                    var l = this.preprocessBody(this.rawBody, r);
                    s = be.createFormDataBody(l, i[0], i[1]);
                } else this.url = be.IMAGE_VARIATIONS_URL, s = be.createFormDataBody(this.rawBody, i[0]);
                $8e4453fb4fc895c8$var$E.tempRemoveContentHeader(this.connectSettings, $8e4453fb4fc895c8$var$C.request.bind(this, this, s, e), !1);
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI20 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee105(e, t, i) {
                    var s, r;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee105$(_context105) {
                        while(true)switch(_context105.prev = _context105.next){
                            case 0:
                                if ((s = this.connectSettings) != null && s.headers) {
                                    _context105.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                if (!(i != null && i[0])) {
                                    _context105.next = 6;
                                    break;
                                }
                                this.callApiWithImage(e, t, i);
                                _context105.next = 11;
                                break;
                            case 6:
                                if (this.connectSettings) {
                                    _context105.next = 8;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 8:
                                this.url = be.IMAGE_GENERATION_URL;
                                r = this.preprocessBody(this.rawBody, t[t.length - 1].text);
                                $8e4453fb4fc895c8$var$C.request(this, r, e);
                            case 11:
                            case "end":
                                return _context105.stop();
                        }
                    }, _callee105, this);
                }));
                function callServiceAPI(_x192, _x193, _x194) {
                    return _callServiceAPI20.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData23 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee106(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee106$(_context106) {
                        while(true)switch(_context106.prev = _context106.next){
                            case 0:
                                if (!e.error) {
                                    _context106.next = 2;
                                    break;
                                }
                                throw e.error.message;
                            case 2:
                                return _context106.abrupt("return", {
                                    files: e.data.map(function(i) {
                                        return i.url ? {
                                            src: i.url,
                                            type: "image"
                                        } : {
                                            src: "".concat($8e4453fb4fc895c8$var$ti).concat(i.b64_json),
                                            type: "image"
                                        };
                                    })
                                });
                            case 3:
                            case "end":
                                return _context106.stop();
                        }
                    }, _callee106);
                }));
                function extractResultData(_x195) {
                    return _extractResultData23.apply(this, arguments);
                }
                return extractResultData;
            }() // private static readonly MODAL_MARKDOWN = `
        }
    ], [
        {
            key: "canFileSendMessage",
            value: function canFileSendMessage(e, t) {
                return !!(t != null && t[0]) || !!(e && e.trim() !== "");
            }
        },
        {
            key: "createFormDataBody",
            value: function createFormDataBody(e, t, i) {
                var s = new FormData();
                return s.append("image", t), i && s.append("mask", i), Object.keys(e).forEach(function(r) {
                    s.append(r, String(e[r]));
                }), s;
            }
        }
    ]);
}($8e4453fb4fc895c8$var$G);
$8e4453fb4fc895c8$var$be.IMAGE_GENERATION_URL = "https://api.openai.com/v1/images/generations", $8e4453fb4fc895c8$var$be.IMAGE_VARIATIONS_URL = "https://api.openai.com/v1/images/variations", $8e4453fb4fc895c8$var$be.IMAGE_EDIT_URL = "https://api.openai.com/v1/images/edits";
var $8e4453fb4fc895c8$var$ws = $8e4453fb4fc895c8$var$be;
var $8e4453fb4fc895c8$var$Ko = /*#__PURE__*/ function(_Ls3) {
    function Ko(e) {
        var _this50$maxMessages;
        var _this50;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ko);
        var r;
        var t = JSON.parse(JSON.stringify(e.directConnection)), i = (r = t.cohere) == null ? void 0 : r.chat, s = t.cohere;
        _this50 = $8e4453fb4fc895c8$var$_callSuper(this, Ko, [
            e,
            "https://api.cohere.ai/v1/chat",
            "Ask me anything!",
            i,
            s
        ]), $8e4453fb4fc895c8$var$_typeof(i) == "object" && Object.assign(_this50.rawBody, i), (_this50$maxMessages = _this50.maxMessages) !== null && _this50$maxMessages !== void 0 ? _this50$maxMessages : _this50.maxMessages = -1;
        return _this50;
    }
    $8e4453fb4fc895c8$var$_inherits(Ko, _Ls3);
    return $8e4453fb4fc895c8$var$_createClass(Ko, [
        {
            key: "preprocessBody",
            value: function preprocessBody(e, t) {
                var i = JSON.parse(JSON.stringify(e)), s = t.filter(function(r) {
                    return r.text;
                });
                return i.query = s[s.length - 1].text, i.chat_history = s.slice(0, s.length - 1).map(function(r) {
                    return {
                        text: r.text,
                        user_name: r.role === "ai" ? "CHATBOT" : "USER"
                    };
                }), i;
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI21 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee107(e, t) {
                    var i;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee107$(_context107) {
                        while(true)switch(_context107.prev = _context107.next){
                            case 0:
                                if (this.connectSettings) {
                                    _context107.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                i = this.preprocessBody(this.rawBody, t);
                                $8e4453fb4fc895c8$var$C.request(this, i, e);
                            case 4:
                            case "end":
                                return _context107.stop();
                        }
                    }, _callee107, this);
                }));
                function callServiceAPI(_x196, _x197) {
                    return _callServiceAPI21.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData24 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee108(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee108$(_context108) {
                        while(true)switch(_context108.prev = _context108.next){
                            case 0:
                                if (!e.message) {
                                    _context108.next = 2;
                                    break;
                                }
                                throw e.message;
                            case 2:
                                return _context108.abrupt("return", {
                                    text: e.text
                                });
                            case 3:
                            case "end":
                                return _context108.stop();
                        }
                    }, _callee108);
                }));
                function extractResultData(_x198) {
                    return _extractResultData24.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$Ls);
var $8e4453fb4fc895c8$var$Ci = /*#__PURE__*/ function() {
    function Ci() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ci);
    }
    return $8e4453fb4fc895c8$var$_createClass(Ci, null, [
        {
            key: "buildHeaders",
            value: function buildHeaders(e) {
                return {
                    Authorization: "Bearer ".concat(e),
                    "Content-Type": "application/json",
                    accept: "application/json"
                };
            }
        },
        {
            key: "handleVerificationResult",
            value: function handleVerificationResult(e, t, i, s) {
                var o;
                (o = e.message) != null && o.includes("invalid request: prompt must be at least 1 token long") ? i(t) : s($8e4453fb4fc895c8$var$M.INVALID_KEY);
            }
        },
        {
            key: "buildKeyVerificationDetails",
            value: function buildKeyVerificationDetails() {
                return {
                    url: "https://api.mistral.ai/v1/models",
                    method: "GET",
                    handleVerificationResult: Ci.handleVerificationResult
                };
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Jo = /*#__PURE__*/ function(_G13) {
    function Jo(e) {
        var _this51$maxMessages, _s$model;
        var _this51;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Jo);
        var s;
        var i = JSON.parse(JSON.stringify(e.directConnection)).mistral;
        _this51 = $8e4453fb4fc895c8$var$_callSuper(this, Jo, [
            e,
            $8e4453fb4fc895c8$var$Ci.buildKeyVerificationDetails(),
            $8e4453fb4fc895c8$var$Ci.buildHeaders,
            i
        ]), _this51.insertKeyPlaceholderText = "Mistral API Key", _this51.keyHelpUrl = "https://console.mistral.ai/api-keys/", _this51.url = "https://api.mistral.ai/v1/chat/completions", _this51.permittedErrorPrefixes = [
            "invalid"
        ], i && (_this51.cleanConfig(i), Object.assign(_this51.rawBody, i)), (_this51$maxMessages = _this51.maxMessages) !== null && _this51$maxMessages !== void 0 ? _this51$maxMessages : _this51.maxMessages = -1, (_s$model = (s = _this51.rawBody).model) !== null && _s$model !== void 0 ? _s$model : s.model = "open-mistral-7b";
        return _this51;
    }
    $8e4453fb4fc895c8$var$_inherits(Jo, _G13);
    return $8e4453fb4fc895c8$var$_createClass(Jo, [
        {
            key: "cleanConfig",
            value: function cleanConfig(e) {
                delete e.key;
            }
        },
        {
            key: "preprocessBody",
            value: function preprocessBody(e, t) {
                var i = JSON.parse(JSON.stringify(e)), s = t.filter(function(r) {
                    return r.text;
                });
                return i.messages = s.slice(0, s.length - 1).map(function(r) {
                    return {
                        text: r.text,
                        user_name: r.role === "ai" ? "system" : "user"
                    };
                }), i;
            }
        },
        {
            key: "callServiceAPI",
            value: function() {
                var _callServiceAPI22 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee109(e, t) {
                    var i;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee109$(_context109) {
                        while(true)switch(_context109.prev = _context109.next){
                            case 0:
                                if (this.connectSettings) {
                                    _context109.next = 2;
                                    break;
                                }
                                throw new Error("Request settings have not been set up");
                            case 2:
                                i = this.preprocessBody(this.rawBody, t);
                                $8e4453fb4fc895c8$var$C.request(this, i, e);
                            case 4:
                            case "end":
                                return _context109.stop();
                        }
                    }, _callee109, this);
                }));
                function callServiceAPI(_x199, _x200) {
                    return _callServiceAPI22.apply(this, arguments);
                }
                return callServiceAPI;
            }()
        },
        {
            key: "extractResultData",
            value: function() {
                var _extractResultData25 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee110(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee110$(_context110) {
                        while(true)switch(_context110.prev = _context110.next){
                            case 0:
                                if (!e.message) {
                                    _context110.next = 2;
                                    break;
                                }
                                throw e.message;
                            case 2:
                                return _context110.abrupt("return", {
                                    text: e.text
                                });
                            case 3:
                            case "end":
                                return _context110.stop();
                        }
                    }, _callee110);
                }));
                function extractResultData(_x201) {
                    return _extractResultData25.apply(this, arguments);
                }
                return extractResultData;
            }()
        }
    ]);
}($8e4453fb4fc895c8$var$G);
var $8e4453fb4fc895c8$var$Zo = /*#__PURE__*/ function() {
    function Zo() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Zo);
    }
    return $8e4453fb4fc895c8$var$_createClass(Zo, null, [
        {
            key: "create",
            value: // this should only be called when no _activeService is set or is demo as otherwise we don't want to reconnect
            function create(e) {
                var t = e.directConnection, i = e.connect, s = e.demo, r = e.webModel;
                if (r) return new $8e4453fb4fc895c8$var$Wt(e);
                if (t) {
                    if (t.openAI) return t.openAI.images ? new $8e4453fb4fc895c8$var$ws(e) : t.openAI.speechToText ? new $8e4453fb4fc895c8$var$Es(e) : t.openAI.textToSpeech ? new $8e4453fb4fc895c8$var$ys(e) : t.openAI.assistant ? new $8e4453fb4fc895c8$var$bs(e) : new $8e4453fb4fc895c8$var$_t(e);
                    if (t.assemblyAI) return new $8e4453fb4fc895c8$var$Ps(e);
                    if (t.cohere) return t.cohere.textGeneration ? new $8e4453fb4fc895c8$var$Go(e) : t.cohere.summarization ? new $8e4453fb4fc895c8$var$Vo(e) : new $8e4453fb4fc895c8$var$Ko(e);
                    if (t.huggingFace) return t.huggingFace.textGeneration ? new $8e4453fb4fc895c8$var$Fo(e) : t.huggingFace.summarization ? new $8e4453fb4fc895c8$var$jo(e) : t.huggingFace.translation ? new $8e4453fb4fc895c8$var$qo(e) : t.huggingFace.fillMask ? new $8e4453fb4fc895c8$var$zo(e) : t.huggingFace.questionAnswer ? new $8e4453fb4fc895c8$var$Uo(e) : t.huggingFace.audioSpeechRecognition ? new $8e4453fb4fc895c8$var$Bo(e) : t.huggingFace.audioClassification ? new $8e4453fb4fc895c8$var$No(e) : t.huggingFace.imageClassification ? new $8e4453fb4fc895c8$var$Do(e) : new $8e4453fb4fc895c8$var$Ho(e);
                    if (t.azure) {
                        if (t.azure.openAI) {
                            if (t.azure.openAI.chat) return new $8e4453fb4fc895c8$var$Os(e);
                            if (t.azure.openAI.assistant) return new $8e4453fb4fc895c8$var$vs(e);
                        }
                        if (t.azure.speechToText) return new $8e4453fb4fc895c8$var$_s(e);
                        if (t.azure.textToSpeech) return new $8e4453fb4fc895c8$var$xs(e);
                        if (t.azure.summarization) return new $8e4453fb4fc895c8$var$Ss(e);
                        if (t.azure.translation) return new $8e4453fb4fc895c8$var$Wo(e);
                    }
                    if (t.stabilityAI) return t.stabilityAI.imageToImage ? new $8e4453fb4fc895c8$var$xi(e) : t.stabilityAI.imageToImageUpscale ? new $8e4453fb4fc895c8$var$Ei(e) : t.stabilityAI.imageToImageMasking ? new $8e4453fb4fc895c8$var$Si(e) : new $8e4453fb4fc895c8$var$_i(e);
                    if (t.mistral) return new $8e4453fb4fc895c8$var$Jo(e);
                }
                return i && (!s || !i.stream) ? new $8e4453fb4fc895c8$var$rt(e) : new $8e4453fb4fc895c8$var$rt(e, void 0, s || !0);
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$js = /*#__PURE__*/ $8e4453fb4fc895c8$var$_createClass(function js() {
    $8e4453fb4fc895c8$var$_classCallCheck(this, js);
});
$8e4453fb4fc895c8$var$js.attibutes = {
    string: function string(e) {
        return e;
    },
    number: function number(e) {
        return parseFloat(e);
    },
    "boolean": function boolean(e) {
        return e === "true";
    },
    object: function object(e) {
        return JSON.parse(e);
    },
    array: function array(e) {
        return JSON.parse(e);
    },
    "function": function _function(e) {
        return new Function("return ".concat(e))();
    }
};
var $8e4453fb4fc895c8$var$As = $8e4453fb4fc895c8$var$js;
function $8e4453fb4fc895c8$var$x(n) {
    return function(e, t) {
        Object.defineProperty(e, t, {});
        var i = e.constructor, s = t.toLocaleLowerCase();
        i._attributes_[s] = $8e4453fb4fc895c8$var$As.attibutes[n], i._attributeToProperty_[s] = t;
    };
}
var $8e4453fb4fc895c8$var$Ti = /*#__PURE__*/ function() {
    function Ti(e, t, i) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ti);
        this._isDisplayed = !1, e ? (this._elementRef = this.createIntroPanelWithChild(e, i), this._isDisplayed = !0) : t && (this._elementRef = this.createInternalIntroPanel(t, i), this._isDisplayed = !0);
    }
    return $8e4453fb4fc895c8$var$_createClass(Ti, [
        {
            key: "createIntroPanelWithChild",
            value: function createIntroPanelWithChild(e, t) {
                var i = Ti.createIntroPanel(t);
                return e.style.display === "none" && (e.style.display = "block"), i.appendChild(e), i;
            }
        },
        {
            key: "createInternalIntroPanel",
            value: function createInternalIntroPanel(e, t) {
                var i = Ti.createIntroPanel(t);
                return i.id = "internal-intro-panel", i.innerHTML = e, i;
            }
        },
        {
            key: "hide",
            value: function hide() {
                this._isDisplayed && this._elementRef && (this._elementRef.style.display = "none", this._isDisplayed = !1);
            }
        },
        {
            key: "display",
            value: function display() {
                !this._isDisplayed && this._elementRef && (this._elementRef.style.display = "", this._isDisplayed = !0);
            }
        }
    ], [
        {
            key: "createIntroPanel",
            value: function createIntroPanel(e) {
                var t = document.createElement("div");
                return t.classList.add("intro-panel"), Object.assign(t.style, e), t;
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Xo = '<?xml version="1.0" encoding="iso-8859-1"?>\n<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" \n	 viewBox="50 30 420 450" xml:space="preserve">\n<g filter="brightness(0) saturate(100%) invert(16%) sepia(0%) saturate(1942%) hue-rotate(215deg) brightness(99%) contrast(93%)">\n	<g>\n		<path d="M447.933,103.629c-0.034-3.076-1.224-6.09-3.485-8.352L352.683,3.511c-0.004-0.004-0.007-0.005-0.011-0.008\n			C350.505,1.338,347.511,0,344.206,0H89.278C75.361,0,64.04,11.32,64.04,25.237v461.525c0,13.916,11.32,25.237,25.237,25.237\n			h333.444c13.916,0,25.237-11.32,25.237-25.237V103.753C447.96,103.709,447.937,103.672,447.933,103.629z M356.194,40.931\n			l50.834,50.834h-49.572c-0.695,0-1.262-0.567-1.262-1.262V40.931z M423.983,486.763c0,0.695-0.566,1.261-1.261,1.261H89.278\n			c-0.695,0-1.261-0.566-1.261-1.261V25.237c0-0.695,0.566-1.261,1.261-1.261h242.94v66.527c0,13.916,11.322,25.239,25.239,25.239\n			h66.527V486.763z"/>\n	</g>\n</g>\n<g>\n	<g>\n		<path d="M362.088,164.014H149.912c-6.62,0-11.988,5.367-11.988,11.988c0,6.62,5.368,11.988,11.988,11.988h212.175\n			c6.62,0,11.988-5.368,11.988-11.988C374.076,169.381,368.707,164.014,362.088,164.014z"/>\n	</g>\n</g>\n<g>\n	<g>\n		<path d="M362.088,236.353H149.912c-6.62,0-11.988,5.368-11.988,11.988c0,6.62,5.368,11.988,11.988,11.988h212.175\n			c6.62,0,11.988-5.368,11.988-11.988C374.076,241.721,368.707,236.353,362.088,236.353z"/>\n	</g>\n</g>\n<g>\n	<g>\n		<path d="M362.088,308.691H149.912c-6.62,0-11.988,5.368-11.988,11.988c0,6.621,5.368,11.988,11.988,11.988h212.175\n			c6.62,0,11.988-5.367,11.988-11.988C374.076,314.06,368.707,308.691,362.088,308.691z"/>\n	</g>\n</g>\n<g>\n	<g>\n		<path d="M256,381.031H149.912c-6.62,0-11.988,5.368-11.988,11.988c0,6.621,5.368,11.988,11.988,11.988H256\n			c6.62,0,11.988-5.367,11.988-11.988C267.988,386.398,262.62,381.031,256,381.031z"/>\n	</g>\n</g>\n</svg>', $8e4453fb4fc895c8$var$q = /*#__PURE__*/ function() {
    function q() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, q);
    }
    return $8e4453fb4fc895c8$var$_createClass(q, null, [
        {
            key: "createImage",
            value: function createImage(e, t, i) {
                var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
                var r = new Image();
                return r.src = e.src, !i && s && $8e4453fb4fc895c8$var$j.scrollDownOnImageLoad(r.src, t), $8e4453fb4fc895c8$var$j.processContent("image", r, r.src, e.name);
            }
        },
        {
            key: "createImageMessage",
            value: function createImageMessage(e, t, i, s) {
                var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
                var o = q.createImage(t, e.elementRef, s, r), a = e.createNewMessageElement("", i);
                return a.bubbleElement.appendChild(o), a.bubbleElement.classList.add(q.IMAGE_BUBBLE_CLASS), {
                    type: "image",
                    elements: a
                };
            }
        },
        {
            key: "createAudioElement",
            value: function createAudioElement(e, t) {
                var i = document.createElement("audio");
                return i.src = e.src, i.classList.add("audio-player"), i.controls = !0, $8e4453fb4fc895c8$var$Ct.IS_SAFARI && (i.classList.add("audio-player-safari"), i.classList.add(t === $8e4453fb4fc895c8$var$b.USER_ROLE ? "audio-player-safari-right" : "audio-player-safari-left")), i;
            }
        },
        {
            key: "createNewAudioMessage",
            value: function createNewAudioMessage(e, t, i, s) {
                var r = q.createAudioElement(t, i), o = e.createMessageElementsOnOrientation("", i, s);
                return o.bubbleElement.appendChild(r), o.bubbleElement.classList.add(q.AUDIO_BUBBLE_CLASS), {
                    type: "audio",
                    elements: o
                };
            }
        },
        {
            key: "createAnyFile",
            value: function createAnyFile(e) {
                var t = document.createElement("div");
                t.classList.add("any-file-message-contents");
                var i = document.createElement("div");
                i.classList.add("any-file-message-icon-container");
                var s = $8e4453fb4fc895c8$var$re.createSVGElement($8e4453fb4fc895c8$var$Xo);
                s.classList.add("any-file-message-icon"), i.appendChild(s);
                var r = document.createElement("div");
                return r.classList.add("any-file-message-text"), r.textContent = e.name || $8e4453fb4fc895c8$var$j.DEFAULT_FILE_NAME, t.appendChild(i), t.appendChild(r), $8e4453fb4fc895c8$var$j.processContent("any", t, e.src, r.textContent);
            }
        },
        {
            key: "createNewAnyFileMessage",
            value: function createNewAnyFileMessage(e, t, i, s) {
                var r = e.createMessageElementsOnOrientation("", i, s), o = q.createAnyFile(t);
                return r.bubbleElement.classList.add(q.ANY_FILE_BUBBLE_CLASS), r.bubbleElement.appendChild(o), {
                    type: "file",
                    elements: r
                };
            }
        },
        {
            key: "createMessages",
            value: function createMessages(e, t, i) {
                var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
                return t.map(function(o) {
                    return o.ref && (o = $8e4453fb4fc895c8$var$j.removeFileRef(o)), $8e4453fb4fc895c8$var$j.isAudioFile(o) ? q.createNewAudioMessage(e, o, i, s) : $8e4453fb4fc895c8$var$j.isImageFile(o) ? q.createImageMessage(e, o, i, s, r) : q.createNewAnyFileMessage(e, o, i, s);
                });
            }
        },
        {
            key: "addMessages",
            value: function addMessages(e, t, i, s) {
                q.createMessages(e, t, i, s).forEach(function(_ref28) {
                    var o = _ref28.type, a = _ref28.elements;
                    $8e4453fb4fc895c8$var$j.addMessage(e, a, o, i, s);
                });
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$q.IMAGE_BUBBLE_CLASS = "image-message", $8e4453fb4fc895c8$var$q.AUDIO_BUBBLE_CLASS = "audio-message", $8e4453fb4fc895c8$var$q.ANY_FILE_BUBBLE_CLASS = "any-file-message";
var $8e4453fb4fc895c8$var$ki = $8e4453fb4fc895c8$var$q;
var $8e4453fb4fc895c8$var$ae = /*#__PURE__*/ function() {
    function ae() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, ae);
    }
    return $8e4453fb4fc895c8$var$_createClass(ae, null, [
        {
            key: "removeElements",
            value: function removeElements(e, t) {
                if (!t) return;
                var i = e.findIndex(function(s) {
                    return s === t;
                });
                e.splice(i, 1), t == null || t.outerContainer.remove();
            }
        },
        {
            key: "removeFilesMessages",
            value: function removeFilesMessages(e, t) {
                var i;
                (i = t[1].files) == null || i.forEach(function(s) {
                    ae.removeElements(e.messageElementRefs, s);
                }), delete t[0].files, delete t[1].files;
            }
        },
        {
            key: "removeTextHTMLMessage",
            value: function removeTextHTMLMessage(e, t, i) {
                var s = t[1][i];
                ae.removeElements(e.messageElementRefs, s), delete t[0][i], delete t[1][i];
            }
        },
        {
            key: "updateHTMLMessage",
            value: function updateHTMLMessage(e, t, i) {
                var s, r;
                if (t[1].html) $8e4453fb4fc895c8$var$xe.overwriteElements(e, i, t[1].html);
                else {
                    var o = $8e4453fb4fc895c8$var$xe.create(e, i, t[0].role), a = ((r = t[1].files) == null ? void 0 : r[((s = t[1].files) == null ? void 0 : s.length) - 1]) || t[1].text;
                    e.elementRef.insertBefore(o.outerContainer, a.outerContainer.nextSibling), e.messageElementRefs.splice(e.messageElementRefs.length - 1, 1);
                    var l = e.messageElementRefs.findIndex(function(c) {
                        return c === a;
                    });
                    e.messageElementRefs.splice(l + 1, 0, o), t[1].html = o;
                }
                t[0].html = i;
            }
        },
        {
            key: "updateFileMessages",
            value: function updateFileMessages(e, t, i) {
                var h, f;
                var s = t[0].role, r = $8e4453fb4fc895c8$var$ki.createMessages(e, i, s), o = t[1].html, a = ((f = t[1].files) == null ? void 0 : f[((h = t[1].files) == null ? void 0 : h.length) - 1]) || t[1].text, l = o || a;
                var c = e.messageElementRefs.findIndex(function(u) {
                    return u === l;
                });
                a && (c += 1);
                var d = (o == null ? void 0 : o.outerContainer) || (a == null ? void 0 : a.outerContainer.nextSibling);
                r.forEach(function(_ref29, p) {
                    var u = _ref29.type, m = _ref29.elements;
                    $8e4453fb4fc895c8$var$j.setElementProps(e, m, u, s), e.elementRef.insertBefore(m.outerContainer, d), e.messageElementRefs.splice(e.messageElementRefs.length - 1, 1), e.messageElementRefs.splice(c + p, 0, m);
                }), ae.removeFilesMessages(e, t), t[1].files = r.map(function(_ref30) {
                    var u = _ref30.elements;
                    return u;
                }), t[0].files = i;
            }
        },
        {
            key: "updateTextMessage",
            value: function updateTextMessage(e, t, i) {
                var s;
                if (t[1].text) e.renderText(t[1].text.bubbleElement, i);
                else {
                    var r = e.createElements(i, t[0].role), o = ((s = t[1].files) == null ? void 0 : s[0]) || t[1].html;
                    e.elementRef.insertBefore(r.outerContainer, o.outerContainer);
                    var a = e.messageElementRefs.findIndex(function(l) {
                        return l === o;
                    });
                    e.messageElementRefs.splice(a, 0, r), t[1].text = r;
                }
                t[0].text = i;
            }
        },
        {
            key: "isElementActive",
            value: function isElementActive(e) {
                var t, i;
                return $8e4453fb4fc895c8$var$he.isActiveElement((t = e.text) == null ? void 0 : t.bubbleElement.classList) || $8e4453fb4fc895c8$var$he.isActiveElement((i = e.html) == null ? void 0 : i.bubbleElement.classList);
            }
        },
        {
            key: "update",
            value: function update(e, t, i) {
                var s = e.messageToElements[i];
                if (s) {
                    if (ae.isElementActive(s[1])) return console.error("Cannot update a message that is being streamed");
                    t.text && ae.updateTextMessage(e, s, t.text), t.html && ae.updateHTMLMessage(e, s, t.html), t.files ? ae.updateFileMessages(e, s, t.files) : ae.removeFilesMessages(e, s), !t.text && s[1].text && ae.removeTextHTMLMessage(e, s, "text"), !t.html && s[1].html && ae.removeTextHTMLMessage(e, s, "html");
                } else console.error("Message index not found. Please use the `getMessages` method to find the correct index");
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Yo = /*#__PURE__*/ function() {
    function Yo() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Yo);
    }
    return $8e4453fb4fc895c8$var$_createClass(Yo, null, [
        {
            key: "getText",
            value: function getText(e, t) {
                var i;
                if (!e.directConnection && !e.connect && !e.webModel && !e.demo) return "Connect to any API using the [connect](https://deepchat.dev/docs/connect#connect-1) property or a popular service via [directConnection](https://deepchat.dev/docs/directConnection/#directConnection).\n Host AI entirely on your browser via a [webModel](https://deepchat.dev/docs/webModel).\n To get started checkout the [Start](https://deepchat.dev/start) page and live code [examples](https://deepchat.dev/examples/frameworks).\n To remove this message set the [demo](https://deepchat.dev/docs/demo#demo) property to true.";
                if (e.directConnection) {
                    if (!t.isDirectConnection()) return "Please define a valid service inside\n          the [directConnection](https://deepchat.dev/docs/directConnection/#directConnection) object.";
                    var s = (i = e.directConnection.openAI) == null ? void 0 : i.chat;
                    if ($8e4453fb4fc895c8$var$_typeof(s) == "object" && s.tools && !s.function_handler) return "Please define the `function_handler` property inside the openAI [chat](https://deepchat.dev/docs/directConnection/openAI#Chat) object.";
                } else if (e.connect && !e.connect.url && !e.connect.handler) return e.demo ? e.connect.stream ? null : "When [demo](https://deepchat.dev/docs/demo) mode is enabled - the [connect](https://deepchat.dev/docs/connect#connect-1) object can only accept the [stream](https://deepchat.dev/docs/connect#Stream) property." : "Please define a `url` or a `handler` property inside the [connect](https://deepchat.dev/docs/connect#connect-1) object.";
                return null;
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$he = /*#__PURE__*/ function(_Be) {
    function he(e, t, i) {
        var _this52;
        $8e4453fb4fc895c8$var$_classCallCheck(this, he);
        var a, l;
        _this52 = $8e4453fb4fc895c8$var$_callSuper(this, he, [
            e
        ]);
        var s = t.permittedErrorPrefixes, r = t.introPanelMarkUp, o = t.demo;
        _this52._errorMessageOverrides = (a = e.errorMessages) == null ? void 0 : a.overrides, _this52._onClearMessages = $8e4453fb4fc895c8$var$gi.onClearMessages.bind(_this52, e), _this52._onError = $8e4453fb4fc895c8$var$gi.onError.bind(_this52, e), _this52._displayLoadingMessage = he.getDisplayLoadingMessage(e, t), _this52._permittedErrorPrefixes = s, _this52.addSetupMessageIfNeeded(e, t) || _this52.populateIntroPanel(i, r, e.introPanelStyle), _this52.addIntroductoryMessages(e, t), new $8e4453fb4fc895c8$var$$t(e, _this52, t), _this52._displayServiceErrorMessages = (l = e.errorMessages) == null ? void 0 : l.displayServiceErrorMessages, e.getMessages = function() {
            return JSON.parse(JSON.stringify(_this52.messageToElements.map(function(_ref31) {
                var _ref32 = $8e4453fb4fc895c8$var$_slicedToArray(_ref31, 1), c = _ref32[0];
                return c;
            })));
        }, e.clearMessages = _this52.clearMessages.bind(_this52, t), e.refreshMessages = _this52.refreshTextMessages.bind(_this52, e.remarkable), e.scrollToBottom = $8e4453fb4fc895c8$var$X.scrollToBottom.bind(_this52, _this52.elementRef), e.addMessage = function(c, d) {
            _this52.addAnyMessage($8e4453fb4fc895c8$var$_objectSpread($8e4453fb4fc895c8$var$_objectSpread({}, c), {}, {
                sendUpdate: !!d
            }), !d);
        }, e.updateMessage = function(c, d) {
            return $8e4453fb4fc895c8$var$ae.update(_this52, c, d);
        }, t.isWebModel() && t.setUpMessages(_this52), o && _this52.prepareDemo($8e4453fb4fc895c8$var$Y.processDemo(o)), e.textToSpeech && $8e4453fb4fc895c8$var$xt.processConfig(e.textToSpeech, function(c) {
            _this52.textToSpeech = c;
        });
        return _this52;
    }
    $8e4453fb4fc895c8$var$_inherits(he, _Be);
    return $8e4453fb4fc895c8$var$_createClass(he, [
        {
            key: "prepareDemo",
            value: function prepareDemo(e) {
                var t;
                if ($8e4453fb4fc895c8$var$_typeof(e) == "object") {
                    if (e.displayLoading) {
                        var _i12 = e.displayLoading.history;
                        _i12 != null && _i12.small && $8e4453fb4fc895c8$var$De.addMessage(this, !1), _i12 != null && _i12.full && $8e4453fb4fc895c8$var$De.addMessage(this);
                    }
                    e.displayErrors && (e.displayErrors["default"] && this.addNewErrorMessage("", ""), e.displayErrors.service && this.addNewErrorMessage("service", ""), e.displayErrors.speechToText && this.addNewErrorMessage("speechToText", "")), (t = e.displayLoading) != null && t.message && this.addLoadingMessage(), e.response && (this.customDemoResponse = e.response);
                }
            }
        },
        {
            key: "addSetupMessageIfNeeded",
            value: function addSetupMessageIfNeeded(e, t) {
                var i = $8e4453fb4fc895c8$var$Yo.getText(e, t);
                if (i) {
                    var s = this.createAndAppendNewMessageElement(i, $8e4453fb4fc895c8$var$b.AI_ROLE);
                    this.applyCustomStyles(s, $8e4453fb4fc895c8$var$b.AI_ROLE, !1);
                }
                return !!i;
            }
        },
        {
            key: "addIntroductoryMessages",
            value: function addIntroductoryMessages(e, t) {
                var _i13, _this53 = this;
                e != null && e.shadowRoot && (this._introMessage = e.introMessage);
                var i = this._introMessage;
                t != null && t.isWebModel() && ((_i13 = i) !== null && _i13 !== void 0 ? _i13 : i = t.getIntroMessage(i)), i && (Array.isArray(i) ? i.forEach(function(s, r) {
                    r !== 0 && $8e4453fb4fc895c8$var$b.hideRoleElements(_this53.messageElementRefs, !!_this53._avatars, !!_this53._names), _this53.addIntroductoryMessage(s);
                }) : this.addIntroductoryMessage(i));
            }
        },
        {
            key: "addIntroductoryMessage",
            value: function addIntroductoryMessage(e) {
                var i;
                var t;
                e != null && e.text ? t = this.createAndAppendNewMessageElement(e.text, $8e4453fb4fc895c8$var$b.AI_ROLE) : e != null && e.html && (t = $8e4453fb4fc895c8$var$xe.add(this, e.html, $8e4453fb4fc895c8$var$b.AI_ROLE, this.messageElementRefs)), t && (this.applyCustomStyles(t, $8e4453fb4fc895c8$var$b.AI_ROLE, !1, (i = this.messageStyles) == null ? void 0 : i.intro), t.outerContainer.classList.add($8e4453fb4fc895c8$var$Be.INTRO_CLASS));
            }
        },
        {
            key: "removeIntroductoryMessage",
            value: function removeIntroductoryMessage() {
                var e = this.messageElementRefs[0];
                e.outerContainer.classList.contains($8e4453fb4fc895c8$var$Be.INTRO_CLASS) && (e.outerContainer.remove(), this.messageElementRefs.shift());
            }
        },
        {
            key: "addAnyMessage",
            value: function addAnyMessage(e) {
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                return e.error ? this.addNewErrorMessage("service", e.error) : this.addNewMessage(e, t, i);
            }
        },
        {
            key: "addNewMessage",
            value: function addNewMessage(e) {
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                var s = he.createMessageContent(e), r = {
                    status: e.overwrite
                };
                if (!e.ignoreText && s.text !== void 0 && e.text !== null && (this.addNewTextMessage(s.text, s.role, r, i), !t && this.textToSpeech && s.role !== $8e4453fb4fc895c8$var$b.USER_ROLE && $8e4453fb4fc895c8$var$xt.speak(s.text, this.textToSpeech)), s.files && Array.isArray(s.files) && $8e4453fb4fc895c8$var$ki.addMessages(this, s.files, s.role, i), s.html !== void 0 && s.html !== null) {
                    var o = $8e4453fb4fc895c8$var$xe.add(this, s.html, s.role, this.messageElementRefs, r, i);
                    $8e4453fb4fc895c8$var$Ne.isElementTemporary(o) && delete s.html;
                }
                return this.isValidMessageContent(s) && !i && this.updateStateOnMessage(s, e.overwrite, e.sendUpdate, t), s;
            }
        },
        {
            key: "isValidMessageContent",
            value: function isValidMessageContent(e) {
                return e.text || e.html || e.files && e.files.length > 0;
            }
        },
        {
            key: "updateStateOnMessage",
            value: function updateStateOnMessage(e, t) {
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
                var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                if (!t) {
                    var r = $8e4453fb4fc895c8$var$b.generateMessageBody(e, this.messageElementRefs);
                    this.messageToElements.push([
                        e,
                        r
                    ]);
                }
                i && this.sendClientUpdate(e, s);
            }
        },
        {
            key: "removeMessageOnError",
            value: function removeMessageOnError() {
                var e = this.messageElementRefs[this.messageElementRefs.length - 1], t = e == null ? void 0 : e.bubbleElement;
                (t != null && t.classList.contains($8e4453fb4fc895c8$var$we.MESSAGE_CLASS) && t.textContent === "" || he.isTemporaryElement(e)) && this.removeLastMessage();
            }
        },
        {
            key: "addNewErrorMessage",
            value: function addNewErrorMessage(e, t) {
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                var c, d, h, f, u;
                this.removeMessageOnError();
                var s = this.getPermittedMessage(t) || ((c = this._errorMessageOverrides) == null ? void 0 : c[e]) || ((d = this._errorMessageOverrides) == null ? void 0 : d["default"]) || "Error, please try again.", r = this.createMessageElementsOnOrientation(s, "error", i);
                $8e4453fb4fc895c8$var$b.hideRoleElements(this.messageElementRefs, !!this._avatars, !!this._names);
                var o = r.bubbleElement, a = r.outerContainer;
                o.classList.add("error-message-text"), this.renderText(o, s);
                var l = $8e4453fb4fc895c8$var$z.extractParticularSharedStyles([
                    "fontSize",
                    "fontFamily"
                ], (h = this.messageStyles) == null ? void 0 : h["default"]);
                $8e4453fb4fc895c8$var$z.applyCustomStylesToElements(r, !1, l), $8e4453fb4fc895c8$var$z.applyCustomStylesToElements(r, !1, (f = this.messageStyles) == null ? void 0 : f.error), i || this.elementRef.appendChild(a), this.textToSpeech && $8e4453fb4fc895c8$var$xt.speak(s, this.textToSpeech), (u = this._onError) == null || u.call(this, s);
            }
        },
        {
            key: "getPermittedMessage",
            value: function getPermittedMessage(e) {
                if (e) {
                    var t = he.extractErrorMessages(e);
                    for(var _i14 = 0; _i14 < t.length; _i14 += 1){
                        var s = t[_i14];
                        if (typeof s == "string") {
                            if (this._displayServiceErrorMessages) return s;
                            if (this._permittedErrorPrefixes) {
                                var r = he.checkPermittedErrorPrefixes(this._permittedErrorPrefixes, s);
                                if (r) return r;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "removeError",
            value: function removeError() {
                this.isLastMessageError() && $8e4453fb4fc895c8$var$b.getLastMessageElement(this.elementRef).remove();
            }
        },
        {
            key: "addDefaultLoadingMessage",
            value: function addDefaultLoadingMessage() {
                var e = this.createMessageElements("", $8e4453fb4fc895c8$var$b.AI_ROLE), t = e.bubbleElement;
                e.bubbleElement.classList.add($8e4453fb4fc895c8$var$Oe.DOTS_CONTAINER_CLASS);
                var i = document.createElement("div");
                return i.classList.add("loading-message-dots"), t.appendChild(i), $8e4453fb4fc895c8$var$Oe.setDots(t, this.messageStyles), e;
            }
        },
        {
            key: "addLoadingMessage",
            value: function addLoadingMessage() {
                var i, s, r, o, a, l;
                if (!this._displayLoadingMessage) return;
                var e = (r = (s = (i = this.messageStyles) == null ? void 0 : i.loading) == null ? void 0 : s.message) == null ? void 0 : r.html, t = e ? $8e4453fb4fc895c8$var$xe.createElements(this, e, $8e4453fb4fc895c8$var$b.AI_ROLE, !1) : this.addDefaultLoadingMessage();
                this.elementRef.appendChild(t.outerContainer), t.bubbleElement.classList.add($8e4453fb4fc895c8$var$Oe.BUBBLE_CLASS), this.applyCustomStyles(t, $8e4453fb4fc895c8$var$b.AI_ROLE, !1, (l = (a = (o = this.messageStyles) == null ? void 0 : o.loading) == null ? void 0 : a.message) == null ? void 0 : l.styles), $8e4453fb4fc895c8$var$X.scrollToBottom(this.elementRef);
            }
        },
        {
            key: "populateIntroPanel",
            value: function populateIntroPanel(e, t, i) {
                (e || t) && (this._introPanel = new $8e4453fb4fc895c8$var$Ti(e, t, i), this._introPanel._elementRef && ($8e4453fb4fc895c8$var$ne.apply(this, this._introPanel._elementRef), this.elementRef.appendChild(this._introPanel._elementRef)));
            }
        },
        {
            key: "addMultipleFiles",
            value: function() {
                var _addMultipleFiles = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee111(e) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee111$(_context111) {
                        while(true)switch(_context111.prev = _context111.next){
                            case 0:
                                return _context111.abrupt("return", Promise.all((e || []).map(function(t) {
                                    return new Promise(function(i) {
                                        if (!t.type || t.type === "any") {
                                            var s = t.file.name || $8e4453fb4fc895c8$var$j.DEFAULT_FILE_NAME;
                                            i({
                                                name: s,
                                                type: "any",
                                                ref: t.file
                                            });
                                        } else {
                                            var _s3 = new FileReader();
                                            _s3.readAsDataURL(t.file), _s3.onload = function() {
                                                i({
                                                    src: _s3.result,
                                                    type: t.type,
                                                    ref: t.file
                                                });
                                            };
                                        }
                                    });
                                })));
                            case 1:
                            case "end":
                                return _context111.stop();
                        }
                    }, _callee111);
                }));
                function addMultipleFiles(_x202) {
                    return _addMultipleFiles.apply(this, arguments);
                }
                return addMultipleFiles;
            }()
        },
        {
            key: "clearMessages",
            value: // WORK - update all message classes to use deep-chat prefix
            function clearMessages(e, t) {
                var _this$messageToElemen;
                var r, o;
                var i = [];
                this.messageElementRefs.forEach(function(a) {
                    he.isActiveElement(a.bubbleElement.classList) ? i.push(a) : a.outerContainer.remove();
                }), Array.from(this.elementRef.children).forEach(function(a) {
                    var c;
                    var l = (c = a.children[0]) == null ? void 0 : c.children[0];
                    l != null && l.classList.contains("error-message-text") && a.remove();
                }), this.messageElementRefs = i;
                var s = this.messageToElements.filter(function(a) {
                    return a[1].text && he.isActiveElement(a[1].text.bubbleElement.classList) || a[1].html && he.isActiveElement(a[1].html.bubbleElement.classList);
                });
                (_this$messageToElemen = this.messageToElements).splice.apply(_this$messageToElemen, [
                    0,
                    this.messageToElements.length
                ].concat($8e4453fb4fc895c8$var$_toConsumableArray(s))), t !== !1 && ((r = this._introPanel) != null && r._elementRef && this._introPanel.display(), this.addIntroductoryMessages()), (o = this._onClearMessages) == null || o.call(this), delete e.sessionId;
            }
        }
    ], [
        {
            key: "getDisplayLoadingMessage",
            value: function getDisplayLoadingMessage(e, t) {
                var _e$displayLoadingBubb;
                return t.websocket ? !1 : (_e$displayLoadingBubb = e.displayLoadingBubble) !== null && _e$displayLoadingBubb !== void 0 ? _e$displayLoadingBubb : !0;
            }
        },
        {
            key: "checkPermittedErrorPrefixes",
            value: function checkPermittedErrorPrefixes(e, t) {
                for(var _i15 = 0; _i15 < e.length; _i15 += 1)if (t.startsWith(e[_i15])) return t;
            }
        },
        {
            key: "extractErrorMessages",
            value: function extractErrorMessages(e) {
                return Array.isArray(e) ? e : e instanceof Error ? [
                    e.message
                ] : typeof e == "string" ? [
                    e
                ] : $8e4453fb4fc895c8$var$_typeof(e) == "object" && e.error ? [
                    e.error
                ] : [];
            }
        },
        {
            key: "isActiveElement",
            value: function isActiveElement(e) {
                return e ? e.contains($8e4453fb4fc895c8$var$Oe.BUBBLE_CLASS) || e.contains($8e4453fb4fc895c8$var$De.CLASS) || e.contains($8e4453fb4fc895c8$var$we.MESSAGE_CLASS) : !1;
            }
        }
    ]);
}($8e4453fb4fc895c8$var$Be);
var $8e4453fb4fc895c8$var$B = /*#__PURE__*/ function() {
    function B() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, B);
    }
    return $8e4453fb4fc895c8$var$_createClass(B, null, [
        {
            key: "adjustInputPadding",
            value: function adjustInputPadding(e, t) {
                t["inside-left"].length > 0 && e.classList.add("text-input-inner-left-adjustment"), t["inside-right"].length > 0 && e.classList.add("text-input-inner-right-adjustment");
            }
        },
        {
            key: "adjustForOutsideButton",
            value: function adjustForOutsideButton(e, t, i) {
                i["outside-right"].length === 0 && i["outside-left"].length > 0 ? (e[0].classList.add(B.INPUT_OUTSIDE_LEFT_SMALL_ADJUSTMENT_CLASS), t.classList.add(B.INPUT_OUTSIDE_LEFT_SMALL_ADJUSTMENT_CLASS)) : i["outside-left"].length === 0 && i["outside-right"].length > 0 && (e[3].classList.add(B.INPUT_OUTSIDE_RIGHT_SMALL_ADJUSTMENT_CLASS), t.classList.add(B.INPUT_OUTSIDE_RIGHT_SMALL_ADJUSTMENT_CLASS));
            }
        },
        {
            key: "adjustOutsideSubmit",
            value: function adjustOutsideSubmit(e, t, i) {
                if (!(i["inside-left"].length > 0 || i["inside-right"].length > 0)) {
                    if (i["outside-right"].length === 0 && i["outside-left"].length > 0) return e[0].classList.add(B.INPUT_OUTSIDE_LEFT_ADJUSTMENT_CLASS), t.classList.add(B.INPUT_OUTSIDE_LEFT_ADJUSTMENT_CLASS), i["outside-left"].map(function(s) {
                        return s.button.elementRef.classList.add("submit-button-enlarged");
                    });
                    if (i["outside-left"].length === 0 && i["outside-right"].length > 0) return e[3].classList.add(B.INPUT_OUTSIDE_RIGHT_ADJUSTMENT_CLASS), t.classList.add(B.INPUT_OUTSIDE_RIGHT_ADJUSTMENT_CLASS), i["outside-right"].map(function(s) {
                        return s.button.elementRef.classList.add("submit-button-enlarged");
                    });
                }
            }
        },
        {
            key: "set",
            value: function set(e, t, i, s) {
                !!B.adjustOutsideSubmit(t, i, s) || B.adjustForOutsideButton(t, i, s), B.adjustInputPadding(e, s);
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$B.INPUT_OUTSIDE_LEFT_ADJUSTMENT_CLASS = "text-input-container-left-adjustment", $8e4453fb4fc895c8$var$B.INPUT_OUTSIDE_RIGHT_ADJUSTMENT_CLASS = "text-input-container-right-adjustment", $8e4453fb4fc895c8$var$B.INPUT_OUTSIDE_LEFT_SMALL_ADJUSTMENT_CLASS = "text-input-container-left-small-adjustment", $8e4453fb4fc895c8$var$B.INPUT_OUTSIDE_RIGHT_SMALL_ADJUSTMENT_CLASS = "text-input-container-right-small-adjustment";
var $8e4453fb4fc895c8$var$Cs = $8e4453fb4fc895c8$var$B;
var $8e4453fb4fc895c8$var$kt = /*#__PURE__*/ function() {
    function kt() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, kt);
    }
    return $8e4453fb4fc895c8$var$_createClass(kt, null, [
        {
            key: "create",
            value: function create() {
                return Array.from({
                    length: 4
                }).map(function(e, t) {
                    var i = document.createElement("div");
                    return i.classList.add("input-button-container"), (t === 0 || t === 3) && i.classList.add("outer-button-container"), (t === 1 || t === 2) && i.classList.add("inner-button-container"), i;
                });
            }
        },
        {
            key: "add",
            value: function add(e, t) {
                e.insertBefore(t[1], e.firstChild), e.insertBefore(t[0], e.firstChild), e.appendChild(t[2]), e.appendChild(t[3]);
            }
        },
        {
            key: "getContainerIndex",
            value: function getContainerIndex(e) {
                return e === "outside-left" ? 0 : e === "inside-left" ? 1 : e === "inside-right" ? 2 : 3;
            }
        },
        {
            key: "addButton",
            value: function addButton(e, t, i) {
                t.classList.add(i);
                var s = kt.getContainerIndex(i);
                e[s].appendChild(t), s === 3 && t.classList.add("outside-right");
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$sn = [
    "camera",
    "gifs",
    "images",
    "audio",
    "mixedFiles",
    "submit",
    "microphone"
];
var $8e4453fb4fc895c8$var$J = /*#__PURE__*/ function() {
    function J() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, J);
    }
    return $8e4453fb4fc895c8$var$_createClass(J, null, [
        {
            key: "createTextElement",
            value: function createTextElement(e) {
                var t = document.createElement("div");
                return t.classList.add("text-button"), t.innerText = e, t;
            }
        },
        {
            key: "createElement",
            value: function createElement(e, t) {
                return t ? J.createTextElement(e) : $8e4453fb4fc895c8$var$re.createSVGElement(e);
            }
        },
        {
            key: "createCustomElement",
            value: function createCustomElement(e, t) {
                var s, r, o, a;
                var i = t == null ? void 0 : t[e];
                if ((s = i == null ? void 0 : i.svg) != null && s.content) return J.createElement((r = i == null ? void 0 : i.svg) == null ? void 0 : r.content, !1);
                if ((o = i == null ? void 0 : i.text) != null && o.content) return J.createElement((a = i == null ? void 0 : i.text) == null ? void 0 : a.content, !0);
            }
        },
        {
            key: "processElement",
            value: function processElement(e, t) {
                t != null && t.classList.contains("text-button") || e.classList.add("input-button-svg");
            }
        },
        {
            key: "createSpecificStateElement",
            value: function createSpecificStateElement(e, t, i) {
                var s;
                return i && (s = J.createCustomElement(t, i)), J.processElement(e, s), s;
            }
        },
        {
            key: "createInnerElement",
            value: function createInnerElement(e, t, i, s) {
                var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
                var o, a;
                return r && !((a = (o = s == null ? void 0 : s[i]) == null ? void 0 : o.svg) != null && a.content) ? t : J.createSpecificStateElement(e, i, s) || t;
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Qo = '<?xml version="1.0" encoding="utf-8"?>\n<svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">\n    <path d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM23 15h-6v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v6h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h6v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6h6c0.552 0 1-0.448 1-1s-0.448-1-1-1z"></path>\n</svg>';
var $8e4453fb4fc895c8$var$ye = /*#__PURE__*/ function() {
    function ye() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, ye);
    }
    return $8e4453fb4fc895c8$var$_createClass(ye, null, [
        {
            key: "unsetAllCSS",
            value: function unsetAllCSS(e, t) {
                var i, s;
                t.container && $8e4453fb4fc895c8$var$R.unsetAllCSSMouseStates(e, t.container), (i = t.svg) != null && i.styles && $8e4453fb4fc895c8$var$R.unsetAllCSSMouseStates(e.children[0], t.svg.styles), (s = t.text) != null && s.styles && $8e4453fb4fc895c8$var$R.unsetAllCSSMouseStates(e.children[0], t.text.styles);
            }
        },
        {
            key: "unsetActionCSS",
            value: function unsetActionCSS(e, t) {
                var i, s;
                t.container && $8e4453fb4fc895c8$var$R.unsetActivityCSSMouseStates(e, t.container), (i = t.svg) != null && i.styles && $8e4453fb4fc895c8$var$R.unsetActivityCSSMouseStates(e.children[0], t.svg.styles), (s = t.text) != null && s.styles && $8e4453fb4fc895c8$var$R.unsetActivityCSSMouseStates(e.children[0], t.text.styles);
            }
        },
        {
            key: "setElementsCSS",
            value: function setElementsCSS(e, t, i) {
                var s, r, o, a, l;
                Object.assign(e.style, (s = t.container) == null ? void 0 : s[i]), Object.assign(e.children[0].style, (o = (r = t.svg) == null ? void 0 : r.styles) == null ? void 0 : o[i]), Object.assign(e.children[0].style, (l = (a = t.text) == null ? void 0 : a.styles) == null ? void 0 : l[i]);
            }
        },
        {
            key: "setElementCssUpToState",
            value: function setElementCssUpToState(e, t, i) {
                ye.setElementsCSS(e, t, "default"), i !== "default" && (ye.setElementsCSS(e, t, "hover"), i !== "hover" && ye.setElementsCSS(e, t, "click"));
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$ii = /*#__PURE__*/ function() {
    function ii(e, t, i, s) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, ii);
        this._mouseState = {
            state: "default"
        }, this.elementRef = e, this._customStyles = i, this.position = t, this.dropupText = s;
    }
    return $8e4453fb4fc895c8$var$_createClass(ii, [
        {
            key: "buttonMouseLeave",
            value: function buttonMouseLeave(e) {
                this._mouseState.state = "default", e && ($8e4453fb4fc895c8$var$ye.unsetAllCSS(this.elementRef, e), $8e4453fb4fc895c8$var$ye.setElementsCSS(this.elementRef, e, "default"));
            }
        },
        {
            key: "buttonMouseEnter",
            value: function buttonMouseEnter(e) {
                this._mouseState.state = "hover", e && $8e4453fb4fc895c8$var$ye.setElementsCSS(this.elementRef, e, "hover");
            }
        },
        {
            key: "buttonMouseUp",
            value: function buttonMouseUp(e) {
                e && $8e4453fb4fc895c8$var$ye.unsetActionCSS(this.elementRef, e), this.buttonMouseEnter(e);
            }
        },
        {
            key: "buttonMouseDown",
            value: function buttonMouseDown(e) {
                this._mouseState.state = "click", e && $8e4453fb4fc895c8$var$ye.setElementsCSS(this.elementRef, e, "click");
            }
        },
        {
            key: "setEvents",
            value: function setEvents(e) {
                this.elementRef.onmousedown = this.buttonMouseDown.bind(this, e), this.elementRef.onmouseup = this.buttonMouseUp.bind(this, e), this.elementRef.onmouseenter = this.buttonMouseEnter.bind(this, e), this.elementRef.onmouseleave = this.buttonMouseLeave.bind(this, e);
            }
        },
        {
            key: "unsetCustomStateStyles",
            value: function unsetCustomStateStyles(e) {
                if (this._customStyles) for(var t = 0; t < e.length; t += 1){
                    var _i16 = e[t], s = _i16 && this._customStyles[_i16];
                    s && $8e4453fb4fc895c8$var$ye.unsetActionCSS(this.elementRef, s);
                }
            }
        },
        {
            key: "reapplyStateStyle",
            value: function reapplyStateStyle(e, t) {
                if (!this._customStyles) return;
                t && this.unsetCustomStateStyles(t);
                var i = this._customStyles[e];
                i && $8e4453fb4fc895c8$var$ye.setElementCssUpToState(this.elementRef, i, this._mouseState.state), this.setEvents(i);
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Kt = /*#__PURE__*/ function() {
    function Kt() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Kt);
    }
    return $8e4453fb4fc895c8$var$_createClass(Kt, null, [
        {
            key: "focusItemWhenOnEdge",
            value: function focusItemWhenOnEdge(e, t) {
                var i = t ? e.children[0] : e.children[e.children.length - 1];
                Kt.focusSiblingItem(i, e, t, !0);
            }
        },
        {
            key: "focusSiblingItem",
            value: function focusSiblingItem(e, t, i) {
                var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                var r = s ? e : e[i ? "nextSibling" : "previousSibling"];
                r ? (e.dispatchEvent(new MouseEvent("mouseleave")), r.dispatchEvent(new MouseEvent("mouseenter"))) : (e.dispatchEvent(new MouseEvent("mouseleave")), Kt.focusItemWhenOnEdge(t, i));
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$$e = /*#__PURE__*/ function() {
    function $e() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, $e);
    }
    return $8e4453fb4fc895c8$var$_createClass($e, null, [
        {
            key: "addItemEvents",
            value: function addItemEvents(e, t, i, s) {
                $8e4453fb4fc895c8$var$et.add(t, s), t.addEventListener("click", function() {
                    i.click();
                }), t.addEventListener("mouseenter", function(r) {
                    e.highlightedItem = r.target;
                }), t.addEventListener("mouseleave", function() {
                    e.highlightedItem = void 0;
                });
            }
        },
        {
            key: "createItemText",
            value: function createItemText(e, t) {
                var i = document.createElement("div");
                return Object.assign(i.style, t), i.classList.add("dropup-menu-item-text"), i.textContent = e || "File", i;
            }
        },
        {
            key: "createItemIcon",
            value: function createItemIcon(e, t) {
                var i = document.createElement("div");
                return Object.assign(i.style, t), i.classList.add("dropup-menu-item-icon"), i.appendChild(e.children[0]), i;
            }
        },
        {
            key: "populateItem",
            value: function populateItem(e, t, i, s) {
                var r = e.children[0];
                r.classList.contains("text-button") ? t.appendChild($e.createItemText(r.textContent, s == null ? void 0 : s.text)) : (t.appendChild($e.createItemIcon(e, s == null ? void 0 : s.iconContainer)), t.appendChild($e.createItemText(i, s == null ? void 0 : s.text)));
            }
        },
        {
            key: "createItem",
            value: function createItem(e, t, i) {
                var l;
                var s = t.elementRef, r = t.dropupText, o = document.createElement("div");
                Object.assign(o.style, (l = i == null ? void 0 : i.item) == null ? void 0 : l["default"]), $e.populateItem(s, o, r, i), o.classList.add("dropup-menu-item");
                var a = $8e4453fb4fc895c8$var$R.processStateful((i == null ? void 0 : i.item) || {}, {
                    backgroundColor: "#f3f3f3"
                }, {
                    backgroundColor: "#ebebeb"
                });
                return $e.addItemEvents(e, o, s, a), o;
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Ns = /*#__PURE__*/ function() {
    function Ns(e, t) {
        var _this54 = this;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ns);
        var i;
        this._isOpen = !0, this._styles = t, this.elementRef = Ns.createElement((i = this._styles) == null ? void 0 : i.container), this.close(), setTimeout(function() {
            return _this54.addWindowEvents(e);
        });
    }
    return $8e4453fb4fc895c8$var$_createClass(Ns, [
        {
            key: "open",
            value: function open() {
                this.elementRef.style.display = "block", this._isOpen = !0;
            }
        },
        {
            key: "close",
            value: function close() {
                this._isOpen && (this.elementRef.style.display = "none", this._isOpen = !1);
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                this._isOpen ? this.close() : this.open();
            }
        },
        {
            key: "addItem",
            value: function addItem(e) {
                var t = $8e4453fb4fc895c8$var$$e.createItem(this, e, this._styles);
                this.elementRef.appendChild(t);
            }
        },
        {
            key: "addWindowEvents",
            value: function addWindowEvents(e) {
                this.clickEvent = this.windowClick.bind(this, e), window.addEventListener("click", this.clickEvent), this.keyDownEvent = this.windowKeyDown.bind(this, e), window.addEventListener("keydown", this.keyDownEvent);
            }
        },
        {
            key: "windowClick",
            value: function windowClick(e, t) {
                var i;
                !e.isConnected && this.clickEvent ? window.removeEventListener("click", this.clickEvent) : e.parentElement !== ((i = t.target.shadowRoot) == null ? void 0 : i.children[0]) && this.close();
            }
        },
        {
            key: "windowKeyDown",
            value: function windowKeyDown(e, t) {
                var i, s, r;
                !e.isConnected && this.keyDownEvent ? window.removeEventListener("keydown", this.keyDownEvent) : this._isOpen && (t.key === $8e4453fb4fc895c8$var$D.ESCAPE ? (this.close(), (i = this.highlightedItem) == null || i.dispatchEvent(new MouseEvent("mouseleave"))) : t.key === $8e4453fb4fc895c8$var$D.ENTER ? ((s = this.highlightedItem) == null || s.click(), (r = this.highlightedItem) == null || r.dispatchEvent(new MouseEvent("mouseleave"))) : t.key === $8e4453fb4fc895c8$var$D.ARROW_DOWN ? $8e4453fb4fc895c8$var$Kt.focusSiblingItem(this.highlightedItem || this.elementRef.children[this.elementRef.children.length - 1], this.elementRef, !0) : t.key === $8e4453fb4fc895c8$var$D.ARROW_UP && $8e4453fb4fc895c8$var$Kt.focusSiblingItem(this.highlightedItem || this.elementRef.children[0], this.elementRef, !1));
            }
        }
    ], [
        {
            key: "createElement",
            value: function createElement(e) {
                var t = document.createElement("div");
                return t.id = "dropup-menu", Object.assign(t.style, e), t;
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$wt = /*#__PURE__*/ function(_ii) {
    function wt(e, t) {
        var _this55;
        $8e4453fb4fc895c8$var$_classCallCheck(this, wt);
        var s;
        _this55 = $8e4453fb4fc895c8$var$_callSuper(this, wt, [
            wt.createButtonElement(),
            void 0,
            {
                styles: (s = t == null ? void 0 : t.button) == null ? void 0 : s.styles
            }
        ]);
        var i = _this55.createInnerElements(_this55._customStyles);
        _this55._menu = new $8e4453fb4fc895c8$var$Ns(e, t == null ? void 0 : t.menu), _this55.addClickEvent(), _this55.buttonContainer = wt.createButtonContainer(), _this55.elementRef.appendChild(i.styles), _this55.buttonContainer.appendChild(_this55.elementRef), _this55.elementRef.classList.add("dropup-icon", "upload-file-button"), _this55.elementRef.children[0].id = "dropup-icon", _this55.buttonContainer.appendChild(_this55._menu.elementRef), _this55.reapplyStateStyle("styles"), _this55.addContainerEvents(e);
        return _this55;
    }
    $8e4453fb4fc895c8$var$_inherits(wt, _ii);
    return $8e4453fb4fc895c8$var$_createClass(wt, [
        {
            key: "createInnerElements",
            value: function createInnerElements(e) {
                return {
                    styles: this.createInnerElement(wt.createSVGIconElement(), "styles", e)
                };
            }
        },
        {
            key: "createInnerElement",
            value: function createInnerElement(e, t, i) {
                return $8e4453fb4fc895c8$var$J.createSpecificStateElement(this.elementRef, t, i) || e;
            }
        },
        {
            key: "addClickEvent",
            value: function addClickEvent() {
                this.elementRef.onclick = this._menu.toggle.bind(this._menu);
            }
        },
        {
            key: "addItem",
            value: function addItem(e) {
                this._menu.addItem(e);
            }
        },
        {
            key: "addContainerEvents",
            value: function addContainerEvents(e) {
                var _this56 = this;
                e.addEventListener("click", function(t) {
                    t.target.classList.contains("dropup-icon") || _this56._menu.close();
                });
            }
        }
    ], [
        {
            key: "createButtonElement",
            value: function createButtonElement() {
                var e = document.createElement("div");
                return e.classList.add("input-button"), e;
            }
        },
        {
            key: "createSVGIconElement",
            value: function createSVGIconElement() {
                return $8e4453fb4fc895c8$var$re.createSVGElement($8e4453fb4fc895c8$var$Qo);
            }
        },
        {
            key: "createButtonContainer",
            value: function createButtonContainer() {
                var e = document.createElement("div");
                return e.id = "dropup-container", e;
            }
        },
        {
            key: "getPosition",
            value: function getPosition(e, t) {
                var i, s;
                return (i = t == null ? void 0 : t.button) != null && i.position ? (s = t == null ? void 0 : t.button) == null ? void 0 : s.position : e["outside-left"].length > 0 && e["outside-right"].length === 0 ? "outside-right" : "outside-left";
            }
        }
    ]);
}($8e4453fb4fc895c8$var$ii);
var $8e4453fb4fc895c8$var$$ = /*#__PURE__*/ function() {
    function $() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, $);
    }
    return $8e4453fb4fc895c8$var$_createClass($, null, [
        {
            key: "addToDropup",
            value: // prettier-ignore
            function addToDropup(e, t, i, s) {
                var r = new $8e4453fb4fc895c8$var$wt(i, s);
                $8e4453fb4fc895c8$var$sn.forEach(function(a) {
                    var l = t["dropup-menu"].findIndex(function(d) {
                        return d.buttonType === a;
                    }), c = t["dropup-menu"][l];
                    c && (r.addItem(c.button), t["dropup-menu"].splice(l, 1));
                });
                var o = $8e4453fb4fc895c8$var$wt.getPosition(t, s);
                $8e4453fb4fc895c8$var$kt.addButton(e, r.buttonContainer, o), t[o].push({});
            }
        },
        {
            key: "addToSideContainer",
            value: function addToSideContainer(e, t) {
                [
                    "inside-left",
                    "inside-right",
                    "outside-left",
                    "outside-right"
                ].forEach(function(s) {
                    var r = s;
                    t[r].forEach(function(o) {
                        $8e4453fb4fc895c8$var$kt.addButton(e, o.button.elementRef, r);
                    });
                });
            }
        },
        {
            key: "setPosition",
            value: function setPosition(e, t, i) {
                var s = $8e4453fb4fc895c8$var$_objectSpread($8e4453fb4fc895c8$var$_objectSpread({}, e[t]), {}, {
                    buttonType: t
                });
                i.push(s), delete e[t];
            }
        },
        {
            key: "createPositionsObj",
            value: function createPositionsObj() {
                return {
                    "dropup-menu": [],
                    "outside-left": [],
                    "inside-left": [],
                    "inside-right": [],
                    "outside-right": []
                };
            }
        },
        {
            key: "generatePositions",
            value: function generatePositions(e) {
                var t = $.createPositionsObj();
                Object.keys(e).forEach(function(s) {
                    var o;
                    var r = (o = e[s]) == null ? void 0 : o.button.position;
                    r && $.setPosition(e, s, t[r]);
                }), t["inside-right"].length === 0 && e.submit && $.setPosition(e, "submit", t["inside-right"]), t["outside-right"].length === 0 && (e.submit ? $.setPosition(e, "submit", t["outside-right"]) : e.microphone ? $.setPosition(e, "microphone", t["outside-right"]) : e.camera && $.setPosition(e, "camera", t["outside-right"])), e.submit && $.setPosition(e, "submit", t["outside-left"].length === 0 ? t["outside-left"] : t["inside-right"]), e.microphone && $.setPosition(e, "microphone", t["outside-left"].length === 0 ? t["outside-left"] : t["inside-right"]);
                var i = Object.keys(e);
                return i.length > 1 || t["dropup-menu"].length > 0 ? $8e4453fb4fc895c8$var$sn.forEach(function(s) {
                    e[s] && t["dropup-menu"].push($8e4453fb4fc895c8$var$_objectSpread($8e4453fb4fc895c8$var$_objectSpread({}, e[s]), {}, {
                        buttonType: s
                    }));
                }) : i.length === 1 && $.setPosition(e, i[0], t["outside-right"].length === 0 ? t["outside-right"] : t["outside-left"]), t;
            }
        },
        {
            key: "addButtons",
            value: function addButtons(e, t, i, s) {
                var r = $.generatePositions(t);
                return $.addToSideContainer(e, r), r["dropup-menu"].length > 0 && $.addToDropup(e, r, i, s), r;
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$ea = '<?xml version="1.0" encoding="utf-8"?>\n<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n<title>file</title>\n<path d="M20 10.9696L11.9628 18.5497C10.9782 19.4783 9.64274 20 8.25028 20C6.85782 20 5.52239 19.4783 4.53777 18.5497C3.55315 17.6211 3 16.3616 3 15.0483C3 13.7351 3.55315 12.4756 4.53777 11.547L12.575 3.96687C13.2314 3.34779 14.1217 3 15.05 3C15.9783 3 16.8686 3.34779 17.525 3.96687C18.1814 4.58595 18.5502 5.4256 18.5502 6.30111C18.5502 7.17662 18.1814 8.01628 17.525 8.63535L9.47904 16.2154C9.15083 16.525 8.70569 16.6989 8.24154 16.6989C7.77738 16.6989 7.33224 16.525 7.00403 16.2154C6.67583 15.9059 6.49144 15.4861 6.49144 15.0483C6.49144 14.6106 6.67583 14.1907 7.00403 13.8812L14.429 6.88674" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>', $8e4453fb4fc895c8$var$ta = '<?xml version="1.0" encoding="utf-8"?>\n<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n  <path d="M20,15.2928932 L20,5.5 C20,4.67157288 19.3284271,4 18.5,4 L5.5,4 C4.67157288,4 4,4.67157288 4,5.5 L4,12.2928932 L7.14644661,9.14644661 C7.34170876,8.95118446 7.65829124,8.95118446 7.85355339,9.14644661 L13.5,14.7928932 L16.1464466,12.1464466 C16.3417088,11.9511845 16.6582912,11.9511845 16.8535534,12.1464466 L20,15.2928932 Z M20,16.7071068 L16.5,13.2071068 L13.8535534,15.8535534 C13.6582912,16.0488155 13.3417088,16.0488155 13.1464466,15.8535534 L7.5,10.2071068 L4,13.7071068 L4,18.5 C4,19.3284271 4.67157288,20 5.5,20 L18.5,20 C19.3284271,20 20,19.3284271 20,18.5 L20,16.7071068 Z M3,5.5 C3,4.11928813 4.11928813,3 5.5,3 L18.5,3 C19.8807119,3 21,4.11928813 21,5.5 L21,18.5 C21,19.8807119 19.8807119,21 18.5,21 L5.5,21 C4.11928813,21 3,19.8807119 3,18.5 L3,5.5 Z M15,6 L17,6 C17.5522847,6 18,6.44771525 18,7 L18,9 C18,9.55228475 17.5522847,10 17,10 L15,10 C14.4477153,10 14,9.55228475 14,9 L14,7 C14,6.44771525 14.4477153,6 15,6 Z M15,7 L15,9 L17,9 L17,7 L15,7 Z"/>\n</svg>\n', $8e4453fb4fc895c8$var$ia = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-49.49 -49.49 593.87 593.87" stroke-width="3.95908" transform="rotate(0)">\n  <g stroke-width="0"></g>\n  <g stroke-linecap="round" stroke-linejoin="round" stroke-width="0.98977"></g>\n  <g>\n    <g>\n      <g>\n        <path d="M163.205,76.413v293.301c-3.434-3.058-7.241-5.867-11.486-8.339c-21.38-12.452-49.663-15.298-77.567-7.846 c-49.038,13.096-80.904,54.519-71.038,92.337c4.019,15.404,14.188,28.221,29.404,37.087c13.553,7.894,29.87,11.933,47.115,11.933 c9.962,0,20.231-1.356,30.447-4.087c42.74-11.406,72.411-44.344,72.807-77.654h0.011v-0.162c0.002-0.166,0-0.331,0-0.496V187.072 l290.971-67.3v178.082c-3.433-3.055-7.238-5.863-11.481-8.334c-21.385-12.452-49.654-15.308-77.567-7.846 c-49.038,13.087-80.904,54.519-71.038,92.356c4.019,15.385,14.183,28.212,29.404,37.067c13.548,7.894,29.875,11.933,47.115,11.933 c9.962,0,20.231-1.356,30.452-4.087c42.74-11.413,72.411-44.346,72.804-77.654h0.004v-0.065c0.003-0.236,0.001-0.469,0-0.704V0 L163.205,76.413z M104.999,471.779c-22.543,6.038-45.942,3.846-62.572-5.846c-10.587-6.163-17.591-14.817-20.255-25.038 c-7.144-27.375,18.452-58.029,57.062-68.346c8.409-2.25,16.938-3.346,25.188-3.346c13.87,0,26.962,3.115,37.389,9.192 c10.587,6.163,17.591,14.817,20.255,25.029c0.809,3.102,1.142,6.248,1.139,9.4v0.321h0.014 C162.99,437.714,139.082,462.678,104.999,471.779z M182.898,166.853V92.067l290.971-67.298v74.784L182.898,166.853z M415.677,399.923c-22.558,6.038-45.942,3.837-62.587-5.846c-10.587-6.163-17.587-14.817-20.25-25.019 c-7.144-27.385,18.452-58.058,57.058-68.365c8.414-2.25,16.942-3.346,25.192-3.346c13.875,0,26.962,3.115,37.385,9.192 c10.596,6.163,17.596,14.817,20.26,25.029v0.01c0.796,3.05,1.124,6.144,1.135,9.244v0.468h0.02 C473.668,365.851,449.763,390.814,415.677,399.923z">\n        </path>\n      </g>\n    </g>\n  </g>\n</svg>', $8e4453fb4fc895c8$var$sa = '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 5.9266752 5.6408391" height="21.31971" width="22.4">\n  <g>\n    <path d="m 5.2564627,1.548212 c -3.1136005,-0.4796804 -1.5568006,-0.2398402 0,0 z M 2.0001198,2.0922063 c 0.1556781,0 0.2657489,0.020893 0.3917849,0.080366 0.081154,0.038347 0.1153492,0.134065 0.076377,0.2138602 -0.038973,0.07979 -0.1363527,0.1134129 -0.2175069,0.075091 -0.078199,-0.036919 -0.1407455,-0.048792 -0.250655,-0.048792 -0.2260486,0 -0.3921482,0.2042182 -0.3921482,0.4801409 0,0.2761822 0.1663188,0.4810688 0.3921482,0.4810688 0.1117901,0 0.2064255,-0.046133 0.255659,-0.1284198 l 0.00162,-0.00389 V 3.0534032 l -0.098011,1.75e-4 c -0.081844,0 -0.1495979,-0.059305 -0.1612403,-0.1365887 l -0.00175,-0.023683 c 0,-0.08047 0.060311,-0.1470874 0.1389194,-0.1585331 l 0.024085,-0.00195 h 0.2612303 c 0.081842,0 0.149598,0.059305 0.1612404,0.1365891 l 0.00175,0.023683 -3.398e-4,0.3968809 v 0 l -0.00168,0.014211 v 0 l -0.00553,0.023034 v 0 l -0.00532,0.014145 c -0.098178,0.22826 -0.3236506,0.3528713 -0.5706303,0.3528713 -0.4240855,0 -0.7181621,-0.3622714 -0.7181621,-0.8016063 0,-0.4391857 0.2940275,-0.8006848 0.7181621,-0.8006848 z m 1.2034759,0.031275 c 0.081843,0 0.1495977,0.059305 0.1612403,0.1365891 l 0.00175,0.023683 v 1.2211775 c 0,0.088516 -0.07298,0.1602721 -0.1630073,0.1602721 -0.081841,0 -0.1495972,-0.059305 -0.1612397,-0.1365892 L 3.040589,3.5049308 V 2.2837527 c 0,-0.088516 0.07298,-0.1602721 0.1630067,-0.1602714 z m 0.7813442,0 0.5209469,0.00195 c 0.090025,3.048e-4 0.1627543,0.072306 0.1624458,0.1608234 -2.809e-4,0.08047 -0.06083,0.1468798 -0.1394772,0.158066 l -0.024092,0.00195 -0.3575326,-0.0013 v 0.4497782 l 0.2928918,2.27e-4 c 0.081842,0 0.1495979,0.059305 0.1612403,0.136589 l 0.00175,0.023683 c 0,0.080469 -0.06031,0.1470871 -0.1389193,0.1585393 l -0.024092,0.00195 -0.2928919,-2.336e-4 1.563e-4,0.2860316 c 0,0.080471 -0.06031,0.1470873 -0.1389193,0.1585395 l -0.024085,0.00195 c -0.081843,0 -0.1495979,-0.059305 -0.1612403,-0.1365826 l -0.00175,-0.023691 V 2.2841354 c 2.798e-4,-0.08047 0.060829,-0.1468797 0.1394758,-0.1580594 z"/>\n    <path d="m 5.0894191,1.0943261 c 0,-0.21918999 -0.177687,-0.39686999 -0.396876,-0.39686999 h -3.43959 c -0.2191879,0 -0.391262,0.1777519 -0.3968759,0.39686999 l -0.027082,3.4379266 c 0.040152,0.2939927 0.4235456,0.409415 0.4235456,0.409415 l 3.4785583,-0.00851 c 0,0 0.3008506,-0.1402998 0.3236271,-0.4201576 0.042911,-0.5272495 0.034693,-1.6106146 0.034693,-3.4186761 z m -4.49792494,0 c 0,-0.36530999 0.29614504,-0.66145999 0.66145894,-0.66145999 h 3.43959 c 0.365314,0 0.66146,0.29615 0.66146,0.66145999 v 3.43959 c 0,0.36532 -0.296146,0.66146 -0.66146,0.66146 h -3.43959 c -0.3653139,0 -0.66145894,-0.29614 -0.66145894,-0.66146 z"/>\n  </g>\n</svg>\n', $8e4453fb4fc895c8$var$na = {
    images: {
        id: "upload-images-icon",
        svgString: $8e4453fb4fc895c8$var$ta,
        dropupText: "Image"
    },
    gifs: {
        id: "upload-gifs-icon",
        svgString: $8e4453fb4fc895c8$var$sa,
        dropupText: "GIF"
    },
    audio: {
        id: "upload-audio-icon",
        svgString: $8e4453fb4fc895c8$var$ia,
        dropupText: "Audio"
    },
    mixedFiles: {
        id: "upload-mixed-files-icon",
        svgString: $8e4453fb4fc895c8$var$ea,
        dropupText: "File"
    }
}, $8e4453fb4fc895c8$var$ra = '<?xml version="1.0" encoding="iso-8859-1"?>\n<svg height="1.4em" width="1.4em" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"\n	 viewBox="0 0 490.9 490.9" xml:space="preserve">\n	<g>\n		<g>\n			<path d="M245.5,322.9c53,0,96.2-43.2,96.2-96.2V96.2c0-53-43.2-96.2-96.2-96.2s-96.2,43.2-96.2,96.2v130.5\n				C149.3,279.8,192.5,322.9,245.5,322.9z M173.8,96.2c0-39.5,32.2-71.7,71.7-71.7s71.7,32.2,71.7,71.7v130.5\n				c0,39.5-32.2,71.7-71.7,71.7s-71.7-32.2-71.7-71.7V96.2z"/>\n			<path d="M94.4,214.5c-6.8,0-12.3,5.5-12.3,12.3c0,85.9,66.7,156.6,151.1,162.8v76.7h-63.9c-6.8,0-12.3,5.5-12.3,12.3\n				s5.5,12.3,12.3,12.3h152.3c6.8,0,12.3-5.5,12.3-12.3s-5.5-12.3-12.3-12.3h-63.9v-76.7c84.4-6.3,151.1-76.9,151.1-162.8\n				c0-6.8-5.5-12.3-12.3-12.3s-12.3,5.5-12.3,12.3c0,76.6-62.3,138.9-138.9,138.9s-138.9-62.3-138.9-138.9\n				C106.6,220,101.2,214.5,94.4,214.5z"/>\n		</g>\n	</g>\n</svg>\n';
var $8e4453fb4fc895c8$var$W = /*#__PURE__*/ function() {
    function W() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, W);
    }
    return $8e4453fb4fc895c8$var$_createClass(W, null, [
        {
            key: "addAttributes",
            value: function addAttributes(e) {
                e.role = "button", e.setAttribute("tabindex", "0");
            }
        },
        {
            key: "addAriaBusy",
            value: function addAriaBusy(e) {
                e.setAttribute("aria-busy", "true");
            }
        },
        {
            key: "removeAriaBusy",
            value: function removeAriaBusy(e) {
                e.removeAttribute("aria-busy");
            }
        },
        {
            key: "addAriaDisabled",
            value: function addAriaDisabled(e) {
                e.setAttribute("aria-disabled", "true");
            }
        },
        {
            key: "removeAriaDisabled",
            value: function removeAriaDisabled(e) {
                e.removeAttribute("aria-disabled");
            }
        },
        {
            key: "removeAriaAttributes",
            value: function removeAriaAttributes(e) {
                W.removeAriaBusy(e), W.removeAriaDisabled(e);
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Jt = /*#__PURE__*/ function(_ii2) {
    function Jt(e) {
        var _this57;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Jt);
        (e == null ? void 0 : e.position) === "dropup-menu" && (e.position = "outside-right"), _this57 = $8e4453fb4fc895c8$var$_callSuper(this, Jt, [
            Jt.createMicrophoneElement(),
            e == null ? void 0 : e.position,
            e
        ]), _this57.isActive = !1, _this57._innerElements = _this57.createInnerElements(_this57._customStyles), _this57.changeToDefault();
        return _this57;
    }
    $8e4453fb4fc895c8$var$_inherits(Jt, _ii2);
    return $8e4453fb4fc895c8$var$_createClass(Jt, [
        {
            key: "createInnerElements",
            value: function createInnerElements(e) {
                var t = Jt.createSVGIconElement();
                return {
                    "default": this.createInnerElement(t, "default", e),
                    active: this.createInnerElement(t, "active", e),
                    unsupported: this.createInnerElement(t, "unsupported", e),
                    commandMode: this.createInnerElement(t, "commandMode", e)
                };
            }
        },
        {
            key: "createInnerElement",
            value: function createInnerElement(e, t, i) {
                return $8e4453fb4fc895c8$var$J.createSpecificStateElement(this.elementRef, t, i) || e;
            }
        },
        {
            key: "changeToActive",
            value: function changeToActive() {
                this.elementRef.replaceChildren(this._innerElements.active), this.toggleIconFilter("active"), this.reapplyStateStyle("active", [
                    "default",
                    "commandMode"
                ]), this.isActive = !0;
            }
        },
        {
            key: "changeToDefault",
            value: function changeToDefault() {
                this.elementRef.replaceChildren(this._innerElements["default"]), this.toggleIconFilter("default"), this.reapplyStateStyle("default", [
                    "active",
                    "commandMode"
                ]), this.isActive = !1;
            }
        },
        {
            key: "changeToCommandMode",
            value: function changeToCommandMode() {
                this.elementRef.replaceChildren(this._innerElements.unsupported), this.toggleIconFilter("command"), this.reapplyStateStyle("commandMode", [
                    "active"
                ]);
            }
        },
        {
            key: "changeToUnsupported",
            value: function changeToUnsupported() {
                this.elementRef.replaceChildren(this._innerElements.unsupported), this.elementRef.classList.add("unsupported-microphone"), this.reapplyStateStyle("unsupported", [
                    "active"
                ]);
            }
        },
        {
            key: "toggleIconFilter",
            value: function toggleIconFilter(e) {
                var t = this.elementRef.children[0];
                if (t.tagName.toLocaleLowerCase() === "svg") switch(e){
                    case "default":
                        t.classList.remove("active-microphone-icon", "command-microphone-icon"), t.classList.add("default-microphone-icon");
                        break;
                    case "active":
                        t.classList.remove("default-microphone-icon", "command-microphone-icon"), t.classList.add("active-microphone-icon");
                        break;
                    case "command":
                        t.classList.remove("active-microphone-icon", "default-microphone-icon"), t.classList.add("command-microphone-icon");
                        break;
                }
            }
        }
    ], [
        {
            key: "createMicrophoneElement",
            value: function createMicrophoneElement() {
                var e = document.createElement("div");
                return e.id = "microphone-button", e.classList.add("input-button"), $8e4453fb4fc895c8$var$W.addAttributes(e), e;
            }
        },
        {
            key: "createSVGIconElement",
            value: function createSVGIconElement() {
                var e = $8e4453fb4fc895c8$var$re.createSVGElement($8e4453fb4fc895c8$var$ra);
                return e.id = "microphone-icon", e;
            }
        }
    ]);
}($8e4453fb4fc895c8$var$ii);
var $8e4453fb4fc895c8$var$In = {}, $8e4453fb4fc895c8$var$qi = {}, $8e4453fb4fc895c8$var$zi = {}, $8e4453fb4fc895c8$var$si = {}, $8e4453fb4fc895c8$var$ct = {};
Object.defineProperty($8e4453fb4fc895c8$var$ct, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$ct.Text = void 0;
var $8e4453fb4fc895c8$var$ze = /*#__PURE__*/ function() {
    function ze() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, ze);
    }
    return $8e4453fb4fc895c8$var$_createClass(ze, null, [
        {
            key: "capitalize",
            value: function capitalize(e) {
                return e.replace(ze.FIRST_CHAR_REGEX, function(t) {
                    return t.toUpperCase();
                });
            }
        },
        {
            key: "lineBreak",
            value: function lineBreak(e) {
                return e.replace(ze.DOUBLE_LINE, "<p></p>").replace(ze.ONE_LINE, "<br>");
            }
        },
        {
            key: "isCharDefined",
            value: function isCharDefined(e) {
                return e !== void 0 && e !== "\xa0" && e !== " " && e !== "\n" && e !== "";
            }
        },
        {
            key: "breakupIntoWordsArr",
            value: function breakupIntoWordsArr(e) {
                return e.split(/(\W+)/);
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$ct.Text = $8e4453fb4fc895c8$var$ze;
$8e4453fb4fc895c8$var$ze.FIRST_CHAR_REGEX = /\S/;
$8e4453fb4fc895c8$var$ze.DOUBLE_LINE = /\n\n/g;
$8e4453fb4fc895c8$var$ze.ONE_LINE = /\n/g;
Object.defineProperty($8e4453fb4fc895c8$var$si, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$si.Translate = void 0;
var $8e4453fb4fc895c8$var$oa = $8e4453fb4fc895c8$var$ct;
var $8e4453fb4fc895c8$var$aa = /*#__PURE__*/ function() {
    function aa() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, aa);
    }
    return $8e4453fb4fc895c8$var$_createClass(aa, null, [
        {
            key: "translate",
            value: function translate(e, t) {
                var i = $8e4453fb4fc895c8$var$oa.Text.breakupIntoWordsArr(e);
                for(var s = 0; s < i.length; s += 1)t[i[s]] && (i[s] = t[i[s]]);
                return i.join("");
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$si.Translate = $8e4453fb4fc895c8$var$aa;
Object.defineProperty($8e4453fb4fc895c8$var$zi, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$zi.WebSpeechTranscript = void 0;
var $8e4453fb4fc895c8$var$nn = $8e4453fb4fc895c8$var$si;
var $8e4453fb4fc895c8$var$la = /*#__PURE__*/ function() {
    function la() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, la);
    }
    return $8e4453fb4fc895c8$var$_createClass(la, null, [
        {
            key: "extract",
            value: function extract(e, t, i) {
                var s = "";
                for(var r = e.resultIndex; r < e.results.length; ++r){
                    var o = e.results[r][0].transcript;
                    i && (o = $8e4453fb4fc895c8$var$nn.Translate.translate(o, i)), e.results[r].isFinal ? t += o : s += o;
                }
                return {
                    interimTranscript: s,
                    finalTranscript: t,
                    newText: s || t
                };
            }
        },
        {
            key: "extractSafari",
            value: function extractSafari(e, t, i) {
                var s = "";
                var r = "";
                for(var o = e.resultIndex; o < e.results.length; ++o){
                    var a = e.results[o][0].transcript;
                    i && (a = $8e4453fb4fc895c8$var$nn.Translate.translate(a, i)), s += a;
                }
                return {
                    interimTranscript: r,
                    finalTranscript: s,
                    newText: r || s
                };
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$zi.WebSpeechTranscript = $8e4453fb4fc895c8$var$la;
var $8e4453fb4fc895c8$var$Mt = {};
Object.defineProperty($8e4453fb4fc895c8$var$Mt, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$Mt.Browser = void 0;
var $8e4453fb4fc895c8$var$Lt = /*#__PURE__*/ $8e4453fb4fc895c8$var$_createClass(function Lt() {
    $8e4453fb4fc895c8$var$_classCallCheck(this, Lt);
});
$8e4453fb4fc895c8$var$Mt.Browser = $8e4453fb4fc895c8$var$Lt;
$8e4453fb4fc895c8$var$Lt.IS_SAFARI = function() {
    return $8e4453fb4fc895c8$var$Lt._IS_SAFARI === void 0 && ($8e4453fb4fc895c8$var$Lt._IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)), $8e4453fb4fc895c8$var$Lt._IS_SAFARI;
};
var $8e4453fb4fc895c8$var$ni = {}, $8e4453fb4fc895c8$var$Gi = {};
Object.defineProperty($8e4453fb4fc895c8$var$Gi, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$Gi.EventListeners = void 0;
var $8e4453fb4fc895c8$var$de = /*#__PURE__*/ function() {
    function de() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, de);
    }
    return $8e4453fb4fc895c8$var$_createClass(de, null, [
        {
            key: "getElementIfFocusedOnAvailable",
            value: function getElementIfFocusedOnAvailable(e, t) {
                return Array.isArray(e) ? e.find(function(i) {
                    return t === i;
                }) : t === e ? e : void 0;
            }
        },
        {
            key: "keyDownWindow",
            value: function keyDownWindow(e) {
                var _this58 = this;
                e.element && de.getElementIfFocusedOnAvailable(e.element, document.activeElement) && (de.KEY_DOWN_TIMEOUT !== null && clearTimeout(de.KEY_DOWN_TIMEOUT), de.KEY_DOWN_TIMEOUT = setTimeout(function() {
                    de.KEY_DOWN_TIMEOUT = null, _this58.resetRecording(e);
                }, 500));
            }
        },
        {
            key: "mouseDownWindow",
            value: function mouseDownWindow(e, t) {
                this.mouseDownElement = de.getElementIfFocusedOnAvailable(e, t.target);
            }
        },
        {
            key: "mouseUpWindow",
            value: function mouseUpWindow(e) {
                this.mouseDownElement && this.resetRecording(e), this.mouseDownElement = void 0;
            }
        },
        {
            key: "add",
            value: function add(e, t) {
                var i = (t == null ? void 0 : t.insertInCursorLocation) === void 0 || (t == null ? void 0 : t.insertInCursorLocation);
                t != null && t.element && i && (e.mouseDownEvent = de.mouseDownWindow.bind(e, t.element), document.addEventListener("mousedown", e.mouseDownEvent), e.mouseUpEvent = de.mouseUpWindow.bind(e, t), document.addEventListener("mouseup", e.mouseUpEvent), e.keyDownEvent = de.keyDownWindow.bind(e, t), document.addEventListener("keydown", e.keyDownEvent));
            }
        },
        {
            key: "remove",
            value: function remove(e) {
                document.removeEventListener("mousedown", e.mouseDownEvent), document.removeEventListener("mouseup", e.mouseUpEvent), document.removeEventListener("keydown", e.keyDownEvent);
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$Gi.EventListeners = $8e4453fb4fc895c8$var$de;
$8e4453fb4fc895c8$var$de.KEY_DOWN_TIMEOUT = null;
var $8e4453fb4fc895c8$var$Vi = {};
Object.defineProperty($8e4453fb4fc895c8$var$Vi, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$Vi.PreResultUtils = void 0;
var $8e4453fb4fc895c8$var$ca = /*#__PURE__*/ function() {
    function ca() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, ca);
    }
    return $8e4453fb4fc895c8$var$_createClass(ca, null, [
        {
            key: "process",
            value: function process(e, t, i, s, r) {
                var o = s == null ? void 0 : s(t, i);
                return o ? (setTimeout(function() {
                    o.restart ? e.resetRecording(r) : o.stop && e.stop();
                }), (o.stop || o.restart) && o.removeNewText) : !1;
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$Vi.PreResultUtils = $8e4453fb4fc895c8$var$ca;
var $8e4453fb4fc895c8$var$ri = {}, $8e4453fb4fc895c8$var$oi = {};
Object.defineProperty($8e4453fb4fc895c8$var$oi, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$oi.AutoScroll = void 0;
var $8e4453fb4fc895c8$var$Ds = /*#__PURE__*/ function() {
    function Ds() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ds);
    }
    return $8e4453fb4fc895c8$var$_createClass(Ds, null, [
        {
            key: "changeStateIfNeeded",
            value: function changeStateIfNeeded(e, t) {
                t && !e.isCursorAtEnd && (e.endPadding = "", e.scrollingSpan.innerHTML = "&nbsp;");
            }
        },
        {
            key: "scrollGeneric",
            value: function scrollGeneric(e, t) {
                e.isCursorAtEnd ? t.scrollTop = t.scrollHeight : e.scrollingSpan.scrollIntoView({
                    block: "nearest"
                });
            }
        },
        {
            key: "scrollSafariPrimitiveToEnd",
            value: function scrollSafariPrimitiveToEnd(e) {
                e.scrollLeft = e.scrollWidth, e.scrollTop = e.scrollHeight;
            }
        },
        {
            key: "isElementOverflown",
            value: function isElementOverflown(e) {
                return e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth;
            }
        },
        {
            key: "isRequired",
            value: function isRequired(e, t) {
                return e && Ds.isElementOverflown(t);
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$oi.AutoScroll = $8e4453fb4fc895c8$var$Ds;
var $8e4453fb4fc895c8$var$dt = {};
Object.defineProperty($8e4453fb4fc895c8$var$dt, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$dt.Elements = void 0;
var $8e4453fb4fc895c8$var$da = /*#__PURE__*/ function() {
    function da() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, da);
    }
    return $8e4453fb4fc895c8$var$_createClass(da, null, [
        {
            key: "isPrimitiveElement",
            value: function isPrimitiveElement(e) {
                return e.tagName === "INPUT" || e.tagName === "TEXTAREA";
            }
        },
        {
            key: "createInterimSpan",
            value: function createInterimSpan() {
                var e = document.createElement("span");
                return e.style.color = "grey", e.style.pointerEvents = "none", e;
            }
        },
        {
            key: "createGenericSpan",
            value: function createGenericSpan() {
                var e = document.createElement("span");
                return e.style.pointerEvents = "none", e;
            }
        },
        {
            key: "appendSpans",
            value: function appendSpans(e, t) {
                if (e.spansPopulated = !0, e.insertInCursorLocation && document.activeElement === t) {
                    var _i17 = window.getSelection();
                    if (_i17 != null && _i17.focusNode) {
                        var s = _i17.getRangeAt(0);
                        s.insertNode(e.scrollingSpan), s.insertNode(e.interimSpan), s.insertNode(e.finalSpan), s.collapse(!1), _i17.removeAllRanges(), _i17.addRange(s);
                        return;
                    }
                }
                t.appendChild(e.finalSpan), t.appendChild(e.interimSpan), t.appendChild(e.scrollingSpan);
            }
        },
        {
            key: "applyCustomColors",
            value: function applyCustomColors(e, t) {
                t.interim && (e.interimSpan.style.color = t.interim), t["final"] && (e.finalSpan.style.color = t["final"]);
            }
        },
        {
            key: "isInsideShadowDOM",
            value: function isInsideShadowDOM(e) {
                return e.getRootNode() instanceof ShadowRoot;
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$dt.Elements = $8e4453fb4fc895c8$var$da;
var $8e4453fb4fc895c8$var$ht = {};
Object.defineProperty($8e4453fb4fc895c8$var$ht, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$ht.Cursor = void 0;
var $8e4453fb4fc895c8$var$Bt = /*#__PURE__*/ function() {
    function Bt() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Bt);
    }
    return $8e4453fb4fc895c8$var$_createClass(Bt, null, [
        {
            key: "setOffsetForGeneric",
            value: function setOffsetForGeneric(e, t) {
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                var s = 0;
                for(var r = 0; r < e.childNodes.length; r += 1){
                    var o = e.childNodes[r];
                    if (o.childNodes.length > 0) {
                        var a = Bt.setOffsetForGeneric(o, t, i);
                        if (a === -1) return -1;
                        i += a;
                    } else if (o.textContent !== null) {
                        if (i + o.textContent.length > t) {
                            var _a4 = document.createRange();
                            _a4.setStart(o, t - i), _a4.collapse(!0);
                            var l = window.getSelection();
                            return l == null || l.removeAllRanges(), l == null || l.addRange(_a4), e.focus(), -1;
                        }
                        i += o.textContent.length, s += o.textContent.length;
                    }
                }
                return s;
            }
        },
        {
            key: "focusEndOfGeneric",
            value: function focusEndOfGeneric(e) {
                var t = document.createRange();
                t.selectNodeContents(e), t.collapse(!1);
                var i = window.getSelection();
                i && (i.removeAllRanges(), i.addRange(t));
            }
        },
        {
            key: "setOffsetForSafariGeneric",
            value: function setOffsetForSafariGeneric(e, t) {
                var i = window.getSelection();
                if (i) {
                    var s = Bt.getGenericElementCursorOffset(e, i, !0);
                    console.log(s), setTimeout(function() {}, 100), Bt.setOffsetForGeneric(e, s + t);
                }
            }
        },
        {
            key: "setOffsetForPrimitive",
            value: function setOffsetForPrimitive(e, t, i) {
                i && e.blur(), e.setSelectionRange(t, t), e.focus();
            }
        },
        {
            key: "getGenericElementCursorOffset",
            value: function getGenericElementCursorOffset(e, t, i) {
                var s = 0;
                if (t.rangeCount > 0) {
                    var r = t.getRangeAt(0), o = r.cloneRange();
                    o.selectNodeContents(e), i ? o.setEnd(r.startContainer, r.startOffset) : o.setEnd(r.endContainer, r.endOffset), s = o.toString().length;
                }
                return s;
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$ht.Cursor = $8e4453fb4fc895c8$var$Bt;
Object.defineProperty($8e4453fb4fc895c8$var$ri, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$ri.CommandUtils = void 0;
var $8e4453fb4fc895c8$var$rn = $8e4453fb4fc895c8$var$oi, $8e4453fb4fc895c8$var$ha = $8e4453fb4fc895c8$var$dt, $8e4453fb4fc895c8$var$ua = $8e4453fb4fc895c8$var$Mt, $8e4453fb4fc895c8$var$on = $8e4453fb4fc895c8$var$ht, $8e4453fb4fc895c8$var$an = $8e4453fb4fc895c8$var$ct;
var $8e4453fb4fc895c8$var$le = /*#__PURE__*/ function() {
    function le() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, le);
    }
    return $8e4453fb4fc895c8$var$_createClass(le, null, [
        {
            key: "processCommand",
            value: function processCommand(e, t) {
                return (!t || !t.caseSensitive) && (e = e.toLowerCase()), (t == null ? void 0 : t.substrings) === !1 ? $8e4453fb4fc895c8$var$an.Text.breakupIntoWordsArr(e) : e;
            }
        },
        {
            key: "process",
            value: function process(e) {
                var t;
                return ((t = e.settings) === null || t === void 0 ? void 0 : t.caseSensitive) === !0 ? e : Object.keys(e).reduce(function(s, r) {
                    var o = e[r];
                    return s[r] = typeof o == "string" ? le.processCommand(o, e.settings) : o, s;
                }, {});
            }
        },
        {
            key: "toggleCommandModeOn",
            value: function toggleCommandModeOn(e) {
                var t;
                e.isWaitingForCommand = !0, (t = e.onCommandModeTrigger) === null || t === void 0 || t.call(e, !0);
            }
        },
        {
            key: "toggleCommandModeOff",
            value: function toggleCommandModeOff(e) {
                var t;
                e.isWaitingForCommand && ((t = e.onCommandModeTrigger) === null || t === void 0 || t.call(e, !1), e.isWaitingForCommand = !1);
            }
        },
        {
            key: "setText",
            value: function setText(e, t, i, s) {
                le.toggleCommandModeOff(e), $8e4453fb4fc895c8$var$ha.Elements.isPrimitiveElement(s) ? (s.value = i, e.isTargetInShadow || $8e4453fb4fc895c8$var$on.Cursor.setOffsetForPrimitive(s, i.length, !0), $8e4453fb4fc895c8$var$ua.Browser.IS_SAFARI() && e.autoScroll && $8e4453fb4fc895c8$var$rn.AutoScroll.scrollSafariPrimitiveToEnd(s)) : (s.textContent = i, e.isTargetInShadow || $8e4453fb4fc895c8$var$on.Cursor.focusEndOfGeneric(s), setTimeout(function() {
                    return $8e4453fb4fc895c8$var$rn.AutoScroll.scrollGeneric(e, s);
                })), e.resetRecording(t);
            }
        },
        {
            key: "checkIfMatchesSubstring",
            value: function checkIfMatchesSubstring(e, t) {
                return t.includes(e);
            }
        },
        {
            key: "checkIfMatchesWord",
            value: function checkIfMatchesWord(e, t, i) {
                var s = e;
                for(var r = i.length - 1; r >= 0; r -= 1){
                    var o = r, a = s.length - 1;
                    for(; i[o] === s[a] && a >= 0;)o -= 1, a -= 1;
                    if (a < 0) return !0;
                }
                return !1;
            }
        },
        {
            key: "execCommand",
            value: function execCommand(e, t, i, s, r) {
                var o, a, l;
                var c = e.commands;
                if (!c || !s || !i) return;
                var d = ((o = c.settings) === null || o === void 0 ? void 0 : o.caseSensitive) === !0 ? t : t.toLowerCase(), h = $8e4453fb4fc895c8$var$an.Text.breakupIntoWordsArr(d), f = ((a = c.settings) === null || a === void 0 ? void 0 : a.substrings) === !1 ? le.checkIfMatchesWord : le.checkIfMatchesSubstring;
                if (c.commandMode && f(c.commandMode, d, h)) return e.setInterimColorToFinal(), setTimeout(function() {
                    return le.toggleCommandModeOn(e);
                }), {
                    doNotProcessTranscription: !1
                };
                if (!(c.commandMode && !e.isWaitingForCommand)) {
                    if (c.stop && f(c.stop, d, h)) return le.toggleCommandModeOff(e), setTimeout(function() {
                        return e.stop();
                    }), {
                        doNotProcessTranscription: !1
                    };
                    if (c.pause && f(c.pause, d, h)) return le.toggleCommandModeOff(e), e.setInterimColorToFinal(), setTimeout(function() {
                        var u;
                        e.isPaused = !0, (u = e.onPauseTrigger) === null || u === void 0 || u.call(e, !0);
                    }), {
                        doNotProcessTranscription: !1
                    };
                    if (c.resume && f(c.resume, d, h)) return e.isPaused = !1, (l = e.onPauseTrigger) === null || l === void 0 || l.call(e, !1), le.toggleCommandModeOff(e), e.resetRecording(i), {
                        doNotProcessTranscription: !0
                    };
                    if (c.reset && f(c.reset, d, h)) return r !== void 0 && le.setText(e, i, r, s), {
                        doNotProcessTranscription: !0
                    };
                    if (c.removeAllText && f(c.removeAllText, d, h)) return le.setText(e, i, "", s), {
                        doNotProcessTranscription: !0
                    };
                }
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$ri.CommandUtils = $8e4453fb4fc895c8$var$le;
var $8e4453fb4fc895c8$var$$i = {};
Object.defineProperty($8e4453fb4fc895c8$var$$i, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$$i.Highlight = void 0;
var $8e4453fb4fc895c8$var$fa = $8e4453fb4fc895c8$var$dt, $8e4453fb4fc895c8$var$It = $8e4453fb4fc895c8$var$ht;
var $8e4453fb4fc895c8$var$Mi = /*#__PURE__*/ function() {
    function Mi() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Mi);
    }
    return $8e4453fb4fc895c8$var$_createClass(Mi, null, [
        {
            key: "setStateForPrimitive",
            value: function setStateForPrimitive(e, t) {
                var i, s;
                t.selectionStart !== null && (i = t.selectionStart), t.selectionEnd !== null && (s = t.selectionEnd), e.isHighlighted = i !== s;
            }
        },
        {
            key: "setStateForGeneric",
            value: function setStateForGeneric(e, t) {
                var i = window.getSelection();
                if (i != null && i.focusNode) {
                    var s = $8e4453fb4fc895c8$var$It.Cursor.getGenericElementCursorOffset(t, i, !0), r = $8e4453fb4fc895c8$var$It.Cursor.getGenericElementCursorOffset(t, i, !1);
                    e.isHighlighted = s !== r;
                }
            }
        },
        {
            key: "setState",
            value: function setState(e, t) {
                document.activeElement === t && ($8e4453fb4fc895c8$var$fa.Elements.isPrimitiveElement(t) ? Mi.setStateForPrimitive(e, t) : Mi.setStateForGeneric(e, t));
            }
        },
        {
            key: "removeForGeneric",
            value: function removeForGeneric(e, t) {
                var i = window.getSelection();
                if (i) {
                    var s = $8e4453fb4fc895c8$var$It.Cursor.getGenericElementCursorOffset(t, i, !0);
                    i.deleteFromDocument(), $8e4453fb4fc895c8$var$It.Cursor.setOffsetForGeneric(t, s), e.isHighlighted = !1;
                }
            }
        },
        {
            key: "removeForPrimitive",
            value: function removeForPrimitive(e, t) {
                var i = t.selectionStart, s = t.selectionEnd, r = t.value;
                if (i && s) {
                    var o = r.substring(0, i) + r.substring(s);
                    t.value = o, $8e4453fb4fc895c8$var$It.Cursor.setOffsetForPrimitive(t, i, e.autoScroll);
                }
                e.isHighlighted = !1;
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$$i.Highlight = $8e4453fb4fc895c8$var$Mi;
var $8e4453fb4fc895c8$var$Wi = {};
Object.defineProperty($8e4453fb4fc895c8$var$Wi, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$Wi.Padding = void 0;
var $8e4453fb4fc895c8$var$pa = $8e4453fb4fc895c8$var$dt, $8e4453fb4fc895c8$var$ln = $8e4453fb4fc895c8$var$ht, $8e4453fb4fc895c8$var$ft = $8e4453fb4fc895c8$var$ct;
var $8e4453fb4fc895c8$var$Ri = /*#__PURE__*/ function() {
    function Ri() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ri);
    }
    return $8e4453fb4fc895c8$var$_createClass(Ri, null, [
        {
            key: "setStateForPrimitiveElement",
            value: function setStateForPrimitiveElement(e, t) {
                if (document.activeElement === t && t.selectionStart !== null) {
                    var s = t.selectionStart, r = t.value[s - 1], o = t.selectionEnd === null ? s : t.selectionEnd, a = t.value[o];
                    $8e4453fb4fc895c8$var$ft.Text.isCharDefined(r) && (e.startPadding = " ", e.numberOfSpacesBeforeNewText = 1), $8e4453fb4fc895c8$var$ft.Text.isCharDefined(a) && (e.endPadding = " ", e.numberOfSpacesAfterNewText = 1), e.isCursorAtEnd = t.value.length === o;
                    return;
                }
                var i = t.value[t.value.length - 1];
                $8e4453fb4fc895c8$var$ft.Text.isCharDefined(i) && (e.startPadding = " ", e.numberOfSpacesBeforeNewText = 1), e.isCursorAtEnd = !0;
            }
        },
        {
            key: "setStateForGenericElement",
            value: function setStateForGenericElement(e, t) {
                var i, s, r;
                if (document.activeElement === t) {
                    var a = window.getSelection();
                    if (a != null && a.focusNode) {
                        var l = $8e4453fb4fc895c8$var$ln.Cursor.getGenericElementCursorOffset(t, a, !0), c = (i = t.textContent) === null || i === void 0 ? void 0 : i[l - 1], d = $8e4453fb4fc895c8$var$ln.Cursor.getGenericElementCursorOffset(t, a, !1), h = (s = t.textContent) === null || s === void 0 ? void 0 : s[d];
                        $8e4453fb4fc895c8$var$ft.Text.isCharDefined(c) && (e.startPadding = " "), $8e4453fb4fc895c8$var$ft.Text.isCharDefined(h) && (e.endPadding = " "), e.isCursorAtEnd = ((r = t.textContent) === null || r === void 0 ? void 0 : r.length) === d;
                        return;
                    }
                }
                var o = t.innerText.charAt(t.innerText.length - 1);
                $8e4453fb4fc895c8$var$ft.Text.isCharDefined(o) && (e.startPadding = " "), e.isCursorAtEnd = !0;
            }
        },
        {
            key: "setState",
            value: function setState(e, t) {
                $8e4453fb4fc895c8$var$pa.Elements.isPrimitiveElement(t) ? Ri.setStateForPrimitiveElement(e, t) : Ri.setStateForGenericElement(e, t);
            }
        },
        {
            key: "adjustStateAfterRecodingPrimitiveElement",
            value: function adjustStateAfterRecodingPrimitiveElement(e, t) {
                if (e.primitiveTextRecorded = !0, e.insertInCursorLocation && document.activeElement === t && (t.selectionEnd !== null && (e.endPadding = e.endPadding + t.value.slice(t.selectionEnd)), t.selectionStart !== null)) {
                    e.startPadding = t.value.slice(0, t.selectionStart) + e.startPadding;
                    return;
                }
                e.startPadding = t.value + e.startPadding;
            }
        },
        {
            key: "adjustSateForNoTextPrimitiveElement",
            value: function adjustSateForNoTextPrimitiveElement(e) {
                e.numberOfSpacesBeforeNewText === 1 && (e.startPadding = e.startPadding.substring(0, e.startPadding.length - 1), e.numberOfSpacesBeforeNewText = 0), e.numberOfSpacesAfterNewText === 1 && (e.endPadding = e.endPadding.substring(1), e.numberOfSpacesAfterNewText = 0);
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$Wi.Padding = $8e4453fb4fc895c8$var$Ri;
Object.defineProperty($8e4453fb4fc895c8$var$ni, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$ni.Speech = void 0;
var $8e4453fb4fc895c8$var$cn = $8e4453fb4fc895c8$var$Gi, $8e4453fb4fc895c8$var$ma = $8e4453fb4fc895c8$var$Vi, $8e4453fb4fc895c8$var$dn = $8e4453fb4fc895c8$var$ri, $8e4453fb4fc895c8$var$hi = $8e4453fb4fc895c8$var$oi, $8e4453fb4fc895c8$var$rs = $8e4453fb4fc895c8$var$$i, $8e4453fb4fc895c8$var$Ee = $8e4453fb4fc895c8$var$dt, $8e4453fb4fc895c8$var$os = $8e4453fb4fc895c8$var$Wi, $8e4453fb4fc895c8$var$hn = $8e4453fb4fc895c8$var$Mt, $8e4453fb4fc895c8$var$un = $8e4453fb4fc895c8$var$ht, $8e4453fb4fc895c8$var$as = $8e4453fb4fc895c8$var$ct;
var $8e4453fb4fc895c8$var$ga = /*#__PURE__*/ function() {
    function ga() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, ga);
        this.finalTranscript = "", this.interimSpan = $8e4453fb4fc895c8$var$Ee.Elements.createInterimSpan(), this.finalSpan = $8e4453fb4fc895c8$var$Ee.Elements.createGenericSpan(), this.scrollingSpan = $8e4453fb4fc895c8$var$Ee.Elements.createGenericSpan(), this.isCursorAtEnd = !1, this.spansPopulated = !1, this.startPadding = "", this.endPadding = "", this.numberOfSpacesBeforeNewText = 0, this.numberOfSpacesAfterNewText = 0, this.isHighlighted = !1, this.primitiveTextRecorded = !1, this.recognizing = !1, this._displayInterimResults = !0, this.insertInCursorLocation = !0, this.autoScroll = !0, this.isRestarting = !1, this.isPaused = !1, this.isWaitingForCommand = !1, this.isTargetInShadow = !1, this.cannotBeStopped = !1, this.resetState();
    }
    return $8e4453fb4fc895c8$var$_createClass(ga, [
        {
            key: "prepareBeforeStart",
            value: function prepareBeforeStart(e) {
                var t, i;
                if (e != null && e.element) {
                    if ($8e4453fb4fc895c8$var$cn.EventListeners.add(this, e), Array.isArray(e.element)) {
                        var r = e.element.find(function(o) {
                            return o === document.activeElement;
                        }) || e.element[0];
                        if (!r) return;
                        this.prepare(r);
                    } else this.prepare(e.element);
                }
                (e == null ? void 0 : e.displayInterimResults) !== void 0 && (this._displayInterimResults = e.displayInterimResults), e != null && e.textColor && (this._finalTextColor = (t = e == null ? void 0 : e.textColor) === null || t === void 0 ? void 0 : t["final"], $8e4453fb4fc895c8$var$Ee.Elements.applyCustomColors(this, e.textColor)), (e == null ? void 0 : e.insertInCursorLocation) !== void 0 && (this.insertInCursorLocation = e.insertInCursorLocation), (e == null ? void 0 : e.autoScroll) !== void 0 && (this.autoScroll = e.autoScroll), this._onResult = e == null ? void 0 : e.onResult, this._onPreResult = e == null ? void 0 : e.onPreResult, this._onStart = e == null ? void 0 : e.onStart, this._onStop = e == null ? void 0 : e.onStop, this._onError = e == null ? void 0 : e.onError, this.onCommandModeTrigger = e == null ? void 0 : e.onCommandModeTrigger, this.onPauseTrigger = e == null ? void 0 : e.onPauseTrigger, this._options = e, !((i = this._options) === null || i === void 0) && i.commands && (this.commands = $8e4453fb4fc895c8$var$dn.CommandUtils.process(this._options.commands));
            }
        },
        {
            key: "prepare",
            value: function prepare(e) {
                $8e4453fb4fc895c8$var$os.Padding.setState(this, e), $8e4453fb4fc895c8$var$rs.Highlight.setState(this, e), this.isTargetInShadow = $8e4453fb4fc895c8$var$Ee.Elements.isInsideShadowDOM(e), $8e4453fb4fc895c8$var$Ee.Elements.isPrimitiveElement(e) ? (this._primitiveElement = e, this._originalText = this._primitiveElement.value) : (this._genericElement = e, this._originalText = this._genericElement.textContent);
            }
        },
        {
            key: "resetRecording",
            value: function resetRecording(e) {
                this.isRestarting = !0, this.stop(!0), this.resetState(!0), this.start(e, !0);
            }
        },
        {
            key: "updateElements",
            value: function updateElements(e, t, i) {
                var s;
                var r = $8e4453fb4fc895c8$var$as.Text.capitalize(t);
                if (this.finalTranscript === r && e === "") return;
                $8e4453fb4fc895c8$var$ma.PreResultUtils.process(this, i, e === "", this._onPreResult, this._options) && (e = "", i = "");
                var o = this.commands && $8e4453fb4fc895c8$var$dn.CommandUtils.execCommand(this, i, this._options, this._primitiveElement || this._genericElement, this._originalText);
                if (o) {
                    if (o.doNotProcessTranscription) return;
                    e = "", i = "";
                }
                if (this.isPaused || this.isWaitingForCommand) return;
                (s = this._onResult) === null || s === void 0 || s.call(this, i, e === ""), this.finalTranscript = r, this._displayInterimResults || (e = "");
                var a = this.finalTranscript === "" && e === "";
                this._primitiveElement ? this.updatePrimitiveElement(this._primitiveElement, e, a) : this._genericElement && this.updateGenericElement(this._genericElement, e, a);
            }
        },
        {
            key: "updatePrimitiveElement",
            value: function updatePrimitiveElement(e, t, i) {
                this.isHighlighted && $8e4453fb4fc895c8$var$rs.Highlight.removeForPrimitive(this, e), this.primitiveTextRecorded || $8e4453fb4fc895c8$var$os.Padding.adjustStateAfterRecodingPrimitiveElement(this, e), i && $8e4453fb4fc895c8$var$os.Padding.adjustSateForNoTextPrimitiveElement(this);
                var s = this.startPadding + this.finalTranscript + t;
                if (e.value = s + this.endPadding, !this.isTargetInShadow) {
                    var r = s.length + this.numberOfSpacesAfterNewText;
                    $8e4453fb4fc895c8$var$un.Cursor.setOffsetForPrimitive(e, r, this.autoScroll);
                }
                this.autoScroll && $8e4453fb4fc895c8$var$hn.Browser.IS_SAFARI() && this.isCursorAtEnd && $8e4453fb4fc895c8$var$hi.AutoScroll.scrollSafariPrimitiveToEnd(e);
            }
        },
        {
            key: "updateGenericElement",
            value: function updateGenericElement(e, t, i) {
                this.isHighlighted && $8e4453fb4fc895c8$var$rs.Highlight.removeForGeneric(this, e), this.spansPopulated || $8e4453fb4fc895c8$var$Ee.Elements.appendSpans(this, e);
                var s = (i ? "" : this.startPadding) + $8e4453fb4fc895c8$var$as.Text.lineBreak(this.finalTranscript);
                this.finalSpan.innerHTML = s;
                var r = $8e4453fb4fc895c8$var$hi.AutoScroll.isRequired(this.autoScroll, e);
                $8e4453fb4fc895c8$var$hi.AutoScroll.changeStateIfNeeded(this, r);
                var o = $8e4453fb4fc895c8$var$as.Text.lineBreak(t) + (i ? "" : this.endPadding);
                this.interimSpan.innerHTML = o, $8e4453fb4fc895c8$var$hn.Browser.IS_SAFARI() && this.insertInCursorLocation && $8e4453fb4fc895c8$var$un.Cursor.setOffsetForSafariGeneric(e, s.length + o.length), r && $8e4453fb4fc895c8$var$hi.AutoScroll.scrollGeneric(this, e), i && (this.scrollingSpan.innerHTML = "");
            }
        },
        {
            key: "finalise",
            value: function finalise(e) {
                this._genericElement && (e ? (this.finalSpan = $8e4453fb4fc895c8$var$Ee.Elements.createGenericSpan(), this.setInterimColorToFinal(), this.interimSpan = $8e4453fb4fc895c8$var$Ee.Elements.createInterimSpan(), this.scrollingSpan = $8e4453fb4fc895c8$var$Ee.Elements.createGenericSpan()) : this._genericElement.textContent = this._genericElement.textContent, this.spansPopulated = !1), $8e4453fb4fc895c8$var$cn.EventListeners.remove(this);
            }
        },
        {
            key: "setInterimColorToFinal",
            value: function setInterimColorToFinal() {
                this.interimSpan.style.color = this._finalTextColor || "black";
            }
        },
        {
            key: "resetState",
            value: function resetState(e) {
                this._primitiveElement = void 0, this._genericElement = void 0, this.finalTranscript = "", this.finalSpan.innerHTML = "", this.interimSpan.innerHTML = "", this.scrollingSpan.innerHTML = "", this.startPadding = "", this.endPadding = "", this.isHighlighted = !1, this.primitiveTextRecorded = !1, this.numberOfSpacesBeforeNewText = 0, this.numberOfSpacesAfterNewText = 0, e || (this.stopTimeout = void 0);
            }
        },
        {
            key: "setStateOnStart",
            value: function setStateOnStart() {
                var e;
                this.recognizing = !0, this.isRestarting ? this.isRestarting = !1 : (e = this._onStart) === null || e === void 0 || e.call(this);
            }
        },
        {
            key: "setStateOnStop",
            value: function setStateOnStop() {
                var e;
                this.recognizing = !1, this.isRestarting || (e = this._onStop) === null || e === void 0 || e.call(this);
            }
        },
        {
            key: "setStateOnError",
            value: function setStateOnError(e) {
                var t;
                (t = this._onError) === null || t === void 0 || t.call(this, e), this.recognizing = !1;
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$ni.Speech = $8e4453fb4fc895c8$var$ga;
Object.defineProperty($8e4453fb4fc895c8$var$qi, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$qi.WebSpeech = void 0;
var $8e4453fb4fc895c8$var$fn = $8e4453fb4fc895c8$var$zi, $8e4453fb4fc895c8$var$pn = $8e4453fb4fc895c8$var$Mt, $8e4453fb4fc895c8$var$ba = $8e4453fb4fc895c8$var$ni;
var $8e4453fb4fc895c8$var$Ii = /*#__PURE__*/ function(_ba$Speech) {
    function Ii() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ii);
        return $8e4453fb4fc895c8$var$_callSuper(this, Ii);
    }
    $8e4453fb4fc895c8$var$_inherits(Ii, _ba$Speech);
    return $8e4453fb4fc895c8$var$_createClass(Ii, [
        {
            key: "start",
            value: function start(e) {
                var t;
                this._extractText === void 0 && (this._extractText = $8e4453fb4fc895c8$var$pn.Browser.IS_SAFARI() ? $8e4453fb4fc895c8$var$fn.WebSpeechTranscript.extractSafari : $8e4453fb4fc895c8$var$fn.WebSpeechTranscript.extract), this.validate() && (this.prepareBeforeStart(e), this.instantiateService(e), (t = this._service) === null || t === void 0 || t.start(), this._translations = e == null ? void 0 : e.translations);
            }
        },
        {
            key: "validate",
            value: function validate() {
                return Ii.getAPI() ? !0 : (this.error("Speech Recognition is unsupported"), !1);
            }
        },
        {
            key: "instantiateService",
            value: function instantiateService(e) {
                var t, i;
                var s = Ii.getAPI();
                this._service = new s(), this._service.continuous = !0, this._service.interimResults = (t = e == null ? void 0 : e.displayInterimResults) !== null && t !== void 0 ? t : !0, this._service.lang = ((i = e == null ? void 0 : e.language) === null || i === void 0 ? void 0 : i.trim()) || "en-US", this.setEvents();
            }
        },
        {
            key: "setEvents",
            value: function setEvents() {
                var _this59 = this;
                this._service && (this._service.onstart = function() {
                    _this59.setStateOnStart();
                }, this._service.onerror = function(e) {
                    $8e4453fb4fc895c8$var$pn.Browser.IS_SAFARI() && e.message === "Another request is started" || e.error === "aborted" && _this59.isRestarting || e.error !== "no-speech" && _this59.error(e.message || e.error);
                }, this._service.onaudioend = function() {
                    _this59.setStateOnStop();
                }, this._service.onend = function() {
                    _this59._stopping = !1;
                }, this._service.onresult = function(e) {
                    if ($8e4453fb4fc895c8$var$_typeof(e.results) > "u" && _this59._service) _this59._service.onend = null, _this59._service.stop();
                    else if (_this59._extractText && !_this59._stopping) {
                        var _this59$_extractText = _this59._extractText(e, _this59.finalTranscript, _this59._translations), t = _this59$_extractText.interimTranscript, _i18 = _this59$_extractText.finalTranscript, s = _this59$_extractText.newText;
                        _this59.updateElements(t, _i18, s);
                    }
                });
            }
        },
        {
            key: "stop",
            value: function stop(e) {
                var t;
                this._stopping = !0, (t = this._service) === null || t === void 0 || t.stop(), this.finalise(e);
            }
        },
        {
            key: "error",
            value: function error(e) {
                console.error(e), this.setStateOnError(e), this.stop();
            }
        }
    ], [
        {
            key: "getAPI",
            value: function getAPI() {
                return window.webkitSpeechRecognition || window.SpeechRecognition;
            }
        }
    ]);
}($8e4453fb4fc895c8$var$ba.Speech);
$8e4453fb4fc895c8$var$qi.WebSpeech = $8e4453fb4fc895c8$var$Ii;
var $8e4453fb4fc895c8$var$Ki = {};
Object.defineProperty($8e4453fb4fc895c8$var$Ki, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$Ki.GlobalState = void 0;
var $8e4453fb4fc895c8$var$At = /*#__PURE__*/ function() {
    function At() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, At);
    }
    return $8e4453fb4fc895c8$var$_createClass(At, null, [
        {
            key: "doubleClickDetector",
            value: function doubleClickDetector() {
                return At.doubleClickPending ? !0 : (At.doubleClickPending = !0, setTimeout(function() {
                    At.doubleClickPending = !1;
                }, 300), !1);
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$Ki.GlobalState = $8e4453fb4fc895c8$var$At;
$8e4453fb4fc895c8$var$At.doubleClickPending = !1;
var $8e4453fb4fc895c8$var$Ji = {}, $8e4453fb4fc895c8$var$Zi = {};
Object.defineProperty($8e4453fb4fc895c8$var$Zi, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$Zi.PreventConnectionStop = void 0;
var $8e4453fb4fc895c8$var$va = /*#__PURE__*/ function() {
    function va() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, va);
    }
    return $8e4453fb4fc895c8$var$_createClass(va, null, [
        {
            key: "applyPrevention",
            value: function applyPrevention(e) {
                clearTimeout(e._manualConnectionStopPrevention), e.cannotBeStopped = !0, e._manualConnectionStopPrevention = setTimeout(function() {
                    e.cannotBeStopped = !1;
                }, 800);
            }
        },
        {
            key: "clearPrevention",
            value: function clearPrevention(e) {
                clearTimeout(e._manualConnectionStopPrevention), e.cannotBeStopped = !1;
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$Zi.PreventConnectionStop = $8e4453fb4fc895c8$var$va;
var $8e4453fb4fc895c8$var$Xi = {}, $8e4453fb4fc895c8$var$Yi = {};
Object.defineProperty($8e4453fb4fc895c8$var$Yi, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$Yi.README_URL = void 0;
$8e4453fb4fc895c8$var$Yi.README_URL = "https://github.com/OvidijusParsiunas/speech-to-element";
Object.defineProperty($8e4453fb4fc895c8$var$Xi, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$Xi.AzureSpeechConfig = void 0;
var $8e4453fb4fc895c8$var$ls = $8e4453fb4fc895c8$var$Yi;
var $8e4453fb4fc895c8$var$Li = /*#__PURE__*/ function() {
    function Li() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Li);
    }
    return $8e4453fb4fc895c8$var$_createClass(Li, null, [
        {
            key: "validateOptions",
            value: function validateOptions(e, t) {
                return t ? !t.subscriptionKey && !t.token && !t.retrieveToken ? (e("Please define a 'subscriptionKey', 'token' or 'retrieveToken' property - more info: ".concat($8e4453fb4fc895c8$var$ls.README_URL)), !1) : t.region ? !0 : (e("Please define a 'region' property - more info: ".concat($8e4453fb4fc895c8$var$ls.README_URL)), !1) : (e("Please provide subscription details - more info: ".concat($8e4453fb4fc895c8$var$ls.README_URL)), !1);
            }
        },
        {
            key: "getNewSpeechConfig",
            value: function() {
                var _getNewSpeechConfig = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee112(e, t) {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee112$(_context112) {
                        while(true)switch(_context112.prev = _context112.next){
                            case 0:
                                if (!t.region) {
                                    _context112.next = 2;
                                    break;
                                }
                                return _context112.abrupt("return", t.subscriptionKey ? e.fromSubscription(t.subscriptionKey.trim(), t.region.trim()) : t.token ? e.fromAuthorizationToken(t.token.trim(), t.region.trim()) : t.retrieveToken ? t.retrieveToken().then(function(i) {
                                    return t.region ? e.fromAuthorizationToken((i == null ? void 0 : i.trim()) || "", t.region.trim()) : null;
                                })["catch"](function(i) {
                                    return console.error(i), null;
                                }) : null);
                            case 2:
                            case "end":
                                return _context112.stop();
                        }
                    }, _callee112);
                }));
                function getNewSpeechConfig(_x203, _x204) {
                    return _getNewSpeechConfig.apply(this, arguments);
                }
                return getNewSpeechConfig;
            }()
        },
        {
            key: "process",
            value: function process(e, t) {
                t.language && (e.speechRecognitionLanguage = t.language.trim());
            }
        },
        {
            key: "get",
            value: function() {
                var _get = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee113(e, t) {
                    var i;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee113$(_context113) {
                        while(true)switch(_context113.prev = _context113.next){
                            case 0:
                                _context113.next = 2;
                                return Li.getNewSpeechConfig(e, t);
                            case 2:
                                i = _context113.sent;
                                return _context113.abrupt("return", (i && Li.process(i, t), i));
                            case 4:
                            case "end":
                                return _context113.stop();
                        }
                    }, _callee113);
                }));
                function get(_x205, _x206) {
                    return _get.apply(this, arguments);
                }
                return get;
            }()
        }
    ]);
}();
$8e4453fb4fc895c8$var$Xi.AzureSpeechConfig = $8e4453fb4fc895c8$var$Li;
var $8e4453fb4fc895c8$var$Qi = {};
Object.defineProperty($8e4453fb4fc895c8$var$Qi, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$Qi.StopTimeout = void 0;
var $8e4453fb4fc895c8$var$Zt = /*#__PURE__*/ function() {
    function Zt() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Zt);
    }
    return $8e4453fb4fc895c8$var$_createClass(Zt, null, [
        {
            key: "set",
            value: function set(e) {
                e.stopTimeout = setTimeout(function() {
                    return e.stop();
                }, e.stopTimeoutMS);
            }
        },
        {
            key: "reset",
            value: function reset(e, t) {
                e.stopTimeoutMS = t || Zt.DEFAULT_MS, e.stopTimeout && clearTimeout(e.stopTimeout), Zt.set(e);
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$Qi.StopTimeout = $8e4453fb4fc895c8$var$Zt;
$8e4453fb4fc895c8$var$Zt.DEFAULT_MS = 2e4;
var $8e4453fb4fc895c8$var$es = {};
Object.defineProperty($8e4453fb4fc895c8$var$es, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$es.AzureTranscript = void 0;
var $8e4453fb4fc895c8$var$ya = $8e4453fb4fc895c8$var$si;
var $8e4453fb4fc895c8$var$Ea = /*#__PURE__*/ function() {
    function Ea() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ea);
    }
    return $8e4453fb4fc895c8$var$_createClass(Ea, null, [
        {
            key: "extract",
            value: // newText is used to only send new text in onResult as finalTranscript is continuously accumulated
            function extract(e, t, i, s) {
                return s && (e = $8e4453fb4fc895c8$var$ya.Translate.translate(e, s)), i ? {
                    interimTranscript: "",
                    finalTranscript: t + e,
                    newText: e
                } : {
                    interimTranscript: e,
                    finalTranscript: t,
                    newText: e
                };
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$es.AzureTranscript = $8e4453fb4fc895c8$var$Ea;
Object.defineProperty($8e4453fb4fc895c8$var$Ji, "__esModule", {
    value: !0
});
$8e4453fb4fc895c8$var$Ji.Azure = void 0;
var $8e4453fb4fc895c8$var$mn = $8e4453fb4fc895c8$var$Zi, $8e4453fb4fc895c8$var$gn = $8e4453fb4fc895c8$var$Xi, $8e4453fb4fc895c8$var$cs = $8e4453fb4fc895c8$var$Qi, $8e4453fb4fc895c8$var$bn = $8e4453fb4fc895c8$var$es, $8e4453fb4fc895c8$var$Sa = $8e4453fb4fc895c8$var$ni;
var $8e4453fb4fc895c8$var$Pi = /*#__PURE__*/ function(_Sa$Speech) {
    function Pi() {
        var _this60;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Pi);
        _this60 = $8e4453fb4fc895c8$var$_callSuper(this, Pi, arguments), _this60._newTextPadding = "";
        return _this60;
    }
    $8e4453fb4fc895c8$var$_inherits(Pi, _Sa$Speech);
    return $8e4453fb4fc895c8$var$_createClass(Pi, [
        {
            key: "start",
            value: function start(e, t) {
                this._newTextPadding = "", this.stopTimeout === void 0 && $8e4453fb4fc895c8$var$cs.StopTimeout.reset(this, e == null ? void 0 : e.stopAfterSilenceMs), this.prepareBeforeStart(e), this.startAsync(e), t || $8e4453fb4fc895c8$var$mn.PreventConnectionStop.applyPrevention(this);
            }
        },
        {
            key: "startAsync",
            value: function() {
                var _startAsync = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee114(e) {
                    var t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee114$(_context114) {
                        while(true)switch(_context114.prev = _context114.next){
                            case 0:
                                _context114.t0 = this.validate(e);
                                if (!_context114.t0) {
                                    _context114.next = 6;
                                    break;
                                }
                                _context114.next = 4;
                                return this.instantiateService(e);
                            case 4:
                                this._translations = e == null ? void 0 : e.translations;
                                (t = this._service) === null || t === void 0 || t.startContinuousRecognitionAsync(function() {}, this.error);
                            case 6:
                            case "end":
                                return _context114.stop();
                        }
                    }, _callee114, this);
                }));
                function startAsync(_x207) {
                    return _startAsync.apply(this, arguments);
                }
                return startAsync;
            }()
        },
        {
            key: "validate",
            value: function validate(e) {
                return Pi.getAPI() ? $8e4453fb4fc895c8$var$gn.AzureSpeechConfig.validateOptions(this.error.bind(this), e) : (this.moduleNotFound(), !1);
            }
        },
        {
            key: "instantiateService",
            value: function() {
                var _instantiateService = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee115(e) {
                    var t, i, s, r;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee115$(_context115) {
                        while(true)switch(_context115.prev = _context115.next){
                            case 0:
                                t = Pi.getAPI();
                                i = t.AudioConfig.fromDefaultMicrophoneInput();
                                _context115.next = 4;
                                return $8e4453fb4fc895c8$var$gn.AzureSpeechConfig.get(t.SpeechConfig, e);
                            case 4:
                                s = _context115.sent;
                                if (s) {
                                    r = new t.SpeechRecognizer(s, i);
                                    this.setEvents(r), this._service = r, e.retrieveToken && this.retrieveTokenInterval(e.retrieveToken);
                                } else this.error("Unable to contact Azure server");
                            case 6:
                            case "end":
                                return _context115.stop();
                        }
                    }, _callee115, this);
                }));
                function instantiateService(_x208) {
                    return _instantiateService.apply(this, arguments);
                }
                return instantiateService;
            }()
        },
        {
            key: "setEvents",
            value: function setEvents(e) {
                e.recognizing = this.onRecognizing.bind(this), e.recognized = this.onRecognized.bind(this), e.sessionStarted = this.onSessionStarted.bind(this), e.canceled = this.onCanceled.bind(this), e.sessionStopped = this.onSessionStopped.bind(this);
            }
        },
        {
            key: "onRecognizing",
            value: function onRecognizing(e, t) {
                if (this._stopping) return;
                var _bn$AzureTranscript$e = $8e4453fb4fc895c8$var$bn.AzureTranscript.extract(this._newTextPadding + t.result.text, this.finalTranscript, !1, this._translations), i = _bn$AzureTranscript$e.interimTranscript, s = _bn$AzureTranscript$e.finalTranscript, r = _bn$AzureTranscript$e.newText;
                $8e4453fb4fc895c8$var$cs.StopTimeout.reset(this, this.stopTimeoutMS), this.updateElements(i, s, r);
            }
        },
        {
            key: "onRecognized",
            value: function onRecognized(e, t) {
                var i = t.result;
                switch(i.reason){
                    case window.SpeechSDK.ResultReason.Canceled:
                        break;
                    case window.SpeechSDK.ResultReason.RecognizedSpeech:
                        if (i.text && !this._stopping) {
                            var _bn$AzureTranscript$e2 = $8e4453fb4fc895c8$var$bn.AzureTranscript.extract(this._newTextPadding + i.text, this.finalTranscript, !0, this._translations), s = _bn$AzureTranscript$e2.interimTranscript, r = _bn$AzureTranscript$e2.finalTranscript, o = _bn$AzureTranscript$e2.newText;
                            $8e4453fb4fc895c8$var$cs.StopTimeout.reset(this, this.stopTimeoutMS), this.updateElements(s, r, o), r !== "" && (this._newTextPadding = " ");
                        }
                        break;
                }
            }
        },
        {
            key: "onCanceled",
            value: function onCanceled(e, t) {
                t.reason === window.SpeechSDK.CancellationReason.Error && this.error(t.errorDetails);
            }
        },
        {
            key: "onSessionStarted",
            value: function onSessionStarted() {
                $8e4453fb4fc895c8$var$mn.PreventConnectionStop.clearPrevention(this), this.setStateOnStart();
            }
        },
        {
            key: "onSessionStopped",
            value: function onSessionStopped() {
                this._retrieveTokenInterval || clearInterval(this._retrieveTokenInterval), this._stopping = !1, this.setStateOnStop();
            }
        },
        {
            key: "retrieveTokenInterval",
            value: function retrieveTokenInterval(e) {
                var _this61 = this;
                this._retrieveTokenInterval = setInterval(function() {
                    e == null || e().then(function(t) {
                        _this61._service && (_this61._service.authorizationToken = (t == null ? void 0 : t.trim()) || "");
                    })["catch"](function(t) {
                        _this61.error(t);
                    });
                }, 1e4);
            }
        },
        {
            key: "stop",
            value: function stop(e) {
                var t;
                !e && this._retrieveTokenInterval && clearInterval(this._retrieveTokenInterval), this._stopping = !0, (t = this._service) === null || t === void 0 || t.stopContinuousRecognitionAsync(), this.finalise(e);
            }
        },
        {
            key: "moduleNotFound",
            value: function moduleNotFound() {
                console.error("speech recognition module not found:"), console.error("please install the 'microsoft-cognitiveservices-speech-sdk' npm package or add a script tag: <script src=\"https://aka.ms/csspeech/jsbrowserpackageraw\"></script>"), this.setStateOnError("speech recognition module not found");
            }
        },
        {
            key: "error",
            value: function error(e) {
                this._retrieveTokenInterval && clearInterval(this._retrieveTokenInterval), console.error(e), this.setStateOnError(e), this.stop();
            }
        }
    ], [
        {
            key: "getAPI",
            value: function getAPI() {
                return window.SpeechSDK;
            }
        }
    ]);
}($8e4453fb4fc895c8$var$Sa.Speech);
$8e4453fb4fc895c8$var$Ji.Azure = $8e4453fb4fc895c8$var$Pi;
Object.defineProperty($8e4453fb4fc895c8$var$In, "__esModule", {
    value: !0
});
var $8e4453fb4fc895c8$var$vn = $8e4453fb4fc895c8$var$qi, $8e4453fb4fc895c8$var$xa = $8e4453fb4fc895c8$var$ri, $8e4453fb4fc895c8$var$pe = $8e4453fb4fc895c8$var$Ki, $8e4453fb4fc895c8$var$_a = $8e4453fb4fc895c8$var$Ji;
var $8e4453fb4fc895c8$var$pt = /*#__PURE__*/ function() {
    function pt() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, pt);
    }
    return $8e4453fb4fc895c8$var$_createClass(pt, null, [
        {
            key: "toggle",
            value: function toggle(e, t) {
                var i, s;
                var r = e.toLocaleLowerCase().trim();
                !((i = $8e4453fb4fc895c8$var$pe.GlobalState.service) === null || i === void 0) && i.recognizing ? this.stop() : r === "webspeech" ? pt.startWebSpeech(t) : r === "azure" ? pt.startAzure(t) : (console.error("service not found - must be either 'webspeech' or 'azure'"), (s = t == null ? void 0 : t.onError) === null || s === void 0 || s.call(t, "service not found - must be either 'webspeech' or 'azure'"));
            }
        },
        {
            key: "startWebSpeech",
            value: function startWebSpeech(e) {
                pt.stop() || ($8e4453fb4fc895c8$var$pe.GlobalState.service = new $8e4453fb4fc895c8$var$vn.WebSpeech(), $8e4453fb4fc895c8$var$pe.GlobalState.service.start(e));
            }
        },
        {
            key: "isWebSpeechSupported",
            value: function isWebSpeechSupported() {
                return !!$8e4453fb4fc895c8$var$vn.WebSpeech.getAPI();
            }
        },
        {
            key: "startAzure",
            value: function startAzure(e) {
                var t;
                pt.stop() || !((t = $8e4453fb4fc895c8$var$pe.GlobalState.service) === null || t === void 0) && t.cannotBeStopped || ($8e4453fb4fc895c8$var$pe.GlobalState.service = new $8e4453fb4fc895c8$var$_a.Azure(), $8e4453fb4fc895c8$var$pe.GlobalState.service.start(e));
            }
        },
        {
            key: "stop",
            value: function stop() {
                var e;
                return $8e4453fb4fc895c8$var$pe.GlobalState.doubleClickDetector() ? !0 : (!((e = $8e4453fb4fc895c8$var$pe.GlobalState.service) === null || e === void 0) && e.recognizing && $8e4453fb4fc895c8$var$pe.GlobalState.service.stop(), !1);
            }
        },
        {
            key: "endCommandMode",
            value: function endCommandMode() {
                $8e4453fb4fc895c8$var$pe.GlobalState.service && $8e4453fb4fc895c8$var$xa.CommandUtils.toggleCommandModeOff($8e4453fb4fc895c8$var$pe.GlobalState.service);
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$ui = $8e4453fb4fc895c8$var$In["default"] = $8e4453fb4fc895c8$var$pt;
var $8e4453fb4fc895c8$var$wa = /*#__PURE__*/ function() {
    function wa(e, t) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, wa);
        this.silenceMS = 2e3, this.stop = !0, typeof t == "boolean" && t === !1 && (this.stop = !1), typeof e == "number" && (this.silenceMS = e);
    }
    return $8e4453fb4fc895c8$var$_createClass(wa, [
        {
            key: "setSilenceTimeout",
            value: function setSilenceTimeout(e, t) {
                var _this62 = this;
                this._silenceTimeout = setTimeout(function() {
                    var i;
                    (i = e.submit) == null || i.call(e), $8e4453fb4fc895c8$var$ui.stop(), _this62.stop || setTimeout(t, $8e4453fb4fc895c8$var$Xt.MICROPHONE_RESET_TIMEOUT_MS);
                }, this.silenceMS);
            }
        },
        {
            key: "clearSilenceTimeout",
            value: function clearSilenceTimeout() {
                this._silenceTimeout && clearTimeout(this._silenceTimeout);
            }
        },
        {
            key: "resetSilenceTimeout",
            value: function resetSilenceTimeout(e, t) {
                this.clearSilenceTimeout(), this.setSilenceTimeout(e, t);
            }
        },
        {
            key: "onPause",
            value: function onPause(e, t, i) {
                e ? this.resetSilenceTimeout(t, i) : this.clearSilenceTimeout();
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$qt = /*#__PURE__*/ function(_Jt) {
    function qt(e, t, i) {
        var _this63;
        $8e4453fb4fc895c8$var$_classCallCheck(this, qt);
        var s = $8e4453fb4fc895c8$var$_typeof(e.speechToText) == "object" ? e.speechToText : {};
        _this63 = $8e4453fb4fc895c8$var$_callSuper(this, qt, [
            s == null ? void 0 : s.button
        ]);
        var _this63$processConfig = _this63.processConfiguration(t, e.speechToText), r = _this63$processConfig.serviceName, o = _this63$processConfig.processedConfig;
        if (_this63._addErrorMessage = i, r === "webspeech" && !$8e4453fb4fc895c8$var$ui.isWebSpeechSupported()) _this63.changeToUnsupported();
        else {
            var a = !e.textInput || !e.textInput.disabled;
            _this63.elementRef.onclick = _this63.buttonClick.bind(_this63, t, a, r, o);
        }
        setTimeout(function() {
            _this63._validationHandler = e._validationHandler;
        });
        return _this63;
    }
    // prettier-ignore
    $8e4453fb4fc895c8$var$_inherits(qt, _Jt);
    return $8e4453fb4fc895c8$var$_createClass(qt, [
        {
            key: "processConfiguration",
            value: function processConfiguration(e, t) {
                var _i$displayInterimResu, _i$textColor, _i$translations, _i$commands, _i$events;
                var c;
                var i = $8e4453fb4fc895c8$var$_typeof(t) == "object" ? t : {}, s = $8e4453fb4fc895c8$var$_typeof(i.webSpeech) == "object" ? i.webSpeech : {}, r = i.azure || {}, o = $8e4453fb4fc895c8$var$_objectSpread($8e4453fb4fc895c8$var$_objectSpread({
                    displayInterimResults: (_i$displayInterimResu = i.displayInterimResults) !== null && _i$displayInterimResu !== void 0 ? _i$displayInterimResu : void 0,
                    textColor: (_i$textColor = i.textColor) !== null && _i$textColor !== void 0 ? _i$textColor : void 0,
                    translations: (_i$translations = i.translations) !== null && _i$translations !== void 0 ? _i$translations : void 0,
                    commands: (_i$commands = i.commands) !== null && _i$commands !== void 0 ? _i$commands : void 0,
                    events: (_i$events = i.events) !== null && _i$events !== void 0 ? _i$events : void 0
                }, s), r), a = (c = i.commands) == null ? void 0 : c.submit;
                return a && (o.onPreResult = function(d) {
                    return d.toLowerCase().includes(a) ? (setTimeout(function() {
                        var h;
                        return (h = e.submit) == null ? void 0 : h.call(e);
                    }), $8e4453fb4fc895c8$var$ui.endCommandMode(), {
                        restart: !0,
                        removeNewText: !0
                    }) : null;
                }), i.submitAfterSilence && (this._silenceSubmit = new $8e4453fb4fc895c8$var$wa(i.submitAfterSilence, i.stopAfterSubmit)), {
                    serviceName: qt.getServiceName(i),
                    processedConfig: o
                };
            }
        },
        {
            key: "buttonClick",
            value: function buttonClick(e, t, i, s) {
                var _this64 = this;
                var r = s == null ? void 0 : s.events;
                e.removePlaceholderStyle(), $8e4453fb4fc895c8$var$ui.toggle(i, $8e4453fb4fc895c8$var$_objectSpread({
                    insertInCursorLocation: !1,
                    element: t ? e.inputElementRef : void 0,
                    onError: function onError() {
                        var o;
                        _this64.onError(), (o = _this64._silenceSubmit) == null || o.clearSilenceTimeout();
                    },
                    onStart: function onStart() {
                        var o;
                        _this64.changeToActive(), (o = r == null ? void 0 : r.onStart) == null || o.call(r);
                    },
                    onStop: function onStop() {
                        var o, a, l;
                        (o = _this64._validationHandler) == null || o.call(_this64), (a = _this64._silenceSubmit) == null || a.clearSilenceTimeout(), _this64.changeToDefault(), (l = r == null ? void 0 : r.onStop) == null || l.call(r);
                    },
                    onPauseTrigger: function onPauseTrigger(o) {
                        var a, l;
                        (a = _this64._silenceSubmit) == null || a.onPause(o, e, _this64.elementRef.onclick), (l = r == null ? void 0 : r.onPauseTrigger) == null || l.call(r, o);
                    },
                    onPreResult: function onPreResult(o, a) {
                        var l;
                        (l = r == null ? void 0 : r.onPreResult) == null || l.call(r, o, a);
                    },
                    onResult: function onResult(o, a) {
                        var l, c, d;
                        a && ((l = _this64._validationHandler) == null || l.call(_this64)), (c = _this64._silenceSubmit) == null || c.resetSilenceTimeout(e, _this64.elementRef.onclick), (d = r == null ? void 0 : r.onResult) == null || d.call(r, o, a);
                    },
                    onCommandModeTrigger: function onCommandModeTrigger(o) {
                        var a;
                        _this64.onCommandModeTrigger(o), (a = r == null ? void 0 : r.onCommandModeTrigger) == null || a.call(r, o);
                    }
                }, s));
            }
        },
        {
            key: "onCommandModeTrigger",
            value: function onCommandModeTrigger(e) {
                e ? this.changeToCommandMode() : this.changeToActive();
            }
        },
        {
            key: "onError",
            value: function onError() {
                this._addErrorMessage("speechToText", "speech input error");
            }
        }
    ], [
        {
            key: "getServiceName",
            value: function getServiceName(e) {
                return e.azure ? "azure" : "webspeech";
            }
        },
        {
            key: "toggleSpeechAfterSubmit",
            value: function toggleSpeechAfterSubmit(e) {
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                e.click(), t || setTimeout(function() {
                    return e.click();
                }, qt.MICROPHONE_RESET_TIMEOUT_MS);
            }
        }
    ]);
}($8e4453fb4fc895c8$var$Jt);
$8e4453fb4fc895c8$var$qt.MICROPHONE_RESET_TIMEOUT_MS = 300;
var $8e4453fb4fc895c8$var$Xt = $8e4453fb4fc895c8$var$qt;
var $8e4453fb4fc895c8$var$Pe = /*#__PURE__*/ function() {
    // prettier-ignore
    function Pe(e, t, i, s) {
        var _this65 = this;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Pe);
        this._attachments = [], this._fileCountLimit = 99, this._acceptedFormat = "", t.maxNumberOfFiles && (this._fileCountLimit = t.maxNumberOfFiles), this._toggleContainerDisplay = i, this._fileAttachmentsContainerRef = s, t.acceptedFormats && (this._acceptedFormat = t.acceptedFormats), setTimeout(function() {
            _this65._validationHandler = e._validationHandler;
        });
    }
    return $8e4453fb4fc895c8$var$_createClass(Pe, [
        {
            key: "attemptAddFile",
            value: function attemptAddFile(e, t) {
                return Pe.isFileTypeValid(e, this._acceptedFormat) ? (this.addAttachmentBasedOnType(e, t, !0), !0) : !1;
            }
        },
        {
            key: "addAttachmentBasedOnType",
            value: function addAttachmentBasedOnType(e, t, i) {
                var s = Pe.getTypeFromBlob(e);
                if (s === "image") {
                    var r = Pe.createImageAttachment(t);
                    this.addFileAttachment(e, "image", r, i);
                } else if (s === "audio") {
                    var _r3 = $8e4453fb4fc895c8$var$Yt.createAudioAttachment(t);
                    this.addFileAttachment(e, "audio", _r3, i);
                } else {
                    var _r4 = Pe.createAnyFileAttachment(e.name);
                    this.addFileAttachment(e, "any", _r4, i);
                }
            }
        },
        {
            key: "addFileAttachment",
            value: function addFileAttachment(e, t, i, s) {
                var a;
                var r = Pe.createContainer(i);
                if (this._attachments.length >= this._fileCountLimit) {
                    var l = this._attachments[this._attachments.length - 1].removeButton;
                    l == null || l.click();
                    var c = this._fileAttachmentsContainerRef.children;
                    this._fileAttachmentsContainerRef.insertBefore(r, c[0]);
                } else this._fileAttachmentsContainerRef.appendChild(r);
                var o = {
                    file: e,
                    attachmentContainerElement: r,
                    fileType: t
                };
                return s && (o.removeButton = this.createRemoveAttachmentButton(o), r.appendChild(o.removeButton)), this._toggleContainerDisplay(!0), this._attachments.push(o), this._fileAttachmentsContainerRef.scrollTop = this._fileAttachmentsContainerRef.scrollHeight, (a = this._validationHandler) == null || a.call(this), o;
            }
        },
        {
            key: "createRemoveAttachmentButton",
            value: function createRemoveAttachmentButton(e) {
                var t = document.createElement("div");
                t.classList.add("remove-file-attachment-button"), t.onclick = this.removeAttachment.bind(this, e);
                var i = document.createElement("div");
                return i.classList.add("x-icon"), i.innerText = "\xd7", t.appendChild(i), t;
            }
        },
        {
            key: "removeAttachment",
            value: function removeAttachment(e) {
                var s;
                var t = this._attachments.findIndex(function(r) {
                    return r === e;
                }), i = this._attachments[t].attachmentContainerElement;
                this._attachments.splice(t, 1), $8e4453fb4fc895c8$var$Yt.stopAttachmentPlayback(i), i.remove(), this._toggleContainerDisplay(!1), (s = this._validationHandler) == null || s.call(this);
            }
        },
        {
            key: "getFiles",
            value: function getFiles() {
                return Array.from(this._attachments).map(function(e) {
                    return {
                        file: e.file,
                        type: e.fileType
                    };
                });
            }
        },
        {
            key: "removeAllAttachments",
            value: function removeAllAttachments() {
                this._attachments.forEach(function(e) {
                    setTimeout(function() {
                        var t;
                        return (t = e.removeButton) == null ? void 0 : t.click();
                    });
                });
            }
        }
    ], [
        {
            key: "isFileTypeValid",
            value: function isFileTypeValid(e, t) {
                if (t === "") return !0;
                var i = t.split(",");
                for(var s = 0; s < i.length; s++){
                    var r = i[s].trim();
                    if (e.type === r) return !0;
                    if (r.startsWith(".")) {
                        var o = r.slice(1);
                        if (e.name.endsWith(o)) return !0;
                    } else {
                        if (e.name.endsWith(r)) return !0;
                        if (r.endsWith("/*") && e.type.startsWith(r.slice(0, -2))) return !0;
                    }
                }
                return !1;
            }
        },
        {
            key: "getTypeFromBlob",
            value: function getTypeFromBlob(e) {
                var t = e.type;
                return t.startsWith("image") ? "image" : t.startsWith("audio") ? "audio" : "any";
            }
        },
        {
            key: "createImageAttachment",
            value: function createImageAttachment(e) {
                var t = new Image();
                return t.src = e, t.classList.add("image-attachment"), t;
            }
        },
        {
            key: "createAnyFileAttachment",
            value: function createAnyFileAttachment(e) {
                var t = document.createElement("div");
                t.classList.add("border-bound-attachment"), $8e4453fb4fc895c8$var$Ct.IS_SAFARI && t.classList.add("border-bound-attachment-safari");
                var i = document.createElement("div");
                i.classList.add("any-file-attachment-text");
                var s = document.createElement("div");
                return s.classList.add("file-attachment-text-container"), s.appendChild(i), i.textContent = e, t.appendChild(s), t;
            }
        },
        {
            key: "createContainer",
            value: function createContainer(e) {
                var t = document.createElement("div");
                return t.classList.add("file-attachment"), t.appendChild(e), t;
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Aa = '<?xml version="1.0" encoding="utf-8"?>\n<svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">\n  <title>play</title>\n  <path d="M5.92 24.096q0 1.088 0.928 1.728 0.512 0.288 1.088 0.288 0.448 0 0.896-0.224l16.16-8.064q0.48-0.256 0.8-0.736t0.288-1.088-0.288-1.056-0.8-0.736l-16.16-8.064q-0.448-0.224-0.896-0.224-0.544 0-1.088 0.288-0.928 0.608-0.928 1.728v16.16z"></path>\n</svg>', $8e4453fb4fc895c8$var$yn = '<?xml version="1.0" encoding="utf-8"?>\n<svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">\n<title>stop</title>\n<path d="M5.92 24.096q0 0.832 0.576 1.408t1.44 0.608h16.128q0.832 0 1.44-0.608t0.576-1.408v-16.16q0-0.832-0.576-1.44t-1.44-0.576h-16.128q-0.832 0-1.44 0.576t-0.576 1.44v16.16z"></path>\n</svg>', $8e4453fb4fc895c8$var$Re = /*#__PURE__*/ function(_Pe) {
    // prettier-ignore
    function Re(e, t, i, s) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Re);
        return $8e4453fb4fc895c8$var$_callSuper(this, Re, [
            e,
            t,
            i,
            s
        ]);
    }
    $8e4453fb4fc895c8$var$_inherits(Re, _Pe);
    return $8e4453fb4fc895c8$var$_createClass(Re, [
        {
            key: "createTimer",
            value: function createTimer(e, t) {
                var _this66 = this;
                var i = 0;
                var s = t !== void 0 && t < Re.TIMER_LIMIT_S ? t : Re.TIMER_LIMIT_S;
                return setInterval(function() {
                    var a;
                    i += 1, i === s && ((a = _this66.stopPlaceholderCallback) == null || a.call(_this66), _this66.clearTimer()), i === 600 && e.classList.add("audio-placeholder-text-4-digits");
                    var r = Math.floor(i / 60), o = (i % 60).toString().padStart(2, "0");
                    e.textContent = "".concat(r, ":").concat(o);
                }, 1e3);
            }
        },
        {
            key: "createPlaceholderAudioAttachment",
            value: function createPlaceholderAudioAttachment(e) {
                var t = Re.createAudioContainer(), i = document.createElement("div");
                i.classList.add("audio-placeholder-text-3-digits");
                var s = document.createElement("div");
                s.classList.add("file-attachment-text-container", "audio-placeholder-text-3-digits-container"), s.appendChild(i);
                var r = $8e4453fb4fc895c8$var$re.createSVGElement($8e4453fb4fc895c8$var$yn);
                return r.classList.add("attachment-icon", "stop-icon", "not-removable-attachment-icon"), i.textContent = "0:00", this._activePlaceholderTimer = this.createTimer(i, e), t.appendChild(s), this.addPlaceholderAudioAttachmentEvents(t, r, s), t;
            }
        },
        {
            key: "addPlaceholderAudioAttachmentEvents",
            value: function addPlaceholderAudioAttachmentEvents(e, t, i) {
                var _this67 = this;
                var s = function s() {
                    return e.replaceChildren(t);
                };
                e.addEventListener("mouseenter", s);
                var r = function r() {
                    return e.replaceChildren(i);
                };
                e.addEventListener("mouseleave", r);
                var o = function o() {
                    var a;
                    return (a = _this67.stopPlaceholderCallback) == null ? void 0 : a.call(_this67);
                };
                e.addEventListener("click", o);
            }
        },
        {
            key: "addPlaceholderAttachment",
            value: function addPlaceholderAttachment(e, t) {
                var i = this.createPlaceholderAudioAttachment(t);
                this._activePlaceholderAttachment = this.addFileAttachment(new File([], ""), "audio", i, !1), this.stopPlaceholderCallback = e;
            }
        },
        {
            key: "completePlaceholderAttachment",
            value: function completePlaceholderAttachment(e, t) {
                var i = this._activePlaceholderAttachment;
                i && (i.file = e, Re.addAudioElements(i.attachmentContainerElement.children[0], t), i.removeButton = this.createRemoveAttachmentButton(i), i.attachmentContainerElement.appendChild(i.removeButton), this._activePlaceholderAttachment = void 0, this.clearTimer());
            }
        },
        {
            key: "removePlaceholderAttachment",
            value: function removePlaceholderAttachment() {
                this._activePlaceholderAttachment && (this.removeAttachment(this._activePlaceholderAttachment), this._activePlaceholderAttachment = void 0, this.clearTimer());
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                this._activePlaceholderTimer !== void 0 && (clearInterval(this._activePlaceholderTimer), this._activePlaceholderTimer = void 0, this.stopPlaceholderCallback = void 0);
            }
        }
    ], [
        {
            key: "createAudioContainer",
            value: function createAudioContainer() {
                var e = document.createElement("div");
                return e.classList.add("border-bound-attachment", "audio-attachment-icon-container"), $8e4453fb4fc895c8$var$Ct.IS_SAFARI && e.classList.add("border-bound-attachment-safari"), e;
            }
        },
        {
            key: "addAudioElements",
            value: function addAudioElements(e, t) {
                var i = e.parentElement ? $8e4453fb4fc895c8$var$X.cloneElement(e) : e, s = document.createElement("audio");
                s.src = t;
                var r = $8e4453fb4fc895c8$var$re.createSVGElement($8e4453fb4fc895c8$var$Aa);
                r.classList.add("attachment-icon", "play-icon");
                var o = $8e4453fb4fc895c8$var$re.createSVGElement($8e4453fb4fc895c8$var$yn);
                o.classList.add("attachment-icon", "stop-icon"), i.replaceChildren(r), s.onplay = function() {
                    i.replaceChildren(o);
                }, s.onpause = function() {
                    i.replaceChildren(r), s.currentTime = 0;
                }, s.onended = function() {
                    i.replaceChildren(r);
                }, i.onclick = function() {
                    s.paused ? s.play() : s.pause();
                };
            }
        },
        {
            key: "createAudioAttachment",
            value: function createAudioAttachment(e) {
                var t = Re.createAudioContainer();
                return Re.addAudioElements(t, e), t;
            }
        },
        {
            key: "stopAttachmentPlayback",
            value: function stopAttachmentPlayback(e) {
                var t, i, s;
                (s = (i = (t = e.children[0]) == null ? void 0 : t.children) == null ? void 0 : i[0]) != null && s.classList.contains("stop-icon") && e.children[0].click();
            }
        }
    ]);
}($8e4453fb4fc895c8$var$Pe);
$8e4453fb4fc895c8$var$Re.TIMER_LIMIT_S = 5999;
var $8e4453fb4fc895c8$var$Yt = $8e4453fb4fc895c8$var$Re;
var $8e4453fb4fc895c8$var$Ca = /*#__PURE__*/ function() {
    function Ca() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ca);
    }
    return $8e4453fb4fc895c8$var$_createClass(Ca, null, [
        {
            key: "create",
            value: // prettier-ignore
            function create(e, t, i, s, r) {
                return r === "audio" ? new $8e4453fb4fc895c8$var$Yt(e, t, i, s) : new $8e4453fb4fc895c8$var$Pe(e, t, i, s);
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$ai = /*#__PURE__*/ function() {
    function ai(e, t, i) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, ai);
        this._fileAttachmentsTypes = [], this.elementRef = this.createAttachmentContainer();
        var s = $8e4453fb4fc895c8$var$_typeof(i) == "object" && !!i.displayFileAttachmentContainer;
        this.toggleContainerDisplay(s), e.appendChild(this.elementRef), t && Object.assign(this.elementRef.style, t);
    }
    // prettier-ignore
    return $8e4453fb4fc895c8$var$_createClass(ai, [
        {
            key: "addType",
            value: function addType(e, t, i) {
                var s = $8e4453fb4fc895c8$var$Ca.create(e, t, this.toggleContainerDisplay.bind(this), this.elementRef, i);
                return this._fileAttachmentsTypes.push(s), s;
            }
        },
        {
            key: "createAttachmentContainer",
            value: function createAttachmentContainer() {
                var e = document.createElement("div");
                return e.id = "file-attachment-container", e;
            }
        },
        {
            key: "toggleContainerDisplay",
            value: function toggleContainerDisplay(e) {
                e ? this.elementRef.style.display = "block" : this.elementRef.children.length === 0 && (this.elementRef.style.display = "none");
            }
        },
        {
            key: "getAllFileData",
            value: function getAllFileData() {
                var e = this._fileAttachmentsTypes.map(function(t) {
                    return t.getFiles();
                }).flat();
                return e.length > 0 ? e : void 0;
            }
        },
        {
            key: "completePlaceholders",
            value: function() {
                var _completePlaceholders = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee117() {
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee117$(_context117) {
                        while(true)switch(_context117.prev = _context117.next){
                            case 0:
                                _context117.next = 2;
                                return Promise.all(this._fileAttachmentsTypes.map(/*#__PURE__*/ function() {
                                    var _ref33 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee116(e) {
                                        var t;
                                        return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee116$(_context116) {
                                            while(true)switch(_context116.prev = _context116.next){
                                                case 0:
                                                    return _context116.abrupt("return", (t = e.stopPlaceholderCallback) == null ? void 0 : t.call(e));
                                                case 1:
                                                case "end":
                                                    return _context116.stop();
                                            }
                                        }, _callee116);
                                    }));
                                    return function(_x209) {
                                        return _ref33.apply(this, arguments);
                                    };
                                }()));
                            case 2:
                            case "end":
                                return _context117.stop();
                        }
                    }, _callee117, this);
                }));
                function completePlaceholders() {
                    return _completePlaceholders.apply(this, arguments);
                }
                return completePlaceholders;
            }()
        },
        {
            key: "addFilesToAnyType",
            value: function addFilesToAnyType(e) {
                ai.addFilesToType(e, this._fileAttachmentsTypes);
            }
        },
        {
            key: "removeAllFiles",
            value: function removeAllFiles() {
                this._fileAttachmentsTypes.forEach(function(e) {
                    return e.removeAllAttachments();
                }), this.elementRef.replaceChildren(), this.toggleContainerDisplay(!1);
            }
        },
        {
            key: "getNumberOfTypes",
            value: function getNumberOfTypes() {
                return this._fileAttachmentsTypes.length;
            }
        }
    ], [
        {
            key: "addFilesToType",
            value: function addFilesToType(e, t) {
                e.forEach(function(i) {
                    var s = new FileReader();
                    s.readAsDataURL(i), s.onload = function(r) {
                        for(var o = 0; o < t.length && !t[o].attemptAddFile(i, r.target.result); o += 1);
                    };
                });
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$ve = /*#__PURE__*/ function() {
    function ve(e, t, i) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, ve);
        this._isOpen = !1, this._contentRef = ve.createModalContent(t, i == null ? void 0 : i.backgroundColor), this._buttonPanel = ve.createButtonPanel(i == null ? void 0 : i.backgroundColor), this._elementRef = ve.createContainer(this._contentRef, i), this._elementRef.appendChild(this._buttonPanel), e.appendChild(this._elementRef), this._backgroundPanelRef = ve.createDarkBackgroundPanel(), e.appendChild(this._backgroundPanelRef), this.addWindowEvents(e);
    }
    return $8e4453fb4fc895c8$var$_createClass(ve, [
        {
            key: "isOpen",
            value: function isOpen() {
                return this._isOpen;
            }
        },
        {
            key: "addButtons",
            value: function addButtons() {
                var _this68 = this;
                for(var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)e[_key2] = arguments[_key2];
                e.forEach(function(t) {
                    $8e4453fb4fc895c8$var$W.addAttributes(t), _this68._buttonPanel.appendChild(t);
                });
            }
        },
        {
            key: "close",
            value: function close() {
                var _this69 = this;
                this._elementRef.classList.remove("show-modal"), this._elementRef.classList.add("hide-modal"), this._backgroundPanelRef.classList.remove("show-modal-background"), this._backgroundPanelRef.classList.add("hide-modal-background"), this._isOpen = !1, setTimeout(function() {
                    _this69._elementRef.style.display = "none", _this69._backgroundPanelRef.style.display = "none";
                }, ve.MODAL_CLOSE_TIMEOUT_MS);
            }
        },
        {
            key: "displayModalElements",
            value: function displayModalElements() {
                this._elementRef.style.display = "flex", this._elementRef.classList.remove("hide-modal"), this._elementRef.classList.add("show-modal"), this._backgroundPanelRef.style.display = "block", this._backgroundPanelRef.classList.remove("hide-modal-background"), this._backgroundPanelRef.classList.add("show-modal-background"), this._isOpen = !0;
            }
        },
        {
            key: "openTextModal",
            value: function openTextModal(e) {
                this._contentRef.innerHTML = e, this.displayModalElements();
            }
        },
        {
            key: "addCloseButton",
            value: function addCloseButton(e, t, i) {
                var _this70 = this;
                var s = t ? ve.createSVGButton(e) : ve.createTextButton(e);
                return this.addButtons(s), s.onclick = function() {
                    _this70.close(), setTimeout(function() {
                        i == null || i();
                    }, 140);
                }, s;
            }
        },
        {
            key: "addWindowEvents",
            value: function addWindowEvents(e) {
                this.keyDownEvent = this.windowKeyDown.bind(this, e), window.addEventListener("keydown", this.keyDownEvent);
            }
        },
        {
            key: "windowKeyDown",
            value: function windowKeyDown(e, t) {
                var i, s;
                !e.isConnected && this.keyDownEvent ? window.removeEventListener("keydown", this.keyDownEvent) : this._isOpen && (t.key === $8e4453fb4fc895c8$var$D.ESCAPE ? (this.close(), (i = this.extensionCloseCallback) == null || i.call(this)) : t.key === $8e4453fb4fc895c8$var$D.ENTER && (this.close(), (s = this.extensionCloseCallback) == null || s.call(this)));
            }
        }
    ], [
        {
            key: "createContainer",
            value: function createContainer(e, t) {
                var i = document.createElement("div");
                return i.classList.add("modal"), i.appendChild(e), t && delete t.backgroundColor, Object.assign(i.style, t), i;
            }
        },
        {
            key: "createModalContent",
            value: function createModalContent(e, t) {
                var _i$classList;
                var i = document.createElement("div");
                return (_i$classList = i.classList).add.apply(_i$classList, $8e4453fb4fc895c8$var$_toConsumableArray(e)), t && (i.style.backgroundColor = t), document.createElement("div").appendChild(i), i;
            }
        },
        {
            key: "createButtonPanel",
            value: function createButtonPanel(e) {
                var t = document.createElement("div");
                return t.classList.add("modal-button-panel"), e && (t.style.backgroundColor = e), t;
            }
        },
        {
            key: "createDarkBackgroundPanel",
            value: function createDarkBackgroundPanel() {
                var e = document.createElement("div");
                return e.id = "modal-background-panel", e;
            }
        },
        {
            key: "createTextButton",
            value: function createTextButton(e) {
                var t = document.createElement("div");
                return t.classList.add("modal-button"), t.textContent = e, t;
            }
        },
        {
            key: "createSVGButton",
            value: function createSVGButton(e) {
                var t = document.createElement("div");
                t.classList.add("modal-button", "modal-svg-button");
                var i = $8e4453fb4fc895c8$var$re.createSVGElement(e);
                return i.classList.add("modal-svg-button-icon"), t.appendChild(i), t;
            }
        },
        {
            key: "createTextModalFunc",
            value: function createTextModalFunc(e, t, i) {
                var s;
                if ($8e4453fb4fc895c8$var$_typeof(t) == "object" && (s = t.files) != null && s.infoModal) {
                    var r = new ve(e, [
                        "modal-content"
                    ], t.files.infoModal.containerStyle);
                    return r.addCloseButton("OK", !1, i), r.openTextModal.bind(r, t.infoModalTextMarkUp || "");
                }
            }
        }
    ]);
}();
$8e4453fb4fc895c8$var$ve.MODAL_CLOSE_TIMEOUT_MS = 190;
var $8e4453fb4fc895c8$var$tt = $8e4453fb4fc895c8$var$ve;
var $8e4453fb4fc895c8$var$Ft = /*#__PURE__*/ function(_ii3) {
    // prettier-ignore
    function Ft(e, t, i, s, r, o) {
        var _this71;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ft);
        var h, f, u, m, p, v, y, P, V;
        var a = (h = i == null ? void 0 : i.button) == null ? void 0 : h.position, l = ((m = (u = (f = i == null ? void 0 : i.button) == null ? void 0 : f.styles) == null ? void 0 : u.text) == null ? void 0 : m.content) || o;
        _this71 = $8e4453fb4fc895c8$var$_callSuper(this, Ft, [
            Ft.createButtonElement(),
            a,
            i.button,
            l
        ]);
        var c = a === "dropup-menu", d = _this71.createInnerElements(s, r, _this71._customStyles, c);
        _this71._inputElement = Ft.createInputElement((p = i == null ? void 0 : i.files) == null ? void 0 : p.acceptedFormats), _this71.addClickEvent(e, i), _this71.elementRef.replaceChildren(d.styles), _this71.reapplyStateStyle("styles"), _this71._fileAttachmentsType = t, _this71._openModalOnce = ((y = (v = i.files) == null ? void 0 : v.infoModal) == null ? void 0 : y.openModalOnce) === !1 || (V = (P = i.files) == null ? void 0 : P.infoModal) == null ? void 0 : V.openModalOnce;
        return _this71;
    }
    $8e4453fb4fc895c8$var$_inherits(Ft, _ii3);
    return $8e4453fb4fc895c8$var$_createClass(Ft, [
        {
            key: "createInnerElements",
            value: function createInnerElements(e, t, i) {
                var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                var r = Ft.createSVGIconElement(e, t);
                return {
                    styles: $8e4453fb4fc895c8$var$J.createInnerElement(this.elementRef, r, "styles", i, s)
                };
            }
        },
        {
            key: "triggerImportPrompt",
            value: function triggerImportPrompt(e) {
                e.onchange = this["import"].bind(this, e), e.click();
            }
        },
        {
            key: "import",
            value: function _import(e) {
                $8e4453fb4fc895c8$var$ai.addFilesToType(Array.from(e.files || []), [
                    this._fileAttachmentsType
                ]), e.value = "";
            }
        },
        {
            key: "addClickEvent",
            value: function addClickEvent(e, t) {
                var i = this.triggerImportPrompt.bind(this, this._inputElement), s = $8e4453fb4fc895c8$var$tt.createTextModalFunc(e, t, i);
                this.elementRef.onclick = this.click.bind(this, s);
            }
        },
        {
            key: "click",
            value: function click(e) {
                e && (this._openModalOnce === void 0 || this._openModalOnce === !0) ? (e(), this._openModalOnce === !0 && (this._openModalOnce = !1)) : this.triggerImportPrompt(this._inputElement);
            }
        }
    ], [
        {
            key: "createInputElement",
            value: function createInputElement(e) {
                var t = document.createElement("input");
                return t.type = "file", t.accept = e || "", t.hidden = !0, t.multiple = !0, t;
            }
        },
        {
            key: "createButtonElement",
            value: function createButtonElement() {
                var e = document.createElement("div");
                return e.classList.add("input-button", "upload-file-button"), $8e4453fb4fc895c8$var$W.addAttributes(e), e;
            }
        },
        {
            key: "createSVGIconElement",
            value: function createSVGIconElement(e, t) {
                var i = $8e4453fb4fc895c8$var$re.createSVGElement(t);
                return i.id = e, i;
            }
        }
    ]);
}($8e4453fb4fc895c8$var$ii);
var $8e4453fb4fc895c8$var$Ie = /*#__PURE__*/ function() {
    function Ie() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ie);
    }
    return $8e4453fb4fc895c8$var$_createClass(Ie, null, [
        {
            key: "create",
            value: function create(e, t, i) {
                var s = Ie.createElement(i);
                Ie.addEvents(s, e, t), e.appendChild(s);
            }
        },
        {
            key: "createElement",
            value: function createElement(e) {
                var t = document.createElement("div");
                return t.id = "drag-and-drop", $8e4453fb4fc895c8$var$_typeof(e) == "object" && Object.assign(t.style, e), t;
            }
        },
        {
            key: "addEvents",
            value: function addEvents(e, t, i) {
                t.ondragenter = function(s) {
                    s.preventDefault(), Ie.display(e);
                }, e.ondragleave = function(s) {
                    s.preventDefault(), Ie.hide(e);
                }, e.ondragover = function(s) {
                    s.preventDefault();
                }, e.ondrop = function(s) {
                    s.preventDefault(), Ie.uploadFile(i, s), Ie.hide(e);
                };
            }
        },
        {
            key: "uploadFile",
            value: function uploadFile(e, t) {
                var s;
                var i = (s = t.dataTransfer) == null ? void 0 : s.files;
                i && e.addFilesToAnyType(Array.from(i));
            }
        },
        {
            key: "display",
            value: function display(e) {
                e.style.display = "block";
            }
        },
        {
            key: "hide",
            value: function hide(e) {
                e.style.display = "none";
            }
        },
        {
            key: "isEnabled",
            value: function isEnabled(e, t) {
                return t !== void 0 && t === !1 ? !1 : !!t || e.getNumberOfTypes() > 0;
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$We = /*#__PURE__*/ function() {
    function We() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, We);
    }
    return $8e4453fb4fc895c8$var$_createClass(We, null, [
        {
            key: "validate",
            value: // prettier-ignore
            function validate(e, t, i, s, r) {
                var o = e(i, s, r);
                return o ? t.changeToSubmitIcon() : t.changeToDisabledIcon(), o;
            }
        },
        {
            key: "useValidationFunc",
            value: function() {
                var _useValidationFunc = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee118(e, t, i, s) {
                    var r, o, a;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee118$(_context118) {
                        while(true)switch(_context118.prev = _context118.next){
                            case 0:
                                r = t.isTextInputEmpty() ? "" : t.inputElementRef.textContent;
                                _context118.next = 3;
                                return i.completePlaceholders();
                            case 3:
                                o = i.getAllFileData(), a = o == null ? void 0 : o.map(function(l) {
                                    return l.file;
                                });
                                return _context118.abrupt("return", We.validate(e, s, r, a));
                            case 5:
                            case "end":
                                return _context118.stop();
                        }
                    }, _callee118);
                }));
                function useValidationFunc(_x210, _x211, _x212, _x213) {
                    return _useValidationFunc.apply(this, arguments);
                }
                return useValidationFunc;
            }() // prettier-ignore
        },
        {
            key: "useValidationFuncProgrammatic",
            value: function() {
                var _useValidationFuncProgrammatic = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee119(e, t, i) {
                    var r, s;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee119$(_context119) {
                        while(true)switch(_context119.prev = _context119.next){
                            case 0:
                                s = (r = t.files) == null ? void 0 : r.map(function(o) {
                                    return o.file;
                                });
                                return _context119.abrupt("return", We.validate(e, i, t.text, s, !0));
                            case 2:
                            case "end":
                                return _context119.stop();
                        }
                    }, _callee119);
                }));
                function useValidationFuncProgrammatic(_x214, _x215, _x216) {
                    return _useValidationFuncProgrammatic.apply(this, arguments);
                }
                return useValidationFuncProgrammatic;
            }()
        },
        {
            key: "validateWebsocket",
            value: function validateWebsocket(e, t) {
                return e.websocket && !$8e4453fb4fc895c8$var$U.canSendMessage(e.websocket) ? (t.changeToDisabledIcon(), !1) : !0;
            }
        },
        {
            key: "attach",
            value: function attach(e, t, i, s, r) {
                var o = e.validateInput || $8e4453fb4fc895c8$var$Y.processValidateInput(e);
                e._validationHandler = /*#__PURE__*/ function() {
                    var _ref34 = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee120(a) {
                        var l;
                        return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee120$(_context120) {
                            while(true)switch(_context120.prev = _context120.next){
                                case 0:
                                    if (!(r.status.loadingActive || r.status.requestInProgress || t.isSubmitProgrammaticallyDisabled === !0 || !We.validateWebsocket(t, r))) {
                                        _context120.next = 2;
                                        break;
                                    }
                                    return _context120.abrupt("return", !1);
                                case 2:
                                    l = o || t.canSendMessage;
                                    return _context120.abrupt("return", l ? a ? We.useValidationFuncProgrammatic(l, a, r) : We.useValidationFunc(l, i, s, r) : null);
                                case 4:
                                case "end":
                                    return _context120.stop();
                            }
                        }, _callee120);
                    }));
                    return function(_x217) {
                        return _ref34.apply(this, arguments);
                    };
                }();
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Ln = /*#__PURE__*/ function() {
    function Ln() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ln);
    }
    return $8e4453fb4fc895c8$var$_createClass(Ln, null, [
        {
            key: "getFileName",
            value: function getFileName(e, t) {
                var i = /* @__PURE__ */ new Date(), s = String(i.getHours()).padStart(2, "0"), r = String(i.getMinutes()).padStart(2, "0"), o = String(i.getSeconds()).padStart(2, "0");
                return "".concat(e, "-").concat(s, "-").concat(r, "-").concat(o, ".").concat(t);
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Ta = /*#__PURE__*/ function(_Jt2) {
    function Ta(e, t) {
        var _this72;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ta);
        var i, s;
        _this72 = $8e4453fb4fc895c8$var$_callSuper(this, Ta, [
            t.button
        ]), _this72._waitingForBrowserApproval = !1, _this72._audioType = e, _this72._extension = ((i = t.files) == null ? void 0 : i.format) || "mp3", _this72._maxDurationSeconds = (s = t.files) == null ? void 0 : s.maxDurationSeconds, _this72.elementRef.onclick = _this72.buttonClick.bind($8e4453fb4fc895c8$var$_assertThisInitialized(_this72));
        return _this72;
    }
    $8e4453fb4fc895c8$var$_inherits(Ta, _Jt2);
    return $8e4453fb4fc895c8$var$_createClass(Ta, [
        {
            key: "buttonClick",
            value: function buttonClick() {
                this._waitingForBrowserApproval || (this.isActive ? this.stop() : (this._waitingForBrowserApproval = !0, this.record()));
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this73 = this;
                return new Promise(function(e) {
                    var t, i;
                    _this73.changeToDefault(), (t = _this73._mediaRecorder) == null || t.stop(), (i = _this73._mediaStream) == null || i.getTracks().forEach(function(s) {
                        return s.stop();
                    }), setTimeout(function() {
                        e();
                    }, 10);
                });
            }
        },
        {
            key: "record",
            value: function record() {
                var _this74 = this;
                navigator.mediaDevices.getUserMedia({
                    audio: !0
                }).then(function(e) {
                    _this74.changeToActive(), _this74._mediaRecorder = new MediaRecorder(e), _this74._audioType.addPlaceholderAttachment(_this74.stop.bind(_this74), _this74._maxDurationSeconds), _this74._mediaStream = e, _this74._mediaRecorder.addEventListener("dataavailable", function(t) {
                        _this74.createFile(t);
                    }), _this74._mediaRecorder.start();
                })["catch"](function(e) {
                    console.error(e), _this74.stop();
                })["finally"](function() {
                    _this74._waitingForBrowserApproval = !1;
                });
            }
        },
        {
            key: "createFile",
            value: function createFile(e) {
                var _this75 = this;
                var t = new Blob([
                    e.data
                ], {
                    type: "audio/".concat(this._extension)
                }), i = $8e4453fb4fc895c8$var$Ln.getFileName(this._newFilePrefix || "audio", this._extension), s = new File([
                    t
                ], i, {
                    type: t.type
                }), r = new FileReader();
                r.readAsDataURL(s), r.onload = function(o) {
                    _this75._audioType.completePlaceholderAttachment(s, o.target.result);
                };
            }
        }
    ]);
}($8e4453fb4fc895c8$var$Jt);
var $8e4453fb4fc895c8$var$ka = '<?xml version="1.0" standalone="no"?>\n<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.0//EN" "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">\n<svg xmlns="http://www.w3.org/2000/svg" stroke="currentColor" fill="none" stroke-width="1" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round">\n  <line x1="22" y1="2" x2="11" y2="14"></line>\n  <polygon points="22 2 15 22 11 14 2 10 22 2"></polygon>\n</svg>\n';
var $8e4453fb4fc895c8$var$K = /*#__PURE__*/ function() {
    function K() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, K);
    }
    return $8e4453fb4fc895c8$var$_createClass(K, null, [
        {
            key: "setPropertyValueIfDoesNotExist",
            value: function setPropertyValueIfDoesNotExist(e, t, i) {
                var _e$s, _e$s2;
                var s = t[0];
                t.length === 1 ? (_e$s = e[s]) !== null && _e$s !== void 0 ? _e$s : e[s] = i : ((_e$s2 = e[s]) !== null && _e$s2 !== void 0 ? _e$s2 : e[s] = {}, t.shift(), K.setPropertyValueIfDoesNotExist(e[s], t, i));
            }
        },
        {
            key: "setPropertyValue",
            value: function setPropertyValue(e, t, i) {
                var _e$s3;
                var s = t[0];
                t.length === 1 ? e[s] = i : ((_e$s3 = e[s]) !== null && _e$s3 !== void 0 ? _e$s3 : e[s] = {}, t.shift(), K.setPropertyValue(e[s], t, i));
            }
        },
        {
            key: "getObjectValue",
            value: function getObjectValue(e, t) {
                var i = t[0], s = e[i];
                return s === void 0 || t.length === 1 ? s : K.getObjectValue(s, t.slice(1));
            }
        },
        {
            key: "overwritePropertyObjectFromAnother",
            value: function overwritePropertyObjectFromAnother(e, t, i) {
                var s = K.getObjectValue(t, i);
                if (s) {
                    var r = $8e4453fb4fc895c8$var$_objectSpread($8e4453fb4fc895c8$var$_objectSpread({}, s), K.getObjectValue(e, i) || {});
                    K.setPropertyValue(e, i, r);
                }
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$it = /*#__PURE__*/ function() {
    function it() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, it);
    }
    return $8e4453fb4fc895c8$var$_createClass(it, null, [
        {
            key: "resetSubmit",
            value: function resetSubmit(e, t) {
                t ? e.unsetCustomStateStyles([
                    "loading",
                    "submit"
                ]) : e.unsetCustomStateStyles([
                    "stop",
                    "loading",
                    "submit"
                ]), e.reapplyStateStyle("submit");
            }
        },
        {
            key: "overwriteDefaultStyleWithSubmit",
            value: function overwriteDefaultStyleWithSubmit(e, t) {
                if (!e.submit) return;
                var i = JSON.parse(JSON.stringify(e[t] || {}));
                $8e4453fb4fc895c8$var$K.overwritePropertyObjectFromAnother(i, e.submit, [
                    "container",
                    "default"
                ]), $8e4453fb4fc895c8$var$K.overwritePropertyObjectFromAnother(i, e.submit, [
                    "text",
                    "styles",
                    "default"
                ]), $8e4453fb4fc895c8$var$K.overwritePropertyObjectFromAnother(i, e.submit, [
                    "svg",
                    "styles",
                    "default"
                ]), e[t] = i;
            }
        },
        {
            key: "setUpDisabledButton",
            value: function setUpDisabledButton(e) {
                $8e4453fb4fc895c8$var$K.setPropertyValueIfDoesNotExist(e, [
                    "submit",
                    "container",
                    "default",
                    "backgroundColor"
                ], ""), $8e4453fb4fc895c8$var$K.setPropertyValueIfDoesNotExist(e, [
                    "disabled",
                    "container",
                    "default",
                    "backgroundColor"
                ], "unset"), $8e4453fb4fc895c8$var$K.setPropertyValueIfDoesNotExist(e.submit, [
                    "svg",
                    "styles",
                    "default",
                    "filter"
                ], ""), $8e4453fb4fc895c8$var$K.setPropertyValueIfDoesNotExist(e.disabled, [
                    "svg",
                    "styles",
                    "default",
                    "filter"
                ], "brightness(0) saturate(100%) invert(70%) sepia(0%) saturate(5564%) hue-rotate(207deg) brightness(100%) contrast(97%)"), it.overwriteDefaultStyleWithSubmit(e, "disabled");
            }
        },
        {
            key: "process",
            value: function process(e) {
                var t = JSON.parse(JSON.stringify(e || {}));
                return it.overwriteDefaultStyleWithSubmit(t, "loading"), it.overwriteDefaultStyleWithSubmit(t, "stop"), e != null && e.alwaysEnabled || it.setUpDisabledButton(t), t;
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$k = /*#__PURE__*/ function(_ii4) {
    // prettier-ignore
    function k(e, t, i, s, r, o) {
        var _this76;
        $8e4453fb4fc895c8$var$_classCallCheck(this, k);
        var a = $8e4453fb4fc895c8$var$it.process(e.submitButtonStyles);
        _this76 = $8e4453fb4fc895c8$var$_callSuper(this, k, [
            k.createButtonContainerElement(),
            a == null ? void 0 : a.position,
            a
        ]), _this76._isSVGLoadingIconOverriden = !1, _this76.status = {
            requestInProgress: !1,
            loadingActive: !1
        }, _this76._messages = i, _this76._textInput = t, _this76._fileAttachments = r, _this76._innerElements = _this76.createInnerElements(), _this76._abortStream = new AbortController(), _this76._stopClicked = {
            listener: function listener() {}
        }, _this76._serviceIO = s, _this76._alwaysEnabled = !!(a != null && a.alwaysEnabled), e.disableSubmitButton = _this76.disableSubmitButton.bind($8e4453fb4fc895c8$var$_assertThisInitialized(_this76), s), _this76.attemptOverwriteLoadingStyle(e), o.microphone && _this76.setUpSpeechToText(o.microphone.button, e.speechToText), setTimeout(function() {
            var l;
            _this76._validationHandler = e._validationHandler, _this76.assignHandlers(_this76._validationHandler), (l = _this76._validationHandler) == null || l.call($8e4453fb4fc895c8$var$_assertThisInitialized(_this76));
        });
        return _this76;
    }
    $8e4453fb4fc895c8$var$_inherits(k, _ii4);
    return $8e4453fb4fc895c8$var$_createClass(k, [
        {
            key: "createInnerElements",
            value: function createInnerElements() {
                var _this$createCustomEle = this.createCustomElements(), e = _this$createCustomEle.submit, t = _this$createCustomEle.loading, i = _this$createCustomEle.stop, s = e || k.createSubmitIconElement();
                return {
                    submit: s,
                    loading: t || k.createLoadingIconElement(),
                    stop: i || k.createStopIconElement(),
                    disabled: this.createDisabledIconElement(s)
                };
            }
        },
        {
            key: "createCustomElements",
            value: function createCustomElements() {
                var _this77 = this;
                var e = $8e4453fb4fc895c8$var$J.createSpecificStateElement(this.elementRef, "submit", this._customStyles), t = {
                    loading: void 0,
                    stop: void 0
                };
                return Object.keys(t).forEach(function(i) {
                    var s = i, r = $8e4453fb4fc895c8$var$J.createCustomElement(s, _this77._customStyles);
                    r && (t[s] = r);
                }), t.submit = e, t;
            }
        },
        {
            key: "createDisabledIconElement",
            value: function createDisabledIconElement(e) {
                return $8e4453fb4fc895c8$var$J.createCustomElement("disabled", this._customStyles) || e.cloneNode(!0);
            }
        },
        {
            key: "attemptOverwriteLoadingStyle",
            value: function attemptOverwriteLoadingStyle(e) {
                var t, i, s, r, o, a, l, c, d;
                if (!((i = (t = this._customStyles) == null ? void 0 : t.submit) != null && i.svg || (o = (r = (s = this._customStyles) == null ? void 0 : s.loading) == null ? void 0 : r.svg) != null && o.content || (c = (l = (a = this._customStyles) == null ? void 0 : a.loading) == null ? void 0 : l.text) != null && c.content) && (e.displayLoadingBubble === void 0 || e.displayLoadingBubble === !0)) {
                    var h = document.createElement("style");
                    h.textContent = "\n        .loading-button > * {\n          filter: brightness(0) saturate(100%) invert(72%) sepia(0%) saturate(3044%) hue-rotate(322deg) brightness(100%)\n            contrast(96%) !important;\n        }", (d = e.shadowRoot) == null || d.appendChild(h), this._isSVGLoadingIconOverriden = !0;
                }
            }
        },
        {
            key: "assignHandlers",
            value: function assignHandlers(e) {
                this._serviceIO.completionsHandlers = {
                    onFinish: this.resetSubmit.bind(this, e)
                }, this._serviceIO.streamHandlers = {
                    onOpen: this.changeToStopIcon.bind(this),
                    onClose: this.resetSubmit.bind(this, e),
                    abortStream: this._abortStream,
                    stopClicked: this._stopClicked
                };
                var t = this._serviceIO.stream;
                $8e4453fb4fc895c8$var$_typeof(t) == "object" && typeof t.simulation == "number" && (this._serviceIO.streamHandlers.simulationInterim = t.simulation);
            }
        },
        {
            key: "setUpSpeechToText",
            value: function setUpSpeechToText(e, t) {
                this._microphoneButton = e, this._stopSTTAfterSubmit = $8e4453fb4fc895c8$var$_typeof(t) == "object" ? t.stopAfterSubmit : !1;
            }
        },
        {
            key: "resetSubmit",
            value: function resetSubmit(e) {
                this.status.requestInProgress = !1, this.status.loadingActive = !1, e();
            }
        },
        {
            key: "submitFromInput",
            value: function() {
                var _submitFromInput = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee121() {
                    var e, t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee121$(_context121) {
                        while(true)switch(_context121.prev = _context121.next){
                            case 0:
                                _context121.next = 2;
                                return this._fileAttachments.completePlaceholders();
                            case 2:
                                e = this._fileAttachments.getAllFileData();
                                if (this._textInput.isTextInputEmpty()) this.attemptSubmit({
                                    text: "",
                                    files: e
                                });
                                else {
                                    t = this._textInput.inputElementRef.innerText.trim();
                                    this.attemptSubmit({
                                        text: t,
                                        files: e
                                    });
                                }
                            case 4:
                            case "end":
                                return _context121.stop();
                        }
                    }, _callee121, this);
                }));
                function submitFromInput() {
                    return _submitFromInput.apply(this, arguments);
                }
                return submitFromInput;
            }()
        },
        {
            key: "programmaticSubmit",
            value: function() {
                var _programmaticSubmit = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee122(e) {
                    var _this78 = this;
                    var t;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee122$(_context122) {
                        while(true)switch(_context122.prev = _context122.next){
                            case 0:
                                typeof e == "string" && (e = $8e4453fb4fc895c8$var$Y.processSubmitUserMessage(e));
                                t = {
                                    text: e.text
                                };
                                e.files && (t.files = Array.from(e.files).map(function(i) {
                                    return {
                                        file: i,
                                        type: $8e4453fb4fc895c8$var$Pe.getTypeFromBlob(i)
                                    };
                                })), setTimeout(function() {
                                    return _this78.attemptSubmit(t, !0);
                                });
                            case 3:
                            case "end":
                                return _context122.stop();
                        }
                    }, _callee122);
                }));
                function programmaticSubmit(_x218) {
                    return _programmaticSubmit.apply(this, arguments);
                }
                return programmaticSubmit;
            }() // TO-DO - should be disabled when loading history
        },
        {
            key: "attemptSubmit",
            value: function() {
                var _attemptSubmit = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee123(e) {
                    var t, r, o, a, i, s, _args123 = arguments;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee123$(_context123) {
                        while(true)switch(_context123.prev = _context123.next){
                            case 0:
                                t = _args123.length > 1 && _args123[1] !== undefined ? _args123[1] : !1;
                                _context123.next = 3;
                                return (r = this._validationHandler) == null ? void 0 : r.call(this, t ? e : void 0);
                            case 3:
                                _context123.t0 = _context123.sent;
                                _context123.t1 = !1;
                                if (!(_context123.t0 === _context123.t1)) {
                                    _context123.next = 7;
                                    break;
                                }
                                return _context123.abrupt("return");
                            case 7:
                                this.changeToLoadingIcon();
                                _context123.next = 10;
                                return this.addNewMessage(e);
                            case 10:
                                this._serviceIO.isWebModel() || this._messages.addLoadingMessage();
                                this._textInput.clear();
                                i = (o = e.files) == null ? void 0 : o.map(function(l) {
                                    return l.file;
                                }), s = {
                                    text: e.text === "" ? void 0 : e.text,
                                    files: i
                                };
                                _context123.next = 15;
                                return this._serviceIO.callAPI(s, this._messages);
                            case 15:
                                (a = this._fileAttachments) == null || a.removeAllFiles();
                            case 16:
                            case "end":
                                return _context123.stop();
                        }
                    }, _callee123, this);
                }));
                function attemptSubmit(_x219) {
                    return _attemptSubmit.apply(this, arguments);
                }
                return attemptSubmit;
            }()
        },
        {
            key: "addNewMessage",
            value: function() {
                var _addNewMessage = $8e4453fb4fc895c8$var$_asyncToGenerator(/*#__PURE__*/ $8e4453fb4fc895c8$var$_regeneratorRuntime().mark(function _callee124(_ref35) {
                    var e, t, i;
                    return $8e4453fb4fc895c8$var$_regeneratorRuntime().wrap(function _callee124$(_context124) {
                        while(true)switch(_context124.prev = _context124.next){
                            case 0:
                                e = _ref35.text, t = _ref35.files;
                                i = {
                                    role: $8e4453fb4fc895c8$var$b.USER_ROLE
                                };
                                e && (i.text = e);
                                _context124.t0 = t;
                                if (!_context124.t0) {
                                    _context124.next = 8;
                                    break;
                                }
                                _context124.next = 7;
                                return this._messages.addMultipleFiles(t);
                            case 7:
                                i.files = _context124.sent;
                            case 8:
                                this._serviceIO.sessionId && (i._sessionId = this._serviceIO.sessionId);
                                Object.keys(i).length > 0 && this._messages.addNewMessage(i);
                            case 10:
                            case "end":
                                return _context124.stop();
                        }
                    }, _callee124, this);
                }));
                function addNewMessage(_x220) {
                    return _addNewMessage.apply(this, arguments);
                }
                return addNewMessage;
            }()
        },
        {
            key: "stopStream",
            value: function stopStream() {
                var e;
                this._abortStream.abort(), (e = this._stopClicked) == null || e.listener(), this._validationHandler && this.resetSubmit(this._validationHandler);
            }
        },
        {
            key: "changeToStopIcon",
            value: function changeToStopIcon() {
                this._serviceIO.websocket || (this.elementRef.classList.remove(k.LOADING_CLASS, k.DISABLED_CLASS, k.SUBMIT_CLASS), $8e4453fb4fc895c8$var$W.removeAriaAttributes(this.elementRef), this.elementRef.replaceChildren(this._innerElements.stop), this.reapplyStateStyle("stop", [
                    "loading",
                    "submit"
                ]), this.elementRef.onclick = this.stopStream.bind(this), this.status.loadingActive = !1);
            }
        },
        {
            key: "changeToLoadingIcon",
            value: function changeToLoadingIcon() {
                this._serviceIO.websocket || (this._isSVGLoadingIconOverriden || this.elementRef.replaceChildren(this._innerElements.loading), this.elementRef.classList.remove(k.SUBMIT_CLASS, k.DISABLED_CLASS), $8e4453fb4fc895c8$var$W.removeAriaDisabled(this.elementRef), this.elementRef.classList.add(k.LOADING_CLASS), $8e4453fb4fc895c8$var$W.addAriaBusy(this.elementRef), this.reapplyStateStyle("loading", [
                    "submit"
                ]), this.elementRef.onclick = function() {}, this.status.requestInProgress = !0, this.status.loadingActive = !0);
            }
        },
        {
            key: "changeToSubmitIcon",
            value: function changeToSubmitIcon() {
                var _this79 = this;
                this.elementRef.classList.contains(k.SUBMIT_CLASS) || (this.elementRef.classList.remove(k.LOADING_CLASS, k.DISABLED_CLASS), $8e4453fb4fc895c8$var$W.removeAriaAttributes(this.elementRef), this.elementRef.classList.add(k.SUBMIT_CLASS), this.elementRef.replaceChildren(this._innerElements.submit), $8e4453fb4fc895c8$var$it.resetSubmit(this, this.status.loadingActive), this.elementRef.onclick = function() {
                    var e;
                    _this79.submitFromInput(), (e = _this79._microphoneButton) != null && e.isActive && $8e4453fb4fc895c8$var$Xt.toggleSpeechAfterSubmit(_this79._microphoneButton.elementRef, !!_this79._stopSTTAfterSubmit);
                });
            }
        },
        {
            key: "changeToDisabledIcon",
            value: function changeToDisabledIcon() {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                this._alwaysEnabled && !e ? this.changeToSubmitIcon() : this.elementRef.classList.contains(k.DISABLED_CLASS) || (this.elementRef.classList.remove(k.LOADING_CLASS, k.SUBMIT_CLASS), $8e4453fb4fc895c8$var$W.removeAriaBusy(this.elementRef), this.elementRef.classList.add(k.DISABLED_CLASS), $8e4453fb4fc895c8$var$W.addAriaDisabled(this.elementRef), this.elementRef.replaceChildren(this._innerElements.disabled), this.reapplyStateStyle("disabled", [
                    "submit"
                ]), this.elementRef.onclick = function() {});
            }
        },
        {
            key: "disableSubmitButton",
            value: function disableSubmitButton(e, t) {
                var i;
                e.isSubmitProgrammaticallyDisabled = t !== !1, !(this.status.requestInProgress || this.status.loadingActive) && (t === !1 ? (i = this._validationHandler) == null || i.call(this) : this.changeToDisabledIcon(!0));
            }
        }
    ], [
        {
            key: "createButtonContainerElement",
            value: function createButtonContainerElement() {
                var e = document.createElement("div");
                return e.classList.add("input-button"), $8e4453fb4fc895c8$var$W.addAttributes(e), e;
            }
        },
        {
            key: "createSubmitIconElement",
            value: function createSubmitIconElement() {
                var e = $8e4453fb4fc895c8$var$re.createSVGElement($8e4453fb4fc895c8$var$ka);
                return e.id = "submit-icon", e;
            }
        },
        {
            key: "createLoadingIconElement",
            value: function createLoadingIconElement() {
                var e = document.createElement("div");
                return e.classList.add("loading-submit-button"), e;
            }
        },
        {
            key: "createStopIconElement",
            value: function createStopIconElement() {
                var e = document.createElement("div");
                return e.id = "stop-icon", e;
            }
        }
    ]);
}($8e4453fb4fc895c8$var$ii);
$8e4453fb4fc895c8$var$k.SUBMIT_CLASS = "submit-button", $8e4453fb4fc895c8$var$k.LOADING_CLASS = "loading-button", $8e4453fb4fc895c8$var$k.DISABLED_CLASS = "disabled-button";
var $8e4453fb4fc895c8$var$Ts = $8e4453fb4fc895c8$var$k;
var $8e4453fb4fc895c8$var$Ma = '<?xml version="1.0" encoding="utf-8"?>\n<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">\n  <path d="M27.1 14.313V5.396L24.158 8.34c-2.33-2.325-5.033-3.503-8.11-3.503C9.902 4.837 4.901 9.847 4.899 16c.001 6.152 5.003 11.158 11.15 11.16 4.276 0 9.369-2.227 10.836-8.478l.028-.122h-3.23l-.022.068c-1.078 3.242-4.138 5.421-7.613 5.421a8 8 0 0 1-5.691-2.359A7.993 7.993 0 0 1 8 16.001c0-4.438 3.611-8.049 8.05-8.049 2.069 0 3.638.58 5.924 2.573l-3.792 3.789H27.1z"/>\n</svg>\n', $8e4453fb4fc895c8$var$Ra = '<?xml version="1.0" encoding="utf-8"?>\n<svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">\n  <title>capture</title>\n  <path d="M0 16q0 3.264 1.28 6.208t3.392 5.12 5.12 3.424 6.208 1.248 6.208-1.248 5.12-3.424 3.392-5.12 1.28-6.208-1.28-6.208-3.392-5.12-5.088-3.392-6.24-1.28q-3.264 0-6.208 1.28t-5.12 3.392-3.392 5.12-1.28 6.208zM4 16q0-3.264 1.6-6.016t4.384-4.352 6.016-1.632 6.016 1.632 4.384 4.352 1.6 6.016-1.6 6.048-4.384 4.352-6.016 1.6-6.016-1.6-4.384-4.352-1.6-6.048z"></path>\n</svg>\n', $8e4453fb4fc895c8$var$Ia = '<?xml version="1.0" encoding="utf-8"?>\n<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">\n  <path d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"/>\n</svg>', $8e4453fb4fc895c8$var$La = '<?xml version="1.0" encoding="utf-8"?>\n<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M4.89163 13.2687L9.16582 17.5427L18.7085 8" stroke="#000000" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>';
var $8e4453fb4fc895c8$var$Bs = /*#__PURE__*/ function(_tt) {
    // prettier-ignore
    function Bs(e, t, i, s) {
        var _this80;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Bs);
        _this80 = $8e4453fb4fc895c8$var$_callSuper(this, Bs, [
            e,
            [
                "modal-content",
                "modal-camera-content"
            ],
            i
        ]), _this80._stopped = !1, _this80._format = "image/png", _this80._canvas = document.createElement("canvas"), _this80._canvas.classList.add("camera-modal-canvas");
        var _this80$addButtonsAnd = _this80.addButtonsAndTheirEvents(t), r = _this80$addButtonsAnd.captureButton, o = _this80$addButtonsAnd.submitButton;
        _this80._captureButton = r, _this80._submitButton = o, _this80._captureIcon = _this80._captureButton.children[0], _this80._refreshIcon = $8e4453fb4fc895c8$var$re.createSVGElement($8e4453fb4fc895c8$var$Ma), _this80._refreshIcon.classList.add("modal-svg-button-icon", "modal-svg-refresh-icon"), (s == null ? void 0 : s.format) === "jpeg" && (_this80._format = "image/jpeg"), s != null && s.dimensions && (_this80._dimensions = s.dimensions), _this80._contentRef.appendChild(_this80._canvas), _this80.extensionCloseCallback = _this80.stop;
        return _this80;
    }
    $8e4453fb4fc895c8$var$_inherits(Bs, _tt);
    return $8e4453fb4fc895c8$var$_createClass(Bs, [
        {
            key: "addButtonsAndTheirEvents",
            value: function addButtonsAndTheirEvents(e) {
                var t = $8e4453fb4fc895c8$var$tt.createSVGButton($8e4453fb4fc895c8$var$Ra);
                t.classList.add("modal-svg-camera-button"), t.children[0].classList.add("modal-svg-camera-icon");
                var i = this.addCloseButton($8e4453fb4fc895c8$var$Ia, !0);
                i.classList.add("modal-svg-close-button"), i.children[0].classList.add("modal-svg-close-icon");
                var s = $8e4453fb4fc895c8$var$tt.createSVGButton($8e4453fb4fc895c8$var$La);
                return s.classList.add("modal-svg-submit-button"), this.addButtons(t, s), this.addButtonEvents(t, i, s, e), {
                    captureButton: t,
                    submitButton: s
                };
            }
        },
        {
            key: "addButtonEvents",
            value: function addButtonEvents(e, t, i, s) {
                var _this81 = this;
                e.onclick = function() {
                    _this81.capture();
                }, t.addEventListener("click", this.stop.bind(this)), i.onclick = function() {
                    var r = _this81.getFile();
                    r && $8e4453fb4fc895c8$var$ai.addFilesToType([
                        r
                    ], [
                        s
                    ]), _this81.stop(), _this81.close();
                };
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this82 = this;
                this._mediaStream && this._mediaStream.getTracks().forEach(function(e) {
                    return e.stop();
                }), this._stopped = !0, setTimeout(function() {
                    _this82._captureButton.replaceChildren(_this82._captureIcon), _this82._captureButton.classList.replace("modal-svg-refresh-button", "modal-svg-camera-button");
                    var e = _this82._canvas.getContext("2d");
                    e == null || e.clearRect(0, 0, _this82._canvas.width, _this82._canvas.height);
                }, $8e4453fb4fc895c8$var$tt.MODAL_CLOSE_TIMEOUT_MS);
            }
        },
        {
            key: "start",
            value: function start() {
                var _this83 = this;
                this._dataURL = void 0, this._submitButton.classList.add("modal-svg-submit-disabled"), this._stopped = !1, navigator.mediaDevices.getUserMedia({
                    video: this._dimensions || !0
                }).then(function(e) {
                    if (_this83._mediaStream = e, !_this83.isOpen()) return _this83.stop();
                    var t = document.createElement("video");
                    t.srcObject = e, t.play(), requestAnimationFrame(_this83.updateCanvas.bind(_this83, t, _this83._canvas));
                })["catch"](function(e) {
                    console.error(e), _this83.stop(), _this83.close();
                });
            }
        },
        {
            key: "capture",
            value: function capture() {
                this._dataURL ? (this._captureButton.replaceChildren(this._captureIcon), this._captureButton.classList.replace("modal-svg-refresh-button", "modal-svg-camera-button"), this._submitButton.classList.add("modal-svg-submit-disabled"), this._dataURL = void 0) : (this._captureButton.replaceChildren(this._refreshIcon), this._captureButton.classList.replace("modal-svg-camera-button", "modal-svg-refresh-button"), this._submitButton.classList.remove("modal-svg-submit-disabled"), this._dataURL = this._canvas.toDataURL());
            }
        },
        {
            key: "getFile",
            value: function getFile() {
                if (this._dataURL) {
                    var e = atob(this._dataURL.split(",")[1]), t = new Array(e.length);
                    for(var a = 0; a < e.length; a++)t[a] = e.charCodeAt(a);
                    var _i19 = new Uint8Array(t), s = new Blob([
                        _i19
                    ], {
                        type: this._format
                    }), r = this._format === "image/jpeg" ? "jpeg" : "png", o = $8e4453fb4fc895c8$var$Ln.getFileName(this._newFilePrefix || "photo", r);
                    return new File([
                        s
                    ], o, {
                        type: s.type
                    });
                }
            }
        },
        {
            key: "updateCanvas",
            value: function updateCanvas(e, t) {
                if (!this._stopped) {
                    if (!this._dataURL) {
                        t.width = e.videoWidth, t.height = e.videoHeight;
                        var _i20 = t.getContext("2d");
                        _i20 == null || _i20.drawImage(e, 0, 0, t.width, t.height);
                    }
                    requestAnimationFrame(this.updateCanvas.bind(this, e, t));
                }
            }
        },
        {
            key: "openCameraModal",
            value: function openCameraModal(e) {
                this.displayModalElements(), e.start();
            }
        }
    ], [
        {
            key: "createCameraModalFunc",
            value: function createCameraModalFunc(e, t, i, s) {
                var r = new Bs(e, t, i, s);
                return r.openCameraModal.bind(r, r);
            }
        }
    ]);
}($8e4453fb4fc895c8$var$tt);
var $8e4453fb4fc895c8$var$Pa = '<?xml version="1.0" encoding="utf-8"?>\n<svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">\n  <path d="M29 7h-4.599l-2.401-4h-12l-2.4 4h-4.6c-1 0-3 1-3 2.969v16.031c0 1.657 1.5 3 2.792 3h26.271c1.313 0 2.938-1.406 2.938-2.968v-16.032c0-1-1-3-3-3zM30 26.032c0 0.395-0.639 0.947-0.937 0.969h-26.265c-0.232-0.019-0.797-0.47-0.797-1v-16.031c0-0.634 0.851-0.953 1-0.969h5.732l2.4-4h9.802l1.785 3.030 0.55 0.97h5.731c0.705 0 0.99 0.921 1 1v16.032zM16 10c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zM16 22c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"></path>\n</svg>';
var $8e4453fb4fc895c8$var$Oi = /*#__PURE__*/ function(_ii5) {
    function Oi(e, t, i) {
        var _this84;
        $8e4453fb4fc895c8$var$_classCallCheck(this, Oi);
        var a, l, c, d;
        var s = (a = i == null ? void 0 : i.button) == null ? void 0 : a.position, r = ((d = (c = (l = i == null ? void 0 : i.button) == null ? void 0 : l.styles) == null ? void 0 : c.text) == null ? void 0 : d.content) || "Photo";
        _this84 = $8e4453fb4fc895c8$var$_callSuper(this, Oi, [
            Oi.createButtonElement(),
            s,
            (i == null ? void 0 : i.button) || {},
            r
        ]);
        var o = _this84.createInnerElements(_this84._customStyles, s === "dropup-menu");
        i && _this84.addClickEvent(e, t, i.modalContainerStyle, i.files), _this84.elementRef.classList.add("upload-file-button"), _this84.elementRef.appendChild(o.styles), _this84.reapplyStateStyle("styles");
        return _this84;
    }
    // prettier-ignore
    $8e4453fb4fc895c8$var$_inherits(Oi, _ii5);
    return $8e4453fb4fc895c8$var$_createClass(Oi, [
        {
            key: "createInnerElements",
            value: function createInnerElements(e) {
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                return {
                    styles: $8e4453fb4fc895c8$var$J.createInnerElement(this.elementRef, Oi.createSVGIconElement(), "styles", e, t)
                };
            }
        },
        {
            key: "addClickEvent",
            value: // prettier-ignore
            function addClickEvent(e, t, i, s) {
                var r = $8e4453fb4fc895c8$var$Bs.createCameraModalFunc(e, t, i, s);
                this.elementRef.onclick = r;
            }
        }
    ], [
        {
            key: "createButtonElement",
            value: function createButtonElement() {
                var e = document.createElement("div");
                return e.classList.add("input-button"), $8e4453fb4fc895c8$var$W.addAttributes(e), e;
            }
        },
        {
            key: "createSVGIconElement",
            value: function createSVGIconElement() {
                var e = $8e4453fb4fc895c8$var$re.createSVGElement($8e4453fb4fc895c8$var$Pa);
                return e.id = "camera-icon", e;
            }
        }
    ]);
}($8e4453fb4fc895c8$var$ii);
var $8e4453fb4fc895c8$var$Ut = /*#__PURE__*/ function() {
    function Ut(e, t, i, s) {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Ut);
        this.elementRef = Ut.createPanelElement(e.inputAreaStyle);
        var r = {}, o = this.createFileUploadComponents(e, i, s, r), a = new $8e4453fb4fc895c8$var$mi(e, i, o);
        e.speechToText && !r.microphone && (r.microphone = {
            button: new $8e4453fb4fc895c8$var$Xt(e, a, t.addNewErrorMessage.bind(t))
        });
        var l = new $8e4453fb4fc895c8$var$Ts(e, a, t, i, o, r);
        a.submit = l.submitFromInput.bind(l), $8e4453fb4fc895c8$var$We.attach(e, i, a, o, l), e.submitUserMessage = l.programmaticSubmit.bind(l), r.submit = {
            button: l
        }, Ut.addElements(this.elementRef, a, r, s, o, e.dropupStyles);
    }
    return $8e4453fb4fc895c8$var$_createClass(Ut, [
        {
            key: "createFileUploadComponents",
            value: // prettier-ignore
            function createFileUploadComponents(e, t, i, s) {
                var o, a, l, c;
                var r = new $8e4453fb4fc895c8$var$ai(this.elementRef, e.attachmentContainerStyle, t.demo);
                if (Ut.createUploadButtons(e, t.fileTypes || {}, r, i, s), (o = t.camera) != null && o.files) {
                    var d = ((a = s.images) == null ? void 0 : a.fileType) || r.addType(e, t.camera.files, "images");
                    s.camera = {
                        button: new $8e4453fb4fc895c8$var$Oi(i, d, t.camera)
                    };
                }
                if ((l = t.recordAudio) != null && l.files) {
                    var _d = ((c = s.audio) == null ? void 0 : c.fileType) || r.addType(e, t.recordAudio.files, "audio");
                    s.microphone = {
                        button: new $8e4453fb4fc895c8$var$Ta(_d, t.recordAudio)
                    };
                }
                return $8e4453fb4fc895c8$var$Ie.isEnabled(r, e.dragAndDrop) && $8e4453fb4fc895c8$var$Ie.create(i, r, e.dragAndDrop), r;
            }
        }
    ], [
        {
            key: "createPanelElement",
            value: function createPanelElement(e) {
                var t = document.createElement("div");
                return t.id = "input", Object.assign(t.style, e), t;
            }
        },
        {
            key: "createUploadButtons",
            value: function createUploadButtons(e, t, i, s, r) {
                Object.keys(t).forEach(function(o) {
                    var a = o, l = t[a];
                    if (l.files) {
                        var c = i.addType(e, l.files, a), _na$a = $8e4453fb4fc895c8$var$na[a], d = _na$a.id, h = _na$a.svgString, f = _na$a.dropupText, u = new $8e4453fb4fc895c8$var$Ft(s, c, l, d, h, f);
                        r[a] = {
                            button: u,
                            fileType: c
                        };
                    }
                });
            }
        },
        {
            key: "addElements",
            value: function addElements(e, t, i, s, r, o) {
                $8e4453fb4fc895c8$var$X.addElements(e, t.elementRef);
                var a = $8e4453fb4fc895c8$var$kt.create(), l = $8e4453fb4fc895c8$var$$.addButtons(a, i, s, o);
                $8e4453fb4fc895c8$var$Cs.set(t.inputElementRef, a, r.elementRef, l), $8e4453fb4fc895c8$var$kt.add(e, a);
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Fs = /*#__PURE__*/ function() {
    function Fs() {
        $8e4453fb4fc895c8$var$_classCallCheck(this, Fs);
    }
    return $8e4453fb4fc895c8$var$_createClass(Fs, null, [
        {
            key: "createElements",
            value: function createElements(e, t, i) {
                var s = document.createElement("div");
                s.id = "chat-view";
                var r = new $8e4453fb4fc895c8$var$he(e, t, i);
                t.websocket && $8e4453fb4fc895c8$var$U.createConnection(t, r);
                var o = new $8e4453fb4fc895c8$var$Ut(e, r, t, s);
                return $8e4453fb4fc895c8$var$X.addElements(s, r.elementRef, o.elementRef), s;
            }
        },
        {
            key: "render",
            value: function render(e, t, i, s) {
                var r = Fs.createElements(e, i, s);
                t.replaceChildren(r);
            }
        }
    ]);
}();
var $8e4453fb4fc895c8$var$Oa = '#validate-property-key-view{height:100%;position:relative;display:flex;justify-content:center;align-items:center;padding:8px}#loading-validate-key-property{display:inline-block;width:50px;height:50px}#loading-validate-key-property:after{content:" ";display:block;width:38px;height:38px;margin:1px;border-radius:50%;border:5px solid #5fb2ff;border-color:#5fb2ff transparent #5fb2ff transparent;animation:loading-spinner 1.4s linear infinite}#insert-key-view{height:100%;position:relative}#insert-key-contents{text-align:center;position:absolute;top:44%;left:50%;transform:translate(-50%,-50%);width:82%;display:flex;max-width:700px}#insert-key-title{margin-bottom:15px}#insert-key-input-container{margin-right:2.7em;width:calc(100% - 80px)}#insert-key-input{padding:.3em 1.7em .3em .3em;border-width:1px;border-style:solid;border-radius:3px;width:100%;font-size:inherit}.insert-key-input-valid{border-color:gray}.insert-key-input-invalid{border-color:red}#visibility-icon-container{position:relative;float:right;cursor:pointer;-webkit-user-select:none;user-select:none}.visibility-icon{filter:brightness(0) saturate(100%) invert(63%) sepia(1%) saturate(9%) hue-rotate(43deg) brightness(98%) contrast(92%);position:absolute;right:-1.7em;top:-1.43em}#visible-icon{top:-1.4em}.visibility-icon:hover{filter:unset}.visibility-icon>*{pointer-events:none}#start-button{border:1px solid grey;color:#454545;border-radius:4px;width:3em;display:flex;justify-content:center;align-items:center;cursor:pointer;padding:.28em .3em;-webkit-user-select:none;user-select:none;background-color:#fff}#start-button:hover{background-color:#f2f2f2}#start-button:active{background-color:#d2d2d2}#insert-key-help-text-container{width:100%;position:absolute;margin-top:32px;margin-bottom:20px}#insert-key-help-text-contents{width:100%;position:absolute}#insert-key-input-invalid-text{display:block;margin-top:1em;margin-bottom:.5em;color:red}.insert-key-input-help-text{display:block;margin-top:16px}#loading-key{display:inline-block;width:16px;height:16px}#loading-key:after{content:" ";display:block;width:11px;height:11px;margin:1px;border-radius:50%;border:2px solid #0084ff;border-color:#0084ff transparent #0084ff transparent;animation:loading-spinner 1.2s linear infinite}#error-view{color:red;font-size:1.2em;line-height:1.3em;margin-top:-5px;text-align:center;height:100%;display:flex;justify-content:center;align-items:center;padding-left:8px;padding-right:8px}@keyframes loading-spinner{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.intro-panel{position:absolute;display:flex;justify-content:center;right:0;bottom:0;left:0;margin:auto;height:fit-content;top:-2.5em}#internal-intro-panel{width:250px;height:min-content;display:block;border-radius:5px;overflow:auto;border:1px solid rgb(203,203,203);padding:10px;max-height:calc(100% - 6.8em)}#internal-intro-panel>p{margin-block-start:.8em;margin-block-end:.8em}pre code.hljs{display:block;overflow-x:auto;padding:1em}code.hljs{padding:3px 5px}/*!\n  Theme: a11y-dark\n  Author: @ericwbailey\n  Maintainer: @ericwbailey\n\n  Based on the Tomorrow Night Eighties theme: https://github.com/isagalaev/highlight.js/blob/master/src/styles/tomorrow-night-eighties.css\n*/.hljs{background:#2b2b2b;color:#f8f8f2}.hljs-comment,.hljs-quote{color:#d4d0ab}.hljs-deletion,.hljs-name,.hljs-regexp,.hljs-selector-class,.hljs-selector-id,.hljs-tag,.hljs-template-variable,.hljs-variable{color:#ffa07a}.hljs-built_in,.hljs-link,.hljs-literal,.hljs-meta,.hljs-number,.hljs-params,.hljs-type{color:#f5ab35}.hljs-attribute{color:gold}.hljs-addition,.hljs-bullet,.hljs-string,.hljs-symbol{color:#abe338}.hljs-section,.hljs-title{color:#00e0e0}.hljs-keyword,.hljs-selector-tag{color:#dcc6e0}.hljs-emphasis{font-style:italic}.hljs-strong{font-weight:700}@media screen and (-ms-high-contrast: active){.hljs-addition,.hljs-attribute,.hljs-built_in,.hljs-bullet,.hljs-comment,.hljs-link,.hljs-literal,.hljs-meta,.hljs-number,.hljs-params,.hljs-quote,.hljs-string,.hljs-symbol,.hljs-type{color:highlight}.hljs-keyword,.hljs-selector-tag{font-weight:700}}#messages{overflow:auto}.outer-message-container:last-child{margin-bottom:5px}.inner-message-container{display:flex;margin-left:auto;margin-right:auto;width:calc(97.5% - 24px);max-width:100%}.message-bubble{margin-top:10px;word-wrap:break-word;width:fit-content;max-width:60%;border-radius:10px;padding:.42em .55em;height:fit-content;line-height:1.26em}.user-message-text{color:#fff;background-color:#0084ff;margin-right:0;margin-left:auto}.ai-message-text{color:#000;background-color:#e4e6eb;margin-left:0;margin-right:auto}.loading-history-message-full-view{position:absolute;height:70%;width:100%;display:flex;align-items:center}.loading-history-message-small{height:20px;margin-bottom:30px}.loading-history-message-small>div>div{scale:.6}.loading-history-message{margin-top:0;width:100%;max-width:100%;display:flex;justify-content:center;background-color:unset}.loading-history{width:70px}.loading-history div{position:absolute;width:var(--loading-history-width);height:var(--loading-history-height);margin:var(--loading-history-margin);border:var(--loading-history-border);border-radius:50%;animation:loading-spinner 1.2s cubic-bezier(.5,0,.5,1) infinite;border-color:var(--loading-history-color) transparent transparent transparent}.loading-history div:nth-child(1){animation-delay:-.45s}.loading-history div:nth-child(2){animation-delay:-.3s}.loading-history div:nth-child(3){animation-delay:-.15s}.html-message{max-width:unset}.error-message-text{margin:14px auto 10px;background-color:#f4c0c0;color:#474747;text-align:center;max-width:95%}.deep-chat-loading-message-dots-container{width:1em;padding:.6em .75em .6em 1.3em}.loading-message-dots{position:relative;width:.45em;height:.45em;border-radius:5px;background-color:var(--loading-message-color);color:var(--loading-message-color);animation:loading-message-dots 1s infinite linear alternate;animation-delay:.5s}.loading-message-dots:before,.loading-message-dots:after{content:"";display:inline-block;position:absolute;top:0}.loading-message-dots:before{left:-.7em;width:.45em;height:.45em;border-radius:5px;background-color:var(--loading-message-color);color:var(--loading-message-color);animation:loading-message-dots 1s infinite alternate;animation-delay:0s}.loading-message-dots:after{left:.7em;width:.45em;height:.45em;border-radius:5px;background-color:var(--loading-message-color);color:var(--loading-message-color);animation:loading-message-dots 1s infinite alternate;animation-delay:1s}@keyframes loading-message-dots{0%{background-color:var(--loading-message-color)}50%,to{background-color:var(--loading-message-color-fade)}}.message-bubble>p:first-child{margin-top:0}.message-bubble>p:last-child{margin-bottom:0}pre{overflow:auto;display:block;word-break:break-all;word-wrap:break-word;border-radius:7px;background:#2b2b2b;color:#f8f8f2;margin-top:.8em;margin-bottom:.8em;padding:.6em;font-size:.9em;line-height:1.5em}.image-message{padding:0;display:flex;background-color:#ddd}.image-message>*,.image-message>*>*{width:100%;border-radius:8px;display:flex}.audio-message{width:60%;max-width:300px;height:2.2em;max-height:54px;padding:0;background-color:unset}.audio-player{width:100%;height:100%}.audio-player-safari{height:fit-content;width:40px}.audio-player-safari-left{float:left}.audio-player-safari-right{float:right}.any-file-message{padding:1px}.any-file-message-contents{display:flex}.any-file-message-icon-container{width:1.3em;min-width:1.3em;position:relative;border-radius:4px;margin-left:6px;margin-right:2px}.any-file-message-icon{background-color:#fff;border-radius:4px;position:absolute;width:1em;height:1.25em;padding:1px;margin-top:auto;margin-bottom:auto;top:0;bottom:0}.any-file-message-text{padding-top:5px;overflow-wrap:anywhere;padding-bottom:5px;padding-right:7px}.message-bubble>a{color:inherit}.left-item-position{margin-right:10px}.right-item-position{margin-left:10px}.avatar{padding-top:5px;width:1.5em;height:1.5em;border-radius:1px}.avatar-container{margin-top:9px}.name{margin-top:16px;font-size:15px}#drag-and-drop{position:absolute;display:none;z-index:10;height:calc(100% - 10px);width:calc(100% - 10px);background-color:#70c6ff4d;border:5px dashed #6dafff}#file-attachment-container{position:absolute;height:3.6em;width:calc(80% - 4px);top:-2.5em;border-radius:5px;overflow:auto;text-align:left;background-color:#d7d7d73b;padding-left:4px}.file-attachment{width:2.85em;height:2.85em;display:inline-flex;margin-right:.6em;margin-bottom:.44em;margin-top:4px;position:relative;background-color:#fff;border-radius:5px}.image-attachment{width:100%;height:100%;object-fit:cover;border-radius:5px}.border-bound-attachment{width:calc(100% - 2px);height:calc(100% - 2px);border:1px solid #c3c3c3;border-radius:5px;overflow:hidden}.border-bound-attachment-safari{width:calc(100% - 1px);height:calc(100% - 1px)}.audio-attachment-icon-container{cursor:pointer}.audio-attachment-icon-container:hover{background-color:#f8f8f8}.attachment-icon{left:0;right:0;bottom:0;top:2px;margin:auto;position:absolute;width:25px;-webkit-user-select:none;user-select:none}.not-removable-attachment-icon{top:0;right:0;bottom:0;left:0}.play-icon{filter:brightness(0) saturate(100%) invert(17%) sepia(0%) saturate(1392%) hue-rotate(67deg) brightness(98%) contrast(97%)}.stop-icon{filter:brightness(0) saturate(100%) invert(29%) sepia(90%) saturate(1228%) hue-rotate(198deg) brightness(93%) contrast(98%)}.audio-placeholder-text-3-digits{padding-left:.26rem}.audio-placeholder-text-4-digits{padding-left:.1rem}.any-file-attachment{padding:2px 0}.file-attachment-text-container{position:absolute;width:inherit;display:flex;align-items:center;height:100%;top:-1px}.audio-placeholder-text-3-digits-container{padding-top:1px;cursor:default}.any-file-attachment-text{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-left:.13em;margin-left:auto;margin-right:auto}.remove-file-attachment-button{height:1.25em;width:1.25em;border:1px solid #cfcfcf;border-radius:25px;background-color:#fff;top:-4px;right:-5px;position:absolute;display:flex;justify-content:center;cursor:pointer;-webkit-user-select:none;user-select:none}.remove-file-attachment-button:hover{background-color:#e4e4e4}.remove-file-attachment-button:active{background-color:#d7d7d7}.x-icon{color:#4e4e4e;top:-.075em;position:relative;font-size:1.05em}.modal{display:none;flex-direction:column;align-items:center;justify-content:center;position:absolute;width:80%;max-width:420px;max-height:80%;margin:auto;top:0;right:0;bottom:0;left:0;z-index:2}.modal-content{border-top:1px solid rgb(217,217,217);border-left:1px solid rgb(217,217,217);border-right:1px solid rgb(217,217,217);border-top-left-radius:inherit;border-top-right-radius:inherit;background-color:#fff;overflow-y:auto;height:fit-content;max-height:calc(100% - 3.3em);width:100%}.modal-content>p{margin-left:1em;margin-right:1em}.modal-content>ul{margin-right:1em}.modal-button-panel{height:3.3em;border:1px solid;border-color:rgb(223,223,223) rgb(217,217,217) rgb(217,217,217);border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;background-color:#fff;text-align:center;justify-content:center;display:flex;width:100%}.modal-button{min-width:2.5em;text-align:center;color:#fff;border-radius:5px;padding:.4em .4em .3em;height:1.25em;background-color:#3279b2;top:0;bottom:0;cursor:pointer;-webkit-user-select:none;user-select:none;margin:auto .31em}.modal-button:hover{background-color:#276da7}.modal-button:active{background-color:#1b5687}.modal-svg-button{padding:0 0 2px;width:2em;height:1.8em}.modal-svg-button-icon{width:100%;height:100%;filter:brightness(0) saturate(100%) invert(100%) sepia(15%) saturate(4%) hue-rotate(346deg) brightness(101%) contrast(102%)}#modal-background-panel{position:absolute;width:100%;height:100%;background-color:#00000042;z-index:1;display:none}.show-modal-background{animation:fadeInBackground .3s ease-in-out}@keyframes fadeInBackground{0%{opacity:0}to{opacity:1}}.show-modal{animation:fadeInModal .3s ease-in-out}@keyframes fadeInModal{0%{opacity:0;scale:.95}to{opacity:1;scale:1}}.hide-modal-background{animation:fadeOutBackground .2s ease-in-out}@keyframes fadeOutBackground{0%{opacity:1}to{opacity:0}}.hide-modal{animation:fadeOutModal .2s ease-in-out}@keyframes fadeOutModal{0%{opacity:1;scale:1}to{opacity:0;scale:.95}}.modal-camera-content{overflow:hidden;text-align:center;border:unset;height:100%;background-color:#2a2a2a;display:flex;justify-content:center}.camera-modal-canvas{max-width:100%;max-height:100%;margin-top:auto;margin-bottom:auto}.modal-svg-submit-button{background-color:green}.modal-svg-submit-button:hover{background-color:#007500}.modal-svg-submit-button:active{background-color:#006500}.modal-svg-submit-disabled{pointer-events:none;background-color:#747474}.modal-svg-close-button{height:1.56em;padding-top:.37em;padding-bottom:0;background-color:#c13e3e}.modal-svg-close-button:hover{background-color:#b43434}.modal-svg-close-button:active{background-color:#972929}.modal-svg-close-icon{width:80%;height:80%}.modal-svg-camera-button{height:1.6em;padding-top:.38em;padding-bottom:0}.modal-svg-camera-icon{height:76%}.modal-svg-refresh-icon{height:105%}.modal-svg-refresh-button{height:1.66em;padding-top:.11em;padding-bottom:.21em}.input-button-container{position:relative;z-index:1}.inside-right{position:absolute;right:calc(10% + .35em);bottom:.85em}.inside-left{position:absolute;left:calc(10% + .35em);bottom:.85em}.outside-left{position:absolute;right:calc(11px - .55em);bottom:.88em}.outside-right{position:absolute;left:calc(11px - .55em);bottom:.88em}#upload-images-icon{position:absolute;pointer-events:none;width:1.45em;height:1.45em;left:.11em;bottom:.08em;filter:brightness(0) saturate(100%) invert(43%) sepia(0%) saturate(740%) hue-rotate(77deg) brightness(99%) contrast(92%)}#upload-gifs-icon{position:absolute;pointer-events:none;width:1.5em;height:1.48em;left:.07em;bottom:.08em;filter:brightness(0) saturate(100%) invert(49%) sepia(0%) saturate(2586%) hue-rotate(12deg) brightness(93%) contrast(90%)}#upload-audio-icon{position:absolute;pointer-events:none;width:1.21em;height:1.21em;left:.17em;bottom:.2em;filter:brightness(0) saturate(100%) invert(15%) sepia(0%) saturate(337%) hue-rotate(125deg) brightness(91%) contrast(94%);transform:scaleX(.95)}#camera-icon{position:absolute;pointer-events:none;width:1.21em;height:1.21em;left:.23em;bottom:.2em;filter:brightness(0) saturate(100%) invert(52%) sepia(0%) saturate(161%) hue-rotate(164deg) brightness(91%) contrast(92%);transform:scaleX(.95)}#upload-mixed-files-icon{position:absolute;pointer-events:none;width:1.21em;height:1.21em;left:.25em;bottom:.2em;filter:brightness(0) saturate(100%) invert(53%) sepia(0%) saturate(36%) hue-rotate(74deg) brightness(98%) contrast(93%);transform:scaleX(.95)}#interim-text{color:gray}#microphone-button{padding-top:.5px}.outer-button-container>#microphone-button{padding-bottom:1px}#microphone-icon{position:absolute;pointer-events:none;width:1.21em;height:1.21em;left:.25em;bottom:.25em}.default-microphone-icon{filter:brightness(0) saturate(100%) invert(32%) sepia(0%) saturate(924%) hue-rotate(46deg) brightness(95%) contrast(99%)}.active-microphone-icon{filter:brightness(0) saturate(100%) invert(10%) sepia(97%) saturate(7495%) hue-rotate(0deg) brightness(101%) contrast(107%);border-radius:10px}.command-microphone-icon{filter:brightness(0) saturate(100%) invert(42%) sepia(96%) saturate(1067%) hue-rotate(77deg) brightness(99%) contrast(102%)}.unsupported-microphone{display:none}#submit-icon{height:100%;filter:brightness(0) saturate(100%) invert(32%) sepia(0%) saturate(924%) hue-rotate(46deg) brightness(95%) contrast(99%);width:1.21em}#stop-icon{background-color:#acacac;position:absolute;width:.95em;height:.95em;left:.35em;bottom:.35em;border-radius:2px}.submit-button-enlarged{scale:1.1;margin-right:.3em;margin-left:.3em}.loading-submit-button{position:relative;left:calc(-9990px + .275em);width:.22em;height:.22em;border-radius:5px;background-color:#848484;color:#848484;box-shadow:9990px 0 #848484,calc(9990px + .44em) 0 0 0 #848484,calc(9990px + .8em) 0 0 0 #848484;animation:loading-submit-button 1.5s infinite linear;bottom:-.75em}@keyframes loading-submit-button{0%{box-shadow:9990px 0 #848484,calc(9990px + .44em) 0 0 0 #848484,calc(9990px + .8em) 0 0 0 #848484}16.667%{box-shadow:9990px -6px #848484,calc(9990px + .44em) 0 0 0 #848484,calc(9990px + .8em) 0 0 0 #848484}33.333%{box-shadow:9990px 0 #848484,calc(9990px + .44em) 0 0 0 #848484,calc(9990px + .8em) 0 0 0 #848484}50%{box-shadow:9990px 0 #848484,calc(9990px + .44em) -6px 0 0 #848484,calc(9990px + .8em) 0 0 0 #848484}66.667%{box-shadow:9990px 0 #848484,calc(9990px + .44em) 0 0 0 #848484,calc(9990px + .8em) 0 0 0 #848484}83.333%{box-shadow:9990px 0 #848484,calc(9990px + .44em) 0 0 0 #848484,calc(9990px + .8em) -6px 0 0 #848484}to{box-shadow:9990px 0 #848484,calc(9990px + .44em) 0 0 0 #848484,calc(9990px + .8em) 0 0 0 #848484}}.input-button{border-radius:4px;cursor:pointer;margin-bottom:.2em;-webkit-user-select:none;user-select:none}.input-button-svg{width:1.65em;height:1.65em}.input-button:hover,.input-button:focus-visible{background-color:#9c9c9c2e}.input-button:active{background-color:#9c9c9c5e}.loading-button{cursor:auto}.loading-button:hover{background-color:unset}.text-button{filter:unset!important;display:flex;justify-content:center;align-items:center;margin-left:4px;margin-right:4px;height:1.6em}#text-input-container{background-color:#fff;width:80%;display:flex;border:1px solid #0000001a;border-radius:5px;margin-top:.8em;margin-bottom:.8em;box-shadow:#959da533 0 1px 12px;overflow-y:auto;max-height:200px;position:relative}.text-input-container-left-adjustment{margin-left:1.5em}.text-input-container-right-adjustment{margin-right:1.5em}.text-input-container-left-small-adjustment{margin-left:1.1em}.text-input-container-left-small-adjustment>.outside-left{right:calc(14px - .55em)}.text-input-container-right-small-adjustment{margin-right:1.1em}.text-input-container-right-small-adjustment>.outside-right{left:calc(14px - .55em)}#text-input{text-align:left;outline:none;word-wrap:break-word;line-break:auto}.text-input-styling{padding:.4em .5em;overflow:overlay;width:100%}.text-input-inner-left-adjustment{padding-left:2.2em}.text-input-inner-right-adjustment{padding-right:2em}.text-input-disabled{pointer-events:none;-webkit-user-select:none;user-select:none}[contenteditable]:empty:before{content:attr(deep-chat-placeholder-text);pointer-events:none}[contenteditable][textcolor]:empty:before{color:gray}.outside-right>#dropup-menu,.inside-right>#dropup-menu{right:0}#dropup-icon{position:absolute;pointer-events:none;width:1.16em;height:1.2em;left:.265em;bottom:.43em;filter:brightness(0) saturate(100%) invert(54%) sepia(0%) saturate(724%) hue-rotate(6deg) brightness(92%) contrast(90%)}#dropup-menu{background-color:#fff;position:absolute;transform:translateY(-100%);border-radius:5px;z-index:1;top:-.49em;box-shadow:#0003 -1px 2px 10px,#0000001a 0 2px 4px;cursor:pointer;-webkit-user-select:none;user-select:none}.dropup-menu-item{height:1.4em;padding:.28em .84em .28em .35em;display:flex;position:relative}.dropup-menu-item:first-child{padding-top:.49em;border-top-left-radius:inherit;border-top-right-radius:inherit}.dropup-menu-item:last-child{padding-bottom:.45em;border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.dropup-menu-item-icon{width:1.39em;position:relative;margin-right:.56em}.dropup-menu-item-icon>svg{bottom:0!important;top:0!important;margin-bottom:auto;margin-top:auto}.dropup-menu-item-text{margin-top:.08em;width:max-content}#input{width:100%;display:inline-flex;text-align:center;margin-left:auto;margin-right:auto;margin-top:auto;position:relative;justify-content:center}#chat-view{height:100%;display:grid;grid-template-columns:100%}::-webkit-scrollbar{width:9px;height:9px}::-webkit-scrollbar-thumb{background-color:#d0d0d0;border-radius:5px}::-webkit-scrollbar-track{background-color:#f2f2f2}.deep-chat-web-model-button{margin-top:10px;margin-bottom:5px;margin-left:1px}:host{all:initial;display:table-cell}#container{height:inherit;width:inherit;overflow:hidden}';
var $8e4453fb4fc895c8$var$Na = Object.defineProperty, $8e4453fb4fc895c8$var$_ = function _(n, e, t, i) {
    for(var s = void 0, r = n.length - 1, o; r >= 0; r--)(o = n[r]) && (s = o(e, t, s) || s);
    return s && $8e4453fb4fc895c8$var$Na(e, t, s), s;
};
var $8e4453fb4fc895c8$export$2d59493fd8924eee = /*#__PURE__*/ function(_ms) {
    function S() {
        var _this85;
        $8e4453fb4fc895c8$var$_classCallCheck(this, S);
        _this85 = $8e4453fb4fc895c8$var$_callSuper(this, S), _this85.getMessages = function() {
            return [];
        }, _this85.submitUserMessage = function() {
            return console.warn("submitUserMessage failed - please wait for chat view to render before calling this property.");
        }, _this85.addMessage = function() {
            return console.warn("addMessage failed - please wait for chat view to render before calling this property.");
        }, _this85.updateMessage = function() {}, _this85.clearMessages = function() {}, _this85.focusInput = function() {
            return $8e4453fb4fc895c8$var$Qt.focusFromParentElement(_this85._elementRef);
        }, _this85.refreshMessages = function() {}, _this85.scrollToBottom = function() {}, _this85.disableSubmitButton = function() {}, _this85.setPlaceholderText = function() {}, _this85._hasBeenRendered = !1, _this85._auxiliaryStyleApplied = !1, _this85._elementRef = document.createElement("div"), _this85._elementRef.id = "container", _this85.attachShadow({
            mode: "open"
        }).appendChild(_this85._elementRef), $8e4453fb4fc895c8$var$Pt.apply($8e4453fb4fc895c8$var$Oa, _this85.shadowRoot), setTimeout(function() {
            _this85._hasBeenRendered || _this85.onRender();
        }, 20);
        return _this85;
    }
    $8e4453fb4fc895c8$var$_inherits(S, _ms);
    return $8e4453fb4fc895c8$var$_createClass(S, [
        {
            key: "changeToChatView",
            value: function changeToChatView() {
                this._activeService && (this._activeService.validateKeyProperty = !1), this.onRender();
            }
        },
        {
            key: "onRender",
            value: function onRender() {
                var _this$_childElement;
                $8e4453fb4fc895c8$var$pi.attemptAppendStyleSheetToHead(this.style), $8e4453fb4fc895c8$var$Y.processConnect(this), (!this._activeService || this._activeService.demo) && (this._activeService = $8e4453fb4fc895c8$var$Zo.create(this)), this.auxiliaryStyle && !this._auxiliaryStyleApplied && ($8e4453fb4fc895c8$var$Pt.apply(this.auxiliaryStyle, this.shadowRoot), this._auxiliaryStyleApplied = !0), $8e4453fb4fc895c8$var$Pt.applyDefaultStyleToComponent(this.style, this.chatStyle), $8e4453fb4fc895c8$var$Y.checkForContainerStyles(this, this._elementRef), this._activeService.key && this._activeService.validateKeyProperty ? $8e4453fb4fc895c8$var$fi.render(this._elementRef, this.changeToChatView.bind(this), this._activeService) : !(this._activeService instanceof $8e4453fb4fc895c8$var$G) || this._activeService.key ? ((_this$_childElement = this._childElement) !== null && _this$_childElement !== void 0 ? _this$_childElement : this._childElement = this.children[0], $8e4453fb4fc895c8$var$Fs.render(this, this._elementRef, this._activeService, this._childElement)) : this._activeService instanceof $8e4453fb4fc895c8$var$G && $8e4453fb4fc895c8$var$H.render(this._elementRef, this.changeToChatView.bind(this), this._activeService), this._hasBeenRendered = !0, $8e4453fb4fc895c8$var$gi.onRender(this);
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                $8e4453fb4fc895c8$var$Wt.chat = void 0;
            }
        }
    ]);
}($8e4453fb4fc895c8$var$ms);
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "connect");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "directConnection");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "webModel");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "requestBodyLimits");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("function")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "requestInterceptor");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("function")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "responseInterceptor");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("function")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "validateInput");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("function")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "loadHistory");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "chatStyle");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "attachmentContainerStyle");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "dropupStyles");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "inputAreaStyle");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "textInput");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "submitButtonStyles");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("string")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "auxiliaryStyle");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("array")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "history");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "introMessage");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "avatars");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "names");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("boolean")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "displayLoadingBubble");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "errorMessages");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "messageStyles");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "textToSpeech");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "speechToText");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "images");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "gifs");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "camera");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "audio");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "microphone");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "mixedFiles");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "dragAndDrop");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "introPanelStyle");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "htmlClassUtilities");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "remarkable");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("function")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "onMessage");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("function")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "onClearMessages");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("function")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "onComponentRender");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("function")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "onError");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "demo");
$8e4453fb4fc895c8$var$_([
    $8e4453fb4fc895c8$var$x("object")
], $8e4453fb4fc895c8$export$2d59493fd8924eee.prototype, "_insertKeyViewStyles");
customElements.define("deep-chat", $8e4453fb4fc895c8$export$2d59493fd8924eee);


const $6b7d6ec503bbce71$var$chatConfig = {
    elementId: "chat-element",
    elementStyle: "width: 100%; height: calc(100vh - 6.5rem); height: calc(100svh - 6.5rem); border: none; background-color: transparent ",
    messageStyles: {
        default: {
            shared: {
                bubble: {
                    maxWidth: "100%",
                    backgroundColor: "unset",
                    marginTop: "10px",
                    marginBottom: "10px",
                    color: "#fafafa"
                },
                outerContainer: {
                    padding: "0.5rem 1rem",
                    borderRadius: "0.5rem",
                    fontSize: "16px"
                },
                innerContainer: {
                    width: "100%"
                }
            },
            user: {
                bubble: {
                    marginLeft: "0px"
                },
                outerContainer: {
                    backgroundColor: "rgba(38, 39, 48, 0.7)"
                }
            },
            ai: {
                outerContainer: {
                    backgroundColor: "transparent"
                }
            },
            woosmap: {
                bubble: {
                    display: "flex",
                    width: "100%",
                    height: "400px"
                }
            }
        },
        loading: {
            message: {
                styles: {
                    bubble: {
                        "margin-top": "15px",
                        "backgroundColor": "rgba(38, 39, 48, 0.7)",
                        "fontSize": "18px",
                        "color": "white"
                    }
                }
            }
        }
    },
    textInput: {
        styles: {
            container: {
                borderRadius: "0.5rem",
                border: "unset",
                width: "calc(100% - 55px)",
                backgroundColor: "rgb(38, 39, 48)",
                boxShadow: "0px 0.3px 0.9px rgba(0, 0, 0, 0.12), 0px 1.6px 3.6px rgba(0, 0, 0, 0.16)"
            },
            text: {
                padding: "12px",
                paddingLeft: "15px",
                paddingRight: "34px",
                color: "#fafafa"
            },
            input: {
                outline: "rgb(255, 75, 75)"
            }
        },
        placeholder: {
            text: "Welcome!",
            style: {
                color: "#BCBCBC"
            }
        }
    },
    submitButtonStyles: {
        submit: {
            "container": {
                "default": {
                    "bottom": "1em",
                    "right": "0.6em",
                    "borderRadius": "20px",
                    "width": "1.9em",
                    "height": "1.9em"
                }
            },
            svg: {
                styles: {
                    "default": {
                        filter: "brightness(0) saturate(100%) invert(100%)"
                    }
                }
            }
        },
        position: "inside-right"
    },
    auxiliaryStyle: `
    ::-webkit-scrollbar {
      background: transparent;
      border-radius: 100px;
      height: 6px;
      width: 6px;
    } 
    ::-webkit-scrollbar-track {
      background-color: transparent
    }`,
    introMessage: {
        text: "Hello! I\u2019m your AI assistant here to help you find nearby Starbucks locations. Just share an address, city, zip code, or point of interest, and I\u2019ll show the closest stores on a map and provide directions if needed. What location would you like to search?"
    },
    frenchIntroMessage: {
        text: "Bonjour! Je suis votre assistant IA, pr\xeat \xe0 vous aider \xe0 trouver les Starbucks les plus proches. Il vous suffit de me donner une adresse, une ville, un code postal ou un point d\u2019int\xe9r\xeat, et je vous afficherai les magasins les plus proches sur une carte, avec les directions si besoin. Quel endroit souhaitez-vous rechercher?"
    },
    useWoosmapAPIUrl: "https://evwzeuiwz5.execute-api.us-east-1.amazonaws.com/dev/use-woosmap/",
    //useWoosmapWSSUrl: "wss://y2ba5gdvxd.execute-api.us-east-1.amazonaws.com/dev",
    useWoosmapWSSUrl: "wss://y8cbmhf502.execute-api.us-east-1.amazonaws.com/dev",
    remarkable: {
        "html": true,
        "typographer": true
    },
    speechToText: {
        webSpeech: {
            "language": "en-US"
        },
        button: {
            active: {
                svg: {
                    styles: {
                        "default": {
                            bottom: "0.35em",
                            left: "0.35em",
                            filter: "brightness(0) saturate(100%) invert(10%) sepia(97%) saturate(7495%) hue-rotate(0deg) brightness(101%) contrast(107%)"
                        }
                    }
                }
            },
            default: {
                "container": {
                    "default": {
                        "bottom": "1em",
                        "right": "0.6em",
                        "borderRadius": "20px",
                        "width": "1.9em",
                        "height": "1.9em"
                    }
                },
                svg: {
                    styles: {
                        "default": {
                            bottom: "0.35em",
                            left: "0.35em",
                            filter: "brightness(0) saturate(100%) invert(100%)"
                        }
                    }
                }
            },
            "position": "outside-right"
        }
    }
};
var $6b7d6ec503bbce71$export$2e2bcd8739ae039 = $6b7d6ec503bbce71$var$chatConfig;


const $f2d40335fc3ed2c6$var$labels = {
    title: "Woosmap Agent - Chatbot demo"
};
var $f2d40335fc3ed2c6$export$2e2bcd8739ae039 = {
    labels: $f2d40335fc3ed2c6$var$labels
};


var $98197dbaf5b6f207$exports = {};
$98197dbaf5b6f207$exports = new URL("woosmap.41720dc7.svg", import.meta.url).toString();


var $ef1ddd8f541e014e$exports = {};
$ef1ddd8f541e014e$exports = new URL("user.785114b9.svg", import.meta.url).toString();


var $bb6e6271f1c3612b$exports = {};
$bb6e6271f1c3612b$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24\" viewBox=\"0 -960 960 960\" width=\"24\" style=\"filter:brightness(0)saturate()invert(70%)sepia(0%)saturate(5564%)hue-rotate(207deg)brightness()contrast(97%)\"><path d=\"M481.54-180q-125.63 0-212.81-87.17-87.19-87.17-87.19-212.77 0-125.6 87.19-212.83Q355.91-780 481.54-780q70.15 0 132.77 31.19 62.61 31.2 104.15 88.04V-780h60v244.61H533.85v-59.99h158q-31.62-57.93-87.7-91.27Q548.08-720 481.54-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h63.23q-27.23 97.92-107.27 158.96Q583.46-180 481.54-180Z\"/></svg>";



function $fb6f3ecaa0346039$export$89a7e74069fbb7af(params = {}) {
    let queryString = "";
    Object.keys(params).forEach((key)=>{
        if (queryString.length !== 0) queryString += "&";
        queryString += key + "=" + params[key].toString();
    });
    return queryString;
}
function $fb6f3ecaa0346039$export$b89605802fcf91d2(polylineString, precision = 5) {
    const coordinates = [];
    const factor = Math.pow(10, precision);
    let index, lat, lng, byte, shift, result, latitude_change, longitude_change;
    index = 0;
    lat = 0;
    lng = 0;
    while(index < polylineString.length){
        byte = null;
        shift = 0;
        result = 0;
        do {
            byte = polylineString.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        }while (byte >= 0x20);
        latitude_change = result & 1 ? ~(result >> 1) : result >> 1;
        shift = result = 0;
        do {
            byte = polylineString.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        }while (byte >= 0x20);
        longitude_change = result & 1 ? ~(result >> 1) : result >> 1;
        lat += latitude_change;
        lng += longitude_change;
        coordinates.push([
            lat / factor,
            lng / factor
        ]);
    }
    return coordinates;
}
function $fb6f3ecaa0346039$export$61fc7d43ac8f84b0(callback, timeout) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            callback(...args);
        }, timeout);
    };
}
function $fb6f3ecaa0346039$export$37827d046293d309(text) {
    const canvas = document.getElementById("canvasMarkerWoosmap") || document.createElement("canvas");
    canvas.id = "canvasMarkerWoosmap";
    const context = canvas.getContext("2d", {
        willReadFrequently: true
    });
    context.font = "bold 15px sans-serif";
    return context.measureText(text).width;
}
function $fb6f3ecaa0346039$export$a6cdc56e425d0d0a(input) {
    return typeof input === "object" && input !== null && !Array.isArray(input);
}
function $fb6f3ecaa0346039$export$4950aa0f605343fb(target, source) {
    if (!$fb6f3ecaa0346039$export$a6cdc56e425d0d0a(source) || !$fb6f3ecaa0346039$export$a6cdc56e425d0d0a(target)) return target;
    for(const key in source){
        const targetProp = target[key];
        const sourceProp = source[key];
        if ($fb6f3ecaa0346039$export$a6cdc56e425d0d0a(sourceProp) && $fb6f3ecaa0346039$export$a6cdc56e425d0d0a(targetProp)) $fb6f3ecaa0346039$export$4950aa0f605343fb(targetProp, sourceProp);
        else if (!(key in target)) target[key] = source[key];
    }
    return target;
}
function $fb6f3ecaa0346039$export$77ad94ebf1c2b9ed(str, keyValues) {
    let result = str;
    Object.keys(keyValues).forEach((key)=>{
        result = result.replace(new RegExp("\\{\\s*" + key + "\\s*\\}", "g"), keyValues[key]);
    });
    return result;
}


/**
 * Previously loading/loaded scripts that have been requested by `loadScript()`.
 */ let $5a3b137193fd24f6$var$cachedScripts = {};
function $5a3b137193fd24f6$export$2cb99e4be0dc4646(options) {
    const { url: url, params: params, override: override, parentElement: parentElement } = options;
    if (!url || url.length === 0) throw new Error("Invalid url.");
    if (typeof params !== "undefined" && typeof params !== "object") throw new Error("Expected params to be an object.");
    const src = `${url}?${(0, $fb6f3ecaa0346039$export$89a7e74069fbb7af)(params)}`;
    const existing = $5a3b137193fd24f6$var$cachedScripts[src];
    if (existing) {
        if (override) {
            const script = $5a3b137193fd24f6$var$getScriptElement(src);
            if (script) {
                delete $5a3b137193fd24f6$var$cachedScripts[src];
                script.remove();
            }
        } else return existing;
    }
    const promise = new Promise((resolve, reject)=>{
        if ($5a3b137193fd24f6$var$findScript(src)) resolve();
        const script = $5a3b137193fd24f6$export$28503efd90ff36be(url, params);
        const onScriptLoad = ()=>{
            resolve();
        };
        const onScriptError = ()=>{
            cleanup();
            delete $5a3b137193fd24f6$var$cachedScripts[src];
            script.remove();
            const defaultError = new Error(`The script "${src}" failed to load.`);
            reject(defaultError);
        };
        script.addEventListener("load", onScriptLoad);
        script.addEventListener("error", onScriptError);
        if (parentElement) parentElement.insertAdjacentElement("beforebegin", script);
        else document.head.insertBefore(script, document.head.firstElementChild);
        function cleanup() {
            script.removeEventListener("load", onScriptLoad);
            script.removeEventListener("error", onScriptError);
        }
    });
    $5a3b137193fd24f6$var$cachedScripts[src] = promise;
    return promise;
}
/**
 * Find script src in the DOM
 * @param {string} src - used to set the script url and attributes.
 * @return {boolean | null} returns `true` if script exist otherwise `null`.
 */ function $5a3b137193fd24f6$var$findScript(src) {
    const currentScript = document.querySelector(`script[src="${src}"]`);
    if (currentScript === null) return null;
    return true;
}
/**
 * Get script by src in the DOM
 * @param {string} src - used to set the script url and attributes.
 * @return {HTMLScriptElement | null} returns existing `HTMLScriptElement` if script exist otherwise `null`.
 */ function $5a3b137193fd24f6$var$getScriptElement(src) {
    const currentScript = document.querySelector(`script[src="${src}"]`);
    if (currentScript === null) return null;
    return currentScript;
}
function $5a3b137193fd24f6$export$28503efd90ff36be(url, params = {}) {
    const newScript = document.createElement("script");
    newScript.src = `${url}?${(0, $fb6f3ecaa0346039$export$89a7e74069fbb7af)(params)}`;
    newScript.async = true;
    return newScript;
}
function $5a3b137193fd24f6$export$41a88579f6bd1282() {
    $5a3b137193fd24f6$var$cachedScripts = {};
}


const $556b3a7c594eabb0$var$userLocationIconOptions = {
    url: "https://images.woosmap.com/user-position.png",
    scaledSize: {
        height: 32,
        width: 32
    },
    anchor: {
        x: 16,
        y: 16
    }
};
const $556b3a7c594eabb0$var$storeIconOptions = {
    url: "https://images.woosmap.com/starbucks-marker.svg",
    scaledSize: {
        height: 36,
        width: 30
    }
};
const $556b3a7c594eabb0$var$mapPaddings = {
    full: {
        left: 50,
        right: 50,
        top: 80,
        bottom: 50
    }
};
const $556b3a7c594eabb0$var$mapOptions = {
    center: {
        lat: 46.2,
        lng: 3.2
    },
    zoom: 6,
    styles: [
        {
            featureType: "point_of_interest",
            elementType: "all",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        }
    ],
    gestureHandling: "cooperative"
};
var $556b3a7c594eabb0$export$2e2bcd8739ae039 = {
    mapOptions: $556b3a7c594eabb0$var$mapOptions,
    userLocationIconOptions: $556b3a7c594eabb0$var$userLocationIconOptions,
    storeIconOptions: $556b3a7c594eabb0$var$storeIconOptions,
    mapPaddings: $556b3a7c594eabb0$var$mapPaddings
};



var $dRKaB = parcelRequire("dRKaB");
var $de16cbc760dd69a7$exports = {};
$de16cbc760dd69a7$exports = ".travelModeSelector{text-align:center;place-content:flex-start space-between;width:90px;height:34px;display:flex}.travelModeSelector .travelMode{text-align:center;z-index:0;display:inline-block;position:relative}.travelModeSelector .travelMode button{cursor:pointer;font:inherit;vertical-align:baseline;background:0 0;border:0;border-radius:0;outline:0;margin:0;padding:0;list-style:none;display:flex;position:relative;overflow:visible}.travelModeSelector .travelMode .iconTravelMode{width:24px;height:24px;margin:5px}.travelModeSelector .travelMode .iconTravelMode__DRIVING,.travelModeSelector .travelMode .iconTravelMode__WALKING,.travelModeSelector .travelMode .iconTravelMode__CYCLING{display:block}.travelModeSelector .travelMode:after,.travelModeSelector .travelMode button:after{content:\"\";z-index:-1;border-radius:100%;width:36px;height:36px;position:absolute;inset:0}.travelModeSelector .travelMode:hover button:after{background-color:#00000026}";


class $58af7c6ba6d2ef6c$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(){
        super();
        this.markers = [];
        this.route = {
            mode: "DRIVING"
        };
        this.shadow = this.attachShadow({
            mode: "open"
        });
        this.style.height = "100%";
        this.style.width = "100%";
    }
    static get observedAttributes() {
        return [
            "markers",
            "search-location",
            "route"
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        try {
            if (name === "markers" && newValue && (0, (/*@__PURE__*/$parcel$interopDefault($dRKaB))).decode(newValue, true)) {
                const decodedValue = (0, (/*@__PURE__*/$parcel$interopDefault($dRKaB))).decode(newValue);
                this.markers = JSON.parse(decodedValue);
                if (this.map) this.updateMarkersAndFitBounds();
            } else if (name === "search-location" && newValue) {
                const decodedValue = (0, (/*@__PURE__*/$parcel$interopDefault($dRKaB))).decode(newValue);
                this.searchLocation = JSON.parse(decodedValue);
                if (this.map) this.updateMarkersAndFitBounds();
            } else if (name === "route" && newValue) {
                const decodedValue = (0, (/*@__PURE__*/$parcel$interopDefault($dRKaB))).decode(newValue);
                this.route = JSON.parse(decodedValue);
            }
        } catch (error) {
            console.log("Error parsing JSON:", error, "Input:", newValue);
        }
    }
    connectedCallback() {
        this.render();
    }
    render() {
        const mapId = this.getAttribute("id") || "map";
        this.shadow.innerHTML = `
      <style>
        :host {
          display: block;
          width: 100%;
          height: 100%;
        }
        .map-container {
          width: 100%;
          height: 100%;
        }
      </style>
      <style>${0, (/*@__PURE__*/$parcel$interopDefault($de16cbc760dd69a7$exports))}</style>
      <div id="${mapId}" class="map-container"></div>
    `;
        (0, $5a3b137193fd24f6$export$2cb99e4be0dc4646)({
            url: "https://sdk.woosmap.com/map/map.js",
            params: {
                key: "woos-48c80350-88aa-333e-835a-07f4b658a9a4",
                language: "en"
            },
            override: true
        }).then(()=>{
            this.copyStylesToShadowRoot();
            this.initMapView(mapId);
        }).catch((error)=>{
            console.error("Failed to load Woosmap Map JS SDK script", error);
        });
    }
    copyStylesToShadowRoot() {
        const styles = Array.from(document.head.querySelectorAll('style[type="text/css"]'));
        styles.forEach((style)=>{
            if (style.textContent && style.textContent.includes(".mapboxgl-map")) this.shadow.appendChild(style.cloneNode(true));
        });
    }
    initMapView(mapId) {
        const mapContainer = this.shadow.getElementById(mapId);
        if (mapContainer) {
            this.map = new woosmap.map.Map(mapContainer, (0, $556b3a7c594eabb0$export$2e2bcd8739ae039).mapOptions);
            this.infoWindow = new woosmap.map.InfoWindow({});
            this.infoWindow.setOffset(new woosmap.map.Point(0, -40));
            this.updateMarkersAndFitBounds();
            this.map.addListener("click", ()=>{
                this.infoWindow.close();
            });
            if (this.route?.mode && this.markers.length == 1) this.showDirections(this.markers[0].coordinates);
        } else console.error("Map container not found in shadow DOM");
    }
    updateMarkersAndFitBounds() {
        const bounds = new woosmap.map.LatLngBounds();
        if (this.markers && this.markers.length > 0) this.addStoreMarkers(this.markers, bounds);
        if (this.searchLocation) this.addSearchLocation(this.searchLocation, bounds);
        if (!bounds.isEmpty()) this.map.fitBounds(bounds, (0, $556b3a7c594eabb0$export$2e2bcd8739ae039).mapPaddings.full);
        if (this.markers && this.markers.length == 1 && !this.searchLocation) {
            this.map.setCenter({
                lat: this.markers[0].coordinates.lat,
                lng: this.markers[0].coordinates.lng
            });
            this.map.setZoom(12);
        }
    }
    addSearchLocation(location, bounds) {
        this.addMarker("", location, (0, $556b3a7c594eabb0$export$2e2bcd8739ae039).userLocationIconOptions, bounds);
    }
    addStoreMarkers(markers, bounds) {
        const iconUrls = [
            "https://images.woosmap.com/starbucks-marker-1.svg",
            "https://images.woosmap.com/starbucks-marker-2.svg",
            "https://images.woosmap.com/starbucks-marker-3.svg",
            "https://images.woosmap.com/starbucks-marker-4.svg",
            "https://images.woosmap.com/starbucks-marker-5.svg",
            "https://images.woosmap.com/starbucks-marker-6.svg",
            "https://images.woosmap.com/starbucks-marker-7.svg",
            "https://images.woosmap.com/starbucks-marker-8.svg",
            "https://images.woosmap.com/starbucks-marker-9.svg",
            "https://images.woosmap.com/starbucks-marker-10.svg"
        ];
        markers.forEach((marker, index)=>{
            let iconOptions = (0, $556b3a7c594eabb0$export$2e2bcd8739ae039).storeIconOptions;
            if (index < iconUrls.length && this.markers.length > 1) iconOptions = {
                url: iconUrls[index],
                scaledSize: new woosmap.map.Size(30, 30)
            };
            this.addMarker(marker.name, marker.coordinates, iconOptions, bounds);
        });
    }
    addMarker(name, position, iconOptions, bounds) {
        const markerInstance = new woosmap.map.Marker({
            position: new woosmap.map.LatLng(position.lat, position.lng),
            icon: iconOptions
        });
        markerInstance.setMap(this.map);
        bounds.extend(markerInstance.getPosition());
        if (name) markerInstance.addListener("click", ()=>{
            const position = markerInstance.getPosition();
            this.infoWindow.setContent(`<div style="width:160px"><h3 style="color:#1D1D1D; margin-top:5px">${name}</h3>${this.getTravelModeContainer()}</div>`);
            this.infoWindow.open(this.map, position);
            this.showDirections(position);
            this.addTravelModeListeners(position);
        });
    }
    showDirections(destination) {
        if (this.route && this.route.mode && this.searchLocation && destination) {
            if (this.transitRenderer) this.transitRenderer.setMap(null);
            if (this.directionsRenderer) this.directionsRenderer.setMap(null);
            if (this.route.mode.toLowerCase() === "transit") {
                const transitService = new woosmap.map.TransitService();
                this.transitRenderer = new woosmap.map.TransitRenderer({
                    preserveViewport: true
                });
                this.transitRenderer.setMap(this.map);
                transitService.route({
                    origin: this.searchLocation,
                    destination: destination
                }).then((response)=>{
                    if (this.transitRenderer) this.transitRenderer.setRoutes(response.routes);
                }).catch((error)=>{
                    console.error("Transit directions request failed:", error);
                });
            } else {
                const directionsService = new woosmap.map.DirectionsService();
                this.directionsRenderer = new woosmap.map.DirectionsRenderer({
                    preserveViewport: true
                });
                this.directionsRenderer.setMap(this.map);
                const request = {
                    origin: this.searchLocation,
                    destination: destination,
                    travelMode: this.route.mode
                };
                directionsService.route(request, (result, status)=>{
                    if (status === "OK") {
                        if (this.directionsRenderer) this.directionsRenderer.setDirections(result);
                    } else console.error("Directions request failed due to " + status);
                });
            }
        }
    }
    getTravelModeContainer() {
        return `<div id="travelModeContainer">
                    <div class="travelModeSelector">
                        <div data-mode="DRIVING" class="travelMode">
                            <button>
                                <img alt="DRIVING" class="iconTravelMode iconTravelMode__DRIVING"
                                     src="https://images.woosmap.com/directions/drive_black.png">
                            </button>
                        </div>
                        <div data-mode="WALKING" class="travelMode">
                            <button>
                                <img alt="WALKING" class="iconTravelMode iconTravelMode__WALKING"
                                     src="https://images.woosmap.com/directions/walk_black.png">
                            </button>
                        </div>
                        <div data-mode="CYCLING" class="travelMode">
                            <button>
                                <img alt="CYCLING" class="iconTravelMode iconTravelMode__CYCLING"
                                     src="https://images.woosmap.com/directions/bicycle_black.png">
                            </button>
                        </div>
                        <div data-mode="TRANSIT" class="travelMode">
                            <button>
                                <img alt="TRANSIT" class="iconTravelMode iconTravelMode__TRANSIT"
                                    src="https://images.woosmap.com/directions/transit_black.png">
                            </button>
                        </div>
                    </div>
                </div>`;
    }
    addTravelModeListeners(destination) {
        const travelModeButtons = this.shadow.querySelectorAll(".travelMode button");
        travelModeButtons.forEach((button)=>{
            button.addEventListener("click", (event)=>{
                const mode = event.currentTarget.parentElement?.getAttribute("data-mode");
                if (mode) {
                    this.route.mode = mode;
                    this.showDirections(destination);
                }
            });
        });
    }
}


var $008acc21121cf6e4$export$862abd191a2ee43;
(function(GeolocationError) {
    GeolocationError["Unavailable"] = "Unavailable";
    GeolocationError["PermissionDenied"] = "PermissionDenied";
    GeolocationError["PositionUnavailable"] = "PositionUnavailable";
    GeolocationError["Timeout"] = "Timeout";
    GeolocationError["Default"] = "Default";
})($008acc21121cf6e4$export$862abd191a2ee43 || ($008acc21121cf6e4$export$862abd191a2ee43 = {}));
class $008acc21121cf6e4$export$68d023cdc03da2f1 {
    static #_ = this.GeolocationOptions = {
        enableHighAccuracy: true,
        timeout: 6000,
        maximumAge: 30000
    };
    static async getCurrentPosition() {
        try {
            return await new Promise((resolve, reject)=>{
                $008acc21121cf6e4$export$68d023cdc03da2f1.getNavigatorGeolocation().getCurrentPosition(resolve, reject, $008acc21121cf6e4$export$68d023cdc03da2f1.GeolocationOptions);
            });
        } catch (error) {
            throw new Error($008acc21121cf6e4$export$68d023cdc03da2f1.getGeolocationError(error));
        }
    }
    static getNavigatorGeolocation() {
        if (!navigator.geolocation) throw new Error("Unavailable");
        return navigator.geolocation;
    }
    static isGeolocationError(error) {
        return typeof error === "object" && "PERMISSION_DENIED" in error;
    }
    static getGeolocationError(error) {
        console.error(error);
        if ($008acc21121cf6e4$export$68d023cdc03da2f1.isGeolocationError(error)) switch(error.code){
            case error.PERMISSION_DENIED:
                return "PermissionDenied";
            case error.POSITION_UNAVAILABLE:
                return "PositionUnavailable";
            case error.TIMEOUT:
                return "Timeout";
            default:
                return "Default";
        }
        else if (error.message === "Unavailable") return "Unavailable";
        else return "Default";
    }
}


class $31263440ba67c946$export$2e2bcd8739ae039 {
    constructor(container, toolName, status = "loading", toolUseBlock){
        this.container = container;
        this.toolName = toolName;
        this.status = status;
        this.toolUseBlock = toolUseBlock;
        this.renderHTML();
    }
    generateHtmlContent() {
        const statusText = this.status === "loading" ? `Calculating ${this.toolName}...` : this.status === "success" ? `<svg style="margin-right:.5rem" height="18" width="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" stroke="#05A862" stroke-width="2" fill="none"></circle><path d="M16.707 8.707a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 12.586l4.293-4.293a1 1 0 0 1 1.414 0z" fill-rule="evenodd" fill="#05A862"></path></svg> Finished ${this.toolName} tool` : `Error on ${this.toolName} tool`;
        const textClass = this.status === "loading" ? "loading-shimmer" : "";
        return `
        <div class="tooluse-component ${this.status}" style="margin-bottom: 1rem;">
            <div class="collapsible">
                <span style="display:flex" class="${textClass}">${statusText}${this.status === "success" && this.toolUseBlock ? `` : ""}</span>
            </div>
            ${this.status === "loading" ? "" : ""}
            ${this.status === "success" && this.toolUseBlock ? this.getHTMLForInput() : ""}
            ${this.status === "error" ? `<div class="tooluse-error collapsibleContent" style="color: red;">${this.toolError}</div>` : ""}
        </div>
    `.replace(/\s\s+/g, "").trim();
    }
    getHTMLForInput() {
        if (this.toolUseBlock && this.toolUseBlock.input) {
            const inputs = this.toolUseBlock.input;
            let html = '<div class="collapsibleContent" style="margin-top:.5rem; border-radius:5px;color:#b4b4b4"><div style="background:#202029; border: 1px solid #383737; padding: .3rem .8rem; display: flex; font-size: .8rem;">Passed inputs for tool</div>';
            for(const key in inputs)if (inputs.hasOwnProperty(key)) {
                const value = inputs[key];
                if (typeof value === "object") html += `<div style="padding: .5rem .8rem;border: 1px solid #383737; border-top: none; display: flex;"><span>${key}:</span><span style="color:#FFF; margin-left:.3rem">${JSON.stringify(value)}</span></div>`;
                else html += `<div style="padding: .5rem .8rem;border: 1px solid #383737; border-top: none; display: flex;"><span>${key}:</span><span style="color:#FFF; margin-left:.3rem">${value}</span></div>`;
            }
            html += "</div>";
            return html;
        }
        return "";
    }
    renderHTML() {
        this.container.innerHTML = this.generateHtmlContent();
    }
}


class $b173e54008198fa2$export$2e2bcd8739ae039 {
    constructor(container){
        this.debounceTimeout = null;
        this.container = container;
        this.observer = new MutationObserver(()=>this.checkOverflow());
        this.init();
    }
    init() {
        this.checkOverflow();
        this.container.addEventListener("scroll", ()=>this.debounce(this.handleScroll.bind(this), 100));
        this.observer.observe(this.container, {
            childList: true,
            subtree: true
        });
    }
    checkOverflow() {
        if (this.container.scrollHeight > this.container.clientHeight) this.appendScrollButton();
        else this.removeScrollButton();
    }
    appendScrollButton() {
        if (!this.container.querySelector(".scroll-to-bottom")) {
            this.renderHTML();
            const scrollButton = this.container.querySelector(".scroll-to-bottom button");
            if (scrollButton) scrollButton.addEventListener("click", ()=>{
                this.container.scrollTop = this.container.scrollHeight;
                this.removeScrollButton();
            });
        }
    }
    removeScrollButton() {
        const scrollButton = this.container.querySelector(".scroll-to-bottom");
        if (scrollButton) {
            this.observer.disconnect();
            scrollButton.remove();
            this.observer.observe(this.container, {
                childList: true,
                subtree: true
            });
        }
    }
    handleScroll() {
        const margin = 10;
        if (this.container.scrollTop + this.container.clientHeight >= this.container.scrollHeight - margin) this.removeScrollButton();
        else this.appendScrollButton();
    }
    debounce(func, wait) {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout);
        this.debounceTimeout = window.setTimeout(func, wait);
    }
    generateHtmlContent() {
        return `
        <div class="scroll-to-bottom">
            <button>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-md text-token-text-primary">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 21C11.7348 21 11.4804 20.8946 11.2929 20.7071L4.29289 13.7071C3.90237 13.3166 3.90237 12.6834 4.29289 12.2929C4.68342 11.9024 5.31658 11.9024 5.70711 12.2929L11 17.5858V4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4V17.5858L18.2929 12.2929C18.6834 11.9024 19.3166 11.9024 19.7071 12.2929C20.0976 12.6834 20.0976 13.3166 19.7071 13.7071L12.7071 20.7071C12.5196 20.8946 12.2652 21 12 21Z" fill="#FFF"></path>
                </svg>
            </button>
        </div>
    `.replace(/\s\s+/g, "").trim();
    }
    renderHTML() {
        this.container.insertAdjacentHTML("beforeend", this.generateHtmlContent());
    }
}


var $2cba95dcc67a4841$exports = {};
$2cba95dcc67a4841$exports = ".collapsible{cursor:pointer;text-align:left;color:#b4b4b4;border:none;outline:none;align-items:center;display:flex}.collapsible-icon:after{content:\"\";background-image:url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' class='icon-md'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.29289 9.29289C5.68342 8.90237 6.31658 8.90237 6.70711 9.29289L12 14.5858L17.2929 9.29289C17.6834 8.90237 18.3166 8.90237 18.7071 9.29289C19.0976 9.68342 19.0976 10.3166 18.7071 10.7071L12.7071 16.7071C12.5196 16.8946 12.2652 17 12 17C11.7348 17 11.4804 16.8946 11.2929 16.7071L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289Z' fill='%23B4B4B4'%3E%3C/path%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:20px 20px;margin-left:5px;padding-right:18px}.active .collapsible-icon:after{background-image:url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' class='icon-md'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.29289 14.7071C5.68342 15.0976 6.31658 15.0976 6.70711 14.7071L12 9.41421L17.2929 14.7071C17.6834 15.0976 18.3166 15.0976 18.7071 14.7071C19.0976 14.3166 19.0976 13.6834 18.7071 13.2929L12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7C11.7348 7 11.4804 7.10536 11.2929 7.29289L5.29289 13.2929C4.90237 13.6834 4.90237 14.3166 5.29289 14.7071Z' fill='%23B4B4B4'%3E%3C/path%3E%3C/svg%3E\")}.collapsible:hover{color:#fff!important}.collapsibleContent{max-height:0;transition:max-height .2s ease-out;overflow:hidden}";


var $234f737fe54fad86$exports = {};
$234f737fe54fad86$exports = ".loading-shimmer{text-fill-color:transparent;-webkit-text-fill-color:transparent;background:#b4b4b4 gradient(linear,100% 0,0 0,from(#b4b4b4),color-stop(.5,#fff),to(#b4b4b4));background:#b4b4b4 -webkit-gradient(linear,100% 0,0 0,from(#b4b4b4),color-stop(.5,#fff),to(#b4b4b4)) -100% 0/50% 200% no-repeat;-webkit-background-clip:text;background-clip:text;animation-name:loading-shimmer;animation-duration:3s;animation-iteration-count:infinite;animation-delay:.2s;display:inline-block}.loading-shimmer:hover{-webkit-text-fill-color:#fff;background:0 0;animation:none}@keyframes loading-shimmer{0%{background-position:-100% 0}to{background-position:250% 0}}";


var $22a4c8e3b88be8e0$exports = {};
$22a4c8e3b88be8e0$exports = ".scroll-to-bottom{transition:opacity .3s ease-in-out}.scroll-to-bottom button{cursor:pointer;z-index:10;width:2rem;height:2rem;padding:unset;background:#0e1117;border:1px solid #b4b4b4;border-radius:9999px;justify-content:center;align-items:center;display:flex;position:absolute;bottom:5rem;right:50%;transform:translate(50%)}.scroll-to-bottom button svg{width:18px;height:18px}";


var $a505caa6f3d0edcf$exports = {};
$a505caa6f3d0edcf$exports = "button{cursor:pointer;background-color:#0000;border:none;justify-content:center;align-items:center;padding-right:0;display:flex}button:disabled{cursor:not-allowed;opacity:.5}button img{width:24px;height:24px}";


var $b34f49fa5d96aba1$exports = {};
$b34f49fa5d96aba1$exports = "@media (max-width:600px){.avatar-container{display:none}.deep-chat-user-container{border-radius:0!important}.deep-chat-user-container .inner-message-container{flex-flow:row-reverse}.message-bubble{padding-left:0!important;padding-right:0!important}}";


class $781fdfbf8a4d8045$export$2e2bcd8739ae039 {
    constructor({ target: target }){
        this.historyMessages = [];
        this.isFrench = false;
        this.mapRenderedIds = [];
        this.collapsibleElements = new Set();
        this.target = target;
        this.init();
        customElements.define("woosmap-map", (0, $58af7c6ba6d2ef6c$export$2e2bcd8739ae039));
    }
    init() {
        this.render();
    }
    render() {
        this.target.innerHTML = `
      <div class="container">
        <div class="wrapper">
        <h1>${(0, $f2d40335fc3ed2c6$export$2e2bcd8739ae039).labels.title}</h1>
        <span class="divider"></span>
        <deep-chat></deep-chat>
        </div>
      </div>
    `;
        this.chatElement = this.target.querySelector("deep-chat");
        this.configureChatElement();
    }
    getBrowserLanguage() {
        return navigator.language || navigator.userLanguage;
    }
    configureChatElement() {
        const browserLanguage = this.getBrowserLanguage();
        this.isFrench = browserLanguage.startsWith("fr");
        this.chatElement.avatars = {
            ai: {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($98197dbaf5b6f207$exports)))
            },
            user: {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($ef1ddd8f541e014e$exports)))
            },
            default: {
                styles: {
                    position: "left",
                    avatar: {
                        width: "2em",
                        height: "2em"
                    }
                }
            }
        };
        if (this.isFrench) (0, $6b7d6ec503bbce71$export$2e2bcd8739ae039).textInput.placeholder.text = "Bienvenue!";
        this.chatElement.textInput = (0, $6b7d6ec503bbce71$export$2e2bcd8739ae039).textInput;
        this.chatElement.introMessage = this.isFrench ? (0, $6b7d6ec503bbce71$export$2e2bcd8739ae039).frenchIntroMessage : (0, $6b7d6ec503bbce71$export$2e2bcd8739ae039).introMessage;
        this.chatElement.messageStyles = (0, $6b7d6ec503bbce71$export$2e2bcd8739ae039).messageStyles;
        this.chatElement.auxiliaryStyle = (0, $6b7d6ec503bbce71$export$2e2bcd8739ae039).auxiliaryStyle;
        this.chatElement.setAttribute("style", (0, $6b7d6ec503bbce71$export$2e2bcd8739ae039).elementStyle);
        this.chatElement.displayLoadingBubble = false;
        this.chatElement.history = [];
        this.chatElement.speechToText = (0, $6b7d6ec503bbce71$export$2e2bcd8739ae039).speechToText;
        this.chatElement.submitButtonStyles = (0, $6b7d6ec503bbce71$export$2e2bcd8739ae039).submitButtonStyles;
        this.chatElement.remarkable = (0, $6b7d6ec503bbce71$export$2e2bcd8739ae039).remarkable;
        this.handleChatInterceptors();
        //this.handleHTML5Position();
        window.setTimeout(()=>{
            this.injectClearButton();
            this.injectCustomStyles();
            this.manageScrollToBottom();
        }, 100);
    }
    async handleHTML5Position() {
        const position = await (0, $008acc21121cf6e4$export$68d023cdc03da2f1).getCurrentPosition();
        if (position) {
            const strPosition = JSON.stringify({
                lat: position.coords.latitude,
                lng: position.coords.longitude
            });
            const labelPosition = this.isFrench ? `Voici ma position ${strPosition}` : `Here is my location ${strPosition}`;
            this.chatElement.submitUserMessage({
                text: labelPosition
            });
        }
    }
    clearChat() {
        this.historyMessages = [];
        const messagesContainer = this.chatElement?.shadowRoot?.querySelector("#messages");
        if (messagesContainer) {
            const children = Array.from(messagesContainer.children);
            children.forEach((child)=>{
                if (!child.classList.contains("deep-chat-intro")) messagesContainer.removeChild(child);
            });
        }
        if (this.clearButton) this.clearButton?.setAttribute("disabled", "true");
    }
    manageScrollToBottom() {
        const messagesContainer = this.chatElement?.shadowRoot?.querySelector("#messages");
        if (messagesContainer) new (0, $b173e54008198fa2$export$2e2bcd8739ae039)(messagesContainer);
    }
    injectCustomStyles() {
        const style = document.createElement("style");
        style.textContent = `${0, (/*@__PURE__*/$parcel$interopDefault($b34f49fa5d96aba1$exports))}${0, (/*@__PURE__*/$parcel$interopDefault($2cba95dcc67a4841$exports))}${0, (/*@__PURE__*/$parcel$interopDefault($234f737fe54fad86$exports))}${0, (/*@__PURE__*/$parcel$interopDefault($22a4c8e3b88be8e0$exports))}${0, (/*@__PURE__*/$parcel$interopDefault($a505caa6f3d0edcf$exports))}`;
        const shadowRoot = this.chatElement?.shadowRoot;
        shadowRoot?.appendChild(style);
    }
    injectClearButton() {
        this.clearButton = document.createElement("button");
        this.clearButton.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($bb6e6271f1c3612b$exports)));
        this.clearButton.addEventListener("click", this.clearChat.bind(this));
        this.clearButton.setAttribute("disabled", "true");
        const shadowRoot = this.chatElement?.shadowRoot;
        const targetElement = shadowRoot?.querySelector("#text-input-container");
        targetElement?.prepend(this.clearButton);
    }
    handleChatInterceptors() {
        if (!this.chatElement) {
            console.error("Chat element is not initialized.");
            return;
        }
        this.chatElement.connect = {
            websocket: true,
            handler: (_, signals)=>{
                let text = "";
                let overwrite = false;
                let mapComponent = null;
                let toolUseHtml = "";
                try {
                    const websocket = new WebSocket((0, $6b7d6ec503bbce71$export$2e2bcd8739ae039).useWoosmapWSSUrl);
                    websocket.onopen = ()=>{
                        signals.onOpen(); // enables the user to send messages
                    };
                    websocket.onmessage = (message)=>{
                        overwrite = !!text;
                        const response = JSON.parse(message.data);
                        if (response.stop_reason && response.stop_reason === "end_turn") {
                            text = "";
                            // Display the stored map component if available
                            if (mapComponent) {
                                const mapMsg = this.createMapMessage(mapComponent);
                                if (mapMsg.role === "woosmap") this.chatElement.addMessage(mapMsg, false);
                                mapComponent = null; // Reset the map component variable
                            }
                        } else if (response.tool_use) {
                            // Create and display the ToolUseComponent as standard HTML
                            const toolUseContainer = document.createElement("div");
                            toolUseContainer.setAttribute("id", `tool-use-${response.tool_use}`);
                            this.toolUseComponent = new (0, $31263440ba67c946$export$2e2bcd8739ae039)(toolUseContainer, response.tool_use, "loading");
                            // Convert the ToolUseComponent to a string representation
                            toolUseHtml = toolUseContainer.outerHTML;
                            text += toolUseHtml;
                            signals.onResponse({
                                text: text,
                                overwrite: overwrite
                            });
                        } else if (response.toolResult) {
                            const toolResultContent = response.toolResult.content.find((content)=>content.json?.result);
                            if (toolResultContent) {
                                const result = toolResultContent.json.result;
                                const toolName = response.tool_use_block.name;
                                // Update the ToolUseComponent with the result
                                const toolUseContainer = document.createElement("div");
                                toolUseContainer.setAttribute("id", `tool-use-${toolName}`);
                                this.toolUseComponent = new (0, $31263440ba67c946$export$2e2bcd8739ae039)(toolUseContainer, toolName, "success", response.tool_use_block);
                                // Replace the last occurrence of the component in the text
                                const toolUseSuccessHtml = toolUseContainer.outerHTML;
                                text = text.replace(toolUseHtml, toolUseSuccessHtml);
                                if (toolName == "create_map") mapComponent = result;
                                signals.onResponse({
                                    text: text,
                                    overwrite: overwrite
                                });
                            } else if (response.toolResult.error) {
                                // Update the ToolUseComponent with the error
                                const toolName = response.tool_use_block.name;
                                if (toolName == "create_map") mapComponent = null;
                                const toolUseContainer = document.createElement("div");
                                toolUseContainer.setAttribute("id", `tool-use-${toolName}`);
                                this.toolUseComponent = new (0, $31263440ba67c946$export$2e2bcd8739ae039)(toolUseContainer, toolName, "error", response.tool_use_block);
                                // Replace the last occurrence of the component in the text
                                const toolUseErrorHtml = toolUseContainer.outerHTML;
                                text = text.replace(toolUseHtml, toolUseErrorHtml);
                                text += "<!-- end-tool-use -->";
                                signals.onResponse({
                                    text: text,
                                    overwrite: overwrite
                                });
                            }
                        } else if (response.text) {
                            text += response.text;
                            signals.onResponse({
                                text: text,
                                overwrite: overwrite
                            });
                        } else if (response.end_stream) {
                            this.historyMessages = response.end_stream;
                            this.addCollapsibleListeners();
                        }
                        if (this.historyMessages.length > 0) this.clearButton.removeAttribute("disabled");
                    };
                    websocket.onclose = ()=>{
                        signals.onClose(); // stops the user from sending messages
                    };
                    websocket.onerror = ()=>{
                        // 'Connection error' is a special string that will also display in Deep Chat
                        signals.onResponse({
                            error: "Connection error"
                        });
                    };
                    // triggered when the user sends a message
                    signals.newUserMessage.listener = (body)=>{
                        // Ensure the message includes the action field
                        text = "";
                        toolUseHtml = "";
                        const message = {
                            action: "sendmessage",
                            ...body
                        };
                        websocket.send(JSON.stringify(message));
                    };
                } catch (e) {
                    signals.onResponse({
                        error: "error"
                    }); // displays an error message
                    signals.onClose(); // stops the user from sending messages
                }
            }
        };
        this.chatElement.requestInterceptor = (originalRequest)=>{
            try {
                const messages = originalRequest.body?.messages;
                if (!messages || messages.length === 0) {
                    console.error("No messages found in the request body.");
                    return originalRequest;
                }
                const lastUserMessage = {
                    role: messages[0].role,
                    content: [
                        {
                            text: messages[0].text
                        }
                    ]
                };
                this.historyMessages.push(lastUserMessage);
                originalRequest.body = {
                    messages: this.historyMessages
                };
                return originalRequest;
            } catch (error) {
                console.error("Error intercepting request:", error);
                return originalRequest;
            }
        };
    }
    createMapMessage(mapComponent) {
        if (mapComponent) {
            // Extract the map ID from the mapComponent string
            const mapIdMatch = mapComponent.match(/id="([^"]+)"/);
            const mapId = mapIdMatch ? mapIdMatch[1] : null;
            if (mapId && !this.mapRenderedIds.includes(mapId)) {
                this.mapRenderedIds.push(mapId);
                return {
                    html: mapComponent,
                    role: "woosmap"
                };
            } else return {
                error: "Map already rendered - skipping",
                role: "ai"
            };
        } else return {
            error: "Error creating map message",
            role: "ai"
        };
    }
    addCollapsibleListeners() {
        this.chatElement?.shadowRoot?.querySelectorAll(".collapsible").forEach((element)=>{
            if (!this.collapsibleElements.has(element)) {
                const child = element.firstElementChild;
                if (child) child.classList.add("collapsible-icon");
                element.addEventListener("click", (e)=>{
                    const target = e.currentTarget;
                    this.toggleActive(target);
                });
                this.collapsibleElements.add(element);
            }
        });
    }
    toggleActive(container) {
        container.classList.toggle("active");
        const content = container.nextElementSibling;
        if (content?.style.maxHeight && content?.style.maxHeight != "0px") content.style.maxHeight = "0px";
        else content.style.maxHeight = content.scrollHeight + "px";
    }
}


window.LocationChatBot = (0, $781fdfbf8a4d8045$export$2e2bcd8739ae039);


//# sourceMappingURL=index.e32a3ba4.js.map
